const _ = {
  T_50_XYL_2NBCL_BLOODMOON_SKYBOX: "Nền Nguyệt Nhãn",
  BR_WORKSHOP_INVALID_PERFORMANCE_COST: "Xuất bản thất bại do có quá nhiều tài nguyên trường cảnh. Vui lòng giảm lượng tại nguyên và thử lại.",
  BR_WORKSHOP_NO_PERMISSION_PUB_MONETIZATION_MAP: "Hiện không có quyền truy cập tính năng dành cho thành viên",
  T_12_I_GIFT_SENDER_BELL: "Chuông Noel",
  T_12_L_ACCESSORY_COS_MOTORHELMET_DESC: "Nhìn mọi thứ chậm hơn bình thường. [FFB300](Che mũ)[-]",
  T_12_L_ACCESSORY_COS_SANTAHEAD: "Mặt nạ Ông già Noel",
  T_12_L_COS_PINKMAN: "Khủng Long Hường",
  T_12_L_COS_POLAR: "Gấu Bắc Cực",
  T_12_L_COS_RENDER: "Khủng Long Cầu Vồng",
  T_12_L_COS_TIGER: "Khủng Long Hổ",
  T_12_L_MALE_BOTTOM_COS_ELF: "Quần Tiểu tiên (Nam)",
  T_12_L_MALE_COS_SANTA: "Ông già Noel",
  T_12_L_MALE_HAIR_COS_ELF: "Mũ Tiểu tiên (Nam)",
  T_12_L_MALE_SHOE_COS_ELF: "Giày Tiểu tiên (Nam)",
  T_12_L_MALE_TOP_COS_ELF: "Áo Tiểu tiên (Nam)",
  T_12_O_CAT_NAME: "Mèo mèo",
  T_12_O_M1014_CHRISTMAS_NAME: "M1014 Giáng Sinh",
  T_12_O_MACHETE_GOLD_NAME: "Đao Vàng Ròng",
  T_12_O_PET_TITLE: "TRỢ THỦ",
  T_12_Q_ITEM_AN94: "AN94",
  T_12_Q_ITEM_DOUBLEJUMPSHOE: "Giày bật",
  T_12_Q_ITEM_DOUBLEJUMPSHOE_DESC: "Cho phép nhảy 2 lần trên không",
  T_12_Q_ITEM_FLYSHOE: "Giày phản lực",
  T_12_Q_ITEM_FLYSHOE_DESC: "Có thể bay được. Chú ý tránh để hết nhiên liệu khi đang trên cao.",
  T_12_Q_ITEM_STOCK1: "Báng Lv1",
  T_12_Q_ITEM_STOCK2: "Báng Lv2",
  T_12_Q_ITEM_STOCK3: "Báng Lv3",
  T_12_Q_ITEM_TREATMENTGUN: "Súng lục điện",
  T_12_Q_ITEM_VEST4: "Giáp chống nổ",
  T_12_R_CHARACTER_GANGLEADER_NAME: "Antonio",
  T_12_R_CHARACTER_MONKEYGOD_NAME: "Tôn Ngộ Không",
  T_12_R_EMOTE_SHOOTDANCE_NAME: "Bắn nhảy",
  T_12_R_EMOTE_WAVE_NAME: "Vẫy tay",
  T_12_R_SKILL_NAME_GANGLEADER: "Khí Chất Đại Ca",
  T_12_R_SKILL_NAME_MONKEYGOD: "Ảo ảnh",
  T_13_I_COLLECTION_V_AMPHIBIAN: "Xe đa năng",
  T_13_I_COLLECTION_V_JEEP: "Xe Jeep",
  T_13_I_COLLECTION_V_MONSTER: "Xe thính",
  T_13_I_COLLECTION_V_MOTOBIKE: "Xe máy",
  T_13_I_COLLECTION_V_ROADSTER: "Xe thể thao",
  T_13_I_COLLECTION_V_SUV: "Xe bán tải",
  T_13_I_COLLECTION_V_TUTU: "Tuk Tuk",
  T_13_L_MALE_ACCESSORY_COS_BJD: "Mặt nạ Ma búp bê",
  T_13_L_MALE_BOTTOM_COS_VALENTINE: "Quần Anh chàng đang yêu",
  T_13_L_MALE_HAIR_COS_BJD: "Tóc Ma búp bê",
  T_13_L_MALE_TOP_COS_VALENTINE: "Áo Anh chàng đang yêu",
  T_13_M_PVE_MATCH_SUMMARY_WEAPON: "Vũ Khí",
  T_13_O_PETSKIN_OCELOT_CAT_NAME: "Skin trợ thủ: Thám tử Mèo mèo",
  T_13_O_SCAR_VALENTINE_NAME: "SCAR Thần tình yêu",
  T_13_R_CHARACTER_HACKERGIRL_NAME: "Moco",
  T_13_R_EMOTE_BABYSHARK_NAME: "Baby Shark",
  T_13_R_EMOTE_BOMBSQUAD_NAME: "Chống đẩy",
  T_13_R_EMOTE_EGYPT_NAME: "Điệu nhảy xác ướp",
  T_13_R_PVE_WEAPON_SLOT: "Ô vũ khí",
  T_13_R_PVE_WEAPONSKIN_RANGE: "Tầm xa",
  T_13_R_PVE_WEAPONSKIN_SPEED: "Tốc độ bắn",
  T_13_R_SKILL_DESC_HACKERGIRL: "Đánh dấu kẻ địch bị bắn trúng trong[FFB300]{0}s[-] và chia sẻ thông tin với đồng đội.",
  T_13_R_SKILL_NAME_HACKERGIRL: "Kính Phù thủy công nghệ",
  T_13_Z_KICKOFF_BAN: "Bạn đã bị cấm ở phòng này.",
  T_13_Z_ROOM_MORNING: "Ngày",
  T_13_Z_ROOM_NIGHT: "Đêm",
  T_14_G_ITEM_KATANA: "Kiếm katana",
  T_14_I_HEADPIC_SONGKRAN_NAME: "TÉ NƯỚC !",
  T_14_L_ACCESSORY_COS_EASTERHEAD2: "Mũ Thỏ Vuông Hồng",
  T_14_L_COS_EASTER: "Gói Thỏ Tím 1937",
  T_14_L_FEMALE_SHOE_COS_FIREFIGHTERS: "Giày Hoa Khôi Cứu Hỏa",
  T_14_L_MALE_ACCESSORY_COS_EASTERRABBIT: "Đầu Thỏ Quậy",
  T_14_O_AK_WATERSPLASHING_NAME: "AK47 Bóng Nước",
  T_14_O_DOG_NAME: "Cún Robot",
  T_14_O_PETSKIN_IRON_DOG_NAME: "Skin Trợ thủ: Cún Máy Móc",
  T_14_O_PETSKIN_LIGNTNING_DOG_NAME: "Skin Trợ thủ: Cún Tia Chớp",
  T_14_O_PETSKIN_MAGNETIC_DOG_NAME: "Skin Trợ thủ: Cún Nam Châm",
  T_14_O_PETSKIN_NIGHT_CAT_NAME: "Skin Trợ thủ: Mèo Đêm",
  T_14_O_SCAR_BLOODMOON_NAME: "SCAR Huyết Nguyệt",
  T_14_O_SCAR_SHARK_NAME: "SCAR Hàm Cá Mập",
  T_14_Q_ITEM_RGS50: "Phóng Lựu",
  T_14_R_CHARACTER_SAMURAI_NAME: "Hayato",
  T_14_R_SKILL_DESC_SAMURAI: "Với mỗi [FFB300]{0}%[-] HP đã mất, tăng [FFB300]{1}%[-] xuyên giáp.",
  T_14_R_SKILL_NAME_SAMURAI: "Xuyên Giáp",
  T_15_L_MALE_ACCESSORY_COS_FAIM: "Mặt nạ Kẻ thanh trừng",
  T_15_L_MALE_ACCESSORY_COS_PESTILENCE: "Mặt nạ Sát thủ sinh học",
  T_15_L_MALE_BOTTOM_COS_FAIM: "Quần Kẻ thanh trừng",
  T_15_L_MALE_BOTTOM_COS_PESTILENCE: "Quần Sát thủ sinh học",
  T_15_L_MALE_SHOE_COS_FAIM: "Giày Kẻ thanh trừng",
  T_15_L_MALE_SHOE_COS_PESTILENCE: "Giày Sát thủ sinh học",
  T_15_L_MALE_TOP_COS_FAIM: "Áo Kẻ thanh trừng",
  T_15_L_MALE_TOP_COS_PESTILENCE: "Áo Sát thủ sinh học",
  T_15_L_TOP_COS_MOTHERSDAY: "Mẹ siêu việt",
  T_15_O_AN94_APOCALYPSE_NAME: "AN94 Thảm họa",
  T_15_O_BASEBALLBAT_VIKING_NAME: "Gậy Viking",
  T_15_O_M1014_APOCALYPSE_NAME: "M1014 Thảm họa",
  T_15_O_M4A1_APOCALYPSE_NAME: "M4A1 Thảm họa",
  T_15_O_PANTHER_NAME: "Báo bóng đêm",
  T_15_O_PETSKIN_CAPTAIN_PANTHER_NAME: "Skin trợ thủ: Báo đội trưởng",
  T_15_O_PETSKIN_GOLDEN_PANTHER_NAME: "Skin trợ thủ: Báo Hoàng Kim",
  T_15_O_PETSKIN_PURPLE_PANTHER_NAME: "Skin trợ thủ: Báo cai trị",
  T_15_O_SKS_DEATH_NAME: "SKS Tử thần",
  T_15_O_UMP_APOCALYPSE_NAME: "UMP Thảm họa",
  T_15_Q_ITEM_CG15: "CG15",
  T_15_Q_ITEM_GATLING: "Súng máy Gatling",
  T_15_R_CHARACTER_AGENT_NAME: "Laura",
  T_15_R_EMOTE_LETSGROOVE_NAME: "Lắc",
  T_15_R_SKILL_DESC_AGENT: "Tăng [FFB300]{0}%[-] Chính xác khi ngắm qua ống ngắm",
  T_15_R_SKILL_NAME_AGENT: "Siêu xạ thủ",
  T_15_W_BACKPACK_MECHGIRL_NAME: "Balo Thiên Thần Chiến Tranh",
  T_16_B_ITEM_GRAPPLINGHOOK: "Dây móc",
  T_16_B_ITEM_GRAPPLINGHOOKGUN: "Súng dây móc",
  T_16_L_MALE_COS_LEGO: "Người Xếp Hình",
  T_16_L_MALE_SHOE_COS_SUMMER: "Giày Hè vui vẻ",
  T_16_P_MANUAL_MONSTER: "Xe thính",
  T_16_P_MANUAL_MUSHROOM1: "Nấm cấp 1",
  T_16_P_MANUAL_MUSHROOM2: "Nấm cấp 2",
  T_16_P_MANUAL_MUSHROOM3: "Nấm cấp 3",
  T_16_P_MANUAL_MUSHROOM4: "Nấm cấp 4",
  T_16_P_MANUAL_ROADSTER_DESC: "Xe thể thao sành điệu. Độ bền thấp nhưng tốc độ nhanh kinh hoàng. Có thể chở tối đa 2 người",
  T_16_P_MANUAL_STROP: "Cáp trượt",
  T_16_P_MANUAL_SUV: "Xe bán tải",
  T_16_P_MANUAL_SUV_DESC: "Phương tiện đặc trưng của FreeFire. Độ bền vừa phải và tốc độ rất nhanh. Có thể chở 2 người chơi",
  T_16_P_MANUAL_TUTU_DESC: "Một phương tiện với độ bền thấp và di chuyển chậm. Có thể chở tối đa 3 người.",
  T_16_P_MANUAL_WEAPON_AR: "Súng trường",
  T_16_P_MANUAL_WEAPON_BOMB: "Lưu đạn",
  T_16_P_MANUAL_WEAPON_PISTOL: "Súng lục",
  T_16_P_MANUAL_WEAPON_SG: "Shotgun",
  T_16_P_MANUAL_WEAPON_SMG: "Súng tiểu liên",
  T_16_P_MANUAL_WEAPON_SR: "Súng ngắm",
  T_16_Q_MINISENTRY: "Tháp pháo nhỏ",
  T_16_Q_MINISENTRY_DESC: "Tháp pháo tự động quét và tấn công địch xung quanh",
  T_16_R_EMOTE_DESERT_NAME: "Trời sập",
  T_16_R_EMOTE_EPHUNTER_NAME: "Vũ điệu chiến trận",
  T_16_R_EMOTE_EPHUNTER2_NAME: "Đập tay",
  T_16_R_EMOTE_KICKTHEMOON_NAME: "Nguyệt cước",
  T_16_R_EMOTE_WIGGLEWALK_NAME: "Lắc lư",
  T_16_W_AK_FIRE_NAME: "AK47 - Lửa đỏ",
  T_16_W_SCAR_LLENN_NAME: "SCAR - Quỷ hồng",
  T_16_W_SCAR_WATER_NAME: "SCAR - Thủy thần",
  T_16_Y_CHARACTER_HITMAN_NAME: "Rafael",
  T_16_Y_PANDA_NAME: "Thám tử Panda",
  T_16_Y_PETSKIN_BROWN_PANDA_NAME: "Skin trợ thủ: Panda Hoang Dã",
  T_16_Y_PETSKIN_SKELETON_PANDA_NAME: "Skin trợ thủ: Panda Đầu Lâu",
  T_16_Y_PETSKIN_THOR_PANDA_NAME: "Skin trợ thủ: Panda Thần Sấm",
  T_17_B_CS_MODE_NAME: "Tử Chiến",
  T_17_C_SKILL_NAME_PLAYBOY: "Điên cuồng",
  T_17_L_FEMALE_ACCESSORY_COS_JOKER_ROYAL: "Mặt nạ Nàng hề hoàng gia",
  T_17_L_FEMALE_ACCESSORY_COS_VAMPIRE: "Mặt nạ Công nương máu",
  T_17_L_FEMALE_BOTTOM_COS_VAMPIRE: "Quần Công nương máu",
  T_17_L_FEMALE_HAIR_COS_SELVEDGEWORK: "Mũ Ly Ly",
  T_17_L_FEMALE_SHOE_COS_VAMPIRE: "Giày Công nương máu",
  T_17_L_FEMALE_TOP_COS_VAMPIRE: "Áo Công nương máu",
  T_17_L_MALE_ACCESSORY_COS_VAMPIRE: "Mặt nạ Nam tước máu",
  T_17_L_MALE_BOTTOM_COS_BOSOZOKU: "Quần Băng cướp đêm (Nam)",
  T_17_L_MALE_BOTTOM_COS_VAMPIRE: "Quần Nam tước máu",
  T_17_L_MALE_HAIR_COS_FFUNIT: "Mũ Lãng khách tím",
  T_17_L_MALE_SHOE_COS_INDEPENDENCE: "Giày phong cách Latin (Nam)",
  T_17_L_MALE_SHOE_COS_VAMPIRE: "Giày Nam tước máu",
  T_17_L_MALE_TOP_COS_VAMPIRE: "Áo Nam tước máu",
  T_17_L_MALE_TOP_COS_YINYANG_GOLD: "Áo Thích khách kim long",
  T_17_O_PETSKIN_ANNIVERSARY_CAT_NAME: "Skin trợ thủ: Mèo công chúa",
  T_17_O_PETSKIN_EARTHDRAGON_SHIBA_NAME: "Skin trợ thủ: Rồng đất",
  T_17_O_PETSKIN_ELECTRICDRAGON_SHIBA_NAME: "Skin trợ thủ: Rồng điện",
  T_17_O_PETSKIN_GREENDRAGON_SHIBA_NAME: "Skin trợ thủ: Rồng xanh",
  T_17_O_SHIBA_NAME: "Shiba",
  T_17_Q_FOLDWINGS: "Dù lượn",
  T_17_Q_FOLDWINGS_DESC: "Dùng để lượn từ địa hình cao",
  T_17_Q_SUPERHEAT: "PLASMA",
  T_17_R_EMOTE_PARTYDANCE_NAME: "Nhảy tiệc tùng",
  T_17_W_FAMAS_VAMPIRE_NAME: "FAMAS Ma cà rồng",
  T_17_W_SCAR_ASSASSIN_NAME: "SCAR - Bóng ma Sát thủ",
  T_17_W_SCAR_PLAYBOY_NAME: "SCAR Thanh lịch",
  T_17_Y_CHARACTER_MADEMANA_NAME: "A124",
  T_17_Y_CHARACTER_PLAYBOY_NAME: "Joseph",
  T_17_Z_CS_NAME: "Tên",
  T_17_Z_ROOM_JUMP_SWITCH: "Độ cao đã nhảy",
  T_17_Z_ROOM_SPEED_SWITCH: "Tốc độ di chuyển",
  T_18_B_THROWINGKNIFE_NAME: "Phi đao",
  T_18_C_DUMMY_NAME: "Lựu đạn Chim mồi",
  T_18_C_SKILL_DESC_DJMALE: "Tạo hào quang [FFB300]{1}m[-] tăng tốc độ di chuyển thêm [FFB300]{3}%[-] và hồi [FFB300]{2} HP/s[-], tồn tại trong [FFB300]{0}s[-]. Hiệu ứng không chồng lên nhau.Hồi chiêu: [FFB300]{4}s[-].",
  T_18_C_SKILL_NAME_DJMALE: "Giai điệu sinh mệnh",
  T_18_C_SKILL_NAME_JUNKENGINEER: "Giáp vĩnh cửu",
  T_18_L_COS_INDIANEWYEAR: "Khủng Long Huyền Thoại",
  T_18_L_HAIR_COS_HALLOWEEN2019: "Mũ Cương Thi",
  T_18_L_MALE_ACCESSORY_COS_BJD2_MAGMA: "Mặt nạ Ma Búp Bê Nham Thạch",
  T_18_O_FOX_NAME: "Hồ ly",
  T_18_O_PETSKIN_BLACKFOX_NAME: "Hồ ly Chiến trận",
  T_18_O_PETSKIN_BLUEFOX_NAME: "Lam Hồ ly",
  T_18_O_PETSKIN_HALLOWEEN_SHIBA_NAME: "Shiba Nham thạch",
  T_18_O_PETSKIN_PINKFOX_NAME: "Hỏa Hồ ly",
  T_18_O_PETSKIN_SPIRIT_PANTHER_NAME: "Báo bóng ma",
  T_18_U_WEAPON_M1887_NAME: "M1887",
  T_18_W_M4A1_FIRESKELETON_N: "M4A1 - Tử Thần Rực Lửa",
  T_18_W_UMP_GEISHA_N: "UMP - Nghệ Sĩ Tử Thần",
  T_18_Y_CHARACTER_DJMALE_N: "Alok",
  T_18_Y_CHARACTER_JUNKENGINEER_N: "Shani",
  T_19_B_HB_NAME: "Ván trượt điện",
  T_19_C_ICE_GUN_NAME: "Súng băng",
  T_19_C_SKILL_DESC_DEMOLITIONIST: "Sát thương vũ khí nổ tăng thêm [FFB300]{0}%[-], phạm vi nổ tăng thêm [FFB300]{1}%[-].",
  T_19_C_SKILL_DESC_TOMBOY: "Khi lái xe, phục hồi [FFB300]{1} HP[-] mỗi [FFB300]{0}s[-] cho tất cả người chơi trong phương tiện, tối đa [FFB300]{2}[-] HP.",
  T_19_C_SKILL_NAME_DEMOLITIONIST: "Nghệ thuật Phá huỷ",
  T_19_C_SKILL_NAME_TOMBOY: "Phước lành Đường đua",
  T_19_I_EVENT_INFI_ITEM: "Không giới hạn",
  T_19_L_A_ICEFESTIVAL19_B: "Đầu Tuần lộc",
  T_19_L_F_S_ICEFESTIVAL: "Giày Hầu gái Noel",
  T_19_L_MALE_BOTTOM_COS_DISCOMAN: "Quần Nhạc Disco",
  T_19_L_MALE_HAIR_COS_DISCOMAN: "Đầu Nhạc Disco",
  T_19_L_MALE_TOP_COS_DISCOMAN: "Áo Nhạc Disco",
  T_19_O_PETSKIN_NAME: "Trang phục trợ thủ: Mặc định",
  T_19_O_PETSKIN_PANDA_TRAPRAP_NAME: "Panda Hiphop",
  T_19_O_PETSKIN_PANDA_WINTERFELL_NAME: "Panda Bắc cực",
  T_19_O_PETSKIN_ROBOT_PHARAOH_NAME: "Robo Ai cập",
  T_19_O_PETSKIN_ROBOT_SPRING_NAME: "Robo Lễ hội",
  T_19_O_PETSKIN_ROBOT_WINTERFELL_NAME: "Robo Tuyết",
  T_19_O_PETSKIN_SHIBA_TRAPRAP_NAME: "Shiba Hiphop",
  T_19_O_ROBOT_NAME: "Robo",
  T_19_O_TDM_NAME: "Liên hoàn chiến",
  T_19_R_EMOTE_MIGUEL_NAME: "Break dance",
  T_19_S_SECOND_WEAPON_TITLE: "Vũ khí phụ",
  T_19_S_VEST_TITLE: "Giáp chống đạn",
  T_19_U_DOUBLEMAGEZINE_ATTACHMENT_NAME: "Băng đạn đôi",
  T_19_W_GROZA_TAGGERCREW_N: "GROZA - Graffiti",
  T_19_W_M60_ICEFESTIVAL_N: "M60 - Đêm đỏ",
  T_19_W_MP40_PARK_N: "MP40 - Truy sát",
  T_19_W_SCAR_CNNEWYEAR19_N: "Scar - Rồng Thiêng",
  T_19_X_PVE_SAMURAINAME: "Thủ lĩnh Samurai",
  T_19_Y_CHARACTER_DEMOLITIONIST_N: "Alvaro",
  T_19_Y_CHARACTER_TOMBOY_N: "Notora",
  T_20_C_INHALER_NAME: "Mặt nạ cứu thương",
  T_20_C_SKILL_DESC_PARKOURGUY: "Khi bắn trúng kẻ thù, người chơi sẽ được hồi một lượng máu. Khi hạ gục kẻ thù, hồi {0}% máu cho người chơi",
  T_20_C_SKILL_NAME_GRAFFITIST: "Không gian Sắc màu",
  T_20_C_SKILL_NAME_KELLY_AWAKENING: "Phát bắn gia tốc",
  T_20_C_SKILL_NAME_PARKOURGUY: "Đột kích",
  T_20_L_A_APRILFOOL2020: "Đầu Pug",
  T_20_L_F_A_METALHEAD_RED: "Mặt nạ Quỷ Lửa (Nữ)",
  T_20_L_F_B_THAIGIRL: "Quần Mị",
  T_20_L_F_H_KILLERCUPID: "Đầu Thiên sứ Tình yêu",
  T_20_L_F_H_THAIGIRL: "Mặt Mị",
  T_20_L_F_S_THAIGIRL: "Giày Mị",
  T_20_L_F_T_METALHEAD_RED: "Áo Quỷ Lửa (Nữ)",
  T_20_L_F_T_THAIGIRL: "Áo Mị",
  T_20_L_JEANDINO: "Khủng Long Jeans",
  T_20_L_M_A_METALHEAD_RED: "Mặt nạ Quỷ Lửa (Nam)",
  T_20_L_M_T_METALHEAD_RED: "Áo Quỷ Lửa (Nam)",
  T_20_L_M_T_STOCKING: "Áo Thế Phiệt",
  T_20_O_PETSKIN_LOVERFOX_NAME: "Hồ ly Tình yêu",
  T_20_P_CHANNEL_G: "Quân đoàn",
  T_20_P_WORLD_SSPEAKER: "Loa",
  T_20_S_CSROOM_COIN: "Tiền mặc định",
  T_20_U_SHIELD_GUN_NAME: "Súng Từ trường",
  T_20_W_AN94_METALHEAD_N: "AN94 - Ong sát thủ",
  T_20_W_P90_EVILBONE_N: "P90 - Hành quyết",
  T_20_Y_CHARACTER_GRAFFITIST_N: "Steffie",
  T_20_Y_CHARACTER_KELLY_AWAKENING_N: "Kelly Tia chớp",
  T_20_Y_CHARACTER_PARKOURGUY_N: "Jota",
  T_21_B_SMOKEGRENADE_DESC: "Tạo khói, tuyệt vời để che chắn và phòng thủ bên sườn",
  T_21_B_SMOKEGRENADE_NAME: "Lựu khói",
  T_21_C_AUTOPICKUP_AVERAGE: "Mặc định",
  T_21_C_SKILL_DESC_KPOPSINGER: "Khi cứu một đồng đội, đồng đội đó nhận ngay một lá chắn giá trị [FFB300]{0}[-] và [FFB300]{1}%[-] tốc độ di chuyển. Hiệu ứng giảm dần trong vòng [FFB300]{2} giây[-] sau khi cứu thành công. Giảm [FFB300]{3}%[-] tốc độ mất máu khi bị hạ gục của đồng đội. Các hiệu ứng không cộng dồn.",
  T_21_C_SKILL_DESC_SOCCERSTAR: "Mỗi mạng tiêu diệt tăng máu tối đa thêm [FFB300]{0}[-], lên đến [FFB300]{1}[-].",
  T_21_C_SKILL_NAME_KPOPSINGER: "Khúc cao trào",
  T_21_C_SKILL_NAME_SOCCERSTAR: "Hat Trick",
  T_21_L_ANGELICAL: "Khủng long Thám hiểm",
  T_21_L_S_VNSLIPPER: "Dép tổ ong",
  T_21_O_OTTER_NAME: "Ottero",
  T_21_O_PETSKIN_OTTER_GREY_NAME: "Ottero Đầm lầy",
  T_21_O_PETSKIN_OTTER_PINK_NAME: "Ottero Kẹo hồng",
  T_21_O_PETSKIN_OTTER_PURPLE_NAME: "Ottero Âm nhạc",
  T_21_O_PETSKIN_ROBOT_DEATH_NAME: "Robo Tử thần",
  T_21_O_PETSKIN_SPINE_PANTHER_NAME: "Báo Huỷ diệt",
  T_21_R_EMOTE_SORROW_NAME: "U buồn",
  T_21_U_WEAPON_THOMPSON_NAME: "Thompson",
  T_21_W_BACKPACK_SPINE_N: "Balo Dạ Quang",
  T_21_W_BASEBALLPOLE_DEATH2020_N: "Gậy Chiến thắng",
  T_21_W_M79_RABBITKILLER_N: "M79 - Thỏ quậy",
  T_21_W_PAN_VOLCANO_N: "Chảo Nham thạch",
  T_21_W_XM8_RAINBOW_N: "XM8 - Cá mập vàng",
  T_21_Y_CHARACTER_KPOPSINGER_N: "Kapella",
  T_21_Y_CHARACTER_SOCCERSTAR_N: "Luqueta",
  T_22_C_BLT_NAME: "M82B",
  T_22_C_SKILL_DESC_DETECTIVE: "Xác định vị trí của kẻ thù trong [FFB300]{0}m[-], những người không ngồi hoặc nằm. Kéo dài trong [FFB300]{1}s[-]. Vị trí kẻ địch sẽ được chia sẻ cho đồng đội. Thời gian hồi: [FFB300]{2}s[-].",
  T_22_C_SKILL_NAME_DETECTIVE: "Truy Vết",
  T_22_C_SKILL_NAME_STREAMERGUY: "Livestream",
  T_22_L_F_H_COLLEGE: "Tóc Học viên Nham tinh",
  T_22_L_F_S_SUMMER20: "Giày Nữ cứu hộ",
  T_22_L_M_A_GREENCOAT: "Kính Thần tượng giới trẻ",
  T_22_L_M_A_PINKFUR: "Kính Trai hư",
  T_22_L_M_A_PLAGUE2: "Khăn Chuyên Gia Chất Độc",
  T_22_L_M_B_FAIM2: "Quần Hỏa Sư Tối Thượng",
  T_22_L_M_B_GREENCOAT: "Quần Thần tượng giới trẻ",
  T_22_L_M_B_PINKFUR: "Quần Trai hư",
  T_22_L_M_B_PLAGUE2: "Quần Chuyên Gia Chất Độc",
  T_22_L_M_B_REDPANTS: "Quần Dân chơi đường phố",
  T_22_L_M_B_TIGERSTRIPE: "Quần Trùm trường",
  T_22_L_M_H_COLLEGE: "Tóc Học viên Nham thạch",
  T_22_L_M_H_FAIM2: "Tóc Hỏa Sư Tối Thượng",
  T_22_L_M_H_GREENCOAT: "Tóc Thần tượng giới trẻ",
  T_22_L_M_H_PINKFUR: "Tóc Trai hư",
  T_22_L_M_H_PLAGUE2: "Tóc Chuyên Gia Chất Độc",
  T_22_L_M_H_REDPANTS: "Mũ Dân chơi đường phố",
  T_22_L_M_H_TIGERSTRIPE: "Mũ Trùm trường",
  T_22_L_M_S_FAIM2: "Giày Hỏa Sư Tối Thượng",
  T_22_L_M_S_PLAGUE2: "Giày Chuyên Gia Chất Độc",
  T_22_L_M_T_FAIM2: "Áo Hỏa Sư Tối Thượng",
  T_22_L_M_T_GREENCOAT: "Áo Thần tượng giới trẻ",
  T_22_L_M_T_PINKFUR: "Áo Trai hư",
  T_22_L_M_T_PLAGUE2: "Áo Chuyên Gia Chất Độc",
  T_22_L_M_T_REDPANTS: "Áo Dân chơi đường phố",
  T_22_L_M_T_TIGERSTRIPE: "Áo Trùm trường",
  T_22_LC_KAR98K_COLLEGE_N: "Kar98K Học viện",
  T_22_LC_PAN_CAPTAINBUBBLE_N: "Chảo Dưa hấu",
  T_22_LC_SCAR_HERMIT_N: "SCAR Cổ đại",
  T_22_LC_TREATMENTGUN_APOCALYPSE2_N: "Súng lục điện Ác ma",
  T_22_O_HAWK_NAME: "Đại bàng",
  T_22_O_PETSKIN_FOX_APOCALYPSE_NAME: "Hồ ly Khải huyền",
  T_22_O_PETSKIN_HAWK_FIRE_NAME: "Đại bàng Lửa",
  T_22_O_PETSKIN_HAWK_NATURE_NAME: "Đại bàng Xanh",
  T_22_O_PETSKIN_SHIBA_SUMMER_NAME: "Shiba Ánh dương",
  T_22_Q_BOMB_PLIERS: "Dụng cụ gỡ bom",
  T_22_R_EMOTE_SHIMMY_NAME: "Lắc vai",
  T_22_U_GOLD_AWM_N: "AWM_Y",
  T_22_U_WPNSKN_BITE: "Xuyên giáp",
  T_22_U_WPNSKN_SPEED_RUN: "Tốc độ di chuyển",
  T_22_Y_CHARACTER_DETECTIVE_N: "Clu",
  T_22_Y_CHARACTER_STREAMERGUY_N: "Wolfrahh",
  T_23_B_CARDIAC_NAME: "Bộ hồi phục",
  T_23_C_SKILL_NAME_HAYATO_AWAKENING: "Khiên dao",
  T_23_C_SKILL_NAME_SWATGUY: "Lên đạn",
  T_23_D_CHARACTER_HAYATO_AWAKENING_N: "Hayato Hoả quyền",
  T_23_D_CHARACTER_SWATGUY_N: "Jai",
  T_23_L_F_B_GANGSTERRAP_GOLD: "Quần Rap Đường phố vàng (Nữ)",
  T_23_L_F_B_MIKOGIRL: "Quần Nữ tiên tri",
  T_23_L_F_B_NAVYGIRL: "Váy Nữ thuỷ thủ",
  T_23_L_F_H_GANGSTERRAP_GOLD: "Đầu Rap Đường phố vàng (Nữ)",
  T_23_L_F_H_MIKOGIRL: "Đầu Nữ tiên tri",
  T_23_L_F_H_NAVYGIRL: "Đầu Nữ thuỷ thủ",
  T_23_L_F_S_MIKOGIRL: "Giày Nữ tiên tri",
  T_23_L_F_S_ORDERCHALLENGER: "Giày Kẻ chủ mưu",
  T_23_L_F_T_GANGSTERRAP_GOLD: "Áo Rap Đường phố vàng (Nữ)",
  T_23_L_F_T_MIKOGIRL: "Áo Nữ tiên tri",
  T_23_L_F_T_NAVYGIRL: "Áo Nữ thuỷ thủ",
  T_23_L_M_A_GANGSTERRAP_GOLD: "Mặt nạ Rap Đường phố vàng (Nam)",
  T_23_L_M_B_FOXGUY: "Quần Thần cáo",
  T_23_L_M_B_GANGSTERRAP_GOLD: "Quần Rap Đường phố vàng (Nam)",
  T_23_L_M_H_FOXGUY: "Đầu Thần cáo",
  T_23_LC_SKS_GEMINI_N: "SKS Cuồng loạn",
  T_23_O_PENGUIN_NAME: "Mr. Waggor",
  T_23_O_PETSKIN_PENGUIN_A_NAME: "Mr.Waggor Tiệc tùng",
  T_23_O_PETSKIN_PENGUIN_C_NAME: "Mr.Waggor Neon",
  T_23_O_PETSKIN_PENGUIN_G_NAME: "Mr.Waggor Rapper",
  T_23_T_ANNI3_LOBBY_NODENAME20: "Tử Chiến",
  T_23_T_ANNI3_LOBBY_NODENAME5: "Nhân vật",
  T_23_U_AUG: "AUG",
  T_23_Z_R_UID: "UID",
  T_24_AD_ADSPACE_WARNING: "CẢNH BÁO",
  T_24_C_FLAMETHROWER_NAME: "Súng phun lửa",
  T_24_C_SKILL_DESC_PROFESSOR: "EP tối đa tăng lên [FFB300]{0}[-]. Chế độ Jiu-jitsu: Các đồng minh trong vòng [FFB300]{2}m[-] được tăng [FFB300]{1}%[-] tỷ lệ chuyển đổi EP. Chế độ Bậc thầy: Khôi phục [FFB300]{5} EP[-] sau mỗi [FFB300]{4}s[-], tối đa [FFB300]{6} EP[-]. Chuyển đổi Chế độ: CD [FFB300]{3}s[-].",
  T_24_C_SKILL_NAME_PARTYGIRL: "Quẩy lên",
  T_24_C_SKILL_NAME_PROFESSOR: "Bậc thầy",
  T_24_D_CHARACTER_PARTYGIRL_N: "Dasha",
  T_24_D_CHARACTER_PROFESSOR_N: "K",
  T_24_L_B_MAXPANTS: "Quần MAX",
  T_24_L_H_PUMPKIN2020_A: "Mũ Bí ngô",
  T_24_L_T_TSHIRT_COMEDIAN: "Áo thun Hài",
  T_24_LC_MP5_RICHBOXER_N: "MP5 Boxing",
  T_24_LC_SCAR_PARTYGIRL_N: "SCAR Tiệc tùng",
  T_24_LC_SVD_WARRINGSTATES_N: "SVD Samurai",
  T_24_U_M21A5: "Chim Gõ Kiến",
  T_24_U_PARAFAL: "PARAFAL",
  T_24_V_TRAINING_AIMBOT_GAMESCORE: "Tổng điểm",
  T_24_V_TRAINING_BOX_ATTACH: "Phụ kiện",
  T_24_V_TRAINING_BOX_WEAPON: "Vũ khí",
  T_24_W_ARMORY: "Vũ khí",
  T_24_W_ARMOTY_MELEE: "Cận chiến",
  T_24_W_ARMOTY_PISTOL: "Súng lục",
  T_24_W_ARMOTY_RIFLE: "Súng trường",
  T_24_W_ARMOTY_SHOTGUN: "Shotgun",
  T_24_W_ARMOTY_SNIPER: "Súng ngắm",
  T_24_W_ARMOTY_SPECIAL: "Khác",
  T_24_W_ARMOTY_SUBMACHINE: "Tiểu liên",
  T_24_W_PETSKIN_PANDA_BOOYAHDAY_N: "Panda Booyah",
  T_24_W_PETSKIN_RACCOON_BRIGHT_N: "Gấu mèo Tử thần",
  T_24_W_PETSKIN_RACCOON_MECH_N: "Gấu mèo Điện tử",
  T_24_W_PETSKIN_RACCOON_UNDEAD_N: "Gấu mèo Ma quái",
  T_24_W_RACCOON_N: "Gấu mèo Rockie",
  T_25_C_SKILL_NAME_BOUNTYHUNTER: "Hào Quang Hộ Mệnh",
  T_25_D_CHARACTER_BOUNTY_N: "Chrono",
  T_25_E_HUD_01: "Cấu hình đặt trước 1",
  T_25_E_HUD_02: "Cấu hình đặt trước 2",
  T_25_L_F_B_DEMONKILLER: "Quần Quý bà Hỏa quyền",
  T_25_L_F_H_DEMONKILLER: "Tóc Quý bà Hỏa quyền",
  T_25_L_F_S_DEMONKILLER: "Giày Quý bà Hỏa quyền",
  T_25_L_F_T_DEMONKILLER: "Áo Quý bà Hỏa quyền",
  T_25_L_HA_FP_EVIL: "Mặt ác quỷ",
  T_25_L_M_H_ANIMEHAIR: "Tóc thân thiện",
  T_25_L_S_MAXSNEAKERS: "Giày thể thao MAX",
  T_25_LC_BASEBALLBAT_BOUNTY_N: "Gậy Thời không",
  T_25_LC_GLOO_WINTERFEST2020_N: "Bom keo Giáng sinh",
  T_25_LC_M1887_WINTERFEST2020_N: "M1887 Băng giá",
  T_25_LC_MACHETE_BOUNTY_N: "Đao - Thời Không",
  T_25_LC_P90_MUSICFALL_GREEN_N: "P90 Chiến Ca Lục Bảo",
  T_25_LC_P90_MUSICFALL_RED_N: "P90 Chiến Ca Hồng Ngọc",
  T_25_LC_PAN_BOUNTY_N: "Chảo Thời không",
  T_25_R_LEGEND_REMIND: "Lời nhắc",
  T_25_U_MAG7: "MAG-7",
  T_25_U_SICKLE: "Lưỡi hái",
  T_25_U_VECTOR: "Vector",
  T_25_W_BABOON_N: "Đấu sĩ khỉ",
  T_25_W_PETSKIN_BABOON_FROZEN_N: "Đấu sĩ khỉ Hàn băng",
  T_25_W_PETSKIN_BABOON_HELL_N: "Đấu sĩ khỉ Nham thạch",
  T_25_W_PETSKIN_BABOON_PURE_N: "Đấu sĩ Khỉ Tối thượng",
  T_25_W_PETSKIN_PANTHER_WINTERFEST2020_N: "Báo Tuyết",
  T_25_Z_R_SIMULATOR_OFF: "Từ chối",
  T_26_C_SKILL_DESC_SUPERSTAR: "Phóng ra một đợt sóng âm về phía trước trong phạm vi [FFB300]{0}m[-]. Nó phát nổ và gây sát thương cho các bom keo trong bán kính [FFB300]{1}m[-] trong vòng [FFB300]{2}s[-]. Thời gian hồi: [FFB300]{3}s[-].",
  T_26_C_SKILL_NAME_SUPERSTAR: "Hủy diệt băng thành",
  T_26_D_CHARACTER_DELIVERY_N: "Shirou",
  T_26_D_CHARACTER_SUPERSTAR_N: "Skyler",
  T_26_ET_CELLPHONE_NAME: "Mini Drone",
  T_26_L_A_FLAMING_PREM: "Mặt nạ Chiến thần dung nham",
  T_26_L_A_SANTAMODE: "Mặt nạ Người tuyết hắc ám",
  T_26_L_B_SANTAMODE: "Quần Người tuyết hắc ám",
  T_26_L_F_B_WATERFEST21_A: "Quẩy Thôi Nào (Quần)",
  T_26_L_F_H_WATERFEST21_A: "Quẩy Thôi Nào (Đầu)",
  T_26_L_F_S_WATERFEST21_A: "Quẩy Thôi Nào (Giày)",
  T_26_L_F_T_WATERFEST21_A: "Quẩy Thôi Nào (Áo)",
  T_26_L_M_A_EGGDAY2021: "Mặt nạ Thỏ trùm",
  T_26_L_M_B_EGGDAY2021: "Quần Thỏ trùm",
  T_26_L_M_B_PAIRING: "Quần Nam thần lịch lãm",
  T_26_L_M_B_WATERFEST21_A: "Hơi Thở Mùa Hè (Quần)",
  T_26_L_M_H_EGGDAY2021: "Đầu Thỏ trùm",
  T_26_L_M_H_PAIRING: "Đầu Nam thần lịch lãm",
  T_26_L_M_H_WATERFEST21_A: "Hơi Thở Mùa Hè (Đầu)",
  T_26_L_M_S_EGGDAY2021: "Giày Thỏ trùm",
  T_26_L_M_S_PAIRING: "Giày Nam thần lịch lãm",
  T_26_L_M_S_WATERFEST21_A: "Hơi Thở Mùa Hè (Giày)",
  T_26_L_M_T_EGGDAY2021: "Áo Thỏ trùm",
  T_26_L_M_T_PAIRING: "Áo Nam thần lịch lãm",
  T_26_L_M_T_WATERFEST21_A: "Hơi Thở Mùa Hè (Áo)",
  T_26_L_S_SANTAMODE: "Giày Người tuyết hắc ám",
  T_26_L_T_SANTAMODE: "Áo Người tuyết hắc ám",
  T_26_LC_AWM_KOICARP_N: "AWM Vận mệnh hoàng kim",
  T_26_LC_KATANA_VALENTINE2021_N: "Katana - Hồng Phong",
  T_26_LC_VEHICLE_ROADSTER_COBRA_N: "Xe thể thao - Hỗn Mang",
  T_26_P_SKILL_NAME_DELIVERY: "Ăn miếng trả miếng",
  T_26_V_TRAINING_BHH: "Búa Thần bí",
  T_26_V_TRAINING_DICE: "Xúc xắc khổng lồ",
  T_26_W_DRAGON_N: "Rồng Dreki",
  T_26_W_PETSKIN_DRAGON_EVIL_N: "Dreki Đại dương",
  T_26_W_PETSKIN_DRAGON_GOLDEN_N: "Dreki Ánh sáng",
  T_26_W_PETSKIN_DRAGON_PURPLE_N: "Dreki Bóng đêm",
  T_26_W_PETSKIN_PENGUIN_VALENTINE2021_N: "Cánh cụt đang yêu",
  T_26_XL_SETTING_TEAMMATE_INFO: "Thông tin đồng đội",
  T_26_YP_HISTORY_WIN: "Chiến thắng",
  T_26_YP_SOCIAL_GENDER_FEMALE: "Nữ",
  T_26_YP_SOCIAL_GENDER_MALE: "Nam",
  T_26_YP_SOCIAL_NAME: "Biệt danh",
  T_27_C_SKILL_DESC__RACERGIRL: "Tốc độ lái xe tăng [FFB300]{0}%[-]. Khi ở trong phương tiện, nhân vật khó bị ngắm bắn hơn và giảm [FFB300]{1}%[-] sát thương nhận vào.",
  T_27_C_SKILL_DESC_BOUNTYHUNTER: "Tạo ra trường lực không thể xuyên thủng, ngăn [FFB300]{0} sát thương[-]. Không thể tấn công từ trong trường lực. Hiệu ứng tồn tại trong [FFB300]{1}s[-]. Hồi chiêu: [FFB300]{2}s[-].",
  T_27_C_SKILL_DESC_FALCONER: "Sát thương tăng theo khoảng cách, tối đa [FFB300]{0}%[-]. Sát thương vào kẻ thù bị đánh dấu tăng [FFB300]{1}%[-].",
  T_27_C_SKILL_DESC_HAYATO_AWAKENING: "Thức tỉnh: Giảm sát thương phía trước mặt [FFB300]{1}%[-] với mỗi [FFB300]{0}%[-] Máu mất",
  T_27_C_SKILL_DESC_KELLY_AWAKENING: "Thức tỉnh: Chạy nhanh trong [FFB300]{0}s[-] để kích hoạt. Khi kích hoạt,[FFB300]{2}[-] phát bắn đầu tiên trúng mục tiêu gây [FFB300]{1}%[-] sát thương. Tồn tại trong [FFB300]{3}s[-].",
  T_27_C_SKILL_NAME_FALCONER: "Ưng tiễn",
  T_27_C_SKILL_NAME_XTREME: "Cuồng bạo",
  T_27_D_CHARACTER_ANDREW_AWAKENING_N: "Andrew Nhiệt huyết",
  T_27_D_CHARACTER_FALCONER_N: "Maro",
  T_27_D_CHARACTER_XTREME_N: "Xayne",
  T_27_F_EAP_PKG3_D: "Battle in style",
  T_27_HYL_SKILLBOARD_HP: "Máu",
  T_27_L_A_CARDBOARD_MID2: "Mặt nạ Hổ trùm lắm chiêu",
  T_27_L_B_CARDBOARD_REG: "Quần Gấu nhà người ta",
  T_27_L_M_S_KAZAKHSTAN: "Giày Tộc trưởng phương Bắc",
  T_27_L_S_CARDBOARD_REG: "Giày Gấu nhà người ta",
  T_27_L_T_CARDBOARD_REG: "Áo Gấu nhà người ta",
  T_27_LC_VECTOR_FFWS2021_N: "Vector - Bất bại",
  T_27_LC_VEHICLE_MONSTER_FFWS2021_N: "Xe thính - Vinh Quang",
  T_27_LC_VEHICLE_MOTOBIKE_BOXER_N: "Xe máy - Chiến binh",
  T_27_LC_VEHICLE_ROADSTER_FASTBREAKING_N: "Xe thể thao - Niềm Tin",
  T_27_LC_VEHICLE_SUV_DRAGON_N: "Xe bán tải - Long Tộc",
  T_27_P_SKILL_NAME_HITMAN_RE: "Câm Lặng",
  T_27_R_EMOTE_GREETING_NAME: "Cho em xin",
  T_27_R_VEHICLE_ACCELERATION: "Tăng tốc",
  T_27_R_VEHICLE_HP: "Độ bền",
  T_27_R_VEHICLE_SPEED: "Tốc độ tối đa",
  T_27_U_KORD: "Súng máy Kord",
  T_27_U_M1917: "M1917",
  T_27_U_SKILL_DESC_ANDREW_AWAKENING: "Thức tỉnh: Tăng hiệu quả giảm sát thương của giáp thêm [FFB300]{0}%[-]. Tăng thêm [FFB300]{1}%[-] giảm sát thương với mỗi đồng đội trong vòng [FFB300]{2}m[-].",
  T_27_U_SKILL_NAME_ANDREW_AWAKENING: "Gắn kết",
  T_27_U_WSP: "USP-2",
  T_27_W_ALIEN_N: "Moony",
  T_27_W_ARMOTY_DMR: "Súng trường tầm xa",
  T_27_W_PETSKIN_ALIEN_CRYSTAL_N: "Skin Moony Lấp lánh",
  T_27_W_PETSKIN_ALIEN_GAMER_N: "Skin Moony Game thủ",
  T_27_W_PETSKIN_ALIEN_HIPSTER_N: "Skin Moony Hiphop",
  T_27_W_PETSKIN_DOG_FFWS2021_N: "Skin Cún Thiên Hà",
  T_27_W_PETSKIN_PANDA_FFWS2021_N: "Skin Thám tử Panda Thiên Hà",
  T_27_XC_REPLAY_DIE: "Chết",
  T_27_XC_REPLAY_KILL: "Tiêu diệt",
  T_27_XL_WEREWOLVES_INGAME_REPAIR: "Sửa chữa",
  T_28_C_G_ICE_NAME: "Lựu choáng băng",
  T_28_C_SKILL_DESC_STREETBEAT: "Khi vừa di chuyển vừa bắn, tốc độ tăng [FFB300]{0}%[-], độ chính xác tăng [FFB300]{1}%[-].",
  T_28_C_SKILL_NAME_STREETBEAT: "Đạn xuyên âm",
  T_28_D_CHARACTER_STREETBEAT_N: "D-bee",
  T_28_HI_UZI: "Mini Uzi",
  T_28_L_B_BRJERSEY_A: "Quần bóng đá lục",
  T_28_L_B_BRJERSEY_B: "Quần bóng đá lam",
  T_28_L_B_BRJERSEY_C: "Quần bóng đá đỏ",
  T_28_L_B_BRJERSEY_D: "Quần bóng đá đen",
  T_28_L_B_BRJERSEY_E: "Quần bóng đá vàng",
  T_28_L_B_BRJERSEY_F: "Quần bóng đá hồng",
  T_28_L_F_B_FOURSYMBOLS_C: "Quần Chu Tước",
  T_28_L_F_H_FOURSYMBOLS_C: "Đầu Chu Tước",
  T_28_L_F_HA_FOURSYMBOLS_C: "Mặt Chu Tước",
  T_28_L_F_S_FOURSYMBOLS_C: "Giày Chu Tước",
  T_28_L_F_T_FOURSYMBOLS_C: "Áo Chu Tước",
  T_28_L_HA_THUNDER: "Mắt tia chớp",
  T_28_L_M_A_SPORTSUIT: "Mặt nạ trai ngổ ngáo",
  T_28_L_M_B_FOURSYMBOLS_D: "Quần Huyền Vũ",
  T_28_L_M_B_SPORTSUIT: "Quần trai ngổ ngáo",
  T_28_L_M_H_FOURSYMBOLS_D: "Đầu Huyền Vũ",
  T_28_L_M_H_SPORTSUIT: "Đầu trai ngổ ngáo",
  T_28_L_M_S_FOURSYMBOLS_D: "Giày Huyền Vũ",
  T_28_L_M_S_SPORTSUIT: "Giày trai ngổ ngáo",
  T_28_L_M_T_FALLWINTER: "Áo trùm dân chơi",
  T_28_L_M_T_FOURSYMBOLS_D: "Áo Huyền Vũ",
  T_28_L_M_T_SPORTSUIT: "Áo trai ngổ ngáo",
  T_28_L_T_BRJERSEY_A: "Áo bóng đá lục",
  T_28_L_T_BRJERSEY_B: "Áo bóng đá lam",
  T_28_L_T_BRJERSEY_C: "Áo bóng đá đen đỏ",
  T_28_L_T_BRJERSEY_D: "Áo bóng đá đen",
  T_28_L_T_BRJERSEY_E: "Áo bóng đá vàng",
  T_28_L_T_BRJERSEY_F: "Áo bóng đá hồng",
  T_28_LC_AN94_CRIMSONBRIDE_N: "AN94 Hồng Ngọc",
  T_28_LC_GLOO_FALLWINTER_N: "Bom keo tiệc tùng",
  T_28_LC_GLOO_FOURSYMBOLS_N: "Bom keo Thanh Long",
  T_28_LC_KORD_SHINOBI_N: "Súng máy Kord Sát thủ",
  T_28_LC_M21A5_FANTASYEYE_N: "Chim Gõ Kiến Ma pháp sư",
  T_28_LC_MAG7_WHITESHARK_N: "Mag-7 Biển cả",
  T_28_LC_PAN_FOURSYMBOLS_N: "Chảo Huyền Vũ",
  T_28_LC_VEHICLE_JEEP_FOURSYMBOLS_N: "Xe Jeep - Thanh Long",
  T_28_T_WS_ITEM1: "Hộp vuông",
  T_28_T_WS_ITEM10: "Túp lều",
  T_28_T_WS_ITEM11: "Tháp canh",
  T_28_T_WS_ITEM12: "Tiền đồn",
  T_28_T_WS_ITEM13: "Nhà A",
  T_28_T_WS_ITEM14: "Nhà B",
  T_28_T_WS_ITEM15: "Nhà C",
  T_28_T_WS_ITEM16: "Cấu trúc cát",
  T_28_T_WS_ITEM17: "Suối",
  T_28_T_WS_ITEM18: "Hoa anh đào",
  T_28_T_WS_ITEM19: "Cây chuối",
  T_28_T_WS_ITEM2: "Hộp dài",
  T_28_T_WS_ITEM20: "Bồn cầu",
  T_28_T_WS_ITEM21: "Hàng rào",
  T_28_T_WS_ITEM3: "Bụi cây",
  T_28_T_WS_ITEM4: "Đống rơm",
  T_28_T_WS_ITEM5: "Xe",
  T_28_T_WS_ITEM6: "Xe buýt",
  T_28_T_WS_ITEM7: "Container A",
  T_28_T_WS_ITEM8: "Container B",
  T_28_T_WS_ITEM9: "Container C",
  T_28_T_WS_TYPE1: "Vật thể",
  T_28_T_WS_TYPE4: "Trang trí",
  T_28_W_DUCK_N: "Vịt Vàng",
  T_28_W_PETSKIN_DRAGON_FOURSYMBOLS_N: "Dreki Tiểu Thanh Long",
  T_28_W_PETSKIN_DUCK_ARMY_N: "Vịt Vàng chất chơi",
  T_28_W_PETSKIN_DUCK_BLACK_N: "Vịt Vàng đầu gấu",
  T_28_W_PETSKIN_DUCK_SHINY_N: "DJ Vịt Vàng",
  T_28_YF_AR15: "Chim Bói Cá",
  T_29_C_SKILL_DESC_MOCO_AWAKENING: "Thức tỉnh: đánh dấu trên kẻ thù trúng đòn lâu hơn khi kẻ thù di chuyển (tối đa [FFB300]{0}s[-]).",
  T_29_C_SKILL_NAME_MOCO_AWAKENING: "Mắt công nghệ",
  T_29_C_SKILL_NAME_MUSICBRO_BLACK: "Giai điệu sinh tồn",
  T_29_C_SKILL_NAME_MUSICBRO_WHITE: "Nhịp điệu hồi sinh",
  T_29_D_CHARACTER_AMOCO_N: "Moco thức tỉnh",
  T_29_D_CHARACTER_MUSICBRO1_N: "Dimitri",
  T_29_D_CHARACTER_MUSICBRO2_N: "Thiva",
  T_29_HI_MINI14: "AC80",
  T_29_L_B_TRJERSEY: "Quần bóng đá sọc đỏ",
  T_29_L_M_A_FALCONER_C: "Mặt nạ linh vương",
  T_29_L_M_A_JUNGLE_GREEN: "Mặt nạ chiến binh rùa xanh",
  T_29_L_M_B_FALCONER_C: "Quần linh vương",
  T_29_L_M_B_JUNGLE_GREEN: "Quần chiến binh rùa xanh",
  T_29_L_M_H_FALCONER_C: "Tóc linh vương",
  T_29_L_M_H_JUNGLE_GREEN: "Mũ chiến binh rùa xanh",
  T_29_L_M_S_FALCONER_C: "Giày linh vương",
  T_29_L_M_S_JUNGLE_GREEN: "Giày chiến binh rùa xanh",
  T_29_L_M_T_FALCONER_C: "Áo linh vương",
  T_29_L_M_T_JUNGLE_GREEN: "Áo chiến binh rùa xanh",
  T_29_L_T_TRJERSEY: "Áo bóng đá sọc đỏ",
  T_29_M_WS_ITEM22: "Thùng chứa chắc chắn",
  T_29_M_WS_ITEM23: "Hàng rào chắc chắn",
  T_29_M_WS_ITEM24: "Điểm xuất phát A",
  T_29_M_WS_ITEM25: "Điểm xuất phát B",
  T_29_M_WS_TYPE5: "Vật thể tương tác",
  T_29_W_PETSKIN_BROWN_TIGER_N: "Ninja Hổ: Thổ",
  T_29_W_PETSKIN_FIRE_TIGER_N: "Ninja Hổ: Hỏa",
  T_29_W_PETSKIN_HAWK_MOCOMONTH_N: "Skin trợ thủ: Đại bàng ma trận",
  T_29_W_PETSKIN_PANDA_MUSICFEST_N: "Skin trợ thủ: Panda tiệc tùng",
  T_29_W_PETSKIN_WHITE_TIGER_N: "Ninja Hổ: Băng",
  T_29_W_TIGER_NINJA_N: "Tiểu Hổ",
  T_29_YF_MACHETE_MUSICFEST_N: "Đao Huyền Quang",
  T_29_YF_MAGEZINE_CHAIN_N: "Băng đạn súng trường",
  T_29_YF_MUZZLE_CRASH_N: "Nòng Tiểu liên",
  T_29_YF_MUZZLE_WIDE_N: "Nòng shotgun",
  T_29_YF_SPAS12_MOCOMONTH_N: "SPAS12 Moco Công nghệ",
  T_29_YF_UZI_GOLDENWING_N: "UZI Hoàng kim",
  T_29_YF_VEHICLE_MONSTER_SKELETONTRUCK_N: "Xe thính Nanh Vàng",
  T_30_AD_RP_ROUNDEND: "HẾT VÒNG",
  T_30_AD_TRAINING_SNOWBALL: "Cầu tuyết",
  T_30_AD_TRAINING_SNOWBALL_DES: "Hãy cùng làm 1 trận cầu tuyết nào!",
  T_30_C_SKILL_DESC_BOOYAHGUY: "[FFB300]{0} giây[-] sau khi bị tấn công, hồi phục [FFB300]{1}HP[-]/giây trong [FFB300]{2}giây[-]",
  T_30_C_SKILL_NAME_BOOYAHGUY: "Ghi điểm Phút Chót",
  T_30_C_SKILL_NAME_MUERTOGUY: "Vén màn bí ẩn",
  T_30_D_CHARACTER_BOOYAHGUY_N: "Leon",
  T_30_D_CHARACTER_MUERTOGUY_N: "Otho",
  T_30_JMF_SKILLCHIP_NAME_SWATGUY: "Chip kỹ năng của Jai",
  T_30_L_A_BRMASCOT_ADULT: "Đầu gà bực bội",
  T_30_L_A_BRMASCOT_KIDS: "Đầu gà đáng yêu",
  T_30_L_A_SUGARSKULL21_BANDANA: "Mặt nạ xương vàng",
  T_30_L_B_BRFOOTBALL_BLACK: "Quần đội tuyển Brazil (đen)",
  T_30_L_B_BRFOOTBALL_GREEN: "Quần đội tuyển Brazil (lục)",
  T_30_L_B_BRFOOTBALL_GREY: "Quần đội tuyển Brazil (xám)",
  T_30_L_B_BRUNIFORM: "Quần Cầu thủ gà con",
  T_30_L_F_A_SUGARSKULL21: "Mặt nạ Nữ Hoàng Dạ Hội",
  T_30_L_F_B_SUGARSKULL21: "Quần Nữ Hoàng Dạ Hội",
  T_30_L_F_B_THASIAN: "Quần Cô nương vân mỹ",
  T_30_L_F_H_CATEARS: "Tai mèo đáng yêu",
  T_30_L_F_H_SUGARSKULL21: "Tóc Nữ Hoàng Dạ Hội",
  T_30_L_F_H_THASIAN: "Tóc Cô nương vân mỹ",
  T_30_L_F_S_SUGARSKULL21: "Giày Nữ Hoàng Dạ Hội",
  T_30_L_F_S_THASIAN: "Giày Cô nương vân mỹ",
  T_30_L_F_T_SUGARSKULL21: "Áo Nữ Hoàng Dạ Hội",
  T_30_L_F_T_THASIAN: "Áo Cô nương vân mỹ",
  T_30_L_H_CHILDRENSDAY_BLUE: "Mũ cá heo",
  T_30_L_H_CHILDRENSDAY_RED: "Mũ voi kì cục",
  T_30_L_H_CLOWNHAT: "Mũ hề vàng",
  T_30_L_H_ZASCARF: "Khăn vàng ròng",
  T_30_L_M_A_LIGHTFEST_GANGSTER: "Kính Lãng tử giao du",
  T_30_L_M_A_SUGARSKULL21: "Mặt nạ Ông Hoàng Dạ Hội",
  T_30_L_M_B_LIGHTFEST_GANGSTER: "Quần Lãng tử giao du",
  T_30_L_M_B_PKCRICKET: "Giày Nhà vô địch bóng chày",
  T_30_L_M_B_SUGARSKULL21: "Quần Ông Hoàng Dạ Hội",
  T_30_L_M_B_SUGARSKULL21_CASUAL: "Quần Tay đua cuồng phong",
  T_30_L_M_B_THASIAN: "Quần Lãng tử vân long",
  T_30_L_M_H_LIGHTFEST_GANGSTER: "Tóc Lãng tử giao du",
  T_30_L_M_H_SUGARSKULL21: "Tóc Ông Hoàng Dạ Hội",
  T_30_L_M_H_SUGARSKULL21_CASUAL: "Tóc Tay đua cuồng phong",
  T_30_L_M_H_THASIAN: "Tóc Lãng tử vân long",
  T_30_L_M_HA_BOOYAHDAY21_YELLOW: "Mặt Chiến thần phong cách Alpha",
  T_30_L_M_S_LIGHTFEST_GANGSTER: "Giày Lãng tử giao du",
  T_30_L_M_S_PKCRICKET: "Giày Nhà vô địch bóng chày",
  T_30_L_M_S_SUGARSKULL21: "Giày Ông hoàng dạ hội",
  T_30_L_M_S_SUGARSKULL21_CASUAL: "Giày Tay đua cuồng phong",
  T_30_L_M_S_THASIAN: "Giày Lãng tử vân long",
  T_30_L_M_T_LIGHTFEST_GANGSTER: "Áo Lãng tử giao du",
  T_30_L_M_T_PKCRICKET: "Áo Nhà vô địch bóng chày",
  T_30_L_M_T_SUGARSKULL21: "Áo Ông hoàng dạ hội",
  T_30_L_M_T_SUGARSKULL21_CASUAL: "Áo Tay đua cuồng phong",
  T_30_L_M_T_THASIAN: "Áo Lãng tử vân long",
  T_30_L_S_BRUNIFORM: "Giày Cầu thủ gà con",
  T_30_L_T_BRFOOTBALL_BLACK: "Áo đội tuyển Brazil (đen)",
  T_30_L_T_BRFOOTBALL_GREEN: "Áo đội tuyển Brazil (lục)",
  T_30_L_T_BRFOOTBALL_GREY: "Áo đội tuyển Brazil (xám)",
  T_30_L_T_BRUNIFORM: "Áo Cầu thủ gà con",
  T_30_M_WS_PARTY_MODE: "Sân chơi",
  T_30_R_EMOTE_BATTLEINSTYLE_NAME: "BATTLE IN STYLE",
  T_30_R_EMOTE_BOOYAHDAY21_PROVOCATION_NAME: "Tới luôn đi",
  T_30_R_EMOTE_MAX_NAME: "Bắn rap",
  T_30_R_LEGEND_HALO_NAME: "Hiệu ứng Vòng Lửa",
  T_30_T_WS_DEFAULTDESCRIPTION: "Bản đồ thú vị trong thiết kế bản đồ",
  T_30_T_WS_ITEM26: "Lốp xe",
  T_30_T_WS_ITEM27: "Lốp lộn xộn A",
  T_30_T_WS_ITEM28: "Lốp lộn xộn B",
  T_30_T_WS_ITEM29: "Lốp lộn xộn C",
  T_30_T_WS_ITEM30: "Xe đụng",
  T_30_T_WS_ITEM31: "Xe lội nước",
  T_30_T_WS_ITEM32: "Xe Jeep",
  T_30_T_WS_ITEM33: "Thùng rác",
  T_30_T_WS_ITEM34: "Bóng râm",
  T_30_T_WS_ITEM35: "Lều y tế",
  T_30_T_WS_ITEM36: "Garage",
  T_30_T_WS_ITEM37: "Tường sơn",
  T_30_T_WS_ITEM38: "Cổng Trời",
  T_30_T_WS_ITEM39: "Bệ sắt",
  T_30_T_WS_ITEM40: "Túp lều",
  T_30_T_WS_ITEM41: "Trailer",
  T_30_T_WS_ITEM42: "Tường A",
  T_30_T_WS_ITEM43: "Tường B",
  T_30_T_WS_ITEM44: "Tường C",
  T_30_T_WS_ITEM45: "Tường D",
  T_30_T_WS_ITEM46: "Tường E",
  T_30_T_WS_ITEM47: "Tường F",
  T_30_U_ATTACHMENT_1: "Phụ Kiện Lá Chắn",
  T_30_U_ATTACHMENT_4: "Phụ Kiện Giáp: Mở rộng",
  T_30_U_ATTACHMENT_5: "Phụ Kiện Mũ: Cường Hóa",
  T_30_U_ATTACHMENT_6: "Phụ Kiện Giáp: Chống Nổ",
  T_30_W_PETSKIN_BABOON_SUGARSKULL21_N: "Đấu sĩ Khỉ: Bí hiểm",
  T_30_W_PETSKIN_PENGUIN_EVILRHYTHM_N: "Cánh cụt Sinh tồn",
  T_30_W_PETSKIN_RABBIT_BULLSEYE_N: "Mật vụ thỏ bông: Thiên Nhãn",
  T_30_W_PETSKIN_RABBIT_CLOWN_N: "Mật vụ thỏ bông: Hồng Ngọc",
  T_30_W_PETSKIN_RABBIT_URBAN_N: "Mật vụ thỏ bông: Công nghệ",
  T_30_W_PETSKIN_ROBOT_TRNAZAR_N: "Robo Thủy long",
  T_30_W_PETSKIN_ROBOT_VNDRINK_N: "Robo Yomost",
  T_30_W_RABBIT_N: "Mật vụ thỏ bông",
  T_30_XH_PCMAP_P17: "Xưởng Cơ Khí",
  T_30_YF_GLOO_BOOYAHDAY21_N: "Bom keo Phong cách",
  T_30_YF_GRENADE_BOOYAHDAY21_N: "Lựu đạn Phong cách",
  T_30_YF_Healinggun_Sniper_N: "Súng ngắm điện",
  T_30_YF_MINI_LIGHTFEST_N: "AC80 ánh sáng",
  T_30_YF_PARAFAL_ZATRIBAL_N: "PARAFAL Hoàng tử máu",
  T_30_YF_SCAR_LIGHTFEST_N: "SCAR ánh sáng",
  T_30_YF_THOMPSON_SUGARSKULL21_N: "Thompson Dạ hội",
  T_30_YF_VEHICLE_ROADSTER_EVILRHYTHM_N: "Xe thể thao - Sinh Tồn",
  T_31_C_SKILL_NAME_WINTERGUY: "Keo Bất Tử",
  T_31_HQ_BASEBALLBAT_WINTERFEST21_N: "Gậy Kỷ Nguyên",
  T_31_HQ_GLOO_EAGLE_N: "Bom keo Lãnh Chúa",
  T_31_HQ_HEALINGSNIPER_WINTERFEST21_N: "Súng ngắm điện - Lễ Hội Tuyết",
  T_31_HQ_KATANA_WINTERFEST21_N: "Katana - Tuyết Hồng",
  T_31_HQ_PAN_WINTERFEST21_N: "Chảo Kỷ Nguyên",
  T_31_HQ_PETSKIN_OTTER_WINTERFEST21_N: "Skin trợ thủ: Ottero Giáng sinh",
  T_31_HQ_PETSKIN_PENGUIN_WINTERFEST21_N: "Skin trợ thủ: Waggor dân quẩy",
  T_31_HQ_PETSKIN_YETI_GREEN_N: "Skin trợ thủ: Yeti Tộc Trưởng",
  T_31_HQ_PETSKIN_YETI_RED_N: "Skin trợ thủ: Yeti Chiến binh",
  T_31_HQ_SICKLE_WINTERFEST21_N: "Lưỡi hái Tuyết Hồng",
  T_31_HQ_VEHICLE_MOTOBIKE_NEWYEAR21_N: "Xe máy - Băng Tâm",
  T_31_HQ_YETI_N: "Yeti",
  T_31_KK_WINTER_BUJIX: "Hộp tiếp tế",
  T_31_KK_WINTER_SANJITOU: "Mũ bảo hiểm",
  T_31_L_A_BDCRICKET: "Mũ Cầu Thủ Vô Địch",
  T_31_L_A_WINTERFEST21: "Mặt nạ Tuần Lộc",
  T_31_L_B_BDCRICKET: "Quần Cầu Thủ Vô Địch",
  T_31_L_B_MEJERSEY_10: "Quần Bóng Đá Hồng Ngọc Số 10",
  T_31_L_B_MEJERSEY_11: "Quần Bóng Đá Số 11",
  T_31_L_B_MEJERSEY_13: "Quần Bóng Đá Trắng Số 13",
  T_31_L_B_MEJERSEY_18G: "Quần Bóng Đá Vân Lục Số 18",
  T_31_L_B_MEJERSEY_18R: "Quần Bóng Đá Vân Đỏ Số 18",
  T_31_L_B_MEJERSEY_7: "Quần Bóng Đá Cánh Lục Số 7",
  T_31_L_F_B_RUMUSICIAN: "Quần Em Ét O Ét",
  T_31_L_F_B_THAGENT: "Quần Điệp Viên Bóng Đêm",
  T_31_L_F_H_REGGAETON_HEADWEAR: "Mũ Hòa Nhạc (Nữ)",
  T_31_L_F_H_RUMUSICIAN: "Tóc Em Ét O Ét",
  T_31_L_F_H_THAGENT: "Tóc Điệp Viên Bóng Đêm",
  T_31_L_F_HA_RUMUSICIAN: "Mặt Em Ét O Ét",
  T_31_L_F_S_RUMUSICIAN: "Giày Em Ét O Ét",
  T_31_L_F_S_THAGENT: "Giày Điệp Viên Bóng Đêm",
  T_31_L_F_T_RUMUSICIAN: "Áo Em Ét O Ét",
  T_31_L_F_T_THAGENT: "Áo Điệp Viên Bóng Đêm",
  T_31_L_HA_RUMUSICIAN_MU: "Mặt Anh Ét O Ét",
  T_31_L_HA_WINTERFEST21_BLUE: "Mặt nạ Băng Tâm",
  T_31_L_HA_WINTERFEST21_PINK: "Mặt nạ Pháo bông",
  T_31_L_M_A_REGGAETON_B: "Kính Dân Chơi Neon",
  T_31_L_M_A_REGGAETON_P: "Kính DJ Nhạc Bốc",
  T_31_L_M_A_RUMUSICIAN: "Mặt nạ Anh Ét O Ét",
  T_31_L_M_A_THAGENT: "Mặt nạ Mật Vụ Hoàng Gia",
  T_31_L_M_B_PKCOSTUME: "Quần Lục Thanh Lịch",
  T_31_L_M_B_REGGAETON_B: "Quần Dân Chơi Neon",
  T_31_L_M_B_REGGAETON_P: "Quần DJ Nhạc Bốc",
  T_31_L_M_B_RUMUSICIAN: "Quần Anh Ét O Ét",
  T_31_L_M_B_THAGENT: "Quần Mật Vụ Hoàng Gia",
  T_31_L_M_H_GREENCAP: "Mũ Lưỡi Trai Vô Địch",
  T_31_L_M_H_PKCOSTUME: "Tóc Lục Thanh Lịch",
  T_31_L_M_H_REGGAETON_B: "Tóc Dân Chơi Neon",
  T_31_L_M_H_REGGAETON_HEADWEAR: "Mũ Hòa Nhạc (Nam)",
  T_31_L_M_H_REGGAETON_P: "Tóc DJ Nhạc Bốc",
  T_31_L_M_H_RUMUSICIAN: "Tóc Anh Ét O Ét",
  T_31_L_M_H_THAGENT: "Tóc Mật Vụ Hoàng Gia",
  T_31_L_M_S_PKCOSTUME: "Giày Lục Thanh Lịch",
  T_31_L_M_S_REGGAETON_B: "Giày Dân Chơi Neon",
  T_31_L_M_S_REGGAETON_P: "Giày DJ Nhạc Bốc",
  T_31_L_M_S_RUMUSICIAN: "Giày Anh Ét O Ét",
  T_31_L_M_S_THAGENT: "Giày Mật Vụ Hoàng Gia",
  T_31_L_M_T_PKCOSTUME: "Áo Lục Thanh Lịch",
  T_31_L_M_T_REGGAETON_B: "Áo Dân Chơi Neon",
  T_31_L_M_T_REGGAETON_P: "Áo DJ Nhạc Bốc",
  T_31_L_M_T_REGGAETON_TATOO: "Hình xăm Hầm Hố",
  T_31_L_M_T_RUMUSICIAN: "Áo Anh Ét O Ét",
  T_31_L_M_T_THAGENT: "Áo Mật Vụ Hoàng Gia",
  T_31_L_S_BDCRICKET: "Giày Cầu Thủ Vô Địch",
  T_31_L_T_BDCRICKET: "Áo Cầu Thủ Vô Địch",
  T_31_L_T_BRBANK: "Áo khoác Đỏ Phong Cách",
  T_31_L_T_MEJERSEY_10: "Áo Bóng Đá Hồng Ngọc Số 10",
  T_31_L_T_MEJERSEY_11: "Áo Bóng Đá Đỏ Số 11",
  T_31_L_T_MEJERSEY_13: "Áo Bóng Đá Trắng Số 13",
  T_31_L_T_MEJERSEY_18G: "Áo Bóng Đá Vân Lục Số 18",
  T_31_L_T_MEJERSEY_18R: "Áo Bóng Đá Vân Đỏ Số 18",
  T_31_L_T_MEJERSEY_7: "Áo Bóng Đá Cánh Lục Số 7",
  T_31_L_T_PKMOBILE: "Áo Vô Cực",
  T_31_L_T_REGGAETON_HOOD: "Áo Trùm Cá Tính",
  T_31_MF_CHARACTER_WINTERGUY_N: "Nairi",
  T_31_R_EMOTE_FALCONER_NAME: "Bạn là nhất!",
  T_31_RW_COMBINEMACHINE_2: "Bộ kích hoạt súng đôi (nâng cao)",
  T_31_RW_VIBRATION_EXPLOSION: "Vụ nổ",
  T_31_RW_VIBRATION_MELEEWEAPONS: "Vũ khí cận chiến",
  T_31_RW_VIBRATION_OTHERWEAPONS: "Súng khác",
  T_31_T_WS_1PLAYERTEAM: "Solo",
  T_31_T_WS_2PLAYERTEAM: "Duo",
  T_31_T_WS_3PLAYERTEAM: "Trio",
  T_31_T_WS_4PLAYERTEAM: "Tổ đội",
  T_31_T_WS_5PLAYERTEAM: "Đội 5 người",
  T_31_T_WS_6PLAYERTEAM: "Đội 6 người",
  T_31_T_WS_BUFFTIME_TITLE: "Thời gian làm mới (giây)",
  T_31_T_WS_BUFFTYPE_AMMO: "Đạn",
  T_31_T_WS_BUFFTYPE_ARMOR: "Áo giáp",
  T_31_T_WS_BUFFTYPE_HP: "Máu",
  T_31_T_WS_BUFFTYPE_RANDOM: "Ngẫu nhiên",
  T_31_T_WS_BUFFTYPE_TITLE: "Loại Buff",
  T_31_T_WS_DESC48: "Đưa bạn đến một nơi khác, trong vòng vài mili giây",
  T_31_T_WS_DESC49: "Tạo ra âm thanh của một cây đàn piano",
  T_31_T_WS_DESC51: "Tạo ra âm thanh của trống",
  T_31_T_WS_DESC53: "Tạo ra âm thanh của bộ nhạc cụ tổng hợp",
  T_31_T_WS_DESC59: "Một thiết bị tạo ra một bộ đệm định kỳ. Nhặt nó để nhận được một phụ kiện tương ứng",
  T_31_T_WS_DRUMTYPE_CLAPS: "Vỗ tay",
  T_31_T_WS_DRUMTYPE_HIHATS: "Hi-hat",
  T_31_T_WS_DRUMTYPE_KICK: "Đánh trống",
  T_31_T_WS_DRUMTYPE_OPENHIHATS: "Mở Hi-hat",
  T_31_T_WS_DRUMTYPE_RIDES: "Chũm chọe to",
  T_31_T_WS_DRUMTYPE_SNARES: "Trống lẫy",
  T_31_T_WS_EARLYSHRINK: "Thu hẹp nhanh",
  T_31_T_WS_ITEM48: "Cổng dịch chuyển",
  T_31_T_WS_ITEM49: "Phím Piano",
  T_31_T_WS_ITEM51: "Khóa trống",
  T_31_T_WS_ITEM53: "Combo phím A",
  T_31_T_WS_ITEM55: "Combo phím B",
  T_31_T_WS_ITEM57: "Combo phím C",
  T_31_T_WS_ITEM59: "Bộ tạo đệm",
  T_31_T_WS_LATESHRINK: "Thu hẹp muộn",
  T_31_T_WS_ME_DAMAGE: "Sát thương gây ra",
  T_31_T_WS_ME_DAMAGED: "Sát thương đã xảy ra",
  T_31_T_WS_ME_DEFAULTEPPERCENT: "Tỷ lệ EP ban đầu",
  T_31_T_WS_ME_DEFAULTSAFERADIUS: "Bán kính vùng an toàn đầu tiên",
  T_31_T_WS_ME_EPQUICKRESTORE: "Chuyển đổi EP nhanh",
  T_31_T_WS_ME_FLOW: "Chế độ",
  T_31_T_WS_ME_GENERALSETTING: "Chung",
  T_31_T_WS_ME_INRANDOMSPAWN: "Điểm xuất phát ngẫu nhiên",
  T_31_T_WS_ME_KILLSCORE: "Điểm thưởng hạ gục địch",
  T_31_T_WS_ME_MAXEP: "EP tối đa",
  T_31_T_WS_ME_MAXHP: "Máu tối đa",
  T_31_T_WS_ME_NEARTEAM: "Gần đồng đội",
  T_31_T_WS_ME_REBIRTH: "Thời gian chờ điểm xuất phát",
  T_31_T_WS_ME_REBIRTHLOCATION: "Vị trí điểm xuất phát",
  T_31_T_WS_ME_SAFEZONESHRINKTIME: "Thời gian bắt đầu thu hẹp Vùng an toàn",
  T_31_T_WS_ME_WINSCORE: "Điểm chiến thắng",
  T_31_T_WS_MINIZONE: "Chiến trường Mini",
  T_31_T_WS_MUSICTYPE_TITLE: "Loại nhạc",
  T_31_T_WS_UNLIMITEDAMMO: "Vô hạn đạn",
  T_31_WT_WS_DESC1: "Hộp gỗ hình vuông có thể xếp chồng lên nhau",
  T_31_WT_WS_DESC10: "Một túp lều đổ nát có cầu thang gỗ để leo lên",
  T_31_WT_WS_DESC11: "Được xây dựng với nhiều cửa sổ để dễ dàng bắn",
  T_31_WT_WS_DESC12: "Được làm bằng kim loại và có cửa ra vào và cửa sổ",
  T_31_WT_WS_DESC13: "Có cửa ra vào và cửa sổ",
  T_31_WT_WS_DESC14: "Ngôi nhà hai tầng có sân thượng",
  T_31_WT_WS_DESC15: "Ngôi nhà hai tầng có mái nhà kín",
  T_31_WT_WS_DESC16: "Trang trí - một tượng cát hình trái tim",
  T_31_WT_WS_DESC17: "Trang trí - một đài phun nước trong như pha lê",
  T_31_WT_WS_DESC18: "Trang trí - cây hoa màu hồng",
  T_31_WT_WS_DESC19: "Trang trí - một cây chuối nhỏ không có quả chuối nào",
  T_31_WT_WS_DESC2: "Một hộp gỗ hình chữ nhật có thể xếp chồng lên nhau",
  T_31_WT_WS_DESC20: "Nội thất phòng tắm màu trắng có thể đặt trong nhà",
  T_31_WT_WS_DESC21: "Một hàng rào nhỏ dùng để phân chia các khu vực",
  T_31_WT_WS_DESC22: "Các tấm ván bằng gỗ ở mặt bên của container có thể bị phá vỡ",
  T_31_WT_WS_DESC23: "Một hàng rào nhỏ có thể bị phá vỡ",
  T_31_WT_WS_DESC24: "Khu vực chờ cho đội A(khả dụng cho Tử chiến, Liên hoàn chiến và các chế độ khác)",
  T_31_WT_WS_DESC25: "Khu vực chờ cho đội B (chỉ áp dụng cho Tử chiến, Liên hoàn chiến và các chế độ khác)",
  T_31_WT_WS_DESC26: "Trả người chơi về hướng họ đang quay đầu, ở tầm gần",
  T_31_WT_WS_DESC27: "Trả lại người chơi về hướng định trước, ở tầm gần",
  T_31_WT_WS_DESC28: "Trả lại người chơi về hướng định trước, ở tầm trung",
  T_31_WT_WS_DESC29: "Trả lại người chơi về hướng định trước, ở tầm xa",
  T_31_WT_WS_DESC3: "Được tô điểm bởi những bông hoa đỏ và vàng có thể thắp sáng chiến trường",
  T_31_WT_WS_DESC30: "Một chiếc xe đụng có thể lái được",
  T_31_WT_WS_DESC31: "Một chiếc xe lội nước có thể lái được",
  T_31_WT_WS_DESC32: "Một chiếc xe Jeep có thể lái được",
  T_31_WT_WS_DESC33: "Thùng rác chứa đầy rác. Thấp hơn một người nhưng có thể dùng làm nơi trú ẩn",
  T_31_WT_WS_DESC34: "Nơi trú ẩn ngoài trời, kết cấu bằng kim loại",
  T_31_WT_WS_DESC35: "Một căn lều cỡ trung có hai cửa ra vào nhưng không có cửa sổ",
  T_31_WT_WS_DESC36: "Một nhà để xe lớn xây bằng gạch",
  T_31_WT_WS_DESC37: "Một bức tường gạch lớn dùng để ngăn cách các khu vực",
  T_31_WT_WS_DESC38: "Một cột mốc hữu ích",
  T_31_WT_WS_DESC39: "Một bệ kim loại lớn có thể được sử dụng làm chiến trường chính",
  T_31_WT_WS_DESC4: "Cao hơn đầu người và vì thế có thể làm chỗ trú ẩn",
  T_31_WT_WS_DESC40: "Trông giống như một phương tiện giải trí và có nhiều cửa ra vào và cửa sổ",
  T_31_WT_WS_DESC41: "Trông giống như một phương tiện giải trí và có một cửa ra vào và nhiều cửa sổ",
  T_31_WT_WS_DESC42: "Một bức tường một mặt có lối vào",
  T_31_WT_WS_DESC43: "Một bức tường một mặt thông thường",
  T_31_WT_WS_DESC44: "Một góc tường",
  T_31_WT_WS_DESC45: "Một góc tường không bằng phẳng",
  T_31_WT_WS_DESC46: "Một góc tường không bằng phẳng",
  T_31_WT_WS_DESC47: "Một góc tường có cửa sổ",
  T_31_WT_WS_DESC5: "Một chiếc ô tô bị bỏ, thấp hơn người chút nhưng có thể làm chỗ trú ẩn",
  T_31_WT_WS_DESC6: "Cao hơn đầu người và vì thế có thể làm chỗ trú ẩn",
  T_31_WT_WS_DESC7: "Mở ở cả hai đầu và có thể được bố trí để tạo thành các lối đi hoặc để phân chia các khu vực",
  T_31_WT_WS_DESC8: "Mở ở một đầu và có thể được sử dụng để phân chia các khu vực",
  T_31_WT_WS_DESC9: "Bịt kín cả hai đầu và có thể dùng để phân chia các khu vực",
  T_31_YF_MAC10_N: "MAC10",
  T_31_YM_PIN_VEHICLE: "Phương tiện",
  T_31_Z_OB_UAV: "UAV",
  T_32_C_SKILL_DESC_YAKUZA: "Lướt về phía trước với tốc độ cao trong [FFB300]{0}s[-]. Kỹ năng này có thể tích lũy để sử dụng tới [FFB300]{2} lần[-], thời gian hồi chiêu giữa các lần là [FFB300]{3}s[-]. Hồi chiêu: [FFB300]{1}s[-].",
  T_32_C_SKILL_NAME_YAKUZA: "Tốc hành tức thời",
  T_32_HQ_AUG_VNSTREET_N: "AUG Thần Bo",
  T_32_HQ_BACKPACK_REDDRAGON_N: "Balo Huyết Long",
  T_32_HQ_BLT_VALENTINE2022_N: "M82B Bóng Tối",
  T_32_HQ_GLOO_DUNHUANG_N: "Bom keo Băng Tiễn",
  T_32_HQ_GLOO_HURRICANE_2_N: "Bom keo Lõi Ma Thuật",
  T_32_HQ_GRENADE_HURRICANE_N: "Lựu đạn Mic Lõi Đồng",
  T_32_HQ_MAC10_DUNHUANG_N: "MAC10 Băng Tiễn",
  T_32_HQ_PETSKIN_DUCK_RED_N: "Skin trợ thủ: Vịt đỏ",
  T_32_HQ_PETSKIN_TORTOISE_BLUE_N: "Skin trợ thủ: Rùa Công Nghệ",
  T_32_HQ_PETSKIN_TORTOISE_GREEN_N: "Skin trợ thủ: Rùa Game Thủ",
  T_32_HQ_PETSKIN_TORTOISE_RED_N: "Skin Trợ Thủ: Rùa Lân Sư",
  T_32_HQ_TORTOISE_N: "Rùa Bảo Kê",
  T_32_HQ_VEHICLE_ROADSTER_UNDERTAKER_N: "Xe thể thao - Tai Ương",
  T_32_L_F_A_PHARAOH: "Mặt nạ Dân Chơi Ai Cập",
  T_32_L_F_B_PHARAOH: "Quần Dân Chơi Ai Cập",
  T_32_L_F_H_PHARAOH: "Mũ Dân Chơi Ai Cập",
  T_32_L_F_HA_PHARAOH: "Mặt Dân Chơi Ai Cập",
  T_32_L_F_S_PHARAOH: "Giày Dân Chơi Ai Cập",
  T_32_L_F_T_PHARAOH: "Áo Dân Chơi Ai Cập",
  T_32_L_M_A_JUNKFOOD: "Kính Anh Chàng Bơ Gơ",
  T_32_L_M_A_PHARAOH: "Mặt nạ Hoàng Tử Ai Cập",
  T_32_L_M_B_JUNKFOOD: "Quần Anh Chàng Bơ Gơ",
  T_32_L_M_B_PHARAOH: "Quần Hoàng Tử Ai Cập",
  T_32_L_M_H_JUNKFOOD: "Tóc Anh Chàng Bơ Gơ",
  T_32_L_M_H_PHARAOH: "Mũ Hoàng Tử Ai Cập",
  T_32_L_M_S_JUNKFOOD: "Giày Anh Chàng Bơ Gơ",
  T_32_L_M_S_PHARAOH: "Giày Hoàng Tử Ai Cập",
  T_32_L_M_T_JUNKFOOD: "Áo Anh Chàng Bơ Gơ",
  T_32_L_M_T_PHARAOH: "Áo Hoàng Tử Ai Cập",
  T_32_L_T_WHITESWEATER: "Áo Cổ rùa trắng",
  T_32_LC_NEWVAULT_EMOTE: "Hành động",
  T_32_LO_WS_IMMORTAL: "Vùng bất tử",
  T_32_LO_WS_ITEM60: "Đường ống",
  T_32_LO_WS_ITEM60_DESC: "Đường ống có thể đi qua",
  T_32_LO_WS_ITEM61: "Đường ống chữ T",
  T_32_LO_WS_ITEM61_DESC: "Đường ống chữ T có thể đi qua",
  T_32_LO_WS_ITEM62: "Đường ống ngã 4",
  T_32_LO_WS_ITEM62_DESC: "Đường ống ngã 4 có thể đi qua",
  T_32_LO_WS_ITEM63: "Đường ống góc",
  T_32_LO_WS_ITEM63_DESC: "Đường ống góc có thể đi qua",
  T_32_LO_WS_ITEM64: "Xe bán hàng lưu động",
  T_32_LO_WS_ITEM64_DESC: "Xe đẩy dịch vụ ăn uống đậu bên đường",
  T_32_LO_WS_ITEM65: "Nấm khổng lồ",
  T_32_LO_WS_ITEM65_DESC: "Một người có thể đi trên cây nấm khổng lồ này",
  T_32_LO_WS_ITEM66: "Giá phơi đồ",
  T_32_LO_WS_ITEM66_DESC: "Thường thấy ở các khu dân cư",
  T_32_LO_WS_ITEM67: "Tấm ván",
  T_32_LO_WS_ITEM67_DESC: "Sử dụng để làm một cây cầu đơn giản",
  T_32_LO_WS_ITEM68: "Tấm lưới",
  T_32_LO_WS_ITEM68_DESC: "Đồ trang trí phương Đông",
  T_32_LO_WS_ITEM69: "Cột trụ",
  T_32_LO_WS_ITEM69_DESC: "Thường thấy ở các công trường",
  T_32_LO_WS_ITEM70: "Cây xương rồng",
  T_32_LO_WS_ITEM70_DESC: "Cây xương rồng lớn nhưng không có gai",
  T_32_LO_WS_ITEM71: "Cây trụi lá",
  T_32_LO_WS_ITEM71_DESC: "Cây đã sống lâu",
  T_32_LO_WS_ITEM72: "Đèn lồng đá",
  T_32_LO_WS_ITEM72_DESC: "Được trang trí đẹp trong các khu vườn",
  T_32_LO_WS_ITEM73: "Đèn đường",
  T_32_LO_WS_ITEM73_DESC: "Thường thấy trên đường",
  T_32_LO_WS_ITEM74: "Tấm pin mặt trời",
  T_32_LO_WS_ITEM74_DESC: "Hấp thụ năng lượng mặt trời",
  T_32_LO_WS_ITEM75: "Điều hòa",
  T_32_LO_WS_ITEM75_DESC: "Mang lại sự mát mẻ trong mùa hè",
  T_32_LO_WS_ITEM76: "Quạt",
  T_32_LO_WS_ITEM77: "Cánh quạt",
  T_32_LO_WS_ITEM78: "Khối lập phương",
  T_32_LO_WS_ITEM79: "Nhẫn",
  T_32_LO_WS_ITEM80: "Búa",
  T_32_LO_WS_ITEM81: "Tấm bảng",
  T_32_LO_WS_ITEM82: "Bia đạn",
  T_32_LO_WS_ITEM83: "Tường kéo",
  T_32_LO_WS_ITEM84AMMO: "Điểm nhặt đạn",
  T_32_LO_WS_ITEM84AMMO_DESC: "Sau khi được đặt, loại đạn đã lựa chọn sẽ xuất hiện tại đó",
  T_32_LO_WS_ITEM84AR: "Điểm nhặt áo giáp",
  T_32_LO_WS_ITEM84AR_DESC: "Sau khi được đặt, loại áo giáp đã lựa chọn sẽ xuất hiện tại đó",
  T_32_LO_WS_ITEM84ARLV1: "Giáp Lv.1",
  T_32_LO_WS_ITEM84ARLV2: "Giáp Lv.2",
  T_32_LO_WS_ITEM84ARLV3: "Giáp Lv.3",
  T_32_LO_WS_ITEM84CO: "Điểm nhặt vật phẩm tiếp tế",
  T_32_LO_WS_ITEM84CO_DESC: "Sau khi được đặt, loại vật phẩm tiếp tế đã lựa chọn sẽ xuất hiện tại đó",
  T_32_LO_WS_ITEM84JA: "Điểm nhặt lựu đạn",
  T_32_LO_WS_ITEM84JA_DESC: "Sau khi được đặt, loại lựu đã lựa chọn sẽ xuất hiện tại đó",
  T_32_LO_WS_ITEM84TE: "Điểm nhặt ống ngắm",
  T_32_LO_WS_ITEM84TE_DESC: "Sau khi được đặt, loại ống ngắm đã lựa chọn sẽ xuất hiện tại đó",
  T_32_LO_WS_ITEM84W: "Điểm nhặt vũ khí",
  T_32_LO_WS_ITEM84W_DESC: "Sau khi được đặt, loại vũ khí đã chọn sẽ xuất hiện tại đó",
  T_32_LO_WS_ITEM85: "Vùng Tiêu Diệt",
  T_32_LO_WS_ITEM85_DESC: "Khi sử dụng, những người chơi bước lên sẽ chịu một trạng thái đặc biệt (Chỉ có trong chế độ tùy chỉnh)",
  T_32_LO_WS_ITEM85CP: "Checkpoint",
  T_32_LO_WS_ITEM85CP_DESC: "Các vật phẩm được đặt trong chế độ Vượt chướng ngại vật. Người chơi phải vượt qua checkpoint. Khi bị tiêu diệt, người chơi sẽ xuất phát lại ở Checkpoint cuối cùng mà họ đã vượt qua (Chỉ có trong chế độ tùy chỉnh)",
  T_32_LO_WS_ITEM85TM: "Điểm kết thúc",
  T_32_LO_WS_ITEM85TM_DESC: "Một vật phẩm trong chế độ Vượt chướng ngại vật. Người chơi phải tiến vào bên trong vật phẩm này để hoàn thành trận đấu (Chỉ có trong chế độ tùy chỉnh)",
  T_32_LO_WS_ITEM86: "Điểm xuất phát",
  T_32_LO_WS_ITEM86_DESC: "Không có đội cụ thể được chỉ định tại điểm xuất phát này. Khi xuất phát, mội đội ngẫu nhiên sẽ xuất phát ở đây. (Chỉ có trong chế độ tùy chỉnh)",
  T_32_LO_WS_ITEM86L: "Điểm xuất phát rộng",
  T_32_LO_WS_ITEM86L_DESC: "Tất cả người chơi sẽ xuất phát tại điểm xuất phát lớn của chế độ Vượt chướng ngại vật. (Chỉ có trong chế độ tùy chỉnh)",
  T_32_LO_WS_ITEM87: "Hộp",
  T_32_LO_WS_ITEM87_DESC: "Cho phép tùy chỉnh kích thước",
  T_32_LO_WS_ITEM88: "Hình hộp chữ nhật & Con dốc",
  T_32_LO_WS_ITEM88_DESC: "Hình hộp chữ nhật & Con dốc có thể tùy chỉnh kích thước",
  T_32_LO_WS_ITEMLINE: "Di chuyển",
  T_32_LO_WS_ITEMMOVE: "Cài đặt khởi động",
  T_32_LO_WS_ITEMROT: "Biến đổi",
  T_32_LO_WS_ITEMSCALE: "Thu phóng",
  T_32_LO_WS_KILLZONE: "Vùng tận thế",
  T_32_LO_WS_LOOT_AMMOTYPE: "Loại đạn",
  T_32_LO_WS_LOOT_ARTYPE: "Loại giáp",
  T_32_LO_WS_LOOT_COTYPE: "Loại vật phẩm tiếp tế",
  T_32_LO_WS_LOOT_JATYPE: "Lựu ném",
  T_32_LO_WS_LOOT_RANDOM: "Ngẫu nhiên",
  T_32_LO_WS_LOOT_TETYPE: "Loại ống ngắm",
  T_32_LO_WS_LOOT_WEAPONTYPE: "Loại vũ khí",
  T_32_LO_WS_SCALEX: "Chiều dài",
  T_32_LO_WS_SCALEY: "Chiều cao",
  T_32_LO_WS_SCALEZ: "Chiều rộng",
  T_32_LO_WS_TRIGGERH: "Ẩn",
  T_32_LO_WS_TRIGGERHORP: "Hiện/Ẩn Bộ Kích Hoạt",
  T_32_LO_WS_TRIGGERP: "Hiện",
  T_32_LO_WS_TRIGGERTYPE: "Loại kích hoạt",
  T_32_M_WS_MODE_ANNIHILATE: "Hạ gục",
  T_32_M_WS_MODE_SCORE: "Ghi điểm",
  T_32_M_WS_MODE_SPEED: "Vượt chướng ngại vật",
  T_32_M_WS_MULTIPLETEAMS: "Chiến đấu nhiều đội",
  T_32_M_WS_ROUNDS: "Vòng",
  T_32_R_EMOTE_HURRICANE_BLUE_NAME: "Bước nhảy xì tin",
  T_32_RW_WEAPON_M1887TD_NAME: "M1887-X",
  T_32_T_WS_ME_BLUECIRCLE: "Vùng nguy hiểm",
  T_32_T_WS_ME_BLUECIRCLEDAMAGE: "Sát thương",
  T_32_T_WS_ME_BLUECIRCLESETTING: "Thiết lập vùng nguy hiểm",
  T_32_T_WS_ME_CUSTOM: "Tùy chỉnh",
  T_32_T_WS_ME_ENDTYPE1: "Hạ gục",
  T_32_T_WS_ME_ENDTYPE2: "Ghi điểm",
  T_32_T_WS_ME_ENDTYPE3: "Vượt chướng ngại vật",
  T_32_T_WS_ME_ENDTYPEDESC1: "Đội sống sót cuối cùng sẽ chiến thắng",
  T_32_T_WS_ME_ENDTYPEDESC2: `Chế độ tính điểm, đội đạt đủ điểm trước sẽ thắng.
Bạn có thể thiết lập quy chế chơi và tùy chỉnh thông số chơi tùy ý, bao gồm cài đặt số điểm nhận được qua tiêu diệt.`,
  T_32_T_WS_ME_ENDTYPEDESC3: `Chế độ thử thách kỹ năng di chuyển, đội nào về hết đích trước sẽ thắng.
Bạn có thể tùy ý điều chỉnh quy chế chơi, chướng ngại vật và đích.`,
  T_32_T_WS_ME_MATCHTIME: "Thời gian trận đấu",
  T_32_T_WS_ME_MECHANIC: "Cơ chế",
  T_32_T_WS_ME_NEARCHECKPOINT: "Gần Checkpoint",
  T_32_T_WS_ME_PLAYERNUMLIMIT: "Tổng số người chơi không thể vượt quá 12",
  T_32_T_WS_ME_PREGAMETIME: "Thời gian chuẩn bị",
  T_32_T_WS_ME_RESPAWN: "Xuất phát",
  T_32_T_WS_ME_RESPAWNSETTING: "Cài đặt điểm xuất phát",
  T_32_T_WS_ME_ROUNDNUM: "Số vòng",
  T_32_T_WS_ME_ROUNDOPEN: "Kích hoạt nhiều vòng đấu",
  T_32_T_WS_ME_ROUNDRESET: "Làm mới mỗi vòng đấu",
  T_32_T_WS_ME_ROUNDSETTING: "Vòng",
  T_32_T_WS_ME_SAFEZONESHRINKTIME2: "Thời lượng vòng bo thu hẹp",
  T_32_T_WS_ME_SCORESETTING: "Điểm",
  T_32_T_WS_ME_TEAMMATENUM: "Số thành viên mỗi đội",
  T_32_T_WS_ME_TEAMNUM: "Số đội",
  T_32_T_WS_ME_TEAMSETTING: "Đội",
  T_32_U_ATTACHMENT_8: "Balo mở rộng",
  "T_32_U_GOLD_FAMAS-I": "FAMAS-I",
  "T_32_U_GOLD_FAMAS-II": "FAMAS-II",
  "T_32_U_GOLD_FAMAS-III": "FAMAS-III",
  T_32_U_GOLD_HEATGUN_I: "PLASMA-I",
  T_32_U_GOLD_HEATGUN_II: "PLASMA-II",
  T_32_U_GOLD_HEATGUN_III: "PLASMA-III",
  T_32_U_GOLD_KAR98K_I: "Kar98k-I",
  T_32_U_GOLD_KAR98K_II: "Kar98k-II",
  T_32_U_GOLD_KAR98K_III: "Kar98k-III",
  T_32_U_GOLD_M14_I: "M14-I",
  T_32_U_GOLD_M14_II: "M14-II",
  T_32_U_GOLD_M14_III: "M14-III",
  "T_32_U_GOLD_M4A1-I": "M4A1-I",
  "T_32_U_GOLD_M4A1-II": "M4A1-II",
  "T_32_U_GOLD_M4A1-III": "M4A1-III",
  T_32_U_GOLD_M60_I: "M60-I",
  T_32_U_GOLD_M60_II: "M60-II",
  T_32_U_GOLD_M60_III: "M60-III",
  T_32_U_GOLD_MP5_I: "MP5-I",
  T_32_U_GOLD_MP5_II: "MP5-II",
  T_32_U_GOLD_MP5_III: "MP5-III",
  T_32_U_GOLD_VSS_I: "VSS-I",
  T_32_U_GOLD_VSS_II: "VSS-II",
  T_32_U_GOLD_VSS_III: "VSS-III",
  T_32_U_REPLACER: "Chip nâng cấp",
  T_32_WT_WS_BARRIER: "Vật cản",
  T_32_WT_WS_BDS: "Tòa nhà",
  T_32_WT_WS_MMINVALIDERROR: "Mã bản đồ không hợp lệ",
  T_32_WT_WS_TRGS: "Bộ Kích hoạt",
  T_32_YF_CHARGESHOT_N: "Súng sạc",
  T_32_YF_GOLD_GROZA_N: "GROZA-X",
  T_32_YF_GOLD_M249_N: "M249-X",
  T_32_YF_GOLD_SVD_N: "SVD-Y",
  T_32_YS_WEAPON_TAG_18: "Tăng sát thương",
  T_32_YS_WEAPON_TAG_3: "Tốc độ",
  T_32_YS_WEAPON_TAG_36: "Xuyên giáp",
  T_32_YS_WEAPON_TAG_39: "Chế độ hai súng",
  T_32_YS_WEAPON_TAG_42: "Tường băng",
  T_33_C_SKILL_DESC_GRAFFITIST: "Tạo một khu vực [FFB300]{0}m[-], vô hiệu hóa các loại lựu ném. Đồng đội trong khu vực sẽ khôi phục [FFB300]{1}%[-] độ bền của giáp mỗi giây và sát thương đạn khi bị bắn từ kẻ thù sẽ giảm [FFB300]{2}%[-]. Kéo dài trong [FFB300]{3}s[-]. Các hiệu ứng không cộng dồn lên nhau.Thời gian hồi chiêu: [FFB300]{4}s[-].",
  T_33_C_SKILL_DESC_HITMAN: "Khi sử dụng Súng ngắm và Súng trường tầm xa, sẽ không phát ra tiếng súng nhằm tránh bị lộ vị trí (tương tự như có giảm thanh), và khiến kẻ địch khi bị hạ gục sẽ mất máu nhanh hơn  [FFB300]{0}%[-].",
  T_33_C_SKILL_DESC_KENTA: "Tạo một khiên chắn phía trước có chiều rộng [FFB300]{0}m[-] giúp giảm [FFB300]{1}%[-] sát thương của vũ khí từ phía trước. Khi người dùng bắn, sát thương giảm còn [FFB300]{2}%[-]. Tồn tại trong [FFB300]{3}s[-]. Thời gian hồi chiêu: [FFB300]{4}s[-].",
  T_33_C_SKILL_DESC_MADEMANA: "Phát ra một sóng điện từ với đường kính [FFB300]{0}m[-] vô hiệu hóa kỹ năng kẻ thù, gây [FFB300]{3} sát thương[-] và làm gián đoạn thời gian hồi chiêu của chúng. Kéo dài trong [FFB300]{1}s[-]. Thời gian hồi chiêu: [FFB300]{2}s[-].",
  T_33_C_SKILL_NAME_BODYGUARD: "Chuyên gia vũ khí",
  T_33_C_SKILL_NAME_KENTA: "Khiên thịnh nộ",
  T_33_C_SKILL_NAME_MADEMANA: "Sức nóng Chiến trường",
  T_33_DY_AXOLOTL_N: "Rồng Thiên Tài Zasil",
  T_33_DY_PETSKIN_AXOLOTL_GREY_N: "Skin trợ thủ: Dưa hấu mùa hè",
  T_33_DY_PETSKIN_DUCK_FFWS03_N: "Skin trợ thủ: Chiến binh Vịt Vàng",
  T_33_DY_PETSKIN_HAWK_FASTBREAKING22_N: "Skin trợ thủ: Falco nở hoa",
  T_33_HQ_BASEBALLBAT_APRILFOOL22_N: "Gậy bánh mì",
  T_33_HQ_EMOTE_SONGKRAN_N: "Quẩy lên",
  T_33_HQ_G18_CYBERTHIEF_N: "G18 - DJ Lục bảo",
  T_33_HQ_GRENADE_CYBERTHIEF_N: "Lựu đạn DJ Lục bảo",
  T_33_HQ_M14_SPIDERLILY_N: "M14 - Lily rực cháy",
  T_33_HQ_MAG7_FFUNIT2_N: "MAG-7 - Đặc dị bóng tối",
  T_33_HQ_MP40_FFWS03_N: "MP40 - Chiến binh hòa bình",
  T_33_HQ_SCAR_FFWS03_N: "Scar - Chiến binh hòa bình",
  T_33_HQ_SICKLE_FASTBREAKING22_N: "Lưỡi hái Lục bảo",
  T_33_HQ_THROWINGKNIFE_FFWS03_N: "Phi đao - Chiến binh",
  T_33_HQ_VECTOR_CYBERTHIEF_N: "Vector - DJ Lục bảo",
  T_33_HQ_VEHICLE_JEEP_FASTBREAKING22_N: "Jeep - Lục Bảo",
  T_33_HQ_VEHICLE_MONSTER_LION_RED_N: "Xe thính - Hỏa Ngục",
  T_33_HQ_VEHICLE_SUV_FFWS03_N: "Xe bán tải - Chiến Binh",
  T_33_LO_WS_BHPARA_A: "Chủ động",
  T_33_LO_WS_BHPARA_ATKMODE: "Loại tấn công",
  T_33_LO_WS_BHPARA_GROUP: "Đội",
  T_33_LO_WS_BHPARA_NA: "Không tấn công",
  T_33_LO_WS_BHPARA_P: "Bị động",
  T_33_LO_WS_DICE_DESC: "Một xúc xắc giúp bạn nhảy cao và được sử dụng trong nhiều lối chơi khác nhau",
  T_33_LO_WS_DICEVXZ: "Tốc độ theo trục hoành",
  T_33_LO_WS_DICEVY: "Tốc độ theo trục tung",
  T_33_LO_WS_DTOWER: "Tháp",
  T_33_LO_WS_DTOWER_DESC: "Tự động tấn công kẻ địch trong khoảng cách nhất định từ khu vực phòng thủ. Bị phá hủy nếu như máu về không. (Chỉ có trong một số chế độ đặc biệt)",
  T_33_LO_WS_FORT: "Pháo đài",
  T_33_LO_WS_FORT_DESC: "Tự động tấn công kẻ địch trong phạm vi nhất định từ khu vực quan trọng. Bị phá hủy nếu như máu về không (chỉ có trong chế độ đặc biệt)",
  T_33_LO_WS_ITEM89: "Bể lọc",
  T_33_LO_WS_ITEM89_DESC: "Bể giữ nước",
  T_33_LO_WS_ITEM90: "Chuồng chó",
  T_33_LO_WS_ITEM90_DESC: "Nhà giành cho những chú chó con",
  T_33_LO_WS_ITEM91: "Điểm dừng xe buýt",
  T_33_LO_WS_ITEM91_DESC: "Điểm dừng xe buýt thông thường",
  T_33_LO_WS_ITEM92: "Tường phun sơn",
  T_33_LO_WS_ITEM92_DESC: "Một bức tường được tô điểm bằng phun sơn",
  T_33_LO_WS_ITEM93: "Lều tranh",
  T_33_LO_WS_ITEM93_DESC: "Cấu trúc cơ bản làm từ cỏ khô",
  T_33_LO_WS_ITEM94: "Hàng ghế",
  T_33_LO_WS_ITEM94_DESC: "Hàng ghế công viên",
  T_33_LO_WS_ITEM95: "Cầu đá",
  T_33_LO_WS_ITEM95_DESC: "Một cây cầu xây bằng đá",
  T_33_LO_WS_ITEM96: "Bảng ô ngoài trời",
  T_33_LO_WS_ITEM96_DESC: "Ngăn ngừa ánh sáng mặt trời dưới ô",
  T_33_LO_WS_ITEM97: "Cổng về đích",
  T_33_LO_WS_ITEM97_DESC: "Cho biết điểm kết thúc",
  T_33_LO_WS_ITEM98: "Biển quảng cáo",
  T_33_LO_WS_ITEM98_DESC: "Một biểu ngữ quảng cáo",
  T_33_LO_WS_PARA_DM: "Sát thương",
  T_33_LO_WS_PARA_HP: "Máu",
  T_33_LO_WS_PARA_RANGE: "Phạm vi kẻ địch bị quét",
  T_33_LO_WS_PARA_SP: "Tốc độ",
  T_33_LO_WS_ZBPARA_AMOUNT: "Số zombie mỗi đợt",
  T_33_LO_WS_ZBPARA_INTERVAL: "Thời gian giữa các đợt (giây)",
  T_33_LO_WS_ZBPARA_ROUND: "Các đợt sinh ra zombie",
  T_33_LO_WS_ZBSPAWNER: "Điểm xuất phát của Zombie",
  T_33_LO_WS_ZBSPAWNER_DESC: "Zombies sẽ được tạo ra tự động. Hành vi của zombie có thể được tùy chỉnh (chỉ có trong một số chế độ đặc biệt)",
  T_33_MF_CHARACTER_BLACKSMITH_N: "Kenta",
  T_33_PD_ZOMBIE_LEVELUP: "Nâng cấp",
  T_33_RW_SKILL_DESC_GANGGIRL: "Tăng tốc độ bắn lên [FFB300]{0}%[-]. Khi người chơi bắn trúng một kẻ địch, tốc độ bắn chuyển thành tốc độ di chuyển, tối đa [FFB300]{1}%[-], và quá trình chuyển đổi sẽ đặt lại khi người chơi sống sót sau giao tranh",
  T_33_RW_SKILL_NAME_GANGGIRL: "Chiến hay Chạy",
  T_33_WT_WS_BASICSET1: "Cơ bản",
  T_33_WT_WS_QCEPRTIP: "Chuyển đổi từ EP sang Máu nhanh hơn",
  T_33_WT_WS_SKILLSET_TAG: "Kỹ năng không giới hạn",
  T_33_WT_WS_SKILLSET1: "Cài đặt kỹ năng",
  T_33_WT_WS_SKILLSET10: "Hào Quang Hộ Mệnh (Chrono)",
  T_33_WT_WS_SKILLSET11: "Hủy diệt băng thành (Skyler)",
  T_33_WT_WS_SKILLSET12: "Cuồng bạo (Xayne)",
  T_33_WT_WS_SKILLSET13: "Nhịp điệu hồi sinh (Dimitri)",
  T_33_WT_WS_SKILLSET2: "Kỹ năng bị động",
  T_33_WT_WS_SKILLSET2_TIP: "Bật/Tắt kỹ năng bị động",
  T_33_WT_WS_SKILLSET3: "Kỹ năng chủ động (bật để điều chỉnh thời gian hồi chiêu bên dưới)",
  T_33_WT_WS_SKILLSET3_TIP: "Bật/Tắt kỹ năng chủ động. Nếu bật, thời gian hồi chiêu của các kỹ năng chủ động khác nhau có thể được điều chỉnh như bên dưới",
  T_33_WT_WS_SKILLSET4: "Ảo ảnh (Tôn Ngộ Không)",
  T_33_WT_WS_SKILLSET5: "Sức nóng Chiến trường (A124)",
  T_33_WT_WS_SKILLSET6: "Giai điệu sinh mệnh (Alok)",
  T_33_WT_WS_SKILLSET7: "Không gian Sắc màu (Steffie)",
  T_33_WT_WS_SKILLSET8: "Truy Vết (Clu)",
  T_33_WT_WS_SKILLSET9: "Bậc thầy (K)",
  T_33_WT_WS_UNIT_HPSECOND: "Máu/giây",
  T_33_WT_WS_UNIT_METER: "mét",
  T_33_WT_WS_UNIT_SECOND: "giây",
  T_33_YF_G36_N: "G36",
  T_33_YS_B_RAINCOAT: "Quần Bò rách gối",
  T_33_YS_H_ONIGIRI: "Mũ bông cơm nắm",
  T_33_YS_H_RAINCOAT: "Mũ đi mưa vịt vàng",
  T_33_YS_HA_CRYINGFACE: "Mặt nạ Khóc lóc",
  T_33_YS_M_H_FROGKING: "Mũ Hoàng tử ếch",
  T_33_YS_S_RAINCOAT: "Giày đi mưa vịt vàng",
  T_33_YS_T_BLACKHOLE: "Hoodie Ảo ảnh thị giác",
  T_33_YS_T_RAINCOAT: "Áo mưa vịt vàng",
  T_33_YS_T_SOCCER_GREEN: "Áo Đội quân Âu Lạc",
  T_33_YS_T_SOCCER_YELLOW: "Áo Chiến binh sao vàng",
  T_33_YS_T_WIFI: "Áo phông thất tình",
  T_34_C_SKILL_DESC_STREAMERGUY: "Mỗi khi tiêu diệt địch hoặc được đồng đội đã bị hạ theo dõi sẽ nhận một cộng dồn. Mỗi cộng dồn giảm sát thương headshot nhận vào [FFB300]{0}%[-] (tối đa [FFB300]{1}%[-]) và sát thương headshot lên kẻ địch tăng [FFB300]{2}%[-] (tối đa [FFB300]{3}%[-])",
  T_34_C_SKILL_DESC_TRACKER: "Phóng ra một drone tự truy tìm kẻ địch trong khoảng cách [FFB300]100m[-], tạo ra một [FFB300]vụ nổ đường kính {5}m[-] làm giảm [FFB300]{0}%[-] tốc độ di chuyển và [FFB300]{1}%[-] tốc độ bắn. Tồn tại trong [FFB300]{3}s[-]. Gây ra [FFB300]{2} sát thương[-]. Hồi chiêu: [FFB300]{4}s[-].",
  T_34_C_SKILL_NAME_TRACKER: "Bom tầm xa",
  T_34_DY_PETSKIN_SURFSHARK_ENERGY_N: "Pet Skin: Cá mập rực cháy",
  T_34_DY_PETSKIN_SURFSHARK_SEA_N: "Pet Skin: Cá mập Sâu Thẳm",
  T_34_DY_PETSKIN_SURFSHARK_STORM_N: "Pet Skin: Cá mập sấm chớp",
  T_34_DY_PETSKIN_TIGER_BIS_N: "Pet Skin: Hổ Công Nghệ",
  T_34_DY_SURFSHARK_N: "Cá Mập Finn",
  T_34_HQ_EMOTE_BIS_COMMAND_N: "Nhạc Trưởng",
  T_34_HQ_EMOTE_RAMPAGE4_BLUE_N: "Vào Nhịp",
  T_34_HQ_EMOTE_RIDICULE_N: "Ngon thì nhào zô!",
  T_34_HQ_VEHICLE_SUV_CRAZYSCIENTIST_N: "Xe bán tải - Kỹ Sư Quỷ Quyệt",
  T_34_HQ_VEHICLE_TUTU_WINTERDOG_N: "Tuk Tuk - Husky Nhí Nhảnh",
  T_34_JL_EAGLE_RAMPAGE4_N: "Desert Eagle - Hỏa Bộc",
  T_34_JL_G36_MADBIONIC_N: "G36 - Chiến binh giả tưởng",
  T_34_JL_GRENADE_BIS_N: "Lựu đạn Chiến binh pixel",
  T_34_JL_MACHETE_RAMPAGE4_N: "Đao Hắc Vân",
  T_34_JL_THROWINGKNIFE_BANANA_N: "Phi đao - Quả chuối",
  T_34_JL_UMP45_BIS_N: "UMP - Kỷ nguyên công nghệ",
  T_34_LY_WS_ABS_DESC: "Lấy giá trị tuyệt đối của số này",
  T_34_LY_WS_ADD_DESC: "Thêm một thành phần mới vào cuối một danh sách",
  T_34_LY_WS_AUTO_A: "Tự động quét kẻ địch",
  T_34_LY_WS_BOT: "Zombie thường",
  T_34_LY_WS_BOT_PATH: "Đường",
  T_34_LY_WS_BOT_TYPE: "Loại",
  T_34_LY_WS_BOT4: "Zombie cầm rìu",
  T_34_LY_WS_BOT5: "Zombie ném",
  T_34_LY_WS_BOT6: "Zombie tự nổ",
  T_34_LY_WS_BOT8: "Che chắn",
  T_34_LY_WS_COL_DESC: "Chọn 1 màu",
  T_34_LY_WS_DEL_DESC: "Xóa thành phần tương ứng của một mục được chỉ định trong một danh sách",
  T_34_LY_WS_DF_PER: "Phòng thủ %",
  T_34_LY_WS_FORT_INTERVAL: "Thời gian giữa các lần tấn công (giây)",
  T_34_LY_WS_GET: "Lấy",
  T_34_LY_WS_GET_DESC: "Lấy thành phần tương ứng của một mục được chỉ định trong một danh sách",
  T_34_LY_WS_GLEN_ARR_DESC: "Lấy số thành phần trong danh sách hiện tại",
  T_34_LY_WS_GLEN_DESC: "Lấy độ dài của chuỗi văn bản này",
  T_34_LY_WS_GVX: "Lấy thành phần x của vectơ",
  T_34_LY_WS_GVX_DESC: "Lấy vectơ thành phần trước",
  T_34_LY_WS_GVY: "Lấy thành phần y của vectơ",
  T_34_LY_WS_GVY_DESC: "Lấy thành phần thứ hai của một vectơ",
  T_34_LY_WS_GVZ: "Lấy thành phần z của vectơ",
  T_34_LY_WS_GVZ_DESC: "Lấy thành phần thứ ba của một vectơ",
  T_34_LY_WS_INDEX: "Chỉ mục",
  T_34_LY_WS_JOIN: "Kết nối",
  T_34_LY_WS_NEG_DESC: "Lấy giá trị âm của số này",
  T_34_LY_WS_PATH: "Thiết lập đường",
  T_34_LY_WS_PATH_DESC: "Sử dụng để chỉ định lộ trình di chuyển của các sinh vật đặc biệt (chỉ có trong chế độ đặc biệt)",
  T_34_LY_WS_POINT: "Bộ đánh dấu",
  T_34_LY_WS_POINT_DESC: "Sử dụng để đánh dấu vị trí hiện tại (chỉ có trong chế độ đặc biệt)",
  T_34_LY_WS_RANGE_F: "Tầm xa",
  T_34_LY_WS_RANGE_M: "Tầm trung",
  T_34_LY_WS_RANGE_N: "Tầm gần",
  T_34_LY_WS_RNDF_DESC: "Tạo một số thập phân ngẫu nhiên từ một khoảng thời gian",
  T_34_LY_WS_RNDI_DESC: "Tạo một số nguyên ngẫu nhiên từ một khoảng thời gian",
  T_34_LY_WS_SET: "Thiết Lập",
  T_34_LY_WS_SET_DESC: "Đặt phần tử tương ứng của một mục được chỉ định trong một danh sách",
  T_34_LY_WS_SQRT_DESC: "Lấy căn bậc hai của số này",
  T_34_LY_WS_STRC_DESC: "Kết nối hai chuỗi văn bản",
  T_34_LY_WS_SVX: "Đặt thành phần vectơ x",
  T_34_LY_WS_SVX_DESC: "Đặt thành phần vectơ thứ 1",
  T_34_LY_WS_SVY: "Đặt thành phần vectơ  y",
  T_34_LY_WS_SVY_DESC: "Đặt thành phần vectơ thứ 2",
  T_34_LY_WS_SVZ: "Đặt thành phần vectơ  z",
  T_34_LY_WS_SVZ_DESC: "Đặt thành phần vectơ thứ 3",
  T_34_LY_WS_VADD: "Cộng Vectơ",
  T_34_LY_WS_VADD_DESC: "Thêm hai vectơ",
  T_34_LY_WS_VAL_DESC: "Nhập một số nguyên hoặc số thập phân theo tình huống",
  T_34_LY_WS_VANG_DESC: "Tính góc giữa hai vectơ",
  T_34_LY_WS_VCP: "Tích Vectơ",
  T_34_LY_WS_VCP_DESC: "Tính tích chéo của hai vectơ",
  T_34_LY_WS_VDIS_DESC: "Tính khoảng cách giữa hai vectơ",
  T_34_LY_WS_VDP: "Tích vô hướng",
  T_34_LY_WS_VDP_DESC: "Tính tích vô hướng của hai Vec-tơ",
  T_34_LY_WS_VFX1: "Hình cầu",
  T_34_LY_WS_VFX2: "Hình trụ",
  T_34_LY_WS_VFX3: "Reo",
  T_34_LY_WS_VFX4: "Bom",
  T_34_LY_WS_VFX5: "Pixel",
  T_34_LY_WS_VFX6: "Tia lửa",
  T_34_LY_WS_VMOD_DESC: "Tính độ lớn của vectơ",
  T_34_LY_WS_VMUL: "Nhân Vectơ",
  T_34_LY_WS_VMUL_DESC: "Nhân hai vectơ",
  T_34_LY_WS_VNOR_DESC: "Chuẩn hóa một vectơ",
  T_34_LY_WS_VSUB: "Trừ Vectơ",
  T_34_LY_WS_VSUB_DESC: "Trừ hai vectơ",
  T_34_M_WS_ANGLE: "Xoay",
  T_34_M_WS_ARRAY: "Danh sách",
  T_34_M_WS_ATT: "Thuộc tính",
  T_34_M_WS_BOOL: "Boolean",
  T_34_M_WS_COLORARRAY: "Mảng màu",
  T_34_M_WS_COLOUR: "Màu",
  T_34_M_WS_CONFRONBANNER: "Ảnh bìa chiến đấu",
  T_34_M_WS_COORDINATE: "Tọa độ",
  T_34_M_WS_CUSTOMINF: "Giao diện HUD tùy chỉnh",
  T_34_M_WS_CUSTOMMODEDESC: `Chế độ trống cho phép bạn thiết kế trò chơi từ con số 0.
Có thể hơi ngợp với các bạn mới bắt đầu tạo bản đồ.`,
  T_34_M_WS_DAMAGETYPE: "Loại sát thương",
  T_34_M_WS_DAMAGETYPEDESC: "Loại sát thượng hiện do hệ thống thiết lập",
  T_34_M_WS_DESCTEXT: "Văn bản mô tả",
  T_34_M_WS_DURACTION: "Thời gian",
  T_34_M_WS_ECAMODE: "Chế độ tùy chỉnh",
  T_34_M_WS_ENDPHASEDESC: "Giai đoạn hiện tại kết thúc ngay và tiến đến giai đoạn tiếp theo",
  T_34_M_WS_ENTITY: "Đơn vị mẫu",
  T_34_M_WS_FLOAT: "Số thập phân",
  T_34_M_WS_GAME: "Game",
  T_34_M_WS_GAMERESULTS: "Kết quả trận đấu",
  T_34_M_WS_GETCONTROL2: "Nhận một vật phẩm điều khiển từ giao diện người chơi để chỉnh sửa thuộc tính vật phẩm (Bao gồm thiết kế, màu sắc, nội dung, v.v..)",
  T_34_M_WS_HEIGHT: "Chiều cao",
  T_34_M_WS_HUDBUTTONWIDGET: "Điều chỉnh nút",
  T_34_M_WS_HUDEMPTYWIDGET: "Điều chỉnh không có sẵn",
  T_34_M_WS_HUDIMAGEWIDGET: "Điều chỉnh hình ảnh",
  T_34_M_WS_HUDINPUTWIDGET: "Điều chỉnh hộp văn bản",
  T_34_M_WS_HUDLABELWIDGET: "Điều chỉnh văn bản",
  T_34_M_WS_ICON: "Biểu tượng",
  T_34_M_WS_ICON_AIM: "Ngắm",
  T_34_M_WS_ICON_ARROW: "Mũi tên",
  T_34_M_WS_ICON_BLAST: "Vụ nổ",
  T_34_M_WS_ICON_CIRCULAR: "Hình tròn",
  T_34_M_WS_ICON_CLOTH: "Cây cọ",
  T_34_M_WS_ICON_COLLIMATION: "Tâm súng",
  T_34_M_WS_ICON_CORPSE: "Zombie",
  T_34_M_WS_ICON_CROSS: "Gạch chéo",
  T_34_M_WS_ICON_DAY: "Mặt trời",
  T_34_M_WS_ICON_DEFENSE: "Khiên",
  T_34_M_WS_ICON_DIALOGUE: "Hội thoại",
  T_34_M_WS_ICON_DIAMONDS: "Kim cương",
  T_34_M_WS_ICON_EXCLAMATIONMARK: "Dấu chấm than",
  T_34_M_WS_ICON_FLAG: "Cờ",
  T_34_M_WS_ICON_FOLDER: "Tệp",
  T_34_M_WS_ICON_GLASSES: "Mắt",
  T_34_M_WS_ICON_GUN: "Súng",
  T_34_M_WS_ICON_HEART: "Trái tim",
  T_34_M_WS_ICON_HEXAGON: "Lục giác",
  T_34_M_WS_ICON_HOURGLASS: "Đồng hồ cát",
  T_34_M_WS_ICON_HOUSE: "Nhà",
  T_34_M_WS_ICON_KEY: "Khóa",
  T_34_M_WS_ICON_LIGHTNING: "Sét",
  T_34_M_WS_ICON_LOCK: "Khóa",
  T_34_M_WS_ICON_LOOP: "Vòng lặp",
  T_34_M_WS_ICON_MAGNIFIER: "Kính lúp",
  T_34_M_WS_ICON_MONEY: "Tiền",
  T_34_M_WS_ICON_MONTH: "Mặt trăng",
  T_34_M_WS_ICON_OPENFOLDER: "Mở tệp",
  T_34_M_WS_ICON_PLUS: "Cộng",
  T_34_M_WS_ICON_QUADRI: "Tứ giác",
  T_34_M_WS_ICON_QUESTIONMARK: "Dấu chấm hỏi",
  T_34_M_WS_ICON_RECYCLING: "Tái sử dụng",
  T_34_M_WS_ICON_REFRESH: "Làm mới",
  T_34_M_WS_ICON_REST: "Nghỉ ngơi",
  T_34_M_WS_ICON_RETURN: "Quay lại",
  T_34_M_WS_ICON_RIGHTTRAPEZOID: "Hình thang",
  T_34_M_WS_ICON_SCISSORS: "Biểu tượng Kéo",
  T_34_M_WS_ICON_SETUP: "Cài đặt",
  T_34_M_WS_ICON_SIGN: "Đánh dấu",
  T_34_M_WS_ICON_SIGNOUT: "Thoát",
  T_34_M_WS_ICON_SQUARE: "Hình vuông",
  T_34_M_WS_ICON_STAR: "Ngôi sao",
  T_34_M_WS_ICON_STONE: "Đá",
  T_34_M_WS_ICON_SWIMMINGCIRCLE: "Phao bơi",
  T_34_M_WS_ICON_TAGGING: "Ghim",
  T_34_M_WS_ICON_THESWORD: "Kiếm",
  T_34_M_WS_ICON_TRAPEZOID: "Hình thang",
  T_34_M_WS_ICON_TRASHCAN: "Thùng rác",
  T_34_M_WS_ICON_TRIANGLE: "Tam giác",
  T_34_M_WS_ICON_TROPHY: "Chiếc cúp",
  T_34_M_WS_ICON_UP: "Đồng ý",
  T_34_M_WS_ICON_WRONG: "Sai",
  T_34_M_WS_ICON_YES: "Đúng",
  T_34_M_WS_ICONNAME: "Biểu tượng tên",
  T_34_M_WS_INT: "Số nguyên",
  T_34_M_WS_KILLZONE: "Vùng hạ gục",
  T_34_M_WS_LEFTCOLOR: "Màu bên trái",
  T_34_M_WS_LEFTTEAMINDEX: "Chỉ số đội bên trái",
  T_34_M_WS_LEFTTEAMSCORE: "Điểm đội bên trái",
  T_34_M_WS_LOCSWITCH: "Chuyển đổi bản địa hóa",
  T_34_M_WS_MAX: "Lớn nhất",
  T_34_M_WS_MIN: "Nhỏ nhất",
  T_34_M_WS_NUMBER: "Số",
  T_34_M_WS_OBJECT: "Đơn vị mẫu",
  T_34_M_WS_OPEN: "Mở",
  T_34_M_WS_OPENSATUS: "Bật trạng thái",
  T_34_M_WS_PICTURE: "Đồ họa",
  T_34_M_WS_RANKARRAY: "Xếp hạng mảng",
  T_34_M_WS_RESULTS: "Kết quả",
  T_34_M_WS_RIGHTCOLOR: "Màu bên phải",
  T_34_M_WS_RIGHTTEAMINDEX: "Chỉ số đội bên phải",
  T_34_M_WS_RIGHTTEAMSCORE: "Điểm đội bên phải",
  T_34_M_WS_ROUNDBANNER: "Ảnh vòng đấu",
  T_34_M_WS_ROUNDDESC: "Mô tả vòng đấu",
  T_34_M_WS_ROUNDHUD: "Số vòng đấu",
  T_34_M_WS_ROUNDPARAMS: "Mảng số vòng đấu",
  T_34_M_WS_SAME_NAME: "Tên bị lặp. Vui lòng thử tên mới",
  T_34_M_WS_SCOREARRAY: "Mảng điểm",
  T_34_M_WS_SCORINGTYPE: "Loại điểm",
  T_34_M_WS_SCORINGTYPEDECS: "Loại điểm số mà người chơi có thể nhận được. Hỗ trợ tùy chỉnh điểm số.",
  T_34_M_WS_SCUFFLESCORING: "Điểm nhiều đội",
  T_34_M_WS_SETATTRIBUTES: "Cài đặt thuộc tính",
  T_34_M_WS_SHUT: "Tắt",
  T_34_M_WS_SOUND: "Hiệu ứng âm thanh",
  T_34_M_WS_SOUNDCLICK: "Clicking",
  T_34_M_WS_SOUNDDD: "Đếm ngược",
  T_34_M_WS_SOUNDFEMALEA: "Bị thương (nữ)",
  T_34_M_WS_SOUNDM: "Tiếng bắn",
  T_34_M_WS_SOUNDMALEA: "Bị thương (nam)",
  T_34_M_WS_SOUNDUAV: "Vụ nổ",
  T_34_M_WS_ST_ASSISTCOUNT: "Hỗ trợ",
  T_34_M_WS_ST_CHECKPROGRESS: "Tiến trình Checkpoint",
  T_34_M_WS_ST_DAMAGESUM: "Sát thương",
  T_34_M_WS_ST_FINISHCOUNT: "Số lượng mục tiêu đã đạt được",
  T_34_M_WS_ST_FINISHORDER: "Thứ tự mục tiêu đạt được",
  T_34_M_WS_ST_FINISHTIME: "Thời gian mục tiêu đạt được",
  T_34_M_WS_ST_KILLCOUNT: "Mạng tiêu diệt",
  T_34_M_WS_ST_MAINSCORE: "Điểm mục tiêu",
  T_34_M_WS_ST_RANKSCORE: "Điểm xếp hạng",
  T_34_M_WS_ST_SURVIVALDURACTION: "Thời gian sống sót",
  T_34_M_WS_ST_UNKOWN: "Không xác định",
  T_34_M_WS_STARTBANNER: "Ảnh bắt đầu",
  T_34_M_WS_STARTTIME: "Thời gian bắt đầu",
  T_34_M_WS_STRING: "Chuỗi ký tự",
  T_34_M_WS_STUDIO: "TẠO MAP",
  T_34_M_WS_TEAMARRAY: "Mảng đội",
  T_34_M_WS_TEXTCONTENT: "Nội dung",
  T_34_M_WS_THEMECOLOR: "Màu chủ đạo",
  T_34_M_WS_TIME: "HUD Đếm ngược",
  T_34_M_WS_TITLETEXT: "Tiêu đề văn bản",
  T_34_M_WS_TYPE: "Loại",
  T_34_M_WS_UODATETYPE: "Loại cập nhật",
  T_34_M_WS_VARNAME: "Tên biến",
  T_34_M_WS_VECTOR: "Vectơ",
  T_34_M_WS_VFX: "Hiệu ứng hình ảnh",
  T_34_M_WS_WIDTH: "Chiều rộng",
  T_34_MF_CHARACTER_TRACKER_N: "Homer",
  T_34_PD_FlagBattle_HYPE_1: "Lửa",
  T_34_SP_WS_BLOCK1_NAME: "Chuyển trạng thái",
  T_34_SP_WS_BLOCK1_NAMEDESC: "Chuyển giai đoạn của trận đấu để chuyển sang giai đoạn (hoặc vòng đấu) mong muốn. Các vòng đấu cũng có chỉ số giai đoạn và là một loại giai đoạn đặc biệt.",
  T_34_SP_WS_BLOCK1_PARAM1_NAMEDESC: "Chỉ số của giai đoạn mục tiêu",
  T_34_SP_WS_BLOCK10_NAME: "Tạo hiệu ứng hình ảnh",
  T_34_SP_WS_BLOCK10_NAMEDESC: "Tạo một biểu tượng bằng cách sử dụng các hiệu ứng hình ảnh chỉ định. Các thuộc tính khác của hiệu ứng hình ảnh có thể được cấu hình bằng cách điều chỉnh các thuộc tính của đơn vị hiệu ứng hình ảnh.",
  T_34_SP_WS_BLOCK10_PARAM3_NAME: "Hiệu ứng hình ảnh",
  T_34_SP_WS_BLOCK10_PARAM3_NAMEDESC: "Các dạng hiệu ứng hình ảnh có thể được áp dụng",
  T_34_SP_WS_BLOCK12_NAME: "Xóa hiệu ứng hình ảnh",
  T_34_SP_WS_BLOCK12_NAMEDESC: "Xóa hiệu ứng hình ảnh được chỉ định",
  T_34_SP_WS_BLOCK12_PARAM1_NAME: "Đơn vị hiệu ứng hình ảnh",
  T_34_SP_WS_BLOCK12_PARAM1_NAMEDESC: "Đơn vị hiệu ứng hình ảnh bị xóa",
  T_34_SP_WS_BLOCK13_NAMEDESC: "Yêu cầu ứng dụng dùng hiệu ứng hình ảnh",
  T_34_SP_WS_BLOCK13_PARAM1_NAME: "Danh sách người chơi",
  T_34_SP_WS_BLOCK13_PARAM1_NAMEDESC: "Những người chơi sẽ nhận được tin nhắn",
  T_34_SP_WS_BLOCK13_PARAM2_NAME: "Đường dẫn tài nguyên",
  T_34_SP_WS_BLOCK13_PARAM2_NAMEDESC: "Đường dẫn tài nguyên hệ thống nằm trong:đường dẫn. Đường dẫn tài nguyên tùy chỉnh nằm ngoài: đường dẫn. Mặc định là trống",
  T_34_SP_WS_BLOCK13_PARAM3_NAMEDESC: "Kênh RGBA, với mỗi kênh nhận giá trị từ 0 đến 255 được lưu trong int32. Màu mặc định là màu trắng (255,255,255,255).",
  T_34_SP_WS_BLOCK13_PARAM4_NAME: "Phóng to",
  T_34_SP_WS_BLOCK13_PARAM4_NAMEDESC: "Tỉ lệ phóng to mặc định là 1",
  T_34_SP_WS_BLOCK13_PARAM5_NAMEDESC: "Vị trí hiển thị được biểu thị bằng tọa độ toàn cục. Vector3 (0) theo mặc định.",
  T_34_SP_WS_BLOCK14_NAME: "Bật hiệu ứng âm thanh",
  T_34_SP_WS_BLOCK14_NAMEDESC: "Ra lệnh cho hệ thống bật hiệu ứng âm thanh",
  T_34_SP_WS_BLOCK15_NAME: "Nhật ký đầu ra",
  T_34_SP_WS_BLOCK15_NAMEDESC: "Xuất nội dung lên giao diện nhật ký",
  T_34_SP_WS_BLOCK2_NAMEDESC: "Bật chế độ gây sát thương cho người chơi ngoài bo",
  T_34_SP_WS_BLOCK2_PARAM1_NAMEDESC: "Điểm trung tâm của Vùng an toàn",
  T_34_SP_WS_BLOCK2_PARAM2_NAME: "Bán kính",
  T_34_SP_WS_BLOCK2_PARAM2_NAMEDESC: "Bán kính vòng bo",
  T_34_SP_WS_BLOCK2_PARAM3_NAMEDESC: "Thời gian đếm ngược trước khi bo thu",
  T_34_SP_WS_BLOCK2_PARAM4_NAMEDESC: "Thời lượng bo thu",
  T_34_SP_WS_BLOCK2_PARAM5_NAMEDESC: "Sát thương nhận khi ở ngoài bo",
  T_34_SP_WS_BLOCK3_NAMEDESC: "Khi tắt vùng nguy hiểm, người chơi ngoài bo sẽ không nhận sát thương",
  T_34_SP_WS_BLOCK4_NAMEDESC: "Sử dụng để trì hoãn một hành động tiếp theo trong một thời gian được chỉ định",
  T_34_SP_WS_BLOCK4_PARAM1_NAMEDESC: "Thời gian chờ đợi, được tính bằng mili giây",
  T_34_SP_WS_BLOCK5_NAMEDESC: "Sử dụng để ngừng một hành động tiếp theo đến khung tiếp theo",
  T_34_SP_WS_BLOCK6_NAME: "Tạo giao diện tùy chỉnh",
  T_34_SP_WS_BLOCK6_NAMEDESC: "Tạo giao diện tùy chỉnh có sẵn",
  T_34_SP_WS_BLOCK6_PARAM1_NAMEDESC: "Tên được sử dụng để tạo giao diện người chơi. Biến cục bộ mà nó tương ứng là hoạt ảnh đang được tạo.",
  T_34_SP_WS_BLOCK6_PARAM2_NAME: "Người chơi",
  T_34_SP_WS_BLOCK6_PARAM2_NAMEDESC: "Đơn vị mẫu của một người chơi cụ thể. Chỉ hiển thị cho người chơi được nói đến.",
  T_34_SP_WS_BLOCK6_PARAM3_NAMEDESC: "Thông số đặc biệt của giao diện",
  T_34_SP_WS_BLOCK7_NAMEDESC: "Tạo một giao diện mặc định, chỉ hiện thị cho những người chơi được chỉ định",
  T_34_SP_WS_BLOCK8_NAMEDESC: "Khi bị xóa, giao diện mặc định sẽ không được nhìn thấy trên ứng dụng khách (bị ẩn hoặc bị loại bỏ)",
  T_34_SP_WS_BLOCK8_PARAM1_NAME: "Đơn vị giao diện HUD",
  T_34_SP_WS_BLOCK8_PARAM1_NAMEDESC: "Giao diện bị xóa",
  T_34_SP_WS_BLOCK9_NAMEDESC: "Khi bị xóa, giao diện tùy chỉnh sẽ được xem trên ứng dụng khách (bị ẩn hoặc bị loại bỏ)",
  T_34_T_WS_BLOCK1_NAMEDESC: "Sự kiện xảy ra khi trận đấu bắt đầu",
  T_34_T_WS_BLOCK10_NAMEDESC: "Sự kiện kích hoạt khi một người chơi bị tiêu diệt",
  T_34_T_WS_BLOCK10_PARAM1_DESC: "Người chơi bị tiêu diệt sẽ kích hoạt sự kiện",
  T_34_T_WS_BLOCK13_NAMEDESC: "Sự kiện xảy ra khi người chơi hỗ trợ người khác",
  T_34_T_WS_BLOCK13_PARAM2_DESC: "Người chơi bị tiêu diệt",
  T_34_T_WS_BLOCK14_NAMEDESC: "Sự kiện xảy ra khi người chơi gây sát thương",
  T_34_T_WS_BLOCK14_PARAM2_DESC: "Người chơi nhận sát thương",
  T_34_T_WS_BLOCK14_PARAM3_DESC: "Loại sát thương gây ra",
  T_34_T_WS_BLOCK14_PARAM4_DESC: "Lượng sát thương gây ra",
  T_34_T_WS_BLOCK15_NAMEDESC: "Sự kiện kích hoạt khi người chơi tiêu diệt người chơi khác",
  T_34_T_WS_BLOCK15_PARAM2_DESC: "Người chơi bị tiêu diệt",
  T_34_T_WS_BLOCK15_PARAM3_DESC: "Loại sát thương tiêu diệt",
  T_34_T_WS_BLOCK16_NAMEDESC: "Sự kiện kích hoạt khi người chơi tham gia trận đấu",
  T_34_T_WS_BLOCK17_NAMEDESC: "Sự kiện kích hoạt khi người chơi được hồi sinh",
  T_34_T_WS_BLOCK18_NAMEDESC: "Sự kiện xảy ra khi một đội bị loại",
  T_34_T_WS_BLOCK19_NAMEDESC: "Sự kiện kích hoạt khi một đội được thêm",
  T_34_T_WS_BLOCK2_NAMEDESC: "Sự kiện kích hoạt khi trận đấu kết thúc",
  T_34_T_WS_BLOCK20_NAMEDESC: "Sự kiện kích hoạt khi một đội bị quét sạch",
  T_34_T_WS_BLOCK3_NAMEDESC: "Sự kiện kích hoạt khi mỗi vòng bắt đầu",
  T_34_T_WS_BLOCK3_PARAM1_DESC: "Số vòng bắt đầu từ 0",
  T_34_T_WS_BLOCK3_PARAM1_NAME: "Chỉ số vòng đấu",
  T_34_T_WS_BLOCK4_NAMEDESC: "Sự kiện kích hoạt khi mỗi vòng kết thúc",
  T_34_T_WS_BLOCK5_NAMEDESC: "Sự kiện xảy ra khi trạng thái bắt đầu",
  T_34_T_WS_BLOCK5_PARAM1_DESC: "Số giai đoạn bắt đầu từ 0",
  T_34_T_WS_BLOCK5_PARAM1_NAME: "Định danh trạng thái",
  T_34_T_WS_BLOCK6_NAMEDESC: "Sự kiện kích hoạt khi giai đoạn kết thúc",
  T_34_T_WS_BLOCK7_NAMEDESC: "Sự kiện kích hoạt khi một người chơi thoát khỏi trận đấu",
  T_34_T_WS_BLOCK7_PARAM1_DESC: "Người chơi này sẽ kích hoạt sự kiện",
  T_34_T_WS_BLOCK7_PARAM1_NAME: "Kích hoạt người chơi",
  T_34_T_WS_BLOCK8_NAMEDESC: "Sự kiện xảy ra khi điểm của người chơi thay đổi",
  T_34_T_WS_BLOCK8_PARAM2_DESC: "Loại điểm đã thay đổi",
  T_34_T_WS_BLOCK8_PARAM3_DESC: "Giá trị điểm sau khi thay đổi",
  T_34_T_WS_BLOCK9_NAMEDESC: "Sự kiện kích hoạt khi điểm đổi thay đổi",
  T_34_T_WS_BLOCK9_PARAM1_DESC: "Đội sẽ kích hoạt sự kiện",
  T_34_WT_WS_BORNENTITY_PARAM1: "Điểm xuất phát",
  T_34_WT_WS_BORNENTITY_PARAM2: "Tọa độ có sẵn",
  T_34_WT_WS_BORNENTITY_PARAM3: "Đặt như điểm xuất phát mặc định",
  T_34_WT_WS_BORNENTITY_PARAM4: "Ranh giới phát sáng",
  T_34_WT_WS_BORNENTITY_PARAM5: "Đang dùng hoặc không",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM1: "Checkpoint HUD",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM2: "Trạng thái mở",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM1: "Kích hoạt trạng thái",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM2: "Kích hoạt tiêu diệt hoặc không",
  T_34_WT_WS_ENTITY_PARAM1: "Đơn vị game",
  T_34_WT_WS_ENTITY_PARAM10: "Số đội",
  T_34_WT_WS_ENTITY_PARAM11: "Số lượng thành viên đội",
  T_34_WT_WS_ENTITY_PARAM12: "Trang bị làm mới mỗi vòng đấu",
  T_34_WT_WS_ENTITY_PARAM13: "Bật sát thương ngoài bo",
  T_34_WT_WS_ENTITY_PARAM14: "Kích thước bo",
  T_34_WT_WS_ENTITY_PARAM15: "Thời gian bắt đầu thu hẹp bo",
  T_34_WT_WS_ENTITY_PARAM16: "Thời gian vòng bo thu",
  T_34_WT_WS_ENTITY_PARAM17: "Sát thương ngoài bo",
  T_34_WT_WS_ENTITY_PARAM18: "Điểm mục tiêu",
  T_34_WT_WS_ENTITY_PARAM19: "Điểm tiêu diệt",
  T_34_WT_WS_ENTITY_PARAM2: "Tình trạng không hợp lệ",
  T_34_WT_WS_ENTITY_PARAM20: "Loại hồi sinh",
  T_34_WT_WS_ENTITY_PARAM21: "Tiêu chí xếp hạng điểm của vòng đấu (người chơi)",
  T_34_WT_WS_ENTITY_PARAM22: "Tiêu chí quan trọng (người chơi)",
  T_34_WT_WS_ENTITY_PARAM23: "Tiêu chí xếp hạng điểm của vòng đấu (đội)",
  T_34_WT_WS_ENTITY_PARAM24: "Tiêu chí quan trọng (đội)",
  T_34_WT_WS_ENTITY_PARAM25: "Tiêu chí xếp hạng điểm (MVP)",
  T_34_WT_WS_ENTITY_PARAM26: "Tiêu chí quan trọng (MVP)",
  T_34_WT_WS_ENTITY_PARAM27: "Điểm xếp hạng vòng đấu",
  T_34_WT_WS_ENTITY_PARAM28: "Hiển thị tiêu chí trên trang kết quả",
  T_34_WT_WS_ENTITY_PARAM29: "Tổng số vòng đấu",
  T_34_WT_WS_ENTITY_PARAM3: "Thời gian game",
  T_34_WT_WS_ENTITY_PARAM4: "Chỉ số vòng đấu hiện tại",
  T_34_WT_WS_ENTITY_PARAM5: "Chỉ số giai đoạn hiện tại",
  T_34_WT_WS_ENTITY_PARAM6: "ID chế độ mẫu",
  T_34_WT_WS_ENTITY_PARAM7: "Bật hồi sinh người chơi",
  T_34_WT_WS_ENTITY_PARAM8: "Bật hồi sinh bot",
  T_34_WT_WS_ENTITY_PARAM9: "Thời gian hồi sinh",
  T_34_WT_WS_ENTITY1_NAME: "Đơn vị hiện tại",
  T_34_WT_WS_ENTITY1_NAMEDESC: "Trả lại đơn vị mẫu hiện tại",
  T_34_WT_WS_ENTITY10_NAME: "Xóa biểu tượng",
  T_34_WT_WS_ENTITY10_NAMEDESC: "Xóa bỏ biểu tượng được chỉ định",
  T_34_WT_WS_ENTITY10_PARAM1DESC: "Lựa chọn biểu tượng bạn muốn xóa",
  T_34_WT_WS_ENTITY11_NAME: "Xóa văn bản",
  T_34_WT_WS_ENTITY11_NAMEDESC: "Xóa bỏ một đoạn văn bản",
  T_34_WT_WS_ENTITY11_PARAM2ESC: "Lựa chọn văn bản bạn muốn xóa",
  T_34_WT_WS_ENTITY12_NAMEDESC: "Thêm một vật phẩm cho một người chơi được chỉ định",
  T_34_WT_WS_ENTITY12_PARAM1DESC: "Người chơi sẽ nhận vật phẩm",
  T_34_WT_WS_ENTITY12_PARAM2DESC: "ID vật phẩm cụ thể được nhận",
  T_34_WT_WS_ENTITY12_PARAM2DESC3: "Số lượng vật phẩm được cung cấp",
  T_34_WT_WS_ENTITY12_PARAM3: "Số lượng",
  T_34_WT_WS_ENTITY13_PARAM1: "Loại",
  T_34_WT_WS_ENTITY13_PARAM2: "Vị trí",
  T_34_WT_WS_ENTITY13_PARAM2DESC: "Tọa độ vị trí xuất hiện của vật thể",
  T_34_WT_WS_ENTITY13_PARAM4: "Vật thể",
  T_34_WT_WS_ENTITY14_NAME: "Xóa bỏ vật thể",
  T_34_WT_WS_ENTITY14_NAMEDESC: "Xóa bỏ vật thể được chỉ định",
  T_34_WT_WS_ENTITY14_PARAM1DESC: "Xóa vật thể",
  T_34_WT_WS_ENTITY15_NAMEDESC: "Có được tất cả đơn vị người chơi",
  T_34_WT_WS_ENTITY16_NAMEDESC: "Có được tất cả các đơn vị trong nhóm",
  T_34_WT_WS_ENTITY17_NAMEDESC: "Hồi một lượng máu cho những người chơi được chỉ định. Nếu như lượng hồi vượt quá máu tối đa, máu sẽ hồi phục về mức tối đa",
  T_34_WT_WS_ENTITY17_PARAM1DESC: "Người chơi có dao động máu được tùy chỉnh",
  T_34_WT_WS_ENTITY17_PARAM2DESC: "Lượng máu định trước được hồi phục",
  T_34_WT_WS_ENTITY18_NAME: "Nhận tọa độ ngẫu nhiên",
  T_34_WT_WS_ENTITY18_NAMEDESC: "Định cấu hình vị trí cho những người chơi được chỉ định xuất hiện và quay trở lại",
  T_34_WT_WS_ENTITY18_PARAM1DESC: "Người chơi sẽ được hồi sinh ngẫu nhiên tại điểm này",
  T_34_WT_WS_ENTITY18_RETURNDESC: "Tọa độ của vị trí mà người chơi sẽ được chỉ định",
  T_34_WT_WS_ENTITY19_NAME: "Nhận điểm người chơi",
  T_34_WT_WS_ENTITY19_NAMEDESC: "Có được điểm số nhất định của những người chơi được chỉ định",
  T_34_WT_WS_ENTITY19_PARAM1DESC: "Nhận điểm của người chơi này",
  T_34_WT_WS_ENTITY19_PARAM2DESC: "Nhận được các loại điểm",
  T_34_WT_WS_ENTITY19_RETURNDESC: "Giá trị điểm được nhận",
  T_34_WT_WS_ENTITY2_NAME: "Đặt thuộc tính",
  T_34_WT_WS_ENTITY2_NAMEDESC: "Định cấu hình giá trị của thuộc tính, tại nơi loại thuộc tính đã được chọn",
  T_34_WT_WS_ENTITY2_PARAM1: "Đơn vị mẫu",
  T_34_WT_WS_ENTITY2_PARAM1DESC: "Giá trị thuộc tính của đơn vị game",
  T_34_WT_WS_ENTITY2_PARAM3: "Thuộc tính",
  T_34_WT_WS_ENTITY2_PARAM3DESC: "Một thuộc tính nhất định của đơn vị trò chơi này",
  T_34_WT_WS_ENTITY2_PARAM4: "Giá trị",
  T_34_WT_WS_ENTITY2_PARAM4DESC: "Giá trị cụ thể của thuộc tính. Đảm bảo rằng loại thuộc tính phù hợp với loại đã chọn và khớp với loại được định cấu hình trong các khối có liên quan.",
  T_34_WT_WS_ENTITY20_NAMEDESC: "Định cấu hình điểm số nhất định của những người chơi được chỉ định",
  T_34_WT_WS_ENTITY20_PARAM1DESC: "Định cấu hình điểm của những người chơi này",
  T_34_WT_WS_ENTITY20_PARAM2DESC: "Định cấu hình loại điểm",
  T_34_WT_WS_ENTITY20_PARAM3: "Điểm",
  T_34_WT_WS_ENTITY20_PARAM3DESC: "Giá trị điểm đang được đặt",
  T_34_WT_WS_ENTITY21_NAME: "Nhận toàn bộ điểm đội",
  T_34_WT_WS_ENTITY21_NAMEDESC: "Đạt được tổng số điểm nhất định của các đội được chỉ định",
  T_34_WT_WS_ENTITY21_PARAM1: "Đội",
  T_34_WT_WS_ENTITY21_PARAM1DESC: "Nhận điểm của đội này",
  T_34_WT_WS_ENTITY22_NAME: "Đặt điểm đội",
  T_34_WT_WS_ENTITY22_NAMEDESC: "Định cấu hình điểm số nhất định của các đội được chỉ định",
  T_34_WT_WS_ENTITY22_PARAM1DESC: "Định cấu hình điểm của đội này",
  T_34_WT_WS_ENTITY23_NAME: "Nhận được điểm của người chơi",
  T_34_WT_WS_ENTITY23_NAMEDESC: "Đạt được điểm số nhất định của một vòng nhất định cho các người chơi được chỉ định",
  T_34_WT_WS_ENTITY23_PARAM1DESC: "Nhận điểm của những người chơi này",
  T_34_WT_WS_ENTITY23_PARAM2: "Vòng",
  T_34_WT_WS_ENTITY23_PARAM2DESC: "Nhận điểm từ vòng đấu này",
  T_34_WT_WS_ENTITY24_NAME: "Đạt điểm đội trong vòng đấu",
  T_34_WT_WS_ENTITY24_NAMEDESC: "Đạt được điểm số nhất định của một vòng nhất định cho các đội được chỉ định",
  T_34_WT_WS_ENTITY25_NAME: "Dịch chuyển",
  T_34_WT_WS_ENTITY25_NAMEDESC: "Dịch chuyển những người chơi được chỉ định đến một vị trí được chỉ định",
  T_34_WT_WS_ENTITY25_PARAM1DESC: "Người chơi sẽ được dịch chuyển",
  T_34_WT_WS_ENTITY25_PARAM2DESC: "Tọa độ nơi người chơi sẽ được dịch chuyển đến",
  T_34_WT_WS_ENTITY26_NAMEDESC: "Cho phép người chơi được chỉ định gây sát thương cho các mục tiêu được chỉ định. Nếu không có người chơi tấn công nào được chọn, các mục tiêu được chỉ định sẽ nhận sát thương từ hệ thống.",
  T_34_WT_WS_ENTITY26_PARAM2DESC: "Đơn vị sẽ nhận sát thương",
  T_34_WT_WS_ENTITY26_PARAM4DESC: "Lượng sát thương gây ra",
  T_34_WT_WS_ENTITY28_NAMEDESC: "Hồi sinh người chơi được chỉ định",
  T_34_WT_WS_ENTITY28_PARAM1DESC: "Đơn vị người chơi có thể được hồi sinh",
  T_34_WT_WS_ENTITY3_NAMEDESC: "Định cấu hình loại khối",
  T_34_WT_WS_ENTITY3_PARAM1: "như",
  T_34_WT_WS_ENTITY4_NAME: "Nhận thuộc tính",
  T_34_WT_WS_ENTITY4_NAMEDESC: "Nhận một thuộc tính cụ thể của một đơn vị",
  T_34_WT_WS_ENTITY4_PARAM1DESC: "Nhận đơn vị trò chơi cụ thể của giá trị thuộc tính",
  T_34_WT_WS_ENTITY4_RETURNDESC: "Nhận giá trị thuộc tính cụ thể có thể nhận",
  T_34_WT_WS_ENTITY5_NAMEDESC: "Định cấu hình khả năng di chuyển cho tất cả người chơi",
  T_34_WT_WS_ENTITY6_NAME: "Tạo biểu tượng",
  T_34_WT_WS_ENTITY6_PARAM1: "Biểu tượng",
  T_34_WT_WS_ENTITY6_PARAM1DESC: "Hình ảnh hiển thị trên giao diện. Chọn từ các thiết kế khác nhau.",
  T_34_WT_WS_ENTITY6_PARAM4DESC: "Lựa chọn biểu tượng trong đó thiết kế được áp dụng",
  T_34_WT_WS_ENTITY7_NAMEDESC: "Tạo một biểu tượng giao diện cho người chơi được chỉ định. Nếu không có  đơn vị người chơi nào được chọn, hoạt ảnh sẽ được tạo cho tất cả người chơi.",
  T_34_WT_WS_ENTITY7_PARAM1: "Người chơi",
  T_34_WT_WS_ENTITY7_PARAM1DESC: "Tạo biểu tượng giao diện cho người chơi lựa chọn",
  T_34_WT_WS_ENTITY8_NAME: "Tạo văn bản",
  T_34_WT_WS_ENTITY8_PARAM1: "Văn bản",
  T_34_WT_WS_ENTITY8_PARAM1DESC: "Nội dung văn bản cụ thể được tạo từ lệnh này",
  T_34_WT_WS_ENTITY8_PARAM3DESC: "Văn bản hiện đang được tạo",
  T_34_WT_WS_ENTITY9_NAMEDESC: "Thêm một dòng văn bản trên giao diện cho người chơi được chỉ định. Nếu không có người chơi nào được chọn, văn bản sẽ được tạo trên giao diện của tất cả người chơi.",
  T_34_WT_WS_ENTITY9_PARAM1DESC: "Thêm một giao diện văn bản cho người chơi lựa chọn",
  T_34_WT_WS_ICONENTITY_PARAM1: "Định danh biểu tượng",
  T_34_WT_WS_ICONENTITY_PARAM2: "Thiết kế",
  T_34_WT_WS_ICONENTITY_PARAM3: "Màu",
  T_34_WT_WS_ICONENTITY_PARAM4: "Tỷ lệ",
  T_34_WT_WS_ICONENTITY_PARAM5: "Vị trí hiển thị",
  T_34_WT_WS_ICONENTITY_PARAM6: "Theo dõi mục tiêu",
  T_34_WT_WS_ICONENTITY_PARAM7: "Nhìn xuyên tường",
  T_34_WT_WS_ICONENTITY_PARAM8: "Luôn ở trên màn hình",
  T_34_WT_WS_ONETEAM_TAG: "Đội đơn",
  T_34_WT_WS_PHASEENTITY_PARAM1: "Giai đoạn",
  T_34_WT_WS_PHASEENTITY_PARAM2: "Chỉ số giai đoạn",
  T_34_WT_WS_PHASEENTITY_PARAM3: "Thời gian bắt đầu",
  T_34_WT_WS_PHASEENTITY_PARAM4: "Thời gian kết thúc",
  T_34_WT_WS_PHASEENTITY_PARAM5: "Thời lượng",
  T_34_WT_WS_PLAYERENTITY_PARAM1: "Đơn vị người chơi",
  T_34_WT_WS_PLAYERENTITY_PARAM10: "Điểm hồi sinh",
  T_34_WT_WS_PLAYERENTITY_PARAM12: "Tỉ lệ sát thương",
  T_34_WT_WS_PLAYERENTITY_PARAM13: "Chế độ nhân vật 3D",
  T_34_WT_WS_PLAYERENTITY_PARAM17: "Xác định",
  T_34_WT_WS_PLAYERENTITY_PARAM18: "Máu hiện tại",
  T_34_WT_WS_PLAYERENTITY_PARAM2: "Đầy máu",
  T_34_WT_WS_PLAYERENTITY_PARAM3: "AI",
  T_34_WT_WS_PLAYERENTITY_PARAM4: "Trạng thái người chơi",
  T_34_WT_WS_PLAYERENTITY_PARAM5: "Thời gian sống sót",
  T_34_WT_WS_PLAYERENTITY_PARAM6: "Bất khả xâm phạm",
  T_34_WT_WS_PLAYERENTITY_PARAM7: "Đội",
  T_34_WT_WS_PLAYERENTITY_PARAM8: "ID mốc mục tiêu",
  T_34_WT_WS_PLAYERENTITY_PARAM9: "Điểm xuất phát",
  T_34_WT_WS_PROCIRCLE_ICON: "Biểu tượng",
  T_34_WT_WS_PVEDESC1: "Nếu ít nhất một người chơi chạm đến vạch đích trước khi thời gian kết thúc, thì đội đó sẽ thắng. Nếu như tất cả người chơi bị tiêu diệt cùng lúc, game kết thúc.",
  T_34_WT_WS_PVEDESC2: "Sống sót trong một thời gian chỉ định để giành chiến thắng. Nếu tất cả người chơi bị tiêu diệt cùng lúc, game kết thúc.",
  T_34_WT_WS_PVENAME1: "Nhanh",
  T_34_WT_WS_PVENAME2: "Sinh tồn",
  T_34_WT_WS_RUNCHECKENTITY_PARAM1: "ID mốc hiện tại",
  T_34_WT_WS_RUNCHECKENTITY_PARAM2: "Số Checkpoint chế độ Vượt chướng ngại vật",
  T_34_WT_WS_SKILLSET14: "Khiên thịnh nộ",
  T_34_WT_WS_TEAMENTITY_PARAM1: "Đội",
  T_34_WT_WS_TEAMENTITY_PARAM2: "Át chủ bài",
  T_34_WT_WS_TEAMENTITY_PARAM3: "Tất cả thành viên",
  T_34_WT_WS_TRIGGERNTITY_PARAM1: "Kích hoạt thường xuyên",
  T_34_WT_WS_TRIGGERNTITY_PARAM2: "Bề ngoài",
  T_34_WT_WS_TXTENTITY_PARAM1: "Văn bản",
  T_34_WT_WS_TXTENTITY_PARAM2: "Nội dung",
  T_34_WT_WS_VFXENTITY_PARAM1: "Định danh hiệu ứng hình ảnh",
  T_34_WZ_WS_LOGIC10_NAME: "Bấm tiếp tục để chuyển",
  T_34_WZ_WS_LOGIC10_NAMEDESC: "Bỏ qua phần lặp lại vòng lặp hiện tại và thực hiện phần tiếp theo",
  T_34_WZ_WS_LOGIC11_NAME: "Trả về",
  T_34_WZ_WS_LOGIC11_NAMEDESC: "Kết thúc quá trình thực thi hiện tại và quay trở lại chương trình chính. Cho phép gửi lại dữ liệu khi trở về.",
  T_34_WZ_WS_LOGIC11_PARAM1_NAME: "Giá trị trả lại",
  T_34_WZ_WS_LOGIC11_PARAM1_NAMEDESC: "Dữ liệu được gửi trở lại chương trình chính",
  T_34_WZ_WS_LOGIC2_NAME: "So sánh",
  T_34_WZ_WS_LOGIC2_NAMEDESC: "So sánh 2 giá trị bằng việc dùng 2 nhà điều hành được chỉ định",
  T_34_WZ_WS_LOGIC2_PARAM1_NAME: "Giá trị bên trái",
  T_34_WZ_WS_LOGIC2_PARAM1_NAMEDESC: "Giá trị bên trái được sử dụng cho việc so sánh",
  T_34_WZ_WS_LOGIC2_PARAM2_NAME: "Tính năng so sánh",
  T_34_WZ_WS_LOGIC2_PARAM2_NAMEDESC: "Chọn cách bạn muốn các giá trị được so sánh. Các toán tử được hỗ trợ là: >,  ≥,==, !=, ≤, <, VÀ (dữ liệu có hai giá trị), HOẶC(dữ liệu có hai giá trị)",
  T_34_WZ_WS_LOGIC2_PARAM3_NAME: "Giá trị đúng",
  T_34_WZ_WS_LOGIC2_PARAM3_NAMEDESC: "Giá trị bên phải được sử dụng để so sánh",
  T_34_WZ_WS_LOGIC2_PARAM4_NAMEDESC: "Kết quả so sánh",
  T_34_WZ_WS_LOGIC3_NAME: "KHÔNG",
  T_34_WZ_WS_LOGIC3_NAMEDESC: "Đưa ra giá trị ngược lại của một giá trị logic",
  T_34_WZ_WS_LOGIC3_PARAM1_NAMEDESC: "Giá trị bạn muốn sử dụng thuật toán KHÔNG",
  T_34_WZ_WS_LOGIC3_PARAM2_NAMEDESC: "Kết quả của việc không thể vận hành",
  T_34_WZ_WS_LOGIC4_NAME: "Kiểm tra trống",
  T_34_WZ_WS_LOGIC4_NAMEDESC: "Kiểm tra xem một đơn vị có trống hoặc null hay không",
  T_34_WZ_WS_LOGIC4_PARAM1_NAME: "Đơn vị mẫu",
  T_34_WZ_WS_LOGIC4_PARAM1_NAMEDESC: "Đơn vị dùng để kiểm tra sự thiếu giá trị",
  T_34_WZ_WS_LOGIC4_PARAM2_NAMEDESC: "Đơn vị có trống hay không",
  T_34_WZ_WS_LOGIC5_NAME: "Nếu",
  T_34_WZ_WS_LOGIC5_NAMEDESC: "Thực thi tùy theo điều kiện có được đáp ứng hay không. Các quy trình con cũng giống như các nhánh logic tiếp theo.",
  T_34_WZ_WS_LOGIC5_PARAM1_NAME: "Giá trị",
  T_34_WZ_WS_LOGIC5_PARAM1_NAMEDESC: "Số lượng điều kiện và số lượng quá trình con (nhánh logic) phải giống nhau",
  T_34_WZ_WS_LOGIC6_NAME: "Vòng lặp của phạm vi số nguyên",
  T_34_WZ_WS_LOGIC6_NAMEDESC: "Lặp lại từ x đến y theo từng bước của z. Quá trình con là chính vòng lặp.",
  T_34_WZ_WS_LOGIC6_PARAM1_NAMEDESC: "Tên của mục vòng lặp có thể được sử dụng để trích xuất giá trị của mục vòng lặp",
  T_34_WZ_WS_LOGIC6_PARAM2_NAME: "Giá trị bắt đầu",
  T_34_WZ_WS_LOGIC6_PARAM2_NAMEDESC: "Giá trị mà tại đó vòng lặp bắt đầu",
  T_34_WZ_WS_LOGIC6_PARAM3_NAME: "Giá trị kết thúc",
  T_34_WZ_WS_LOGIC6_PARAM3_NAMEDESC: "Giá trị mà tại đó vòng lặp kết thúc",
  T_34_WZ_WS_LOGIC6_PARAM4_NAME: "Bước",
  T_34_WZ_WS_LOGIC6_PARAM4_NAMEDESC: "Bước của mỗi vòng lặp. Khi giá trị bắt đầu nhỏ hơn giá trị kết thúc, bước phải lớn hơn 0. Khi giá trị bắt đầu lớn hơn giá trị kết thúc, bước phải nhỏ hơn 0.",
  T_34_WZ_WS_LOGIC7_NAME: "Vòng lặp nguyên tố",
  T_34_WZ_WS_LOGIC7_NAMEDESC: "Cho phép truyền qua vùng chứa dữ liệu để trích xuất từng phần tử con trong đó. Quá trình con chính là vòng lặp.",
  T_34_WZ_WS_LOGIC7_PARAM1_NAME: "Thành phần",
  T_34_WZ_WS_LOGIC7_PARAM1_NAMEDESC: "Di chuyển đến tên này sẽ trích xuất giá trị của phần tử phụ của biến cục bộ",
  T_34_WZ_WS_LOGIC7_PARAM3_NAME: "Vùng chứa dữ liệu",
  T_34_WZ_WS_LOGIC7_PARAM3_NAMEDESC: "Vùng chứa dữ liệu cần duyệt. Hiện tại hỗ trợ vùng chứa danh sách.",
  T_34_WZ_WS_LOGIC8_NAME: "Vòng lặp điều kiện",
  T_34_WZ_WS_LOGIC8_NAMEDESC: "Vòng lặp có điều kiện lặp lại cho đến khi một điều kiện được đáp ứng. Vòng lặp dừng khi điều kiện là Sai.",
  T_34_WZ_WS_LOGIC8_PARAM1_NAME: "Điều kiện",
  T_34_WZ_WS_LOGIC8_PARAM1_NAMEDESC: "Lặp lại vòng lặp nếu điều kiện là Đúng và dừng cho đến khi điều kiện là Sai",
  T_34_WZ_WS_LOGIC9_NAME: "Phá vỡ vòng lặp",
  T_34_WZ_WS_LOGIC9_NAMEDESC: "Dừng quy trình vòng lặp hiện tại và nhảy ra khỏi vòng lặp",
  T_34_Y_B_DINOSAURS: "Quần Khủng long nhún nhảy",
  T_34_YF_M24_N: "M24",
  T_34_YS_F_B_ANGEL_BW: "Thiên thần thánh thiện (Nữ)",
  T_34_YS_F_B_PANDACATTLE: "Quần Pyjama Bò sữa",
  T_34_YS_F_B_RAMPAGE4_RAIN: "Quần Thiên Vũ",
  T_34_YS_F_H_RAMPAGE4_RAIN: "Đầu Thiên Vũ",
  T_34_YS_F_HA_RAMPAGE4_RAIN: "Mặt Thiên Vũ",
  T_34_YS_F_S_PANDACATTLE: "Giày Pyjama Bò sữa",
  T_34_YS_F_S_RAMPAGE4_RAIN: "Giày Thiên Vũ",
  T_34_YS_F_T_PANDACATTLE: "Áo Pyjama Bò sữa",
  T_34_YS_F_T_RAMPAGE4_RAIN: "Áo Thiên Vũ",
  T_34_YS_M_B_ANGEL_BW: "Thiên thần thánh thiện (Nam)",
  T_34_YS_M_B_PANDACATTLE: "Quần Pyjama Gấu trúc",
  T_34_YS_M_H_PANDACATTLE: "Đầu Pyjama Gấu trúc",
  T_34_YS_M_S_PANDACATTLE: "Giày Pyjama Gấu trúc",
  T_34_YS_M_T_PANDACATTLE: "Áo Pyjama Gấu trúc",
  T_34_YZY_CHARACTER_RHYTHMGIRL_N: "A-Patroa",
  T_35_C_SKILL_DESC_BRAZILSOLDIER: "Nhận [FFB300]{0} EP[-] mỗi khi hạ gục địch.",
  T_35_DY_PET_OWL_N: "Cú Trinh Sát",
  T_35_DY_PETSKIN_ALIEN_DIGITALUNIVERSE_N: "Moony Vũ trụ",
  T_35_DY_PETSKIN_CATEAM_AXOLOTL_N: "Rồng Bộ Hành",
  T_35_DY_PETSKIN_CATEAM_HAWK_N: "Đại Bàng Lam Hỏa",
  T_35_DY_PETSKIN_OWL_FIRE_N: "Trinh sát rực lửa",
  T_35_DY_PETSKIN_OWL_NIGHT_N: "Trinh sát bóng đêm",
  T_35_DY_PETSKIN_OWL_STORM_N: "Trinh sát băng giá",
  T_35_JL_KNOCKEDDOWN: "Bị hạ gục",
  T_35_JL_SKILL_DESC_CRAZYGIRL: "Trong vòng [FFB300]{1}s[-] giây sau khi bắn vào Bom Keo, đánh dấu những kẻ địch trong phạm vi [FFB300]{3}m[-] và có thể gây sát thương lên những kẻ đó xuyên qua bom keo (sát thương gây ra sẽ thấp hơn bình thường). Có thể xuyên thấu tối đa đến [FFB300]{0}[-] Bom Keo. Thời gian hồi chiêu: [FFB300]{2}s[-].",
  T_35_JL_SKILL_NAME_CRAZYGIRL: "Xuyên Tường",
  T_35_KY_INFECTION_MAPNAME: "Tử Địa",
  T_35_M_WS_BUTTONCLICKDESC: "Kích hoạt khi nút tương ứng được nhấn. Có thể nhận người kích hoạt qua thông số.",
  T_35_M_WS_GETTEAMMATEPOS: "Nhận ở gần vị trí đồng đội",
  T_35_M_WS_ROUND2: "Lượt hiện tại",
  T_35_PD_Infection_HUMANSELECT: "Chọn vũ khí",
  T_35_PD_INFECTION_MODENAME: "Thời khắc tận thế",
  T_35_QX_WS_ICONTYPE_ITEM: "Vật thể",
  T_35_QX_WS_ICONTYPE_NATURE: "Thiên nhiên",
  T_35_QX_WS_ICONTYPE_SHAPE: "Hình khối",
  T_35_QX_WS_ICONTYPE_SYMBOL: "Biểu tượng",
  T_35_QX_WS_SOUNDTYPE_WEAPON: "Vũ khí",
  T_35_R_EMOTE_TAG_MUSIC_N: "Âm nhạc",
  T_35_RW_SKILL_DESC_Singers: "Bạn và đồng minh trong khoảng cách [FFB300]{0}m[-] có thể chặn [FFB300]{1}%[-] sát thương bằng EP của họ. Trong trường hợp này, lượng EP bị trừ của đồng đội sẽ được cộng vào EP của người sử dụng",
  T_35_RW_SKILL_NAME_Singers: "Hỗ trợ Câm lặng",
  T_35_SP_WS_COMMENTKEY_01: "Độ khó phù hợp",
  T_35_SP_WS_COMMENTKEY_02: "Lối chơi sáng tạo",
  T_35_SP_WS_COMMENTKEY_03: "Lối chơi thú vị",
  T_35_SP_WS_COMMENTKEY_04: "Có thể chơi lại",
  T_35_SP_WS_COMMENTKEY_05: "Cốt truyện hấp dẫn",
  T_35_SP_WS_COMMENTKEY_06: "Cân bằng tốt",
  T_35_SP_WS_COMMENTKEY_07: "Trải nghiệm tốt",
  T_35_SP_WS_COMMENTKEY_08: "Linh hoạt",
  T_35_SP_WS_COMMENTKEY_09: "Nhìn khá đẹp",
  T_35_SP_WS_COMMENTKEY_10: "Quá khó",
  T_35_SP_WS_COMMENTKEY_11: "Quá dễ",
  T_35_SP_WS_COMMENTKEY_12: "Lối chơi thiếu sáng tạo",
  T_35_SP_WS_COMMENTKEY_13: "Quá dài",
  T_35_SP_WS_COMMENTKEY_14: "Thiếu cân bằng",
  T_35_SP_WS_COMMENTKEY_15: "Trải nghiệm không tốt",
  T_35_SP_WS_IMAGE03: "Cấu tạo",
  T_35_SP_WS_IMAGE04: "Khung",
  T_35_SY_CHARGESHOT_TEARS_N: "Súng sạc Long hỏa vân",
  T_35_SY_GRENADE_DIGITALUNIVERSE_01_N: "Lựu đạn - Sinh nhật 5 tuổi",
  T_35_SY_GRENADE_PIRATES_N: "Lựu đạn Hải tặc",
  T_35_SY_GRENADE_RIDERS_N: "Lựu đạn Quái xế",
  T_35_SY_M24_KUN_N: "M24 - Hải Ngư Tiên Tử",
  T_35_SY_SCAR_PARKOUR_N: "SCAR - Sắc Tố Hồ Ly",
  T_35_SY_VEHICLE_JEEP_PANTOMIME_N: "Xe Jeep - Mảnh Ghép Trắng Đen",
  T_35_SY_VEHICLE_MONSTER_DIGITALUNIVERSE_D: "Hãy tận hưởng bữa tiệc sinh nhật!",
  T_35_SY_VEHICLE_MOTOBIKE_DIGITALUNIVERSE_N: "Xe máy - Sinh Nhật 5 Tuổi",
  T_35_WT_WS_PREFAB_MENUBAR_1: "Cấu trúc và thiết kế",
  T_35_WT_WS_PREFAB_MENUBAR_1_1: "Cấu trúc",
  T_35_WT_WS_PREFAB_MENUBAR_1_6: "Khác",
  T_35_WT_WS_PREFAB_MENUBAR_2: "Kiến trúc",
  T_35_WT_WS_PREFAB_MENUBAR_2_1: "Tòa nhà cỡ lớn",
  T_35_WT_WS_PREFAB_MENUBAR_2_2: "Tòa nhà cỡ vừa",
  T_35_WT_WS_PREFAB_MENUBAR_3: "Đối tượng hàm",
  T_35_WT_WS_PREFAB_MENUBAR_3_1: "Thiết Yếu",
  T_35_WT_WS_PREFAB_MENUBAR_3_6: "Âm nhạc",
  T_35_WT_WS_PVEMODE_TAG: "Chế độ sinh tồn",
  T_35_WZY_WS_BECRE_NAMEDESC: "Kích hoạt khi vật thể được tạo",
  T_35_WZY_WS_BEKILL_NAMEDESC: 'Kích hoạt khi vật thể bị tiêu diệt. Nguồn tấn công có thể được xác định bằng "Nguồn kích hoạt" và loại tấn công có thể xác định bằng "Loại sát thương"',
  T_35_WZY_WS_BEKILL_PARAM1_NAMEDESC: "Vật thể kích hoạt hành động",
  T_35_WZY_WS_CREPROP_NAMEDESC: "Tạo một loạt vật phẩm ở một khu vực cụ thể. Khi tạo 1 loại vật phẩm, số lượng sẽ là số vật phẩm đó. Khi tạo một nhóm vật phẩm, số lượng là số theo danh sách vật phẩm tương ứng. Vật phẩm được tạo sẽ phụ thuộc vào đơn vị của bản đồ",
  T_35_WZY_WS_CREPROP_PARAM1_NAMEDESC: "Một danh sách chứa các vật phẩm có thể được tạo. Có thể bao gồm các vật phẩm đơn.",
  T_35_WZY_WS_CREPROP_PARAM2_NAMEDESC: "Một bảng để chọn số lượng vật phẩm. Có thể bao gồm số lượng của 1 loại vật phẩm",
  T_35_WZY_WS_DAMTYPE_CAR: "Xe",
  T_35_WZY_WS_DAMTYPE_FALL: "Té ngã",
  T_35_WZY_WS_DAMTYPE_FIREARMS: "Súng",
  T_35_WZY_WS_DAMTYPE_GRENADE: "Lựu đạn",
  T_35_WZY_WS_DAMTYPE_MELEE: "Vũ khí cận chiến",
  T_35_WZY_WS_DAMTYPE_ZONE: "Sát thương ngoài vùng an toàn",
  T_35_WZY_WS_DELPROP_NAMEDESC: "Sử dụng để xóa số lượng cụ thể của một vật phẩm của một người chơi",
  T_35_WZY_WS_ENTERTRIGGER_NAME: "Tiến vào khu vực",
  T_35_WZY_WS_ENTERTRIGGER_NAMEDESC: 'Kích hoạt khi "Nguồn kích hoạt" tiến vào khu vực kích hoạt',
  T_35_WZY_WS_ENTITYPLAYER_DESC: "Người chơi cần có được định danh. Khi được liên kết với người chơi, thông tin định danh sẽ chỉ được cập nhật cho người chơi nói trên. Khi không có người chơi nào được liên kết, tất cả người chơi sẽ nhận được thông tin định danh.",
  T_35_WZY_WS_FIGHTENTITY_NAME: "Đơn vị chiến đấu",
  T_35_WZY_WS_GETALLOB_NAMEDESC: "Nhận tất cả vật thể thuộc một loại cụ thể. Kết quả sẽ là một danh sách",
  T_35_WZY_WS_GETALLOB_PARAM1_NAMEDESC: "Loại Vật thể",
  T_35_WZY_WS_HUDWIDGET_NAME: "Điều khiển UI",
  T_35_WZY_WS_HURT_NAMEDESC: 'Kích hoạt khi vật thể nhận sát thương. Nguồn sát thương có thể được xác định thông qua "Nguồn kích hoạt"',
  T_35_WZY_WS_ITEMSTYPE_NAMEDESC: "Loại vật phẩm",
  T_35_WZY_WS_LEVELOBJECT_NAME: "Vật thể giai đoạn",
  T_35_WZY_WS_OBKILL_NAMEDESC: 'Kích hoạt khi phá hủy bởi một vật thể khác. Vật thể bị phá hủy có thể được xác định thông qua "Vật thể bị phá hủy"',
  T_35_WZY_WS_OBKILL_PARAM1_NAMEDESC: "Vật thể bị tiêu diệt",
  T_35_WZY_WS_ONHURT_NAMEDESC: "Kích hoạt khi một vật gây sát thương",
  T_35_WZY_WS_ONHURT_PARAM1_DESC: "Vật thể đang gây sát thương",
  T_35_WZY_WS_ONHURT_PARAM1_NAME: "Thực thể mục tiêu",
  T_35_WZY_WS_PREFABID_NAME: "Mẫu UI",
  T_35_WZY_WS_PROPERTY_EPNOW: "EP hiện tại",
  T_35_WZY_WS_PROPERTY_JUMP: "Nhảy cao",
  T_35_WZY_WS_QUITTRIGGER_NAME: "Thoát khỏi khu vực",
  T_35_WZY_WS_QUITTRIGGER_NAMEDESC: 'Kích hoạt khi "Nguồn kích hoạt" thoát khỏi khu vực kích hoạt',
  T_35_WZY_WS_REMOVEELEMENT_NAMEDESC: "Xóa phần tử đã chỉ định khỏi mảng, [List] là mảng chứa phần tử cần xóa và [Element] là giá trị của phần tử cần xóa",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAME: "Giá trị",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAMEDESC: "Giá trị loại bỏ",
  T_35_WZY_WS_ROUNDENTITY_NAME: "Vật phẩm hình cầu",
  T_35_WZY_WS_TOWER_PARAM1: "Thủ nhà",
  T_35_WZY_WS_TOWER_PARAM2: "ID đội",
  T_35_WZY_WS_TOWER_PARAM3: "Máu hiện tại",
  T_35_WZY_WS_TOWER_PARAM4: "Máu tối đa",
  T_35_WZY_WS_TOWER_PARAM5: "Sát thương",
  T_35_WZY_WS_TOWER_PARAM6: "Tần suất tấn công",
  T_35_WZY_WS_TOWER_PARAM7: "Tầm bắn",
  T_35_WZY_WS_TOWER_PARAM8: "Phòng thủ %",
  T_35_XYL_PDM_REVENGE: "Báo thù",
  T_35_XYL_WS_BISPARTERRE: "Bồn hoa",
  T_35_XYL_WS_BISPARTERRE_DESC: "Một bồn hoa đá theo chủ đề Battle-In-Style",
  T_35_XYL_WS_BISWALL: "Tường Graffiti",
  T_35_XYL_WS_BISWALL_DESC: "Một bức tường được trang trí theo phong cách Battle-In-Style",
  T_35_XYL_WS_BOTDROP: "Bật/tắt hòm xác",
  T_35_XYL_WS_CUSTOMTRIGGER: "Kích hoạt tùy ý",
  T_35_XYL_WS_CUSTOMTRIGGER_DESC: "Đặt một vật thể để kích hoạt hiệu ứng nhất định khi người chơi kích hoạt nó. Hiệu ứng này phải được thiết lập thông qua bản thiết kế. (Chỉ xuất hiện trong Chế độ tùy chỉnh.)",
  T_35_XYL_WS_DOUBLEDOOR: "Cổng",
  T_35_XYL_WS_DOUBLEDOOR_DESC: "Một cánh cổng có thể mở toang ra",
  T_35_XYL_WS_RESET: "Lặp lại mỗi vòng đấu",
  T_35_XYL_WS_RESETN: "Không",
  T_35_XYL_WS_RESETY: "Có",
  T_35_XYL_WS_ROADBLOCK: "Rào chắn 1",
  T_35_XYL_WS_ROADBLOCK_DESC: "Ngăn vượt qua",
  T_35_XYL_WS_STAIRS: "Cầu thang",
  T_35_XYL_WS_STAIRS_DESC: "Có thể kết hơp với sàn nhà",
  T_35_XYL_WS_STAIRSL: "Sàn nhà B",
  T_35_XYL_WS_STAIRSL_DESC: "Dùng để kết hợp với cầu thang",
  T_35_XYL_WS_STAIRSZ: "Sàn nhà A",
  T_35_XYL_WS_STAIRSZ_DESC: "Dùng để kết hợp với cầu thang",
  T_35_XYL_WS_TBOOTH: "Bốt điện thoại",
  T_35_XYL_WS_TBOOTH_DESC: "Thường xuyên bắt gặp trên đường",
  T_35_YF_PP19_N: "PP19",
  T_35_YS_A_CATEAM_HW: "Mũ điêu huynh",
  T_35_YS_A_CUBBY: "Mặt nạ gấu nâu",
  T_35_YS_F_A_PANTOMIME: "Mặt nạ diễn viên kịch câm",
  T_35_YS_F_A_RIDERS: "Mặt nạ Tay đua cự phách",
  T_35_YS_F_B_DIGITALUNIVERSE2: "Quần DJ bay bổng",
  T_35_YS_F_B_GOLDCHAIN: "Quần Yêu Nữ Hàng Hiệu",
  T_35_YS_F_B_PANTOMIME: "Quần diễn viên kịch câm",
  T_35_YS_F_B_RIDERS: "Quần Tay đua cự phách",
  T_35_YS_F_H_BEAR_HW: "Đầu gấu (nữ)",
  T_35_YS_F_H_DIGITALUNIVERSE2: "Đầu DJ bay bổng",
  T_35_YS_F_H_GOLDCHAIN: "Đầu Yêu Nữ Hàng Hiệu",
  T_35_YS_F_H_PANTOMIME: "Đầu diễn viên kịch câm",
  T_35_YS_F_H_RIDERS: "Đầu Tay đua cự phách",
  T_35_YS_F_HA_GOLDCHAIN: "Mặt Yêu Nữ Hàng Hiệu",
  T_35_YS_F_S_DIGITALUNIVERSE2: "Giày DJ bay bổng",
  T_35_YS_F_S_GOLDCHAIN: "Giày Yêu Nữ Hàng Hiệu",
  T_35_YS_F_S_PANTOMIME: "Giày diễn viên kịch câm",
  T_35_YS_F_S_RIDERS: "Giày Tay đua cự phách",
  T_35_YS_F_T_DIGITALUNIVERSE2: "Áo DJ bay bổng",
  T_35_YS_F_T_GOLDCHAIN: "Áo Yêu Nữ Hàng Hiệu",
  T_35_YS_F_T_PANTOMIME: "Áo diễn viên kịch câm",
  T_35_YS_F_T_RIDERS: "Áo Tay đua cự phách",
  T_35_YS_ITEM_SUPERFAK: "Túi siêu cứu thương",
  T_35_YS_M_A_GOLDCHAIN: "Mặt nạ Dân chơi xích vàng",
  T_35_YS_M_A_RIDERS: "Mặt nạ Quái Xế Neon",
  T_35_YS_M_B_GOLDCHAIN: "Quần Dân chơi xích vàng",
  T_35_YS_M_B_RIDERS: "Quần Quái Xế Neon",
  T_35_YS_M_H_BEAR_HW: "Đầu gấu (nam)",
  T_35_YS_M_H_GOLDCHAIN: "Đầu Dân chơi xích vàng",
  T_35_YS_M_H_RIDERS: "Đầu Quái Xế Neon",
  T_35_YS_M_S_GOLDCHAIN: "Giày Dân chơi xích vàng",
  T_35_YS_M_S_RIDERS: "Giày Quái Xế Neon",
  T_35_YS_M_T_GOLDCHAIN: "Áo Dân chơi xích vàng",
  T_35_YS_M_T_RIDERS: "Áo Quái Xế Neon",
  T_35_YS_T_CHAMPION: "Áo phông nhà vô địch",
  T_35_YS_T_PAINTING: "Áo Eo Thon",
  T_35_YZY_CHARACTER_CRAZYGIRL_N: "Iris",
  T_35_YZY_CHARACTER_SINGERS_N: "J.Biebs",
  T_36_JH_WS_BASEMONEY: "Nhận xu khi trận đấu bắt đầu",
  T_36_JH_WS_CESAYCLOSE: "Tắt tính năng tự động tắt",
  T_36_JH_WS_CHOOSEEDITSHOP: "Chọn một cửa hàng để chỉnh sửa",
  T_36_JH_WS_CHOOSESHOP: "Chọn 1 cửa hàng",
  T_36_JH_WS_COINCOUNT: "Số tiền",
  T_36_JH_WS_COINHUD: "Hiển thị số tiền hoặc không",
  T_36_JH_WS_CRAFTSHOP: "Sửa cửa hàng",
  T_36_JH_WS_CREATEGOLD: "Máy tạo xu",
  T_36_JH_WS_CSHOPENTITY: "Liên kết đơn vị cửa hàng",
  T_36_JH_WS_CSHOPHUD: "Giao diện cửa hàng",
  T_36_JH_WS_CURRENTLIMIT: "Hạn mức còn lại",
  T_36_JH_WS_ECONOMIC: "Kinh tế",
  T_36_JH_WS_INGAMEECONOMI: "Kinh tế trong trò chơi",
  T_36_JH_WS_ITEMINDEXID: "Số vật phẩm",
  T_36_JH_WS_KILLMONEY: "Nhận xu sau khi loại người chơi",
  T_36_JH_WS_KILLMONEYTIP: "Số xu nhận được sau khi tiêu diệt zombie trong chế độ Tốc độ và chế độ Sức bền",
  T_36_JH_WS_LISTINDEX: "Danh sách loại vật phẩm",
  T_36_JH_WS_NULL: "Null",
  T_36_JH_WS_NUMBER: "Số lượng",
  T_36_JH_WS_OPTIONNAME: "Độc quyền Thời khắc tận thế",
  T_36_JH_WS_REALSHOPENTITY: "Đơn vị cửa hàng",
  T_36_JH_WS_SEEORHIDE: "Hiển thị máy bán hàng",
  T_36_JH_WS_SHOPFRONT: "Cửa hàng",
  T_36_JH_WS_SHOPITEMLIST: "Loại vật phẩm",
  T_36_JH_WS_SHOPOPENCON: "Trạng thái mở",
  T_36_JH_WS_SSHOPNAME: "Tên cửa hàng",
  T_36_JH_WS_TOTALLIMIT: "Giới hạn mua sắm",
  T_36_JH_WS_TRIGGERWIDE: "Vùng kích hoạt",
  T_36_JH_WS_VENDMACHINE: "Máy bán hàng",
  T_36_JH_WS_WINMONEY: "Nhận xu sau khi chiến thắng",
  T_36_JH_WS_WORTH: "đáng giá",
  T_36_JL_FOREGRIP_MR_N: "Tay cầm súng trường tầm xa",
  T_36_JL_GOLD_SCAR_I_N: "SCAR-I",
  T_36_JL_GOLD_SCAR_II_N: "SCAR-II",
  T_36_JL_GOLD_SCAR_III_N: "SCAR-III",
  T_36_JL_STOCK_SG_N: "Báng shotgun",
  T_36_JL_STOCK_SR_N: "Báng súng ngắm",
  T_36_KK_WS_MONTSTERDES: "Xe tải 4 chỗ với độ bền và độ linh hoạt cao",
  T_36_M_WS_SETTEMPVAR: "Cài đặt biến tạm thời",
  T_36_M_WS_TEMPVAR: "Biến tạm thời",
  T_36_SY_AK47_MAMBAS_N: "AK47 - Phong Xà",
  T_36_SY_AN94_MAMBAS_N: "AN94 - Phong Xà",
  T_36_SY_AR15_MAMBAS_N: "Chim Bói Cá - Phong Xà",
  T_36_SY_AUG_MAMBAS_N: "AUG - Phong Xà",
  T_36_SY_AWM_MAMBAS_N: "AWM - Phong Xà",
  T_36_SY_BLT_MAMBAS_N: "M82B - Phong Xà",
  T_36_SY_CHARGESHOT_MAMBAS_N: "Súng sạc - Phong Xà",
  T_36_SY_EAGLE_MAMBAS_N: "Desert Eagle - Phong Xà",
  T_36_SY_FAMAS_MAMBAS_N: "FAMAS - Phong Xà",
  T_36_SY_G18_MAMBAS_N: "G18 - Phong Xà",
  T_36_SY_G36_MAMBAS_N: "G36 - Phong Xà",
  T_36_SY_GRENADE_FESTIVAL_TU_N: "Lưu đạn - Lễ Hội Hải Quân",
  T_36_SY_GROZA_MAMBAS_N: "Groza - Phong Xà",
  T_36_SY_HAND_CANNON_MAMBAS_N: "Pháo cầm tay - Phong Xà",
  T_36_SY_HEALINGSNIPER_MAMBAS_N: "Súng ngắm điện - Phong Xà",
  T_36_SY_ICE_GUN_MAMBAS_N: "Súng băng - Phong Xà",
  T_36_SY_KAR98K_MAMBAS_N: "Kar98k - Phong Xà",
  T_36_SY_KORD_MAMBAS_N: "Kord - Phong Xà",
  T_36_SY_M1014_MAMBAS_N: "M1014 - Phong Xà",
  T_36_SY_M14_MAMBAS_N: "M14 - Phong Xà",
  T_36_SY_M1873_MAMBAS_N: "M1873 - Phong Xà",
  T_36_SY_M1887_MAMBAS_N: "M1887 - Phong Xà",
  T_36_SY_M1917_MAMBAS_N: "M1917 - Phong Xà",
  T_36_SY_M21A5_MAMBAS_N: "Chim Gõ Kiến - Phong Xà",
  T_36_SY_M24_MAMBAS_N: "M24 - Phong Xà",
  T_36_SY_M249_MAMBAS_N: "M249 - Phong Xà",
  T_36_SY_M4A1_MAMBAS_N: "M4A1 - Phong Xà",
  T_36_SY_M500_MAMBAS_N: "M500 - Phong Xà",
  T_36_SY_M60_MAMBAS_N: "M60 - Phong Xà",
  T_36_SY_M79_MAMBAS_N: "M79- Phong Xà",
  T_36_SY_MAC10_MAMBAS_N: "MAC10 - Phong Xà",
  T_36_SY_MAG7_MAMBAS_N: "MAG-7 - Phong Xà",
  T_36_SY_MINI_MAMBAS_N: "AC80 - Phong Xà",
  T_36_SY_MP40_MAMBAS_N: "MP40 - Phong Xà",
  T_36_SY_MP5_MAMBAS_N: "MP5 - Phong Xà",
  T_36_SY_P90_MAMBAS_N: "P90 - Phong Xà",
  T_36_SY_PARAFAL_MAMBAS_N: "PARAFAL - Phong Xà",
  T_36_SY_PP19_MAMBAS_N: "PP19 - Phong Xà",
  T_36_SY_PP19_POLICEMAN_N: "PP19 - Cảnh vệ ma thuật",
  T_36_SY_SCAR_MAMBAS_N: "SCAR - Phong Xà",
  T_36_SY_SKS_MAMBAS_N: "SKS - Phong Xà",
  T_36_SY_SPAS12_MAMBAS_N: "SPAS12 - Phong Xà",
  T_36_SY_SUPERHEAT_GUN_MAMBAS_N: "PLASMA - Phong Xà",
  T_36_SY_SVD_MAMBAS_N: "SVD - Phong Xà",
  T_36_SY_THOMPSON_MAMBAS_N: "Thompson - Phong Xà",
  T_36_SY_THROWINGKNIFE_MAMBAS_N: "Phi đao - Phong Xà",
  T_36_SY_THROWINGKNIFE_MENA_N: "Phi đao Thổ cẩm",
  T_36_SY_TREATMENTGUN_MAMBAS_N: "Súng lục điện - Phong Xà",
  T_36_SY_UMP45_MAMBAS_N: "UMP - Phong Xà",
  T_36_SY_USP45_MAMBAS_N: "USP - Phong Xà",
  T_36_SY_UZI_MAMBAS_N: "Mini Uzi - Phong Xà",
  T_36_SY_VECTOR_MAMBAS_N: "Vector - Phong Xà",
  T_36_SY_VEHICLE_MONSTER_TRUCK_BDK_N: "Xe thính - Vàng Kim Chói Lóa",
  T_36_SY_VEHICLE_MOTOBIKE_SUGARSKULL22_N: "Xe máy - Cơn Lốc Ma Mị",
  T_36_SY_VEHICLE_ROADSTER_BDK_N: "Xe thể thao - Vua Tốc Độ",
  T_36_SY_VEHICLE_TUTU_POLICEMAN_N: "Tuk Tuk - Cảnh Vệ Ma Thuật",
  T_36_SY_VSS_MAMBAS_N: "VSS - Phong Xà",
  T_36_SY_XM8_MAMBAS_N: "XM8 - Phong Xà",
  T_36_WZY_AFTERACCUMULATOR: "Sau khi tích lũy",
  T_36_WZY_AVAILAB: "Bật",
  T_36_WZY_BACKANDFORTH: "Khứ hồi",
  T_36_WZY_BASEMULTIPLIER: "Hệ số cơ bản",
  T_36_WZY_BASIC: "Loại cơ bản",
  T_36_WZY_BEFORACCUMULATOR: "Trước khi tích lũy",
  T_36_WZY_CYLIC: "Hai chiều",
  T_36_WZY_GUNPRO_PARAM1: "Sát thương cơ bản",
  T_36_WZY_GUNPRO_PARAM10: "Bắt đầu tăng độ giật",
  T_36_WZY_GUNPRO_PARAM11: "Khu vực lan tối đa",
  T_36_WZY_GUNPRO_PARAM12: "Sấy",
  T_36_WZY_GUNPRO_PARAM2: "Đạn trong băng đạn",
  T_36_WZY_GUNPRO_PARAM3: "Số băng đạn lúc đầu",
  T_36_WZY_GUNPRO_PARAM4: "Tốc độ bắn",
  T_36_WZY_GUNPRO_PARAM7: "Khoảng cách với sát thương tối đa",
  T_36_WZY_GUNPRO_PARAM8: "Khoảng cách với sát thương tối thiểu",
  T_36_WZY_GUNPRO_PARAM9: "Sát thương tối thiểu",
  T_36_WZY_MULTIPLIR: "Hệ số",
  T_36_WZY_PRICE: "Giá",
  T_36_WZY_SUMMULTIPLIER: "Hệ số tích lũy",
  T_36_WZY_WS_3DZOOM: "Thu phóng 3D",
  T_36_WZY_WS_ABSRES: "Giá trị kết quả tuyệt đối",
  T_36_WZY_WS_ADDALLELE_NAMEDESC: "Thêm tất cả các thành phần từ [Danh sách Nguồn] vào cuối [Danh sách mục tiêu]",
  T_36_WZY_WS_ADDALLELE_PARAM1_DESC: "Danh sách mục tiêu để thêm yếu tố",
  T_36_WZY_WS_ADDALLELE_PARAM2_DESC: "Dánh sách nguồn chứa các yếu tố cần thêm",
  T_36_WZY_WS_ADDCURR_NAMEDESC: "Thêm một đơn vị nhất định vào ví định trước",
  T_36_WZY_WS_ADDCURR_PARAM1_NAME: "Ví",
  T_36_WZY_WS_ADDCURR_PARAM1_NAMEDESC: "Ví để thêm đơn vị tiền tệ vào",
  T_36_WZY_WS_ADDSUB: "Cộng hoặc trừ giá trị",
  T_36_WZY_WS_AIENTITY: "Trí tuệ nhân tọa",
  T_36_WZY_WS_ALLSHOP_DESC: "Danh sách bao gồm các đơn vị cửa hàng",
  T_36_WZY_WS_ANGLE_DESC: "Giá trị của góc",
  T_36_WZY_WS_ANYTYPE: "Loại bất kỳ",
  T_36_WZY_WS_ARILEFT: "Giá trị bên trái biểu thức",
  T_36_WZY_WS_ARIRES: "Kết quả vận hành",
  T_36_WZY_WS_ARIRIGHT: "Giá trị bên phải biểu thức",
  T_36_WZY_WS_ARITHMETIC_NAME: "4 phép tính số học",
  T_36_WZY_WS_ARITHMETIC_NAMEDESC: "Biểu thức số nguyên cơ bản bao gồm: cộng, trừ, nhân, chia và chia lấy số dư. Biểu thức số thực bao gồm cộng, trừ, nhân, chia",
  T_36_WZY_WS_ARRAY_DESC: "Danh sách mục tiêu",
  T_36_WZY_WS_ARRCONELE_NAMEDESC: "Kiểm tra xem danh sách có bao gồm 1 yếu tố định trước. Giá trị trả về là Boolean",
  T_36_WZY_WS_ARRCONELE_PARAM1_DESC: "Danh sách định trước",
  T_36_WZY_WS_ARRCONELE_PARAM2_DESC: "Vật thể cần xem xét trong một danh sách",
  T_36_WZY_WS_ARRCONELERES: "Kết quả của việc tìm một vật thể chỉ định trong một danh sách. Giá trị thuộc loại Boolean",
  T_36_WZY_WS_ATTACK: "Tuần tra và Tấn công",
  T_36_WZY_WS_BEKNODOWN_NAMEDESC: "Kích hoạt khi người chơi bị hạ gục",
  T_36_WZY_WS_BIGFLOAT: "Số thập phân lớn",
  T_36_WZY_WS_BIGTOYBALL: "Xúc xắc",
  T_36_WZY_WS_BOOLLIST: "Danh sách Boolean",
  T_36_WZY_WS_CEIL_NAME_DESC: "Làm tròn giá trị tới giá trị số nguyên nhỏ nhất lớn hơn giá trị hiện tại.",
  T_36_WZY_WS_CEIL_PARAM1_NAMEDESC: "Giá trị làm tròn lên",
  T_36_WZY_WS_CEILRES: "Kết quả làm tròn lên",
  T_36_WZY_WS_CHASEENT_NAMEDESC: "AI được chọn sẽ truy đuổi đơn vị này bất kể khoảng cách. [Đơn vị bị truy đuổi] có thể là bất cứ đơn vị nào. Khi [Đơn vị bị truy đuổi] không có thuộc tính Máu, AI sẽ không gây sát thương nào.",
  T_36_WZY_WS_CHASEENT_PARAM1_NAMEDESC: "Đơn vị truy đuổi",
  T_36_WZY_WS_CHASEENT_PARAM2_NAMEDESC: "Đơn vị bị truy đuổi. Có thể là bất cứ đơn vị nào",
  T_36_WZY_WS_CLONEOBJ_PARAM1_DESC: "Mẫu để sao chép vật thể. Chọn bằng cách sử dụng trỏ chuột. Thuộc tính và mã vận hành của Bản sao sẽ giống với vật được chọn",
  T_36_WZY_WS_CLONEOBJ_PARAM2_DESC: "Đơn vị vật thể được sao chép",
  T_36_WZY_WS_CONDITION: "Điều kiện",
  T_36_WZY_WS_CONDITIONLIST: "Danh sách Điều kiện",
  T_36_WZY_WS_CONOFHUD: "Đơn vị giao diện HUD chứa nút điều khiển",
  T_36_WZY_WS_CONTROL_DESC: "Chỉ số duy nhất của nút điều khiển",
  T_36_WZY_WS_COS_NAMEDESC: "Tính Cos của một góc",
  T_36_WZY_WS_COSRES: "Cos của góc",
  T_36_WZY_WS_CREABLEOB: "Vật thể tạo được",
  T_36_WZY_WS_CREOBJ_NAMEDESC: "Tạo một đơn vị vật thể ở một vị trí được chỉ định. (Bản Test)",
  T_36_WZY_WS_CREOBJ_PARAM1_DESC: "Tọa độ của vật thể được tạo",
  T_36_WZY_WS_CREOBJ_PARAM2_DESC: "Loại vật thể được tạo",
  T_36_WZY_WS_CREOBJ_PARAM3_DESC: "Đơn vị mẫu của vật thể được tạo",
  T_36_WZY_WS_CREPROD_PARAM2_NAME: "Tiền tệ",
  T_36_WZY_WS_CREPROD_PARAM4_NAME: "Đơn vị vật phẩm",
  T_36_WZY_WS_CREPROD_PARAM4_NAMEDESC: "Tạo một đơn vị vật phẩm",
  T_36_WZY_WS_CREWALL_NAMEDESC: "Tạo một Ví. [Người chơi liên kết] là người chơi có thể thấy Ví này",
  T_36_WZY_WS_CREWALL_PARAM1_NAME: "Người chơi liên kết",
  T_36_WZY_WS_CREWALL_PARAM1_NAMEDESC: "Người chơi mà có thể thấy được Ví đã liên kết. Nếu không được cài đặt, Ví sẽ được hiển thị đến tất cả người chơi",
  T_36_WZY_WS_CREWALL_PARAM2_NAMEDESC: "Chủ sở hữu của Ví",
  T_36_WZY_WS_CREWALL_PARAM3_NAME: "Đơn vị Ví",
  T_36_WZY_WS_CREWALL_PARAM3_NAMEDESC: "Đã tạo một Ví",
  T_36_WZY_WS_CURRAMT: "Lượng tiền",
  T_36_WZY_WS_DATA_TYPE1: "Tham số được thêm vào",
  T_36_WZY_WS_DATA_TYPE2: "Tính toán cơ bản và logic",
  T_36_WZY_WS_DATA_TYPE3: "Điều chỉnh Danh sách",
  T_36_WZY_WS_DATA_TYPE4: "Tính toán Vector",
  T_36_WZY_WS_DESTITEM_NAME: "Phá hủy một trang bị",
  T_36_WZY_WS_DESTITEM_NAMEDESC: "Phá hủy một loại trang bị chỉ định của một người chơi chỉ định",
  T_36_WZY_WS_DESTITEM_PARAM1_NAMEDESC: "Vật phẩm có thể phá huỷ là súng, áo giáp và mũ.",
  T_36_WZY_WS_DESTITEM_PARAM2_NAMEDESC: "Chỉ số vị trí của loại trang bị được chọn. Chỉ số của vũ khí là [1,3] và Giáp và Nón là 1 theo mặc định",
  T_36_WZY_WS_DESTITEM_WHELOSTEQU: "Mất trang bị khi bị tiêu diệt",
  T_36_WZY_WS_DESTOBJ: "Phá hủy vật thể",
  T_36_WZY_WS_DIRPOINT: "Điểm định hướng",
  T_36_WZY_WS_DIRPOINTDESC: "Điểm chỉ hướng cần được tạo",
  T_36_WZY_WS_ELEFINDRES: "Chỉ số vị trí đầu tiên của yếu tố",
  T_36_WZY_WS_ELEFIRINDEX_NAMEDESC: "Nhận chỉ số của vị trí đầu tiên của một yếu tố trong một danh sách. Nếu không có yếu tố đó trong danh sách, kết quả sẽ trả về -1",
  T_36_WZY_WS_ELEFIRINDEX_PARAM2_DESC: "Các yếu tố cần tìm trong một danh sách",
  T_36_WZY_WS_ELELASINDEX_NAMEDESC: "Nhận chỉ số của vị trí cuối cùng của một yếu tố trong một danh sách. Nếu không có yếu tố đó trong danh sách, kết quả sẽ trả về -1",
  T_36_WZY_WS_ELELINDRES: "Chỉ số của yếu tố cuối cùng",
  T_36_WZY_WS_ELEMENTSNUM: "Thứ tự của yếu tố trong danh sách",
  T_36_WZY_WS_ENTCOLLIDE_NAMEDESC: "Kích hoạt khi [Triggering entity] chạm phải điểm kích hoạt này",
  T_36_WZY_WS_ENTCOLLIDE_PARAM1_NAMEDESC: "Đơn vị chạm phải điểm kích hoạt",
  T_36_WZY_WS_ENTDRIVEH_NAMEDESC: "Kích hoạt khi [Triggering entity] lái xe",
  T_36_WZY_WS_ENTDRIVEH_PARAM1_NAMEDESC: "Đơn vị đang lái xe",
  T_36_WZY_WS_ENTERTRI_NAMEDESC: "Kích hoạt khi người chơi tiến vào Bộ kích hoạt",
  T_36_WZY_WS_ENTERTRI_PARAM1_DESC: "Bộ kích hoạt để vào",
  T_36_WZY_WS_ENTGETOFFVEH_NAMEDESC: "Kích hoạt khi [Triggering entity] thoát khỏi xe",
  T_36_WZY_WS_ENTGETOFFVEH_PARAM1_NAMEDESC: "Đơn vị thoát khỏi xe",
  T_36_WZY_WS_ENTGETONVEH_NAMEDESC: "Kích hoạt khi [Triggering entity] vào xe",
  T_36_WZY_WS_ENTGETONVEH_PARAM1_NAMEDESC: "Đơn vị vào xe",
  T_36_WZY_WS_ENTITY_TYPE1: "Thường dùng",
  T_36_WZY_WS_ENTITY_TYPE2: "Thuộc tính",
  T_36_WZY_WS_ENTITY_TYPE3: "Vật thể và vật phẩm",
  T_36_WZY_WS_ENTITY_TYPE4: "AI",
  T_36_WZY_WS_ENTITY2_PARAM4_DESC: "Giá trị của yếu tố được thay đổi",
  T_36_WZY_WS_ENTITY7_PARAM1_DESC: "Người chơi mục tiêu",
  T_36_WZY_WS_ENTITYLIST: "Danh sách các đơn vị",
  T_36_WZY_WS_ENTKNOFLY_NAMEDESC: "Kích hoạt khi [Triggering entity] nhảy khỏi lốp xe",
  T_36_WZY_WS_ENTKNOFLY_PARAM1_NAMEDESC: "Đơn vị nhảy khỏi lốp xe",
  T_36_WZY_WS_ENTTP_NAMEDESC: "Kích hoạt khi [Triggering entity] vào cổng và được dịch chuyển",
  T_36_WZY_WS_ENTTP_PARAM1_NAMEDESC: "Đơn vị đã được dịch chuyển",
  T_36_WZY_WS_EQUARMOR_PARAM2_DESC: "Loại giáp được trang bị, bao gồm áo giáp, mũ bảo hiểm và balo",
  T_36_WZY_WS_EQUWEAP_NAMEDESC: "Kích hoạt khi người chơi trang bị vũ khí thành công. [Trigger Player] là người chơi trang bị vũ khí thành công. [Weapon entity] là vũ khí mà người chơi trang bị.",
  T_36_WZY_WS_EQUWEAP_PARAM2_DESC: "Đơn vị vũ khí được trang bị",
  T_36_WZY_WS_EQUWEAP_PARAM2_NAME: "Loại vũ khí",
  T_36_WZY_WS_EULERANGLE: "Góc Euler",
  T_36_WZY_WS_FACECAMERA: "Luôn hướng về máy quay",
  T_36_WZY_WS_FLOATLIST: "Danh sách số thực",
  T_36_WZY_WS_FLOOR_NAME_DESC: "Làm tròn xuống một giá trị đến số nguyên lớn nhất nhỏ hơn nó",
  T_36_WZY_WS_FLOOR_PARAM1_NAMEDESC: "Giá trị để làm tròn xuống",
  T_36_WZY_WS_FLOORRES: "Kết quả làm tròn xuống",
  T_36_WZY_WS_FORMUENT: "Đon vị thuộc tính có thể định dạng",
  T_36_WZY_WS_FORMUFACT: "Loại yếu tố định dạng thuộc tính",
  T_36_WZY_WS_GAME_TYPE2: "Lối chơi",
  T_36_WZY_WS_GAME_TYPE3: "Hiệu ứng đặc biệt",
  T_36_WZY_WS_GENENT_NAMEDESC: "Kích hoạt khi máy tạo ra một đơn vị. [Unit entity] là danh sách của những đơn vị được tạo bởi máy. [# of waves] là số lần tạo của máy",
  T_36_WZY_WS_GENENT_PARAM1_NAME: "Đơn vị",
  T_36_WZY_WS_GENENT_PARAM1_NAMEDESC: "Danh sách bao gồm các đơn vị được tạo bởi máy tạo đơn vị",
  T_36_WZY_WS_GENENT_PARAM2_NAMEDESC: "Số lần tạo các đơn vị của máy tạo vật phẩm",
  T_36_WZY_WS_GETALLSHOP_NAMEDESC: "Nhận tất cả cửa hàng trong trận đấu. Giá trị trả lại là một danh sách gồm các đơn vị cửa hàng",
  T_36_WZY_WS_GETCOLOR_NAMEDESC: "Sử dung RGB để nhận một màu",
  T_36_WZY_WS_GETCURRAMT_NAMEDESC: "Nhận một lượng nhất định vào một Ví nhất định",
  T_36_WZY_WS_GETCURRAMT_PARAM1_NAMEDESC: "Ví nhận được tiền",
  T_36_WZY_WS_GETCURRAMT_PARAM2_NAMEDESC: "Loại tiền tệ của lượng tiền được nhận",
  T_36_WZY_WS_GETENTTYPE_NAMEDESC: "Nhận loại đơn vị của đơn vị chỉ định",
  T_36_WZY_WS_GETENTTYPE_PARAM1_DESC: "Đơn vị cần nhận thông tin loại",
  T_36_WZY_WS_GETENTTYPERES: "Loại đơn vị của đơn vị chỉ định",
  T_36_WZY_WS_GETFOR_NAME: "Nhận tọa độ định hướng",
  T_36_WZY_WS_GETFOR_NAMEDESC: "Nhận véc-tơ của điểm định hướng được chỉ định",
  T_36_WZY_WS_GETFORRES: "Véc-tơ của điểm định hướng",
  T_36_WZY_WS_GETMONEYENT_NAMEDESC: "Nhận đơn vị tiền tệ của một loại tiền tệ nhất định trong ví",
  T_36_WZY_WS_GETMONEYENT_PARAM1_DESC: "Ví chứa đơn vị tiền tệ",
  T_36_WZY_WS_GETPOS_NAME: "Nhận tọa độ",
  T_36_WZY_WS_GETPOS_NAMEDESC: "Nhận tọa độ của một điểm định hướng",
  T_36_WZY_WS_GETPOS_PARAM1_DESC: "Điểm định hướng được chỉ định",
  T_36_WZY_WS_GETPROP_PARAM2_NAME: "Loại vật phẩm",
  T_36_WZY_WS_GETWALLET_NAME: "Nhận Ví",
  T_36_WZY_WS_GETWALLET_NAMEDESC: "Nhận Ví của người sở hữu được chọn",
  T_36_WZY_WS_GETWALLET_PARAM2_NAMEDESC: "Có tồn tại ví liên kết",
  T_36_WZY_WS_GETWALLETRES: "Chủ của đơn vị ví",
  T_36_WZY_WS_HUDCONTROL_DESC: "Đơn vị kiểm soát của một giao diện HUD",
  T_36_WZY_WS_HUDTYPE: "Loại giao diện HUD",
  T_36_WZY_WS_INCIDENT_TYPE1: "Sự kiện Global",
  T_36_WZY_WS_INCIDENT_TYPE2: "Đơn vị sự kiện",
  T_36_WZY_WS_INDEX_DESC: "Giá trị chỉ số của một danh sách",
  T_36_WZY_WS_INTLIST: "Danh sách số nguyên",
  T_36_WZY_WS_JENTSUBCL_NAMEDESC: "Kiểm tra xem một loại đơn vị có thuộc một danh mục con nhất định hay không. Kết quả trả về là Boolean.",
  T_36_WZY_WS_JENTSUBCL_PARAM2_NAMESESC: "Danh mục chính để kiểm tra đơn vị có thuộc về hay không",
  T_36_WZY_WS_JENTSUBCLRES: "Kết quả của kiểm tra loại thuộc về",
  T_36_WZY_WS_JENTTYPE_NAMEDESC: "Kiểm tra xem liệu một đơn vị có thuộc về một loại đơn vị nhất định. Kết quả trả lại là Boolean",
  T_36_WZY_WS_JENTTYPE_PARAM1_NAMEDESC: "Đơn vị cần kiểm tra",
  T_36_WZY_WS_JENTTYPE_PARAM2_NAMEDESC: "Nghĩa là nó bằng với loại đơn vị",
  T_36_WZY_WS_JENTTYPERES: "Kết quả của kiểm tra đơn vị",
  T_36_WZY_WS_JUSTPATROL: "Chỉ dành cho cảnh vệ",
  T_36_WZY_WS_LEAVETRI_NAMEDESC: "Kích hoạt khi người chơi thoát khỏi Bộ kích hoạt",
  T_36_WZY_WS_LEAVETRI_PARAM1_DESC: "Bộ kích hoạt để thoát",
  T_36_WZY_WS_LEVELOBLIST: "Danh sách vật thể",
  T_36_WZY_WS_LEVOBJSLIST: "Danh sách tất cả các vật thể bản đồ trong trận này",
  T_36_WZY_WS_LEVOBTYPE: "Loại vật thể",
  T_36_WZY_WS_LISTT: "Danh sách bất kỳ",
  T_36_WZY_WS_LOGCONTEXT_DESC: "Nội dung được xuất ra màn hình",
  T_36_WZY_WS_LOGIC2_PARAM1_NAMEDESC: "Chuỗi ký tự bên trái trong lệnh Kết nối",
  T_36_WZY_WS_LOGIC2_PARAM3_NAMEDESC: "Chuỗi ký tự bên phải trong lệnh Kết nối",
  T_36_WZY_WS_LOGIC5_PARAM1_NAMEDESC: "Giá cần yếu tố được thêm vào",
  T_36_WZY_WS_LOGOPER: "Thực hiện phép tính logic (Và/hoặc): nếu sử dung Và và cả hai Boolean được nhập vào là Đúng, kết quả sẽ là đúng, nếu sử dung Hoặc và ít nhất một trong 2 Boolean là đúng thì kết quả là đúng",
  T_36_WZY_WS_LOOTPOINT: "Điểm nhặt đồ",
  T_36_WZY_WS_MAINWEAP: "Vũ khí hiện tại",
  T_36_WZY_WS_MAX_DESC: "Chặn trên của một số nguyên được tạo",
  T_36_WZY_WS_MIN_DESC: "Chặn dưới của số nguyên được tạo",
  T_36_WZY_WS_MODGUNPRO_PARAM1_NAME: "Đơn vị vũ khí",
  T_36_WZY_WS_MONENT: "Đơn vị tiền tệ",
  T_36_WZY_WS_MONTYPE: "Loại tiền tệ",
  T_36_WZY_WS_MOVETO_NAMEDESC: "Điều khiển AI di chuyển đến điểm chỉ định. Sử dung [Return or not] để quyết định liệu AI có quay trở về vị trí bắt đầu hay không. Sử dung [Attack or not] để quyết định AI có truy tìm kẻ địch trên đường đi hay không.",
  T_36_WZY_WS_MOVETO_PARAM1_NAMEDESC: "Đơn vị AI sẽ di chuyển",
  T_36_WZY_WS_MOVETO_PARAM2_NAMEDESC: "Điểm đến",
  T_36_WZY_WS_MOVETO_PARAM3_NAMEDESC: "Sử dụng để cài đặt di chuyển của AI, có trở về điểm bắt đầu sau khi đến điểm kết thúc hay không. ĐÚNG là có trở về, SAI là không trở về",
  T_36_WZY_WS_MOVETO_PARAM4_NAME: "Tấn công hoặc không",
  T_36_WZY_WS_MOVETO_PARAM4_NAMEDESC: "Dùng để cài đặt logic tấn công kẻ địch gần kề trên đường đi của AI. ĐÚNG nghĩa là tìm kiếm kẻ địch, SAI có nghĩa là không tìm kiếm kẻ địch",
  T_36_WZY_WS_MULVALUE: "Phép nhân cơ số",
  T_36_WZY_WS_MULVEC: "Nhân cơ số Véc-tơ",
  T_36_WZY_WS_NEGRES: "Giá trị kết quả âm",
  T_36_WZY_WS_NEUTRAL: "Trung lập",
  T_36_WZY_WS_NEXTVAWE_NAMEDESC: "Bắt buộc máy tạo đơn vị được chỉ định tạo đợt tiếp theo. Máy tạo đơn vị bao gồm Máy tạo Zombie và Máy tạo trang bị",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAME: "Đơn vị máy tạo",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAMEDESC: "Đơn vị máy được chỉ định, như máy tạo Zombie, máy tạo trang bị",
  T_36_WZY_WS_OBJENT: "Đơn vị vật thể",
  T_36_WZY_WS_OBTITEM_NAMEDESC: "Kích hoạt khi một trang bị được nhặt. [Loại trang bị] là loại của trang bị đã nhận được",
  T_36_WZY_WS_OBTWEAP_NAMEDESC: "Kích hoạt khi một vũ khí được nhận. [Weapon entity] là vũ khí đã nhận",
  T_36_WZY_WS_ONEWAY: "1 chiều",
  T_36_WZY_WS_OPENSTATE: "Trạng thái",
  T_36_WZY_WS_OPERMETHOD_NAME: "Vận hành",
  T_36_WZY_WS_OPERMETHOD_NAMEDESC: "Các phép tính số học cơ bản. Hiện tại, phép tính số nguyên bao gồm cộng, trừ, nhân, chia và chia lấy phần dư, và phép tính số thực bao gồm cộng, trừ, nhân và chia",
  T_36_WZY_WS_OWNERENT_DESC: "Đơn vị có ví để nhận",
  T_36_WZY_WS_PERCENTAGE: "Điều chỉnh phần trăm",
  T_36_WZY_WS_PLACOLLIDE_NAME: "Khi người chơi chạm phải điểm kích hoạt",
  T_36_WZY_WS_PLACOLLIDE_NAMEDESC: "Kích hoạt khi [Trigger player] chạm phải điểm kích hoạt",
  T_36_WZY_WS_PLACOLLIDE_PARAM1_NAMEDESC: "Người chơi chạm phải điểm kích hoạt",
  T_36_WZY_WS_PLACOLLIDE_PARAM2_NAMEDESC: "Đơn vị vật thể mà người chơi chạm phải",
  T_36_WZY_WS_PLADRIVEH_NAME: "Khi người chơi sử dụng phương tiện",
  T_36_WZY_WS_PLADRIVEH_NAMEDESC: "Kích hoạt khí [Trigger player] lái xe",
  T_36_WZY_WS_PLADRIVEH_PARAM1_NAMEDESC: "Người chơi lái xe",
  T_36_WZY_WS_PLADRIVEH_PARAM2_NAMEDESC: "Đơn vị xe mà người chơi đang lái",
  T_36_WZY_WS_PLAGETOFFVEH_NAME: "Khi người chơi thoát phương tiện",
  T_36_WZY_WS_PLAGETOFFVEH_NAMEDESC: "Kích hoạt khi [Trigger player] thoát khỏi xe",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM1_NAMEDESC: "Người chơi thoát khỏi xe",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM2_NAMEDESC: "Xe mà người chơi thoát khỏi",
  T_36_WZY_WS_PLAGETONVEH_NAME: "Khi người chơi vào phương tiện",
  T_36_WZY_WS_PLAGETONVEH_NAMEDESC: "Kích hoạt khi [Trigger player] vào xe",
  T_36_WZY_WS_PLAGETONVEH_PARAM2_NAMEDESC: "Đơn vị phương tiện mà người chơi vào",
  T_36_WZY_WS_PLAKNOFLY_NAME: "Khi người chơi nhảy lên lốp xe",
  T_36_WZY_WS_PLAKNOFLY_NAMEDESC: "Kích hoạt khi [Trigger player] nhảy khỏi lốp xe",
  T_36_WZY_WS_PLAKNOFLY_PARAM1_NAMEDESC: "Khi người chơi nhảy khỏi lốp xe",
  T_36_WZY_WS_PLAKNOFLY_PARAM2_NAMEDESC: "Đơn vị vật thể mà người chơi nhảy khỏi",
  T_36_WZY_WS_PLATP_NAME: "Sau khi người chơi được dịch chuyển",
  T_36_WZY_WS_PLATP_PARAM1_NAMEDESC: "Người chơi sử dụng cổng dịch chuyển",
  T_36_WZY_WS_PLATP_PARAM2_NAMEDESC: "Đơn vị cổng mà người chơi sử dụng",
  T_36_WZY_WS_PLAYERLIST_DESC: "Danh sách tất cả người chơi trong trận",
  T_36_WZY_WS_POINTPICKER: "Trục đường",
  T_36_WZY_WS_PORTALENT: "Đơn vị cổng",
  T_36_WZY_WS_PREFAB: "Mẫu",
  T_36_WZY_WS_PRODLIST: "Danh sách vật phẩm",
  T_36_WZY_WS_PRODSORT_PARAM3_NAME: "Thứ tự sắp xếp",
  T_36_WZY_WS_PROPMOD: "Phương pháp thay đổi thuộc tính",
  T_36_WZY_WS_RANKABLEE: "Đơn vị có thể được xếp hạng",
  T_36_WZY_WS_REDCURR_NAMEDESC: "Tiêu thụ một lượng tiền",
  T_36_WZY_WS_REDCURR_PARAM1_NAMEDESC: "Ví chứa loại tiền được tiêu thụ",
  T_36_WZY_WS_REDCURR_PARAM2_NAMEDESC: "Loại tiền được tiêu thụ",
  T_36_WZY_WS_REDCURR_PARAM3_NAMEDESC: "Số tiền tiêu thụ",
  T_36_WZY_WS_RNDFRES: "Số thực được tạo ngẫu nhiên",
  T_36_WZY_WS_RNDIRES: "Kết quả tạo số nguyên ngẫu nhiên",
  T_36_WZY_WS_ROUND_NAME_DESC: "Làm tròn giá trị tới số nguyên gần nhất",
  T_36_WZY_WS_ROUND_PARAM1_NAMEDESC: "Giá trị để làm tròn",
  T_36_WZY_WS_ROUNDRES: "Kết quả làm tròn",
  T_36_WZY_WS_RUNAI_NAMEDESC: "Sơ đồ hành vi mà AI được chọn sẽ thực hiện",
  T_36_WZY_WS_RUNAI_PARAM1_NAMEDESC: "Đơn vị dừng/chạy một sơ đồ hành vi",
  T_36_WZY_WS_SCOREABLEE: "Đơn vị có thể nhận điểm",
  T_36_WZY_WS_SCORECHANGE_NAMEDESC: "Kích hoạt khi điểm thay đổi. [Loại điểm] là loại của của số điểm được thay đổi. [Điểm] là điểm mới",
  T_36_WZY_WS_SETDIRPOINT_NAME: "Tạo điểm định hướng",
  T_36_WZY_WS_SETDIRPOINT_NAMESESC: "Nhận một điểm định hướng mới. Sử dụng [Location] để quy định tọa độ và [Direction] để quy định véc-tơ định hướng.",
  T_36_WZY_WS_SETDIRPOINT_PARAM1_NAMEDESC: "Tọa độ của một điểm định hướng",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAME: "Phương hướng",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAMEDESC: "Véc-tơ của một điểm chỉ hướng",
  T_36_WZY_WS_SETPATH_NAMEDESC: "Đơn vị AI sẽ di chuyển dựa trên thứ tự được thiết lập ở đây. Những loại di chuyển bao gồm chu kỳ, một chiều, và",
  T_36_WZY_WS_SETPATH_PARAM2_NAMEDESC: "Danh sách chưa các điểm mà AI phải đi qua",
  T_36_WZY_WS_SETPATH_PARAM3_NAME: "Loại di chuyển",
  T_36_WZY_WS_SETPATH_PARAM3_NAMEDESC: "Đây là các loại hình di chuyển. Một chiều là để AI ngừng di chuyển khi nó đến đích. Vòng lại là để AI tìm kiếm đường quay lại khi nó đến đích. Hai chiều dành cho AI là việc quay trở lại vị trí ban đầu theo thứ tự ngược lại của đường đi.",
  T_36_WZY_WS_SHOPECON: "Cửa hàng và kinh tế",
  T_36_WZY_WS_SHOWFLO_NAMEDESC: "Sử dụng để hiển thị một thông báo nổi trên màn hình. Thiết lập nội dung bằng [Text], màu chữ bằng [Color], và thời gian hiển thị bằng [Duration] (đơn vị thời gian là 0.001 giây",
  T_36_WZY_WS_SHOWFLO_PARAM1_DESC: "Nội dung của thông báo nổi",
  T_36_WZY_WS_SHOWFLO_PARAM2_DESC: "Màu của thông báo nổi",
  T_36_WZY_WS_SHOWFLO_PARAM3_DESC: "Thời gian hiển thị của thông báo nổi, tính bằng 0.001 giây",
  T_36_WZY_WS_SIN_NAMEDESC: "Tìm sin của một góc",
  T_36_WZY_WS_SINRES: "Sin của góc",
  T_36_WZY_WS_SKIPKNODOWN: "Có tiêu diệt khi hạ gục hay không",
  T_36_WZY_WS_SQRTRES: "Kết quả bình phương",
  T_36_WZY_WS_STRCONRES: "Kết quả của liên kết chuỗi ký tự",
  T_36_WZY_WS_STRINGLIST: "Danh sách Chuỗi ký tự",
  T_36_WZY_WS_STRLEN: "Độ dài chuỗi ký tự",
  T_36_WZY_WS_STRVAL: "Chuỗi ký tự nhận được",
  T_36_WZY_WS_TAN_NAMEDESC: "Tìm tan của góc",
  T_36_WZY_WS_TANRES: "Tan của góc",
  T_36_WZY_WS_TEAMLIST: "Danh sách đội",
  T_36_WZY_WS_TEAMLIST_DESC: "Danh sách tất cả các đội trong trận",
  T_36_WZY_WS_TIMETWEENTIPS: "Đơn vị thông báo đếm ngược",
  T_36_WZY_WS_TOSTRING_NAMEDESC: "Chuyển đổi giá trị thành chuỗi ký tự",
  T_36_WZY_WS_TOSTRING_PARAM1_DESC: "Giá trị để được chuyển đổi thành chuỗi ký tự",
  T_36_WZY_WS_TOSTRINGRES: "Kết quả chuyển đổi chuỗi ký tự",
  T_36_WZY_WS_TOWERCAMP_DESC: "Số hiệu của phe và đội là như nhau. Pháo đài và tháp sẽ tấn công tất cả người chơi và AI trong tầm bắn",
  T_36_WZY_WS_TRACURR_NAMEDESC: "Chuyển một số tiền của một loại tiền tệ nhất định từ Ví này sang Ví khác",
  T_36_WZY_WS_TRACURR_PARAM1_NAMEDESC: "Ví mà số tiền trong đó được chuyển đi",
  T_36_WZY_WS_TRACURR_PARAM2_NAMEDESC: "Loại tiền tệ của giao dịch",
  T_36_WZY_WS_TRACURR_PARAM3_NAMEDESC: "Số tiền trong giao dịch",
  T_36_WZY_WS_TRACURR_PARAM4_NAMEDESC: "Ví nhận được số tiền đã được chuyển",
  T_36_WZY_WS_TWEENTIPS: "Đơn vị thông báo nổi",
  T_36_WZY_WS_TYPEENUM: "Loại Enum",
  T_36_WZY_WS_USEPROP_NAMEDESC: "Kích hoạt khi người chơi sử dụng một vật phẩm. [Trigger Player] là người chơi sử dụng một vật phẩm. [Item type] là vật phẩm mà người chơi đã sử dụng.",
  T_36_WZY_WS_USEPROP_PARAM2_DESC: "Loại vật phẩm được sử dụng bởi người chơi",
  T_36_WZY_WS_VECADDLEFT: "Giá trị bên trái của Cộng Véc-tơ",
  T_36_WZY_WS_VECADDRES: "Kết quả cộng vector",
  T_36_WZY_WS_VECADDRIGHT: "Giá trị bên phải của Cộng Véc-tơ",
  T_36_WZY_WS_VECANGLEFT: "Giá trị bên trái của Góc giữa Véc-tơ",
  T_36_WZY_WS_VECANGRES: "Góc giữa 2 vector",
  T_36_WZY_WS_VECANGRIGHT: "Giá trị bên phải của Góc giữa Véc-tơ",
  T_36_WZY_WS_VECCROLEFT: "Giá trị bên trái của Tích có hướng",
  T_36_WZY_WS_VECCRORES: "Kết quả Tích có hướng",
  T_36_WZY_WS_VECCRORIGHT: "Giá trị bên phải của Tích có hướng",
  T_36_WZY_WS_VECDISLEFT: "Giá trị bên trái của khoảng cách 2 véc-tơ",
  T_36_WZY_WS_VECDISRES: "Khoảng cách giữa hai vector",
  T_36_WZY_WS_VECDISRIGHT: "Giá trị bên phải của",
  T_36_WZY_WS_VECDOCLEFT: "Giá trị bên trái của Tích vô hướng",
  T_36_WZY_WS_VECDOCRES: "Kết quả của Tích vô hướng",
  T_36_WZY_WS_VECDOCRIGHT: "Giá trị bên phải của Tích vô hướng",
  T_36_WZY_WS_VECMULRES: "Kết quả của phép nhân cơ số",
  T_36_WZY_WS_VECNORRES: "Vector chuẩn hoá",
  T_36_WZY_WS_VECSIZERES: "Độ lớn của một Véc-tơ",
  T_36_WZY_WS_VECSUBLEFT: "Giá trị bên trái của phép trừ Véc-tơ",
  T_36_WZY_WS_VECSUBRES: "Kết quả phép trừ vector",
  T_36_WZY_WS_VECSUBRIGHT: "Giá trị bên phải của phép Trừ Véc-tơ",
  T_36_WZY_WS_VECTORLIST: "Danh sách Vector",
  T_36_WZY_WS_VECX: "trục x",
  T_36_WZY_WS_VECY: "trục y",
  T_36_WZY_WS_VECZ: "trục z",
  T_36_WZY_WS_VEHENT: "Đơn vị phương tiện",
  T_36_WZY_WS_WALLCONT: "Nội dung Ví",
  T_36_WZY_WS_ZOMBIESPERWAVE: "Liên tục",
  T_36_XYL_WS_AIBOT: "Đơn vị",
  T_36_XYL_WS_AIGENERATOR: "Máy tạo đơn vị",
  T_36_XYL_WS_AIGENERATOR_DESC: "Một máy đơn vị có thể tạo liên tục các vật thể được chỉ định (ví dụ: zombies)",
  T_36_XYL_WS_AIWAVE: "Số lượng đơn vị mỗi đợt",
  T_36_XYL_WS_ARROW: "Dấu chỉ hướng",
  T_36_XYL_WS_ARROW_DESC: "Một biển báo chỉ đến 1 hướng",
  T_36_XYL_WS_BREAKBOX: "Hộp có thể phá huỷ",
  T_36_XYL_WS_BREAKBOX_DESC: "Hộp gỗ, có thể bị tấn công hoặc phá huỷ",
  T_36_XYL_WS_FENCE: "Hàng rào sắt",
  T_36_XYL_WS_FENCE_DESC: "Hàng rào cho phép đạn xuyên qua",
  T_36_XYL_WS_STAIRI: "Bậc thang C",
  T_36_XYL_WS_STAIRI_DESC: "Nền để có thể kết hợp với cầu thang",
  T_36_XYL_WS_ZOMBIEAI: "Zombie",
  T_36_XYL_WS_ZOMBIEAI_DESC: "Một zombie có thể được điều chỉnh và được nhân bản trong Máy tạo đơn vị",
  T_36_YF_CORRODE_GRENADE_N: "Lựu ăn mòn",
  T_36_YF_SETTING_TYPE3: "Cấu hình đặt trước 3",
  T_36_YS_B_BRFOOTBALL_BLUE01: "Quần Đội tuyển Brazil (lam)",
  T_36_YS_B_BRFOOTBALL_YELLOW01: "Quần Đội tuyển Brazil (Vàng)",
  T_36_YS_F_A_GHOSTHUNTER: "Mặt nạ Miêu Nữ kẹo đường",
  T_36_YS_F_B_GHOSTHUNTER: "Quần Miêu Nữ kẹo đường",
  T_36_YS_F_H_GHOSTHUNTER: "Đầu Miêu Nữ kẹo đường",
  T_36_YS_F_S_GHOSTHUNTER: "Giày Miêu Nữ kẹo đường",
  T_36_YS_SETTING_GRENADE: "Lựu ném",
  T_36_YS_SETTING_MOVE: "Di chuyển",
  T_36_YS_T_BRFOOTBALL_BLUE01: "Áo Đội tuyển Brazil (lam)",
  T_36_YS_T_BRFOOTBALL_YELLOW01: "Áo Đội tuyển Brazil (Vàng)",
  T_36_YZY_CHARACTER_GANGGIRL_N: "Luna",
  T_36_YZY_CHARACTER_YAKUZA_N: "Tatsuya",
  T_36_YZY_PET_WOLF_N: "Fang",
  T_36_YZY_PETSKIN_AXOLOTL_GRIZA_N: "Skin trợ thủ: Rồng Mộng Mơ",
  T_36_YZY_PETSKIN_HAWK_BDK_N: "Skin trợ thủ: Đại Bàng Sấm Sét",
  T_36_YZY_PETSKIN_WOLF_FIRE_N: "Skin trợ thủ: Sói Đan Huyết",
  T_36_YZY_PETSKIN_WOLF_SUGARSKULL22_N: "Skin trợ thủ: Sói Quỷ Dữ",
  T_36_YZY_PETSKIN_WOLF_WINTER_N: "Skin trợ thủ: Sói Băng Giá",
  T_37_B_WS_HIDE: "Trốn tìm",
  T_37_HZ_WS_CATMODEDESC1: "Trốn Tìm",
  T_37_JH_WS_CREATEGOLD_DESC: "Máy bán hàng mà người chơi có thể mua vật phẩm (không khả dụng trong tử chiến, liên hoàn chiến, tiệc tùng và nạn dịch Zombie)",
  T_37_JH_WS_NAME1: "Phi đao (Thời khắc tận thế)",
  T_37_JH_WS_NAME10: "M1887-X (Thời Khắc Tận Thế)",
  T_37_JH_WS_NAME11: "SPAS12 (Thời Khắc Tận Thế)",
  T_37_JH_WS_NAME12: "M1014 (Thời Khắc Tận Thế)",
  T_37_JH_WS_NAME13: "MP40 (Thời Khắc Tận Thế)",
  T_37_JH_WS_NAME14: "MP5-III (Thời Khắc Tận Thế)",
  T_37_JH_WS_NAME15: "P90 (Thời Khắc Tận Thế)",
  T_37_JH_WS_NAME16: "M60-III (Thời Khắc Tận Thế)",
  T_37_JH_WS_NAME17: "Thompson (Thời Khắc Tận Thế)",
  T_37_JH_WS_NAME18: "UMP (Thời Khắc Tận Thế)",
  T_37_JH_WS_NAME19: "SVD (Thời Khắc Tận Thế)",
  T_37_JH_WS_NAME2: "GROZA (Thời Khắc Tận Thế)",
  T_37_JH_WS_NAME20: "AWM (Thời Khắc Tận Thế)",
  T_37_JH_WS_NAME21: "M82B (Thời Khắc Tận Thế)",
  T_37_JH_WS_NAME22: "M249-X (Thời Khắc Tận Thế)",
  T_37_JH_WS_NAME23: "Kar98k-III (Thời Khắc Tận Thế)",
  T_37_JH_WS_NAME3: "AK47 (Thời Khắc Tận Thế)",
  T_37_JH_WS_NAME4: "M4A1-III (Thời Khắc Tận Thế)",
  T_37_JH_WS_NAME5: "SCAR (Thời Khắc Tận Thế)",
  T_37_JH_WS_NAME6: "M14-III (Thời Khắc Tận Thế)",
  T_37_JH_WS_NAME7: "PARAFAL (Thời Khắc Tận Thế)",
  T_37_JH_WS_NAME8: "XM8 (Thời Khắc Tận Thế)",
  T_37_JH_WS_NAME9: "MAG-7 (Thời Khắc Tận Thế)",
  T_37_JH_WS_VENDMACHINE_DESC: "Vàng có thể được nhặt trong bản đồ (không khả dụng trong tử chiến, liên hoàn chiến, nạn dịch zombie và tiệc tùng)",
  T_37_JH_WS_X: "Trục X",
  T_37_JH_WS_Y: "Trục Y",
  T_37_JH_WS_Z: "Trục Z",
  T_37_JL_FOOTBALL_TIE: "Hoà",
  T_37_JL_GOLD_M1014_I_N: "M1014-I",
  T_37_JL_GOLD_M1014_II_N: "M1014-II",
  T_37_JL_GOLD_M1014_III_N: "M1014-III",
  T_37_JL_M1216_N: "Trogon",
  T_37_KK_WS_SNOWMAN: "Waggor người tuyết",
  T_37_LC_BP_ENTRANCE_GIFT: "Quà!",
  T_37_M_WS_MISSING: "Thiếu nguồn",
  T_37_M_WS_NAMEERROR: "Chứa các ký tự nhạy cảm. Hãy thay đổi.",
  T_37_PD_HuntingGround_BOSSTITLE: "Đồ tể",
  T_37_QL_JUMPPAD_DES: "Tạo một đệm nhảy trên mặt đất. Nó được sử dụng để nhảy lên cao và cho phép bắn trên không trung.",
  T_37_QL_JUMPPAD_NAME: "Đệm nhảy",
  T_37_R_TAILOR_LIMIT: "Giới hạn",
  T_37_RW_LOADOUT_BORNFIRETAG: "Nhận 2 lửa trại mỗi khi bắt đầu trận. Lửa trại [FFBA00]Hồi phục 5 máu và 20 EP mỗi giây[-] (Lên đến 10s) cho bạn và đồng đội trong vùng ảnh hưởng. Lửa trại không cộng dồn.",
  T_37_RW_PROPCATAPULT_DESC: "Khi được đặt xuống, bệ phóng di động có thể giúp phóng người chơi vào không trung. Người hãy nhớ ở trong vùng an toàn",
  T_37_RW_PROPCATAPULT_NAME: "Bệ phóng di động",
  T_37_SP_WS_COLOR_02: "Màu",
  T_37_SP_WS_COLOR_03: "Giao diện",
  T_37_SP_WS_LOG_ENTITY_IS_EMPTY: "Đơn vị là null",
  T_37_SP_WS_LOG_PHASE_END: "Màn {0} đã kết thúc",
  T_37_SP_WS_LOG_PHASE_START: "Màn {0} bắt đầu",
  T_37_SP_WS_LOG_ROUND_END: "Vòng {0} đã kết thúc",
  T_37_SP_WS_LOG_ROUND_START: "Vòng {0} đã bắt đầu",
  T_37_SP_WS_LOG_VAR_ASSIGNMENT_OPERATOR_MISMATCH: "Sai loại dữ liệu khi khai báo dữ liệu cho môt biến. Loại hiện tại: {0}. Loại yêu cầu {1}",
  T_37_SP_WS_LOG_VAR_UNDEFINED_OR_OUT_OF_SCOPE: "Không thể xác định biến cục bộ {0}",
  T_37_SP_WS_MAPACCESS_08: "Sửa",
  T_37_SP_WS_RACEMODE_01: "Chế độ đếm giờ",
  T_37_SP_WS_RACEMODE_02: "Thời gian đếm ngược",
  T_37_SP_WS_RACEMODE_04: "Khi bật, sẽ có đồng hồ đếm ngược khi cả đội về đích. Trò chơi kết thúc khi kết thúc đếm ngược.",
  T_37_SY_AR15_KABUKI_N: "Chim Bói Cá - Tam Nương Hana",
  T_37_SY_BACKPACK_STRAW_N: "Balo Mũ Rơm",
  T_37_SY_GRENADE_FFWS2022_01_N: "Lựu đạn - Băng Long",
  T_37_SY_GROUPANIM_BLACKHOLE_N: "Hành Động Gia Nhập Tinh Vân",
  T_37_SY_M1216_MAMBAS_N: "Trogon - Phong Xà",
  T_37_SY_PET_FLYINGCREATURE_N: "Long Thần Arvon",
  T_37_SY_PETSKIN_DUCK_WINTERFEST22_N: "Skin Beanie Băng giá",
  T_37_SY_PETSKIN_FLYINGCREATURE_BLUE_N: "Skin Arvon Thạch Long",
  T_37_SY_PETSKIN_FLYINGCREATURE_ORANGE_N: "Skin Arvon Chiến Long",
  T_37_SY_PETSKIN_FLYINGCREATURE_PURPLE_N: "Skin Arvon Cuồng Long",
  T_37_SY_PETSKIN_TORTOISE_SOCCER22_N: "Skin Flash vua phá lưới",
  T_37_SY_PETSKIN_YETI_NEWYEAR22_N: "Skin Yeti Băng giá",
  T_37_SY_VEHICLE_JEEP_WINTERFEST22_N: "Xe Jeep - Cực Âm",
  T_37_SY_VEHICLE_SUV_FFWS2022_N: "Xe bán tải - Long Thần",
  T_37_WT_WS_PVE2DESC: `Chế độ sống sót, người chơi tiêu diệt số lượng zombie mục tiêu trong thời hạn giới hạn hoặc sống sót cho đến cuối cùng.
Bạn có thể tùy ý thiết lập quy chế chơi và điều chỉnh cài đặt zombie, bao gồm số lượng zombie cần phải diệt.`,
  T_37_WT_WS_RULEDESC: "Tiêu diệt số lượng zombie mục tiêu để giành chiến thắng.",
  T_37_WT_WS_RULETITLE: "Mục tiêu",
  T_37_WT_WS_TXT1: "Tiêu diệt zombie",
  T_37_WT_WS_TXT1DESC: "Khi bật, người chơi giành chiến thắng bằng cách tiêu diệt số lượng zombie được chỉ định. Khi tắt, người chơi chiến thắng bằng cách sống sót cho đến cuối cùng.",
  T_37_WT_WS_TXT2: "Mạng tiêu diệt",
  T_37_WZY_FRIDPLA: "Người chơi đồng minh",
  T_37_WZY_FRIDSIDE: "Phe đồng minh",
  T_37_WZY_FRIDTEAM: "Đội đồng minh",
  T_37_WZY_HOSTPLA: "Người chơi đối thủ",
  T_37_WZY_HOSTSIDE: "Phe đối thủ",
  T_37_WZY_WS_ACCFRAMES: "Khung hình tích lũy",
  T_37_WZY_WS_ADDITEMTOPROD_NAMEDESC: "Thêm các vật phẩm vào trang bị. Bạn có thể thêm một hoặc một nhóm vật phẩm. Số tiền có thể là số lượng các mục riêng lẻ hoặc một danh sách vật phẩm (bao gồm số tiền).",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM1_DESC: "Đơn vị trang bị được thêm vật phẩm",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM2_DESC: "Vật phẩm được thêm vào. Bạn có thể thêm vào một hoặc một nhóm vật phẩm",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM3_DESC: "Số lượng các vật phẩm riêng lẻ cần thêm hoặc một danh sách bao gồm các vật phẩm của số tiền này.",
  T_37_WZY_WS_ADDLABEL_NAMEDESC: "Chọn một thẻ cho một đơn vị",
  T_37_WZY_WS_ADDLABEL_PARAM1_DESC: "Đơn vị để thêm thẻ",
  T_37_WZY_WS_ADDLABEL_PARAM2_DESC: "Nội dung văn bản để thêm vào",
  T_37_WZY_WS_AIMABLEENT: "Đơn vị có thể bị ngắm bắn",
  T_37_WZY_WS_AIMASSISTTYPE: "Loại hỗ trợ ngắm",
  T_37_WZY_WS_ALLOWDROP_NAME: "Bật/Tắt thả vật phẩm",
  T_37_WZY_WS_ALLOWDROP_NAMEDESC: "Có cho phép người chơi thả vật phẩm",
  T_37_WZY_WS_ALLOWDROP_PARAM1_DESC: "Đơn vị người chơi để thiết lập cho phép thả vật phẩm",
  T_37_WZY_WS_ALLOWDROP_PARAM2_DESC: "Có cho phép người chơi thả vật phẩm hay không. Đây là giá trị Boolean.",
  T_37_WZY_WS_ALLOWPICKUP_NAME: "Bật/Tắt nhặt vật phẩm",
  T_37_WZY_WS_ALLOWPICKUP_NAMEDESC: "Có cho phép người chơi nhặt vật phẩm hay không",
  T_37_WZY_WS_ALLOWPICKUP_PARAM1_DESC: "Đơn vị người chơi để thiết lập cho phép nhặt vật phẩm",
  T_37_WZY_WS_ALLOWPICKUP_PARAM2_DESC: "Có cho phép người chơi nhặt vật phẩm hay không. Đây là giá trị Boolean",
  T_37_WZY_WS_AMBIENTCOLOR: "Màu ánh sáng xung quanh",
  T_37_WZY_WS_AMRORTOOL: "Sửa giáp",
  T_37_WZY_WS_ATTACK: "Tấn công",
  T_37_WZY_WS_BACKTONOR_NAMEDESC: "Bỏ ngụy trang của người chơi",
  T_37_WZY_WS_BACKTONOR_PARAM1_DESC: "Đơn vị người chơi bị hủy bỏ ngụy trang",
  T_37_WZY_WS_BALLADDV_NAMEDES: "Tăng tốc độ của một quả bóng",
  T_37_WZY_WS_BALLADDV_PARAM1_DESC: "Quả bóng được tăng tốc độ cho",
  T_37_WZY_WS_BALLADDV_PARAM2_DESC: "Vector tốc độ tăng",
  T_37_WZY_WS_BALLKICKED_NAMEDESC: "Kích hoạt khi bóng va chạm với Máy bắn bóng. [Player entity] là người chơi sở hữu máy bắn bóng. [Speed boost] là tốc độ của bóng sau khi va chạm",
  T_37_WZY_WS_BALLKICKED_PARAM1_DESC: "Người chơi sở hữu máy bắn bóng",
  T_37_WZY_WS_BALLKICKED_PARAM2_DESC: "Vectơ tốc độ của bóng sau khi va chạm",
  T_37_WZY_WS_BALLKNOCKED_NAMEDESC: "Kích hoạt khi bóng va chạm với một đơn vị và tốc độ của bóng được gia tăng. [Colliding entity] là đơn vị va chạm với bóng. [Speed boost] là tốc độ của bóng sau va chạm",
  T_37_WZY_WS_BALLKNOCKED_PARAM1_DESC: "Đơn vị va chạm với bóng",
  T_37_WZY_WS_BALLKNOCKED_PARAM2_DESC: "Vector tốc độ được thêm vào bóng khi va chạm",
  T_37_WZY_WS_BEAIMED_NAMEDESC: "Kích hoạt khi đơn vị bị ngắm bởi 1 người chơi",
  T_37_WZY_WS_BEAIMED_PARAM1_DESC: "Người chơi bị ngắm",
  T_37_WZY_WS_BEHAVIORSTAT: "Tình trạng hành vi của người chơi",
  T_37_WZY_WS_BEHIT_PARAM1_DESC: "Vũ khí dùng để tấn công",
  T_37_WZY_WS_BLOODBARENT: "Đơn vị thanh máu",
  T_37_WZY_WS_BOMBEND: "Trước khi nổ",
  T_37_WZY_WS_BOMBSTART: "Chỉ dẫn bomb",
  T_37_WZY_WS_CHANENT: "Đơn vị kênh",
  T_37_WZY_WS_CHEER: "Ăn mừng",
  T_37_WZY_WS_CHELABEL_NAMEDESC: "Kiểm tra đơn vị được chọn",
  T_37_WZY_WS_CHELABEL_PARAM1_DESC: "Đơn vị cần kiểm tra chứa thẻ",
  T_37_WZY_WS_CHELABEL_PARAM2_DESC: "Thẻ cần kiểm tra",
  T_37_WZY_WS_CHELABELRES: "Kết quả của kiểm tra thẻ. Đây là một giá trị Boolean",
  T_37_WZY_WS_CJERSEY_NAME: "Đổi áo bóng đá",
  T_37_WZY_WS_CJERSEY_PARAM1_DESC: "Người chơi cần thay đổi áo bóng đá",
  T_37_WZY_WS_CJERSEY_PARAM2: "Thiết kế áo bóng đá",
  T_37_WZY_WS_CJERSEY_PARAM2_DESC: "Thiết kế được thay đổi thành",
  T_37_WZY_WS_CJERSEY_PARAM3_DESC: "Màu của phần 1 của áo bóng đá",
  T_37_WZY_WS_CJERSEY_PARAM4_DESC: "Màu của phần 2 của áo bóng đá",
  T_37_WZY_WS_CJERSEY_PARAM5_DESC: "Màu của phần 3 của áo bóng đá",
  T_37_WZY_WS_CJERSEYTYPE1: "Thiết kế 1",
  T_37_WZY_WS_CJERSEYTYPE2: "Thiết kế 2",
  T_37_WZY_WS_CJERSEYTYPE3: "Thiết kế 3",
  T_37_WZY_WS_CLEAR_ARR_DESC: "Xóa tất cả thành phần trong một danh sách",
  T_37_WZY_WS_CREABLEOB_DESC: "Loại vật thể được dùng để tạo khối",
  T_37_WZY_WS_CREPROD_NAMEDESC: "Tạo một trang bị có thể tùy chỉnh và trả lại một đơn vị trang bị. Nội dung trang bị có thể được định cấu hình thông qua cài đặt thuộc tính.",
  T_37_WZY_WS_CRESHELVES_NAMEDESC: "Tạo danh sách trang bị có thể tùy chỉnh và trả lại một đơn vị danh sách trang bị. Nội dung của danh sách này có thể được thay đổi thông qua cài đặt thuộc tính.",
  T_37_WZY_WS_CRESHELVES_PARAM1_DESC: "Đơn vị vật phẩm được tạo",
  T_37_WZY_WS_CRESIDE_NAMEDESC: "Tạo một đơn vị phe",
  T_37_WZY_WS_CRESIDE_PARAM1_DESC: "Đơn vị phe được tạo",
  T_37_WZY_WS_CRESTORE_NAMEDESC: "Tạo một cửa hàng có thể tùy chỉnh và trả lại một đơn vị cửa hàng. Nội dung của cửa hàng có thể được thay đổi thông qua cài đặt thuộc tính.",
  T_37_WZY_WS_CRESTORE_PARAM2_DESC: "Đơn vị cửa hàng được tạo",
  T_37_WZY_WS_CSKYBOX_NAMEDESC: "Thay đổi bầu trời trong trò chơi. Các lựa chọn bao gồm: Ban ngày, chiều tà và ban đêm",
  T_37_WZY_WS_CSKYBOX_PARAM1_DESC: "Loại bầu trời được tạo. Bao gồm ban ngày, chiều tà và ban đêm",
  T_37_WZY_WS_DARKNESS: "Độ tối tổng thể",
  T_37_WZY_WS_DELENT_NAMEDESC: "Xóa một đơn vị được chỉ định. Hiện hỗ trợ đơn vị biểu tượng, đơn vị văn bản, đơn vị HUD, đơn vị hiệu ứng hình ảnh, đơn vị vũ khí và các đơn vị đối tượng khác.",
  T_37_WZY_WS_DELENT_PARAM1_DESC: "Đơn vị được xóa",
  T_37_WZY_WS_DROP: "Lỗi",
  T_37_WZY_WS_DROPITEMS_NAMEDESC: "Kích hoạt khi người chơi đánh rơi một vật phẩm. [Loại vật phẩm] là ID của loại vật phẩm bị loại bỏ.",
  T_37_WZY_WS_DROPITEMS_PARAM1_DESC: "Loại ID của vật phẩm được thả",
  T_37_WZY_WS_DROPWEAP_NAMEDESC: "Kích hoạt khi người chơi đánh rơi vũ khí. [Weapon entity] là vũ khí được thả xuống.",
  T_37_WZY_WS_DROPWEAP_PARAM1_DESC: "Vũ khí được thả xuống",
  T_37_WZY_WS_DUMMYLEOBJ: "Đối tượng giai đoạn thông thường",
  T_37_WZY_WS_DUST: "Chiều tà",
  T_37_WZY_WS_EMPTYCH: "Kênh trống mặc định",
  T_37_WZY_WS_EMPTYCH1: "Kênh 1 trống",
  T_37_WZY_WS_EMPTYCH2: "Kênh 2 trống",
  T_37_WZY_WS_EMPTYCH3: "Kênh 3 trống",
  T_37_WZY_WS_EMPTYCH4: "Kênh 4 trống",
  T_37_WZY_WS_EMPTYCH5: "Kênh 5 trống",
  T_37_WZY_WS_EMPTYCH6: "Kênh 6 trống",
  T_37_WZY_WS_ENTFILTER_NAMEDESC: 'Có được một danh sách chứa tất cả các đơn vị thỏa mãn 3 điều kiện. Nội dung được chèn cho "Bao gồm tất cả", "Loại trừ" và "Bao gồm" là một loại thành phần đơn lẻ hoặc danh sách các loại thành phần. Kết quả trả về là danh sách các đơn vị thỏa mãn các điều kiện.',
  T_37_WZY_WS_ENTFILTER_PARAM1_DESC: "Các đơn vị được lọc ra phải chứa tất cả các thành phần từ mảng này",
  T_37_WZY_WS_ENTFILTER_PARAM2_DESC: "Các đơn vị được lọc ra không được chứa (các) thành phần được chỉ định từ mảng này",
  T_37_WZY_WS_ENTFILTER_PARAM3_DESC: "Các đơn vị được lọc ra phải chứa ít nhất một thành phần từ mảng này",
  T_37_WZY_WS_ENTITY2_PARAM3_DESC: "Loại thuộc tính của đơn vị cần đổi",
  T_37_WZY_WS_ENTITY2_PARAM4_DESC: "Giá trị thuộc tính được đổi thành",
  T_37_WZY_WS_EXITCHAN_NAMEDESC: "Khiến người chơi thoát khỏi kênh giao tiếp hiện tại và họ sẽ không nằm trong bất cứ kênh nào",
  T_37_WZY_WS_EXITCHAN_PARAM1_DESC: "Người chơi được loại khỏi kênh giao tiếp",
  T_37_WZY_WS_FAKEENT: "Đơn vị ngụy trang",
  T_37_WZY_WS_FIND_STR_DESC: "Tìm vị trí của một ký tự trong chuỗi ký tự",
  T_37_WZY_WS_FINDSTR_PARAM1DESC: "Ký tự cần tìm",
  T_37_WZY_WS_FINDSTR_PARAM2DESC: "Tìm trong một chuỗi ký tự từ vị trí bắt đầu (vị trí 0)",
  T_37_WZY_WS_FINDSTRRES: "Vị trí đầu tiên mà chuỗi ký tự xuất hiện. Bắt đầu bằng 0",
  T_37_WZY_WS_FOGCOLOR: "Màu sương",
  T_37_WZY_WS_FRICTIONCON: "Hệ số nhân ma sát thông thường",
  T_37_WZY_WS_FRICTIONIMP: "Hệ số nhân ma sát khi bắn bóng",
  T_37_WZY_WS_FROMDEATH: "Hồi sinh",
  T_37_WZY_WS_FROMKNODOWN: "Cứu",
  T_37_WZY_WS_GETCHAN_NAMEDESC: "Nhận kênh giao tiếp của một người chơi",
  T_37_WZY_WS_GETCHAN_PARAM1_DESC: "Đơn vị người chơi cần nhận kênh giao tiếp",
  T_37_WZY_WS_GETCHANRES: "Kênh giao tiếp mà người chơi đang tham gia",
  T_37_WZY_WS_GETEMPTYCH_NAMEDES: "Theo ID kênh 1 đến 8, lấy kênh trống được tạo theo mặc định khi bắt đầu trò chơi",
  T_37_WZY_WS_GETEMPTYCH_PARAM1_DESC: "ID của kênh trống mặc định",
  T_37_WZY_WS_GETEMPTYCH_RES: "Đơn vị kênh thu được",
  T_37_WZY_WS_GETFAKEENT_NAMEDESC: "Nhận đơn vị ngụy trang của người chơi",
  T_37_WZY_WS_GETFAKEENT_PARAM1_DESC: "Vật thể cần nhận đơn vị ngụy trang",
  T_37_WZY_WS_GETGAMEENT_NAME: "Nhận đơn vị thế giới",
  T_37_WZY_WS_GETGAMEENT_NAMEDESC: "Lấy đơn vị trò chơi của trận đấu này",
  T_37_WZY_WS_GETHOSTPLA_NAME: "Nhận người chơi có thể tấn công",
  T_37_WZY_WS_GETHOSTSIDE_PARAM1: "Đơn vị phe phái",
  T_37_WZY_WS_GOAL_NAMEDESC: "Kích hoạt khi một quả bóng đá đi vào khung thành. [Ghi bàn] là mục tiêu mà quả bóng đi vào. [Người ghi bàn] là cầu thủ cuối cùng tiếp xúc với bóng. [Hỗ trợ] là cầu thủ thứ hai đến cuối cùng tiếp xúc với bóng.",
  T_37_WZY_WS_GOAL_PARAM1_DESC: "Mục tiêu mà quả bóng đi vào",
  T_37_WZY_WS_GOAL_PARAM2_DESC: "Cầu thủ cuối cùng tiếp xúc với bóng",
  T_37_WZY_WS_GOAL_PARAM3_DESC: "Cầu thủ thứ hai đến cuối cùng tiếp xúc với bóng",
  T_37_WZY_WS_HEARTBEAT: "Nhịp tim",
  T_37_WZY_WS_HEAVYWEAPON: "Vũ khí hạng nặng",
  T_37_WZY_WS_HIHGSHOOTANGLE: "Góc Volley nhỏ nhất",
  T_37_WZY_WS_HOSTPLA: "Danh sách người chơi có thể bị tấn công",
  T_37_WZY_WS_HOSTSIDE: "Danh sách các phe có thể bị tấn công",
  T_37_WZY_WS_HOSTTEAM: "Danh sách các đội có thể bị tấn công",
  T_37_WZY_WS_ICON_CLOCK: "Đếm ngược",
  T_37_WZY_WS_ICON_CLOTHES: "Quần áo",
  T_37_WZY_WS_ICON_QUIT: "Thoát",
  T_37_WZY_WS_INSERT_ARR_DESC: "Chèn một yếu tố mới vào một vị trí được chỉ định trong danh sách",
  T_37_WZY_WS_INTERCEPT_STR_DESC: "Trích xuất một chuỗi có độ dài được chỉ định, bắt đầu từ vị trí chỉ định. Nếu độ dài trích xuất vượt quá độ dài chuỗi, nó sẽ trích xuất nội dung cho đến cuối chuỗi.",
  T_37_WZY_WS_INTERCEPTSTR_PARAM1DESC: "Độ dài trích xuất",
  T_37_WZY_WS_INTERCEPTSTRRES_DESC: "Chuỗi đã được trích xuất",
  T_37_WZY_WS_INTORINTL: "Số nguyên hoặc danh sách số nguyên",
  T_37_WZY_WS_JOINSIDE_NAMEDESC: "Cho người chơi gia nhập một phe chỉ định",
  T_37_WZY_WS_JOINSIDE_PARAM2_DESC: "Phe cho người gia nhập",
  T_37_WZY_WS_JUMP: "Nhảy",
  T_37_WZY_WS_LABEL: "Thẻ",
  T_37_WZY_WS_LENSFLARE: "Lóe sáng",
  T_37_WZY_WS_LENTH: "Độ dài",
  T_37_WZY_WS_LIGHTATTACK: "Đánh thành công",
  T_37_WZY_WS_LIGHTCOLOR: "Màu của nguồn sáng",
  T_37_WZY_WS_LIGHTINTENSITY: "Độ sáng của nguồn sáng",
  T_37_WZY_WS_LOADSCENE_NAMEDESC: "Tải khung cảnh bản đồ mới",
  T_37_WZY_WS_LOADSCENE_PARAM1_DESC: "Tên của khung cảnh bản đồ cần tải",
  T_37_WZY_WS_MOROBJECT: "Vật phẩm ngụy trang",
  T_37_WZY_WS_MOVEAXISX: "Di chuyển dọc theo trục x",
  T_37_WZY_WS_MOVEAXISY: "Di chuyển dọc theo trục y",
  T_37_WZY_WS_MOVEAXISZ: "Di chuyển dọc theo trục z",
  T_37_WZY_WS_MOVEDISTITLE: "Khoảng cách di chuyển",
  T_37_WZY_WS_MUTEQUICKCHAT_NAME: "Bật (Tắt) gửi tin nhắn nhanh",
  T_37_WZY_WS_MUTEQUICKCHAT_NAMEDESC: "Bật hoặc tắt gửi tin nhắn nhanh. Khi tắt, gửi tin nhắn nhanh trên giao diện HUD của ngườ chơi sẽ bị vô hiệu hóa và người chơi sẽ không thể gửi hay nhận tin nhắn nhanh.",
  T_37_WZY_WS_MUTEQUICKCHAT_PARAM1_DESC: "Người chơi được bật/tắt gửi tin nhắn nhanh",
  T_37_WZY_WS_MUTEVOICE_NAME: "Bật (Tắt) voice chat",
  T_37_WZY_WS_MUTEVOICE_NAMEDESC: "Bật hoặc tắt voice chat. Khi tắt, nút voice chat trên giao diện HUD của ngườ chơi sẽ bị vô hiệu hóa và người chơi sẽ không thể giao tiếp bằng giọng nói",
  T_37_WZY_WS_MUTEVOICE_PARAM1_DESC: "Người chơi được bật/tắt voice chat",
  T_37_WZY_WS_MUTEVOICE_PARAM2_DESC: "Boolean. Đúng nghĩa là tắt; Sai nghĩa là bật",
  T_37_WZY_WS_NIGHTMODE: "Chế độ ban đêm",
  T_37_WZY_WS_ONAIM_NAMEDESC: "Kích hoạt khi người chơi nhắm vào một đơn vị có thể nhắm bắn. [Target entity] là đơn vị đang được nhắm tới. Khi không có đơn vị nào được nhắm đến, giá trị trả về là null.",
  T_37_WZY_WS_ONAIM_PARAM1_NAME: "Đơn vị bị ngắm bắn",
  T_37_WZY_WS_ONHIT_PARAM1_DESC: "Đơn vị va chạm với vũ khí",
  T_37_WZY_WS_ONSCENELOADING_NAMEDESC: "Kích hoạt khi khung cảnh bản đồ tải thành công",
  T_37_WZY_WS_ONSCENELOADING_PARAM1_DESC: "Tên của khung cảnh bản đồ cần tải. Đây là một giá trị.",
  T_37_WZY_WS_ONSCENESWITCH_NAMEDESC: "Kích hoạt khi khung cảnh bản đồ chuyển đổi thành công",
  T_37_WZY_WS_ONSCENESWITCH_PARAM1_DESC: "Tên của phong cảnh bản đồ mới. Đây là một giá trị.",
  T_37_WZY_WS_OUTJERSEY_NAMEDESC: "Khôi phục trang phục của người chơi về giao diện mặc định",
  T_37_WZY_WS_OUTJERSEY_PARAM1_DESC: "Người chơi có trang phục mặc định để khôi phục",
  T_37_WZY_WS_PETSET: "Cài đặt Trợ thủ",
  T_37_WZY_WS_PETSKILL: "Kỹ năng trợ thủ",
  T_37_WZY_WS_PETSWITCH2: "Liệu các kỹ năng của pet có thể được sử dụng hay không",
  T_37_WZY_WS_PLAMOVE_PARAM2_DESC: "Có cho phép người chơi chuyển động hay không. Đây là một giá trị Boolean",
  T_37_WZY_WS_PLAYERBEHAVIOR: "Loại hành vi người chơi",
  T_37_WZY_WS_PRESS: "Click",
  T_37_WZY_WS_PROGRESS: "Giai đoạn hiện tại",
  T_37_WZY_WS_PROGRESSBAR: "Tiến trình HUD",
  T_37_WZY_WS_RANKDOWN: "Xuống hạng",
  T_37_WZY_WS_REMLABEL_NAMEDESC: "Loại bỏ thẻ cho đơn vị được chọn",
  T_37_WZY_WS_REMLABEL_PARAM1_DESC: "Văn bản bị loại bỏ",
  T_37_WZY_WS_REPLACE_STR_DESC: "Thay thế nội dung của một chuỗi bằng một nội dung được chỉ định",
  T_37_WZY_WS_REPLACESTR_PARAM1DESC: "Nhân vật mới được thay thế",
  T_37_WZY_WS_REPLACESTR_PARAM2DESC: "Nhân vật mới được thay thế bằng",
  T_37_WZY_WS_REVERSE_ARR_DESC: "Đảo ngược tất cả các yếu tố trong danh sách này",
  T_37_WZY_WS_REVIVEHERE: "Người chơi hồi sinh đồng đội tại điểm hồi sinh",
  T_37_WZY_WS_REVIVEHERE_NAMEDESC: "Kích hoạt khi một người chơi đang hồi sinh đồng đội tại điểm hồi sinh",
  T_37_WZY_WS_REVIVEWAYDESC: "Cách một người chơi được hồi sinh hoặc giúp đỡ khỏi bị tiêu diệt hoặc bị hạ gục",
  T_37_WZY_WS_SATBEHAVIOR_NAMEDESC: "Định cấu hình trạng thái của các hành vi khác nhau cho người chơi. Khi bị tắt, không thể sử dụng các nút tương ứng trên HUD, đồng thời không cho phép các chuyển động bằng tay và tự động. Khi bị ẩn, các nút tương ứng sẽ không được hiển thị trên HUD, và các chuyển động bằng tay không được phép trong khi các chuyển động tự động được phép. Khi được bật, các nút tương ứng sẽ được hiển thị trên HUD, đồng thời cho phép các chuyển động bằng tay và tự động.",
  T_37_WZY_WS_SATBEHAVIOR_PARAM1_DESC: "Trình phát để đặt trạng thái hành vi",
  T_37_WZY_WS_SATBEHAVIOR_PARAM2_DESC: "Hành vi của người chơi, bao gồm di chuyển, tấn công, nhảy và chạy nước rút",
  T_37_WZY_WS_SATBEHAVIOR_PARAM3_DESC: "Trạng thái bao gồm vô hiệu hóa, ẩn và kích hoạt. Khi bị ẩn, các nút tương ứng sẽ không được hiển thị trên HUD, và các chuyển động bằng tay không được phép trong khi các chuyển động tự động được phép. Khi được bật, các nút tương ứng sẽ được hiển thị trên HUD, đồng thời cho phép các chuyển động bằng tay và tự động.",
  T_37_WZY_WS_SETBALL_PARAM2_DESC: "Tọa độ của quả bóng",
  T_37_WZY_WS_SETBALL_PARAM3_DESC: "Có giữ nguyên tốc độ được cài đặt sẵn của bóng hay không",
  T_37_WZY_WS_SETPLAHOST_NAME: "Cài đặt tấn công của người chơi",
  T_37_WZY_WS_SETPLAHOST_NAMEDESC: "Thiết lập liệu [Setting player] có thể tân công [Target player] hay không. Cài đặt mặc định dựa trên việc liệu người chơi mục tiêu có thuộc về đội hay phe có thể được tấn công hay không. Cài đặt được ưu tiên hơn cài đặt đội/phe",
  T_37_WZY_WS_SETPLAHOST_PARAM1_DESC: "Người chơi được thiết lập kẻ địch",
  T_37_WZY_WS_SETPLAHOST_PARAM2_DESC: "Người chơi là kẻ địch",
  T_37_WZY_WS_SETPLAHOST_PARAM3: "Có thể bị tấn công",
  T_37_WZY_WS_SETPLAHOST_PARAM3_DESC: '"Có" nghĩa là có thể bị tấn công; "Không" nghĩa là không thể bị tấn công. Cài đặt mặc định dưa trên liệu người chơi có thuộc về một đội hay phe có thể bị tấn công hay không',
  T_37_WZY_WS_SETSIDEHOST_PARAM3_DESC: '"Có" nghĩa là có thể bị tấn công, "Không"nghĩa là không thể bị tấn công',
  T_37_WZY_WS_SHADOWSTRENGTH: "Bóng",
  T_37_WZY_WS_SHOOTANGLE: "Góc bắn nhỏ nhất",
  T_37_WZY_WS_SKYBOX: "Bầu trời",
  T_37_WZY_WS_SKYBOXENT: "Đơn vị trời",
  T_37_WZY_WS_SKYBOXTYPE: "Các loại bầu trời cơ bản",
  T_37_WZY_WS_STEPPED: "Bước kích hoạt",
  T_37_WZY_WS_SWCHAN_NAMEDESC: "Đổi kênh voice chat của người chơi",
  T_37_WZY_WS_SWCHAN_PARAM1_DESC: "Người chơi được đổi kênh giao tiếp",
  T_37_WZY_WS_SWCHAN_PARAM2_DESC: "Kênh được đổi thành",
  T_37_WZY_WS_SWITCHSCENE_NAMEDESC: "Chuyển sang phong cảnh bản đồ được chỉ định",
  T_37_WZY_WS_SWITCHSCENE_PARAM1_DESC: "Tên của phong cảnh bản đồ để chuyển cảnh",
  T_37_WZY_WS_TARGETSTR_DESC: "Chuỗi mục tiêu",
  T_37_WZY_WS_TEAMASIDE: "Đội và phe",
  T_37_WZY_WS_TELEPORTN_AUTO: "Tự động",
  T_37_WZY_WS_TELEPORTN_AVAILABLE: "Dịch chuyển hay không",
  T_37_WZY_WS_TELEPORTN_MANUAL: "Thủ công",
  T_37_WZY_WS_TELEPORTN_NO: "Huỷ bỏ",
  T_37_WZY_WS_TELEPORTN_TITLE: "Phương thức dịch chuyển",
  T_37_WZY_WS_TELEPORTN_YES: "Xác nhận",
  T_37_WZY_WS_TERRAINWET: "Độ ẩm của địa hình",
  T_37_WZY_WS_TRANSFORM_NAMEDESC: "Thay thể bề ngoài của một [Player Entity] với bề ngoài của một [Scenery object]",
  T_37_WZY_WS_TRANSFORM_PARAM1_DESC: "Đơn vị người chơi có diện mạo thay đổi",
  T_37_WZY_WS_TRANSFORM_PARAM2_DESC: "Người chơi cần nhận đơn vị ngụy trang",
  T_37_WZY_WS_TRANSP: "Độ trong suốt",
  T_37_WZY_WS_UNLOADSCENE_NAMEDESC: "Gỡ cài đặt khung cảnh bản đồ được chỉ định",
  T_37_WZY_WS_UNLOADSCENE_PARAM1_DESC: "Tên của phong cảnh bản đồ cần gỡ cài đặt",
  T_37_WZY_WS_VFX1: "Tượng trưng",
  T_37_WZY_WS_VFX2: "Khói",
  T_37_WZY_WS_VFX3: "Vụ nổ lời nguyền",
  T_37_WZY_WS_VFX5: "Đông cứng",
  T_37_WZY_WS_VFX6: "Spotlight",
  T_37_WZY_WS_VFX7: "Hỗn loạn",
  T_37_WZY_WS_VFX8: "Vụ nổ khí quyển",
  T_37_WZY_WS_VISABLE: "Hiển thị",
  T_37_WZY_WS_WEAOPEN: "Hiện hay không",
  T_37_WZY_WS_WEAPONENT: "Đơn vị vũ khí",
  T_37_WZY_WS_WEATARGETED: "Hỗ trợ ngắm",
  T_37_XYL_CUSTOMJERSEY: "Máy tạo áo bóng đá",
  T_37_XYL_CUSTOMJERSEY_DESC: "Sử dụng Máy tạo áo bóng đá để sáng tạo ra chiếc áo độc quyền của chính bạn",
  T_37_XYL_FOOTGUN: "Máy bắn bóng",
  T_37_XYL_SOCCER: "Bóng đá",
  "T_37_XYL_SOCCER_ RADIUS": "Bán kính",
  T_37_XYL_SOCCER_DESC: "Quả bóng đã được thay đổi thuộc tính",
  T_37_XYL_SOCCER_HIGHT1: "Góc bình thường",
  T_37_XYL_SOCCER_HIGHT2: "Góc Volley",
  T_37_XYL_SOCCER_RESET: "Thời gian làm mới sau khi ghi bàn (giây)",
  T_37_XYL_SOCCER_RESIST1: "Lực ma sát (Khi đá bóng)",
  T_37_XYL_SOCCER_RESIST2: "Lực ma sát (Khi bắn bóng)",
  T_37_XYL_SOCCERGOAL: "Khung thành",
  T_37_XYL_SOCCERGOAL_DESC: "Đây là khung thành. Đưa bóng vào khung thành để ghi điểm. (Chỉ có trong Ghi điểm.)",
  T_37_XYL_SOCCERITEM: "Máy tạo trang bị",
  T_37_XYL_SOCCERITEM_DESC: "Khi được đặt xuống, nó sẽ tạo ra vật phẩm được chọn",
  T_37_XYL_SPAWN_PEOPLE: "Số người chơi",
  T_37_XYL_WS_AIRCONDITIONER001: "Điều hòa B",
  T_37_XYL_WS_AMMUCHEST: "Hòm chiến lợi phẩm A",
  T_37_XYL_WS_BAFFLE001: "Hàng rào A",
  T_37_XYL_WS_BARREL001: "Thùng",
  T_37_XYL_WS_BARREL001_DES: "Thùng gỗ tròn thường thấy",
  T_37_XYL_WS_BOARD001: "Biển quảng cáo B",
  T_37_XYL_WS_BOOK001: "Đống sách A",
  T_37_XYL_WS_BOOK002: "Board Game A",
  T_37_XYL_WS_BOUGAINVILLEA: "Hoa giấy",
  T_37_XYL_WS_BOUGAINVILLEA_DES: "Trang trí - làm bừng sáng không gian!",
  T_37_XYL_WS_BOX001: "Đống hộp A",
  T_37_XYL_WS_BOX002: "Hộp bé",
  T_37_XYL_WS_BUSHCOVER: "Bụi cỏ",
  T_37_XYL_WS_BUSHCOVER_DES: "Một bụi cây có thể được sử dụng để ẩn náu",
  T_37_XYL_WS_CABINET001: "Ngăn kéo A",
  T_37_XYL_WS_CHAIR001: "Ghế A",
  T_37_XYL_WS_COCONUTTREE: "Cây dừa",
  T_37_XYL_WS_COCONUTTREE_DES: "Trang trí - Tạo không khí bãi biển!",
  T_37_XYL_WS_COMPUTER001: "Máy tính A",
  T_37_XYL_WS_DAMAGERATIO: "Tỉ lệ sát thương",
  T_37_XYL_WS_FIREEX: "Bình cứu hỏa",
  T_37_XYL_WS_GUIDEPOSE: "Con trỏ",
  T_37_XYL_WS_HUGEHOUSE001: "Nhà 3 tầng",
  T_37_XYL_WS_HUGEHOUSE002: "Nhà 2 tâng B",
  T_37_XYL_WS_JACKSTRAW: "Hình nộm",
  T_37_XYL_WS_LADDER001: "Thang A",
  T_37_XYL_WS_OILDRUM: "Thùng dầu",
  T_37_XYL_WS_ORNAMENT001: "Bình A",
  T_37_XYL_WS_PACKBOX: "Hộp vật liệu",
  T_37_XYL_WS_PILLA001: "Trụ bê tông",
  T_37_XYL_WS_PRESENT: "Hộp quà",
  T_37_XYL_WS_PRESENT_DES: "Chứa quà lễ hội",
  T_37_XYL_WS_PUMPKIN: "Bí Ngô trang trí",
  T_37_XYL_WS_PUMPKINCUT: "Bí ngô trang trí",
  T_37_XYL_WS_PUMPKINCUT_DES: "Một cách trang trí thường thấy cho một lễ hội Halloween",
  T_37_XYL_WS_ROADBLOCK001: "Rào chắn 2",
  T_37_XYL_WS_SHELF001: "Kệ sách A",
  T_37_XYL_WS_SOFA001: "Sofa A",
  T_37_XYL_WS_SPAWNTEAM: "Tất cả đội",
  T_37_XYL_WS_SUPPLYBOX: "Thùng đạn",
  T_37_XYL_WS_TABLE001: "Bàn A",
  T_37_XYL_WS_TABLE002: "Bàn B",
  T_37_XYL_WS_TARGET001: "Mục tiêu",
  T_37_XYL_WS_TEAMID_1: "1",
  T_37_XYL_WS_TEAMID_10: "10",
  T_37_XYL_WS_TEAMID_11: "11",
  T_37_XYL_WS_TEAMID_12: "12",
  T_37_XYL_WS_TEAMID_2: "2",
  T_37_XYL_WS_TEAMID_3: "3",
  T_37_XYL_WS_TEAMID_4: "4",
  T_37_XYL_WS_TEAMID_5: "5",
  T_37_XYL_WS_TEAMID_6: "6",
  T_37_XYL_WS_TEAMID_7: "7",
  T_37_XYL_WS_TEAMID_8: "8",
  T_37_XYL_WS_TEAMID_9: "9",
  T_37_XYL_WS_TELEPORTEND: "Điểm cuối của cổng dịch chuyển",
  T_37_XYL_WS_TELEPORTNEW: "Cổng A",
  T_37_XYL_WS_TELEPORTNEW_DESC: "Công dịch chuyển người chơi đến điểm đích",
  T_37_XYL_WS_TIRES001: "Lốp A",
  T_37_XYL_WS_TOOLRACK: "Kệ dụng cụ",
  T_37_XYL_WS_WALL001: "Tường",
  T_37_XYL_WS_WOOD001: "Khúc gỗ",
  T_37_XYL_WS_YELLOWDUCK001: "Phao vịt",
  T_37_XYL_WS_YELLOWDUCK001_DES: "Một chiếc vòng bơi được thổi phồng hình con vịt",
  T_37_YM_BOMBSQUAD_DEFUSER: "Bom làm lệch hướng",
  T_37_YS_B_BRFOOTBALL_WHITE: "Quần Số 10 Huyền Thoại",
  T_37_YS_F_B_VN_STREET: "Quần Dân chơi phố cổ",
  T_37_YS_F_H_VN_STREET: "Tóc Dân chơi phố cổ",
  T_37_YS_F_S_VN_STREET: "Giày Dân chơi phố cổ",
  T_37_YS_F_T_VN_STREET: "Áo Dân chơi phố cổ",
  T_37_YS_M_A_CRICKET_BLACK: "Mặt nạ Siêu Sao Cricket Đen",
  T_37_YS_M_A_THKOL: "Mặt nạ Lửa Khiêu Khích",
  T_37_YS_M_B_CRICKET_BLACK: "Quần Siêu Sao Cricket Đen",
  T_37_YS_M_B_SILVERERA: "Quần Ấn Kỵ Sĩ",
  T_37_YS_M_B_THKOL: "Quần Lửa Khiêu Khích",
  T_37_YS_M_H_SILVERERA: "Đầu Ấn Kỵ Sĩ",
  T_37_YS_M_H_THKOL: "Đầu Lửa Khiêu Khích",
  T_37_YS_M_S_CRICKET_BLACK: "Giày Siêu Sao Cricket Đen",
  T_37_YS_M_S_SILVERERA: "Giày Ấn Kỵ Sĩ",
  T_37_YS_M_S_THKOL: "Giày Lửa Khiêu Khích",
  T_37_YS_M_T_CRICKET_BLACK: "Áo Siêu Sao Cricket Đen",
  T_37_YS_M_T_SILVERERA: "Áo Ấn Kỵ Sĩ",
  T_37_YS_M_T_THKOL: "Áo Lửa Khiêu Khích",
  T_37_YS_T_BRFOOTBALL_WHITE: "Áo Số 10 Huyền Thoại",
  T_37_ZF_ROOM_UGC_MINPLAYER: "Số người chơi tối thiểu",
  T_38_BQ_SKILL_NAME_DUMMY1: "Kẻ Đóng Thế",
  T_38_BQ_SKILL_NAME_DUMMY2: "Dịch Chuyển Nhân Dạng",
  T_38_CJ_F_B_STREAMER_MUSIC: "Quần Nữ Streamer Phong Cách",
  T_38_CJ_F_H_STREAMER_MUSIC: "Đầu Nữ Streamer Phong Cách",
  T_38_CJ_F_S_STREAMER_MUSIC: "Giày Nữ Streamer Phong Cách",
  T_38_CJ_F_T_STREAMER_MUSIC: "Áo Nữ Streamer Phong Cách",
  T_38_JH_WS_CM1: "Luật chơi rõ ràng",
  T_38_JH_WS_CM2: "Không rõ luật chơi",
  T_38_JH_WS_CM3: "Người chơi thoát nhiều",
  T_38_JL_M79_AMMO_N: "Đạn M79",
  T_38_JMF_SKILLCHIP_NAME_SINGER: "Chip kỹ năng của J.Biebs",
  T_38_M_WS_VECTOR2: "2D Vector",
  T_38_R_TACTICS_N: "CHIẾN THUẬT",
  T_38_RW_NIW_NIWNAME: "Máy tạo bom keo",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CALLSTACKCOUNTMAX: "Quá nhiều lớp khối. Hiện tại: {0}. Tối đa: {1}.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CREATEITEMCOUNTMAXPERMATCHKEY: "Số lượng vật phẩm bạn đã tạo ({0}) đã vượt giới hạn ({1}).",
  T_38_SP_WS_LOG_EXCEED_LIMIT_DISPATCHEVENTMAXCOUNTPERFRAME: "Số sự kiện nhận được trong cùng một khung ({0}) đã vượt quá giới hạn ({1}).",
  T_38_SP_WS_LOG_EXCEED_LIMIT_ENTITIESCREATEDPERFRAMEMAX: "Đã đạt giới hạn tạo thực thể động mỗi khung: ({0}); đã từ chối {1} lần thử tạo.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LISTINITLENGTHMAX: "Độ dài của danh sách khởi tạo ({0}) đã vượt quá giới hạn ({1}).Tự động mở rộng tối đa",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LOOPTIMESMAX: "Số vòng lặp ({0}) đã vượt giới hạn ({1}). Vòng lặp bị gián đoạn",
  T_38_SP_WS_LOG_EXCEED_LIMIT_PERSCOPECOROUTINECONCURRENCYMAX: "Số lượng coroutine đồng thời ({0}) trong phạm vi coroutine đã vượt quá giới hạn ({1}).",
  T_38_SP_WS_LOG_LIST_APPEND_IS_NIL: "Không thể thêm phần tử vào danh sách. Danh sách {0} trống",
  T_38_SP_WS_LOG_VAR_ARITHMETIC_FAILED: "Các loại giá trị không khớp khi thực hiện phép toán số học cơ bản. Loại giá trị bên trái là {0} và loại giá trị bên phải là {1}.",
  T_38_SP_WS_LOG_VAR_REPEATED_DEF_IN_SCOPE: "Định nghĩa biến tạm thời lặp đi lặp lại. Tên biến: {0}.",
  T_38_SP_WS_REVIEW_01: "Độc hại",
  T_38_SP_WS_REVIEW_02: "Tầm thường",
  T_38_SP_WS_REVIEW_03: "Xúc phạm",
  T_38_SP_WS_REVIEW_04: "Cực kỳ độc hại",
  T_38_SP_WS_REVIEW_05: "Đe dọa",
  T_38_SP_WS_REVIEW_06: "Thiếu tôn trọng",
  T_38_SP_WS_REVIEW_07: "Đang đánh giá",
  T_38_SP_WS_REVIEW_08: "{0} tên {1} không tuân thủ các quy tắc. {2}.",
  T_38_SP_WS_REVIEW_09: "String",
  T_38_SP_WS_REVIEW_10: "Cửa hàng",
  T_38_SP_WS_REVIEW_11: "Biến",
  T_38_SP_WS_REVIEW_12: "Chức năng",
  T_38_SP_WS_REVIEW_13: "Vật thể",
  T_38_SP_WS_REVIEW_14: "Chuyển đến định nghĩa",
  T_38_SP_WS_REVIEW_15: "Tới Quản lý vật thể",
  T_38_SP_WS_REVIEW_16: "Không chuyển hướng",
  T_38_SP_WS_REVIEW_17: "Tên bản đồ",
  T_38_SP_WS_REVIEW_18: "Mô tả",
  T_38_SP_WS_REVIEW_19: "Ảnh bìa",
  T_38_SP_WS_REVIEW_20: "Nội dung chứa từ nhạy cảm",
  T_38_SP_WS_REVIEW_21: "Lưu thất bại. Không thể đánh giá",
  T_38_SP_WS_REVIEW_22: "Đánh giá đang làm mới",
  T_38_SY_BASEBALLBAT_KITCHEN_N: "Gậy Đầu Bếp Sát Thủ",
  T_38_SY_CHARACTER_DESIGNER_N: "Santino",
  T_38_SY_PET_CACTUS_N: "Kactus",
  T_38_SY_PETSKIN_CACTUS_BLACK_N: "Kactus bóng ma",
  T_38_SY_PETSKIN_CACTUS_PINK_N: "Kactus Neon",
  T_38_SY_PETSKIN_CACTUS_YELLOW_N: "Kactus Mộng Mơ",
  T_38_SY_PETSKIN_FLYINGCREATURE_ES_N: "Skin Arvon Tiệc Tùng",
  T_38_SY_PETSKIN_RACCOON_MO_N: "Skin Rockie Thời Thượng",
  T_38_SY_SCAR_ELDERGODS_N: "SCAR - Hỏa Thần Quỷ Ấn",
  T_38_SY_SICKLE_ES_N: "Lưỡi hái Truyện Tranh",
  T_38_SY_VEHICLE_SUV_KITCHEN_N: "Xe bán tải - Đầu Bếp Sát Thủ",
  T_38_WT_WS_MUITLEVEL: "Nhiều cấp",
  T_38_WT_WS_SKILLSET15: "Sức nóng Chiến trường (A124)",
  T_38_WT_WS_SKILLSET16: "Bom tầm xa (Homer)",
  T_38_WT_WS_SKILLSET17: "Xuyên Tường (Iris)",
  T_38_WT_WS_SKILLSET18: "Tốc hành tức thời (Tatsuya)",
  T_38_WZY_WS_ACTIVEA: "Có thể sử dụng trong cảnh quan hay không",
  T_38_WZY_WS_ACTIVEB: "Bật logic làm mới hoặc không",
  T_38_WZY_WS_ACTIVEVALUE: "Trạng thái hoạt động",
  T_38_WZY_WS_AIR: "Không khí",
  T_38_WZY_WS_ALLOWMOVE: "Di chuyển được hay không",
  T_38_WZY_WS_AMMOAMOUNT: "Số lượng đạn",
  T_38_WZY_WS_AMMONAME: "Thực thể đạn",
  T_38_WZY_WS_ARMOR_DAMRED: "Hệ số giảm sát thương",
  T_38_WZY_WS_ARMOR_DAMRED_EXP: "Hệ số giảm sát thương nổ",
  T_38_WZY_WS_ARMOR_DURABILITY: "Độ bền hiện tại",
  T_38_WZY_WS_ARMOR_DURABILITYMAX: "Độ bền cao nhất",
  T_38_WZY_WS_ARMOR_ISDAMAGE: "Có bị hư hại hay không",
  T_38_WZY_WS_ARMOR_ISDESTROY: "Có bị phá hủy hay không",
  T_38_WZY_WS_ARMOR_LEVEL: "Cấp độ",
  T_38_WZY_WS_ASSCONZOM: "Hỗ trợ tiêu diệt zombie",
  T_38_WZY_WS_BAGNAME: "Thực thể balo",
  T_38_WZY_WS_BAGSPACEEX: "Ô trống balo bổ sung",
  T_38_WZY_WS_BRIDGING: "Thành phần kết xuất cầu nối",
  T_38_WZY_WS_BUBBLE: "Bong bóng",
  T_38_WZY_WS_CLEARBAG_NAMEDESC: "Làm trống balo của một đơn vị người chơi",
  T_38_WZY_WS_CLEARMAP_NAMEDESC: "Bỏ đi các vật phẩm không cần trong bản độ, chẳng hạn như vật nhặt, các vật ném hoặc các hộp vật phẩm",
  T_38_WZY_WS_CLEARPRO: "Xóa yếu tố thuộc tính đơn",
  T_38_WZY_WS_CLONEOBJ_NAMEDESC: "Tạo bản copy của [vật thể trang trí cảnh] ở vị trí của [đơn vị người chơi], trả về [đơn vị ẩn thân]",
  T_38_WZY_WS_COMPONENT: "Thành phần",
  T_38_WZY_WS_COSTAMMO: "Sử dụng đạn",
  T_38_WZY_WS_CRECREMA_NAMEDESC: "Tạo và trả về vật thể camera, các thuộc tính có thể được thay đổi trong bản thiết lập thuộc tính",
  T_38_WZY_WS_CYCLES: "Số lần bật",
  T_38_WZY_WS_CYLINDERJUD_NAMEDESC: "Kiểm tra xem vật thể có nằm trong phạm vi hình trụ, cần [Tâm], [bán kính], [chiều cao] của hình trụ.",
  T_38_WZY_WS_CYLINDERJUD_RES: "Kết quả kiểm tra phạm vi hình trụ. Trả về giá trị đúng hoặc sai.",
  T_38_WZY_WS_DAMSUMZOM: "Sát thương lên Zombie",
  T_38_WZY_WS_DARKNESS: "Hắc ám",
  T_38_WZY_WS_DIFCOLOR: "Màu bề mặt",
  T_38_WZY_WS_DIFTEXTURE: "Chất liệu bề mặt",
  T_38_WZY_WS_DRUMMUSIC: "Loại thành phần: trống",
  T_38_WZY_WS_ENTITY_PLAYERDISDESC: "Người chơi thoát game",
  T_38_WZY_WS_ENTITY_PLAYERRECDESC: "Người chơi kết nối lại",
  T_38_WZY_WS_EUIANCHOR: "HUD danh sách điểm neo",
  T_38_WZY_WS_FEATHER: "Lông vũ",
  T_38_WZY_WS_FLAMEAMMO: "Đạn máy phun lửa",
  T_38_WZY_WS_FLOWER: "Hoa",
  T_38_WZY_WS_FOLLOW_NAMEDESC: "Chỉnh cho [vật thể] luôn đi theo [vật thể được đi theo]",
  T_38_WZY_WS_FOLLOWENT: "Vật thể đi theo",
  T_38_WZY_WS_GETCURCAM_NAMEDESC: "Lấy vật thể camera được sử dụng bởi [đơn vị người chơi]",
  T_38_WZY_WS_GETCURCAMDESC: "Camera đang được sử dụng bởi người chơi",
  T_38_WZY_WS_GETITEMNUM_NAMEDESC: "Lấy số lương vật phẩm thuộc loại [loại vật phẩm] mà người chơi sở hựu",
  T_38_WZY_WS_GETITEMNUM_RES: "Số lượng vật phẩm thuộc loại cho trước mà người chơi sở hữu",
  T_38_WZY_WS_GETVEC_NAME: "Lấy véc-tơ",
  T_38_WZY_WS_GETVEC_NAMEDESC: "Tạo véc-tơ từ tọa đồ x,y,z của một tập hợp điểm của một véc tơ khác",
  T_38_WZY_WS_GETVECRES: "Tạo véc-tơ từ tọa độ x,y,z",
  T_38_WZY_WS_GHOST: "Hồn ma",
  T_38_WZY_WS_GRENADEFROZENNAME: "Thực thể lựu đạn đóng băng",
  T_38_WZY_WS_GRENADEFROZENPARAM1: "Bán kính khu đóng băng",
  T_38_WZY_WS_GRENADEFROZENPARAM2: "Thời lượng đóng băng",
  T_38_WZY_WS_GRENADENAME: "Thực thể lựu đạn",
  T_38_WZY_WS_GRENADEPARAM1: "Sát thương tối thiểu",
  T_38_WZY_WS_GRENADEPARAM2: "Sát thương tối đa",
  T_38_WZY_WS_GRENADEPARAM4: "Phạm vi nổ",
  T_38_WZY_WS_GRENADEPARAM5: "Tốc độ ném",
  T_38_WZY_WS_GRENADEPARAM6: "Độ trễ nổ",
  T_38_WZY_WS_GRENADEPARAM7: "Hệ số sát thương bản thân",
  T_38_WZY_WS_GRENADEPARAM8: "Hệ số sát thương đồng đội",
  T_38_WZY_WS_GRENADEPARAM9: "Hệ số sát thương xe cộ",
  T_38_WZY_WS_GUNFIRE: "Súng",
  T_38_WZY_WS_GUNPRO_PARAM2: "Tốc độ nạp đạn",
  T_38_WZY_WS_GUNPRO_PARAM3: "Tỷ lệ sát thương trúng cơ thể",
  T_38_WZY_WS_GUNPRO_PARAM4: "Tỷ lệ sát thương khi trúng đầu",
  T_38_WZY_WS_GUNPRO_PARAM5: "Tỷ lệ sát thương trúng tứ chi",
  T_38_WZY_WS_GUNPRO_PARAM7: "Thêm sát thương",
  T_38_WZY_WS_HELMET_NAME: "Đơn vị giáp",
  T_38_WZY_WS_ICON1: "Vương miệng",
  T_38_WZY_WS_ICON2: "So tài",
  T_38_WZY_WS_INITPOS: "Vị trí bắt đầu",
  T_38_WZY_WS_ISRESET: "Chuyển động tịnh tiến",
  T_38_WZY_WS_KILLCONZOM: "Số lượng zombie bị tiêu diệt",
  T_38_WZY_WS_KILLENT_NAMEDESC: "Tiêu diệt [đơn vị vật thể], đơn vị này phải là đơn vị chiến đấu. Bỏ qua thuộc tính bất tử khi loại bỏ.",
  T_38_WZY_WS_LABELPARAM: "D.sách tham số n.dung văn bản",
  T_38_WZY_WS_LEADMUSICA: "Loại thành phần: piano (treble)",
  T_38_WZY_WS_LEADMUSICB: "Loại thành phần: piano (alto)",
  T_38_WZY_WS_LEADMUSICC: "Loại thành phần: piano (bass)",
  T_38_WZY_WS_LINE: "Dây",
  T_38_WZY_WS_LIQUID: "Chất lỏng",
  T_38_WZY_WS_LOCALKEY: "Từ ngữ việt hóa",
  T_38_WZY_WS_LOCALPOS: "Khu vực lân cận",
  T_38_WZY_WS_LOOKAT_NAMEDESC: "Chỉnh cho vật thể luôn nhìn [vật thể mục tiêu]. [Độ lệch tọa độ] là hiệu tọa độ giữa 2 vật thể",
  T_38_WZY_WS_MAINWEAPONA: "Vũ khí chính 1",
  T_38_WZY_WS_MAINWEAPONB: "Vũ khí chính 2",
  T_38_WZY_WS_MOTIONTIME: "Thời gian di chuyển",
  T_38_WZY_WS_MOTIONTYPE: "Phương thức chạy",
  T_38_WZY_WS_MUSHROOM_EPMODIFY: "Điểm EP điều chỉnh",
  T_38_WZY_WS_MUSHROOMNAME: "Thực thể nấm",
  T_38_WZY_WS_OBFACTION: "Quan sát theo phe",
  T_38_WZY_WS_OBGLOBAL: "Quan sát tất cả",
  T_38_WZY_WS_OBSERVER: "Tùy chọn quan sát",
  T_38_WZY_WS_OBTEAM: "Quan sát đội",
  T_38_WZY_WS_OFFSETVEC: "Độ lệch tọa độ",
  T_38_WZY_WS_ONBUY_NAMEDESC: "Kích hoạt khi người chơi mua vật phẩm từ máy bán hàng, gồm [Đơn vị người chơi] và [Đơn vị vật phẩm]",
  T_38_WZY_WS_ONEQUIPED_NAMEDESC: "Kích hoạt khi được trang bị bởi người chơi [đơn vị người chơi]",
  T_38_WZY_WS_ONJUMP_NAMEDESC: "Kích hoạt khi người chơi hoàn thành hành động nhảy",
  T_38_WZY_WS_ONLIE_NAMEDESC: "Kích hoạt khi người chơi hoàn thành hành động nằm",
  T_38_WZY_WS_ONRELOAD_NAMEDESC: "Kích hoạt khi nạp đạn vũ khi",
  T_38_WZY_WS_ONSPRINT_NAMEDESC: "Kích hoạt khi người chơi hoàn thành hành động chạy nhanh",
  T_38_WZY_WS_ONSQUAT_NAMEDESC: "Kích hoạt khi người chơi hoàn thành hành động ngồi xổm",
  T_38_WZY_WS_ONWAEPKILL_NAMEDESC: "Kích hoạt khi vũ khí tiêu diệt một đơn vị bất kì, [đơn vị bị tiêu diệt] giữ thông tin đơn vị đó",
  T_38_WZY_WS_ONWEAPDAMAGE_NAMEDESC: "Kích hoạt khi vũ khí sát thương đơn vị chiến đấu, gồm [Đơn vị bị sát thương] và [Sát thương gây ra]",
  T_38_WZY_WS_OWNER: "Chủ sở hữu",
  T_38_WZY_WS_PARAMLIST: "Danh sách ký tự đặc biệt",
  T_38_WZY_WS_PARTICALMAP: "Hoa văn hạt",
  T_38_WZY_WS_PAUSEMOTE_NAMEDESC: "Dừng hoặc tiếp tục hành động biểu cảm cho [đơn vị người chơi].",
  T_38_WZY_WS_PLAENTTRI_DESC: "Kích hoạt khi người chơi vào trình kích hoạt",
  T_38_WZY_WS_PLAQUITTRI_DESC: "Được kích hoạt khi người chơi rời khỏi trình kích hoạt",
  T_38_WZY_WS_PLAYEMOTE_NAMEDESC: "Bắt buộc [đơn vị người chơi] làm hành động [biểu cảm] một lần, sau đó quay lại tình trạng ban đầu.",
  T_38_WZY_WS_PLAYSPEED: "Tốc độ phát lại theo phần trăm",
  T_38_WZY_WS_PREHUD_NAME: "Biểu tượng tạm thời",
  T_38_WZY_WS_QUITFACTION_NAMEDESC: "Cho phép [đơn vị người dùng] thoát đội hiện tại",
  T_38_WZY_WS_RESETENT: "Đặt lại các thành phần mỗi vòng",
  T_38_WZY_WS_RESUUID: "Tài nguyên UUID",
  T_38_WZY_WS_RIMCOLOR: "Màu viền",
  T_38_WZY_WS_RIMTEXTURE: "Chất liệu viền",
  T_38_WZY_WS_SECTORJUD_NAMEDESC: "Kiểm tra vật thể có nằm trong hình quạt, gồm [Tâm], [Bán kính lớn], [Bán kính nhỏ], [chiều cao]",
  T_38_WZY_WS_SECTORJUD_RES: "Kết quả hàm kiểm tra phạm vi hình quạt. Trả về giá trị đúng hoặc sai.",
  T_38_WZY_WS_SETACTIVE_NAMEDESC: "Thiết lập trạng thái hoạt động của [đơn vị mục tiêu]. [Trạng thái hoạt động] là giá trị đúng sai.",
  T_38_WZY_WS_SETROUNDSCORE: "Cài đặt điểm trong vòng của người chơi",
  T_38_WZY_WS_SHOOTANGMAX: "Góc bắn tối đa",
  T_38_WZY_WS_SHOWMAPINFO: "Hiển thị thông tin bản đồ cùng bên",
  T_38_WZY_WS_SHOWNAMEHUD: "Hiển thị tên HUD cho cùng một phe",
  T_38_WZY_WS_SOUND1: "Thiết bị gia tốc",
  T_38_WZY_WS_SOUND10: "Bắt đầu giai đoạn",
  T_38_WZY_WS_SOUND11: "Nền xác sống",
  T_38_WZY_WS_SOUND12: "Nền kinh dị",
  T_38_WZY_WS_SOUND13: "Biến hình",
  T_38_WZY_WS_SOUND14: "Tim đập thình thịch",
  T_38_WZY_WS_SOUND15: "Nhịp tim trung bình",
  T_38_WZY_WS_SOUND16: "Nhịp tim chậm",
  T_38_WZY_WS_SOUND17: "Rush Time",
  T_38_WZY_WS_SOUND18: "Click",
  T_38_WZY_WS_SOUND19: "Hồi kỹ năng",
  T_38_WZY_WS_SOUND2: "Thông báo biến mất",
  T_38_WZY_WS_SOUND20: "Tham gia 1 trận",
  T_38_WZY_WS_SOUND3: "Hiệu ứng hình ảnh",
  T_38_WZY_WS_SOUND4: "Tiếng sâu đêm",
  T_38_WZY_WS_SOUND5: "Tấn công (nhàm chán)",
  T_38_WZY_WS_SOUND6: "Hưởng ứng",
  T_38_WZY_WS_SOUND7: "Phát hiện bất ngờ",
  T_38_WZY_WS_SOUND8: "Con ma quấy rối",
  T_38_WZY_WS_SOUNDENT: "Đơn vị âm thanh",
  T_38_WZY_WS_SPAWNPOS: "Điểm xuất hiện cũ",
  T_38_WZY_WS_SPHERENAME: "Hình cầu cơ bản",
  T_38_WZY_WS_SPHERERADIUS: "Bán kính hình cầu",
  T_38_WZY_WS_SPHERICALJUD_NAMEDESC: "Kiểm tra vật thể có nằm trong hình cầu, trong đó phải cho trước [tâm] và [bán kính] của hình cầu.",
  T_38_WZY_WS_SPHERICALJUD_RES: "Kết quả của hàm kiểm tra phạm vi cầu, giá trị trả về là đúng hoặc sai",
  T_38_WZY_WS_SQUAREJUD_NAMEDESC: "Kiểm tra vật thể nằm trong hình lập phương, bao gồm [Tâm], [chiều dài], [chiều rộng] và [chiều cao]",
  T_38_WZY_WS_SQUAREJUD_RES: "Kết quả kiểm tra phạm vi hình lập phương. Trả về giá trị đúng hoặc sai.",
  T_38_WZY_WS_STARTGENTIME: "Thời gian bắt đầu hồi sinh",
  T_38_WZY_WS_STAYTIME: "Thời gian chờ",
  T_38_WZY_WS_SWITCHCAM_NAMEDESC: "Chuyển camera của người chơi sang [vật thể camera]",
  T_38_WZY_WS_SWITCHCAM_PARAM3_DESC: "Đổi chế độ camera, có thể chỉnh giữa [Di chuyển ngay lập tức] hoặc [Di chuyển trơn mượt]",
  T_38_WZY_WS_SWITCHCAM_PARAM4_DESC: "Thời gian chuyển camera khi [Di chuyển trơn mượt].",
  T_38_WZY_WS_TEXTHUD: "Thành phần HUD văn bản",
  T_38_WZY_WS_TEXTTYPE: "Kích thước font",
  T_38_WZY_WS_TEXTUREID: "Loại chất liệu",
  T_38_WZY_WS_TRANDIST: "Khoảng cách tối đa",
  T_38_WZY_WS_TWEENERENABLED: "Mở lệnh UITweener hay không",
  T_38_WZY_WS_TYPELIST: "Loại danh sách",
  T_38_WZY_WS_TYPELISTORLIST: "Nhập hoặc nhập danh sách",
  T_38_WZY_WS_VEST_NAME: "Đơn vị giáp",
  T_38_WZY_WS_VFX1: "Tiêu diệt kẻ lẩn trốn",
  T_38_WZY_WS_VFX10: "Cháy theo chu kỳ",
  T_38_WZY_WS_VFX11: "Khí độc",
  T_38_WZY_WS_VFX13: "Trái tim",
  T_38_WZY_WS_VFX15: "Cánh cửa",
  T_38_WZY_WS_VFX2: "Bạo tẩu (bùng nổ)",
  T_38_WZY_WS_VFX3: "Phân thân bị tiêu diệt",
  T_38_WZY_WS_VFX4: "Phản hồi bắn",
  T_38_WZY_WS_VFX5: "Phân thân",
  T_38_WZY_WS_VFX6: "Biến hình",
  T_38_WZY_WS_VFX7: "Khói bom pháo sáng",
  T_38_WZY_WS_VFX8: "Theo đuôi",
  T_38_WZY_WS_VFX9: "Đạn lửa",
  T_38_WZY_WS_VFXENT: "Ví dụ hiệu ứng",
  T_38_WZY_WS_VFXTYPEA_NAME: "Có thể đổi hiệu ứng Texture",
  T_38_WZY_WS_VFXTYPEB_NAME: "Không thể đổi hiệu ứng Texture",
  T_38_WZY_WS_VISIBILITY: "Loại hiển thị",
  T_38_WZY_WS_VOLUME: "Thể tích",
  T_38_WZY_WS_WEAPONGEN: "Máy tạo vũ khí",
  T_38_WZY_WS_WHECYCLE: "Lặp lại",
  T_38_XXJ_WS_BLOCKMODE: "Chế độ chặn",
  T_38_XXJ_WS_CUSTOMCAMARA: "Camera tùy chỉnh",
  T_38_XXJ_WS_FFCLASSIC: "Góc nhìn FF",
  T_38_XXJ_WS_FOV: "Tầm nhìn",
  T_38_XXJ_WS_FOVDESC: "Tầm nhìn là phạm vi quan sát của Camera.",
  T_38_XXJ_WS_FPS: "Góc nhìn FPS",
  T_38_XXJ_WS_HORIZONTALANGLE: "Góc ngang",
  T_38_XXJ_WS_INVISICAM: "Bán trong suốt",
  T_38_XXJ_WS_OFFSET: "Độ lệch",
  T_38_XXJ_WS_ORTHOGRAPHIC: "Phép chiếu 2D",
  T_38_XXJ_WS_PERSPECTIVE: "Phép chiếu 3D",
  T_38_XXJ_WS_PROJECTIONMODE: "Góc chiếu",
  T_38_XXJ_WS_STABLE: "Ổn định",
  T_38_XXJ_WS_STARTCAMERA: "Camera mặc định",
  T_38_XXJ_WS_STARTCAMERAMODE: "Chế độ mặc định",
  T_38_XXJ_WS_THIRD: "Camera theo sau",
  T_38_XXJ_WS_TOPVIEW: "Góc nhìn trên xuống",
  T_38_XXJ_WS_TPS: "Góc nhìn TPS",
  T_38_XXJ_WS_TRANSVERSE: "Góc nhìn ngang",
  T_38_XXJ_WS_VERTICALANGLE: "Góc dọc",
  T_38_XXJ_WS_ZOOM: "Phóng đại",
  T_38_XYL_WS_AISTARTTIME: "Thời gian bắt đầu (giây)",
  T_38_XYL_WS_ARMORDESTROY: "Hệ số sát thương lên giáp",
  T_38_XYL_WS_BONFIRE: "Lửa trại",
  T_38_XYL_WS_CANDLE01: "Nến A",
  T_38_XYL_WS_CANNON01: "Pháo cơ giới",
  T_38_XYL_WS_CLIPAMMOSIZE: "Băng đạn",
  T_38_XYL_WS_DAMAGEDTRUCK: "Xe tải bị hư hỏng",
  T_38_XYL_WS_DOLL01: "Búp bê kỳ lạ",
  T_38_XYL_WS_ENTERANCEHOUSE01: "Nhà gạch A",
  T_38_XYL_WS_FENCE002: "Hàng rào sắt B",
  T_38_XYL_WS_FIREWORK01: "Pháo hoa A",
  T_38_XYL_WS_GENERATOR: "Trạm phát vật phẩm",
  T_38_XYL_WS_GRAVITY: "Gia tốc trọng trường",
  T_38_XYL_WS_GRAVITYAREA: "Vùng trọng lực bất thường",
  T_38_XYL_WS_GRAVITYAREA_DESC: "Một khu vực mà người chơi thay đổi được trọng lực",
  T_38_XYL_WS_HOLDWEAPON: "Vũ khí sử dụng",
  T_38_XYL_WS_INDOORFURNITURE: "Nội thất trong nhà",
  T_38_XYL_WS_LIGHTTUBE001: "Đèn tuýp A",
  T_38_XYL_WS_LOVEBALLOON01: "Bong bóng Valentine A",
  T_38_XYL_WS_LOVELAMP01: "Đèn đường trái tim",
  T_38_XYL_WS_LOVESIGN01: "Đèn neon tình yêu",
  T_38_XYL_WS_OILDRUM_DAMAGE: "Sát thương xăng",
  T_38_XYL_WS_OUTDOORPROPS: "Vật phẩm ngoài trời",
  T_38_XYL_WS_PIPEANDBOX: "Ống và thùng Container",
  T_38_XYL_WS_PLANT: "Cây",
  T_38_XYL_WS_ROSE01: "Hoa hồng",
  T_38_XYL_WS_ROSEN: "Bó hoa hồng",
  T_38_XYL_WS_SMALLBUILDING: "Tòa nhà nhỏ",
  T_38_XYL_WS_SOFA002: "Sofa B",
  T_38_XYL_WS_TOWNHOUSE01: "Nhà 2 Tầng Cũ",
  T_38_XYL_WS_TV001: "TV cũ",
  T_38_ZP_CC_EXCHANGESTATUS: "Trạng thái",
  T_39_BQ_SKILL_NAME_VILLAIN: "Huyết Cầu Bảo Hộ",
  T_39_CJ_A_BURN: "Mặt nạ chiến thần",
  T_39_HJ_WS_Arrow002: "Mũi tên 2",
  T_39_HJ_WS_LIKERATE2: "{0} phút",
  T_39_HJ_WS_LIKERATE3: "{0} - {1} phút",
  T_39_HJ_WS_SOUND10: "Bước chân",
  T_39_HJ_WS_SOUND11: "Hoàn thành nhiệm vụ 1",
  T_39_HJ_WS_SOUND13: "Báo động nguy hiểm 1",
  T_39_HJ_WS_SOUND14: "Báo động nguy hiểm 2",
  T_39_HJ_WS_SOUND15: "Đếm ngược 3",
  T_39_HJ_WS_SOUND16: "Âm thanh cho hướng dẫn",
  T_39_HJ_WS_SOUND17: "Quạ kêu",
  T_39_HJ_WS_SOUND18: "Dịch chuyển tới khu vực sai",
  T_39_HJ_WS_SOUND19: "Dịch chuyển tới khu vực đúng",
  T_39_HJ_WS_SOUND2: "Đếm ngược 1",
  T_39_HJ_WS_SOUND20: "Dịch chuyển",
  T_39_HJ_WS_SOUND21: "Giật điện",
  T_39_HJ_WS_SOUND23: "Nhặt được đồ",
  T_39_HJ_WS_SOUND24: "Nhạc nền điện tử dễ thương",
  T_39_HJ_WS_SOUND25: "Nhạc nền game giải trí",
  T_39_HJ_WS_SOUND4: "Âm vang thiết bị máy móc",
  T_39_HJ_WS_SOUND5: "Muỗi",
  T_39_HJ_WS_SOUND6: "Ding ding ding 1",
  T_39_HJ_WS_SOUND7: "Ding ding ding 2",
  T_39_HJ_WS_SOUND8: "Đã trang bị giáp",
  T_39_HJ_WS_SOUND9: "Tiến công 1",
  T_39_HJ_WS_UNLIMITEDGLOOWALL: "Vô hạn bom keo",
  T_39_HJ_WS_UNLIMITEDTHROWABLES: "Vô hạn vật ném",
  T_39_HQ_EVOGUN2_SOUNDEQUIP3: "Tiếng súng đặc biệt",
  T_39_HQ_UGC_CUSTOMRES: "Tài nguyên tùy chọn",
  T_39_M_ACCOUNTID: "Tài khoản",
  T_39_M_WS_BUTTON_DOUBLECLICKDESC: "Thực hiện sau khi ấn hai lần",
  T_39_MF_SKILLTAG_4: "DI CHUYỂN",
  T_39_PD_HuntingGroundSnow_MYNAME: "Mr.V",
  T_39_QL_SKILL_OTHO_DES: "Sau khi hạ gục kẻ địch, đánh dấu đồng đội kẻ địch trong phạm vi [FFB300]{0}m[-] tính từ kẻ địch bị hạ gục và làm chậm tốc độ di chuyển của chúng [FFB300]{1}%[-]. Kéo dài trong [FFB300]{2}s[-]. Khi bị hạ gục bởi kẻ địch ở gần, đánh dấu và làm chậm kẻ địch , đồng đội của kẻ địch xung quanh.",
  T_39_QL_SKILL_WOLFRAHH_DES: "Sau khi hạ kẻ thù, chuyển sang chế độ Highlight đồng thời tăng tốc độ bắn thêm [FFB300]{0}%[-] và tốc độ di chuyển thêm [FFB300]{1}%[-] nhưng sau đó giảm xuống nhanh chóng. Kéo dài trong [FFB300]{2}s[-]. Trong chế độ Highlight, liên tục hạ gục kẻ thù sẽ đặt lại đếm ngược và tăng thêm tốc độ bắn [FFB300]{3}%[-] và tốc độ di chuyển thêm [FFB300]{4}%[-].",
  T_39_QL_SKILL_XAYNE_DES1: "Chế độ Cuồng Bạo: Nhận [FFB300]{0} máu tạm thời[-] trong [FFB300]{1}s[-]. Trong thời gian này, các hiệu ứng hồi phục máu tăng [FFB300]{2}%[-]. Thời gian hồi: [FFB300]{3}s[-].",
  T_39_RW_GM_DEFEAT: "Thất bại",
  T_39_RW_SKILL_DESC_FORD: "Khi nhận sát thương, tăng [FFB300]{1} HP/s[-] trong[FFB300]{0}s[-]. Kỹ năng này của bạn sẽ được thiết lập lại ngay lập tức sau khi bạn kích hoạt kỹ năng chủ động.Thời gian làm mới: [FFB300]{2}s[-].",
  T_39_SP_WS_ITEMENTITY_01: "Đơn vị Vật phẩm",
  T_39_SY_CHARACTER_ALVARO_AWAKENING_N: "Alvaro Thức Tỉnh",
  T_39_SY_CHARACTER_VILLAIN_N: "Orion",
  T_39_SY_KATANA_FASTBREAKING23_N: "Katana - Lữ Khách",
  "T_39_SY_PETSKIN_FLYINGCREATURE_FB23 _N": "Arvon Xa Lánh",
  "T_39_SY_PETSKIN_TIGER_BDFEST _N": "Tiểu Hổ Hoàng Gia",
  "T_39_SY_PETSKIN_WOLF_SCARLET _N": "Fang Huyết Hỏa",
  T_39_SY_VEHICLESKIN_MONSTER_TRUCK_FASTBREAKING23_N: "Xe thính - Lữ Khách Hành Hương",
  T_39_SY_VEHICLESKIN_TUTU_BDFEST_N: "Tuk Tuk Lễ hội",
  T_39_WH_SKILL_DESC_GRENADESPLIT: "Thức tỉnh: [FFB300]{0}s[-] trước khi phát nổ, lựu đạn sẽ tạo thêm [FFB300]{1}[-] lựu đạn nhỏ hơn, có thể gây [FFB300]{2}%[-] sát thương so với ban đầu.",
  T_39_WH_SKILL_NAME_GRENADESPLIT: "Bom phân hạch",
  T_39_WT_WS_EMPTYMAP_TAG: "Trống",
  T_39_WT_WS_FEMAPMODE: "Tên chế độ",
  T_39_WT_WS_FEMAPTAG: "Tag bản đồ",
  T_39_WT_WS_MAPPLAYER: "Số người chơi",
  T_39_WT_WS_MEDENTERNUM: "Giới hạn số người tham gia giữa game",
  T_39_WT_WS_MIDENTER: "Tham gia giữa game",
  T_39_WT_WS_MIDENTERCOUNT: "Giới hạn tham gia giữa game",
  T_39_WT_WS_MIDENTERTIME1: "Giới hạn thời gian tham gia giữa game",
  T_39_WT_WS_MIDENTERTIME2: "Thời lượng tham gia giữa game",
  T_39_WT_WS_MIDENTERTIMETIP: "Khi không đạt đến giới hạn số người chơi trên bản đồ, cho phép người chơi tham gia trong vòng N giây sau khi trận đấu bắt đầu. Người chơi không thể tham gia sau N giây.",
  T_39_WT_WS_MIDENTERTIP: "Khi bật, người chơi có thể tham gia bản đồ này giữa trò chơi.",
  T_39_WT_WS_PLAYERCOUNT: "Số người chơi bản đồ",
  T_39_WT_WS_PLAYERCOUNTTIP: "Số người chơi khi trận đấu bắt đầu. Nhiều người chơi hơn có thể tham gia vào giữa trò chơi cho đến khi đạt đến giới hạn của bản đồ.",
  T_39_WT_WS_TAG1: "Loạn chiến",
  T_39_WT_WS_TAG10: "Dễ",
  T_39_WT_WS_TAG11: "Trung bình",
  T_39_WT_WS_TAG12: "Khó",
  T_39_WT_WS_TAG13: "Thách thức",
  T_39_WT_WS_TAG14: "Chạy trốn",
  T_39_WT_WS_TAG16: "VIP",
  T_39_WT_WS_TAG17: "Tài nguyên tùy chọn",
  T_39_WT_WS_TAG18: "Giải đố",
  T_39_WT_WS_TAG19: "Đua xe",
  T_39_WT_WS_TAG2: "Đấu súng",
  T_39_WT_WS_TAG20: "Nhạc",
  T_39_WT_WS_TAG21: "MOBA",
  T_39_WT_WS_TAG22: "Phiêu lưu",
  T_39_WT_WS_TAG23: "Thợ Săn Thây Ma",
  T_39_WT_WS_TAG24: "PvP",
  T_39_WT_WS_TAG25: "Trò Chơi Hội Nhóm",
  T_39_WT_WS_TAG26: "Liên hoàn chiến",
  T_39_WT_WS_TAG27: "Thủ Thành",
  T_39_WT_WS_TAG28: "Huấn luyện",
  T_39_WT_WS_TAG3: "Bậc Thầy Vũ Khí",
  T_39_WT_WS_TAG4: "Hồi sinh",
  T_39_WT_WS_TAG5: "Bắn tỉa",
  T_39_WT_WS_TAG6: "Sinh tồn",
  T_39_WT_WS_TAG7: "Solo",
  T_39_WT_WS_TAG8: "Kinh dị",
  T_39_WT_WS_TAG9: "Thường",
  T_39_WT_WS_TAGMAXTIP: "Có thể chọn tới {0} tag",
  T_39_WT_WS_TAGTYPE1: "Loại gameplay",
  T_39_WT_WS_TAGTYPE2: "Loại bản đồ",
  T_39_WT_WS_TAGTYPE3: "Loại chế độ",
  T_39_WT_WS_TAGTYPE4: "Kích cỡ đội",
  T_39_WZY_WS_ACCSPEED: "Gia tốc",
  T_39_WZY_WS_ADDSCRIPT_NAMEDESC: "Thêm script [tên script] cho [đơn vị]",
  T_39_WZY_WS_ASC: "Tăng dần",
  T_39_WZY_WS_ASCIGZERO: "Bỏ 0 khi tăng dần",
  T_39_WZY_WS_BALLISTMOVENT: "Đơn vị đạn đạo",
  T_39_WZY_WS_BEUSED_NAMEDESC: "Được kích hoạt khi vật phẩm được sử dụng bởi [Thực thể người chơi]",
  T_39_WZY_WS_BODYSCALE: "Tỉ lệ cơ thể",
  T_39_WZY_WS_BRAKETORQUE: "Mã lực thắng",
  T_39_WZY_WS_CAMTRANTYPE: "Loại chuyển tiếp camera",
  T_39_WZY_WS_CARVEHICLE: "Phương tiện 4 bánh",
  T_39_WZY_WS_CHECKSCRIPT_NAMEDESC: "Kiểm tra xem script [tên script] có tồn tại trong [đơn vị]. Giá trị trả về là đúng sai.",
  T_39_WZY_WS_CHECKSCRIPT_RES: "Kiểm tra xem [đơn vị] có kết quả của một script (trả về đúng sai)",
  T_39_WZY_WS_COMBINEALL: "Tay đôi (khác kiểu súng)",
  T_39_WZY_WS_COMBINESELF: "Tay đôi (cùng loại súng)",
  T_39_WZY_WS_CONENAME: "Khối nón cơ bản",
  T_39_WZY_WS_COORSYS: "Hệ tọa độ",
  T_39_WZY_WS_CRASHMAXD: "Sát thường tông cao nhất",
  T_39_WZY_WS_CRASHMIND: "Sát thương tông thấp nhất",
  T_39_WZY_WS_CRAWLSPEED: "Tỷ suất tốc độ di chuyển (Nằm sắp)",
  T_39_WZY_WS_CREBALLISTMOV_NAMEDESC: "Tạo chuyển động đạn đạo cho [Đơn vị mục tiêu]. Điều chỉnh được [Tốc độ ban đầu], [Gia tốc], [Khoảng cách tối đa] đạt được trong từ hướng di chuyển ban đầu. Trả về [Đơn vị đạn đạo]",
  T_39_WZY_WS_CRETWEEN_NAME: "Tạo chuyển động nội suy",
  T_39_WZY_WS_CRETWEEN_NAMEDESC: "Tạo chuyển động nội suy cho [Đơn vị], với các [Thuộc tính] của đơn vị thay đổi trơn tru từ [Giá trị đầu] đến [Giá trị đích] theo [Thời gian]. [Phương thức] chỉnh độ mượt của thay đổi, bao gồm [Tuyến tính], [Qua lại 2 chiều], [Vòng lặp]. [Quỹ đạo] là đường đi của chuyển động. Trả về [Đơn vị chuyển động nội suy]",
  T_39_WZY_WS_CURVE: "Quỹ đạo",
  T_39_WZY_WS_CUSTRESULT: "Kết quả trận đấu tự chọn",
  T_39_WZY_WS_CYLINDERNAME: "Khối trụ cơ bản",
  T_39_WZY_WS_DEFAULT: "Không có hoạt ảnh (Mặc định)",
  T_39_WZY_WS_DESC: "Giảm dần",
  T_39_WZY_WS_DIFFUSEALPHA: "Độ trong suốt bề mặt",
  T_39_WZY_WS_DISCONNECT: "Ngắt kết nối",
  T_39_WZY_WS_DOUBLEJUMPSHOE_ENERGYRECOVERY: "Năng lượng hồi phục mỗi giây",
  T_39_WZY_WS_DOUBLEJUMPSHOE_JUMCONSUME: "Tốn năng lượng",
  T_39_WZY_WS_DOUBLEJUMPSHOE_MAXJUMPH: "Độ cao tối đa khi nhảy lần hai",
  T_39_WZY_WS_ENABLEJOIN: "Cho phép gia nhập khi đang trong trận",
  T_39_WZY_WS_ENDPOS: "Điểm cuối toạ độ",
  T_39_WZY_WS_ENGINETORQUE: "Mã lực phương tiện",
  T_39_WZY_WS_EXPLODED: "Sát thương vụ nổ",
  T_39_WZY_WS_FEELDSPEED: "Tỷ suất tốc độ di chuyển (Bị hạ gục)",
  T_39_WZY_WS_FLASH_CFLASHTIME: "Thời gian đốt sáng trung tâm",
  T_39_WZY_WS_FLASH_CRANGE: "Phạm vi trung tâm",
  T_39_WZY_WS_FLASH_EFLASHTIME: "Thời gian đốt sáng ngoài rìa",
  T_39_WZY_WS_FLASH_HITEFFECTSWITCH: "Hiệu ứng dính bom choáng",
  T_39_WZY_WS_FLASH_RANGE: "Phạm vi nổ",
  T_39_WZY_WS_FOLDWINGS_FALLSPEED: "Tốc độ hạ cánh",
  T_39_WZY_WS_FOLDWINGS_FLYMAXH: "Độ cao nhất có thể bay lên",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDH: "Tốc độ lượt ngang",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDV: "Tốc độ lướt dọc",
  T_39_WZY_WS_FOLDWINGS_MINENDH: "Độ cao hạ cánh thấp nhất",
  T_39_WZY_WS_FOLDWINGS_MINFLYH: "Độ cao cất cánh thấp nhất",
  T_39_WZY_WS_FOLDWINGS_OVERHFALLSPEED: "Tốc độ rơi sau khi bay vượt ngưỡng cao",
  T_39_WZY_WS_FOLDWINGS_TURNSPEED: "Tốc độ xoay",
  T_39_WZY_WS_FOLMOVENT: "Đơn vị chuyển động đi theo",
  T_39_WZY_WS_GETSKILLLIST_NAMEDESC: "Lấy danh sách kỹ năng của [Đơn vị người chơi]",
  T_39_WZY_WS_HB_BOOSTCD: "Thời gian hồi chiêu sau lướt",
  T_39_WZY_WS_HB_BOOSTDURATION: "Thời gian lướt",
  T_39_WZY_WS_HB_BOOSTINITIAL: "Thời gian hồi chiêu lướt ván",
  T_39_WZY_WS_HB_BOOSTINITIALSWITCH: "Thời gian hồi chiêu lướt ván",
  T_39_WZY_WS_HB_BOOSTSPEED: "Tốc độ lướt",
  T_39_WZY_WS_HB_HOVERBCD: "Thời gian hồi phục ván trượt",
  T_39_WZY_WS_HB_JUMPCD: "Thời gian hồi chiêu nhảy",
  T_39_WZY_WS_HB_JUMPH: "Độ nhảy cao của ván trượt",
  T_39_WZY_WS_HEADSCALE: "Tỉ lệ đầu",
  T_39_WZY_WS_HEADSHOTDESCALE: "Sát thương headshot giảm trừ",
  T_39_WZY_WS_INTITALSPEED: "Tốc độ ban đầu",
  T_39_WZY_WS_INVENTORYBASE: "Các loại vật phẩm cơ bản",
  T_39_WZY_WS_JETSHOE_BASEENERGYCOST: "Năng lượng tiêu hao mỗi giây",
  T_39_WZY_WS_JETSHOE_BASEHSPEED: "Tốc độ di chuyển chiều ngang",
  T_39_WZY_WS_JETSHOE_BASEVSPEED: "Tốc độ di chuyển chiều dọc",
  T_39_WZY_WS_JETSHOE_DASHENERGYCOST: "Năng lượng bay lướt mỗi giây",
  T_39_WZY_WS_JETSHOE_DASHHSPEED: "Tốc độ di chuyển nhanh chiều ngang",
  T_39_WZY_WS_JETSHOE_RUSHDIS: "Khoảng cách bay nhanh",
  T_39_WZY_WS_JETSHOE_RUSHENERGYCOST: "Năng lượng bay nhanh mỗi giây",
  T_39_WZY_WS_JETSHOE_RUSHVSPEED: "Tốc độ di chuyển nhanh chiều dọc",
  T_39_WZY_WS_JETSHOE_UPENERGYCOST: "Năng lượng bay cao mỗi giây",
  T_39_WZY_WS_LANDMINE_CANBEATTACK: "Có thể bị tấn công",
  T_39_WZY_WS_LANDMINE_CANSELFTRIGGER: "Có thể tự kích hoạt",
  T_39_WZY_WS_LANDMINE_CANTEAMTRIGGER: "Có thể kích hoạt bởi đồng minh hay không",
  T_39_WZY_WS_LANDMINE_CANVEHICLETRIGGER: "Kích hoạt thông qua phương tiện",
  T_39_WZY_WS_LANDMINE_LIFETIME: "Thời lượng",
  T_39_WZY_WS_LANDMINE_STARTTIME: "Thời gian kích hoạt",
  T_39_WZY_WS_LANDMINE_TRIGGERRADIUS: "Bán kích kích hoạt",
  T_39_WZY_WS_LANDMINE_TRIGGERTIME: "Thời gian kích hoạt",
  T_39_WZY_WS_LEAVE: "Thoát",
  T_39_WZY_WS_LIMBSCALE: "Tỉ lệ chân tay",
  T_39_WZY_WS_LISTLOCSTR: "Danh sách từ khóa đã dịch",
  T_39_WZY_WS_LOADRESULT_NAME: "Đăng kết quả trận đấu",
  T_39_WZY_WS_LOADRESULT_NAMEDESC: "Đăng kết quả trận đấu của [Người chơi], bao gồm [Hạng], [Kết quả], [Tên điểm], [Số điểm]. Kết quả bao gồm các kiểu theo biến số tự nhiên, 1 là thắng, 2 là thua, 3 là Booyah, 4 là hòa.",
  T_39_WZY_WS_LOOKMOVENT: "Đơn vị chuyển động đi theo tầm nhìn",
  T_39_WZY_WS_MAXCOUNT: "Số lượng tối đa",
  T_39_WZY_WS_MAXDISTANCE: "Khoảng cách tối đa",
  T_39_WZY_WS_MINISENTRY_ANGELDOWN: "Góc hướng xuống của tháp pháo",
  T_39_WZY_WS_MINISENTRY_ANGELSPEED: "Tốc độ xoay của tháp pháo",
  T_39_WZY_WS_MINISENTRY_ANGELUP: "Góc hướng lên của tháp pháo",
  T_39_WZY_WS_MINISENTRY_DAM: "Sát thương tháp pháo",
  T_39_WZY_WS_MINISENTRY_DEFENSE: "Độ phòng thủ giảm sát thương",
  T_39_WZY_WS_MINISENTRY_FIREANGLE: "Góc bắn",
  T_39_WZY_WS_MINISENTRY_HITCHANCE: "Độ chính xác của tháp pháo",
  T_39_WZY_WS_MINISENTRY_INTERVAL: "Tần suất tấn công của tháp pháo",
  T_39_WZY_WS_MINISENTRY_MAXCOUNT: "Số tháp pháo tối đa",
  T_39_WZY_WS_MINISENTRY_RANGE: "Phạm vi tấn công của tháp pháo",
  T_39_WZY_WS_MOVEENT: "Đơn vị chuyển động",
  T_39_WZY_WS_NOCOMBINE: "Không thể trang bị tay đôi",
  T_39_WZY_WS_ONCE: "Một lần",
  T_39_WZY_WS_ONDROP_NAMEDESC: "Được kích hoạt khi vật phẩm bị loại bỏ bởi [Thực thể người chơi]",
  T_39_WZY_WS_ONEQUIP_NAMEDESC: "Được kích hoạt khi vật phẩm được trang bị bởi [Thực thể người chơi]",
  T_39_WZY_WS_ONGRAPFIRE_NAMEDESC: "Kích hoạt khi bắn súng dây móc",
  T_39_WZY_WS_ONLANDSTART_NAMEDESC: "Kích hoạt khi mìn được kích hoạt",
  T_39_WZY_WS_ONLANDTRIGGER_NAMEDESC: "Được kích hoạt khi mìn được kích hoạt bởi [Player Enitity]",
  T_39_WZY_WS_ONMOTIONPAUSE_NAMEDESC: "Kích hoạt khi đơn vị ngừng di chuyển",
  T_39_WZY_WS_ONMOTIONREATART_NAMEDESC: "Kích hoạt khi đơn vị di chuyển lại từ đầu từ trạng thái dừng",
  T_39_WZY_WS_ONMOTIONSTART_NAMEDESC: "Kích hoạt khi đơn vị bắt đầu di chuyển",
  T_39_WZY_WS_ONPICKUP_NAMEDESC: "Được kích hoạt khi vật phẩm được nhặt bởi [Thực thể người chơi]",
  T_39_WZY_WS_ONTHROWHIT_NAMEDESC: "Kích hoạt khi vật thể ném trúng mục tiêu",
  T_39_WZY_WS_OPENATTACK: "Cho phép tấn công",
  T_39_WZY_WS_PAUSEMOV_NAMEDESC: "Ngưng Đơn vị chuyển động hoặc Danh sách đơn vị chuyển động",
  T_39_WZY_WS_PAUSESOUND_NAME: "Dừng hiệu ứng âm thanh",
  T_39_WZY_WS_PAUSESOUND_NAMEDESC: "Dừng Đơn vị âm thanh hoặc Danh sách đơn vị âm thanh",
  T_39_WZY_WS_PIANOTYPE: "Loại phần tử âm thanh",
  T_39_WZY_WS_PINGPONG: "Qua lại 2 chiều",
  T_39_WZY_WS_PLAYABLELIST: "Danh sách thực thể chuyển động",
  T_39_WZY_WS_PLAYINGSTATUE: "Trạng thái",
  T_39_WZY_WS_PLAYMOV_NAMEDESC: "Phục hồi Đơn vị chuyển động hoặc Danh sách đơn vị chuyển động đã bị dừng. Có thể chọn tiếp tục hoặc lặp lại.",
  T_39_WZY_WS_PLAYSOUND_NAME: "Chơi hiệu ứng âm thanh",
  T_39_WZY_WS_PLAYSOUND_NAMEDESC: "Phục hồi Đơn vị âm thanh hoặc Danh sách đơn vị âm thanh đã dừng. Có thể chọn tiếp tục hoặc lặp lại.",
  T_39_WZY_WS_PROCIRCLE_NAME: "Tiến trình hình tròn",
  T_39_WZY_WS_RAYINSPCON_NAMEDESC: "Chiếu một tiêu theo [Hướng] từ [Tọa độ ban đầu], định danh tất cả đơn vị trúng tia trong [Khoảng cách], trả về [Danh sách đơn vị trúng] và [Tọa độ trúng]",
  T_39_WZY_WS_RAYINSPSIN_NAMEDESC: "Chiếu một tia theo [Hướng] từ [Tọa độ ban đầu], định danh đơn vị đầu tiên trúng tia trong [Khoảng cách], trả về [Đơn vị trúng] và [Tọa độ trúng]",
  T_39_WZY_WS_REAHEALHP: "Giá trị phục hồi áo giáp",
  T_39_WZY_WS_REAHEALTIME: "Khoảng thời gian có hiệu lực",
  T_39_WZY_WS_RELATCOORSYS: "Hệ tọa độ tương đối",
  T_39_WZY_WS_REPAIRARM: "Bộ sửa chữa",
  T_39_WZY_WS_REVERSE: "Đảo ngược",
  T_39_WZY_WS_RIMALPHA: "Độ trong suốt cạnh",
  T_39_WZY_WS_SCORENAME: "Tên điểm",
  T_39_WZY_WS_SENDSIGN_NAMEDESC: "Gửi tín hiệu tới [Đơn vị mục tiêu], các tham số truyền đi là các tham số tín hiệu định sẵn. Tùy theo kiểu đơn vị được định nghĩa từ đầu mà các tham số tín hiệu cho trước sẽ thay đổi.",
  T_39_WZY_WS_SETFOLMOV_NAMEDESC: "Tạo chuyển động đi theo vị trí cho [Đơn vị mục tiêu]. [Đơn vị mục tiêu] đi theo [Đơn vị bị đi theo]. [Độ li tọa độ] là độ lệch tọa độ giữa [Đơn vị mục tiêu] và [Đơn vị bị đi theo]. [Hệ tọa độ] có thể đổi thành Tọa độ độc lập hoặc Tọa độ tương đối tùy vào tư thế của [Đơn vị bị đi theo]. Trả về [Đơn vị chuyển động đi theo vị trí].",
  T_39_WZY_WS_SETLOOKMOV_NAMEDESC: "Tạo chuyển động đi theo tầm nhìn cho [Đơn vị mục tiêu]. [Đơn vị mục tiêu] đi theo [Đơn vị bị đi theo]. [Độ li tọa độ] là độ lệch tọa độ giữa [Đơn vị mục tiêu] và [Đơn vị bị đi theo]. [Hệ tọa độ] có thể đổi thành Tọa độ độc lập hoặc Tọa độ tương đối tùy vào tư thế của [Đơn vị bị đi theo]. Trả về [Đơn vị chuyển động đi theo tầm nhìn].",
  T_39_WZY_WS_SHOE_FALLDAMSCALE: "Tỷ suất sát thương do rơi tự do",
  T_39_WZY_WS_SHOE_MAXENERGY: "Năng lương tối đa",
  T_39_WZY_WS_SKILLLIST: "Danh sách kỹ năng",
  T_39_WZY_WS_SKILLTYPE: "Kỹ năng nhân vật",
  T_39_WZY_WS_SMOKEG_EFFECTTIME: "Thời gian hiệu ứng khói",
  T_39_WZY_WS_SMOOTH: "Đổi camera",
  T_39_WZY_WS_SOUNDENTL: "Danh sách đơn vị hiệu ứng âm thanh",
  T_39_WZY_WS_SOUNDENTLORSENT: "Đơn vị hiệu ứng âm thanh hoặc Danh sách",
  T_39_WZY_WS_SPRINTSPEED: "Tỷ suất tốc độ chạy nhanh",
  T_39_WZY_WS_SQUATSPEED: "Tỷ suất tốc độ di chuyển (Ngồi xổm)",
  T_39_WZY_WS_STARTCOO: "Tọa độ ban đầu",
  T_39_WZY_WS_STATE: "Trạng thái chơi",
  T_39_WZY_WS_TARGETVAL: "Giá trị đích",
  T_39_WZY_WS_THROWSPEED: "Tốc độ móc bay",
  T_39_WZY_WS_TOWER_PARAM10: "Góc quay",
  T_39_WZY_WS_TOWER_PARAM11: "Trạng thái tháp pháo",
  T_39_WZY_WS_TOWER_PARAM12: "ID Thực thể",
  T_39_WZY_WS_TOWER_PARAM9: "Mục tiêu tấn công",
  T_39_WZY_WS_TOWSPEED: "Tốc độ người chơi di chuyển",
  T_39_WZY_WS_TWEENCURVE_NAME: "Quỹ đạo tùy chọn",
  T_39_WZY_WS_TWEENCURVE_NAMEDESC: "Quỹ đạo tùy chọn dùng trong chuyển động nội suy",
  T_39_WZY_WS_TWEENENT: "Đơn vị chuyển động nội suy",
  T_39_WZY_WS_TWEENPLAYST_NAME: "Các phương thức chuyển động",
  T_39_WZY_WS_TWEENPLAYST_NAMEDESC: "Các phương thức chuyển động nội suy",
  T_39_WZY_WS_TWEENSTYLE: "Phương thức",
  T_39_WZY_WS_UNLOADSCRIPT_NAMEDESC: "Xóa script [tên script] cho [đơn vị]",
  T_39_WZY_WS_UPSET_NAMEDESC: "Xáo ngẫu nhiên danh sách phần tử",
  T_39_WZY_WS_VISIBLEONBACK: "Thấy được trên lưng",
  T_39_WZY_WS_WEAPCOMBINET: "Loại vũ khí tay đôi",
  T_39_WZY_WS_WEAPON_KNOCKDOWNDAM: "Sát thương thêm cho mục tiêu đang bị hạ gục",
  T_39_WZY_WS_WEAPON_ONCEAMMO: "Lượng đạn mỗi lần bắn",
  T_39_WZY_WS_WEAREPLAY: "Lặp lại chuyển động?",
  T_39_WZY_WS_WORLDCOORSYS: "Hệ tọa độ độc lập",
  T_39_XXJ_WS_ADDFRIEND: "Thêm bạn",
  T_39_XXJ_WS_ALLOWZ: "Cho phép chuyển động trục x của người chơi",
  T_39_XXJ_WS_BLOCKMODEDESC: "Cách xử lý của camera khi có vật đứng giữa camera và đối tượng",
  T_39_XXJ_WS_CAMERADISTANCE: "Khoảng cách đến đối tượng",
  T_39_XXJ_WS_CAMERATYPEDESC: "Thay đổi camera từ các thiết lập cho sẵn hoặc tự điều chỉnh thông số",
  T_39_XXJ_WS_CAMERAUSER: "Người dùng camera",
  T_39_XXJ_WS_CURENTCAMERA: "Camera đang dùng",
  T_39_XXJ_WS_DETAILS: "Chi tiết trận đấu",
  T_39_XXJ_WS_FFECONOMY: "Tài nguyên",
  T_39_XXJ_WS_FOCUSTARGET: "Đối tượng theo dõi",
  T_39_XXJ_WS_FOLLOWTARGET: "Đối tượng đi theo",
  T_39_XXJ_WS_GAMERESULT: "Kết quả trận",
  T_39_XXJ_WS_GAMETITLE1: "Trận 1",
  T_39_XXJ_WS_GAMETITLE2: "Trận 2",
  T_39_XXJ_WS_GIFT: "Quà tặng",
  T_39_XXJ_WS_HORIZONTALANGLEDESC: "Góc quay camera theo chiều ngang",
  T_39_XXJ_WS_INVISICAM: "Xuyên thấu",
  T_39_XXJ_WS_INVISICAMDESC: "Vật thể giữa camera và đối tượng sẽ bị tàng hình.",
  T_39_XXJ_WS_LEFTSCORE: "Điểm đội trái",
  T_39_XXJ_WS_LIKE: "Thích",
  T_39_XXJ_WS_LOBBY: "Sảnh chờ",
  T_39_XXJ_WS_MAINSCORENAME: "Tên của điểm tổng",
  T_39_XXJ_WS_MAINSCORENUM: "Số điểm tổng",
  T_39_XXJ_WS_MAPEVALUATE: "Đánh giá bản đồ",
  T_39_XXJ_WS_MULTITEAMRESULTHUD: "Kết quả tất cả đội",
  T_39_XXJ_WS_MVP1: "MVP 1",
  T_39_XXJ_WS_MVP2: "MVP 2",
  T_39_XXJ_WS_OFFSET2: "Khoảng cách đến điểm quan sát",
  T_39_XXJ_WS_OFFSET2DESC: "Tâm điểm của camera so với vị trí của người chơi (tùy thuộc vào kiểu camera đang sử dụng).",
  T_39_XXJ_WS_OFFSETDESC: "Vị trí của camera so với vị trí của người chơi (tùy thuộc vào kiểu camera đang sử dụng).",
  T_39_XXJ_WS_ORTHOGONAL: "Tầm nhìn 2D",
  T_39_XXJ_WS_ORTHOGONALDESC: "Camera bỏ đi chiều sâu, cho thấy tất cả vật thể xa lẫn gần đều cùng kích cỡ.",
  T_39_XXJ_WS_PERSPECTIVE: "Tầm nhìn 3D",
  T_39_XXJ_WS_PERSPECTIVEDESC: "Camera sử dụng phép chiếu 3D để quan sát đối tượng",
  T_39_XXJ_WS_PROJECTIONMODEDESC: "Cách camera cấu tạo hình ảnh khi xử lý môi trường 3D",
  T_39_XXJ_WS_RANK1: "Hạng đội",
  T_39_XXJ_WS_RANK2: "Hạng người chơi",
  T_39_XXJ_WS_REPORT: "Báo cáo",
  T_39_XXJ_WS_REVIEW: "Chơi lại",
  T_39_XXJ_WS_RIGHTSCORE: "Điểm đội phải",
  T_39_XXJ_WS_SCORENUM1: "Điểm 1",
  T_39_XXJ_WS_SCORENUM2: "Điểm 2",
  T_39_XXJ_WS_SCORENUM3: "Điểm 3",
  T_39_XXJ_WS_SCORENUM4: "Điểm 4",
  T_39_XXJ_WS_SCORENUM5: "Điểm 5",
  T_39_XXJ_WS_SCORETITLELIST: "Tên danh sách điểm",
  T_39_XXJ_WS_SHARE: "Chia sẻ",
  T_39_XXJ_WS_SPECTATORSWITCH: "Chế độ người xem",
  T_39_XXJ_WS_STABLE: "Ổn định",
  T_39_XXJ_WS_STABLEDESC: "Camera sẽ giữ ổn định nếu có một vật thể đứng giữa camera và đối tượng đang dõi theo.",
  T_39_XXJ_WS_TEAMNAME1: "Tên đội bên trái",
  T_39_XXJ_WS_TEAMNAME2: "Tên đội bên phải",
  T_39_XXJ_WS_TEAMRANK: "Hạng đội",
  T_39_XXJ_WS_TRANSITIONTIME: "Thời gian chuyển tiếp camera",
  T_39_XXJ_WS_TRANSITIONTYPE: "Loại chuyển tiếp camera",
  T_39_XXJ_WS_TWOTEAMRESULTHUD: "Kết quả 2 đội",
  T_39_XXJ_WS_VERTICALANGLEDESC: "Góc quay camera theo chiều dọc",
  T_39_XXJ_WS_ZOOM: "Thu phóng",
  T_39_XXJ_WS_ZOOMDESC: "Camera sẽ tự thu phóng nếu có một vật thể đứng giữa camera và đối tượng đang dõi theo.",
  T_39_XYL_WS_LIGHTINTENSITY: "Cường độ sáng",
  T_39_XYL_WS_LIGHTRANGE: "Tầm sáng",
  T_39_XYL_WS_POINTLIGHT: "Đèn chiếu sáng",
  T_39_XYL_WS_WATERZONE: "Tùy chỉnh vùng nước",
  T_40_B_DISABLE_RECONNECT: "Tắt tự động kết nối lại.",
  T_40_CJ_T_SHUTTLECOCK_BLACK: "Áo cầu thủ Indo đen",
  T_40_CJ_T_SHUTTLECOCK_RED2: "Áo cầu thủ Indo đỏ",
  T_40_CJ_T_SHUTTLECOCK_REDBLACK: "Áo cầu thủ Indo đỏ đen",
  T_40_CJ_T_SHUTTLECOCK_YELLOW: "Áo cầu thủ Indo vàng",
  T_40_CJ_T_SPORTSWEAR_FIRE: "Áo cầu thủ tay dài",
  T_40_DYEING_CLEAR: "Xóa màu đã tô",
  T_40_HJ_WS_EFFECT32: "Hiệu ứng giày thể thao",
  T_40_HJ_WS_EFFECT33: "Hiệu ứng nổ",
  T_40_HJ_WS_EFFECT34: "Hiệu ứng điểm xuất hiện",
  T_40_HJ_WS_EFFECT35: "Hiệu ứng laser",
  T_40_HJ_WS_EFFECT36: "Hiệu ứng đạn vũ khí",
  T_40_HJ_WS_EFFECT37: "Hiệu ứng đạn trúng mục tiêu",
  T_40_HJ_WS_EFFECT38: "Hiệu ứng Bắn",
  T_40_HJ_WS_EFFECT43: "Hiệu ứng mạng nhện",
  T_40_HJ_WS_EFFECT44: "Hiệu ứng kích hoạt kỹ năng",
  T_40_HJ_WS_SOUND69: "Mở hộp",
  T_40_HJ_WS_SOUND70: "Nâng cấp",
  T_40_HJ_WS_SOUND71: "Cấp độ tối đa",
  T_40_HJ_WS_SOUND72: "Nhấp vào nút",
  T_40_HJ_WS_SOUND73: "Đếm ngược 1",
  T_40_HJ_WS_SOUND74: "Tiếng còi",
  T_40_HJ_WS_SOUND75: "Trò chơi kết thúc",
  T_40_HJ_WS_SOUND76: "Tiến lên",
  T_40_HJ_WS_SOUND77: "Booyah",
  T_40_HJ_WS_SOUND78: "Cột mốc",
  T_40_HJ_WS_SOUND79: "Đếm ngược 2",
  T_40_HJ_WS_SOUND80: "Trò chơi bắt đầu",
  T_40_HJ_WS_SOUND81: "Nhận được số lượng lớn vàng",
  T_40_HJ_WS_SOUND82: "Nhận được vàng",
  T_40_HJ_WS_SOUND83: "Nhận được số lượng nhỏ vàng",
  T_40_HJ_WS_SOUND84: "Tham gia trận đấu",
  T_40_HJ_WS_SOUND85: "Mở lì xì của hội",
  T_40_HJ_WS_SOUND86: "Tiếng loa",
  T_40_HJ_WS_SOUND87: "Tiêu diệt boss",
  T_40_HJ_WS_SOUND88: "Mở Hòm chiến lợi phẩm",
  T_40_HJ_WS_SOUND89: "Kỹ năng Bùng nổ sắc màu",
  T_40_HJ_WS_SOUND90: "Trúng đạn",
  T_40_HJ_WS_SOUND91: "Kỹ năng Khiên sắc màu",
  T_40_HJ_WS_SOUND92: "Nhấn nút một nút bị tắt",
  T_40_HJ_WS_SOUND93: "Hồi chiêu hoàn tất",
  T_40_HJ_WS_SOUND95: "Kỹ năng laser",
  T_40_HJ_WS_SOUND96: "Nhận vật phẩm 2",
  T_40_HJ_WS_SOUND97: "Trò chơi kết thúc 2",
  T_40_HJ_WS_SOUND98: "Thông báo hạ gục",
  T_40_HJ_WS_SOUNDTYPE_BMG: "Nhạc nền",
  T_40_HJ_WS_SOUNDTYPE_INGAME: "Âm thanh trong trò chơi",
  T_40_HJ_WS_SOUNDTYPE_UI: "Âm thanh giao diện người dùng (UI)",
  T_40_JH_WS_MAPTAG1: "Trò chơi sắc màu",
  T_40_JH_WS_MAPTAG10: "Trốn tìm Sắc màu",
  T_40_JH_WS_MAPTAG11: "Kỷ niệm trò chơi",
  T_40_JH_WS_MAPTAG12: "Vai trò",
  T_40_JH_WS_MAPTAG13: "Mô phỏng",
  T_40_JH_WS_MAPTAG14: "Đấu trường bất cân",
  T_40_JH_WS_MAPTAG15: "Chiến đấu tài nguyên",
  T_40_JH_WS_MAPTAG16: "Hộ tống",
  T_40_JH_WS_MAPTAG17: "Bản đồ chính thức",
  T_40_JH_WS_MAPTAG18: "Mini Game",
  T_40_JH_WS_MAPTAG19: "Thức thách tốc độ",
  T_40_JH_WS_MAPTAG2: "Phun Sắc màu",
  T_40_JH_WS_MAPTAG20: "Giả mạo",
  T_40_JH_WS_MAPTAG3: "Trận chiến Sắc màu",
  T_40_JH_WS_MAPTAG4: "Đấu súng sắc màu.",
  T_40_JH_WS_MAPTAG5: "Sân chơi sắc màu",
  T_40_JH_WS_MAPTAG6: "Tô màu sân chơi",
  T_40_JH_WS_MAPTAG7: "Bữa tiệc Sắc màu",
  T_40_JH_WS_MAPTAG8: "Vượt chướng ngại vật sắc màu",
  T_40_JH_WS_MAPTAG9: `Vượt chướng ngại vật 
"Vũ trụ nhện"`,
  T_40_JH_WS_TAG30: "Bố già",
  T_40_JH_WS_TAG31: "Wreck Havoc",
  T_40_JH_WS_TAG32: "Thị trấn huyền bí",
  T_40_JH_WS_TAG33: "Khủng hoảng bình minh",
  T_40_JH_WS_TAG34: "Cái chết trỗi dậy",
  T_40_JH_WS_TAG35: "Đánh đấm",
  T_40_JH_WS_TAG36: "Nóc xưởng cũ",
  T_40_JH_WS_UGCTOKENNAME: "HH thiết kế bản đồ",
  T_40_L_QUICKMESSAGE_MODE2: "Tử Chiến",
  T_40_M_WS_HIS: "Của",
  T_40_SP_WS_DYEING: "Sắc màu",
  T_40_SP_WS_DYEING_AREA: "Tô màu khu vực",
  T_40_SP_WS_DYEING_COLOR: "Số sắc màu",
  T_40_SP_WS_DYEING_COUNT: "Số lượng tô màu",
  T_40_SP_WS_DYEING_DIR: "Hướng tô màu",
  T_40_SP_WS_DYEING_DIS: "Khoảng cách tô màu",
  T_40_SP_WS_DYEING_FIXEDDYEINGRANGE: "Đã sửa khu vực tô màu",
  T_40_SP_WS_DYEING_NORMAL: "Bình thường",
  T_40_SP_WS_DYEING_PLANE: "Tô màu mặt đất",
  T_40_SP_WS_DYEING_POSITION: "Điều phối",
  T_40_SP_WS_DYEING_RANDOMDECAY: "Giảm xác suất tô màu ngẫu nhiên",
  T_40_SP_WS_DYEING_RANDOMRATIO: "Xác suất tô màu ngẫu nhiên",
  T_40_SP_WS_DYEING_RANGE: "Khu vực tô màu",
  T_40_SP_WS_DYEING_STATE: "Trạng thái tô màu",
  T_40_SP_WS_FACTIONTIPS_11: "Tím",
  T_40_SP_WS_SHOE_CURENERGY: "Năng lượng hiện tại",
  T_40_SW_SKILL_Name_Nanoscientist: "Lá Chắn Lượng Tử",
  T_40_SY_AK47_PENGUIN_W_N: "AK47 Cánh cụt Waggor",
  T_40_SY_CHARACTER_DJMALE_AWAKENING_N: "Alok thức tỉnh",
  T_40_SY_CHARACTER_NANOSCIENTIST_N: "Sonia",
  T_40_SY_FAMAS_PENGUIN_W_N: "FAMAS Cánh cụt Waggor",
  T_40_SY_M1014_PENGUIN_W_N: "M1014 Cánh cụt Waggor",
  T_40_SY_M24_PENGUIN_W_N: "M24 Cánh cụt Waggor",
  T_40_SY_MINI_PENGUIN_W_N: "AC80 Cánh cụt Waggor",
  T_40_SY_PET_PUG_N: "Pug",
  T_40_SY_PETSKIN_ALIEN_TIGHTGUY_N: 'Moony "Người nhện"',
  T_40_SY_PETSKIN_FLYINGCREATURE_ME_N: "Trang phục trợ thủ: Arvon Chớp Đen",
  T_40_SY_PETSKIN_PUG_BLACK_N: "Trang phục trợ thủ: Pug mắt laser",
  T_40_SY_PETSKIN_PUG_GREEN_N: "Trang phục trợ thủ: Pug Aloha",
  T_40_SY_PETSKIN_PUG_ORANGE_N: "Trang phục trợ thủ: Pug Sọc hổ",
  T_40_SY_SCAR_PENGUIN_W_N: "Scar Cánh cụt Waggor",
  T_40_SY_THOMPSON_PENGUIN_W_N: "Thompson Cánh cụt Waggor",
  T_40_SY_UMP45_PENGUIN_W_N: "UMP Cánh cụt Waggor",
  T_40_SY_USP45_PENGUIN_W_N: "USP Cánh cụt Waggor",
  T_40_SY_UZI_PENGUIN_W_N: "Mini Uzi Cánh cụt Waggor",
  T_40_V_WS_INPUT_TEXT_ACTIVE: "Bật nội dung văn bản",
  T_40_V_WS_INPUT_TEXT_DEFAULT: "Nhập nội dung văn bản",
  T_40_W_DJMALE_AWAKENING_D: "Thức tỉnh: Khi sử dụng kỹ năng, mỗi [FFB300]{2}s[-] các nốt nhạc sẽ xuất hiện cách [FFB300]{1}m[-] sau lưng người sử dụng, tồn tại trong [FFB300]{0}s[-]. Đồng đội có thể nhặt các nốt nhạc để nhận hiệu ứng hào quang.",
  T_40_W_DJMALE_AWAKENING_N: "Nhịp điệu sinh mệnh",
  T_40_W_NURSE_D: "Chia sẻ [FFB300]{0}%[-] lượng máu hồi đơn mục tiêu từ bản thân (kỹ năng, túi cứu thương,súng hồi máu,...) cho tất cả đồng đội trong bán kính [FFB300]{1}m[-].",
  T_40_WH_MP_BOXING_NAME: "Đấm Bốc",
  T_40_WH_MP_C_PACK: "Balo",
  T_40_WH_MP_EXCH_COIN: "Xu Truy Đuổi",
  T_40_WH_MP_EXCH_TEMPCOIN: "Tiền thưởng",
  T_40_WH_MP_PAYCHECK: "Tiền thưởng",
  T_40_WT_SKILL_DESC_MUSICBRO_BLACK: "Tốc độ cứu đồng đội tăng [FFB300]{0}%[-]. Hồi chiêu: [FFB300]{3}s[-]. Cứu đồng đội giúp họ hồi phục [FFB300]{2} HP[-] trong [FFB300]{1}s[-].",
  T_40_WT_SKILL_DESC_MUSICBRO_WHITE2: "Tạo ra một vùng [FFB300]{0}m[-] hồi máu. Trong vùng đó, người sử dụng và đồng đội được hồi [FFB300]{1} HP/s[-]. Tự động kích hoạt khi cần thiết. Vùng kích hoạt trong [FFB300]{2}s[-]. Hiệu ứng giúp hỗ trợ đồng đội có thể tăng cường bằng các kỹ năng khác. Thời gian hồi chiêu: [FFB300]{3}s[-].",
  T_40_WT_WS_ICONENTITY_PARAM6: "Phương pháp hiển thị",
  T_40_WZY_WS_CUSTOMTRIGGER_CAPSULE: "Hình viên con nhộng",
  T_40_WZY_WS_CUSTOMTRIGGER_HEIGHT: "Cao",
  T_40_WZY_WS_CUSTOMTRIGGER_RADIUS: "Bán kính",
  T_40_WZY_WS_CUSTOMTRIGGER_SPHERE: "Hình cầu",
  T_40_WZY_WS_FONT_FF_CN_T: "FZLanTingHei-R-BIG5 (sẽ được dịch)",
  T_40_WZY_WS_FONT_HINDSILIGURI: "Hind Siliguri (được dịch)",
  T_40_WZY_WS_FONT_NOTONASTALIQURDU: "Noto Nastaliq Urdu (sẽ được dịch)",
  T_40_WZY_WS_FONT_NOTOSANS: "GFF Devanagari (sẽ được dịch)",
  T_40_WZY_WS_FONT_SIMPBDO: "Tiếng Ả Rập giản thể (sẽ được dịch)",
  T_40_WZY_WS_FONT_SUPERMARKET: "Siêu thị (tạm dịch)",
  T_40_WZY_WS_ICONENTITY_COLOR: "Màu sắc",
  T_40_WZY_WS_ICONENTITY_FILLED: "Chế độ xây dựng",
  T_40_WZY_WS_ICONENTITY_ICONTYPE: "Tài nguyên ảnh",
  T_40_WZY_WS_ICONENTITY_NAME: "Đối tượng biểu tượng",
  T_40_WZY_WS_ICONENTITY_RENDERTYPE: "Phương pháp kết xuất",
  T_40_WZY_WS_ICONENTITY_SIMPLE: "Chế độ đơn giản",
  T_40_WZY_WS_ICONENTITY_SLICED: "Chế độ cắt lát",
  T_40_WZY_WS_ICONENTITY_TILED: "Chế độ gạch",
  T_40_WZY_WS_NEWMAPTAG: "Logo bản đồ mới",
  T_40_WZY_WS_NEWVFX1: "Halo",
  T_40_WZY_WS_NEWVFX10: "Nguyền rủa",
  T_40_WZY_WS_NEWVFX11: "Vùng đóng băng",
  T_40_WZY_WS_NEWVFX12: "Gió lạnh",
  T_40_WZY_WS_NEWVFX13: "Bông tuyết",
  T_40_WZY_WS_NEWVFX14: "Ngọn lửa",
  T_40_WZY_WS_NEWVFX15: "Chùm sáng",
  T_40_WZY_WS_NEWVFX16: "Phát tán khí độc",
  T_40_WZY_WS_NEWVFX17: "Khí độc",
  T_40_WZY_WS_NEWVFX18: "Ngọn nửa bùng cháy",
  T_40_WZY_WS_NEWVFX19: "Hiệu ứng ánh sáng",
  T_40_WZY_WS_NEWVFX2: "Bong bóng",
  T_40_WZY_WS_NEWVFX20: "Ngôi sao",
  T_40_WZY_WS_NEWVFX3: "Ash",
  T_40_WZY_WS_NEWVFX4: "Đá văng",
  T_40_WZY_WS_NEWVFX5: "Đường kẻ",
  T_40_WZY_WS_NEWVFX6: "Nhấp nháy",
  T_40_WZY_WS_NEWVFX7: "Vòng quay",
  T_40_WZY_WS_NEWVFX8: "Tăng hạt",
  T_40_WZY_WS_NEWVFX9: "Khói",
  T_40_WZY_WS_PRESENTTXT_FONTSIZE: "Cỡ chữ",
  T_40_WZY_WS_PRESENTTXT_FONTSTYLE: "Kiểu chữ",
  T_40_WZY_WS_TEXTENTITY_FONTTYPE: "Kiểu chữ",
  T_40_WZY_WS_TEXTENTITY_NAME: "Đối tượng văn bản",
  T_40_WZY_WS_UIFONT_LATIN: "Cơ quan FB (được dịch)",
  T_40_WZY_WS_UIFONT_LATIN_BOLD: "GFF Latin (sẽ được dịch)",
  T_40_XXJ_WS_ACTIONHUD: "T.phần HUD của nút tương tác",
  T_40_XXJ_WS_ACTIVEINHIERARCHY_DESCKEY: 'Cho dù nó có thể được sử dụng trong cảnh. Chỉ đọc và phụ thuộc vào "Phụ huynh có sẵn hay không" và "Trạng thái hoạt động".',
  T_40_XXJ_WS_ACTIVEPARENT_DESCKEY: "Cho dù tất cả các bậc đối tượng cha đang hoạt động. Điều này là chỉ đọc và không hiển thị cho người chơi.",
  T_40_XXJ_WS_ACTIVEPARENT_NAMEKEY: "Nút đối tượng cha có khả dụng hay không",
  T_40_XXJ_WS_ACTIVESELF_DESCKEY: "Hiển thị khi trạng thái mở là đúng, nếu không thì đóng",
  T_40_XXJ_WS_ACTIVESELF1_DESCKEY: 'Cho dù nó có thể hoạt động trên chính mình. Để sử dụng trong khung cảnh, bạn phải sử dụng "Hoạt động trong khung cảnh hay không". Chỉ đọc và được định cấu hình bằng API.',
  T_40_XXJ_WS_ADDORREMOVECAMERACULLINGMASK_DESCKEY: "cullingMask của camera có hiển thị với một lớp nhất định hay không",
  T_40_XXJ_WS_ADDTOKENATPOSITION_DESCKEY: "Tạo mã thông báo tại một địa điểm nhất định",
  T_40_XXJ_WS_ADDTOKENTOPLAYER_DESCKEY: "Vật phẩm có thể nhặt được để tặng cho người chơi",
  T_40_XXJ_WS_AFORWARD_DESCKEY: "Định hướng hiện tại của người chơi",
  T_40_XXJ_WS_AFORWARD_NAMEKEY: "Theo hướng",
  T_40_XXJ_WS_AIREALATTACKENTITY_DESCKEY: "Thực thể tấn công AI",
  T_40_XXJ_WS_AITARGET_DESCKEY: "Kẻ tấn công",
  T_40_XXJ_WS_ALIGNMENT_DESCKEY: "Kiểu căn chỉnh",
  T_40_XXJ_WS_ALIGNMENT_NAMEKEY: "Căn ngang",
  T_40_XXJ_WS_ALIGNMENTVERTICAL_NAMEKEY: "Căn dọc",
  T_40_XXJ_WS_ALPHA_DESCKEY: "Độ trong suốt",
  T_40_XXJ_WS_AMMOINCLIP_DESCKEY: "Số đạn còn lại",
  T_40_XXJ_WS_AMMOINCLIP_NAMEKEY: "Đạn còn lại",
  T_40_XXJ_WS_ANCHORMAX: "Neo tối đa",
  T_40_XXJ_WS_ANCHORMIN: "Neo tối thiểu",
  T_40_XXJ_WS_APOSITION_DESCKEY: "Vị trí hiện tại của người chơi",
  T_40_XXJ_WS_APOSITION_NAMEKEY: "Vị trí",
  T_40_XXJ_WS_ARMORHUD_NAMEKEY: "Công tắc HUD giáp",
  T_40_XXJ_WS_ASSETCONFIGID_NAMEKEY: "Cài đặt thông tin ID",
  T_40_XXJ_WS_ASSETID_NAMEKEY: "Thông tin ID",
  T_40_XXJ_WS_ATTACKENTITY_NAMEKEY: "Mục tiêu tấn công",
  T_40_XXJ_WS_ATTACKGRENADE_NAMEKEY: "Công tắc HUD ném tấn công",
  T_40_XXJ_WS_ATTACKTARGET_DESCKEY: "Thực thể đang bị AI tấn công",
  T_40_XXJ_WS_ATTACKTARGET_NAMEKEY: "Đối tượng bị AI tấn công",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_DESCKEY: "Các tọa độ có sẵn của điểm xuất hiện",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_NAMEKEY: "Tọa độ điểm có sẵn",
  T_40_XXJ_WS_BACKGROUND_DESCKEY: "Hình ảnh dưới cùng",
  T_40_XXJ_WS_BACKGROUND_NAMEKEY: "Bản đồ cơ sở",
  T_40_XXJ_WS_BAGHUD_NAMEKEY: "Công tắc HUD balo",
  T_40_XXJ_WS_BGALPHA_NAMEKEY: "Độ trong suốt của nền",
  T_40_XXJ_WS_BGCOLOR_DESCKEY: "Màu nền",
  T_40_XXJ_WS_BGCOLOR_NAMEKEY: "Màu nền",
  T_40_XXJ_WS_BGFILL_DESCKEY: "Cho dù để lấp đầy nền",
  T_40_XXJ_WS_BGFILL_NAMEKEY: "Điền vào nền",
  T_40_XXJ_WS_BGNAME_DESCKEY: "Tên nền",
  T_40_XXJ_WS_BGNAME_NAMEKEY: "Tên nền",
  T_40_XXJ_WS_BGSIZEDELTA_DESCKEY: "Kích thước nền delta",
  T_40_XXJ_WS_BGSIZEDELTA_NAMEKEY: "Kích cỡ nền",
  T_40_XXJ_WS_BLUE: "Xanh dương",
  T_40_XXJ_WS_BODY_DESCKEY: "Thân",
  T_40_XXJ_WS_BODY_NAMEKEY: "Thân",
  T_40_XXJ_WS_BONESCALE_NAMEKEY: "Mở rộng xương",
  T_40_XXJ_WS_BORNPOSITIONVEC3_DESCKEY: "Điểm xuất hiện của người chơi",
  T_40_XXJ_WS_BORNPOSITIONVEC3_NAMEKEY: "Điểm xuất hiện",
  T_40_XXJ_WS_BOTH: "Cả Nam và Nữ",
  T_40_XXJ_WS_BUTTONNAME: "Tên thành phần nút",
  T_40_XXJ_WS_CAMERA_DESCKEY: "Camera",
  T_40_XXJ_WS_CAMERADIR_DESCKEY: "Hướng mà camera của khách hàng đang đối mặt",
  T_40_XXJ_WS_CAMERAPOS_DESCKEY: "Vị trí của client camera",
  T_40_XXJ_WS_CAMERARAYCASTHUD_DESCKEY: "Dò đường camera của client",
  T_40_XXJ_WS_CAMERARAYCASTHUD_NAMEKEY: "Phát hiện tia camera",
  T_40_XXJ_WS_CANCELDRAGIFFITS_DESCKEY: "Dừng kéo khi trùng với khung nhìn",
  T_40_XXJ_WS_CANCELDRAGIFFITS_NAMEKEY: "Thoát kéo khi nó vừa với khung nhìn",
  T_40_XXJ_WS_CAPSULEHEIGHT_DESCKEY: "Khoảng cách giữa tâm của các hình bán nguyệt của hình cầu. Nó không thể nhỏ hơn hai lần bán kính của hình cầu.",
  T_40_XXJ_WS_CELLSIZE_DESCKEY: "Kích thước ô",
  T_40_XXJ_WS_CELLSIZE_NAMEKEY: "Chiều rộng và chiều cao của lưới đối tượng con",
  T_40_XXJ_WS_CELLVALUE: "Đọc nội dung của một ô trong bảng và trả về đối tượng",
  T_40_XXJ_WS_CENTER_DESCKEY: "Các tọa độ thế giới tương ứng với trung tâm của bản đồ nhỏ. 0 mặc định.",
  T_40_XXJ_WS_CENTER_NAMEKEY: "Trung tâm bản đồ nhỏ",
  T_40_XXJ_WS_CENTEROFFSET_DESCKEY: "Độ lệch vị trí của nút",
  T_40_XXJ_WS_CENTEROFFSET_NAMEKEY: "Vị trí bù đắp",
  T_40_XXJ_WS_CENTEROFMASS_DESCKEY: "Tâm khối so với tọa độ cục bộ",
  T_40_XXJ_WS_CENTEROFMASS_NAMEKEY: "Tọa độ tâm (so với hệ tọa độ cục bộ)",
  T_40_XXJ_WS_CENTRALLINEACTIVE_DESCKEY: "Có hiển thị đường giữa hay không",
  T_40_XXJ_WS_CENTRALLINEACTIVE_NAMEKEY: "Có hiển thị đường ở giữa hay không",
  T_40_XXJ_WS_CENTRALLINEPOS_DESCKEY: "Vị trí đường giữa [0,1]",
  T_40_XXJ_WS_CENTRALLINEPOS_NAMEKEY: "Vị trí đường giữa",
  T_40_XXJ_WS_CHASERANGE: "Đuổi theo vùng lân cận",
  T_40_XXJ_WS_CHASETARGET_DESCKEY: "Thực thể đang bị AI truy đuổi",
  T_40_XXJ_WS_CHASETARGET_NAMEKEY: "Đối tượng bị AI truy đuổi",
  T_40_XXJ_WS_CHILD_DESCKEY: "Thực thể đối tượng con",
  T_40_XXJ_WS_CHILDINDEX_NAMEKEY: "Phần gốc và phần con",
  T_40_XXJ_WS_CHITPOS_DESCKEY: "Điểm bị đường camera chiếu vào",
  T_40_XXJ_WS_CHOOSECARHUD: "Chọn thẻ đối tượng HUD",
  T_40_XXJ_WS_CLAMP_DESCKEY: "Nếu tham số nằm trong khoảng số giữa giá trị nhỏ nhất và lớn nhất, hàm sẽ trả về giá trị của tham số; nếu tham số lớn hơn phạm vi, hàm sẽ trả về giá trị lớn nhất; nếu đối số nhỏ hơn phạm vi, hàm sẽ trả về giá trị nhỏ nhất",
  T_40_XXJ_WS_CLEARALLCHILDREN_DESCKEY: "Chỉ hỗ trợ các thực thể có thành phần Chuyển đổi. Hiện tại bị hạn chế đối với tất cả các đối tượng.",
  T_40_XXJ_WS_CLICKSIZE_DESCKEY: "Kích thước của khu vực nhấp chuột",
  T_40_XXJ_WS_CLICKSIZE_NAMEKEY: "Khu vực nhấp chuột",
  T_40_XXJ_WS_CLIPPINGTYPE_DESCKEY: "Loại cắt",
  T_40_XXJ_WS_CLIPPINGTYPE_NAMEKEY: "Loại cắt",
  T_40_XXJ_WS_CLONEENT_D: "Sao chép thực thể đã chọn và các thuộc tính của nó trong khi vẫn giữ nguyên gốc. Nếu Level Object được chọn, nó sẽ dựa trên Create Level Object.",
  T_40_XXJ_WS_CLOTHES_DESCKEY: "Danh sách trang phục",
  T_40_XXJ_WS_CLOTHID_DESCKEY: "ID trang phục",
  T_40_XXJ_WS_CLOTHID_NAMEKEY: "ID trang phục",
  T_40_XXJ_WS_CLOTHID1_DESCKEY: "ID trang phục",
  T_40_XXJ_WS_COL_DESC: "Cột để đọc",
  T_40_XXJ_WS_COLNAME_DESC: "Tên cột để đọc",
  T_40_XXJ_WS_COLOR_DESCKEY: "Màu sắc",
  T_40_XXJ_WS_COLOR_NAMEKEY: "Màu sắc",
  T_40_XXJ_WS_COLOR1_DESCKEY: "Thêm các lớp màu bằng kênh màu RGBA. Giá trị kênh nằm trong khoảng từ 0 đến 255 và được lưu trữ trong Int32. Trắng (255, 255, 255, 255) theo mặc định.",
  T_40_XXJ_WS_COLOR2_DESCKEY: "Màu của thanh tiến trình",
  T_40_XXJ_WS_COLOR3_DESCKEY: "Loại kênh màu RGBA, nằm trong khoảng từ 0 đến 255",
  T_40_XXJ_WS_COLOR4_DESCKEY: "Màu sắc của văn bản",
  T_40_XXJ_WS_COLOR5_DESCKEY: "Màu sắc của HUD",
  T_40_XXJ_WS_COLOR6_DESCKEY: "Màu sắc của ánh sáng",
  T_40_XXJ_WS_COLORA_DESCKEY: "Giá trị màu A",
  T_40_XXJ_WS_COLORB_DESCKEY: "Giá trị màu B",
  T_40_XXJ_WS_COLORBAR_NAMEKEY: "Màu thanh tiến trình",
  T_40_XXJ_WS_COLORDRUM_DESCKEY: "Thùng sắc màu",
  T_40_XXJ_WS_COLORDRUM_NAMEKEY: "Xô thuốc nhuộm",
  T_40_XXJ_WS_COLORG_DESCKEY: "Giá trị màu G",
  T_40_XXJ_WS_COLORGETCHANNEL_DESCKEY: "Lấy kênh RGBA",
  T_40_XXJ_WS_COLORGUN: "Súng phun cầu vồng",
  T_40_XXJ_WS_COLORGUN_01: "Súng phun cầu vòng (đỏ)",
  T_40_XXJ_WS_COLORGUN_02: "Súng phun cầu vồng (vàng)",
  T_40_XXJ_WS_COLORGUN_03: "Súng phun cầu vồng (xanh dương)",
  T_40_XXJ_WS_COLORGUN_04: "Súng phun cầu vòng (xanh lục)",
  T_40_XXJ_WS_COLORGUN_05: "Súng phun cầu vòng (Tím)",
  T_40_XXJ_WS_COLORR_DESCKEY: "Giá trị màu R",
  T_40_XXJ_WS_COLORTEXT_NAMEKEY: "Màu chữ",
  T_40_XXJ_WS_COLVALUE: "Nội dung cột",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_DESCKEY: "Thực thể HUD của một công tắc HUD chung",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_NAMEKEY: "Thực thể HUD chuyển đổi HUD chung",
  T_40_XXJ_WS_CONSTRAINT_DESCKEY: "Hạn chế",
  T_40_XXJ_WS_CONSTRAINT_NAMEKEY: "Giới hạn",
  T_40_XXJ_WS_CONSTRAINTCOUNT_DESCKEY: "Số lượng ràng buộc",
  T_40_XXJ_WS_CONSTRAINTCOUNT_NAMEKEY: "Giới hạn số lượng",
  T_40_XXJ_WS_CONTENTORIGIN_DESCKEY: "Nội dung gốc",
  T_40_XXJ_WS_CONTENTORIGIN_NAMEKEY: "Hướng ban đầu",
  T_40_XXJ_WS_CONTENTORIGIN2_DESCKEY: "Điểm bắt đầu của cuộn. Góc trên bên trái theo mặc định.",
  T_40_XXJ_WS_CREATEMAPBITENTITY_DESCKEY: "Tạo một pixel tĩnh cho một đối tượng nhất định trong bản đồ. Pixel sẽ không di chuyển cùng với đối tượng.",
  T_40_XXJ_WS_CREATEMAPICONENTITY_DESCKEY: "Tạo biểu tượng bản đồ nhỏ",
  T_40_XXJ_WS_CREATETIMESTAMPLOCSTRING_DESCKEY: "Xác định chuỗi được bản địa hóa cho dấu thời gian",
  T_40_XXJ_WS_CREATEUIWIDGET_D: "Tạo thành phần giao diện người dùng tùy chỉnh tại HUD tùy chỉnh được chỉ định và thành phần chính",
  T_40_XXJ_WS_CREEP_NAMEKEY: "Công tắc HUD bò",
  T_40_XXJ_WS_CROUCH_DESCKEY: "Hiển thị khi đúng, nếu không thì đóng",
  T_40_XXJ_WS_CROUCH_NAMEKEY: "Công tắc HUD ngồi",
  T_40_XXJ_WS_CULLINGMASK_DESCKEY: "Đây là lớp kết xuất cullingMask của camera. Bạn có thể lọc thực thể kết xuất bằng cấp của lớp hiển thị.",
  T_40_XXJ_WS_CULLINGMASK_NAMEKEY: "Mặt nạ trống",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_DESCKEY: "ID áo",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_NAMEKEY: "Thân trên",
  T_40_XXJ_WS_CUSTOMCLOTHFACEID_DESCKEY: "ID sơn mặt",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_DESCKEY: "ID giày",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_NAMEKEY: "Giày",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_DESCKEY: "ID đầu",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_NAMEKEY: "Mũ",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_DESCKEY: "ID sơn mặt",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_NAMEKEY: "Mặt",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_DESCKEY: "ID quần",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_NAMEKEY: "Thân dưới",
  T_40_XXJ_WS_CUSTOMCLOTHMAKEUP_NAMEKEY: "Trang điểm",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_DESCKEY: "ID gói",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_NAMEKEY: "Áo liền quần",
  T_40_XXJ_WS_CUSTOMXY_DESCKEY: "Lượng kéo theo hướng xy",
  T_40_XXJ_WS_CUSTOMXY_NAMEKEY: "Lượng kéo XY",
  T_40_XXJ_WS_DB: "Đọc giá trị bảng cơ sở dữ liệu",
  T_40_XXJ_WS_DB_DESC: "Đọc giá trị tương ứng với một định danh trong một bảng trong cơ sở dữ liệu",
  T_40_XXJ_WS_DBDELETE_DESC: "Xóa giá trị tương ứng với một định danh trong một bảng trong cơ sở dữ liệu",
  T_40_XXJ_WS_DBKEY_DESCKEY: "Tên tùy chỉnh được sử dụng để xác định dữ liệu",
  T_40_XXJ_WS_DBKEY_NAMEKEY: "Định danh",
  T_40_XXJ_WS_DBTABLENAME: "Tên bảng cơ sở dữ liệu",
  T_40_XXJ_WS_DBTABLENAME_DESC: "Tên bảng trong cơ sở dữ liệu",
  T_40_XXJ_WS_DBVALUE_DESCKEY: "Giá trị bằng văn bản",
  T_40_XXJ_WS_DBWRITE: "Ghi giá trị bảng cơ sở dữ liệu",
  T_40_XXJ_WS_DBWRITE_DESC: "Viết giá trị tương ứng với một định danh trong một bảng trong cơ sở dữ liệu",
  T_40_XXJ_WS_DEFENCEGRENADE_NAMEKEY: "Công tắc HUD ném phòng thủ",
  T_40_XXJ_WS_DEFULT: "Mặc định",
  T_40_XXJ_WS_DELETELEADERBOARD_DESC: "Xóa giá trị tương ứng với Key trong bảng thành tích trong cơ sở dữ liệu",
  T_40_XXJ_WS_DELETELEADERBOARD2_DESC: "Xóa giá trị tương ứng với thứ hạng nhất định trong bảng thành tích trong cơ sở dữ liệu",
  T_40_XXJ_WS_DEPTH: "Lớp HUD",
  T_40_XXJ_WS_DEPTH_D: "Lớp HUD cơ bản",
  T_40_XXJ_WS_DICTANDLIST: "Danh sách và Từ điển",
  T_40_XXJ_WS_DICVALUE_DESCKEY: "Giá trị của từ điển mục tiêu",
  T_40_XXJ_WS_DIFFUSEALPHA_DESCKEY: "Độ trong suốt của bề mặt",
  T_40_XXJ_WS_DIR_DESCKEY: "Vector",
  T_40_XXJ_WS_DIRECTPOSVEC3_DESCKEY: "Một điểm được cung cấp và có thể được sử dụng làm điểm hồi sinh, v.v.",
  T_40_XXJ_WS_DIRECTPOSVEC3_NAMEKEY: "Tọa độ điểm",
  T_40_XXJ_WS_DISABLEALL: "Bỏ chọn tất cả",
  T_40_XXJ_WS_DISABLECOLOR_NAMEKEY: "Tắt màu",
  T_40_XXJ_WS_DISTANT_DESCKEY: "Khoảng cách phát hiện đường camera",
  T_40_XXJ_WS_DISTANT_NAMEKEY: "Khoảng cách tia",
  T_40_XXJ_WS_DRAGEFFECT_DESCKEY: "Hỗ trợ nhiều hướng kéo",
  T_40_XXJ_WS_DRAGEFFECT_NAMEKEY: "Hiệu ứng kéo",
  T_40_XXJ_WS_DRIVER_DESCKEY: "Người điều khiển phương tiện",
  T_40_XXJ_WS_DRIVER_NAMEKEY: "Tài xế",
  T_40_XXJ_WS_EDITVALUE_DESCKEY: "Giá trị sửa đổi",
  T_40_XXJ_WS_EFFECTACTIVE_DESCKEY: "Hiển thị các hiệu ứng đặc biệt",
  T_40_XXJ_WS_EFFECTACTIVE_NAMEKEY: "Hiệu ứng hiển thị đặc biệt",
  T_40_XXJ_WS_EFFECTCOLOR_NAMEKEY: "Hiệu ứng màu",
  T_40_XXJ_WS_EFFECTENTITY_DESCKEY: "Thực thể hiệu ứng đặc biệt đại diện cho hiệu ứng đặc biệt sẽ được hiển thị",
  T_40_XXJ_WS_EFFECTENTITYGENERATOR_DESCKEY: "Đối tượng hiệu ứng đặc biệt",
  T_40_XXJ_WS_EMOTIONHUD_NAMEKEY: "Công tắc HUD cảm xúc",
  T_40_XXJ_WS_ENABLEALL: "Lựa chọn tất cả",
  T_40_XXJ_WS_ENABLELOGIC_DESCKEY: "Có bật cập nhật logic hay không. Khi tắt, các khối trên thực thể này sẽ ngừng cập nhật mọi khung hình.",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_DESCKEY: "Khi được ghi vào thuộc tính vũ khí, số liệu thống kê cơ bản của vũ khí sẽ bị ảnh hưởng bởi vỏ vũ khí",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_NAMEKEY: "Tạo thuộc tính skin vũ khí",
  T_40_XXJ_WS_ENTITY_DESCKEY: "Một thực thể là một bình chứa tất cả các thành phần, phải được thêm vào các thực thể để được kích hoạt",
  T_40_XXJ_WS_ENTITY_NAMEKEY: "Loại thực thể",
  T_40_XXJ_WS_ENTITY1_DESCKEY: "Thành phần cơ bản của một thực thể. Tất cả các thành phần sẽ kết hợp thành phần này.",
  T_40_XXJ_WS_ENTITYVARNAME_DESCKEY: "Thực thể để biến thành",
  T_40_XXJ_WS_ENTITYVARNAME11_DESCKEY: "Tên tham số được sử dụng trong mã để biểu thị thực thể của điều khiển giao diện người dùng tùy chỉnh mới được thêm vào. Giá trị biến cục bộ tương ứng của nó là thực thể của điều khiển giao diện người dùng tùy chỉnh mới được thêm vào.",
  T_40_XXJ_WS_ENTITYVARNAME12_DESCKEY: "Tên biến thực thể",
  T_40_XXJ_WS_ENTITYVARNAME13_DESCKEY: "Tên tham số được sử dụng trong mã để đại diện cho thực thể của biểu tượng đã tạo. Giá trị biến cục bộ tương ứng của nó là thực thể của biểu tượng đã tạo.",
  T_40_XXJ_WS_EPITEMHUD_NAMEKEY: "Công tắc HUD thanh EP",
  T_40_XXJ_WS_EULERANGLES_DESCKEY: "Góc quay Euler",
  T_40_XXJ_WS_FACINFECTION: "Phe (Chế độ lây nhiễm)",
  T_40_XXJ_WS_FACINFECTION_DESC: "Phe của người chơi, 1 = Người, 2 = Droid",
  T_40_XXJ_WS_FEMALE: "Nữ",
  T_40_XXJ_WS_FILLDIRECTION_DESCKEY: "Điền hướng",
  T_40_XXJ_WS_FILLDIRECTION_NAMEKEY: "Hướng bố trí",
  T_40_XXJ_WS_FIRE_NAMEKEY: "Công tắc HUD đốt lửa",
  T_40_XXJ_WS_FLOATVALUE_DESCKEY: "Giá trị của số thực",
  T_40_XXJ_WS_FOLLOWTARGET_DESCKEY: "Thực thể mục tiêu để theo dõi. Làm trống theo mặc định.",
  T_40_XXJ_WS_FONTSIZE_DESCKEY: "Kích thước của văn bản",
  T_40_XXJ_WS_FONTSIZE_NAMEKEY: "Cỡ chữ",
  T_40_XXJ_WS_FONTSTYLE_DESCKEY: "Kiểu chữ",
  T_40_XXJ_WS_FOOTBALLGLOOWALL: "Lá chắn gel đá bóng",
  T_40_XXJ_WS_FORMATSTYLE_DESCKEY: "Phong cách định dạng",
  T_40_XXJ_WS_FORWARD_DESCKEY: "Hướng đi của người chơi",
  T_40_XXJ_WS_FORWARD1_DESCKEY: "Hướng dịch chuyển tức thời",
  T_40_XXJ_WS_FREE_DESCKEY: "Camera di chuyển tự do, do người chơi điều khiển",
  T_40_XXJ_WS_FREE_NAMEKEY: "Camera tự do",
  T_40_XXJ_WS_GENDER: "Giới tính",
  T_40_XXJ_WS_GENDER_DESCKEY: "Giới tính",
  T_40_XXJ_WS_GENDERTYPE_DESCKEY: "Liệt kê giới tính",
  T_40_XXJ_WS_GETCAMERACULLINGMASK_DESCKEY: "Lấy cullingMask của camera",
  T_40_XXJ_WS_GETCHILDBYINDEX_DESCKEY: "Chỉ hỗ trợ các thực thể có thành phần Chuyển đổi. Hiện tại bị hạn chế đối với tất cả các đối tượng.",
  T_40_XXJ_WS_GETCHILDREN_DESCKEY: "Chỉ hỗ trợ các thực thể có thành phần Chuyển đổi. Hiện tại bị hạn chế đối với tất cả các đối tượng.",
  T_40_XXJ_WS_GETPARENT_DESCKEY: "Chỉ hỗ trợ các thực thể có thành phần Chuyển đổi. Hiện tại bị hạn chế đối với tất cả các đối tượng.",
  T_40_XXJ_WS_GETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Lấy ID trang phục của người chơi",
  T_40_XXJ_WS_GETPLAYERRANK: "Nhận xếp hạng người chơi",
  T_40_XXJ_WS_GETPLAYERRANK_D: "Nhận tổng xếp hạng người chơi",
  T_40_XXJ_WS_GETPLAYERROUNDRANK: "Nhận thứ hạng vòng đấu người chơi",
  T_40_XXJ_WS_GETPLAYERROUNDRANK_D: "Nhận thứ hạng vòng đấu cụ thể người chơi",
  T_40_XXJ_WS_GETPLAYERTOKENNUM_DESCKEY: "Tìm kiếm dữ liệu của mã thông báo của người chơi",
  T_40_XXJ_WS_GETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Nhận skin vũ khí của người chơi",
  T_40_XXJ_WS_GETRANDOMSPAWNPOSVEC3_DESCKEY: "Có được một bộ tọa độ chưa bị chiếm bởi các điểm sinh sản ngẫu nhiên",
  T_40_XXJ_WS_GETSCENESKYBOX_DESCKEY: "Lấy skybox của một khung cảnh",
  T_40_XXJ_WS_GETSERVERREGION_DESCKEY: "Lấy khu vực máy chủ",
  T_40_XXJ_WS_GETSERVERTIME_DESCKEY: "Nhận dấu thời gian của máy chủ",
  T_40_XXJ_WS_GETTEAMMATENEARPOSVEC3_DESCKEY: "Có được một vị trí gần đồng đội, tránh những khu vực mà người chơi không thể đứng trên",
  T_40_XXJ_WS_GETTEAMRANK: "Nhận xếp hạng đội",
  T_40_XXJ_WS_GETTEAMRANK_D: "Tổng xếp hạng đội",
  T_40_XXJ_WS_GETTEAMROUNDRANK: "Nhận xếp hạng đội",
  T_40_XXJ_WS_GETTEAMROUNDRANK_D: "Nhận xếp hạng đội cụ thể",
  T_40_XXJ_WS_GREEN: "Xanh lục",
  T_40_XXJ_WS_HALFEXTENTS_DESCKEY: "Một nửa kích thước của hình dạng 3 chiều",
  T_40_XXJ_WS_HEAD_DESCKEY: "Đầu",
  T_40_XXJ_WS_HEAD_NAMEKEY: "Đầu",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_DESCKEY: "Thực thể hiệu ứng nhịp tim",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_NAMEKEY: "Thực thể hiệu ứng nhịp tim trên màn hình",
  T_40_XXJ_WS_HEIGHT_DESCKEY: "Chiều cao",
  T_40_XXJ_WS_HINTBUTTONHUD_DESCKEY: "Nút gợi ý",
  T_40_XXJ_WS_HINTBUTTONHUD_NAMEKEY: "Nút gợi ý",
  T_40_XXJ_WS_HITPOINTEFFECT_DESCKEY: "Thực thể sẽ được hiển thị tại vị trí đích",
  T_40_XXJ_WS_HITPOINTEFFECT_NAMEKEY: "Đối tượng điểm mục tiêu",
  T_40_XXJ_WS_HITPOS_DESCKEY: "vị trí bị bắn trúng",
  T_40_XXJ_WS_HORIZONTALBAR_DESCKEY: "Kiểu hiển thị ngang",
  T_40_XXJ_WS_HORIZONTALBAR_NAMEKEY: "Kiểu hiển thị ngang",
  T_40_XXJ_WS_HOSTENTITYFOLLOW_DESCKEY: "Thực thể đang theo sau một thực thể khác",
  T_40_XXJ_WS_HOSTENTITYLOOK_DESCKEY: "Thực thể đang nhìn vào một thực thể khác",
  T_40_XXJ_WS_HPITEMHUD_NAMEKEY: "Công tắc HUD thanh máu",
  T_40_XXJ_WS_HUDEMPTYPANEL_DESCKEY: "Chỉnh sửa đầu vào HUD. Đây là HUD mà người chơi có thể chỉnh sửa từ giao diện chỉnh sửa.",
  T_40_XXJ_WS_HUDEMPTYPANEL_NAMEKEY: "Thành phần thực thể HudEmptyPanel",
  T_40_XXJ_WS_HUDENTITY_DESCKEY: "Thực thể HUD mà nó thuộc về",
  T_40_XXJ_WS_HUDGRID_DESCKEY: "Thực thể chèn HUD. Đó là HUD mà người chơi chỉnh sửa bằng trình chỉnh sửa.",
  T_40_XXJ_WS_HUDGRID_NAMEKEY: "Thành phần thực thể HudGrid",
  T_40_XXJ_WS_HUDPANEL_DESCKEY: "Thực thể chèn HUD. Đó là HUD mà người chơi chỉnh sửa bằng trình chỉnh sửa.",
  T_40_XXJ_WS_HUDPANEL_NAMEKEY: "Thành phần thực thể HudPanel",
  T_40_XXJ_WS_HUDSCROLLVIEW_DESCKEY: "Thực thể chèn HUD. Đó là HUD mà người chơi chỉnh sửa bằng trình chỉnh sửa.",
  T_40_XXJ_WS_HUDSCROLLVIEW_NAMEKEY: "Thành phần thực thể HudScrollView",
  T_40_XXJ_WS_HUMANMODELID_NAMEKEY: "ID hình người",
  T_40_XXJ_WS_ICON_DESCKEY: "Tên tài nguyên của biểu tượng",
  T_40_XXJ_WS_ICON_NAMEKEY: "Biểu tượng",
  T_40_XXJ_WS_ICON1_DESCKEY: "Chọn một biểu tượng",
  T_40_XXJ_WS_ICONENTITY_DESCKEY: "Thực thể biểu tượng đại diện cho biểu tượng sẽ được hiển thị",
  T_40_XXJ_WS_ICONPATH_DESCKEY: "Một đường dẫn tài nguyên. Tài nguyên tích hợp có trong: đường dẫn. Tài nguyên tùy chỉnh đã hết in:path. Làm trống theo mặc định.",
  T_40_XXJ_WS_ICONSPRITENAME_DESCKEY: "Tên biểu tượng",
  T_40_XXJ_WS_ICONSPRITENAME_NAMEKEY: "Tên biểu tượng",
  T_40_XXJ_WS_ICONTYPE_DESCKEY: "Đường dẫn tài nguyên. Làm trống theo mặc định.",
  T_40_XXJ_WS_INCLUDETRIGGER_DESCKEY: "Liệu nó có thể quét các yếu tố kích hoạt",
  T_40_XXJ_WS_INDEX_DESCKEY: "Chỉ mục của đối tượng con bên dưới đối tượng cha",
  T_40_XXJ_WS_INITIALVALUE_NAMEKEY: "Giá trị ban đầu [0, 1]",
  T_40_XXJ_WS_INTVALUE_DESCKEY: "Giá trị của số nguyên",
  T_40_XXJ_WS_IS3D: "Hiệu ứng âm thanh 3D",
  T_40_XXJ_WS_ISBILLBOARD_DESCKEY: "Luôn đối mặt với camera",
  T_40_XXJ_WS_ISBOLD_NAMEKEY: "In đậm",
  T_40_XXJ_WS_ISBYORDER_D: "Phát hiện xem người chơi có kích hoạt các đối tượng cấp độ theo thứ tự thời gian hay không",
  T_40_XXJ_WS_ISFEBUTTON_NAMEKEY: "Có phải nút FE không",
  T_40_XXJ_WS_ISHIT_DESCKEY: "Liệu đường camera có chạm vào thực thể hay không",
  T_40_XXJ_WS_ISINCULLINGMASK_DESCKEY: "Liệu nó có hiển thị với một lớp nhất định hay không",
  T_40_XXJ_WS_ISITALIC_NAMEKEY: "Chữ nghiêng",
  T_40_XXJ_WS_ISSHOWSCAN_DESCKEY: "Cho dù được đánh dấu bằng cách quét",
  T_40_XXJ_WS_ISSHOWSCAN_NAMECKEY: "Đánh dấu bằng cách quét hay không",
  T_40_XXJ_WS_ISSHOWTAG_DESCKEY: "Cho dù được đánh dấu bằng nút pin",
  T_40_XXJ_WS_ISTRIGGER: "Đã kích hoạt",
  T_40_XXJ_WS_ISUNDERLINE_NAMEKEY: "Gạch chân",
  T_40_XXJ_WS_ITEMID_DESCKEY: "ID vật phẩm tương ứng của thực thể",
  T_40_XXJ_WS_ITEMID_NAMEKEY: "ID vật phẩm",
  T_40_XXJ_WS_ITEMID1_DESCKEY: "ID vật phẩm (chỉ có ID vũ khí trong phiên bản hiện tại)",
  T_40_XXJ_WS_ITEMID2_DESCKEY: "ID vũ khí",
  T_40_XXJ_WS_ITEMID3_DESCKEY: "ID vật phẩm",
  T_40_XXJ_WS_JAILBREAKAREA_DESCKEY: "Khu đô thị",
  T_40_XXJ_WS_JAILBREAKAREA_NAMEKEY: "Khu đô thị",
  T_40_XXJ_WS_JUMP_NAMEKEY: "Công tắc HUD nhảy",
  T_40_XXJ_WS_KEY_DESCKEY: "Giá trị key",
  T_40_XXJ_WS_KEY_NAMEKEY: "Khoá",
  T_40_XXJ_WS_KEYNAME_DESCKEY: "Tên của khóa để duyệt. Bạn có thể sử dụng điều này để lấy giá trị của một khóa trong một biến cục bộ.",
  T_40_XXJ_WS_KILLINGTIPS_NAMEKEY: "Tắt công tác thông báo",
  T_40_XXJ_WS_LABELCOLOR_NAMEKEY: "Màu sắc kí tự",
  T_40_XXJ_WS_LANDMINEOBJ: "Thực thể sau khi tạo mìn",
  T_40_XXJ_WS_LAYERMASK_DESCKEY: "Mặt nạ của lớp va chạm. Các lớp không được chọn sẽ không được đưa vào quá trình quét. Khi trống, tất cả các lớp sẽ được đưa vào quá trình quét.",
  T_40_XXJ_WS_LAYERSEDIT: "Sử các lớp",
  T_40_XXJ_WS_LAYERSETTING: "Cài đặt mức độ hiển thị",
  T_40_XXJ_WS_LAYERTYPE_DESCKEY: "Lớp va chạm của phát hiện đường camera",
  T_40_XXJ_WS_LAYERTYPE_NAMEKEY: "Mức độ",
  T_40_XXJ_WS_LAYOUTTYPE_DESCKEY: "Kiểu bố cục",
  T_40_XXJ_WS_LAYOUTTYPE_NAMEKEY: "Loại bố cục",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD: "Thành phần bảng điểm",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD_D: "Thực thể HUD của bảng điểm. Việc sửa đổi thuộc tính của thực thể sẽ ảnh hưởng đến nội dung được hiển thị trên giao diện người dùng tương ứng.",
  T_40_XXJ_WS_LEADERBOARDNAME: "Tên bảng xếp hạng",
  T_40_XXJ_WS_LEADERBOARDNAME_DESC: "Tên của bảng thành tích trong cơ sở dữ liệu",
  T_40_XXJ_WS_LEAVEACCELERATION_DESCKEY: "Gia tốc khi lắc",
  T_40_XXJ_WS_LEAVEACCELERATION_NAMEKEY: "Tăng tốc từ xoay",
  T_40_XXJ_WS_LEFTARM_DESCKEY: "Tay trái",
  T_40_XXJ_WS_LEFTARM_NAMEKEY: "Cánh tay trái",
  T_40_XXJ_WS_LEFTCOLOR_DESCKEY: "Màu bên trái",
  T_40_XXJ_WS_LEFTCOLOR_NAMEKEY: "Màu bên trái",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_DESCKEY: "Có hiển thị các hiệu ứng đặc biệt ở bên trái hay không",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_NAMEKEY: "Có hiển thị các hiệu ứng đặc biệt ở bên trái hay không",
  T_40_XXJ_WS_LEFTFOOT_DESCKEY: "Bàn chân trái",
  T_40_XXJ_WS_LEFTFOOT_NAMEKEY: "Bàn chân trái",
  T_40_XXJ_WS_LEFTHAND_DESCKEY: "Bàn tay trái",
  T_40_XXJ_WS_LEFTHAND_NAMEKEY: "Tay trái",
  T_40_XXJ_WS_LEFTICON_DESCKEY: "Biểu tượng bên trái",
  T_40_XXJ_WS_LEFTICON_NAMEKEY: "Biểu tượng bên trái",
  T_40_XXJ_WS_LEFTLEG_DESCKEY: "Chân trái",
  T_40_XXJ_WS_LEFTLEG_NAMEKEY: "Chân trái",
  T_40_XXJ_WS_LEFTSCORETEXT_DESCKEY: "Văn bản điểm bên trái",
  T_40_XXJ_WS_LEFTSCORETEXT_NAMEKEY: "Văn bản điểm bên trái",
  T_40_XXJ_WS_LEFTTEXT_DESCKEY: "Văn bản bên trái",
  T_40_XXJ_WS_LEFTTEXT_NAMEKEY: "Văn bản bên trái",
  T_40_XXJ_WS_LERP_DESCKEY: 't nằm trong khoảng từ 0 đến 1. Khi t=0, trả về "từ". Khi t=1, quay lại "đến". Khi t=0,5, hãy trả về giá trị trung bình của các giá trị của "từ" và "đến".',
  T_40_XXJ_WS_LEVELOBJECT: "Cấp đối tượng",
  T_40_XXJ_WS_LINESPACING_NAMEKEY: "Cách dòng",
  T_40_XXJ_WS_LISTFINDMAX_DESCKEY: "So sánh các giá trị trong danh sách và trả về giá trị lớn nhất",
  T_40_XXJ_WS_LISTFINDMIN_DESCKEY: "So sánh các giá trị trong danh sách và trả về giá trị nhỏ nhất",
  T_40_XXJ_WS_LISTORMAP_NAMEKEY: "Danh sách hoặc bản đồ",
  T_40_XXJ_WS_LOCALPOSITION: "Vị trí cục bộ",
  T_40_XXJ_WS_LOCALROTA: "Góc Euler nội địa",
  T_40_XXJ_WS_LOCALROTATIONQ: "Phép quay bậc bốn cục bộ",
  T_40_XXJ_WS_LOCALSACLE: "Quy mô cục bộ",
  T_40_XXJ_WS_LOCSWITCH_NAMEKEY: "Chuyển hóa cục bộ",
  T_40_XXJ_WS_LOOPRANGE_DESCKEY: "Container đi ngang qua",
  T_40_XXJ_WS_MALE: "Nam",
  T_40_XXJ_WS_MAPCLEAR_DESCKEY: "Từ điển rõ ràng",
  T_40_XXJ_WS_MAPGETLENGTH_DESCKEY: "Lấy chiều dài của bản đồ",
  T_40_XXJ_WS_MAPGETVALUE_DESCKEY: "Lấy giá trị của key được chỉ định trong phần tử từ điển",
  T_40_XXJ_WS_MAPREMOVEVALUE_DESCKEY: "Xóa cặp khóa-giá trị đã chỉ định khỏi từ điển",
  T_40_XXJ_WS_MAPSETVALUE_DESCKEY: "Đặt giá trị của key được chỉ định trong dấu đầu dòng",
  T_40_XXJ_WS_MAPSIZE_DESCKEY: "Kích thước của bản đồ nhỏ. Chiều rộng và chiều cao của nó bằng nhau.",
  T_40_XXJ_WS_MAPSIZE_NAMEKEY: "Kích thước bản đồ",
  T_40_XXJ_WS_MAPT: "Mẫu chính tả",
  T_40_XXJ_WS_MAPT_D: "Mẫu dữ liệu cho chính tả. Bạn có thể chỉ định nội dung thông qua T1 và T2",
  T_40_XXJ_WS_MAPVALUE_D: "Kho dữ liệu cho mệnh lệnh. Phần tử bao gồm cặp chìa khóa và giá trị",
  T_40_XXJ_WS_MAPVALUE_DESCKEY: "Từ điển mục tiêu",
  T_40_XXJ_WS_MAPVALUE_NAMEKEY: "Từ điển",
  T_40_XXJ_WS_MASKNAME_DESCKEY: "Loại mặt nạ là hình ảnh tên được sử dụng khi đeo mặt nạ",
  T_40_XXJ_WS_MASKNAME_NAMEKEY: "Tên mặt nạ",
  T_40_XXJ_WS_MASS_DESCKEY: "Khối lượng (tính bằng kg)",
  T_40_XXJ_WS_MASS_NAMEKEY: "Khối lượng (kg)",
  T_40_XXJ_WS_MAX_DESCKEY: "So sánh 2 giá trị và trả về giá trị lớn hơn",
  T_40_XXJ_WS_MAXLENGTH_NAMEKEY: "Độ dài tối đa.",
  T_40_XXJ_WS_MAXNUM_DESCKEY: "Giá trị tối đa",
  T_40_XXJ_WS_MAXWIDGETID_DESCKEY: "ID thành phần lớn nhất",
  T_40_XXJ_WS_MAXWIDGETID_NAMEKEY: "WidgetID tối đa",
  T_40_XXJ_WS_MEDICALPROPSHUD_NAMEKEY: "Công tắc HUD vật phẩm y tế",
  T_40_XXJ_WS_MIN_DESCKEY: "So sánh 2 giá trị và trả về giá trị nhỏ hơn",
  T_40_XXJ_WS_MINIMAP_NAMEKEY: "Thành phần thực thể bản đồ nhỏ",
  T_40_XXJ_WS_MINIMAPBIT_NAMEKEY: "Thành phần thực thể pixel bản đồ nhỏ",
  T_40_XXJ_WS_MINIMAPICON_NAMEKEY: "Thành phần thực thể biểu tượng bản đồ nhỏ",
  T_40_XXJ_WS_MINMAPHUD_NAMEKEY: "Công tắc HUD bản đồ mini",
  T_40_XXJ_WS_MINNUM_DESCKEY: "Giá trị tối thiểu",
  T_40_XXJ_WS_MOMENTUMAMOUNT_DESCKEY: "Yếu tố động lượng. Giá trị càng lớn, động lượng khi cuộn càng lớn.",
  T_40_XXJ_WS_MOMENTUMAMOUNT_NAMEKEY: "Yếu tố quán tính",
  T_40_XXJ_WS_MOVINGJOYSTICK_NAMEKEY: "Cần điều khiển HUD di chuyển",
  T_40_XXJ_WS_MRESULT_DESCKEY: "Kết quả trận đấu",
  T_40_XXJ_WS_NEWENTITY_D: "Một thực thể vật phẩm mới được tạo sau khi sử dụng (có thể trống)",
  T_40_XXJ_WS_NEWMAP_DESCKEY: "Xây dựng từ điển mới",
  T_40_XXJ_WS_NEWMAP_NAMEKEY: "Xây dựng từ điển mới",
  T_40_XXJ_WS_NORMAL1_DESCKEY: "Mặc định của phát bắn",
  T_40_XXJ_WS_NORMALIZEDPOSITION_DESCKEY: "Vị trí HUD [0,1]",
  T_40_XXJ_WS_NORMALIZEDPOSITION_NAMEKEY: "Vị trí HUD",
  T_40_XXJ_WS_NUMLIST_DESCKEY: "Danh sách để chuyển đổi các chỉ số thành số",
  T_40_XXJ_WS_OBJECT_DESCKEY: "Đối tượng mà súng phun trúng",
  T_40_XXJ_WS_OBSOLETE: "Đã bị loại bỏ, vui lòng thay thế phần tử này để đảm bảo an toàn",
  T_40_XXJ_WS_OFFSET_DESCKEY: "Vị trí hiển thị. Khi có một mục tiêu được theo dõi, đó là phần bù giữa vị trí mới và vị trí ban đầu. Khi không có mục tiêu theo dõi, đó là tọa độ màn hình (mặc định là Vector3(0)).",
  T_40_XXJ_WS_OFFSET2_DESCKEY: "Tọa độ màn hình (mặc định là Vector3(0)).",
  T_40_XXJ_WS_OFFSET3_DESCKEY: "Vị trí hiển thị. Khi có một mục tiêu được theo dõi, đó là phần bù giữa vị trí mới và vị trí ban đầu. Khi không có mục tiêu theo dõi, đó là tọa độ màn hình (mặc định là Vector3(0)).",
  T_40_XXJ_WS_OFFSET4_DESCKEY: "Vị trí hiển thị (mỏ neo ở góc trên cùng bên phải)",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_DESCKEY: "Độ lệch ngang",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_NAMEKEY: "Bù đắp theo chiều ngang",
  T_40_XXJ_WS_OFFSETUPDOWN_DESCKEY: "Độ lệch dọc",
  T_40_XXJ_WS_OFFSETUPDOWN_NAMEKEY: "Bù đắp theo chiều dọc",
  T_40_XXJ_WS_OK_DESCKEY: "Chuyển đổi thành công",
  T_40_XXJ_WS_ONAISTARTATTACK_DESCKEY: "Kích hoạt sự kiện này khi thực thể đi vào vùng tấn công lân cận",
  T_40_XXJ_WS_ONAISTARTCHASE_DESCKEY: "Kích hoạt sự kiện này khi thực thể đi vào vùng truy đuổi lân cận",
  T_40_XXJ_WS_ONAISTOPATTACK_DESCKEY: "Kích hoạt sự kiện này khi thực thể rời khỏi vùng tấn công lân cận",
  T_40_XXJ_WS_ONAISTOPCHASE_DESCKEY: "Kích hoạt sự kiện này khi thực thể rời khỏi vùng truy đuổi lân cận",
  T_40_XXJ_WS_ONCLIENTCAMERARAYCAST_DESCKEY: "Kích hoạt phát hiện đường camera thông qua máy khách",
  T_40_XXJ_WS_ONCOLLISION_D: "Chỉ có các thực thể được gắn kết với thành phần Collider mới hỗ trợ sự kiện này.",
  T_40_XXJ_WS_ONSPRAYENTITY_DESCKEY: "Kích hoạt sự kiện này khi súng phun trúng một thực thể",
  T_40_XXJ_WS_ONSTOPFIRE_DESCKEY: "Khi ngừng bắn",
  T_40_XXJ_WS_ONSWITCHPLAYERAREA_DESCKEY: "Khi một người chơi chuyển đổi khu vực phong cảnh",
  T_40_XXJ_WS_OPENSTATE_DESCKEY: "Hiển thị khi trạng thái mở là đúng, nếu không thì đóng",
  T_40_XXJ_WS_OPENSTATE_NAMEKEY: "Trạng thái mở",
  T_40_XXJ_WS_ORANGE: "Cam",
  T_40_XXJ_WS_ORDER_DESC: "Vị trí trong bảng xếp hạng",
  T_40_XXJ_WS_ORDER1: "Hạng khởi đầu",
  T_40_XXJ_WS_ORDER2: "Hạng kết thúc",
  T_40_XXJ_WS_ORIGINAL: "Giữ logic ban đầu",
  T_40_XXJ_WS_OVERFLOW_NAMEKEY: "Phương thức tràn",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_DESCKEY: "Khi được ưu tiên, các thuộc tính của vũ khí của người chơi sẽ thay thế các thuộc tính ban đầu của vũ khí",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_NAMEKEY: "Ưu tiên skin vũ khí của người chơi",
  T_40_XXJ_WS_OWNER_DESCKEY: "Người chơi sở hữu thực thể này",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_DESCKEY: "UID chung của khung cảnh đối tượng con mà nó thuộc về",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_NAMEKEY: "Cảnh phụ GUID mà nó thuộc về",
  T_40_XXJ_WS_PARENT_DESCKEY: "Thực thể đối tượng cha",
  T_40_XXJ_WS_PARENT_NAMEKEY: "Đối tượng cha",
  T_40_XXJ_WS_PARENTENTITYID_NAMEKEY: "ID thực thể thành phần gốc",
  T_40_XXJ_WS_PARENTWIDGETFILEID_DESCKEY: "ID tệp của thành phần chính",
  T_40_XXJ_WS_PASSENGERS_DESCKEY: "Tất cả hành khách trên xe",
  T_40_XXJ_WS_PASSENGERS_NAMEKEY: "Hành khách",
  T_40_XXJ_WS_PHYSICALLAYER: "Lớp vật lý",
  T_40_XXJ_WS_PHYSICALLAYERMATRIX: "Ma trận lớp vật lý",
  T_40_XXJ_WS_PHYSICALTIP1: "Tên đã tồn tại",
  T_40_XXJ_WS_PHYSICALTIP2: "Xóa một tên lớp, ẩn nó trong lớp ma trận vật lý và lớp dữ liệu đặc biệt, nhưng đối tượng trong lớp đó sẽ không bị ảnh hưởng",
  T_40_XXJ_WS_PHYSICS: "Vật lý",
  T_40_XXJ_WS_PICKUPLISTHUD_NAMEKEY: "Công tắc HUD chọn danh sách chuyển đổi",
  T_40_XXJ_WS_PLAYABLE_DESCKEY: "Một thực thể có thể chơi được",
  T_40_XXJ_WS_PLAYABLELOOKAT_DESCKEY: "Một thực thể luôn phải đối mặt với một thực thể khác",
  T_40_XXJ_WS_PLAYABLEPOSFOLLOW_DESCKEY: "Một thực thể theo sau một thực thể khác",
  T_40_XXJ_WS_PLAYABLETRAJECTORY_DESCKEY: "Hoạt ảnh vệt đạn là hoạt ảnh mô phỏng vệt đạn",
  T_40_XXJ_WS_PLAYER1_DESCKEY: "Người chơi nhận được tin nhắn",
  T_40_XXJ_WS_PLAYERAVATAR_DESCKEY: "Hình đại diện được sử dụng bởi người chơi",
  T_40_XXJ_WS_PLAYERAVATARINFO_DESCKEY: "Trang phục do người chơi trang bị",
  T_40_XXJ_WS_PLAYERAVATARINFO_NAMEKEY: "Quần áo người chơi",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_DESCKEY: "Loại HUD của người chơi",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_NAMEKEY: "Loại HUD người chơi",
  T_40_XXJ_WS_PLAYERIDINFAC: "Số người chơi trong phe",
  T_40_XXJ_WS_PLAYERLOG_DESCKEY: "Người chơi để báo cáo",
  T_40_XXJ_WS_PLAYERREMOVETOKEN_DESCKEY: "Sử dụng mã thông báo của một người chơi nhất định",
  T_40_XXJ_WS_PLAYERSKILLS_DESCKEY: "Danh sách các kỹ năng của người chơi",
  T_40_XXJ_WS_PLAYERSTATETYPE_DESCKEY: "Trạng thái của người chơi: còn sống, bị hạ gục hoặc bị tiêu diệt.",
  T_40_XXJ_WS_PLAYSPEED_DESCKEY: "Tốc độ phát lại",
  T_40_XXJ_WS_PLAYSPEED_NAMEKEY: "Tốc độ chơi",
  T_40_XXJ_WS_PLAYSPEED1_DESCKEY: "Ví dụ: 1,25 có nghĩa là nhanh hơn 25% so với tốc độ ban đầu",
  T_40_XXJ_WS_POS_DESCKEY: "Các tọa độ để dịch chuyển tức thời đến",
  T_40_XXJ_WS_PRESENTEFFECTTEXTYPE_DESCKEY: "Các loại nhãn dán hiệu ứng đặc biệt",
  T_40_XXJ_WS_PRESSEDCOLOR_NAMEKEY: "Màu khi nhấn",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_DESCKEY: "Thực hiện duyệt một vùng chứa để lấy cặp khóa-giá trị. Bao gồm một tiến trình con, đó là vòng lặp.",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_NAMEKEY: "Vòng lặp truy cập dict",
  T_40_XXJ_WS_PROGRESS_DESCKEY: "Tiến trình [0,1]",
  T_40_XXJ_WS_PROGRESS_NAMEKEY: "Tiến độ[0,1]",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_DESCKEY: "Nút sử dụng kỹ năng",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_NAMEKEY: "Nút tiến độ kỹ năng",
  T_40_XXJ_WS_QUATERNION: "Phép quay bậc bốn",
  T_40_XXJ_WS_QUICKCHATHUD_NAMEKEY: "Công tắc HUD chat nhanh",
  T_40_XXJ_WS_QUICKCHATSHOWHUD_NAMEKEY: "Công tắc HUD tin nhắn bên cạnh danh sách đội",
  T_40_XXJ_WS_RADIUS_DESCKEY: "Bán kính của hai hình bán nguyệt của hình viên thuốc",
  T_40_XXJ_WS_READCELL: "Đọc nội dung của một ô trong bảng",
  T_40_XXJ_WS_READCSV: "Đọc nội dung bảng",
  T_40_XXJ_WS_READCSV_DESC: "Đọc nội dung của toàn bộ bảng và trả về một mảng hai chiều",
  T_40_XXJ_WS_READCSVCELL: "Đọc nội dung của một ô trong bảng theo số hàng và tên cột",
  T_40_XXJ_WS_READCSVCOL_DESC: "Đọc nội dung của một cột trong toàn bộ bảng và trả về một mảng",
  T_40_XXJ_WS_READCSVROW_DESC: "Đọc nội dung của một hàng trong toàn bộ bảng và trả về một mảng",
  T_40_XXJ_WS_READLEADERBOARD: "Đọc giá trị bảng thành tích trong cơ sở dữ liệu",
  T_40_XXJ_WS_READLEADERBOARD_DESC: "Đọc giá trị tương ứng với một mã định danh trong bảng thành tích trong cơ sở dữ liệu",
  T_40_XXJ_WS_READLEADERBOARD2: "Đọc giá trị bảng xếp hạng trong cơ sở dữ liệu theo khoảng xếp hạng",
  T_40_XXJ_WS_READLEADERBOARD2_DESC: "Đọc giá trị từ một thứ hạng nhất định đến một thứ hạng nhất định trong bảng thành tích trong cơ sở dữ liệu",
  T_40_XXJ_WS_RED: "Đỏ",
  T_40_XXJ_WS_RELOAD: "Thay đạn",
  T_40_XXJ_WS_RENDERTYPE_DESCKEY: "Phương pháp hiển thị",
  T_40_XXJ_WS_RESETPLAYERCLOTHES_DESCKEY: "Khôi phục trang phục mặc định của người chơi",
  T_40_XXJ_WS_RESETPLAYERWEAPONSKINBYWEAPONID_DESCKEY: "Khôi phục giao diện vũ khí mặc định của người chơi",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_DESCKEY: "Việc kéo có bị hạn chế đối với chế độ xem hay không. Được chọn theo mặc định.",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_NAMEKEY: "Có hạn chế kéo không",
  T_40_XXJ_WS_RESULT_DESCKEY: "Kết quả đọc",
  T_40_XXJ_WS_RESULT_NAMEKEY: "Kết quả",
  T_40_XXJ_WS_RESULT1_DESCKEY: "Có tìm số lớn nhất trong danh sách hay không",
  T_40_XXJ_WS_RESULT2_DESCKEY: "Có tìm số nhỏ nhất trong danh sách hay không",
  T_40_XXJ_WS_RESULTVALUE_DESCKEY: "Tìm số nhỏ nhất trong một danh sách",
  T_40_XXJ_WS_RESULTVALUE1_DESCKEY: "Tìm số lớn nhất trong một danh sách",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_DESCKEY: "Điểm hồi sinh của một người chơi. Nếu không có điểm kiểm tra, hãy sử dụng điểm sinh sản. Nếu không thì sử dụng các điểm kiểm tra.",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_NAMEKEY: "Điểm hồi sinh",
  T_40_XXJ_WS_RIGHTARM_DESCKEY: "Tay phải",
  T_40_XXJ_WS_RIGHTARM_NAMEKEY: "Cánh tay phải",
  T_40_XXJ_WS_RIGHTCOLOR_DESCKEY: "Màu bên phải",
  T_40_XXJ_WS_RIGHTCOLOR_NAMEKEY: "Màu bên phải",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_DESCKEY: "Có hiển thị các hiệu ứng đặc biệt ở bên phải hay không",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_NAMEKEY: "Có hiển thị các hiệu ứng đặc biệt ở bên phải hay không",
  T_40_XXJ_WS_RIGHTFOOT_DESCKEY: "Bàn chân phải",
  T_40_XXJ_WS_RIGHTFOOT_NAMEKEY: "Bàn chân phải",
  T_40_XXJ_WS_RIGHTHAND_DESCKEY: "Bàn tay phải",
  T_40_XXJ_WS_RIGHTHAND_NAMEKEY: "Tay phải",
  T_40_XXJ_WS_RIGHTICON_DESCKEY: "Biểu tượng bên phải",
  T_40_XXJ_WS_RIGHTICON_NAMEKEY: "Biểu tượng bên phải",
  T_40_XXJ_WS_RIGHTLEG_DESCKEY: "Chân phải",
  T_40_XXJ_WS_RIGHTLEG_NAMEKEY: "Chân phải",
  T_40_XXJ_WS_RIGHTSCORETEXT_DESCKEY: "Văn bản điểm bên phải",
  T_40_XXJ_WS_RIGHTSCORETEXT_NAMEKEY: "Văn bản điểm bên phải",
  T_40_XXJ_WS_RIGHTTEXT_DESCKEY: "Văn bản bên phải",
  T_40_XXJ_WS_RIGHTTEXT_NAMEKEY: "Văn bản bên phải",
  T_40_XXJ_WS_RIGIDBODY_DESCKEY: "Kiểu thành phần của rigid body",
  T_40_XXJ_WS_RIGIDBODY_NAMEKEY: "Thành phần rigid body",
  T_40_XXJ_WS_RIGIDBODYTYPE_DESCKEY: "Kiểu liệt kê (enum) của rigid body",
  T_40_XXJ_WS_RIGIDBODYTYPE_NAMEKEY: "Danh sách rigid body",
  T_40_XXJ_WS_ROW_DECS: "Dòng để đọc",
  T_40_XXJ_WS_ROWVALUE: "Nội dung dòng",
  T_40_XXJ_WS_SCALE_DESCKEY: "Đặt giá trị tỷ lệ đối tượng",
  T_40_XXJ_WS_SCALE_NAMEKEY: "Giá trị tỉ lệ",
  T_40_XXJ_WS_SCALE0_DESCKEY: "Độ zoom của chuỗi tọa độ trên thế giới",
  T_40_XXJ_WS_SCALE1_DESCKEY: "Quy mô thu phóng. 1 theo mặc định.",
  T_40_XXJ_WS_SCALECALUE_DESCKEY: "Giá trị tỷ lệ",
  T_40_XXJ_WS_SCENENAME_DESCKEY: "Tên của khu vực",
  T_40_XXJ_WS_SCOREBARHUD_DESCKEY: "Thanh điểm",
  T_40_XXJ_WS_SCOREBARHUD_NAMEKEY: "Thanh điểm",
  T_40_XXJ_WS_SCROLLDIRECTION_DESCKEY: "Hỗ trợ nhiều hướng cuộn",
  T_40_XXJ_WS_SCROLLDIRECTION_NAMEKEY: "Hướng cuộn",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_DESCKEY: "Các yếu tố của cuộn. Giá trị càng lớn, cuộn càng nhanh.",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_NAMEKEY: "Yếu tố bánh xe",
  T_40_XXJ_WS_SETCAMERACULLINGMASK_DESCKEY: "Cấu hình cullingMask của camera",
  T_40_XXJ_WS_SETGLOBAL: "Đặt thế giới",
  T_40_XXJ_WS_SETPARENT_D: "Chỉ hỗ trợ các thực thể có thành phần chuyển đổi",
  T_40_XXJ_WS_SETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Cấu hình ID trang phục của người chơi",
  T_40_XXJ_WS_SETPLAYERCLOTHIDS_DESCKEY: "Sửa đổi trang phục nhiều người chơi",
  T_40_XXJ_WS_SETPLAYERFORWAR: "Đặt hướng người chơi",
  T_40_XXJ_WS_SETPLAYERHUBSWITCH_DESCKEY: "Cấu hình công tắc HUD của người chơi",
  T_40_XXJ_WS_SETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Cấu hình giao diện vũ khí của người chơi",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_DESCKEY: "Có hiển thị các thực thể tại vị trí mục tiêu hay không",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_NAMEKEY: "Hiển thị đối tượng quan tâm",
  T_40_XXJ_WS_SHOWPLAYER: "Hiển thị đối tượng",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD: "HUD chi tiết trận 1 người",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD_D: "Thực thể HUD cho các trận đấu một người chơi. Việc sửa đổi thuộc tính của thực thể sẽ ảnh hưởng đến nội dung được hiển thị trên giao diện người dùng tương ứng.",
  T_40_XXJ_WS_SIZEDELTA: "Kích thước delta của hộp neo và thành phần",
  T_40_XXJ_WS_SKELETON: "Xương",
  T_40_XXJ_WS_SKELETON_D: "Trục được sử dụng để truy cập mặt nạ bộ xương",
  T_40_XXJ_WS_SKELETONPART_NAMEKEY: "Khung xương",
  T_40_XXJ_WS_SKILLBUTTONHUD: "Nút kỹ năng",
  T_40_XXJ_WS_SLOT_DESCKEY: "Vị trí vũ khí",
  T_40_XXJ_WS_SMOOTHDRAGSTART_DESCKEY: "Khi được chọn, sẽ có chuyển động chậm khi kéo. Khi không được chọn, việc kéo tương ứng với tốc độ của chuột.",
  T_40_XXJ_WS_SMOOTHDRAGSTART_NAMEKEY: "Có nới lỏng không",
  T_40_XXJ_WS_SOFTNESS_DESCKEY: "Mượt",
  T_40_XXJ_WS_SOFTNESS_NAMEKEY: "Mềm mại",
  T_40_XXJ_WS_SOUNDNTITY_NAMEKEY: "Thực thể âm thanh",
  T_40_XXJ_WS_SPACE_DESCKEY: "Không gian",
  T_40_XXJ_WS_SPACE_NAMEKEY: "Khoảng cách lưới đối tượng con",
  T_40_XXJ_WS_SPAWNPOSVEC3_DESCKEY: "Tọa độ của điểm xuất hiện của AI",
  T_40_XXJ_WS_SPAWNPOSVEC3_NAMEKEY: "Tọa độ điểm xuất hiện",
  T_40_XXJ_WS_SPEED_DESCKEY: "Tốc độ",
  T_40_XXJ_WS_SPEED_NAMEKEY: "Tốc độ di chuyển",
  T_40_XXJ_WS_SPEEDUP_NAMEKEY: "Công tắc HUD chạy nước rút",
  T_40_XXJ_WS_SPHERERADIUS_DESCKEY: "Bán kính của hình cầu",
  T_40_XXJ_WS_SPRAYCOLOR_DESCKEY: "Màu sắc của bình xịt",
  T_40_XXJ_WS_SPRAYCOLOR_NAMEKEY: "Sơn màu",
  T_40_XXJ_WS_SPRAYRESULTHUD_DESCKEY: "Kết quả phun",
  T_40_XXJ_WS_SPRAYRESULTHUD_NAMEKEY: "Kết quả sơn",
  T_40_XXJ_WS_SPRAYRIFLE_DESCKEY: "Súng phun (súng trường tấn công)",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY: "Súng sơn (súng trường)",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY_01: "Vận tốc ban đầu",
  T_40_XXJ_WS_SPRITEFLIP_NAMEKEY: "Lật nhãn dán",
  T_40_XXJ_WS_SPRITEID: "Mã vật phẩm Sprite",
  T_40_XXJ_WS_SPRITEID_D: "ID được sử dụng để mô tả nội dung Sprite",
  T_40_XXJ_WS_SPRITETYPE_NAMEKEY: "Loại nhãn dán",
  T_40_XXJ_WS_STARGETENTITY_DESCKEY: "Thực thể mục tiêu để tạo thành một pixel tĩnh",
  T_40_XXJ_WS_STARTPOSITION_D: "Tọa độ của tâm hình học của hình",
  T_40_XXJ_WS_STAY_D: "Giữ lại vị trí thế giới hiện tại, vòng quay và tỷ lệ của vật thể con? Điều này thường được đặt thành TRUE và cài đặt giao diện người dùng không hiệu quả đối với tùy chọn này.",
  T_40_XXJ_WS_STRING_NAMEKEY: "Chuỗi",
  T_40_XXJ_WS_STRING2FLOAT_DESCKEY: "Chuyển đổi một chuỗi thành một số thực",
  T_40_XXJ_WS_STRING2INT_DESCKEY: "Chuyển đổi một chuỗi thành một số nguyên",
  T_40_XXJ_WS_STYLE_DESCKEY: "Các phương thức chơi thêm vào. Tùy chọn bao gồm chơi một lần, lặp lại, và chơi lại",
  T_40_XXJ_WS_SWITCHPLAYERAREA_DESCKEY: "Chuyển khu vực của người chơi",
  T_40_XXJ_WS_SWITCHVALUE_DESCKEY: "Chuyển đổi giá trị",
  T_40_XXJ_WS_SWITCHWEAPONBYSLOT_DESCKEY: "Chuyển đổi vũ khí của người chơi theo vị trí",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_DESCKEY: "Chuyển vị trí vật phẩm",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_NAMEKEY: "Chuyển vị trí vật phẩm",
  T_40_XXJ_WS_TABLENAME_DESC: "Hiển thị tên bảng, thực ra là một UUID",
  T_40_XXJ_WS_TABLEVALUE: "Nội dung bảng, mảng hai chiều",
  T_40_XXJ_WS_TAGSLIST_DESCKEY: "Danh sách các thẻ",
  T_40_XXJ_WS_TARGET_DESCKEY: "Thực thể mục tiêu để tạo pixel bản đồ. Làm trống theo mặc định.",
  T_40_XXJ_WS_TARGET_NAMEKEY: "Thực thể mục tiêu để tạo pixel bản đồ",
  T_40_XXJ_WS_TARGETATK_DESCKEY: "Mục tiêu tấn công",
  T_40_XXJ_WS_TARGETENTITY_DESCKEY: "Thực thể mục tiêu",
  T_40_XXJ_WS_TARGETENTITY_NAMEKEY: "Thực thể",
  T_40_XXJ_WS_TARGETENTITY1_DESCKEY: "Thực thể chứa chức năng tùy chỉnh",
  T_40_XXJ_WS_TARGETENTITYAPLAYER_DESCKEY: "Đối tượng bị AI tấn công",
  T_40_XXJ_WS_TARGETENTITYFOLLOW_DESCKEY: "Thực thể mục tiêu để theo dõi",
  T_40_XXJ_WS_TARGETENTITYITEM_DESCKEY: "Thực thể chống đỡ (có thể trống)",
  T_40_XXJ_WS_TARGETENTITYLOOK_DESCKEY: "Thực thể mục tiêu nhìn chằm chằm",
  T_40_XXJ_WS_TARGETENTITYSOUND_DESCKEY: "Thực thể âm thanh cần được tạm dừng",
  T_40_XXJ_WS_TARGETENTITYSOUND2_DESCKEY: "Thực thể hiệu ứng âm thanh cần tiếp tục phát sau khi bị tạm dừng",
  T_40_XXJ_WS_TARGETENTITYSOUND3_DESCKEY: "Thực thể âm thanh cần xóa",
  T_40_XXJ_WS_TEAMMATESINFO_NAMEKEY: "Công tắc HUD thông tin đồng đội",
  T_40_XXJ_WS_TELEPORTA_D: "Dịch chuyển người chơi đến vị trí được chỉ định và đặt hướng nhìn của người chơi",
  T_40_XXJ_WS_TEXT_NAMEKEY: "Văn bản nhắc nhở",
  T_40_XXJ_WS_TEXTCOLOR_NAMEKEY: "Màu văn bản thông báo",
  T_40_XXJ_WS_TEXTENTITY_DESCKEY: "Thực thể văn bản đại diện cho văn bản sẽ được hiển thị",
  T_40_XXJ_WS_TEXTKEY_DESCKEY: "Các phím văn bản để hiển thị",
  T_40_XXJ_WS_TEXTKEY_NAMEKEY: "Ký tự văn bản",
  T_40_XXJ_WS_TIMESTAMP_DESCKEY: "Dấu thời gian",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_DESCKEY: "Kiểu hiển thị của một chuỗi được bản địa hóa",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_NAMEKEY: "Kiểu hiển thị định dạng dấu thời gian",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_DESCKEY: "Chuỗi bản địa hóa cho dấu thời gian",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_NAMEKEY: "Chuỗi nội địa hóa dấu thời gian",
  T_40_XXJ_WS_TIPHUD_DESCKEY: "Gợi ý",
  T_40_XXJ_WS_TIPHUD_NAMEKEY: "Gợi ý",
  T_40_XXJ_WS_TOKENCOUNT_DESCKEY: "Số lượng vật phẩm có thể nhặt được",
  T_40_XXJ_WS_TOKENID_DESCKEY: "ID của vật phẩm có thể nhặt được",
  T_40_XXJ_WS_TOWSPEED_DESCKEY: "Tốc độ kéo của người chơi",
  T_40_XXJ_WS_TRANSITIONTYPE_NAMEKEY: "Loại ngôn ngữ",
  T_40_XXJ_WS_TWEENENTITY_DESCKEY: "Thực thể hoạt hình nội suy",
  T_40_XXJ_WS_TYPE_DESCKEY: 'Đây là loại mô tả. Sử dụng "typeof" sẽ trả về loại của nó.',
  T_40_XXJ_WS_TYPE_NAMEKEY: "Loại phần",
  T_40_XXJ_WS_TYPE2_DESCKEY: "Các loại rigid bodies khác nhau có chức năng khác nhau",
  T_40_XXJ_WS_TYPE3_DESCKEY: "Chỉ các loại tiền tệ cơ bản được hỗ trợ trong phiên bản hiện tại",
  T_40_XXJ_WS_USEDEPTHMAP_DESCKEY: "Có bật hiển thị độ sâu bản đồ nhỏ hay không",
  T_40_XXJ_WS_USEDEPTHMAP_NAMEKEY: "Chuyển đổi bản đồ độ sâu",
  T_40_XXJ_WS_USEGRAVITY_DESCKEY: "Có tuân theo định luật hấp dẫn hay không",
  T_40_XXJ_WS_USEGRAVITY_NAMEKEY: "Trọng lực hay không",
  T_40_XXJ_WS_UUID_DESCKEY: "Mã định danh duy nhất của người chơi",
  T_40_XXJ_WS_UUID_NAMEKEY: "UUID",
  T_40_XXJ_WS_VALUE_DESCKEY: "Giá trị",
  T_40_XXJ_WS_VALUE_NAMEKEY: "Giá trị",
  T_40_XXJ_WS_VALUE01_NAMEKEY: "Giá trị[0, 1]",
  T_40_XXJ_WS_VALUE1_DESCKEY: "Giá trị đầu tiên",
  T_40_XXJ_WS_VALUE2_DESCKEY: "Giá trị thứ hai",
  T_40_XXJ_WS_VALUE6_DESCKEY: "Giá trị [0,1]",
  T_40_XXJ_WS_VALUEA_DESCKEY: "Giá trị bắt đầu",
  T_40_XXJ_WS_VALUEB_DESCKEY: "Giá trị mục tiêu",
  T_40_XXJ_WS_VALUENAME_DESCKEY: "Tên của giá trị để duyệt qua. Bạn có thể sử dụng điều này để lấy giá trị trong một biến cục bộ.",
  T_40_XXJ_WS_VALUET_DESCKEY: "Tiến trình nội suy. Nằm trong khoảng từ 0 đến 1.",
  T_40_XXJ_WS_VARTYPE_NAMEKEY: "Loại biến",
  T_40_XXJ_WS_VERTICALBAR_DESCKEY: "Kiểu hiển thị dọc",
  T_40_XXJ_WS_VERTICALBAR_NAMEKEY: "Kiểu hiển thị dọc",
  T_40_XXJ_WS_VISIBILITYLAYER_DESCKEY: "Mức độ hiển thị của một đối tượng",
  T_40_XXJ_WS_VISIBILITYLAYER_NAMEKEY: "Lớp hiển thị",
  T_40_XXJ_WS_WARDROBETYPE_DESCKEY: "Trang phục bao gồm gói, tóc, mặt nạ, sơn mặt, áo, quần và giày",
  T_40_XXJ_WS_WARDROBETYPE_NAMEKEY: "Loại trang phục",
  T_40_XXJ_WS_WARDROBETYPE6_DESCKEY: "Vị trí trang phục",
  T_40_XXJ_WS_WEAPONHUD_NAMEKEY: "Công tắc HUD vũ khí",
  T_40_XXJ_WS_WEAPONSKINID_DESCKEY: "ID skin vũ khí",
  T_40_XXJ_WS_WEAPONSKINID_NAMEKEY: "ID skin súng",
  T_40_XXJ_WS_WEAPONSKINID1_DESCKEY: "ID skin vũ khí",
  T_40_XXJ_WS_WEAPONSKINID6_DESCKEY: "Skin vũ khí của người chơi",
  T_40_XXJ_WS_WIDGETTYPEENUM: "Thành phần loại liệt kê",
  T_40_XXJ_WS_WIDTH_DESCKEY: "Chiều rộng",
  T_40_XXJ_WS_WORDWRAP_NAMEKEY: "Gộp từ",
  T_40_XXJ_WS_WRITELEADERBOARD: "Viết giá trị bảng thành tích trong cơ sở dữ liệu",
  T_40_XXJ_WS_WRITELEADERBOARD_DESC: "Viết giá trị tương ứng với Key trong bảng thành tích trong cơ sở dữ liệu",
  T_40_XYL_WS_BUMPERFACTORY: "Nhà máy xe điện đụng",
  T_40_XYL_WS_BURNDAMAGE: "Sát thương cháy",
  T_40_XYL_WS_BURNINTERVAL: "Thời gian giữa các lượt nhận sát thương cháy (giây)",
  T_40_XYL_WS_BURNTIME: "Thời gian cháy sau vụ nổ",
  T_40_XYL_WS_COLORFULSKY: "Bầu trời Rubik đa sắc",
  T_40_XYL_WS_CRANEMACHINE: "Máy gắp thú bông",
  T_40_XYL_WS_CRASHMAXDAMAGE: "Sát thương tối đa từ va chạm",
  T_40_XYL_WS_CRASHMAXSPEED: "Giới hạn tốc độ sát thương từ va chạm",
  T_40_XYL_WS_CRASHMESS: "Tham số khối lượng từ va chạm",
  T_40_XYL_WS_CRASHMINDAMAGE: "Sát thương va chạm tối thiểu",
  T_40_XYL_WS_DISPLAYBOARD: "Bảng trưng bày",
  T_40_XYL_WS_EXPLODEDAMAGE: "Sát thương vụ nổ",
  T_40_XYL_WS_EXPLODEDELAY: "Thời gian trễ vụ nổ",
  T_40_XYL_WS_EXPLODERANGE: "Phạm vi vụ nổ",
  T_40_XYL_WS_FERRISWHEEL: "Đu quay",
  T_40_XYL_WS_FOODTRUCK002: "Xe ăn uống nhỏ B",
  T_40_XYL_WS_GEARSHIFTDELAY: "Thời gian chuyển số (giây)",
  T_40_XYL_WS_ICAROUSEL001: "Bộ phận A của vòng ngựa quay",
  T_40_XYL_WS_ICAROUSEL002: "Bộ phận B của vòng ngựa quay",
  T_40_XYL_WS_ICAROUSEL003: "Vòng ngựa xoay",
  T_40_XYL_WS_ICEDANCEDOOL: "Búp bê màu xanh",
  T_40_XYL_WS_IDLEBRAKEINPUT: "Tỷ lệ công suất không kiểm soát khi dừng xe",
  T_40_XYL_WS_LOLLIPOP: "Kẹo que khổng lồ",
  T_40_XYL_WS_NEWHOOKGUN: "Súng dây móc mạnh mẽ",
  T_40_XYL_WS_OPENSWING: "Nút kích hoạt chế độ dao động",
  T_40_XYL_WS_OPENTRACTION: "Nút kích hoạt chế độ nhấn",
  T_40_XYL_WS_PODIUM: "Bục nhận thưởng",
  T_40_XYL_WS_SKYCITY: "Thành phố",
  T_40_XYL_WS_SKYSCRAPER_A001: "Tòa nhà cao tầng A - Bộ phận A",
  T_40_XYL_WS_SKYSCRAPER_A002: "Tòa nhà cao tầng A - Bộ phận B",
  T_40_XYL_WS_SKYSCRAPER_A003: "Tòa nhà cao tầng A - Bộ phận C",
  T_40_XYL_WS_SKYSCRAPER_B001: "Tòa nhà cao tầng B - Bộ phận A",
  T_40_XYL_WS_SKYSCRAPER_B002: "Tòa nhà cao tầng B - Bộ phận B",
  T_40_XYL_WS_SKYSCRAPER_B003: "Tòa nhà cao tầng B - Bộ phận C",
  T_40_XYL_WS_SKYSCRAPER_C001: "Tòa nhà cao tầng C - Bộ phận A",
  T_40_XYL_WS_SKYSCRAPER_C002: "Tòa nhà cao tầng C - Bộ phận B",
  T_40_XYL_WS_SKYSCRAPER_C003: "Tòa nhà cao tầng C - Bộ phận C",
  T_40_XYL_WS_SKYSCRAPER_D001: "Tòa nhà cao tầng D - Bộ phận A",
  T_40_XYL_WS_SKYSCRAPER_D002: "Tòa nhà cao tầng D - Bộ phận B",
  T_40_XYL_WS_SKYSCRAPER_D003: "Tòa nhà cao tầng D - Bộ phận C",
  T_40_XYL_WS_SKYSCRAPER_E001: "Tòa nhà cao tầng E - Bộ phận A",
  T_40_XYL_WS_SKYSCRAPER_E002: "Tòa nhà cao tầng E - Bộ phận B",
  T_40_XYL_WS_SKYSCRAPER_E003: "Tòa nhà cao tầng E - Bộ phận C",
  T_40_XYL_WS_STEERANGLE: "Góc xoay tối đa khi cua ở tốc độ cao",
  T_40_XYL_WS_STEERSPEED: "Tốc độ tối đa cua ở tốc độ cao",
  T_40_XYL_WS_SWINGSPEED: "Tốc độ dao động",
  T_40_XYL_WS_TARGETOBJECT: "Điểm neo chuyển động",
  T_40_XYL_WS_TRACTIONSPEED: "Tốc độ nhấn",
  T_40_XYL_WS_TRIGGERCAPSULE: "Kích hoạt viên nang tùy chỉnh",
  T_40_XYL_WS_TRIGGERSPHERE: "Kích hoạt hình cầu tùy chỉnh",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT: "Đối tượng tùy chỉnh",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT_DESC: "Một thành phần đối tượng trống có thể được sử dụng với thành phần kết xuất và thành phần xung đột.",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER: "Thành phần kết xuất tùy chỉnh",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER_DESC: "Một thành phần kết xuất tùy chỉnh, được sử dụng để kết xuất với các tài nguyên mô hình tùy chỉnh.",
  T_41_B_SKILL_DESC_ASSASSINGIRL: "Kẻ thù bị đánh dấu có thêm tiền thưởng. Bất kì thành viên trong đội tiêu diệt kẻ địch bị đánh dấu sẽ nhận [FFB300]{0} tiền thưởng trong trận[-]. Bạn sẽ nhận thêm [FFB300]100[-] khi loại bỏ kẻ địch. Nhận thêm [FFB300]{1} Xu FF[-] từ Máy tạo xu trong chế độ Sinh Tồn.",
  T_41_B_SKILL_NAME_ASSASSINGIRL: "Thợ Săn Tiền Thưởng",
  T_41_CJ_A_ESPORTS_TH: "Mặt Nạ Đấu Sĩ Huyền Thoại",
  T_41_CJ_B_ESPORTS_TH: "Quần Đấu Sĩ Huyền Thoại",
  T_41_CJ_H_ESPORTS_TH: "Đầu Đấu Sĩ Huyền Thoại",
  T_41_CJ_S_ESPORTS_TH: "Giày Đấu Sĩ Huyền Thoại",
  T_41_CJ_T_ESPORTS_TH: "Áo Đấu Sĩ Huyền Thoại",
  T_41_CJ_T_FFSI: "Áo Nhà Vô Địch FFSI",
  T_41_CJ_T_FOOTBALL_EU01: "Áo Sơn Điểu",
  T_41_CJ_T_FOOTBALL_EU02: "Áo Bạch Mã",
  T_41_CJ_T_FOOTBALL_EU03: "Áo Gà Lôi",
  T_41_CJ_T_FOOTBALL_EU04: "Áo Sư Tử Đỏ",
  T_41_H_CHARACTER_ASSASSINGIRL_N: "Suzy",
  T_41_LXW_TabName_Items: "Vật phẩm",
  T_41_R_CD_COIL: "Vòng bo thu",
  T_41_SJ_WS_SPECIALITEM_ENABLE_DES: "Có kích hoạt thiết bị này hay không",
  T_41_SJ_WS_SPECIALITEM_NAME: "Thiết bị",
  T_41_SW_SKILL_DESC_DELIVERY: "Khi bị kẻ thù tấn công trong phạm vi [FFB300]{0}m[-], kẻ tấn công sẽ bị đánh dấu trong [FFB300]{1}s[-] (thông tin được chia sẻ với đồng đội). Tối đa [FFB300]{2} đánh dấu[-].",
  T_41_SW_SKILL_DESC_GANGLEADER: "Nhận thêm [FFB300]{0} lá chắn[-] ở đầu trận đấu. Hồi lại lá chắn khi sống sót sau trận chiến",
  T_41_SW_SKILL_DESC_JUNKENGINEER: "Khi sử dụng kỹ năng chủ động, cung cấp [FFB300]{1} Lá chắn[-] cho đồng đội và bản thân trong phạm vi [FFB300]{0}m[-]. Lá chắn giảm dần trong [FFB300]{2}s[-]. Sau đó người chơi có thể nhận lại hiệu ứng. Thời gian hồi: [FFB300]{3}s[-].",
  T_41_SW_SKILL_DESC_WINTERGUY: "Bom Keo đã triển khai sẽ hồi phục [FFB300]{0}[-] độ bền mỗi giây khi bị tấn công, trong thời gian đó, các đồng đội trong phạm vi [FFB300]{1}m[-] hồi phục [FFB300]{2} HP/giây[-]. Mỗi đồng đội được hồi tối đa [FFB300]{3} HP[-] từ mỗi bom keo.",
  T_41_SY_PETSKIN_CACTUS_SUGARSKULL23_N: "Skin Trợ Thủ: Kactus Xương Xẩu",
  T_41_SY_PETSKIN_HAWK_INKPAINTING_N: "Skin trợ thủ: Falco Họa Điểu",
  T_41_WCL_CREDITSCORE_PENALTY_HISTORY_TYPE: "Thể loại",
  T_41_WT_SKILL_DESC_FIREBOY: "Triển khai một màn chắn lửa rộng [FFB300]{1}m[-] tồn tại trong [FFB300]{0} giây[-] và di chuyển về trước với tốc độ [FFB300]{2}m/giây[-] trong tối đa [FFB300]{3} giây[-]. Khi còn tường lửa, tái sử dụng kỹ năng để dừng tường lửa. [FFB300]Đối phương (hoặc Bom Keo)[-] chạm vào tường sẽ nhận [FFB300]{4} (hoặc{5}) sát thương[-], rồi nhận [FFB300]{6} (hoặc {7}) sát thương[-]/giây. Sát thương đốt kéo dài trong [FFB300]{8} giây[-]. Hồi chiêu: [FFB300]{9} giây[-]. Có thể tích lũy [FFB300]{10}[-] lần dùng kỹ năng với [FFB300]{11} giây[-] hồi chiêu sau mỗi lần dùng.",
  T_41_WT_SKILL_NAME_FIREBOY: "Ảo ảnh lửa",
  T_41_WZY_WS_CHARGEMAX: "Tối đa. Bom keo nạp lại",
  T_41_WZY_WS_CROSSBOWNAME: "Nỏ",
  T_41_WZY_WS_DECELERATIONRATIO: "Giảm tốc % trong nước",
  T_41_WZY_WS_DEICEWALLPARAM1: "Bán kính chống khu vực",
  T_41_WZY_WS_DEICEWALLPARAM2: "Thời lượng vùng truy cập",
  T_41_WZY_WS_EXPPERCHIP: "EXP từ Chíp tạo keo",
  T_41_WZY_WS_EXPPERDAMAGE: "EXP từ gây sát thương",
  T_41_WZY_WS_EXPPERMOVEMILE: "EXP từ di chuyển",
  T_41_WZY_WS_EXPPERSECOND: "EXP mỗi giây",
  T_41_WZY_WS_GRENADEEXPTIME: "Delay vụ nổ",
  T_41_WZY_WS_GRENADELAUNCHNAME: "Đạn nổ",
  T_41_WZY_WS_GRENADEMAX: "Thiệt hại tối đa",
  T_41_WZY_WS_GRENADEMIN: "Thiệt hại tối thiểu",
  T_41_WZY_WS_GRENADERANGE: "Phạm vi nổ",
  T_41_WZY_WS_GRENADERATIOCEHICLE: "Thiệt hại cho xe",
  T_41_WZY_WS_GRENADERATIOSELF: "Yếu tố tự gây thương tích",
  T_41_WZY_WS_GRENADERATIOTEAMMATE: "Thiệt hại cho đồng đội",
  T_41_WZY_WS_GRENADTHROWSPEED: "Tốc độ ném",
  T_41_WZY_WS_HANDCANNONNAME: "Súng cầm tay",
  T_41_XXJ_WS_ACCELERATION: "Tăng tốc",
  T_41_XXJ_WS_ACCELERATION_D: "Tạo hiệu ứng tăng tốc được xác định",
  T_41_XXJ_WS_ACTION: "Nút hành vi",
  T_41_XXJ_WS_ACTION_D: "Xoay vòng hành động",
  T_41_XXJ_WS_ADDHP: "Vật phẩm hồi máu",
  T_41_XXJ_WS_ADDPLAYERMAXHP: "Tăng máu tối đa",
  T_41_XXJ_WS_AICASTSKILL_D: "Kỹ năng giải phóng AI",
  T_41_XXJ_WS_AIMASSISTCENTEROFFSET: "Có thể được hỗ trợ bù trung tâm mục tiêu",
  T_41_XXJ_WS_AIMASSISTDISTANCE: "Có thể được hỗ trợ nhắm khoảng cách",
  T_41_XXJ_WS_AIMASSISTENTITY: "Các thực thể nhắm mục tiêu có thể được hỗ trợ",
  T_41_XXJ_WS_AIMASSISTENTITY_D: "Thực thể có thể được nhắm mục tiêu hỗ trợ",
  T_41_XXJ_WS_AISKILLTYPE: "Loại kỹ năng Zombie",
  T_41_XXJ_WS_AISKILLTYPE_D: "Loại kỹ năng Zombie",
  T_41_XXJ_WS_ALLITEMGOODSTYPE: "Tất cả vật phẩm",
  T_41_XXJ_WS_ALLITEMGOODSTYPE_D: "Tất cả vật phẩm",
  T_41_XXJ_WS_AMMOCLIPSIZE: "Điều chỉnh số lượng đạn",
  T_41_XXJ_WS_AMMOCLIPSIZE_D: "Đạn trong băng đạn",
  T_41_XXJ_WS_ANCHORPOSITION_D: "Các tọa độ neo liên quan đến đối tượng cha",
  T_41_XXJ_WS_ANGLE_D: "Góc quay trục z",
  T_41_XXJ_WS_ANGULARDRAG: "Hệ số cản quay",
  T_41_XXJ_WS_ANGULARVELOCITY: "Vận tốc góc (rad/s, hệ tọa độ thế giới)",
  T_41_XXJ_WS_ANIMATIONCLIP: "Trạng thái hoạt hình",
  T_41_XXJ_WS_ANIMATIONCONTROLLER: "Điều khiển hoạt ảnh",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE: "Thực thể hoạt ảnh",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE_D: "Tệp và tài nguyên được sử dụng để quản lý bộ điều khiển hoạt ảnh",
  T_41_XXJ_WS_ANIMATIONCONTROLLERRESUUID: "Tài nguyên điều khiển hoạt ảnh UUID",
  T_41_XXJ_WS_ANIMATIONOVERRIDELOOPTYPE: "Loại vòng lặp liệt kê",
  T_41_XXJ_WS_ANIMATIONSTATE: "Trạng thái hoạt ảnh",
  T_41_XXJ_WS_ARITHMETICTYPE_D: "Hoạt động, trong đó tất cả các loại gán giá trị đều được hỗ trợ và các loại kỹ thuật số cũng hỗ trợ tự tăng, tự trừ, tự nhân và tự chia",
  T_41_XXJ_WS_ATTACHMENT: "Phụ kiện đạo cụ",
  T_41_XXJ_WS_ATTACHMENT_D: "Tập tin đính kèm",
  T_41_XXJ_WS_ATTACHTARGET: "Đối tượng ràng buộc",
  T_41_XXJ_WS_BAG: "Balo",
  T_41_XXJ_WS_BAG_D: "Thành phần balo",
  T_41_XXJ_WS_BANNERID: "ID biểu ngữ",
  T_41_XXJ_WS_BANNERID_D: "ID biểu ngữ",
  T_41_XXJ_WS_BEHAVIOURTREE: "Cây hành vi",
  T_41_XXJ_WS_BEHAVIOURTREE_D: "Cây hành vi",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE: "Thực thể Cây hành vi có thể gắn kết",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE_D: "Một thực thể cây hành vi có thể được gắn kết",
  T_41_XXJ_WS_BEHAVIOURTREENODE: "Nút tùy chỉnh cây hành vi",
  T_41_XXJ_WS_BEHAVIOURTREENODE_D: "Pivot tùy chỉnh cây hành vi",
  T_41_XXJ_WS_BODY: "Thân",
  T_41_XXJ_WS_BORDERLR: "Ranh giới trái và phải",
  T_41_XXJ_WS_BORDERLR_D: "Đường viền trái và phải",
  T_41_XXJ_WS_BORDERTB: "Ranh giới trên và dưới",
  T_41_XXJ_WS_BORDERTB_D: "Đường viền trên và dưới",
  T_41_XXJ_WS_BRPEAKRANK: "Xếp hạng Sinh tồn Cao nhất",
  T_41_XXJ_WS_BRPEAKRANK_D: "Xếp hạng Sinh Tồn cao nhất",
  T_41_XXJ_WS_BRRANK: "Xếp hạng Sinh tồn",
  T_41_XXJ_WS_BRRANK_D: "Xếp hạng Sinh Tồn",
  T_41_XXJ_WS_BTCUSTOMNODETYPE: "Loại nút cây hành vi",
  T_41_XXJ_WS_BTCUSTOMNODETYPE_D: "Loại trục cây hành vi",
  T_41_XXJ_WS_BTREE: "Cây hành vi",
  T_41_XXJ_WS_BTREENODESTATE: "Trạng thái chạy của nút cây hành vi",
  T_41_XXJ_WS_BTREENODESTATE_D: "Trạng thái hoạt động của Pivot cây hành vi",
  T_41_XXJ_WS_BUFFABLEENTITY: "Các đối tượng có khả năng sử dụng hệ thống FFBuff",
  T_41_XXJ_WS_BUFFABLEENTITY_D: "Cho phép thêm buff, xóa buff và thêm danh sách buff",
  T_41_XXJ_WS_BUILDINGICEWALL: "Bom keo",
  T_41_XXJ_WS_CAMOUFLAGE: "Đạo cụ chức năng",
  T_41_XXJ_WS_CAMOUFLAGE_D: "Ván trượt, ngụy trang...",
  T_41_XXJ_WS_CAPICITY_D: "Công suất ban đầu",
  T_41_XXJ_WS_CENTERINVISIBLE: "Trung tâm không nhìn thấy",
  T_41_XXJ_WS_CENTERINVISIBLE_D: "Không nhìn thấy trung tâm",
  T_41_XXJ_WS_COLOR: "Màu sắc",
  T_41_XXJ_WS_COLOR_D: "Màu",
  T_41_XXJ_WS_CONDITION: "Nút điều kiện",
  T_41_XXJ_WS_CONDITION_D: "Điều kiện là một kiểu Boolean đặc biệt",
  T_41_XXJ_WS_CONDITION1_D: "Điều kiện Pivot",
  T_41_XXJ_WS_CONSTRAIN: "Các ràng buộc áp đặt lên phần thân cứng, là tập hợp của RigidbodyConstrainType",
  T_41_XXJ_WS_CONSTRAIN_D: "Thêm các ràng buộc vào RigidBody. Đây là phần tổng hợp của loại RigidBody ràng buộc",
  T_41_XXJ_WS_COUNT_D: "Số lượng",
  T_41_XXJ_WS_CROSSBOW_D: "Nỏ",
  T_41_XXJ_WS_CSPEAKRANK: "Xếp hạng Tử chiến Cao nhất",
  T_41_XXJ_WS_CSPEAKRANK_D: "Xếp hạng Tử Chiến cao nhất",
  T_41_XXJ_WS_CSRANK: "Xếp hạng Tử chiến",
  T_41_XXJ_WS_CSRANK_D: "Xếp hạng Tử Chiến",
  T_41_XXJ_WS_CSVNAME_D: "Tệp csv trong SceneData tương ứng với chế độ. Kết thúc bằng .csv. Tiêu đề được viết bằng chữ thường.",
  T_41_XXJ_WS_CURCAPACITY: "Không gian đã dùng",
  T_41_XXJ_WS_CURPROGRESS: "Tiến trình hiện tại",
  T_41_XXJ_WS_CURRENTCLIP: "Đoạn clip hiện tại",
  T_41_XXJ_WS_CURRENTCLIPPROGRESS: "Tiến trình phát lại clip hoạt ảnh hiện tại",
  T_41_XXJ_WS_CURRENTSTATE: "Trạng thái hoạt ảnh hiện tại",
  T_41_XXJ_WS_CUSTOMHUDID: "ID Giao diện tuỳ chỉnh",
  T_41_XXJ_WS_CUSTOMHUDID_D: "ID được sử dụng để mô tả nội dung HUD tùy chỉnh",
  T_41_XXJ_WS_DASHATTACK: "Trượt",
  T_41_XXJ_WS_DEBUG: "Bật gỡ lỗi",
  T_41_XXJ_WS_DEBUG_D: "Sửa chữa",
  T_41_XXJ_WS_DECELERATIONRATIO_D: "Giảm tốc %: Giảm tốc khi một vật thể ở trong nước (phạm vi tạm thời được đặt là 0-100)",
  T_41_XXJ_WS_DEPTH_D: "Chiều sâu",
  T_41_XXJ_WS_DRAG: "Hệ số cản chuyển động",
  T_41_XXJ_WS_DRAG_D: "Hệ số càng lớn, tốc độ giảm tốc độ di chuyển càng nhanh",
  T_41_XXJ_WS_DUMMY: "Hình nhân",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE: "Có bật chế độ tốc độ khung hình thấp hay không",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE_D: "Khi bật khung hình/giây thấp, trò chơi sẽ chạy ở tốc độ 15 khung hình/giây; hoặc nếu không thì 30 khung hình/giây",
  T_41_XXJ_WS_ENTITYLIST: "Trả về danh sách các thực thể đã tạo",
  T_41_XXJ_WS_ENTITYNAME: "Tên thực thể",
  T_41_XXJ_WS_ENTITYNAME_D: "Tên đối tượng do người chơi tùy chỉnh",
  T_41_XXJ_WS_ENTITYORPREFABID_D: "Thực thể hợp lý hoặc ID Prefab",
  T_41_XXJ_WS_EQUIPANDBAG: "Giáp và Balo",
  T_41_XXJ_WS_EQUIPMENTSLOT: "Liệt kê khe cắm thiết bị",
  T_41_XXJ_WS_EQUIPMENTSLOT_D: "Khe trang bị Enum",
  T_41_XXJ_WS_EXPLODE: "Nổ tung",
  T_41_XXJ_WS_EXPLOSIVEWEAPON_D: "Vũ khí nổ",
  T_41_XXJ_WS_FASTAUTORELOADSPEED: "Tốc độ thay đạn tự động",
  T_41_XXJ_WS_FILEID: "ID tập tin",
  T_41_XXJ_WS_FILEID_D: "ID nội bộ của điều khiển trong prefab",
  T_41_XXJ_WS_FILLAMOUNT: "Điền vào giá trị",
  T_41_XXJ_WS_FILLAMOUNT_D: "Giá trị điền",
  T_41_XXJ_WS_FILLDIR: "Điền hướng",
  T_41_XXJ_WS_FILLDIR_D: "Hướng điền",
  T_41_XXJ_WS_FILLDIR_D1: "Điền hướng enum",
  T_41_XXJ_WS_FILLTYPE: "Loại điền vào",
  T_41_XXJ_WS_FILLTYPE_D: "Kiểu điền",
  T_41_XXJ_WS_FILLTYPE_D1: "Điền loại enum",
  T_41_XXJ_WS_FINDSTRAIGHTPATH_D: "Tìm đường đi",
  T_41_XXJ_WS_FINISH: "Hoàn thành",
  T_41_XXJ_WS_FIREINTERVAL: "Khoảng thời gian ra đạn",
  T_41_XXJ_WS_FIREINTERVAL_D: "Khoảng thời gian tấn công",
  T_41_XXJ_WS_FLIP: "Lật",
  T_41_XXJ_WS_FLIP_D: "Phương pháp lật",
  T_41_XXJ_WS_FLYBOMBBEE: "Thây ma bay",
  T_41_XXJ_WS_FORCE: "Lực lượng",
  T_41_XXJ_WS_FORCE_D: "Tạo một lực có cường độ xác định",
  T_41_XXJ_WS_FORCETYPE: "Loại lực lượng",
  T_41_XXJ_WS_FORCETYPE_D: "Các loại lực khác nhau trên RigidBody. Chỉ hiệu quả trên các loại RigidBody động.",
  T_41_XXJ_WS_FREEZEALL: "Giới hạn dịch chuyển và xoay trong tất cả các trục",
  T_41_XXJ_WS_FREEZEPOSITION: "Giới hạn dịch chuyển trên tất cả các trục",
  T_41_XXJ_WS_FREEZEPOSITIONX: "Giới hạn dịch chuyển theo hướng trục X",
  T_41_XXJ_WS_FREEZEPOSITIONY: "Giới hạn dịch chuyển theo hướng trục Y",
  T_41_XXJ_WS_FREEZEPOSITIONZ: "Giới hạn dịch chuyển theo hướng trục Z",
  T_41_XXJ_WS_FREEZEROTATION: "Giới hạn xoay trên tất cả các trục",
  T_41_XXJ_WS_FREEZEROTATIONX: "Giới hạn xoay theo hướng trục X",
  T_41_XXJ_WS_FREEZEROTATIONY: "Giới hạn xoay theo hướng trục Y",
  T_41_XXJ_WS_FREEZEROTATIONZ: "Giới hạn xoay theo hướng trục Z",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE: "Phạm vi thiệt hại đầy đủ",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE_D: "Khoảng cách cho thiệt hại tối đa",
  T_41_XXJ_WS_GAMEID_D: "ID Nhiệm Vụ",
  T_41_XXJ_WS_GIVEJAILBREAKITEM_D: "Tặng một vật phẩm",
  T_41_XXJ_WS_GRADIENT: "Độ dốc",
  T_41_XXJ_WS_GRADIENT_D: "Độ dốc",
  T_41_XXJ_WS_GRADIENTBOTTOM: "Độ dốc dưới cùng",
  T_41_XXJ_WS_GRADIENTBOTTOM_D: "Độ dốc ở phía dưới",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA: "Độ Trong suốt phía dưới",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA_D: "Không nền phía dưới",
  T_41_XXJ_WS_GRADIENTTOP: "Độ dốc hàng đầu",
  T_41_XXJ_WS_GRADIENTTOP_D: "Độ dốc ở trên cùng",
  T_41_XXJ_WS_GRADIENTTOPALPHA: "Minh bạch hàng đầu",
  T_41_XXJ_WS_GRADIENTTOPALPHA_D: "Không nền phía trên",
  T_41_XXJ_WS_GRAPHID: "ID Tập lệnh",
  T_41_XXJ_WS_GRAPHID_D: "ID được sử dụng để mô tả nội dung tập lệnh",
  T_41_XXJ_WS_GRENADEDEICEWALL_D: "Thành phần Lựu ăn mòn",
  T_41_XXJ_WS_GRENADEEXPLOSIONTIME_D: "Độ trễ vụ nổ",
  T_41_XXJ_WS_GRENADELAUNCHER_D: "Ném được",
  T_41_XXJ_WS_GRENADEMAXDAMAGE_D: "Sát thương tối đa",
  T_41_XXJ_WS_GRENADEMINDAMAGE_D: "Sát thương tối thiểu",
  T_41_XXJ_WS_GRENADERANGE_D: "Phạm vi nổ",
  T_41_XXJ_WS_GRENADERATIOSELF_D: "Hệ số sát thương bản thân",
  T_41_XXJ_WS_GRENADERATIOTEAMMATE_D: "Hệ số sát thương đồng minh",
  T_41_XXJ_WS_GRENADERATIOVEHICLE_D: "Hệ số sát thương xe",
  T_41_XXJ_WS_GRENADETHROWSPEED_D: "Tốc độ ném",
  T_41_XXJ_WS_GRENADEWEAPON: "Ném đạo cụ lớp cơ sở",
  T_41_XXJ_WS_GRENADEWEAPON_D: "Các loại ném cơ bản",
  T_41_XXJ_WS_HANDCANNON_D: "Ném đạo cụ lớp cơ sở",
  T_41_XXJ_WS_HEAD: "Đầu",
  T_41_XXJ_WS_HEADID: "ID hình đại diện",
  T_41_XXJ_WS_HEADID_D: "ID hình đại diện",
  T_41_XXJ_WS_HEAVYWEAPON_D: "Vũ khí hạng nặng",
  T_41_XXJ_WS_HELMET_D: "Mũ hiện tại",
  T_41_XXJ_WS_HELMET1_D: "Mũ",
  T_41_XXJ_WS_HELMET2_D: "Thực thể mũ bảo hiểm",
  T_41_XXJ_WS_HITBODYPART_D: "Bộ phận cơ thể bị đánh trúng",
  T_41_XXJ_WS_HITBPDYPART: "Tác động bộ phận cơ thể",
  T_41_XXJ_WS_HITENTITY_D: "Đánh thực thể",
  T_41_XXJ_WS_HOSTHUDENTITY_D: "Thực thể HUD mà nó thuộc về",
  T_41_XXJ_WS_HUD3DCONTAINER: "Trình tải nội dung 3D",
  T_41_XXJ_WS_HUD3DCONTAINER_D: "Thực thể vùng chứa HUD 3D. Đây là HUD mà người chơi sửa đổi từ trình chỉnh sửa.",
  T_41_XXJ_WS_HUDGRID: "Điều khiển bố cục tùy chỉnh (Bảng điều khiển)",
  T_41_XXJ_WS_HUDLAYOUT: "Bố trí HUD",
  T_41_XXJ_WS_HUDLAYOUT_D: "Thực thể chèn HUD. Đây là HUD mà người chơi sửa đổi từ trình chỉnh sửa.",
  T_41_XXJ_WS_HUDPROFILEINFO: "Kiểm soát Avatar tùy chỉnh",
  T_41_XXJ_WS_HUDPROFILEINFO_D: "Thực thể thông tin hồ sơ HUD. Đây là HUD mà người chơi sửa đổi từ trình chỉnh sửa.",
  T_41_XXJ_WS_HUDTEXTURE: "Kết cấu HUD",
  T_41_XXJ_WS_HUDTEXTURE_D: "Thực thể kết cấu HUD. Đây là HUD mà người chơi sửa đổi từ trình chỉnh sửa.",
  T_41_XXJ_WS_HUDTRANSFORM: "HUD UITransform",
  T_41_XXJ_WS_HUDTRANSFORM_D: "Thực thể kiểm soát UITransform",
  T_41_XXJ_WS_IMPULSE: "Cú đánh",
  T_41_XXJ_WS_IMPULSE_D: "Tạo một cú đánh ở một cường độ được chỉ định",
  T_41_XXJ_WS_INITIALWORLDPOS: "Tọa độ thế giới ban đầu",
  T_41_XXJ_WS_INTERNALBUFFTYPE: "Loại Buff Nội bộ",
  T_41_XXJ_WS_INTERNALBUFFTYPE_D: "Tương ứng với cột ID trong BuffData.csv. Trước khi thêm nội dung mới, trước tiên vui lòng kiểm tra khả năng tương thích với GPP.",
  T_41_XXJ_WS_INVERTFILL: "Đệm ngược",
  T_41_XXJ_WS_INVERTFILL_D: "Đảo ngược điền",
  T_41_XXJ_WS_ISLOOP: "Cho dù để chu kỳ",
  T_41_XXJ_WS_ISLOOP_D: "Có lặp lại hay không. Mặc định là sai.",
  T_41_XXJ_WS_ISNAVMESHSTATIC: "Chỉ được sử dụng cho các đối tượng được tải tĩnh, NavMesh được đánh giá là được tạo tĩnh",
  T_41_XXJ_WS_ISNAVMESHSTATIC_D: "Chỉ được sử dụng để kiểm tra việc tạo NavMesh tĩnh khi tải các đối tượng tĩnh",
  T_41_XXJ_WS_ISSUCCESS_D: "Bị phá hủy hay không",
  T_41_XXJ_WS_ITEMENTITY_D: "Thực thể vật phẩm",
  T_41_XXJ_WS_ITEMID: "ID vật phẩm",
  T_41_XXJ_WS_ITEMID_D: "Mã vật phẩm",
  T_41_XXJ_WS_ITEMID_D1: "ID mục tương ứng của tệp đính kèm",
  T_41_XXJ_WS_ITEMLIST: "Danh sách vật phẩm",
  T_41_XXJ_WS_ITEMTYPE_D: "Loại vật phẩm",
  T_41_XXJ_WS_JUMPATTACK: "Nhảy tấn công",
  T_41_XXJ_WS_LANDMINE: "Mìn",
  T_41_XXJ_WS_LENGTH: "Chiều dài đoạn",
  T_41_XXJ_WS_LENGTH_D: "Độ dài của thanh tiến trình. Giá trị mặc định là độ dài trên giao diện người dùng nhà lắp ghép.",
  T_41_XXJ_WS_LIMB: "Chân tay",
  T_41_XXJ_WS_LISTLENGTHOVERLIMIT: "Độ dài của danh sách vượt quá dung lượng và việc thêm các phần tử không thành công",
  T_41_XXJ_WS_LISTT_INTERNALBUFFTYPE: "Danh sách loại Buff",
  T_41_XXJ_WS_LOOP: "Vòng",
  T_41_XXJ_WS_LOOP_D: "Vòng lặp",
  T_41_XXJ_WS_MAXCAPACITY: "Không gian",
  T_41_XXJ_WS_MAXCAPACITY_D: "Sức chứa balo",
  T_41_XXJ_WS_MAXPROGRESS: "Tiến trình tối đa, đơn vị là 10 làm tỷ lệ tiến trình tối đa và thông tin tiến trình sẽ chỉ được hiển thị khi nó lớn hơn 0",
  T_41_XXJ_WS_MELEEWEAPON_D: "Vũ khí cận chiến",
  T_41_XXJ_WS_MINDAMAGEDISTANCE: "Khoảng cách bắt đầu thiệt hại tối thiểu",
  T_41_XXJ_WS_MINDAMAGEDISTANCE_D: "Khoảng cách cho thiệt hại tối thiểu",
  T_41_XXJ_WS_MINISENTRY: "Tháp pháo tự động",
  T_41_XXJ_WS_NAME: "Tên",
  T_41_XXJ_WS_NAME_D: "Tên của nút kỹ năng. Được sử dụng để gửi tham số trong các sự cố OnClick, vì vậy tính duy nhất phải được đảm bảo.",
  T_41_XXJ_WS_NAME1_D: "Tên hàng hóa",
  T_41_XXJ_WS_NAME2_D: "Tên danh sách hàng hóa",
  T_41_XXJ_WS_NAME3_D: "Tên máy bán hàng tự động",
  T_41_XXJ_WS_NICKNAME: "Nickname",
  T_41_XXJ_WS_NICKNAME_D: "Tên người chơi",
  T_41_XXJ_WS_NOCHANGE: "Không thay đổi",
  T_41_XXJ_WS_NONE: "Vô hạn",
  T_41_XXJ_WS_NONE1: "Không có",
  T_41_XXJ_WS_OFFSET: "Giá trị bù đắp",
  T_41_XXJ_WS_OFFSET_D: "Bù lại",
  T_41_XXJ_WS_OFFSET1_D: "Giá trị bù đắp bằng văn bản",
  T_41_XXJ_WS_ONCE: "Một lần",
  T_41_XXJ_WS_ONCE_D: "Một lần",
  T_41_XXJ_WS_ONHIDE: "Khi giao diện được đóng lại",
  T_41_XXJ_WS_ONHIDE_D: "Khi đóng giao diện",
  T_41_XXJ_WS_ONNODEENTER_D: "Khi trục đang vào",
  T_41_XXJ_WS_ONSHOW: "Khi giao diện được mở",
  T_41_XXJ_WS_ONSHOW_D: "Khi mở giao diện",
  T_41_XXJ_WS_ONSYNCINPUTTEXT_D: "Kích hoạt khi hộp văn bản đã thay đổi",
  T_41_XXJ_WS_PERSONALUAV: "Mini Drone",
  T_41_XXJ_WS_PINID: "ID huy chương",
  T_41_XXJ_WS_PINID_D: "ID Pin",
  T_41_XXJ_WS_PLAYERBAG: "Thực thể Balo người chơi",
  T_41_XXJ_WS_PLAYERBAG_D: "Thực thể balo của người chơi",
  T_41_XXJ_WS_PLAYERBAGENTITY: "Balo người chơi",
  T_41_XXJ_WS_PLAYERBAGENTITY_D: "Balo của người chơi",
  T_41_XXJ_WS_PLAYERSPEEDFACTORAIMING: "Hệ số điều chỉnh tốc độ di chuyển phạm vi",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING: "Tác động tốc độ của người chơi khi bắn",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING_D: "Tác động của tốc độ di chuyển trong khi bắn",
  T_41_XXJ_WS_PREFABID: "ID Nội dung đặt trước",
  T_41_XXJ_WS_PREFABID_D: "ID được sử dụng để mô tả nội dung prefab",
  T_41_XXJ_WS_PREFABID1_D: "Thực thể mẫu HUD mà ID này đại diện",
  T_41_XXJ_WS_PRIMARYWEAPON1_D: "Vũ khí chính 1",
  T_41_XXJ_WS_PRIMARYWEAPON2_D: "Vũ khí chính 2",
  T_41_XXJ_WS_PROFILEINFO: "Hồ sơ người chơi",
  T_41_XXJ_WS_PROFILEINFO_D: "Tiểu sử người chơi",
  T_41_XXJ_WS_PROGRESSICON_D: "Biểu tượng tiến độ",
  T_41_XXJ_WS_PROGRESSICONSPRITENAME: "Xử lý tên biểu tượng",
  T_41_XXJ_WS_QUITJAILBREAKMINIGAME_D: "Thoái chế độ cảnh sát bắt cướp",
  T_41_XXJ_WS_RANGE: "Phạm vi",
  T_41_XXJ_WS_RANGE_D: "Phạm vi tấn công",
  T_41_XXJ_WS_RANGE_D1: "Phạm vi nổ",
  T_41_XXJ_WS_RANGE_D2: "Phạm vi tháp pháo",
  T_41_XXJ_WS_READCSVDATAALLOVERMODE_D: "Đọc nội dung trên toàn bộ bảng. Trả về một mảng hai chiều.",
  T_41_XXJ_WS_READCSVDATACELLOVERMODE_D: "Đọc nội dung của một ô",
  T_41_XXJ_WS_READCSVDATACOLOVERMODE_D: "Đọc nội dung của một cột nhất định. Trả về một mảng.",
  T_41_XXJ_WS_READCSVDATAROWOVERMODE_D: "Đọc nội dung của một hàng nhất định. Trả về một mảng.",
  T_41_XXJ_WS_READDBACCUMULATEDDATA: "Đọc các giá trị bảng cơ sở dữ liệu tích lũy",
  T_41_XXJ_WS_READDBACCUMULATEDDATA_D: "Đọc giá trị tương ứng với một khóa trong bảng trong cơ sở dữ liệu tích lũy",
  T_41_XXJ_WS_RECOVERPLAYERHP: "Hồi máu liên tục",
  T_41_XXJ_WS_RELOADSPEED: "Tốc độ thay đạn",
  T_41_XXJ_WS_RELOADSPEED_D: "Tốc độ tải lại (Tốc độ cơ bản x Hệ số nhân)",
  T_41_XXJ_WS_RESOURCEID: "UUID tài nguyên",
  T_41_XXJ_WS_RESOURCEID_D: "UUID tài nguyên",
  T_41_XXJ_WS_RESUUID: "Tài nguyên ID",
  T_41_XXJ_WS_RESUUID_D: "UUID tài nguyên được chỉ định để kết xuất",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE: "Loại RigidBody ràng buộc",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE_D: "Mỗi ràng buộc được xác định bằng cách đánh dấu bit và có thể được sử dụng như một tổ hợp",
  T_41_XXJ_WS_ROTATION: "Xoay",
  T_41_XXJ_WS_ROTATION_D: "Góc quay trong tọa độ thế giới. x, y, z tương ứng đề cập đến độ lệch, cao độ và cuộn.",
  T_41_XXJ_WS_ROTATION1_D: "Vòng quay",
  T_41_XXJ_WS_RUNNING: "Chạy",
  T_41_XXJ_WS_SCALE: "Phóng",
  T_41_XXJ_WS_SCALE_D: "Tỉ lệ",
  T_41_XXJ_WS_SCALE1_D: "Cân dọc theo một trục nhất định. Có thể là sự kết hợp của ba trục.",
  T_41_XXJ_WS_SCATTERMAX: "Ngưỡng khuếch tán tối đa",
  T_41_XXJ_WS_SCATTERMAX_D: "Giá trị tại đó bắt đầu lan truyền dấu đầu dòng",
  T_41_XXJ_WS_SCATTERMOVE1: "Kích thước khuếch tán với chuyển động",
  T_41_XXJ_WS_SCATTERRECOVERSPEED: "Tốc độ phục hồi phân tán",
  T_41_XXJ_WS_SCATTERRECOVERSPEED_D: "Tốc độ phục hồi lây lan",
  T_41_XXJ_WS_SCATTERSPEED: "Tốc độ tăng khuếch tán",
  T_41_XXJ_WS_SCATTERSPEED_D: "Tốc độ lan truyền tăng (0,1 = Hình chữ thập mở rộng 10% cho mỗi lần tăng một đợt)",
  T_41_XXJ_WS_SCATTERSPEEDCROUCHCREEP: "Cúi người, úp mặt xuống đất để giảm tán xạ",
  T_41_XXJ_WS_SECONDARYWEAPON_D: "Vũ khí phụ",
  T_41_XXJ_WS_SHADERNAME: "Tên bóng",
  T_41_XXJ_WS_SHADERNAME_D: "Tên shader",
  T_41_XXJ_WS_SHIELDBROKEN: "Cuộc tấn công phá vỡ lá chắn",
  T_41_XXJ_WS_SHIELDUP: "Lá chắn tấn công",
  T_41_XXJ_WS_SHOCKWAVE: "Điện giật",
  T_41_XXJ_WS_SHOWNAME: "Hiển thị biệt hiệu",
  T_41_XXJ_WS_SHOWNAME_D: "Hiển thị biệt danh",
  T_41_XXJ_WS_SHOWPIN: "Hiển thị huy hiệu",
  T_41_XXJ_WS_SHOWPIN_D: "Ghim hiển thị",
  T_41_XXJ_WS_SHOWRANK: "Hiển thị xếp hạng",
  T_41_XXJ_WS_SHOWRANK_D: "Xếp hạng hiển thị",
  T_41_XXJ_WS_SHOWTYPE: "Hiển thị loại",
  T_41_XXJ_WS_SHOWTYPE_D: "Kiểu",
  T_41_XXJ_WS_SHRINKSPEED: "Tốc độ hội tụ",
  T_41_XXJ_WS_SIGHTAIMASSIST: "Cho phép hỗ trợ nhắm mục tiêu trong khi phóng to",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTFALLOFF: "Hệ số suy giảm khoảng cách hỗ trợ ngắm (0-1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOCOEF: "Hệ số ưu tiên khoảng cách hỗ trợ ghim tâm (≥ 1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMAX: "Khoảng cách Tối đa ưu tiêu Ngắm mục tiêu",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMIN: "Khoảng cách Tối thiểu ưu tiêu Ngắm mục tiêu",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIORITY: "Ưu tiên khoảng cách Ngắm mục tiêu",
  T_41_XXJ_WS_SIGHTAIMASSISTSNAPRANGE: "Tỷ lệ thu hút phạm vi màn hình kẻ ô Aim Assist (0-1)",
  T_41_XXJ_WS_SIGHTAMPLIFYRATIO: "Phạm vi Độ phóng đại danh nghĩa",
  T_41_XXJ_WS_SIGHTFOVAMPLIFYRATIO: "Độ phóng đại FOV",
  T_41_XXJ_WS_SIGHTROTSENSITIVENESS: "Hệ số độ nhạy xoay của thị giác",
  T_41_XXJ_WS_SIGHTSHOOTMINDAMAGE: "Hệ số hiệu chỉnh khoảng cách sát thương tối thiểu X",
  T_41_XXJ_WS_SIGHTUIACTIONEXPAND: "Thời gian thu phóng chụp giao diện người dùng Sight (s)",
  T_41_XXJ_WS_SIGHTUIACTIONRATIO: "Phóng đại giao diện người dùng chụp cảnh",
  T_41_XXJ_WS_SIGHTUIACTIONRECOVERY: "Thời gian khôi phục chụp giao diện người dùng phạm vi (s)",
  T_41_XXJ_WS_SPEED: "Tốc độ chơi",
  T_41_XXJ_WS_SPEEQUIP: "Thiết bị chức năng",
  T_41_XXJ_WS_SPEITEM: "Thiết bị",
  T_41_XXJ_WS_STATICGRAPHID: "ID Tập lệnh tĩnh",
  T_41_XXJ_WS_STATICGRAPHID_D: "ID được sử dụng để mô tả nội dung tập lệnh tĩnh",
  T_41_XXJ_WS_STATICWAINING: "Sửa đổi loại cơ thể cứng không thành công",
  T_41_XXJ_WS_TARGETTREE: "Thực thể Cây hành vi",
  T_41_XXJ_WS_TARGETTREE_D: "Thực thể cây hành vi",
  T_41_XXJ_WS_TEAMINDEX: "Số đội",
  T_41_XXJ_WS_TEAMINDEX_D: "Chỉ số đội, trùng với chỉ số đội trong phòng",
  T_41_XXJ_WS_TEAMINDEX_D1: "Số phe nhóm",
  T_41_XXJ_WS_TEMPLATEPREFABID: "PrefabID của mẫu",
  T_41_XXJ_WS_TEXT_D: "Nội dung",
  T_41_XXJ_WS_TEXTURENAME: "Tên kết cấu",
  T_41_XXJ_WS_TEXTURENAME_D: "Tên kết cấu",
  T_41_XXJ_WS_THROWATTACK: "Ném tấn công",
  T_41_XXJ_WS_TICKINTERVAL: "Khoảng thời gian làm mới",
  T_41_XXJ_WS_TICKINTERVAL_D: "Làm mới khoảng thời gian. Số càng lớn, thời gian làm mới càng lâu.",
  T_41_XXJ_WS_TOGGLESPECIALITEMSTATE_D: "Kích hoạt các thiết bị đặc biệt trong balo của người chơi",
  T_41_XXJ_WS_UVRECTWH: "Chiều rộng và chiều cao UV",
  T_41_XXJ_WS_UVRECTWH_D: "Chiều rộng và chiều cao UV",
  T_41_XXJ_WS_UVRECTXY: "Bù đắp tia UV",
  T_41_XXJ_WS_UVRECTXY_D: "Độ lệch tia cực tím",
  T_41_XXJ_WS_VELOCITY: "Vận tốc tuyến tính",
  T_41_XXJ_WS_VELOCITY_D: "Không trực tiếp thay đổi tốc độ của RigidBody's. Bạn có thể thay đổi nó bằng các API có liên quan.",
  T_41_XXJ_WS_VEST_D: "Giáp hiện tại",
  T_41_XXJ_WS_VEST1_D: "Giáp",
  T_41_XXJ_WS_WIDGETID: "ID kiểm soát",
  T_41_XXJ_WS_WIDGETID_D: "ID được sử dụng để mô tả một điều khiển trong nội dung giao diện. Nó phải được ghép nối với một ID HUD tùy chỉnh để đảm bảo rằng nó tương ứng với một ID điều khiển duy nhất.",
  T_41_XXJ_WS_WINDATTACK: "Lốc xoáy",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET: "Viết giá trị bù bảng cơ sở dữ liệu tích lũy",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET_D: "Viết phần bù tương ứng với một khóa trong bảng trong cơ sở dữ liệu tích lũy",
  T_41_XXJ_WS_ZONEDURATION_D: "Thời gian đóng băng",
  T_41_XXJ_WS_ZONEDURATION1_D: "Thời gian Lựu ăn mòn",
  T_41_XXJ_WS_ZONERADIUS_D: "Bán kính vùng đóng băng",
  T_41_XXJ_WS_ZONERADIUS1_D: "Bán kính Lựu ăn mòn",
  T_41_XYL_WS_BOT12: "Máy khoan đất",
  T_41_XYL_WS_BOT9: "Zombie ném đột biến",
  T_41_XYL_WS_ITEM262: "Tấm thép đông lạnh A",
  T_41_XYL_WS_ITEM263: "Thùng hàng đông lạnh A",
  T_41_XYL_WS_ITEM264: "Thùng hàng cung cấp đông lạnh",
  T_41_XYL_WS_ITEM265: "Cổng kim loại đông lạnh",
  T_41_XYL_WS_ITEM266: "Thùng hàng đông lạnh B",
  T_41_XYL_WS_ITEM267: "Đá đông lạnh A",
  T_41_XYL_WS_ITEM268: "Đá đông lạnh B",
  T_41_XYL_WS_ITEM269: "Đá đông lạnh C",
  T_41_XYL_WS_ITEM270: "Đá đông lạnh D",
  T_41_XYL_WS_ITEM271: "Xe điện ngầm bị bỏ hoang",
  T_41_XYL_WS_MODELMATCHNAME: "Cuộc Thi Sáng Tạo Tranh",
  T_41_XYL_WS_NAVMESH: "Lưới điều hướng động",
  T_41_XYL_WS_REFCUBE: "Khối phản chiếu",
  T_41_XYL_WS_SNOWSKY: "Thiên hà băng giá",
  T_41_XYL_WS_TOYCUBE: "Chơi khối",
  T_42_CJ_F_B_VOCATIONAL: "Chuyên gia chế tác (Quần)",
  T_42_CJ_F_H_VOCATIONAL: "Đầu Chuyên gia chế tác",
  T_42_CJ_F_S_VOCATIONAL: "Chuyên gia chế tác (Giày)",
  T_42_CJ_F_T_VOCATIONAL: "Chuyên gia chế tác (Áo)",
  T_42_CJ_HA_THUNDER_GOLD: "Mặt Lôi thần",
  T_42_CJ_M_B_VOCATIONAL: "Bậc thầy chế tác (Quần)",
  T_42_CJ_M_H_VOCATIONAL: "Đầu Bậc thầy chế tác",
  T_42_CJ_M_S_VOCATIONAL: "Bậc thầy chế tác (Giày)",
  T_42_CJ_M_T_VOCATIONAL: "Bậc thầy chế tác (Áo)",
  T_42_H_CHARACTER_SUPERTEEN_N: "Ignis",
  T_42_H_GLOO_EVOTIGER_N: "Bom keo - Mãnh hổ oai phong",
  T_42_H_GRENADE_SMUDGE_N: "Lựu đạn - Hắc miêu",
  T_42_H_M1917_EMPIRE_N: "M1917 - Quân vương",
  T_42_HJ_WS_VFX_INK: "Mực",
  T_42_JH_WS_BANMATCHMAKING: "Không được ghép trận cho bản đồ này",
  T_42_JH_WS_BANROOMCREATE: "Không thể tạo phòng",
  T_42_JH_WS_FPS: "Góc nhìn thứ nhất",
  T_42_JH_WS_SKILLSETALOKAWAKEN: "Nhịp điệu sinh mệnh (Alok)",
  T_42_JH_WS_SKILLSETFIREWALL: "Bức tường lửa (Ignis)",
  T_42_JH_WS_SKILLSETSANTINO: "Dịch Chuyển Nhân Dạng (Santino)",
  T_42_JH_WS_SKILLSETSONIA: "Khiên Hồi Sinh (Sonia)",
  T_42_JH_WS_TAG1: "Cuộc chiến Băng giá",
  T_42_JH_WS_TAG10: "Tay đua vô cực",
  T_42_JH_WS_TAG11: "Tốc độ vô hạn",
  T_42_JH_WS_TAG12: "Đua xe",
  T_42_JH_WS_TAG13: "Không phổ biến",
  T_42_JH_WS_TAG14: "Vùng đất không người",
  T_42_JH_WS_TAG15: "Trận chiến Zombie",
  T_42_JH_WS_TAG16: "Di sản huyền thoại",
  T_42_JH_WS_TAG2: "Đảo Kết Nối 1.0",
  T_42_JH_WS_TAG3: "Đảo Kết Nối 2.0",
  T_42_JH_WS_TAG4: "Play Together",
  T_42_JH_WS_TAG5: "Tàn tích Kẻ sống sót",
  T_42_JH_WS_TAG6: "Tiệc Săn Mồi",
  T_42_JH_WS_TAG7: "Tiệc Săn Mồi",
  T_42_JH_WS_TAG8: "Pháo Đài Vô Cực 2.0",
  T_42_JH_WS_TAG9: "Săn Tiền Thưởng",
  T_42_RW_PORTALSFORPERSONAL_DESC: "Đặt cổng ở bất cứ đâu và dịch chuyển tức thời!",
  T_42_RW_PORTALSPERSONAL_NAME: "Cổng dịch chuyển",
  T_42_SJ_WS_ACCESSORIESITEM: "Đính kèm trang bị",
  T_42_SJ_WS_AUTOPLAY: "Tự chạy",
  T_42_SJ_WS_CLIMB: "Trèo qua",
  T_42_SJ_WS_CLOCK_EVENTS: "Biên soạn sự kiện",
  T_42_SJ_WS_CLOCK_IS_COUNTDOWN: "Đếm ngược hay không",
  T_42_SJ_WS_CLOCK_LOOP_COUNT: "Vòng lặp",
  T_42_SJ_WS_CLOCK_PAUSE_EVENT: "Tạm dừng sự kiện",
  T_42_SJ_WS_CLOCK_START_EVENT: "Bắt đầu sự kiện",
  T_42_SJ_WS_CLOCK_START_TIME: "Thời gian bắt đầu đếm ngược",
  T_42_SJ_WS_CLOCK_STATE: "Trạng thái đồng hồ bấm giờ",
  T_42_SJ_WS_CLOCK_STOP_EVENT: "Kết thúc sự kiện",
  T_42_SJ_WS_DAMRATIOHEAD: "Thay đổi hệ số DMG của headshot",
  T_42_SJ_WS_DAMRATIOLIMB: "Thay đổi hệ số DMG giới hạn",
  T_42_SJ_WS_DAMREDUCEXPLODE: "Hệ số giảm từ sát thương nổ",
  T_42_SJ_WS_DRIVE: "Lái",
  T_42_SJ_WS_ENTITYITEXT_DEPTH: "Hiển thị các lớp",
  T_42_SJ_WS_EXTRABAGCAPACITY: "Tăng sức chứa balo",
  T_42_SJ_WS_EXTRAHPRATIO: "Tỷ lệ HP",
  T_42_SJ_WS_GETOFF_DRIVE: "Rời khỏi phương tiện",
  T_42_SJ_WS_GETON_DRIVE: "Vào",
  T_42_SJ_WS_KNIFEITEM: "Phi đao",
  T_42_SJ_WS_KNIFEITEMPICK: "Phi đao (chiến lợi phẩm trên mặt đất)",
  T_42_SJ_WS_MARKBTNHUD: "Nút ghim trên HUD",
  T_42_SJ_WS_MARKBTNHUD_D: "Bạn có thể bật hoặc tắt nút ghim",
  T_42_SJ_WS_MAXDISTANCE: "Khoảng cách tối đa",
  T_42_SJ_WS_MAXDURARATIO: "Tỷ lệ độ bền tối đa",
  T_42_SJ_WS_MICBTNHUD: "Nút mic trên HUD",
  T_42_SJ_WS_MICBTNHUD_D: "Bạn có thể bật hoặc tắt nút mic",
  T_42_SJ_WS_MINDISTANCE: "Khoảng cách tối thiểu",
  T_42_SJ_WS_OPE_VEHICLE: "Vận hành phương tiện",
  T_42_SJ_WS_PLANE_DESC: "A basic mesh whose size can be freely adjusted",
  T_42_SJ_WS_PLANENAME: "Mặt phẳng cơ bản",
  T_42_SJ_WS_PRIORITY: "Ưu tiên",
  T_42_SJ_WS_REPLACEPRIORITY: "Thay thế mức độ ưu tiên",
  T_42_SJ_WS_SETBTNHUD: "Nút cài đặt trên HUD",
  T_42_SJ_WS_SETBTNHUD_D: "Bạn có thể bật hoặc tắt nút cài đặt",
  T_42_SJ_WS_SIGNALBTNHUD: "Nút kết nối mạng trên HUD",
  T_42_SJ_WS_SIGNALBTNHUD_D: "Bạn có thể bật hoặc tắt nút kết nối mạng",
  T_42_SJ_WS_SPEAKERBTNHUD: "Nút còi trên HUD",
  T_42_SJ_WS_SPEAKERBTNHUD_D: "Bạn có thể bật hoặc tắt nút còi xe",
  T_42_SJ_WS_START_TIME: "Thời gian bắt đầu (giây)",
  T_42_SW_SKILL_DESC_ARMSDEALER: "Tăng cho balo thêm [FFB300]{0}[-] sức chứa đạn, ngoại trừ Súng phóng lựu. ([FFB300]{1}[-] Đạn súng trường, [FFB300]{2}[-] Đạn súng tiểu liên, [FFB300]{3}[-] Đạn súng ngắm, [FFB300]{4}[-] Đạn shotgun)",
  T_42_SW_SKILL_DESC_Bodyguard: "Tốc độ nạp đạn tăng [FFB300]{0}%[-]. Mỗi khi người dùng kỹ năng tấn công kẻ địch, mục tiêu đó sẽ bị giảm [FFB300]{1}%[-] hiệu quả hồi máu trong [FFB300]{3}s[-] (Giảm tối đa: [FFB300]{2}%[-]).",
  T_42_SW_SKILL_DESC_Playboy: "Trở nên miễn nhiễm với các hiệu ứng (ví dụ: làm chậm, đánh dấu, khóa kỹ năng) và được tăng tốc độ di chuyển [FFB300]{1}%[-] cho [FFB300]{2}s[-]. Thời gian hồi chiêu: [FFB300]{0}s[-].",
  T_42_SW_SKILL_DESC_SwatGuy: "Sau khi bắn gục kẻ địch hoặc sử dụng kỹ năng chủ động [FFB300]{0}%[-] băng đạn sẽ tự động được nạp lại",
  T_42_SW_SKILL_NAME_Playboy: "Chiếc Thìa Bạc",
  T_42_SY_BACKPACK_EMPIRE_N: "Balo Quân Vương",
  T_42_SY_PETSKIN_RABBIT_WINTERFEST23_N: "Mật vụ Thỏ bông: Tuyết băng",
  T_42_SY_VEHICLESKIN_MOTOBIKE_URBAN_BW_N: "Xe máy - Phong Cách Đường Phố",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_AFF_N: "Xe thể thao - Aventador Ultimae Booyah",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_ASILVER_N: "Xe thể thao - Aventador Ultimae Grigio Nimbus",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VBLACK_N: "Xe thể thao Veneno Nero Nemesis",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VRED_N: "Xe thể thao Veneno Rosso Efesto",
  T_42_TYC_CST_LOSE_MONEY_1: "Số xu tử chiến nhận được sau một vòng thua",
  T_42_TYC_CST_LOSE_MONEY_2: "Số xu tử chiến nhận được sau chuỗi 2 vòng thua",
  T_42_TYC_CST_LOSE_MONEY_3: "Số xu tử chiến nhận được sau chuỗi 3 vòng thua",
  T_42_WH_ITEM_HEALUAV: "UAV Hồi máu",
  T_42_WH_ITEM_HEALUAV_DESC: "Triển khai Mini drone về phía trước để hồi máu đồng minh trong vùng",
  T_42_WH_ITEM_SKILLCARD: "Kỹ năng: {0}",
  T_42_WH_ITEM_SKILLCARD_DESC: `Sử dụng để giải phóng kỹ năng chủ động của [ffba00]{0}[-]: [ffba00]{1}[-].
{2}`,
  T_42_XXJ_WS_AMMOTYPE: "Loại đạn",
  T_42_XXJ_WS_AMMOTYPE_D: "Loại đạn",
  T_42_XXJ_WS_ASSETCONFIGID: "ID Trang phục",
  T_42_XXJ_WS_ASSETCONFIGID_D: "Trang phục",
  T_42_XXJ_WS_ATTACKSTATUS: "Trạng thái tấn công",
  T_42_XXJ_WS_AUTOPLAY: "Auto play",
  T_42_XXJ_WS_AUTOPLAY_D: "Auto play",
  T_42_XXJ_WS_AVATARABLE: "Thay đổi ngoại trang",
  T_42_XXJ_WS_AVATARABLE_D: "Thay đổi ngoại hình theo từng bộ phận",
  T_42_XXJ_WS_AVATARRESUUID: "Tài nguyên giao diện UUID",
  T_42_XXJ_WS_AXISANGLETOQUATERNION_D: "Chuyển đổi biểu diễn góc trục của phép quay thành Quaternions",
  T_42_XXJ_WS_B_D: "Giá trị màu B",
  T_42_XXJ_WS_BASEVALUE_D: "Cơ số Logarithm",
  T_42_XXJ_WS_BEZIERCURVE: "Đường cong Bezier",
  T_42_XXJ_WS_BEZIERCURVE_D: "Đường cong Bezier",
  T_42_XXJ_WS_BOTDIFFICULTY: "Độ khó BOT",
  T_42_XXJ_WS_BOUNCE_COMBINE: "Phương thức nảy kết hợp",
  T_42_XXJ_WS_BOUNCINES: "Độ nảy",
  T_42_XXJ_WS_BTREEID: "ID cây hành vi",
  T_42_XXJ_WS_BTREEID_D: "ID cây hành vi",
  T_42_XXJ_WS_CANPURCHAS: "Có thể mua được hoặc không",
  T_42_XXJ_WS_CANPURCHAS_D: "Có thể mua được hay không",
  T_42_XXJ_WS_CLIMBSTATUS: "Hành vi leo",
  T_42_XXJ_WS_CLOCK: "Đối tượng hẹn giờ",
  T_42_XXJ_WS_CLOCK_D: "Đối tượng hẹn giờ",
  T_42_XXJ_WS_CLOCK_D1: "Thời gian",
  T_42_XXJ_WS_CONTAINER: "Công-ten-nơ",
  T_42_XXJ_WS_CONTROLPOINTS: "Điểm kiểm soát",
  T_42_XXJ_WS_CONTROLPOINTS_D: "Các điểm kiểm soát",
  T_42_XXJ_WS_COROUTINEID: "Xử lý coroutine",
  T_42_XXJ_WS_COROUTINEID_D: "ID Coroutine đề cập đến phần xử lý của một coroutine cụ thể. Nó cho phép thực hiện nhiều thao tác khác nhau trên tay cầm.",
  T_42_XXJ_WS_CREATESELFRELATIVE_D: "Tạo một người thân",
  T_42_XXJ_WS_CREATESELFRELATIVEFRAME_D: "Tạo một người thân",
  T_42_XXJ_WS_CREATESOUND: "Tạo hiệu ứng âm thanh",
  T_42_XXJ_WS_CREATESOUND_D: "Phát đoạn âm thanh được chỉ định. Nếu có thể thiết lập các thuộc tính khác, bạn có thể thiết lập bằng cách thay đổi thuộc tính vật thể.",
  T_42_XXJ_WS_CUSTOMMISSIONCOMPLETE_D: "Danh sách so sánh nội dung",
  T_42_XXJ_WS_DAMAGELIST_D: "Danh sách tăng DMG",
  T_42_XXJ_WS_DAMAGERATIOHEAD_D: "Tỷ lệ DMG của phát đầu tiên",
  T_42_XXJ_WS_DAMAGEREDUCTIONFACTOREXPLODE_D: "Hệ số giảm DMG nổ",
  T_42_XXJ_WS_DEFAULT_PHYMAT: "Chất liệu Mặc định",
  T_42_XXJ_WS_DEFAULTFIST_D: "Nắm đấm mặc định",
  T_42_XXJ_WS_DELTA: "Delta",
  T_42_XXJ_WS_DELTA_D: "Delta",
  T_42_XXJ_WS_DELTATIME: "Khoảng khung logic",
  T_42_XXJ_WS_DELTATIME_D: "Khoảng thời gian giữa 2 lần cập nhật khung logic của GS",
  T_42_XXJ_WS_DEPTH: "Chiều sâu",
  T_42_XXJ_WS_DEPTH_D: "Hiển thị các lớp trên biểu tượng",
  T_42_XXJ_WS_DISABLEPICKUPITEMS: "Danh sách chiến lợi phẩm trên mặt đất bị vô hiệu hóa",
  T_42_XXJ_WS_DISABLEPICKUPITEMS_D: "Danh sách các vật phẩm không phải là chiến lợi phẩm trên mặt đất",
  T_42_XXJ_WS_DRIVER: "Chỗ ngồi người lái",
  T_42_XXJ_WS_DRIVINGSTATUS: "Lái xe",
  T_42_XXJ_WS_DURATION_D1: "Thời gian đếm ngược tính bằng giây",
  T_42_XXJ_WS_DURATION_D2: "Thời lượng tính bằng giây",
  T_42_XXJ_WS_DURATION_D3: "Thời lượng",
  T_42_XXJ_WS_DURATION_D4: "Thời gian bất khả xâm phạm tính bằng giây",
  T_42_XXJ_WS_DURATIONTIMES: "Khoảng thời gian",
  T_42_XXJ_WS_DURATIONTIMES_D: "Thời lượng tính bằng giây",
  T_42_XXJ_WS_DYNAMIC_FRICTION: "Ma sát động",
  T_42_XXJ_WS_EASY: "Rất Dễ",
  T_42_XXJ_WS_ENDTIMES: "Thời gian kết thúc",
  T_42_XXJ_WS_ENDTIMES_D: "Thời gian kết thúc trên đồng hồ tính bằng giây",
  T_42_XXJ_WS_ENERGYTHRESHOLD: "Giới hạn năng lượng toàn bản đồ",
  T_42_XXJ_WS_ENTITYVARNAME_D: "Thực thể tự tương đối",
  T_42_XXJ_WS_EQUIPMENTATTACHMENT_D: "Đính kèm trang bị",
  T_42_XXJ_WS_EULERANGLETOQUATERNION_D: "Chuyển đổi các góc Euler đã cho thành Quaternions",
  T_42_XXJ_WS_EXPONENTIATION_D: "Lũy thừa",
  T_42_XXJ_WS_EXTRABAGCAPACITY_D: "Dung lượng balo bổ sung",
  T_42_XXJ_WS_FIST: "Nắm đấm",
  T_42_XXJ_WS_FONTTYPE: "Kiểu enum",
  T_42_XXJ_WS_FONTTYPE_D: "Phông chữ enum",
  T_42_XXJ_WS_FORCESYNCVALUE: "Buộc đồng bộ hóa trạng thái GS",
  T_42_XXJ_WS_FORCESYNCVALUE_D: "Gía trị buộc đồng bộ hoá",
  T_42_XXJ_WS_FORCESYNCVALUE_D1: "Thông tin vị trí. từ buộc đồng bộ GS",
  T_42_XXJ_WS_FORCESYNCVALUE1: "Thông tin vị trí buộc đồng bộ",
  T_42_XXJ_WS_FORMULABLEENTITY_D: "Một thực thể có thể hình thành các thuộc tính",
  T_42_XXJ_WS_FORWARD_D: "Vectơ chỉ hướng",
  T_42_XXJ_WS_FRICTION_COMBINE: "Phương thức kết hợp ma sát",
  T_42_XXJ_WS_FUNCPOINT: "Con trỏ hàm",
  T_42_XXJ_WS_FUNCPOINT_D: "Một con trỏ trỏ đến một thể hiện của hàm. Nó được sử dụng để thực hiện các chức năng ảo hoặc cơ chế ủy nhiệm.",
  T_42_XXJ_WS_GETMAPID_D: "Lấy ID Bản đồ",
  T_42_XXJ_WS_GETOFFVEHICLESTATUS: "Rời khỏi phương tiện",
  T_42_XXJ_WS_GETONASDRIVERSTATUS: "Ngồi vào xe (tài xế)",
  T_42_XXJ_WS_GETONASPASSENGERSTATUS: "Ngồi vào xe (hành khách)",
  T_42_XXJ_WS_GETPLAYERTOKENCOUNTTODAY_D: "Tìm kiếm dữ liệu mã thông báo người chơi của ngày hôm nay",
  T_42_XXJ_WS_GRAVITY: "Ma sát toàn bản đồ",
  T_42_XXJ_WS_HANDHELDITEM: "Thiết bị cầm tay hiện tại",
  T_42_XXJ_WS_HANDHELDITEM_D: "Máy cầm tay hiện nay",
  T_42_XXJ_WS_HARD: "Khó",
  T_42_XXJ_WS_HASCOMPONENT_D: "Liệu có tồn tại một thành phần",
  T_42_XXJ_WS_HEIGHTLIST_D: "Danh sách được phân đoạn cao",
  T_42_XXJ_WS_INDEXLIST_D: "Truy cập danh sách chỉ mục của chuỗi",
  T_42_XXJ_WS_INSCENE: "Trong cảnh",
  T_42_XXJ_WS_INSCENE_D: "Trong cảnh",
  T_42_XXJ_WS_IS3D_D: "Cho dù đó là âm nhạc 3D",
  T_42_XXJ_WS_ISCOUNTDOWN_D: "Đếm ngược hoặc bấm giờ",
  T_42_XXJ_WS_ISLOOP: "Lặp hay không",
  T_42_XXJ_WS_ISLOOP_D: "Lệnh IsLoop",
  T_42_XXJ_WS_ISREPLAY_D: "Có nên bắt đầu lại từ đầu hay không",
  T_42_XXJ_WS_ISSWITCH_D: "Khi được đặt thành true, nó có thể được kết hợp với chuyển động tương đối. Khi được đặt thành sai, nó có thể được kết hợp với chuyển động tuyệt đối.",
  T_42_XXJ_WS_JEEP: "Xe Jeep",
  T_42_XXJ_WS_JUMPSTATUS: "Trạng thái nhảy",
  T_42_XXJ_WS_LEFTVALUE: "Giá trị trái",
  T_42_XXJ_WS_LEFTVALUE_D: "Cơ số",
  T_42_XXJ_WS_LOGARITHM_D: "Logarithm",
  T_42_XXJ_WS_LOOPABLE: "Có thể lặp lại",
  T_42_XXJ_WS_LOOPABLE_D: "Có thể lặp lại",
  T_42_XXJ_WS_MAPGETALLKEYS_D: "Nhận tất cả các khóa từ dict",
  T_42_XXJ_WS_MAPVALUE_D: "Từ điển mục tiêu",
  T_42_XXJ_WS_MARKBTNHUD: "Nút ghim trên HUD",
  T_42_XXJ_WS_MATHE: "euler's number",
  T_42_XXJ_WS_MATHPI: "pi",
  T_42_XXJ_WS_MAXDISTANCE_D: "Khoảng cách tối đa",
  T_42_XXJ_WS_MICROPHONEBTNHUD: "Công tắc mic trên HUD",
  T_42_XXJ_WS_MINDISTANCE_D: "Khoảng cách tối thiểu",
  T_42_XXJ_WS_MISSIONID_D: "ID Nhiệm Vụ",
  T_42_XXJ_WS_MISSIONPROGRESS_D: "Tiến trình (không được là số âm)",
  T_42_XXJ_WS_MODERATE: "Vừa phải",
  T_42_XXJ_WS_MONSTERTRUCK: "Xe thính",
  T_42_XXJ_WS_MOTORBIKE: "Xe máy",
  T_42_XXJ_WS_MOVEMENTSTATUS: "Trạng thái di chuyển",
  T_42_XXJ_WS_MULTIPLYQUATERNION_D: "Phép nhân hai bậc bốn (thể hiện sự chồng chất phép quay)",
  T_42_XXJ_WS_NORMAL: "Bình thường",
  T_42_XXJ_WS_OBSOLETE: "Đã vứt bỏ",
  T_42_XXJ_WS_OPENPLAYERVIEW: "Bật góc nhìn của người chơi",
  T_42_XXJ_WS_OPENPLAYERVIEW_D: "Bật góc nhìn của người chơi",
  T_42_XXJ_WS_ORIGINWEAPONTYPE: "Loại vũ khí",
  T_42_XXJ_WS_ORIGINWEAPONTYPE_D: "Loại vũ khí",
  T_42_XXJ_WS_OVERLOADPLAYERSKIN: "Ưu tiên cấu hình người chơi.",
  T_42_XXJ_WS_PARAMSARRAY: "Mảng tham số",
  T_42_XXJ_WS_PARAMSARRAY_D: "Mảng tham số là danh sách các tham số liên quan đến đầu ra. Nó cần khớp với số %v trong mô tả định dạng.",
  T_42_XXJ_WS_PARAMSARRAY_D1: "Danh sách các tham số thực tế được chuyển đến các hàm tùy chỉnh.",
  T_42_XXJ_WS_PARTVISABLEMASK1: "Phần mặt nạ hiển thị 1",
  T_42_XXJ_WS_PARTVISABLEMASK2: "Phần mặt nạ hiển thị 2",
  T_42_XXJ_WS_PARTVISABLEMASK3: "Phần mặt nạ hiển thị 3",
  T_42_XXJ_WS_PARTVISABLEMASK4: "Phần mặt nạ hiển thị 4",
  T_42_XXJ_WS_PASSENGER1: "Ghế hành khách 1",
  T_42_XXJ_WS_PASSENGER2: "Ghế hành khách 2",
  T_42_XXJ_WS_PASSENGER3: "Ghế hành khách 3",
  T_42_XXJ_WS_PHYMAT: "Chất liệu",
  T_42_XXJ_WS_PLAYABLEENTITIES_D: "Thực thể",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME: "Chuyển động tự tương đối trong mỗi khung hình",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME_D: "Tự chuyển động tương đối mỗi khung hình",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE: "Chuyển động tự tương đối",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE_D: "Tự chuyển động tương đối",
  T_42_XXJ_WS_PLAYER_D: "Người chơi cần lên xe",
  T_42_XXJ_WS_PLAYERBEHAVIOR: "Thực thể đồng bộ hóa thuộc tính hành vi của người chơi",
  T_42_XXJ_WS_PLAYERBEHAVIOR_D: "Thực thể đồng bộ hóa thuộc tính hành vi của người chơi",
  T_42_XXJ_WS_PRIORITY_D: "Sự ưu tiên",
  T_42_XXJ_WS_PROPID_D: "ID tài sản",
  T_42_XXJ_WS_QUATERNION: "Quaternion",
  T_42_XXJ_WS_QUATERNION_D: "Quaternion là một vectơ bốn chiều đặc biệt chỉ được sử dụng để biểu diễn một phép quay",
  T_42_XXJ_WS_QUATERNIONTOAXISANGLE_D: "Chuyển đổi các Quaternions đã cho thành góc Axis",
  T_42_XXJ_WS_QUATERNIONTOEULERANGLE_D: "Chuyển đổi các Quaternion đã cho thành các góc Euler. Nếu Quaternions không đạt tiêu chuẩn, trả về (0,0,0).",
  T_42_XXJ_WS_REPEATTIMES_D: "Số lần chơi. Mặc định là 1.",
  T_42_XXJ_WS_RESETPLAYABLE_D: "Cài lại",
  T_42_XXJ_WS_RIGHTVALUE: "Giá trị phải",
  T_42_XXJ_WS_RIGHTVALUE_D: "Sức mạnh",
  T_42_XXJ_WS_SEATTYPE: "Kiểu chỗ ngồi enum",
  T_42_XXJ_WS_SEPSTR_D: "Chuỗi dùng để phân tách",
  T_42_XXJ_WS_SETPLAYERFALLINGDAMAGE_D: "Đặt người chơi rơi SÁT THƯƠNG",
  T_42_XXJ_WS_SETTINGSBTNHUD: "Nút cài đặt trên HUD",
  T_42_XXJ_WS_SHOWPOSITION: "Hiển thị vị trí",
  T_42_XXJ_WS_SHOWPOSITION_D: "Hiển thị vị trí",
  T_42_XXJ_WS_SIGNALICOHUD: "Tín hiệu Ico HUD",
  T_42_XXJ_WS_SIMPLE: "Dễ",
  T_42_XXJ_WS_SLERPQUATERNION_D: "Nội suy quaternion hình cầu từ A đến B",
  T_42_XXJ_WS_SOUNDENTITY_D: "Thực thể hiệu ứng âm thanh thể hiện hiệu ứng âm thanh đang được phát",
  T_42_XXJ_WS_SPEAKERBTNHUD: "Nút còi trên HUD",
  T_42_XXJ_WS_SPLITSTRING_D: "Sử dụng một chuỗi nhất định làm dấu phân cách để chia chuỗi thành một lát",
  T_42_XXJ_WS_SPORTSCAR: "Xe thể thao",
  T_42_XXJ_WS_SPRINTSTATUS: "Trạng thái chạy nhanh",
  T_42_XXJ_WS_SRCVAL_D: "Giá trị nguồn",
  T_42_XXJ_WS_STARTTICKCOUNT: "Thời điểm GS bắt đầu tích tắc",
  T_42_XXJ_WS_STARTTICKCOUNT_D: "Thời điểm GS bắt đầu tích tắc",
  T_42_XXJ_WS_STARTTIME_D: "Thời gian bắt đầu",
  T_42_XXJ_WS_STARTTIME_D1: "Thời gian bắt đầu",
  T_42_XXJ_WS_STATE_D: "Trạng thái của người chơi: đang hoạt động, bị gục hoặc bị loại",
  T_42_XXJ_WS_STATE_D1: "Kiểm tra xem hiệu ứng âm thanh này có đang phát không",
  T_42_XXJ_WS_STATIC_FRICTION: "Ma sát tĩnh",
  T_42_XXJ_WS_STRELEMS_D: "Bộ chuỗi mục tiêu",
  T_42_XXJ_WS_STRINGFINDAT_D: "Trả về chuỗi kết hợp cuối cùng theo danh sách chỉ mục",
  T_42_XXJ_WS_STRINGJOIN_D: "Nối chuỗi bằng cách sử dụng mã định danh được chỉ định",
  T_42_XXJ_WS_STRINGLOWER_D: "Chuyển đổi tất cả các ký tự trong chuỗi thành chữ thường",
  T_42_XXJ_WS_STRINGSTRIP_D: "Xóa các ký tự khoảng trắng ở cả hai bên của chuỗi",
  T_42_XXJ_WS_STRINGUPPER_D: "Chuyển tất cả các ký tự trong chuỗi thành chữ hoa",
  T_42_XXJ_WS_STYLE_D: "Cách chơi",
  T_42_XXJ_WS_SUV: "Xe bán tải",
  T_42_XXJ_WS_SWITCH: "Công tắc",
  T_42_XXJ_WS_SWITCH_D: "Khi được đặt thành true, nó có thể được kết hợp với chuyển động tương đối. Khi được đặt thành false, nó phải được kết hợp với chuyển động tuyệt đối, nếu không các thuộc tính sẽ không có hiệu lực chính xác.",
  T_42_XXJ_WS_TARGETENTITY_D: "Thực thể mục tiêu",
  T_42_XXJ_WS_TEAMROUNDSCOREBANNERHUD: "Nền điểm của đội",
  T_42_XXJ_WS_TEAMSEQ_D: "Số sê-ri của nhóm tương ứng với thuộc tính số sê-ri của thực thể nhóm",
  T_42_XXJ_WS_TEMPORARYSHIELD: "Điểm lá chắn tạm thời",
  T_42_XXJ_WS_TEMPORARYSHIELD_D: "Điểm lá chắn tạm thời",
  T_42_XXJ_WS_TEXT_D: "Văn bản gốc cần thực hiện bộ lọc tục tĩu trên",
  T_42_XXJ_WS_THREESTATESWITCH: "Công tắc 3 chấu",
  T_42_XXJ_WS_THROWINGKNIFE_D: "Phi đao (chiến lợi phẩm trên mặt đất)",
  T_42_XXJ_WS_THROWINGKNIFEBR_D: "Phi đao",
  T_42_XXJ_WS_TUKTUK: "Tuk Tuk",
  T_42_XXJ_WS_TWOTEAMLEADERBOARDHUD: "Chi tiết đấu đội",
  T_42_XXJ_WS_UNIQUEID: "Unique ID",
  T_42_XXJ_WS_UNIQUEID_D: "Unique ID",
  T_42_XXJ_WS_VALUE_D: "Giá trị",
  T_42_XXJ_WS_VECTOR3TOEULERANGLES_D: "Vectơ chỉ phương góc Euler",
  T_42_XXJ_WS_VEHICLEID: "ID Phương tiện",
  T_42_XXJ_WS_VEHICLESKINID: "ID skin xe",
  T_42_XXJ_WS_VERYHARD: "Rất khó",
  T_42_XXJ_WS_VOLUME_D: "Âm lượng. Mặc định là 50.",
  T_42_XXJ_WS_WEAPONTYPE_D: "Loại chính của vũ khí",
  T_42_XXJ_WS_WORKSHOPCODE: "Mã bản đồ",
  T_42_XXJ_WS_WORKSHOPCODE_D: "Mã bản đồ tương ứng với dữ liệu trong cơ sở dữ liệu",
  T_42_XXJ_WS_WORLDPOSITION: "Tọa độ thế giới",
  T_42_XXJ_WS_WORLDPOSITION_D: "Tọa độ thế giới",
  T_42_XYL_WS_ITEM275: "Bình xăng",
  T_42_XYL_WS_ITEM276: "Bao cát A",
  T_42_XYL_WS_ITEM277: "Bao cát B",
  T_42_XYL_WS_ITEM278: "Bao cát C",
  T_42_XYL_WS_ITEM279: "Bao cát",
  T_42_XYL_WS_ITEM280: "Biệt thự hai tầng",
  T_42_XYL_WS_ITEM281: "Nhà máy vũ khí",
  T_42_XYL_WS_ITEM282: "Bức Tường Đá A",
  T_42_XYL_WS_ITEM283: "Bức Tường Đá B",
  T_42_XYL_WS_ITEM284: "Bức Tường Đá C",
  T_42_XYL_WS_ITEM285: "Bức Tường Đá D",
  T_42_XYL_WS_ITEM286: "Hộp tiếp tế quân sự A",
  T_42_XYL_WS_ITEM287: "Xu Đồng",
  T_42_XYL_WS_ITEM288: "Xu Bạc",
  T_42_XYL_WS_ITEM289: "Xu Vàng",
  T_42_XYL_WS_ITEM290: "Kim cương",
  T_42_XYL_WS_ITEM291: "Mảnh kim cương",
  T_42_XYL_WS_ITEM292: "Hồng ngọc",
  T_42_XYL_WS_ITEM293: "Ngọc lục bảo",
  T_42_XYL_WS_ITEM294: "Ngọc bích",
  T_42_XYL_WS_ITEM295: "Cảnh báo",
  T_42_XYL_WS_ITEM297: "Tàn tích",
  T_42_XYL_WS_ITEM297TRUE: "Thiết bị điều khiển",
  T_42_XYL_WS_ITEM298: "Container cung ứng B",
  T_42_XYL_WS_ITEM299: "Đống tuyết",
  T_42_XYL_WS_ITEM300: "Tường công nghệ cao A",
  T_42_XYL_WS_ITEM301: "Tường công nghệ cao B",
  T_42_XYL_WS_ITEM302: "Đá đông lạnh F",
  T_42_XYL_WS_ITEM303: "Đá đông lạnh E",
  T_42_XYL_WS_ITEM304: "Nền tảng công nghệ cao A",
  T_42_XYL_WS_ITEM305: "Cầu thang công nghệ cao A",
  T_42_XYL_WS_ITEM306: "Đèn thăm dò A",
  T_42_XYL_WS_ITEM307: "Vách ngăn đổ nát A",
  T_42_XYL_WS_ITEM308: "Vách ngăn đổ nát B",
  T_42_XYL_WS_ITEM309: "Khung thép đổ nát A",
  T_42_XYL_WS_ITEM310: "Đá tàn tích A",
  T_42_XYL_WS_ITEM311: "Đá tàn tích B",
  T_42_XYL_WS_ITEM312: "Đá tàn tích C",
  T_42_XYL_WS_ITEM313: "Đèn pin A",
  T_42_XYL_WS_ITEM314: "Tàn tích cốt thép A",
  T_42_XYL_WS_LOGICALOBJECT: "Logic",
  T_42_XYL_WS_THEMEHIGHTECH: "Tân Tiến",
  T_42_XYL_WS_THEMEICE: "Tuyết băng",
  T_42_XYL_WS_THEMEMILITARY: "Quân sự",
  T_42_XYL_WS_THEMEOBJECTS: "Vật thể theo chủ đề",
  T_42_XYL_WS_TIMERCONTINUE: "Hẹn giờ tiếp tục sự cố",
  T_42_XYL_WS_TIMERCYCLE: "Số vòng lặp",
  T_42_XYL_WS_TIMERDOWN: "Đếm ngược",
  T_42_XYL_WS_TIMEREND: "Sự cố kết thúc hẹn giờ",
  T_42_XYL_WS_TIMEREVENT: "Customized Timer Incident",
  T_42_XYL_WS_TIMEREVENT1: "Điều khiển hẹn giờ",
  T_42_XYL_WS_TIMEREVENT2: "Đặt sự cố hẹn giờ",
  T_42_XYL_WS_TIMERORDER: "Phương pháp tính thời gian",
  T_42_XYL_WS_TIMERPAUSE: "Sự cố tạm dừng hẹn giờ",
  T_42_XYL_WS_TIMERSTART1: "Thời gian bắt đầu hẹn giờ",
  T_42_XYL_WS_TIMERSTART2: "Sự cố bắt đầu hẹn giờ",
  T_42_XYL_WS_TIMERUP: "Đếm dần lên",
  T_42_XYL_WS_TRIGGERTIME_MS: "Thời gian kích hoạt (tính bằng mili giây)",
  T_42_ZZ_GUILDWAR_AIRCRAFTDESC: "Một chiếc skywing có thể chở nhiều người chơi.",
  T_42_ZZ_GUILDWAR_PERSONALSCORE: "Điểm cá nhân",
  T_42_ZZ_GUILDWAR_SCORE: "Điểm",
  T_43_B_SKILL_DESC_MONKEYGOD: "Biến hình thành bụi cây tồn tại trong [FFB300]{1} giây[-]. Thời gian hồi: [FFB300]{0} giây[-]. Ngộ Không sẽ bị lộ nguyên hình khi tấn công hoặc bị kẻ địch tấn công. Tái tạo hồi chiêu khi Ngộ Không hạ gục kẻ địch.",
  T_43_B_SKILL_DESC_Nanoscientist: "Sau khi nhận sát thương chí mạng, trở nên bất động và bất tử trong [FFB300]{0} giây[-]. Sau đó, nhận [FFB300]{1} lá chắn[-] tồn tại trong [FFB300]{2} giây[-]. Người sử dụng sẽ bị hạ gục sau khi lá chắn biến mất. Thời gian hồi: [FFB300]{3} giây [-].",
  T_43_B_SKILL_DESC_ORION: "EP được thay thế bằng [FFB300]{0} Năng Lượng Đỏ[-]. Khi kích hoạt, sử dụng [FFB300]{1} [-]Năng lượng đỏ để kích hoạt miễn nhiễm, khi này bạn sẽ không nhận sát thương và không thể tấn công đồng thời hút [FFB300]{4} HP[-] (bỏ qua lá chắn của kẻ thù) kẻ thù trong vòng [FFB300]{3}m[-]. Kéo dài trong [FFB300]{2}s[-], giảm tốc độ di chuyển của bản thân đi [FFB300]{6}%[-] trong thời gian kích hoạt. Thời gian hồi: [FFB300]{5} giây[-].",
  T_43_CJ_F_A_RACER: "Nữ Hoàng Đường Đua (Mặt nạ)",
  T_43_CJ_F_B_RACER: "Nữ Hoàng Đường Đua (Quần)",
  T_43_CJ_F_H_RACER: "Nữ Hoàng Đường Đua (Đầu)",
  T_43_CJ_F_HA_RACER: "Nữ Hoàng Đường Đua (Mặt)",
  T_43_CJ_F_S_RACER: "Nữ Hoàng Đường Đua (Giày)",
  T_43_CJ_F_T_RACER: "Nữ Hoàng Đường Đua (Áo)",
  T_43_CJ_M_A_RACER: "Nam Thần Đường Đua (Mặt nạ)",
  T_43_CJ_M_B_MACHINERY: "Siêu Chiến Binh Lam (Quần)",
  T_43_CJ_M_B_RACER: "Nam Thần Đường Đua (Quần)",
  T_43_CJ_M_H_MACHINERY: "Siêu Chiến Binh Lam (Đầu)",
  T_43_CJ_M_H_RACER: "Nam Thần Đường Đua (Đầu)",
  T_43_CJ_M_HA_MACHINERY: "Siêu Chiến Binh Lam (Mặt)",
  T_43_CJ_M_S_MACHINERY: "Siêu Chiến Binh Lam (Giày)",
  T_43_CJ_M_S_RACER: "Nam Thần Đường Đua (Giày)",
  T_43_CJ_M_T_MACHINERY: "Siêu Chiến Binh Lam (Áo)",
  T_43_CJ_M_T_RACER: "Nam Thần Đường Đua (Áo)",
  T_43_H_CHARACTER_GEEK_N: "Ryden",
  T_43_H_VSK94_MAMBAS_N: "VSK94 - Phong Xà",
  T_43_HJ_WS_OPTION8: "Khác",
  T_43_HJ_WS_TEXTURE_BAMBOO: "Tre",
  T_43_HJ_WS_TEXTURE_BEACH: "Bãi biển",
  T_43_HJ_WS_TEXTURE_BRICK1: "Tường gạch A",
  T_43_HJ_WS_TEXTURE_BRICK2: "Tường gạch B",
  T_43_HJ_WS_TEXTURE_BRICK3: "Tường gạch C",
  T_43_HJ_WS_TEXTURE_CEMENT: "Nền bê tông",
  T_43_HJ_WS_TEXTURE_CEMENT2: "Bê tông",
  T_43_HJ_WS_TEXTURE_CRYSTAL: "Pha lê",
  T_43_HJ_WS_TEXTURE_GLASSLAND1: "Cỏ A",
  T_43_HJ_WS_TEXTURE_GLASSLAND2: "Cỏ B",
  T_43_HJ_WS_TEXTURE_ICE: "Tảng băng",
  T_43_HJ_WS_TEXTURE_IRON: "Nền kim loại",
  T_43_HJ_WS_TEXTURE_IRON2: "Container",
  T_43_HJ_WS_TEXTURE_LAVA: "Dung nham",
  T_43_HJ_WS_TEXTURE_MARBLE: "Sàn cẩm thạch",
  T_43_HJ_WS_TEXTURE_NONE: "Trống",
  T_43_HJ_WS_TEXTURE_STONE: "Đá",
  T_43_HJ_WS_TEXTURE_TEXTILE1: "Khăn trải bàn A",
  T_43_HJ_WS_TEXTURE_TEXTILE2: "Khăn trải bàn B",
  T_43_HJ_WS_TEXTURE_WOOD: "Gỗ",
  T_43_HJ_WS_TEXTURE_WOODEN: "Nền gỗ A",
  T_43_HJ_WS_TEXTURE_WOODEN2: "Sàn gỗ B",
  T_43_JH_WS_MAPTAG1: "Thân thiện với tân thủ",
  T_43_JH_WS_MAPTAG10: "Nội dung mới nhàm chán",
  T_43_JH_WS_MAPTAG11: "Phần thưởng quá ít",
  T_43_JH_WS_MAPTAG12: "Phần thưởng mất cân bằng",
  T_43_JH_WS_MAPTAG13: "Thiếu cảm gác thăng tiến",
  T_43_JH_WS_MAPTAG14: "Không Phù Hợp với Tân Thủ",
  T_43_JH_WS_MAPTAG15: "Hướng dẫn khó hiểu",
  T_43_JH_WS_MAPTAG16: "Thiếu hướng dẫn",
  T_43_JH_WS_MAPTAG17: "Người chơi thoát nhiều",
  T_43_JH_WS_MAPTAG18: "Điều khiển phức tạp",
  T_43_JH_WS_MAPTAG19: "Giao Diện Rối Rắm",
  T_43_JH_WS_MAPTAG2: "Nội dung mới thú vị",
  T_43_JH_WS_MAPTAG20: "Thiết kế tệ",
  T_43_JH_WS_MAPTAG21: "Đấu Súng Hấp Dẫn",
  T_43_JH_WS_MAPTAG22: "Nhịp Độ Nhanh",
  T_43_JH_WS_MAPTAG23: "Thế Giới Mở",
  T_43_JH_WS_MAPTAG24: "Cốt Truyện",
  T_43_JH_WS_MAPTAG25: "Hệ Thống Tiến Trình",
  T_43_JH_WS_MAPTAG26: "Giả Lập Thể Thao",
  T_43_JH_WS_MAPTAG27: "Nhiệm Vụ Tổ Đội",
  T_43_JH_WS_MAPTAG28: "Tương Tác Xã Hội",
  T_43_JH_WS_MAPTAG29: "Đa Dạng Khả Năng",
  T_43_JH_WS_MAPTAG3: "Nhiều người chơi",
  T_43_JH_WS_MAPTAG30: "Tự Do Khám Phá",
  T_43_JH_WS_MAPTAG31: "Thử Thách Xếp Hạng",
  T_43_JH_WS_MAPTAG32: "Thử Thách Thành Tựu",
  T_43_JH_WS_MAPTAG33: "Quy Đổi Tiền Tệ",
  T_43_JH_WS_MAPTAG4: "Thiết kế tốt",
  T_43_JH_WS_MAPTAG40: "Nhiều phần thưởng",
  T_43_JH_WS_MAPTAG41: "Tiến trình thú vị",
  T_43_JH_WS_MAPTAG42: "Sân Tập Phổ Biến",
  T_43_JH_WS_MAPTAG43: "Tháp Đơn Phổ Biến",
  T_43_JH_WS_MAPTAG44: "Vùng Chiến Phổ Biến",
  T_43_JH_WS_MAPTAG5: "Bị Giật Lag",
  T_43_JH_WS_MAPTAG6: "Khó phối hợp",
  T_43_JH_WS_MAPTAG7: "Nhiều Lỗi",
  T_43_JH_WS_MAPTAG8: "Ít cập nhật",
  T_43_JH_WS_MAPTAG9: "Sự kiện trong game nhàm chán",
  T_43_JH_WS_SKILLSETAUTOPATHBOMB: "Cạm bẫy nhện độc (Ryden)",
  T_43_SJ_WS_AIRDROP_ITEMS: "Rơi vật phẩm",
  T_43_SJ_WS_AIRDROP_NAME: "Thính",
  T_43_SJ_WS_AIRDROP_TIME: "Thời gian bắt đầu rơi",
  T_43_SJ_WS_AIRDROP_UI_ITEM: "Rơi vật phẩm",
  T_43_SJ_WS_ANITRIGGER_AUTO: "Tự động phát",
  T_43_SJ_WS_ANITRIGGER_CENTER: "Ở vị trí trung tâm",
  T_43_SJ_WS_ANITRIGGER_CLIP: "ID Clip hoạt ảnh",
  T_43_SJ_WS_ANITRIGGER_LOOP: "Lặp lại",
  T_43_SJ_WS_ANITRIGGER_NAME: "HUD kích hoạt hoạt ảnh",
  T_43_SJ_WS_RESET_ROUND: "Làm mới sau mỗi vòng",
  T_43_SJ_WS_START_DROPTIME: "Thời gian bắt đầu rơi (ms)",
  T_43_SJ_WS_TRIGGER_ANIMA: "Kích hoạt hoạt ảnh",
  T_43_SY_PETSKIN_AXOLOTL_WATERFEST24_N: "Skin trợ thủ: Zasil Quàng Thượng",
  T_43_SY_VEHICLESKIN_MOTOBIKE_FIGHTER_N: "Xe máy - Hồn Thú",
  T_43_WH_ITEM_SUPPLYBOX_DESC: "Chứa các loại vật phẩm tiếp tế thiết yếu như đạn và túi cứu thương",
  T_43_WH_ITEM_SUPPLYBOX_NAME: "Hộp Tiếp Tế",
  T_43_WT_SKILL_DESC_DUMMY_REWORK: "Tạo một hình nhân có [FFB300]{1} Máu[-] tự động di chuyển trong vòng [FFB300]{0} giây[-]. Khi ở trong phạm vi [FFB300]{3}m[-] với hình nhân, bạn có thể tái kích hoạt kỹ năng để đổi vị trí với nó. Bạn chỉ có thể đổi vị trí một lần mỗi [FFB300]{4} giây[-], đến tối đa [FFB300]{2} lần[-] tổng cộng. Kẻ địch phá hủy hình nhân sẽ bị đánh dấu trong [FFB300]{5} giây[-]. Thời gian hồi: [FFB300]{6} giây[-].",
  T_43_WT_W_VSK94: "VSK94",
  T_43_XXJ_WS_ACTIVITYSKILL: "Kỹ năng chủ động",
  T_43_XXJ_WS_AIRDROP: "Thính và Zombie",
  T_43_XXJ_WS_ALPHA: "Alpha",
  T_43_XXJ_WS_ALPHA_D: "Độ trong suốt của HUD, phạm vi giá trị từ 0 đến 1.",
  T_43_XXJ_WS_ANIMATIONCTRLID: "ID Điều khiển hoạt ảnh",
  T_43_XXJ_WS_ANIMATIONCTRLID_D: "ID mô tả tài nguyên điều khiển hoạt ảnh",
  T_43_XXJ_WS_AUDIOID: "ID Âm Thanh",
  T_43_XXJ_WS_AUDIOID_D: "ID được dùng để mô tả tài nguyên âm thanh",
  T_43_XXJ_WS_BACKGRCOLOR: "Màu nền",
  T_43_XXJ_WS_BACKGRCOLOR_D: "Màu sắc giữa viền thanh máu và phần nền bị mờ",
  T_43_XXJ_WS_BURNING: "Đang cháy",
  T_43_XXJ_WS_CSVID: "ID CSV",
  T_43_XXJ_WS_CSVID_D: "ID được dùng để mô tả tài nguyên bảng thiết lập",
  T_43_XXJ_WS_CURRENTHP: "HP hiện tại",
  T_43_XXJ_WS_CURRENTHP_D: "Giá trị HP hiện tại",
  T_43_XXJ_WS_DAMAGEMAKER_D: "Thực thể gây sát thương trong trò chơi",
  T_43_XXJ_WS_DAMAGEZONE: "Vùng sát thương",
  T_43_XXJ_WS_DEFAULT: "Mặc định",
  T_43_XXJ_WS_DEFAULT_D: "Mặc định",
  T_43_XXJ_WS_EFFECTID: "ID Hiệu ứng",
  T_43_XXJ_WS_EFFECTID_D: "ID mô tả tài nguyên hiệu ứng đặc biệt",
  T_43_XXJ_WS_FIGHTINGENTITY_D: "Một thực thể có thể chiến đấu (v.d tấn công, bị tấn công, bị tiêu diệt)",
  T_43_XXJ_WS_FOLLOWTARGET: "Theo mục tiêu",
  T_43_XXJ_WS_FOLLOWTARGET_D: "Phải đi theo một thực thể với thành phần Biến hình",
  T_43_XXJ_WS_GAINHPCOLOR: "Nhận màu HP",
  T_43_XXJ_WS_GAINHPCOLOR_D: "Phần HP được tăng thêm sẽ hiển thị với màu này trong một thời gian ngắn",
  T_43_XXJ_WS_ISNOFALLDAMAGE: "Không có sát thương khi ngã",
  T_43_XXJ_WS_ISOPENTWEEN: "Tween đang mở",
  T_43_XXJ_WS_ISOPENTWEEN_D: "Mở để hiển thị thay đổi HP với màu khác nhau",
  T_43_XXJ_WS_KNOCKDOWN_D1: "Người chơi này đang ở trạng thái bị hạ gục",
  T_43_XXJ_WS_KNOCKDOWN_D2: "Thiết lập để người chơi về trạng thái gục trước khi bị tiêu diệt",
  T_43_XXJ_WS_KNOCKDOWN_D3: "Nguồn hồi sinh người chơi. Một người chơi có thể được hồi sinh sau khi bị tiêu diệt.",
  T_43_XXJ_WS_KNOCKDOWNSTATE: "Trạng thái hạ gục",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE: "Loại trạng thái hạ gục",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE_D: "Thiết lập lại trạng thái hạ gục: mặc định, bỏ qua trạng thái hạ gục, hoặc buộc phải vào trạng thái hạ gục",
  T_43_XXJ_WS_LEVEL: "Cấp",
  T_43_XXJ_WS_LEVEL_D: "Cấp",
  T_43_XXJ_WS_LEVEL_D1: "Cấp zombie hiện tại",
  T_43_XXJ_WS_LINESPACING: "Khoảng cách dòng",
  T_43_XXJ_WS_LINESPACING_D: "Không hiển thị khi phần HP giữa hai vạch chia ≤ 0",
  T_43_XXJ_WS_LOSEHPCOLOR: "Màu HP mất",
  T_43_XXJ_WS_LOSEHPCOLOR_D: "Lượng HP bị trừ sẽ hiển thị với màu này trong một thời gian ngắn",
  T_43_XXJ_WS_MAINCOLOR: "Màu chủ đạo",
  T_43_XXJ_WS_MAINCOLOR_D: "Màu HP, cấp, và viền",
  T_43_XXJ_WS_MINISENTRY: "Tháp pháo",
  T_43_XXJ_WS_MINISENTRYATTACKTARGETTYPE_D: "Trị số giá trị của loại mục tiêu mà tháp pháo có thể tấn công",
  T_43_XXJ_WS_MISSILEEXPLODE: "Tên lửa nổ",
  T_43_XXJ_WS_MUSTKNOCKDOWN: "Phải qua hạ gục",
  T_43_XXJ_WS_MUSTKNOCKDOWN_D: "Buộc bị hạ gục",
  T_43_XXJ_WS_OFFSET: "Khoảng cách",
  T_43_XXJ_WS_OFFSET_D: "Khoảng cách tương đối với mục tiêu được theo dõi",
  T_43_XXJ_WS_OILDRUMEXPLODE: "Nổ thùng dầu",
  T_43_XXJ_WS_ONCONTROLLERCOLLIDERHIT_D: "Chỉ kích hoạt khi điều khiển bắt đầu di chuyển",
  T_43_XXJ_WS_PLAYER_D: "Thực thể người chơi trong game. Mỗi người chơi mang một thực thể.",
  T_43_XXJ_WS_PLAYERHEADHUD: "HUD Đầu người chơi",
  T_43_XXJ_WS_PLAYERHEADHUD_D: "Thông tin hiển thị trên đầu người chơi",
  T_43_XXJ_WS_PLAYERNAME: "Tên người chơi",
  T_43_XXJ_WS_PLAYERNAME_D: "Hiển thị tên của chủ sở hữu thanh máu hiện tại",
  T_43_XXJ_WS_PLAYERORVEHICLE: "Người chơi hay phương tiện",
  T_43_XXJ_WS_PLAYERORVEHICLE_D: "Biệt danh của loại thực thể người chơi/phương tiện",
  T_43_XXJ_WS_SCALE: "Tỉ lệ",
  T_43_XXJ_WS_SCALE_D: "Quyết định độ lớn tổng quan của HUD, và font chữ sẽ được điều chỉnh cho phù hợp.",
  T_43_XXJ_WS_SHOWDAMAGENUMBER: "Hiển thị số sát thương",
  T_43_XXJ_WS_SHOWDAMAGENUMBER_D: "Giá trị mặc định là true. Hiển thị số sát thương.",
  T_43_XXJ_WS_SKIPKNOCKDOWN: "Bỏ qua hạ gục",
  T_43_XXJ_WS_SKIPKNOCKDOWN_D: "Bỏ qua trạng thái gục và sẽ bị tiêu diệt ngay lập tức",
  T_43_XXJ_WS_SKIPSTAGGERANIMATION: "Bỏ qua hoạt ảnh khựng lại (khi nhận sát thương)",
  T_43_XXJ_WS_TEAM_D: "(Đã bị thay thế. Vui lòng sử dụng ID đội)",
  T_43_XXJ_WS_TERRAIN: "Địa hình",
  T_43_XXJ_WS_TERRAIN_D: "Thành phần địa hình không thể điều chỉnh thuộc tính. Chỉ được sử dụng để thử tính năng.",
  T_43_XXJ_WS_TOTALHP: "HP tổng",
  T_43_XXJ_WS_TOTALHP_D: "Tổng giá trị HP",
  T_43_XXJ_WS_TWEENENTITY: "Thực thể Tween",
  T_43_XXJ_WS_VEHICLEEXPLODE: "Nổ phương tiện",
  T_43_XXJ_WS_WIDTH: "Độ rộng",
  T_43_XXJ_WS_WIDTH_D: "Độ rộng của thanh máu hiển thị",
  T_43_XXJ_WS_ZOMBIE: "Zombie",
  T_43_XYL_WS_DROIDFIST: "Nắm đấm (Thời khắc tận thế)",
  T_43_XYL_WS_DROIDFLAME: "Súng phun lửa (Thời khắc tận thế)",
  T_43_XYL_WS_JAPANESE: "Kiểu Nhật",
  T_43_YU_WS_ADDGAMEEVENTLOGMAP_D: "Tùy chỉnh bản ghi sự kiện trận đấu. Dùng để phân tích trải nghiệm người dùng.",
  T_43_YU_WS_AIRDROPSTATE: "Trạng thái Thính",
  T_43_YU_WS_AIRDROPSTATE_D: "Trạng thái thùng thính (1: sẵn sàng, 2: đang rơi, 3: đáp đất)",
  T_43_YU_WS_ANIMATIONCLIPID: "ID hoạt ảnh",
  T_43_YU_WS_ANIMATIONCLIPID_D: "ID hoạt ảnh tùy chỉnh",
  T_43_YU_WS_ASKBUYTARGET: "Yêu cầu mua mục tiêu",
  T_43_YU_WS_ASKBUYTARGET_D: "Chỉ định cụ thể mục tiêu và gửi yêu cầu mua hàng",
  T_43_YU_WS_ASKEDLIST: "Danh sách yêu cầu",
  T_43_YU_WS_ASKEDLIST_D: "Danh sách vật phẩm yêu cầu",
  T_43_YU_WS_BACKGROUNDCOLOR1: "Màu nền 1",
  T_43_YU_WS_BACKGROUNDCOLOR1_D: "Màu nền phía trên",
  T_43_YU_WS_BACKGROUNDCOLOR2: "Màu nền 2",
  T_43_YU_WS_BACKGROUNDCOLOR2_D: "Màu nền bên dưới",
  T_43_YU_WS_BATCHCOMBINERENDER: "Render gói tổng hợp",
  T_43_YU_WS_BINDMONEYENTITYLIST: "Danh sách thực thể liên kết tiền tệ",
  T_43_YU_WS_BINDMONEYENTITYLIST_D: "Danh sách các thực thể tiền tệ được liên kết",
  T_43_YU_WS_BINDWALLETENTITYID: "ID ví liên kết",
  T_43_YU_WS_BINDWALLETENTITYID_D: "ID của thực thể ví liên kết",
  T_43_YU_WS_CENTEROFFSET: "Khoảng cách trung tâm",
  T_43_YU_WS_CENTEROFFSET_D: "Giá trị khoảng cách khi va chạm hình viên nang",
  T_43_YU_WS_COLLECTIONID: "ID Tập Hợp",
  T_43_YU_WS_COLLECTIONID_D: "ID Tập Hợp dùng trong tập hợp thông tin dữ liệu",
  T_43_YU_WS_CREATEAIRDROPENTITY_D: "Tạo thính",
  T_43_YU_WS_CREATEUGCDAMAGENUM_D: "Tạo ra số sát thương",
  T_43_YU_WS_CROSSPLATFORM_D: "Khi được chọn, gửi đến máy khách nếu được gọi tại máy chủ và ngược lại.",
  T_43_YU_WS_CSROUNDRESULTHUD: "HUD kết quả vòng đấu CS",
  T_43_YU_WS_CSROUNDRESULTHUD_D: "Hiển thị kết quả khi kết thúc mỗi vòng",
  T_43_YU_WS_CURRENTEMOTECLIP: "Hành động đang phát hiện tại",
  T_43_YU_WS_CURRENTEMOTECLIP_D: "ID của hành động đang phát",
  T_43_YU_WS_DAMAGE_D: "Sát thương ngoài bo",
  T_43_YU_WS_DICTIONARY: "Từ điển",
  T_43_YU_WS_DIRECTIONRULERHUD: "HUD Thước chỉ hướng",
  T_43_YU_WS_DIRECTIONRULERHUD_D: "La bàn ở trên",
  T_43_YU_WS_DOTWEEN_D: "Có thực hiện hoạt ảnh tween hay không",
  T_43_YU_WS_DROPITEMS_D: "Vật phẩm trong thính",
  T_43_YU_WS_DURATION: "Khoảng thời gian",
  T_43_YU_WS_ENERGY: "Năng Lượng",
  T_43_YU_WS_ENERGY_D: "Giá trị điều chỉnh EP",
  T_43_YU_WS_EPHYSXPOSE_CREEPING: "Nằm sấp",
  T_43_YU_WS_EPHYSXPOSE_CROUCHING: "Ngồi",
  T_43_YU_WS_EPHYSXPOSE_DASHING: "Chạy",
  T_43_YU_WS_EPHYSXPOSE_STANDING: "Đứng",
  T_43_YU_WS_EVENTID: "ID Sự kiện",
  T_43_YU_WS_EVENTID_D: "Đại diện cho một sự kiện",
  T_43_YU_WS_FACTION: "Phe",
  T_43_YU_WS_FACTION_D: "Phe của vật thể",
  T_43_YU_WS_FACTION_D1: "Yêu cầu phe ta hỗ trợ mua hàng",
  T_43_YU_WS_FINALRADIUS_D: "Bán kính cuối cùng của vùng an toàn",
  T_43_YU_WS_FIRSTAIDKIT: "Túi Cứu Thương",
  T_43_YU_WS_FIRSTAIDKIT_D: "Túi Cứu Thương",
  T_43_YU_WS_FIRSTPERSONMODEL: "Mô hình người thứ nhất",
  T_43_YU_WS_FIRSTPERSONMODEL_D: "Camera góc nhìn thứ nhất",
  T_43_YU_WS_FONTCOLOR_D: "Màu phông chữ",
  T_43_YU_WS_FONTSIZE_D: "Kích cỡ phông chữ",
  T_43_YU_WS_FORBIDEN: "Cấm",
  T_43_YU_WS_FORBIDEN_D: "Tắt HUD yêu cầu mua đồ",
  T_43_YU_WS_FREEZINGTIME: "Thời gian đóng băng",
  T_43_YU_WS_FREEZINGTIME_D: "Thời gian mục tiêu trúng phải bị đóng băng",
  T_43_YU_WS_GRAVITY: "Trọng lực",
  T_43_YU_WS_GRAVITY_D: "Gia tốc trọng trường. Chỉ ảnh hưởng đến nhân vật người chơi.",
  T_43_YU_WS_HANDCATAPULT: "Bệ Phóng",
  T_43_YU_WS_HANDCATAPULT_D: "Bệ Phóng",
  T_43_YU_WS_HEALTH: "Máu",
  T_43_YU_WS_HEALTH_D: "Giá trị hồi phục độ bền giáp",
  T_43_YU_WS_HEIGHT: "Chiều cao",
  T_43_YU_WS_HELPEDPLAYER_D: "Người chơi được cứu",
  T_43_YU_WS_HELPPLAYER_D: "Người chơi đã hỗ trợ mua đồ",
  T_43_YU_WS_HORIZONTALMAXANGLE: "Góc ngang tối đa",
  T_43_YU_WS_HORIZONTALMINANGLE: "Góc ngang tối thiểu",
  T_43_YU_WS_HUDTOGGLE: "Bật/tắt HUD",
  T_43_YU_WS_HUDTOGGLE_D: "Thực thể bật tắt HUD người chơi có thể điều chỉnh trong trình thiết kế HUD",
  T_43_YU_WS_INHALER: "Mặt nạ hồi máu",
  T_43_YU_WS_INHALER_D: "Mặt nạ hồi máu",
  T_43_YU_WS_INITRADIUS_D: "Bán kính vùng an toàn ban đầu",
  T_43_YU_WS_INT64: "Int64",
  T_43_YU_WS_INT64_D: "Số nguyên 64 bit có dấu",
  T_43_YU_WS_ISAPPLYSHADOW: "Đổ bóng hay không",
  T_43_YU_WS_ISBOTTOMCOLLIDING: "Phần đáy có va chạm không",
  T_43_YU_WS_ISCURRENTEMOTELOOP: "Hành động có lặp không",
  T_43_YU_WS_ISCURRENTEMOTELOOP_D: "Hoạt ảnh hành động có lặp lại hay không",
  T_43_YU_WS_ISSIDECOLLIDING: "Cạnh có va chạm không",
  T_43_YU_WS_ISSLIDING: "Có đang trượt không",
  T_43_YU_WS_ISTOPCOLLIDING: "Phần trên có va chạm không",
  T_43_YU_WS_ITEM331: "Thiết Bị Tân Tiến A",
  T_43_YU_WS_ITEM332: "Đá Phát Sáng A",
  T_43_YU_WS_ITEM333: "Màn Hình Tân Tiến A",
  T_43_YU_WS_ITEM334: "Container Tân Tiến A",
  T_43_YU_WS_ITEM335: "Container Tân Tiến A",
  T_43_YU_WS_ITEM336: "Băng Ghế Đá A",
  T_43_YU_WS_ITEM337: "Công Tắc Tân Tiến A",
  T_43_YU_WS_ITEM338: "Đường Ống Tân Tiến A",
  T_43_YU_WS_ITEM339: "Nền Kim Loại A",
  T_43_YU_WS_ITEM340: "Bàn Tân Tiến A",
  T_43_YU_WS_ITEM341: "Bàn Tân Tiến B",
  T_43_YU_WS_ITEM342: "Bàn Tân Tiến C",
  T_43_YU_WS_ITEM343: "Máy Tính Tân Tiến A",
  T_43_YU_WS_ITEM344: "Đá A",
  T_43_YU_WS_ITEM345: "Tảng Đá B",
  T_43_YU_WS_ITEM346: "Tảng Đá C",
  T_43_YU_WS_ITEM347: "Tảng Đá D",
  T_43_YU_WS_ITEM348: "Tảng Đá E",
  T_43_YU_WS_ITEM349: "Tảng Đá F",
  T_43_YU_WS_ITEM350: "Tảng Đá G",
  T_43_YU_WS_ITEM351: "Rèm Kiểu Nhật A",
  T_43_YU_WS_ITEM352: "Rèm Kiểu Nhật B",
  T_43_YU_WS_ITEM353: "Rèm Kiểu Nhật C",
  T_43_YU_WS_ITEM354: "Cầu Thang Kiểu Nhật A",
  T_43_YU_WS_ITEM355: "Hàng Rào Kiểu Nhật A",
  T_43_YU_WS_ITEM356: "Hàng Rào Kiểu Nhật B",
  T_43_YU_WS_ITEM357: "Hàng Rào Kiểu Nhật C",
  T_43_YU_WS_ITEM358: "Nền Kiểu Nhật A",
  T_43_YU_WS_ITEM359: "Tường Kiểu Nhật B",
  T_43_YU_WS_ITEM360: "Cổng Kiểu Nhật B",
  T_43_YU_WS_ITEM361: "Tường Tân Tiến D",
  T_43_YU_WS_ITEM362: "Tường Tân Tiến B",
  T_43_YU_WS_ITEM363: "Gờ tường nghiêng Tân Tiến",
  T_43_YU_WS_LEFTCOLOR: "Màu bên trái",
  T_43_YU_WS_LEFTCOLOR_D: "Màu phe bên trái",
  T_43_YU_WS_LEFTPLAYERARRAY: "Mảng người chơi trái",
  T_43_YU_WS_LEFTPLAYERARRAY_D: "Mảng người chơi bên trái",
  T_43_YU_WS_LEFTSCORE: "Điểm bên trái",
  T_43_YU_WS_LEFTSCORE_D: "Điểm phe bên trái",
  T_43_YU_WS_LEFTSCOREAFTER: "Điểm bên trái sau đó",
  T_43_YU_WS_LEFTSCOREAFTER_D: "Điểm số cuối cùng của phe bên trái. Sử dụng trong hoạt ảnh chuyển đổi điểm.",
  T_43_YU_WS_LEVELOBJECTID: "ID cấp bậc vật thể",
  T_43_YU_WS_LEVELOBJECTID_D: "Mô tả loại vật thể. Cần đến thiết lập SceneEditPrefab trước khi tải.",
  T_43_YU_WS_LOCALPOSITION_D: "Tọa độ trong hệ thống tọa độ cục bộ",
  T_43_YU_WS_LOCALPOSITION_D1: "Vị trí tương đối",
  T_43_YU_WS_LOCALPOSITION_D2: "Vị trí tương đối với neo ở góc phải",
  T_43_YU_WS_LOCALPOSITION_D3: "Vị trí tương đối với neo",
  T_43_YU_WS_LOCALROTATION_D: "Góc xoay trong hệ tọa độ cục bộ (X: quay ngang, Y: quay dọc, và Z: quay vòng)",
  T_43_YU_WS_LOCALROTATIONQ_D: "Biểu thị góc 4 chiều trong hệ thống tọa độ cục bộ",
  T_43_YU_WS_LOCALSCALE_D: "Tỉ lệ kích cỡ trong hệ thống tọa độ thế giới",
  T_43_YU_WS_MASS: "Khối lượng",
  T_43_YU_WS_MATERIALS: "Vật liệu",
  T_43_YU_WS_MATERIALS_D: "Danh sách các vật liệu dùng để kết xuất đồ họa",
  T_43_YU_WS_MAXSPEED: "Tốc độ tối đa",
  T_43_YU_WS_MAXSPEED_D: "Không tạo thêm động lực khi đã đạt đến tốc độ tối đa, nhưng vận tốc phương tiện vẫn có thể tăng cao hơn (v.d tăng tốc khi xuống dốc)",
  T_43_YU_WS_MESHID: "ID Lưới",
  T_43_YU_WS_MESHID_D: "Mô tả loại lưới",
  T_43_YU_WS_MESHID1: "ID Lưới",
  T_43_YU_WS_MESHID1_D: "Lưới mesh dùng để kết xuất",
  T_43_YU_WS_MINMOVEDISTANCE: "Khoảng cách di chuyển tối thiểu",
  T_43_YU_WS_MINMOVEDISTANCE_D: "Hành động di chuyển với khoảng cách thấp hơn giá trị này sẽ không được thực thi. Khuyến nghị thiết lập giá trị này là 0 trừ khi có điều kiện đặc biệt.",
  T_43_YU_WS_MODULE_AI: "AI",
  T_43_YU_WS_MODULE_AIRDROP: "Thính",
  T_43_YU_WS_MODULE_ANIMATION: "Hoạt ảnh",
  T_43_YU_WS_MODULE_AVATAR: "Ảnh đại diện",
  T_43_YU_WS_MODULE_BASEATTRIBUTES: "Chỉ số cơ bản",
  T_43_YU_WS_MODULE_BEHAVIOURTREE: "Cây hành vi",
  T_43_YU_WS_MODULE_BUFF: "Hiệu ứng tăng sức mạnh",
  T_43_YU_WS_MODULE_CAMERA: "Máy quay",
  T_43_YU_WS_MODULE_CHATCHANNEL: "Kênh trò chuyện",
  T_43_YU_WS_MODULE_CHECKPOINT: "Điểm mốc",
  T_43_YU_WS_MODULE_COLLECTION: "Sưu tầm",
  T_43_YU_WS_MODULE_COMBAT: "Chiến đấu",
  T_43_YU_WS_MODULE_COMPONENT: "Thành phần",
  T_43_YU_WS_MODULE_CONVERT: "Chuyển đổi",
  T_43_YU_WS_MODULE_CUSTOMIZEROOMPARAMETERS: "Tùy chỉnh tham số phòng đấu",
  T_43_YU_WS_MODULE_DATABASE: "Lưu trữ dữ liệu",
  T_43_YU_WS_MODULE_DYEING: "Nhuộm",
  T_43_YU_WS_MODULE_DYNAMICNAVMESH: "Lưới định vị động",
  T_43_YU_WS_MODULE_ECONOMY: "Tài chính",
  T_43_YU_WS_MODULE_FF_PLATFORM: "Nền tảng FF",
  T_43_YU_WS_MODULE_FOOTBALL: "Bóng đá",
  T_43_YU_WS_MODULE_FRAMERATEMODE: "Chế độ tốc độ khung hình",
  T_43_YU_WS_MODULE_GAMERESULT: "Kết quả trận đấu",
  T_43_YU_WS_MODULE_GLOBAL: "Toàn bản đồ",
  T_43_YU_WS_MODULE_GLOBALSCRIPTS: "Tập lệnh toàn cục",
  T_43_YU_WS_MODULE_HANGUPANDCHEAT: "AFK & Gian lận",
  T_43_YU_WS_MODULE_HUD: "Giao diện HUD",
  T_43_YU_WS_MODULE_INPUTSYSTEM: "Hệ thống nhập liệu",
  T_43_YU_WS_MODULE_ITEMS: "Vật phẩm",
  T_43_YU_WS_MODULE_LEVELOBJECT: "Cấp vật thể",
  T_43_YU_WS_MODULE_LIST: "Danh sách",
  T_43_YU_WS_MODULE_MAP: "Từ điển",
  T_43_YU_WS_MODULE_MATCHING: "Trận đấu",
  T_43_YU_WS_MODULE_MATH: "Toán học",
  T_43_YU_WS_MODULE_MECHANISM: "Tham số cơ chế",
  T_43_YU_WS_MODULE_MINIMAP: "Bản đồ nhỏ",
  T_43_YU_WS_MODULE_MORPH: "Biến hình",
  T_43_YU_WS_MODULE_OTHER: "Khác",
  T_43_YU_WS_MODULE_PET: "Trợ thủ",
  T_43_YU_WS_MODULE_PHYSICS: "Vật lý",
  T_43_YU_WS_MODULE_PLAYABLE: "Có thể chơi",
  T_43_YU_WS_MODULE_PLAYER: "Người chơi",
  T_43_YU_WS_MODULE_PLAYERSCRIPTS: "Tập lệnh người chơi",
  T_43_YU_WS_MODULE_PRESETCHARACTER: "Bộ chiến thuật nhân vật",
  T_43_YU_WS_MODULE_PROFILE: "Hồ sơ",
  T_43_YU_WS_MODULE_PROPERTYFORMULA: "Công thức thuộc tính",
  T_43_YU_WS_MODULE_SAFEZONE: "Vòng bo",
  T_43_YU_WS_MODULE_SCENE: "Trường cảnh",
  T_43_YU_WS_MODULE_SKILL: "Kỹ năng",
  T_43_YU_WS_MODULE_STATICSCRIPTS: "Tập lệnh tĩnh",
  T_43_YU_WS_MODULE_STATISTICALREPORT: "Báo cáo",
  T_43_YU_WS_MODULE_STDLIBRARY: "Thư viện STD",
  T_43_YU_WS_MODULE_STRINGS: "Chuỗi",
  T_43_YU_WS_MODULE_TEAM: "Đội",
  T_43_YU_WS_MODULE_WORKFLOW: "Quy trình công việc",
  T_43_YU_WS_MONEYICON: "Biểu tượng tiền tệ",
  T_43_YU_WS_MONEYICON_D: "Biểu tượng tiền bạc",
  T_43_YU_WS_MONEYICONCOLOR: "Màu biểu tượng tiền bạc",
  T_43_YU_WS_MONEYICONCOLOR_D: "Màu biểu tượng tiền bạc",
  T_43_YU_WS_MOVESAFEZONE_D: "Vùng an toàn sẽ dịch chuyển đều từ vị trí khởi đầu đến vị trí kết thúc. Người chơi ngoài vùng an toàn sẽ nhận một lượng sát thương nhất định.",
  T_43_YU_WS_NEWVECTOR2: "Vector2 mới",
  T_43_YU_WS_NEWVECTOR2_D: "Lấy vector 2D mới",
  T_43_YU_WS_OFFSET_D: "Khoảng cách tương quan từ vị trí trên bản đồ với vật thể mục tiêu",
  T_43_YU_WS_ONSHOPREQUESTFILLED_D: "Khi người chơi đạt đủ yêu cầu mua hàng",
  T_43_YU_WS_ONSHOPREQUESTPURCHASE_D: "Khi người chơi yêu cầu giúp mua vật phẩm trong cửa hàng",
  T_43_YU_WS_ONTOGGLECHANGE_D: "Kích hoạt khi trạng thái bật tắt bị thay đổi",
  T_43_YU_WS_OPENSTATE: "Trạng thái mở",
  T_43_YU_WS_OPENSTATE_D: "Hiển thị khi được thiết lập true, và ẩn đi khi không thiết lập",
  T_43_YU_WS_PACEMAKER: "Bộ Hồi Phục",
  T_43_YU_WS_PACEMAKER_D: "Bộ hồi phục",
  T_43_YU_WS_PARAMS_D: "Danh sách các tham số",
  T_43_YU_WS_PARENT_D: "ID vật thể được ghi lại trong quá trình đánh số",
  T_43_YU_WS_PHYSICALCCT: "CCT vật lý",
  T_43_YU_WS_PHYSICALCCT_D: "Điều khiển của người chơi với hiệu ứng vật lý",
  T_43_YU_WS_PLAYER_D: "Người chơi mua hàng",
  T_43_YU_WS_PLAYERDATAID: "ID dữ liệu người chơi",
  T_43_YU_WS_PLAYERDATAID_D: "Tùy chỉnh ID tài nguyên nhân vật",
  T_43_YU_WS_PLAYERPHYSXPOSETYPE: "Loại dáng PhysX người chơi",
  T_43_YU_WS_POSITION: "Vị trí",
  T_43_YU_WS_POSITION_D: "Tọa độ trong hệ thống tọa độ thế giới",
  T_43_YU_WS_POSITION_D1: "Tọa độ trong hệ thống tọa độ thế giới. Chỉ có hiệu quả với âm thanh 3D.",
  T_43_YU_WS_PRESSEDSPRITE: "Hình được nhấn",
  T_43_YU_WS_PRESSEDSPRITE_D: "Hình ảnh được nhấn",
  T_43_YU_WS_PRESSEDSPRITETYPE: "Loại hình được nhấn",
  T_43_YU_WS_PRESSEDSPRITETYPE_D: "Loại hình ảnh được nhấn",
  T_43_YU_WS_PRETIME: "Thời gian tiền trận đấu",
  T_43_YU_WS_RADIUS: "Bán kính",
  T_43_YU_WS_RANDOMRANGE_D: "Chuẩn hóa vị trí thiết lập dựa trên một khoảng cách ngẫu nhiên",
  T_43_YU_WS_REQUESTPURCHASETYPE: "Loại yêu cầu mua hàng",
  T_43_YU_WS_REQUESTPURCHASETYPE_D: "Yêu cầu mua hàng trong cửa hàng",
  T_43_YU_WS_REQUESTTYPE: "Loại yêu cầu",
  T_43_YU_WS_REQUESTTYPE_D: "Loại mục tiêu được yêu cầu bởi HUD người chơi hiện tại",
  T_43_YU_WS_RESPLAYERUUID: "Kiểu bộ chiến thuật",
  T_43_YU_WS_RESPLAYERUUID_D: "ID tài nguyên người chơi",
  T_43_YU_WS_RESUUID: "UUID tài nguyên",
  T_43_YU_WS_RESUUID_D: "Thiết lập cụ thể UUID của gói tài nguyên được render",
  T_43_YU_WS_RIGHTCOLOR: "Màu bên phải",
  T_43_YU_WS_RIGHTCOLOR_D: "Màu phe bên phải",
  T_43_YU_WS_RIGHTPLAYERARRAY: "Mảng người chơi bên phải",
  T_43_YU_WS_RIGHTPLAYERARRAY_D: "Mảng người chơi bên phải",
  T_43_YU_WS_RIGHTSCORE: "Điểm bên phải",
  T_43_YU_WS_RIGHTSCORE_D: "Điểm phe bên phải",
  T_43_YU_WS_RIGHTSCOREAFTER: "Điểm bên phải sau đó",
  T_43_YU_WS_RIGHTSCOREAFTER_D: "Điểm cuối cùng của phe bên phải. Sử dụng trong hoạt ảnh chuyển đổi điểm số",
  T_43_YU_WS_ROTATIONQ_D: "Hệ tọa độ góc 4 chiều trong hệ thống tọa độ thế giới",
  T_43_YU_WS_ROUNDINFOHUD: "HUD thông tin vòng đấu",
  T_43_YU_WS_ROUNDINFOHUD_D: "Thông tin hiển thị ở đầu vòng đấu",
  T_43_YU_WS_SELECTEDCOLOR: "Màu đã chọn",
  T_43_YU_WS_SELECTEDCOLOR_D: "Màu hình ảnh đã chọn",
  T_43_YU_WS_SELECTEDSPRITE: "Ảnh đã chọn",
  T_43_YU_WS_SELECTEDSPRITE_D: "Hình ảnh đã chọn",
  T_43_YU_WS_SELECTEDTYPE: "Loại đã chọn",
  T_43_YU_WS_SELECTEDTYPE_D: "Loại hình ảnh được chọn",
  T_43_YU_WS_SHADOWCOLOR: "Màu đổ bóng",
  T_43_YU_WS_SHADOWOFFSET: "Khoảng cách đổ bóng",
  T_43_YU_WS_SHOWTAG: "Hiển thị thẻ tên",
  T_43_YU_WS_SHOWTAG_D: "Hiển thị đánh dấu đội/phe",
  T_43_YU_WS_SHRINKDURATION_D: "Thời gian thu bo",
  T_43_YU_WS_SIMPLERENDER_D: "Thành phần kết xuất liên kết, được sử dụng khi kết xuất đồ họa các mô hình có sẵn",
  T_43_YU_WS_SKINWIDTH: "Chiều rộng trang phục",
  T_43_YU_WS_SKINWIDTH_D: "Chiều sâu phạm vào trong hình viên nang để tránh việc người chơi bị kẹt hoặc giật lag",
  T_43_YU_WS_SLOPELIMIT: "Giới hạn dốc nghiêng",
  T_43_YU_WS_SLOPELIMIT_D: "Vật thể đặt trên góc nghiêng có độ dốc cao hơn góc này sẽ trượt xuống",
  T_43_YU_WS_SPEED: "Tốc độ",
  T_43_YU_WS_STARTDROPTIME_D: "Thời gian thính rơi, tính bằng mili-giây",
  T_43_YU_WS_STARTPOS_D: "Vị trí bắt đầu của vùng an toàn",
  T_43_YU_WS_STATICICONCOLORS: "Màu biểu tượng tĩnh",
  T_43_YU_WS_STATICICONCOLORS_D: "Màu biểu tượng hiển thị trên thước đo",
  T_43_YU_WS_STATICICONS: "Biểu tượng tĩnh",
  T_43_YU_WS_STATICICONS_D: "Biểu tượng hiển thị trên thước đo",
  T_43_YU_WS_STEPOFFSET: "Bước khoảng cách di chuyển",
  T_43_YU_WS_STEPOFFSET_D: "Chỉ có vật cản cao hơn giá trị này mới có khả năng chặn đạn",
  T_43_YU_WS_SUBTITLE: "Phụ đề",
  T_43_YU_WS_SUBTITLE_D: "Phụ đề",
  T_43_YU_WS_TARGET: "Mục tiêu",
  T_43_YU_WS_TARGET_D: "Vật thể mục tiêu hiển thị lượng sát thương",
  T_43_YU_WS_TARGETICONCOLORS: "Màu biểu tượng mục tiêu",
  T_43_YU_WS_TARGETICONCOLORS_D: "Màu biểu tượng hiển thị trên mục tiêu bị đánh dâu",
  T_43_YU_WS_TARGETICONS: "Biểu tượng mục tiêu",
  T_43_YU_WS_TARGETICONS_D: "Biểu tượng hiển thị trên mục tiêu bị đánh dấu",
  T_43_YU_WS_TARGETPOS_D: "Vị trí kết thúc của vùng an toàn",
  T_43_YU_WS_TEAM: "Đội",
  T_43_YU_WS_TEAM_D: "Thực thể đội trong trò chơi. Mỗi đội mang một thực thể này.",
  T_43_YU_WS_TEAM_D1: "Yêu cầu đội hỗ trợ mua đồ",
  T_43_YU_WS_TIMEOFSTAY_D: "Thời gian hiển thi, tính bằng mili-giây",
  T_43_YU_WS_TITLE: "Tựa đề",
  T_43_YU_WS_TITLE_D: "Tựa đề chính",
  T_43_YU_WS_TRANSFORM_D: "Lịch sử - xoay, điều chỉnh kích cỡ, và quan hệ cha-con",
  T_43_YU_WS_UNSELECTEDCOLOR: "Màu chưa chọn",
  T_43_YU_WS_UNSELECTEDCOLOR_D: "Màu hình chưa chọn",
  T_43_YU_WS_UNSELECTEDSPRITE: "Hình chưa được chọn",
  T_43_YU_WS_UNSELECTEDSPRITE_D: "Hình ảnh chưa được chọn",
  T_43_YU_WS_UNSELECTEDTYPE: "Loại vật thể chưa chọn",
  T_43_YU_WS_UNSELECTEDTYPE_D: "Loại hình chưa chọn",
  T_43_YU_WS_USEPHYSICALCCT: "Sử dụng CCT vật lý",
  T_43_YU_WS_VALUE_D: "Nội dung hiển thị",
  T_43_YU_WS_VECTOR2ADD: "Cộng Vector2",
  T_43_YU_WS_VECTOR2GETX: "Lấy X của Vector2",
  T_43_YU_WS_VECTOR2GETY: "Lấy Y của Vector2",
  T_43_YU_WS_VECTOR2SCALE: "Tỉ lệ Vector2",
  T_43_YU_WS_VECTOR2SETX: "Gán X của Vector 2",
  T_43_YU_WS_VECTOR2SETY: "Gán Y của Vector2",
  T_43_YU_WS_VECTOR2SUB: "Trừ Vector2",
  T_43_YU_WS_VELOCITY: "Tốc độ",
  T_43_YU_WS_VERTICALMAXANGLE: "Góc dọc tối đa",
  T_43_YU_WS_VERTICALMINANGLE: "Góc dọc tối thiểu",
  T_43_YU_WS_VISIBILITY_D: "Biểu thị việc có thể thiết lập hiển thị hay không",
  T_43_YU_WS_VISIBLE_D: "Thiết lập hiển thị. Nếu thiết lập thành vô hình, máy khách sẽ ngưng kết xuất đồ họa mục tiêu.",
  T_43_YU_WS_X: "X",
  T_43_YU_WS_X_D: "X",
  T_43_YU_WS_Y: "Y",
  T_43_YU_WS_Y_D: "Y",
  T_43_ZY_WS_ITEM319: "Tường Tân Tiến A",
  T_43_ZY_WS_ITEM320: "Tường Tân Tiến C",
  T_43_ZY_WS_ITEM321: "Cửa Sổ Tân Tiến",
  T_43_ZY_WS_ITEM322: "Cửa Tân Tiến",
  T_43_ZY_WS_ITEM323: "Mái Thẳng Tân Tiến",
  T_43_ZY_WS_ITEM324: "Mái Tròn Tân Tiến",
  T_43_ZY_WS_ITEM325: "Gờ Tường Tân Tiến",
  T_43_ZY_WS_ITEM326: "Gờ Tường Tròn Tân Tiến",
  T_43_ZY_WS_ITEM327: "Cầu Thang Tân Tiến",
  T_43_ZY_WS_ITEM328: "Trang Trí Tân Tiến",
  T_43_ZY_WS_ITEM329: "Tòa Nhà Tân Tiến",
  T_43_ZY_WS_ITEM330: "Tòa Nhà Tân Tiến",
  T_44_CJ_M_B_SPORT_TH: "Thể Dục Nào! (Quần)",
  T_44_CJ_M_H_SPORT_TH: "Thể Dục Nào! (Đầu)",
  T_44_CJ_M_S_SPORT_TH: "Thể Dục Nào! (Giày)",
  T_44_CJ_M_T_SPORT_TH: "Thể Dục Nào! (Áo)",
  T_44_CJ_W_AIRBURST: "M590",
  T_44_H_CHARACTER_DUALMAN_N: "Kairos",
  T_44_H_M24_ONIMUSHA_N: "M24 - Linh Hỏa",
  T_44_H_USP45_CARNIVORE_N: "USP - Độc Nha",
  T_44_H_VEHICLESKIN_MOTOBIKE_COLLAGE_N: "Xe máy - Nét Vẽ Sấm Sét",
  "T_44_HH_GOLD_AUG-I": "AUG-I",
  "T_44_HH_GOLD_AUG-II": "AUG-II",
  "T_44_HH_GOLD_AUG-III": "AUG-III",
  T_44_JH_WS_CLHALF1: "Buộc bắt đầu với người chơi tối thiểu",
  T_44_JH_WS_HALFWAYKEY1: "Ưu tiên bắt đầu khi đội đầy đủ",
  T_44_PD_PVE_DRAGON_NAME: "Boss Rồng",
  T_44_QL_GRENADE_DRAGON: "Lựu Rồng Băng",
  T_44_QL_GRENADE_DRAGON_DES: "Lựu Choáng Băng được nâng cấp, sẽ phát nổ liên tục 3 lần khi va chạm",
  T_44_QL_JUMPSHOESX: "Giày Lướt Gió",
  T_44_QL_JUMPSHOESX_DES: "Đôi giày đặc biệt cho phép bạn lướt gió khi nhảy lần 2",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME: "Thời gian tắt vòng bo",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME_D: "Thời gian khi Vòng Bo biến mất. Nếu thời gian tắt Vòng bo thấp hơn thời gian Vòng bo bắt đầu, trận đấu sẽ không có bo",
  T_44_SJ_WS_SAFEZONE_COLOR: "Màu vòng bo",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME: "Tần suất sát thương",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME_D: "Tần suất sát thương",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE: "Giá trị sát thương",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE_D: "Sát thương gây ra lên người chơi ngoài bo mỗi lần",
  T_44_SJ_WS_SAFEZONE_DESC: "Một vật thể có thể đặt được ngoài bo",
  T_44_SJ_WS_SAFEZONE_END_RADIUS: "Bán kính bo cuối",
  T_44_SJ_WS_SAFEZONE_END_RADIUS_D: "Bán kính cuối của bo",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS: "Danh sách người chơi Vùng an toàn",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS_D: "Lấy danh sách người chơi đang ở trong Vùng An Toàn",
  T_44_SJ_WS_SAFEZONE_NAME: "Khu vực bo",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME: "Thời gian thu nhỏ (giây)",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME_D: "Thời gian vùng an toan thu nhỏ",
  T_44_SJ_WS_SAFEZONE_START_RADIUS: "Bán kính bo đầu",
  T_44_SJ_WS_SAFEZONE_START_RADIUS_D: "Bán kính đầu của bo",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME: "Thời điểm bo bắt đầu thu",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME_D: "Thời điểm bắt đầu thu bo",
  T_44_SJ_WS_SAFEZONE_STARTTIME: "Thời gian vòng bo xuất hiện",
  T_44_SJ_WS_SAFEZONE_STARTTIME_D: "Thời gian vòng bo bắt đầu xuất hiện trong mỗi vòng đấu. Mặc định là 0.",
  T_44_WT_W_FGG: "FGL-24",
  T_44_WT_W_REWORKHEAT_NAME_X: "PLASMA-X",
  T_44_XXJ_WS_ACTIVATEDALPHA: "Kênh Alpha được kích hoạt",
  T_44_XXJ_WS_ACTIVATEDALPHA_D: "Kênh Alpha được kích hoạt",
  T_44_XXJ_WS_ACTIVESKILLBTNHUD: "HUD Nút Kỹ năng Chủ Động",
  T_44_XXJ_WS_ADDCOMPONENT_D: "Thêm một thành phần vào một thực thể. Chỉ hỗ trợ thành phần tùy chọn. (Thành phần sẽ không thể được thêm lại nếu như đã tồn tại.)",
  T_44_XXJ_WS_ALLMEMBERS: "Tất cả người chơi",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE: "Cho phép nhấn từ ngoài",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE_D: "Cho phép kích hoạt bên ngoài khu vực chỉ định",
  T_44_XXJ_WS_ARROWIMAGE: "Hình mũi tên",
  T_44_XXJ_WS_ARROWIMAGE_D: "Hình mũi tên",
  T_44_XXJ_WS_ARROWOFFSET: "Sai trục mũi tên",
  T_44_XXJ_WS_ARROWOFFSET_D: "Sai trục mũi tên",
  T_44_XXJ_WS_ARROWSIZE: "Kích cỡ mũi tên",
  T_44_XXJ_WS_ARROWSIZE_D: "Kích cỡ mũi tên",
  T_44_XXJ_WS_AUTOPLAY_D: "Tự động phát sau khi được tạo",
  T_44_XXJ_WS_BACKGROUNDIMAGE: "Ảnh nền",
  T_44_XXJ_WS_BACKGROUNDIMAGE_D: "Ảnh gốc",
  T_44_XXJ_WS_BACKGROUNDRADIUS: "Bán kính nền",
  T_44_XXJ_WS_BACKGROUNDRADIUS_D: "Bán kính nền",
  T_44_XXJ_WS_BAGSKINID: "ID Skin Balo",
  T_44_XXJ_WS_BAGSKINID_D: "ID skin của Balo",
  T_44_XXJ_WS_BONEPOSITION: "Vị trí xương",
  T_44_XXJ_WS_BONEPOSITION_D: "Tọa độ thế giới của nút xương",
  T_44_XXJ_WS_CCTMOVE: "Di chuyển CCT",
  T_44_XXJ_WS_COLLIDER: "Va Chạm",
  T_44_XXJ_WS_COLLIDERCOLLECTION: "Thu thập thông tin va chạm",
  T_44_XXJ_WS_COLLIDERCOLLECTION_D: "Thành phần dùng để định nghĩa hình dạng va chạm",
  T_44_XXJ_WS_COLOR: "Màu",
  T_44_XXJ_WS_CONTENT: "Nội dung",
  T_44_XXJ_WS_CONTENT_D: "Nội dung ví là tập hợp của các loại tiền tệ",
  T_44_XXJ_WS_CONTEXT_D: "Nội dung được in",
  T_44_XXJ_WS_CROSSHAIRSHUD: "HUD tâm ngắm",
  T_44_XXJ_WS_CURVE_D: "Đường cong",
  T_44_XXJ_WS_EFFECTCOLOR_D: "Màu của lớp phủ bề mặt",
  T_44_XXJ_WS_ENABLE: "Bật",
  T_44_XXJ_WS_ENTITY_D: "Thực thể",
  T_44_XXJ_WS_GETBAGSKINID_D: "Lấy thiết lập skin balo của người chơi",
  T_44_XXJ_WS_GETFACTION_D: "Lấy phe",
  T_44_XXJ_WS_GETLOADEDSCENE_D: "Lấy trường cảnh đã tải mà chưa bị xóa",
  T_44_XXJ_WS_GETLOCALPLAYER_D: "Lấy người chơi cục bộ",
  T_44_XXJ_WS_GROUPID: "ID Nhóm",
  T_44_XXJ_WS_GROUPID_D: "Cho logic cục bộ",
  T_44_XXJ_WS_HUDJOYSTICK: "Widget HUD Cần điều khiển",
  T_44_XXJ_WS_HUDJOYSTICK_D: "Thực thể cần điều khiển. Người chơi có thể tùy chỉnh HUD thông qua trình chỉnh sửa HUD",
  T_44_XXJ_WS_HUDTOUCHPAD: "Widget HUD bảng chạm",
  T_44_XXJ_WS_HUDTOUCHPAD_D: "Widget HUD bảng chạm người chơi có thể thay đổi trong trình chỉnh sửa HUD",
  T_44_XXJ_WS_HUDWIDGETORCUSTOMHUD: "HUD tùy chỉnh hoặc HUD Widget",
  T_44_XXJ_WS_ICON: "Biểu tượng",
  T_44_XXJ_WS_ICONISALWAYSSHOWN: "Luôn hiển thị dấu",
  T_44_XXJ_WS_ICONISALWAYSSHOWN_D: "Luôn hiển thị dấu chỉ trên la bàn",
  T_44_XXJ_WS_INACTIVATEDALPHA: "Kênh Alpha chưa được kích hoạt",
  T_44_XXJ_WS_INACTIVATEDALPHA_D: "Kênh Alpha chưa được kích hoạt",
  T_44_XXJ_WS_INVOKE_ARGS_MISMATCH: "Khi goi, số lượng tham số thực tế không trùng khớp với tham số hình thức. Số lượng tham số hình thức là {0}, trong khi số lượng thực tế là {1}.",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE: "Là vật thể động",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE_D: "Là vật cản động trong lưới NavMesh",
  T_44_XXJ_WS_ISEND: "Là kết thúc",
  T_44_XXJ_WS_ISEND_D: "Là Kết thúc",
  T_44_XXJ_WS_ISSERVERDRIVEN: "Tính theo Máy chủ",
  T_44_XXJ_WS_ISSERVERDRIVEN_D: "Nếu sai, vật thể tùy chỉnh sẽ không thể bị điều khiển thông qua API.",
  T_44_XXJ_WS_ISSUC_D: "Trả về kết quả thực thi",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS: "Bán kính kéo Cần điều khiển",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS_D: "Bán kính Cần điều khiển",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE: "Hình Cần điều khiển",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE_D: "Hình ảnh Cần điều khiển",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS: "Bán kính Cần điều khiển",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS_D: "Bán kính Cần điều khiển",
  T_44_XXJ_WS_LISTT_PLAYERSKILLID: "Danh sách ID Kỹ năng Nhân vật",
  T_44_XXJ_WS_LOOPTYPE_D: "Loại vòng lặp",
  T_44_XXJ_WS_MIDGAMEEXITCONFIG: "Thiết lập thoát giữa trận",
  T_44_XXJ_WS_MOUNTABLE: "Thứ tự phả hệ",
  T_44_XXJ_WS_MOUNTABLE_D: "Thực thể có thể gắn thêm node con",
  T_44_XXJ_WS_MOVEMENT: "Di chuyển",
  T_44_XXJ_WS_NAME_D: "Tên",
  T_44_XXJ_WS_NATURALCONST: "Hằng số tự  nhiên",
  T_44_XXJ_WS_NATURALCONST_D: "Enum của hằng số tự nhiên nhằm giảm thiểu định nghĩa biến dư thừa",
  T_44_XXJ_WS_NOTIFYICONANIMATION_D: "Phát hoạt ảnh biểu tượng",
  T_44_XXJ_WS_OFFSET_D: "Khoảng cách cơ bản mặc định",
  T_44_XXJ_WS_ONFIRE_D: "Kích hoạt mỗi khi người chơi bắn hoặc tấn công bằng vũ khí cận chiến.",
  T_44_XXJ_WS_ONPLAYERSTANDUP_D: "Kích hoạt sự kiện khi người chơi đứng dậy từ tư thế ngồi hoặc nằm",
  T_44_XXJ_WS_ONSTARTFIRE_D: "Kích hoạt sự kiện khi người chơi nhấn vào nút bắn",
  T_44_XXJ_WS_OPTION: "Cài đặt",
  T_44_XXJ_WS_PASSIVESKILLHUD: "HUD kỹ năng bị động",
  T_44_XXJ_WS_PHYSICALMOVER: "Di chuyển vật lý",
  T_44_XXJ_WS_PHYSICALMOVER_D: "Người chơi trên nền tảng này sẽ tự động đi theo chuyển động di chuyển hoặc xoay",
  T_44_XXJ_WS_PHYSICALOBJECT: "Vật thể vật lý",
  T_44_XXJ_WS_PHYSICALOBJECT_D: "Có thể áp dụng lực",
  T_44_XXJ_WS_PI: "Pi",
  T_44_XXJ_WS_PI_D: "Hằng số π (Pi)",
  T_44_XXJ_WS_PLAYERS: "Danh sách người chơi",
  T_44_XXJ_WS_PLAYERS_D: "Danh sách người chơi",
  T_44_XXJ_WS_PLAYERSKILLID: "ID Kỹ năng nhân vật",
  T_44_XXJ_WS_PLAYERSKILLID_D: "ID kỹ năng nhân vật trong AvatarSkill.csv",
  T_44_XXJ_WS_PREPHYSXPOSE_D: "Dáng trước khi người chơi đứng dậy",
  T_44_XXJ_WS_PRINT: "In",
  T_44_XXJ_WS_PRINTERROR: "In lỗi",
  T_44_XXJ_WS_PRINTERROR_D: "In dữ liệu mục tiêu thành báo lỗi đến bản điều khiển",
  T_44_XXJ_WS_PRINTWARNING: "In cảnh báo",
  T_44_XXJ_WS_PRINTWARNING_D: "In dữ liệu mục tiêu để gửi cảnh báo đến bản điều khiển",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN: "Ưu tiên thiết lập skin người chơi",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN_D: "Ưu tiên thiết lập skin của người chơi ngoài trận",
  T_44_XXJ_WS_READCSVROWBYKEY_D: "Đọc nội dung trong ô của một hàng theo số cột và khóa",
  T_44_XXJ_WS_REMOVEBAGSKINID_D: "Xóa thiết lập skin balo người chơi",
  T_44_XXJ_WS_REMOVECOMPONENT_D: "Loại bỏ một thành phần khỏi thực thể. Chỉ hỗ trợ các thành phần tùy chỉnh",
  T_44_XXJ_WS_RESETBAGSKINID_D: "Reset thiết lập skin balo về thiết lập ban đầu trước khi vào trận",
  T_44_XXJ_WS_SETBAGSKINID_D: "Thiết lập skin balo cho người chơi",
  T_44_XXJ_WS_SETPARENTCLIENT_D: "Thực thể hỗ trợ thành phần Transform, SkeletonPart, Player, và MountPoint",
  T_44_XXJ_WS_SHOWBACKGROUND: "Hiển thị nền",
  T_44_XXJ_WS_SKINID_D: "ID skin Balo và thiết lập skin",
  T_44_XXJ_WS_SPEED_D: "Tốc độ phát lại",
  T_44_XXJ_WS_TARGET: "Mục tiêu",
  T_44_XXJ_WS_TARGET_D: "Vật thể mục tiêu",
  T_44_XXJ_WS_TITLE: "Tựa đề",
  T_44_XXJ_WS_TYPEID_D: "Thành phần loại ID. Chỉ hỗ trợ các thành phần tùy chỉnh",
  T_44_XXJ_WS_UPLOADMATCHRESULT_D: "Tải lên kết quả trận đấu tùy chỉnh",
  T_44_XXJ_WS_WARNINGCSVTYPE: "Sai kiểu dữ liệu. Không thể đọc nội dung bảng dữ liệu",
  T_44_XXJ_WS_X_D: "Tọa độ trục X",
  T_44_XXJ_WS_Y_D: "Tọa độ trục Y",
  T_44_XYL_WS_CTZSAFEZONE: "Vòng Bo tùy chỉnh",
  T_44_XYL_WS_CTZSAFEZONEDESC: "Tạo vị trí bắt đầu và kết thúc của Vòng Bo dựa trên các vị trí và thuộc tính đã thiết lập",
  T_44_XYL_WS_HEMISPHERICALSHELL: "Vỏ bán cầu",
  T_44_XYL_WS_QUARTERCYLINDER: "1/4 hình trụ",
  T_44_XYL_WS_SQUAREPYRAMID: "Hình chóp vuông",
  T_44_XYL_WS_TORUS: "Hình xuyến",
  T_44_XYL_WS_TRIANGULARPYRAMID: "Hình tứ diện",
  T_44_YU_WS_ADDGAMEEVENTLOGMAP: "Thêm nhật ký sự kiện game",
  T_44_YU_WS_ADDUSEREVENTLOGMAP: "Thêm nhật ký sự kiện người dùng",
  T_44_YU_WS_ADDUSEREVENTLOGMAP_D: "Nhật ký sự kiện tùy chỉnh của trận đấu, dùng cho phân tích dữ liệu người dùng",
  T_44_YU_WS_ITEM366: "Tường quân sự A",
  T_44_YU_WS_ITEM367: "Tường quân sự B",
  T_44_YU_WS_ITEM368: "Tường quân sự C",
  T_44_YU_WS_ITEM369: "Tường quân sự D",
  T_44_YU_WS_ITEM370: "Cửa sổ quân sự A",
  T_44_YU_WS_ITEM371: "Cửa sổ quân sự B",
  T_44_YU_WS_ITEM372: "Cửa sổ quân sự C",
  T_44_YU_WS_ITEM373: "Cửa quân sự A",
  T_44_YU_WS_ITEM374: "Cửa quân sự B",
  T_44_YU_WS_ITEM375: "Mái nhà nghiêng quân sự A",
  T_44_YU_WS_ITEM376: "Mái nhà nghiêng quân sự B",
  T_44_YU_WS_ITEM377: "Cầu thang quân sự A",
  T_44_YU_WS_ITEM378: "Cầu thang quân sự B",
  T_44_YU_WS_ITEM379: "Cột trụ quân sự A",
  T_44_YU_WS_ITEM380: "Lan can quân sự A",
  T_45_C_WEAPON_CUST_ENTRANCE: "Tùy chỉnh",
  T_45_CJ_TREATMENTGUN_Y_N: "Súng Lục Điện-Y",
  T_45_H_CHARACTER_ELECTRICGIRL_N: "Kassie",
  T_45_H_EMOTE_MVPDANCE_N: "Đi Kiểu Anh Hùng",
  "T_45_HH_GOLD_MAC10-I": "MAC10-I",
  "T_45_HH_GOLD_MAC10-II": "MAC10-II",
  "T_45_HH_GOLD_MAC10-III": "MAC10-III",
  T_45_HJ_CAMERA_INSPECTOR: "Kiểm tra",
  T_45_HL_Moderation_fail_1: "Tiếc quá, dự án của bạn không vượt qua được vòng kiểm thử",
  T_45_HL_Moderation_fail_2: "bao gồm",
  T_45_HL_Moderation_fail_3: "Lý do bao gồm:",
  T_45_HL_Moderation_fail_Location_1: "Nội dung game",
  T_45_HL_Moderation_fail_reason_1: "Nội dung độc hại",
  T_45_HL_Moderation_fail_reason_10: "Vi phạm tiêu chuẩn cộng đồng",
  T_45_HL_Moderation_fail_reason_11: "Gây ảnh hưởng tiêu cực đến doanh thu của game và vi phạm bản quyền sở hữu trí tuệ",
  T_45_HL_Moderation_fail_reason_2: "Nội dung không phù hợp",
  T_45_HL_Moderation_fail_reason_3: "Chủ đề nhạy cảm",
  T_45_HL_Moderation_fail_reason_4: "Thông tin sai lệch",
  T_45_HL_Moderation_fail_reason_5: "Vi phạm bản quyền",
  T_45_HL_Moderation_fail_reason_6: "Vi phạm riêng tư",
  T_45_HL_Moderation_fail_reason_7: "Vấn đề bảo mật",
  T_45_HL_Moderation_fail_reason_8: "Ngôn ngữ thù ghét",
  T_45_HL_Moderation_fail_reason_9: "Spam",
  T_45_HL_Moderation_fail_reason_999: "Vấn đề khác",
  T_45_JH_WS_CLEMPTYOBJECT: "Nhóm vật thể",
  T_45_JH_WS_PETSWITCH1: "Hiển thị trợ thủ trong trận",
  T_45_QL_CSFPP_DES: "Chiến đấu và tiêu diệt địch dưới góc nhìn thứ nhất trong chế độ Tử Chiến đặc biệt này!",
  T_45_QL_CSFPP_NAME: "Tử Chiến: Góc Nhìn Thứ Nhất",
  T_45_QL_CSFPP_RANKNAME: "Góc nhìn thứ nhất",
  T_45_SJ_WS_REVIEW_23: "Nội dung game",
  T_45_SJ_WS_REVIEW_24: "{0} bao gồm {1}",
  T_45_SJ_WS_REVIEW_25: "{0} {1} bao gồm {2}",
  T_45_SJ_WS_REVIEW_26: "[FFBA00]Nhấn để xem chi tiết >>[-]",
  T_45_SJ_WS_REVIEW_27: "Không được chấp nhận",
  T_45_SJ_WS_REVIEW_28: "Phản hồi kiểm tra",
  T_45_SJ_WS_REVIEW_29: "Chứa {0} nội dung không hợp lệ",
  T_45_SJ_WS_REVIEW_31: "Không được chấp nhận",
  T_45_SJ_WS_REVIEW_32: "Kiểm tra thất bại do ngoại lệ máy chủ",
  T_45_SJ_WS_REVIEW_TITLE: "Chi tiết vi phạm",
  T_45_SJ_WS_VAULTTRIGGER_DES: "Kích hoạt nhảy qua chướng ngại",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE: "Khoảng cách nhảy qua chướng ngại",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE_DES: "Điều chỉnh khoảng cách nhảy qua chướng ngại",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT: "Độ cao nhảy qua chướng ngại",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT_DES: "Điều chỉnh độ cao khi nhảy lên và xuống khi nhảy qua chướng ngại",
  T_45_SJ_WS_VAULTTRIGGER_NAME: "Kích hoạt nhảy qua",
  T_45_TYC_CL_TEMPLATE_WS: `Chế độ tiêu diệt, diệt hết địch để chiến thắng.
Bạn có thể tùy ý chỉnh sửa quy chế và thông số chơi.`,
  T_45_W_SPEEDMODE_FLIGHT_N: "Chiến Cơ Huyền Thoại",
  T_45_XXJ_WS_ACTIONTYPE_D: "0 = tự động tấn công, 1 = tấn công phòng thủ, 2 = không tấn công",
  T_45_XXJ_WS_ADDFRIEND: "Thêm bạn",
  T_45_XXJ_WS_API: "API",
  T_45_XXJ_WS_AUTO: "Tự động",
  T_45_XXJ_WS_BASEDATA: "Dữ liệu cơ bản",
  T_45_XXJ_WS_BOTH: "Cả hai",
  T_45_XXJ_WS_BYHIERARCHY: "Theo cây phân cấp",
  T_45_XXJ_WS_BYPRIORITYHIGHTOLOW: "Theo ưu tiên từ Cao xuống Thấp",
  T_45_XXJ_WS_BYPRIORITYLOWTOHIGH: "Theo ưu tiên từ Thấp lên Cao",
  T_45_XXJ_WS_CAMERA: "Camera",
  T_45_XXJ_WS_CAMERATYPE: "Kiểu Camera",
  T_45_XXJ_WS_CENTERINVISIBLE: "Ẩn Tâm",
  T_45_XXJ_WS_CLIENT: "Máy khách",
  T_45_XXJ_WS_COLLIDERID: "ID bộ va chạm",
  T_45_XXJ_WS_COLLIDERID_D: "ID bộ va chạm",
  T_45_XXJ_WS_COMPONENT: "Thành phần",
  T_45_XXJ_WS_CURRENTCAMERA: "Camera hiện tại",
  T_45_XXJ_WS_CUSTOMPUSHFORCE: "Lực Đẩy Tùy Chỉnh",
  T_45_XXJ_WS_DOUBLE: "Gấp đôi",
  T_45_XXJ_WS_DUMP: "Ném",
  T_45_XXJ_WS_ENABLEMOVEINMIDAIR: "Cho phép di chuyển trên không",
  T_45_XXJ_WS_ENABLEROTATEWITHGRAVITY: "Bật Xoay với Trọng Lực",
  T_45_XXJ_WS_ENUM: "Enum",
  T_45_XXJ_WS_EVENT: "Sự kiện",
  T_45_XXJ_WS_FILLAMOUNT: "Lượng tô màu",
  T_45_XXJ_WS_FILLDIR: "Hướng tô màu",
  T_45_XXJ_WS_FIRETYPE: "Loại phát bắn",
  T_45_XXJ_WS_FIRETYPE_D: "Loại phát bắn",
  T_45_XXJ_WS_FIXEDDELTATIME: "Thời gian Delta cố định",
  T_45_XXJ_WS_FIXEDDELTATIME_D: "Thời gian làm mới khung hình cố định tính theo mili-giây",
  T_45_XXJ_WS_FORWARD: "Tiến đến",
  T_45_XXJ_WS_FORWARD_D: "Hướng của trục Z trong hệ tọa độ cục bộ",
  T_45_XXJ_WS_FUNCTIONTYPE: "Kiểu hàm",
  T_45_XXJ_WS_FUNCTIONTYPE_D: "Kiểu hàm",
  T_45_XXJ_WS_GETLOCALAIMDIRECTION_D: "Hướng ngắm của người chơi cục bộ",
  T_45_XXJ_WS_GETLOCALTIMESTAMP_D: "Lấy mốc thời gian cục bộ",
  T_45_XXJ_WS_GRADIENT: "Gradient",
  T_45_XXJ_WS_GRADIENTBOTTOM: "Gradient dưới",
  T_45_XXJ_WS_GRADIENTBOTTOMALPHA: "Gradient Alpha Dưới",
  T_45_XXJ_WS_GRADIENTTOP: "Gradient trên",
  T_45_XXJ_WS_GRADIENTTOPALPHA: "Gradient Alpha Trên",
  T_45_XXJ_WS_HITPOSITION_D: "Tọa độ thế giới của mục tiêu bị đạn bắn trúng",
  T_45_XXJ_WS_HUDSOCIALBUTTONWIDGET: "Widget UI nút kết bạn",
  T_45_XXJ_WS_INVERTFILL: "Nghịch đảo tô màu",
  T_45_XXJ_WS_ISGROUNDED: "Ở dưới đất",
  T_45_XXJ_WS_ISSILENCE: "Tắt tiếng hay không",
  T_45_XXJ_WS_ISSILENCE_D: "Có tiếng súng hay không",
  T_45_XXJ_WS_ISSINGLESHOT: "Là phát bắn đơn",
  T_45_XXJ_WS_ISSINGLESHOT_D: "Có phải là phát bắn đơn không",
  T_45_XXJ_WS_JUMPHEIGHT: "Độ cao cú nhảy",
  T_45_XXJ_WS_JUMPHEIGHT_D: "Độ cao cú nhảy",
  T_45_XXJ_WS_LAYOUTSORTTYPE: "Kiểu sắp xếp layout",
  T_45_XXJ_WS_LIGHT_D: "Ánh sáng",
  T_45_XXJ_WS_LOCAL: "Cục bộ",
  T_45_XXJ_WS_MAXMULTIJUMPNUM: "Số lần nhảy tối đa",
  T_45_XXJ_WS_MODULE: "Module",
  T_45_XXJ_WS_NONE: "Không",
  T_45_XXJ_WS_ONBEFOREHURT_D: "Thực thi câu lệnh mỗi khi thực thể gây sát thương",
  T_45_XXJ_WS_ONDISABLE_D: "Thực thi khi thực thể bị tắt",
  T_45_XXJ_WS_ONEACHLOOP_D: "Thực thi mỗi khi hiệu ứng phát được lặp lại. Chỉ có hiệu lực trên máy khách đối với những thực thể như hiệu ứng âm thanh hoặc hiệu ứng đặc biệt",
  T_45_XXJ_WS_ONENABLE_D: "Thực thi khi thực thể được bật",
  T_45_XXJ_WS_ONFIXEDUPDATE_D: "Khi vào khung hình có tốc độ cố định là 30FPS",
  T_45_XXJ_WS_ONFRIENDRELATIONCHANGE_D: "Kích hoạt sự kiện máy khách khi người chơi thêm hoặc xóa bạn",
  T_45_XXJ_WS_ONGAMEPAUSE_D: "Kích hoạt sự kiện khi game bị dừng do gọi API",
  T_45_XXJ_WS_ONGAMERESUME_D: "Kích hoạt sự kiện khi trò chơi được chạy lại thông qua gọi API",
  T_45_XXJ_WS_ONPLAYERSTOPDASH_D: "Khi người chơi ngưng chạy",
  T_45_XXJ_WS_ONPLAYERSTOPSWIMSURFING_D: "Khi người chơi ngưng lướt ván",
  T_45_XXJ_WS_ONPLAYERSWIMSURFING_D: "Khi người chơi lướt ván",
  T_45_XXJ_WS_PHYSICALLAYER_D: "Lớp layer vật lý với phạm vi từ 0 đến 31",
  T_45_XXJ_WS_PLATFORMTYPE: "Loại nền tảng",
  T_45_XXJ_WS_PLATFORMTYPE_D: "Kiểu nền tảng",
  T_45_XXJ_WS_PLAYER: "Player",
  T_45_XXJ_WS_PLAYERCCT: "CCT người chơi",
  T_45_XXJ_WS_PLAYERCCT_D: "Điều khiển nhân vật với hiệu ứng vật lý và chỉ có thể sử dụng với nhân vật Free Fire",
  T_45_XXJ_WS_PRIORITY: "Ưu tiên",
  T_45_XXJ_WS_REMAINMULTINUM: "Số lần bật nhảy còn lại",
  T_45_XXJ_WS_REPORT: "Report",
  T_45_XXJ_WS_RIGHT: "Bên phải",
  T_45_XXJ_WS_RIGHT_D: "Hướng của trục X trong hệ tọa độ cục bộ",
  T_45_XXJ_WS_SERVER: "Máy chủ",
  T_45_XXJ_WS_SINGLE: "Đơn",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE: "Kiểu nút kết bạn",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE_D: "Kiểu nút kết bạn",
  T_45_XXJ_WS_SOCIALBUTTONTYPE: "Kiểu nút kết bạn",
  T_45_XXJ_WS_SOCIALBUTTONTYPE_D: "Kiểu nút kết bạn",
  T_45_XXJ_WS_SORTTYPE_D: "Các kiểu sắp xếp: giảm dần, tăng dần, và tăng dần loại trừ không",
  T_45_XXJ_WS_SPEEDWHILEAIMING: "Tốc độ di chuyển khi ngắm",
  T_45_XXJ_WS_SPEEDWHILEAIMING_D: "Tốc độ di chuyển khi ngắm",
  T_45_XXJ_WS_STRINGORLOCSTRING: "String hoặc String bản địa hóa",
  T_45_XXJ_WS_TRIPLE: "Gấp ba",
  T_45_XXJ_WS_UP: "Lên",
  T_45_XXJ_WS_UP_D: "Hướng của trục Y trong hệ tọa độ cục bộ",
  T_45_XXJ_WS_USECUSTOMPUSHFORCE: "Sử dụng lực đẩy tùy chỉnh",
  T_45_XXJ_WS_Z: "Z",
  T_45_XXJ_WS_Z_D: "Z",
  T_45_ZD_VEHICLEDROP_R_DESC: "Ném một pháo hiệu đến vị trí chỉ định để triệu hồi một phương tiện ngẫu nhiên",
  T_45_ZD_VEHICLEDROP_R_NAME: "Phương tiện bí ẩn",
  T_46_H_CHARACTER_MISCHIEFGIRL_N: "Lila",
  T_46_HJ_SHARE_GAMEDURATION: "Thời gian đã chơi",
  T_46_HJ_WS_SHAREBY: "Bởi {0}",
  T_46_HJ_WS_SHAREGAMEMODE: "Chế độ chơi",
  T_46_HJ_WS_SHARETEAM: "Đội",
  T_46_HJ_WS_SHARETEAMVS: "{0} vs {1}",
  T_46_HX_B_SCHOOL_VN: 'Học Sinh "Ngoan" (Quần)',
  T_46_HX_H_SCHOOL_VN: 'Học Sinh "Ngoan" (Đầu)',
  T_46_HX_S_SCHOOL_VN: 'Học Sinh "Ngoan" (Giày)',
  T_46_HX_T_SCHOOL_VN: 'Học Sinh "Ngoan" (Áo)',
  T_46_JH_WS_CLGUIDE_TUTORIAL: "Hướng dẫn",
  T_46_LYF_RANKBOARD_TIPS_OTHERS: "Khác",
  T_46_XXJ_WS_ACTUALPOSITION: "Vị trí thực tế",
  T_46_XXJ_WS_ADDSPECIALFOLLOW_D: "Thêm vật thể để giám sát với đồng bộ AOI bên ngoài tầm nhìn",
  T_46_XXJ_WS_APPEARANCE: "Ngoại hình",
  T_46_XXJ_WS_APPEARANCERES: "Tài nguyên Ngoại hình",
  T_46_XXJ_WS_BECOME: "Kích hoạt",
  T_46_XXJ_WS_BRAKETORQUE_D: "Sức mã lực áp dụng cho phương tiện khi sử dụng phanh/số lùi",
  T_46_XXJ_WS_CAMERAVIEWINGANGLERESTRICTIONTYPE: "Kiểu giới hạn xoay góc Camera",
  T_46_XXJ_WS_CLEANSPECIALFOLLOW_D: "Xóa tất cả vật thể được giám sát của mục tiêu",
  T_46_XXJ_WS_CRASHMAXDAMAGE_D: "Sát thương va chạm tối đa để tính toán sát thương",
  T_46_XXJ_WS_CRASHMAXSPEED: "Tốc độ va chạm tối đa",
  T_46_XXJ_WS_CRASHMAXSPEED_D: "Sử dụng để tính toán sát thương va chạm. Khi vượt quá tốc độ này sẽ không gây thêm sát thương",
  T_46_XXJ_WS_CRASHMESSFACTOR: "Chỉ số trọng lượng va chạm",
  T_46_XXJ_WS_CRASHMESSFACTOR_D: "Một tham số được dùng trong công thức tính sát thương để tính sát thương va chạm",
  T_46_XXJ_WS_CRASHMINDAMAGE_D: "Lượng sát thương va chạm tối thiểu khi tính toán sát thương",
  T_46_XXJ_WS_DB_OVERLIMIT_D: "Vượt quá giới hạn ghi và đọc của dữ liệu lưu trữ",
  T_46_XXJ_WS_DB_PARAMERROR_D: "Ngoại lệ tham số",
  T_46_XXJ_WS_DB_TIMEOUT_D: "Quá thời gian lưu trữ dữ liệu. Hiện áp dụng chủ yếu với đọc và ghi dữ liệu.",
  T_46_XXJ_WS_DELTA: "Delta",
  T_46_XXJ_WS_EDITNPCCOLLIDERTIPS: "Điều chỉnh ngoại hình",
  T_46_XXJ_WS_ENDVALUE_D: "Giá trị mục tiêu",
  T_46_XXJ_WS_ENGINETORQUE_D: "Mã lực tăng cho phương tiện khi nhấn ga",
  T_46_XXJ_WS_ERRORCODE_D: "Enum mã lỗi",
  T_46_XXJ_WS_EULARANGLETOVECTOR3: "Góc Eular với Vector3",
  T_46_XXJ_WS_EULARANGLETOVECTOR3_D: "Chuyển góc Eular thành Vector 3D",
  T_46_XXJ_WS_EXPIRE: "Hết hạn",
  T_46_XXJ_WS_FEMALEAVATAR: "Nhân vật nữ",
  T_46_XXJ_WS_GETPREMIUMEXPIREDATE: "Lấy thời gian Thẻ Thành Viên hết hạn",
  T_46_XXJ_WS_HASSPECIALFOLLOW_D: "Người quan sát có đang giám sát một vật thể hay không",
  T_46_XXJ_WS_HELICOPTER: "Chiến Cơ",
  T_46_XXJ_WS_HELICOPTER_D: "Một phương tiện có thể bay",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE: "Hạn chế lái ở tốc độ cao",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE_D: "Góc lái tối đa khi ở trạng thái tốc độ cao",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED: "Góc lái tốc độ cao",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED_D: "Giới hạn tốc độ chuyển hướng khi xe chạy với tốc độ tối đa",
  T_46_XXJ_WS_IDLE: "Hoạt ảnh khi đứng yên",
  T_46_XXJ_WS_IDLEBRAKEINPUT: "Chỉ số phanh thụ động",
  T_46_XXJ_WS_IDLEBRAKEINPUT_D: "Khi không lái phương tiện, giảm tốc nó. (Giá trị phanh thụ động) x (Momen phanh)",
  T_46_XXJ_WS_INTTOFLOAT: "Int to Float",
  T_46_XXJ_WS_INTTOFLOAT_D: "Chuyển giá trị integer",
  T_46_XXJ_WS_ISPREMIUM: "Có Thẻ Thành Viên",
  T_46_XXJ_WS_LEADERBOARDNAME_D: "Tên BXH trong cơ sở dữ liệu",
  T_46_XXJ_WS_MALEAVATAR: "Nhân vật nam",
  T_46_XXJ_WS_MODULE_AICHARACTOR: "Nhân vật AI",
  T_46_XXJ_WS_NEWUMAAPPEARANCE: "Ngoại hình UMA mới",
  T_46_XXJ_WS_NONE_D: "Không có lỗi",
  T_46_XXJ_WS_NPC: "NPC",
  T_46_XXJ_WS_NPC_D: "Vật thể NPC",
  T_46_XXJ_WS_NPCCOLLIDERTIPS: "Mẹo: NPC hình người thường có mô hình va chạm là một khối với chiều cao 1.4m và chiều rộng 0.25m. NPC trợ thủ là một khối với chiều cao 1m và chiều rộng 0.4m.",
  T_46_XXJ_WS_OBSERVER_D: "Người quan sát đang giám sát vật thể",
  T_46_XXJ_WS_ONPLAYERENTERPREMIUMCENTER: "Khi vào Thẻ Thành Viên Craftland",
  T_46_XXJ_WS_ONPLAYERLEAVEPREMIUMCENTER: "Khi thoát Thẻ Thành Viên Craftland",
  T_46_XXJ_WS_OPENPREMIUMCENTER: "Mở Thẻ Thành Viên Craftland",
  T_46_XXJ_WS_PERSONA: "Nhân Dạng",
  T_46_XXJ_WS_PERSONACENTER: "Trung Tâm Nhân Dạng",
  T_46_XXJ_WS_PET: "Trợ thủ",
  T_46_XXJ_WS_PLAYERORTRANSFORM: "Người chơi hoặc Biến hình",
  T_46_XXJ_WS_PLAYERORTRANSFORM_D: "Biệt danh cho thực thể Người chơi và Biến hình",
  T_46_XXJ_WS_PREMIUM: "Thẻ Thành Viên",
  T_46_XXJ_WS_PREMIUMSTATUS: "Trạng thái thẻ thành viên",
  T_46_XXJ_WS_PROXYOBSERVER: "Người quan sát Proxy",
  T_46_XXJ_WS_PROXYOBSERVER_D: "Người quan sát proxy",
  T_46_XXJ_WS_REMOVESPECIALFOLLOW_D: "Loại bỏ các vật thể được giám sát và hủy đồng bộ AOI bên ngoài tầm nhìn",
  T_46_XXJ_WS_RENEWAL: "Làm mới",
  T_46_XXJ_WS_ROTATEVECTOR: "Vector xoay",
  T_46_XXJ_WS_ROTATEVECTOR_D: "Xoay vector dựa trên hệ trục quaternion",
  T_46_XXJ_WS_SKIN: "Bánh răng",
  T_46_XXJ_WS_STARTVALUE_D: "Giá trị nguồn",
  T_46_XXJ_WS_STATUS: "Trạng thái",
  T_46_XXJ_WS_SWITCHUSERPROXYOBSERVER_D: "Chuyển người quan sát proxy của người dùng",
  T_46_XXJ_WS_TARGET_D: "Mục tiêu được giám sát",
  T_46_XXJ_WS_USER_D: "Người dùng",
  T_46_XXJ_WS_VALUE: "Giá trị",
  T_46_XXJ_WS_VALUE_D: "Vector",
  T_46_XYL_WS_CTZSAFEZONEEND: "Vị trí kết thúc vòng bo",
  T_46_XYL_WS_RESOURCETYPE1: "Công trình cơ bản",
  T_46_XYL_WS_RESOURCETYPE1_1: "Hình học",
  T_46_XYL_WS_RESOURCETYPE1_2: "Hình ảnh & Âm thanh",
  T_46_XYL_WS_RESOURCETYPE2: "Vật phẩm trường cảnh",
  T_46_XYL_WS_RESOURCETYPE2_2: "Tiếp tế chiến đấu",
  T_46_XYL_WS_RESOURCETYPE3: "Thiên nhiên",
  T_46_XYL_WS_RESOURCETYPE4: "Thành phần Module",
  T_46_XYL_WS_TYPEOTHERPROP: "Khác",
  T_46_XYL_WS_TYPEOTHERPROPBOX: "Hộp & Container",
  T_47_CJ_FOREGRIP_SOFT_N: "Tay Cầm Cơ Động",
  T_47_CJ_MAGEZINE_FAST_N: "Băng Đạn Nhanh",
  T_47_CJ_STOCK_FAST_N: "Báng Trợ Lực",
  T_47_GT_WS_USERMANUAL: "Cẩm nang người chơi",
  T_47_HJ_WS_VFX_FOG: "VFX Sương Mù",
  T_47_HJ_WS_VFX_LIGHTING: "VFX Ánh Sáng",
  T_47_HJ_WS_VFX_TRAILING: "Hiệu ứng VFX trailing",
  T_47_HL_CL_CREATOR_LABEL1: "Tài Năng Cộng Đồng",
  T_47_HL_CL_MAP_LABEL1: "Tác phẩm từ Thành Viên Tài Năng của Cộng Đồng",
  T_47_JH_WS_MODERATION_REASON12: "Liên quan đến cờ bạc",
  T_47_RW_NB_GP_GAMEAFFIX_HINT1: "Hợp tác NARUTO SHIPPUDEN",
  T_47_SD_RES_MATERIAL: "File vật liệu",
  T_47_SD_RES_MESH: "Mesh",
  T_47_SD_WS_MAPTAG_AI: "Tạo bản đồ AI",
  T_47_WT_W_NB_GP_KA_EXPLODE_DESC: "Phi đao đặc biệt có thể găm vào mục tiêu khi ném, sau chốc lát sẽ kích hoạt một vụ nổ lửa, gây sát thương thiêu đốt.",
  T_47_WT_W_NB_GP_KA_EXPLODE_NAME: "Kunai Hỏa",
  T_47_WT_W_NB_GP_KA_THUNDER_DESC: "Phi đao đặc biệt có thể găm vào mục tiêu khi ném, sau chốc lát sẽ kích hoạt một vụ nổ Sét, gây tê liệt mục tiêu.",
  T_47_WT_W_NB_GP_KA_THUNDER_NAME: "Kunai Lôi",
  T_47_WT_W_NB_GP_KA_WIND_DESC: "Phi đao đặc biệt có thể găm vào mục tiêu khi ném, sau chốc lát sẽ kích hoạt một cơn lốc xoáy, làm chậm và đẩy lui kẻ địch.",
  T_47_WT_W_NB_GP_KA_WIND_NAME: "Kunai Phong",
  T_47_WT_W_NB_GP_SRK_HEAVY_DESC: "Một loại shuriken thích hợp cho chiến đấu ở tầm trung và xa. Nhanh chóng ném ra một ám khí lớn, gây một lượng sát thương đáng kể.",
  T_47_WT_W_NB_GP_SRK_HEAVY_NAME: "Shuriken Hạng Nặng",
  T_47_WT_W_NB_GP_SRK_LIGHT_DESC: "Loại Shuriken phù hợp để chiến đấu ở tầm gần và trung với hai chế độ tấn công. Khi ném sẽ phóng ra ba mảnh đao gây sát thương nhỏ.",
  T_47_WT_W_NB_GP_SRK_LIGHT_NAME: "Shuriken Hạng Nhẹ",
  T_47_XXJ_WS_ACTION: "Hành Động",
  T_47_XXJ_WS_AOISETTING: "Thiết lập AOI",
  T_47_XXJ_WS_BAGSKINTYPE: "Kiểu skin balo",
  T_47_XXJ_WS_CLEARMEMORY: "Xóa bộ nhớ",
  T_47_XXJ_WS_CLNPC: "NPC Nâng cao",
  T_47_XXJ_WS_CLOTHTYPE: "Kiểu Skin trang phục",
  T_47_XXJ_WS_COMMON_ERROR: "Lỗi Phổ Biến",
  T_47_XXJ_WS_CONTENT: "Nội Dung",
  T_47_XXJ_WS_CREATERANDOMSEED: "Tạo Seed ngẫu nhiên",
  T_47_XXJ_WS_ELAPSEDPERCENTAGE: "Phần trăm đi qua",
  T_47_XXJ_WS_ENABLEUGCFOGFEATURE: "Bật tính năng sương mù",
  T_47_XXJ_WS_ENABLEUGCLIGHTROTATEFEATURE: "Bật tính năng xoay ánh sáng",
  T_47_XXJ_WS_ERRORCODE: "Mã lỗi",
  T_47_XXJ_WS_EXPONENTIAL: "Lũy thừa",
  T_47_XXJ_WS_EXPONENTIALSQUARED: "Hàm mũ bình phương",
  T_47_XXJ_WS_FAILED_INVALIDALLIDSONCREATE: "Tạo phòng thất bại: Không có ID Nhân dạng hợp lệ",
  T_47_XXJ_WS_FOG: "Sương mù",
  T_47_XXJ_WS_FOGDENSITY: "Độ dày sương mù",
  T_47_XXJ_WS_FOGENDDISTANCE: "Khoảng cách kết thúc sương mù",
  T_47_XXJ_WS_FOGMODE: "Chế độ sương mù",
  T_47_XXJ_WS_FOGMODETYPE: "Kiểu chế độ sương mù",
  T_47_XXJ_WS_FOGSTARTDISTANCE: "Vị trí bắt đầu sương mù",
  T_47_XXJ_WS_HEIGHTSCALE: "Thang chiều cao",
  T_47_XXJ_WS_ISVISIBLE: "Hiển thị",
  T_47_XXJ_WS_JOINNEWTEAM: "Tham gia đội mới",
  T_47_XXJ_WS_JOINTEAM: "Tham gia Đội",
  T_47_XXJ_WS_LIGHTROTATE: "Xoay ánh sáng",
  T_47_XXJ_WS_LINEAR: "Tuyến tính",
  T_47_XXJ_WS_LLMCHATHUD: "UI Chat Nhân Dạng",
  T_47_XXJ_WS_NEWTEAM: "Đội Mới",
  T_47_XXJ_WS_NEXT: "Tiếp theo",
  T_47_XXJ_WS_NPC_TIP: "Bạn có thể chỉnh sửa ngoại hình NPC và làm NPC thực hiện hoạt ảnh",
  T_47_XXJ_WS_OBSERVERS: "Người Theo Dõi",
  T_47_XXJ_WS_ONHUDSENDMESSAGETOPERSONA: "Khi Người Chơi Gửi Tin Nhắn Bởi UI Chat Nhân Dạng",
  T_47_XXJ_WS_ONPREMIUMCHANGE: "Khi thay đổi tình trạng Thành Viên",
  T_47_XXJ_WS_ONRECEIVEACTIONFROMPERSONA: "Khi Nhận Hành Động Từ Nhân Dạng",
  T_47_XXJ_WS_ONRECEIVECONTENTFROMPERSONA: "Khi Nhận Nội Dung Từ Nhân Dạng",
  T_47_XXJ_WS_ONRECEIVEFINISHFROMPERSONA: "Khi Nhận Kết Thúc Từ Nhân Dạng",
  T_47_XXJ_WS_ONRECEIVESTATUSFROMPERSONA: "Khi Nhận Trạng Thái Từ Nhân Dạng",
  T_47_XXJ_WS_PARTICLESID: "ID Particle",
  T_47_XXJ_WS_PERSONAAVATAR: "Avatar Nhân Dạng",
  T_47_XXJ_WS_PERSONAID: "ID Nhân dạng",
  T_47_XXJ_WS_PERSONANICKNAME: "Biệt Danh Nhân Dạng",
  T_47_XXJ_WS_PLAYERORNPC: "Người chơi hoặc NPC",
  T_47_XXJ_WS_PREMIUM_CLOSED: "Thẻ thành viên đã đóng",
  T_47_XXJ_WS_RANDOM: "Ngẫu Nhiên",
  T_47_XXJ_WS_SEED: "Seed",
  T_47_XXJ_WS_SENDER: "Người gửi",
  T_47_XXJ_WS_SETPERSONAOBSERVER: "Thiết lập quan sát nhân dạng",
  T_47_XXJ_WS_SETPLAYERCANQUITMIDWAY: "Thiết lập người chơi có thể thoát giữa trận",
  T_47_XXJ_WS_SHOULDREPLY: "Nên đáp lại",
  T_47_XXJ_WS_SHOWSYSTEMREPLY: "Xem phản hồi hệ thống",
  T_47_XXJ_WS_SPOTANGLE: "Góc ánh sáng",
  T_47_XXJ_WS_SPOTLIGHT: "Spotlight",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONA: "Gửi Tin Nhắn Hệ Thống Đến Nhân Dạng",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONASTREAM: "Stream Tin Nhắn Hệ Thống đến Nhân Dạng",
  T_47_XXJ_WS_TARGETTEAM: "Đội mục tiêu",
  T_47_XXJ_WS_THISENTITY: "Thực thể này",
  T_47_XXJ_WS_USERAVATAR: "Avatar Người Dùng",
  T_47_XXJ_WS_USERMESSAGETOPERSONA: "Gửi Tin nhắn người dùng đến Nhân dạng",
  T_47_XXJ_WS_USERMESSAGETOPERSONASTREAM: "Stream Tin Nhắn Người Chơi đến Nhân Dạng",
  T_47_XXJ_WS_USERNICKNAME: "Biệt danh người dùng",
  T_47_XXJ_WS_VEHICLESKINTYPE: "Kiểu skin phương tiện",
  T_47_XXJ_WS_WEAPONSKINTYPE: "Kiểu Skin Vũ Khí",
  T_47_XYL_NB_UGC_EFFECT001: "Hiệu ứng Rasengan",
  T_47_XYL_NB_UGC_EFFECT002: "Hiệu ứng Chidori",
  T_47_XYL_NB_UGC_EFFECT003: "Hiệu ứng Bách Hoa Xung Kích",
  T_47_XYL_NB_UGC_EFFECT004: "Hiệu ứng Hỏa Cầu Thuật",
  T_47_XYL_NB_UGC_EFFECT005: "Hiệu ứng Thủy Long Đạn Thuật",
  T_47_XYL_NB_UGC_EFFECT006: "Hiệu ứng Đại Đột Phá",
  T_47_XYL_NB_UGC_EFFECT007: "Hiệu ứng Bom Vĩ Thú",
  T_47_XYL_NB_UGC_EFFECT008: "Hiệu ứng Uế Thổ Chuyển Sinh",
  T_47_XYL_UGC_CRAFTLANDSHOP: "Cửa hàng tài nguyên",
  T_47_XYL_UGC_DONKEYCART: "Xe Lừa",
  T_47_XYL_UGC_SPOTLIGHT: "Spotlight",
  T_47_XYL_UGC_SPOTLIGHTANGLE: "Góc Spotlight",
  T_48_H_EMOTE_WATERFEST25_N: "Vũ điệu đường phố",
  T_48_H_VEHICLESKIN_MOTOBIKE_WATERFEST25_N: "Xe máy - Uầyyy",
  T_48_HJ_AC_STATENOTEXIST: "Trạng thái {0} không tồn tại trong trình điều khiển hoạt ảnh",
  T_48_HL_CODESCRIPT: "Mã tập lệnh",
  T_48_HL_GLOBAL_VAR: "Tên biến toàn cục",
  T_48_HL_GRAPH: "Khối",
  T_48_HL_HUD: "HUD",
  T_48_HL_LEADERBOARD_NAME: "Bảng xếp hạng",
  T_48_HL_LOCAL_VAR: "Tên biến cục bộ",
  T_48_HL_LOCALIZATION: "Tên bản địa hóa",
  T_48_HL_OPEN_ATTRIBUTES: "Tên thuộc tính mở",
  T_48_HX_A_WATERFEST25: "Lễ Hội Bọt Biển (Mặt nạ)",
  T_48_HX_B_WATERFEST25: "Lễ Hội Bọt Biển (Quần)",
  T_48_HX_F_B_BLACKDRESS: "Hắc Quang (Quần)",
  T_48_HX_F_H_BLACKDRESS: "Hắc Quang (Đầu)",
  T_48_HX_F_HA_BLACKDRESS: "Hắc Quang (Vẽ mặt)",
  T_48_HX_F_S_BLACKDRESS: "Hắc Quang (Giày)",
  T_48_HX_F_T_BLACKDRESS: "Hắc Quang (Áo)",
  T_48_HX_H_WATERFEST25: "Lễ Hội Bọt Biển (Đầu)",
  T_48_HX_HA_WATERFEST25: "Lễ Hội Bọt Biển (Vẽ mặt)",
  T_48_HX_M_A_BLACKDRESS: "Hắc Tinh (Mặt nạ)",
  T_48_HX_M_B_BLACKDRESS: "Hắc Tinh (Quần)",
  T_48_HX_M_H_BLACKDRESS: "Hắc Tinh (Đầu)",
  T_48_HX_M_HA_BLACKDRESS: "Hắc Tinh (Vẽ mặt)",
  T_48_HX_M_S_BLACKDRESS: "Hắc Tinh (Giày)",
  T_48_HX_M_T_BLACKDRESS: "Hắc Tinh (Áo)",
  T_48_HX_S_WATERFEST25: "Lễ Hội Bọt Biển (Giày)",
  T_48_HX_T_WATERFEST25: "Lễ Hội Bọt Biển (Áo)",
  T_48_JH_WS_STRINGDESC: 'Nhập một đoạn văn bản hoặc chuỗi ký tự. Một số widget có thể hiển thị văn bản có định dạng. Thêm màu sắc cho văn bản bằng cách sử dụng định dạng sau: [#XXXXXX]văn bản[-]. "#XXXXXX" là mã màu bạn muốn hiển thị. Lưu ý rằng màu chữ của widget liên quan phải được đặt thành màu trắng.',
  T_48_M_WS_P_ICON: "Ảnh đại diện",
  T_48_META_API_10001: "Tìm thực thể bằng ID",
  T_48_META_API_10001_P0: "ID thực thể",
  T_48_META_API_1098: "Đọc giá trị bảng cơ sở dữ liệu theo số lượng lớn",
  T_48_META_API_1098_D: "Đọc hàng loạt nhiều mục dữ liệu từ một bảng dữ liệu được chỉ định, trong đó các mục của danh sách ID người chơi đặc biệt tương ứng với các mục của danh sách khóa.",
  T_48_META_API_1098_P1: "ID tải khoản",
  T_48_META_API_1098_P1_D: "Danh sách ID người chơi đặc biệt đọc dữ liệu tương ứng với khóa ở cùng chỉ mục trong danh sách khóa.",
  T_48_META_API_1098_P2: "Khóa",
  T_48_META_API_1098_P2_D: "Danh sách khóa đọc dữ liệu tương ứng với ID người chơi đặc biệt ở cùng một chỉ mục trong danh sách ID.",
  T_48_META_API_1098_P5: "Mã trạng thái",
  T_48_META_API_1098_P5_D: "Danh sách mã trạng thái",
  T_48_META_API_1105: "Thông báo bắt đầu cốt truyện",
  T_48_META_API_1105_D: "Bắt đầu cốt truyện đã chỉ định cho người chơi kích hoạt cốt truyện",
  T_48_META_API_1105_P1_D: "ID cốt truyện",
  T_48_META_API_1108: "Lấy ngôn ngữ cục bộ",
  T_48_META_API_1500_P0: "Vectơ",
  T_48_META_API_1505_P1: "Z",
  T_48_META_API_3300: "Đặt trọng lượng cho bộ phận thân thể",
  T_48_META_API_3300_D: "Thiết lập trọng lượng bộ phận thân thể khi pha trộn với các hoạt ảnh có mức độ ưu tiên thấp hơn.",
  T_48_META_API_3300_P0_D: "Thành phần trình điều khiển hoạt ảnh có thể thêm mà bộ phận thân thể thuộc về",
  T_48_META_API_3300_P1: "Tên bộ phận",
  T_48_META_API_3300_P1_D: "Tên bộ phận thân thể",
  T_48_META_API_3300_P2: "Trọng lượng",
  T_48_META_API_3300_P2_D: "Trọng lượng có phạm vi giá trị từ [0,1], biểu thị mức độ pha trộn với các hoạt ảnh có mức độ ưu tiên thấp hơn.",
  T_48_META_API_3315: "Phát ghi đè hoạt ảnh nhân vật",
  T_48_META_API_3315_D: "Phát hoạt ảnh của nhân vật với khả năng ghi đè hoạt ảnh mặc định của trò chơi",
  T_48_META_API_3315_P3: "Ghi đè điều khiển chơi",
  T_48_META_API_3315_P3_D: "Liệu có thay thế hoạt ảnh mặc định hay không",
  T_48_META_API_3316: "Dừng hoạt ảnh",
  T_48_META_API_3316_D: "Dừng hoạt ảnh của mục tiêu khi ở trạng thái chỉ định",
  T_48_META_API_90_P1: "Có thể thoát giữa chừng",
  T_48_META_API_93: "Tạo chuyển động theo đường",
  T_48_META_API_93_D: "Tạo chuyển động đã nội suy theo một đường để làm vật thể di chuyển theo đường đã chỉ định",
  T_48_META_API_93_P1: "Đường dẫn",
  T_48_META_API_93_P1_D: "Đường đi của chuyển động",
  T_48_META_API_93_P3_D: "Độ lớn của vận tốc",
  T_48_META_API_93_P4: "Hướng theo tiếp tuyến",
  T_48_META_API_93_P4_D: "Liệu vật thể đang đối mặt cùng hướng chuyển động hay không. Thuộc tính này không thay đổi ngay cả khi hướng đối mặt của vật thể bị bắt thay đổi bằng cách nào khác.",
  T_48_META_API_96: "Sao chép nội dung đặt trước",
  T_48_META_API_96_D: "Tạo một phiên bản nội dung đặt trước có khả năng được xử lý không đồng bộ",
  T_48_META_API_96_P2: "Tải không đồng bộ",
  T_48_META_API_96_P2_D: "Liệu tải có không đồng bộ hay không",
  T_48_META_EVT_3140: "Lúc đổi đội",
  T_48_META_EVT_3140_D: "Kích hoạt khi đội của thực thể hiện tại thay đổi",
  T_48_META_EVT_3140_P0: "Đội trước",
  T_48_META_EVT_3140_P0_D: "Đội đối tượng thuộc trước khi đổi",
  T_48_META_EVT_3140_P1: "Đội hiện tại",
  T_48_META_EVT_3140_P1_D: "Đội đối tượng thuộc về sau khi đổi",
  T_48_META_EVT_3141: "Lúc bắt đầu cốt truyện",
  T_48_META_EVT_3141_D: "Kích hoạt khi cốt truyện bắt đầu",
  T_48_META_EVT_3141_P1: "ID cốt truyện",
  T_48_META_EVT_3141_P1_D: "ID cốt truyện",
  T_48_META_EVT_3142: "Lúc kết thúc cốt truyện",
  T_48_META_EVT_3142_D: "Kích hoạt khi cốt truyện kết thúc",
  T_48_META_EVT_3142_P0_D: "Người chơi kích hoạt",
  T_48_META_EVT_3142_P1_D: "ID cốt truyện",
  T_48_META_EVT_3143: "Cài đặt cốt truyện khi kích hoạt",
  T_48_META_EVT_3143_D: "Kích hoạt khi có sự lựa chọn trong cốt truyện",
  T_48_META_EVT_3143_P1_D: "ID cốt truyện",
  T_48_META_EVT_3143_P2: "ID lựa chọn",
  T_48_META_EVT_3143_P2_D: "ID của lựa chọn được chọn",
  T_48_META_TYP_409_I10: "Đổi đội thất bại_Đội không hợp lệ",
  T_48_META_TYP_409_I11: "Đổi đội thất bại_Bị tiêu diệt",
  T_48_META_TYP_409_I12: "Đổi đội thất bại_Đang trong xe",
  T_48_META_TYP_409_I7: "Đổi đội thất bại_Không được hỗ trợ",
  T_48_META_TYP_409_I8: "Đổi đội thất bại_Đang trong đội",
  T_48_META_TYP_409_I9: "Đổi đội thất bại_Đối tượng không hợp lệ",
  T_48_META_TYP_41_I19: "Tắt va chạm",
  T_48_META_TYP_417: "Hiệu ứng hạt",
  T_48_META_TYP_428: "Người chơi biến hình hay trang phục NPC",
  T_48_META_TYP_431: "Di chuyển theo đường",
  T_48_META_TYP_431_I1: "Đường dẫn",
  T_48_META_TYP_432: "Điểm đường đi cho đường cong tùy chỉnh",
  T_48_META_TYP_432_I0: "Lăn",
  T_48_META_TYP_432_I1: "Tiếp tuyến",
  T_48_META_TYP_433: "Kiểu đường cong tùy chỉnh",
  T_48_META_TYP_433_I0: "Tuyến tính",
  T_48_META_TYP_433_I1: "Mượt",
  T_48_META_TYP_433_I2: "Tùy chỉnh",
  T_48_META_TYP_434: "Đường cong tùy chỉnh",
  T_48_META_TYP_434_I2: "Vòng lặp đóng",
  T_48_META_TYP_434_I3: "Điểm đường đi",
  T_48_META_TYP_437_I5: "Tên kiểu điểm số",
  T_48_META_TYP_437_I6: "Nội dung điểm số bên trái",
  T_48_META_TYP_437_I7: "Nội dung điểm số bên phải",
  T_48_META_TYP_438_I1: "Người chơi",
  T_48_META_TYP_438_I2: "Xếp hạng",
  T_48_META_TYP_438_I3: "Tổng điểm số",
  T_48_META_TYP_438_I4: "Tên kiểu điểm số",
  T_48_META_TYP_438_I5: "Màu",
  T_48_META_TYP_438_I6: "Điểm số",
  T_48_META_TYP_439: "Nhóm",
  T_48_META_TYP_442_I1: "Điểm số bên trái",
  T_48_META_TYP_442_I10: "Biểu tượng bị tiêu diệt bên phải",
  T_48_META_TYP_442_I2: "Điểm số bên phải",
  T_48_META_TYP_442_I3: "Số người chơi còn sống bên trái",
  T_48_META_TYP_442_I4: "Số người chơi còn sống bên phải",
  T_48_META_TYP_442_I5: "Số người chơi bị tiêu diệt bên trái",
  T_48_META_TYP_442_I6: "Số người chơi bị tiêu diệt bên phải",
  T_48_META_TYP_442_I7: "Biểu tượng người chơi còn sống bên trái",
  T_48_META_TYP_442_I8: "Biểu tượng người chơi còn sống bên phải",
  T_48_META_TYP_442_I9: "Biểu tượng bị tiêu diệt bên trái",
  T_48_META_TYP_444: "Kiểu ngôn ngữ",
  T_48_META_TYP_444_I0: "Anh",
  T_48_META_TYP_444_I1: "Trung (Giản Thể)",
  T_48_META_TYP_444_I10: "Pháp",
  T_48_META_TYP_444_I11: "Đức",
  T_48_META_TYP_444_I12: "Thổ Nhĩ Kỳ",
  T_48_META_TYP_444_I13: "Hindi",
  T_48_META_TYP_444_I14: "Nhật",
  T_48_META_TYP_444_I15: "Română",
  T_48_META_TYP_444_I16: "Ả Rập",
  T_48_META_TYP_444_I17: "Myanmar",
  T_48_META_TYP_444_I18: "Urdu",
  T_48_META_TYP_444_I19: "Bengal",
  T_48_META_TYP_444_I2: "Trung (Phồn Thể)",
  T_48_META_TYP_444_I3: "Thái",
  T_48_META_TYP_444_I4: "Việt",
  T_48_META_TYP_444_I5: "Indonesia",
  T_48_META_TYP_444_I6: "Bồ Đào Nha",
  T_48_META_TYP_444_I7: "Tây Ban Nha",
  T_48_META_TYP_444_I8: "Nga",
  T_48_META_TYP_444_I9: "Hàn Quốc",
  T_48_SD_ERROR_DIVISOR: "Ước số không thể là 0",
  T_48_SD_ERROR_KEY_NOTINMAP: "Khóa được chỉ định không tồn tại trong bản đồ: {0}",
  T_48_SD_ERROR_LIST_OUTRANGE: "Chỉ mục danh sách nằm ngoài phạm vi: {0}",
  T_48_SD_SK_WARNING: "Không tìm thấy {1} trong {0}",
  T_48_TYC_WS_WARNING_SERVER_DRIVEN_DISABLED: 'Vì thuộc tính "Tính theo Máy chủ" của bộ điều khiển nhân vật Craftland {0} bị tắt, API máy chủ liên quan sẽ không có hiệu lực',
  T_48_XXJ_WS_PARENTERROR: "Thiết lập cha thất bại",
  T_48_XXJ_WS_PERFORMANCE: "Hiệu suất",
  T_48_XXJ_WS_TANGENT: "Tiếp tuyến",
  T_48_XXJ_WS_WAYPOINT: "Điểm đường đi",
  T_48_XYL_UGC_COMPOSITEOJBECTLIST: "Danh sách các vật thể",
  T_48_XYL_UGC_CUSTOMIZEMINIMAP: "Sử dụng bản đồ nhỏ tùy chỉnh",
  T_48_XYL_UGC_HIDEMINIMAP: "Giấu HUD bản đồ nhỏ",
  T_48_XYL_WS_BASICCUSTOMSURFACE: "Bề mặt tùy chỉnh cơ bản",
  T_48_XYL_WS_BASICCYLINDERCUTOUT: "Mặt cắt hình trụ",
  T_48_XYL_WS_BASICHEMISPHERE: "Bán cầu cơ bản",
  T_48_XYL_WS_BASICQUARTERROUNDEDTORUS: "1/4 hình xuyến",
  T_48_XYL_WS_BASICQUARTERTORUS: "1/4 hình xuyến vuông",
  T_48_XYL_WS_BASICROUNDEDTORUS: "Hình xuyến",
  T_48_XYL_WS_BASICTRIANGLE: "Bề mặt tam giác",
  T_48_XYL_WS_MAPPLAYERSTIPS: "Số lượng người chơi trong trận = Số lượng đội x Số lượng người chơi trong một đội. Số lượng người chơi trong trận càng lớn, thời gian tìm trận càng lâu hơn.",
  T_48_XYL_WS_MAPPLAYERSWARNING: "Số lượng người chơi lớn có thể dẫn đến thời gian tìm trận lâu hơn",
  T_49_HL_CL_CREATOR_LABEL2: "Tài Năng Cộng Đồng Craftland",
  T_49_HL_CL_MAPS_LABEL2: "Người Chiến Thắng",
  T_49_HL_CL_MAPS_LABEL3: "Người thắng cuộc",
  T_49_HX_T_TUNG: "Tung Tung Tung",
  T_49_HZY_CONTROLLER_TRAJECTORY: "Hướng bay",
  T_49_JH_WS_SKILLKASSIE: "Liên Kết Phục Hồi (Kassie)",
  T_49_JH_WS_SKILLKODA: "Mắt Thần (Koda)",
  T_49_JH_WS_SKILLOSCAR: "Tiến Công (Oscar)",
  T_49_LXW_EIGHTHB_EDIT_AITRAIN_ENTRANCE: "Tạo bằng AI",
  T_49_META_API_10065: "Đổi camera tùy chỉnh",
  T_49_META_API_10067: "Lấy camera tùy chỉnh hiện tại",
  T_49_META_API_10069: "Tạo Camera tùy chỉnh",
  T_49_META_API_10070: "Thiết lập culling mask cho camera tùy chỉnh",
  T_49_META_API_10070_D: "Thiết lập culling mask của camera được chọn để điều khiển hiển thị xuyên mọi lớp",
  T_49_META_API_10071: "Lấy culling mask cho camera tùy chỉnh",
  T_49_META_API_10071_D: "Lấy culling mask của camera chỉ định",
  T_49_META_API_10072: "Thiết lập lớp culling mask cho camera tùy chỉnh",
  T_49_META_API_10072_D: "Thiết lập hiển thị của camera được chọn cho lớp nhất định",
  T_49_META_API_10073: "Chụp màn hình",
  T_49_META_API_10073_D: "Chụp màn hình (để kiểm tra nội bộ)",
  T_49_META_API_106: "Lấy dấu thời gian máy chủ (ms)",
  T_49_META_API_106_D: "Lấy dấu thời gian máy chủ chuẩn đến từng mili giây",
  T_49_META_API_107: "Dấu thời gian thành chuỗi cục bộ (ms)",
  T_49_META_API_107_D: "Chuyển dấu thời gian (trong ms) thành chuỗi theo định dạng nhất định",
  T_49_META_API_107_P0: "Dấu thời gian (ms)",
  T_49_META_API_107_P0_D: "Dấu thời gian chuẩn đến từng mili giây",
  T_49_META_API_108: "Lerp Vector3",
  T_49_META_API_108_D: "Thực hiện nội suy tuyến tính từ vector 3D A đến vector B",
  T_49_META_API_1089_P2: "Yêu cầu ID",
  T_49_META_API_109: "Cập nhật bối cảnh cho Nhân dạng",
  T_49_META_API_109_D: "Cập nhật bối cảnh mô hình của nhân dạng nhất định trong phòng hiện tại để thay với bối cảnh trước sau khi thực hiện. Bối cảnh sẽ ảnh hưởng tới cách nhân dạng phân tích bối cảnh, lịch sử hoặc một số thông số của hội thoại hiện tại.",
  T_49_META_API_109_P1: "Bối cảnh",
  T_49_META_API_109_P1_D: "Miêu tả bối cảnh",
  T_49_META_API_110: "Phản hồi về Trả lời của Nhân dạng",
  T_49_META_API_110_D: "Gửi phản hồi dựa vào nội dung trả lời của nhân dạng nhằm giúp cải thiện mô hình của chúng tôi.",
  T_49_META_API_110_P1: "Được yêu thích",
  T_49_META_API_110_P1_D: "Câu trả lời có được thích hay không. True = thích.",
  T_49_META_API_1109: "Thiết lập vị trí người chơi cục bộ",
  T_49_META_API_1109_D: "Khi người chơi sử dụng nhân vật cổ điển, API này có thể thiết lập vị trí của người chơi.",
  T_49_META_API_1109_P0_D: "Vị trí được chọn",
  T_49_META_API_111: "Slerp Vector3",
  T_49_META_API_111_D: "Thực hiện nội suy cầu từ vector 3D A đến vector B để thao tác xoay xảy ra mượt mà",
  T_49_META_API_1110: "Thiết lập người chơi cục bộ phía trước",
  T_49_META_API_1110_D: "Khi người chơi dùng nhân vật cổ điển, API này có thể thiết lập hướng người chơi đối mặt.",
  T_49_META_API_1110_P0_D: "Vector về phía trước",
  T_49_META_API_112: "Khôi phục Bộ nhớ Nhân dạng",
  T_49_META_API_112_D: "Khôi phục bộ nhớ của nhân dạng về trước ID trả lời nhất định. Mọi dữ liệu hội thoại sau câu trả lời đó, cùng với câu trả lời sẽ bị xóa.",
  T_49_META_API_113: "Phát âm thanh một lần",
  T_49_META_API_113_D: "Phát một hiệu ứng âm thanh một lần với âm lượng có thể được điều chỉnh",
  T_49_META_API_113_P0_D: "ID tài nguyên hiệu ứng âm thanh được phát",
  T_49_META_API_113_P1: "Âm lượng",
  T_49_META_API_113_P1_D: "Âm lượng của hiệu ứng âm thanh, từ 0 tới 1.",
  T_49_META_API_97: "Tạo điều khiển cho bộ phận xương đối mặt",
  T_49_META_API_97_D: "Sau khi tạo thực thể điều khiển cho bộ phận xương đối mặt, bạn có thể dùng thực thể điều khiển để điều khiển bộ phận xương chỉ định và khiến bộ phận luôn đối mặt mục tiêu.",
  T_49_META_API_97_P0_D: "Thực thể điều khiển cho bộ phận xương đối mặt. Nếu thực thể bị phá, tính năng đối mặt sẽ ngưng.",
  T_49_META_API_97_P1_D: "Bộ phận xương đang được điều khiển",
  T_49_META_API_97_P2_D: "Mục tiêu đang được đối mặt",
  T_49_META_API_98: "Chiếu",
  T_49_META_API_98_D: "Tính phép chiếu vector A lên vector B",
  T_49_META_API_99: "Lấy dấu thời gian cục bộ (ms)",
  T_49_META_API_99_D: "Lấy dấu thời gian cục bộ chuẩn đến từng mili giây",
  T_49_META_EVT_16_P1_D: "Mỗi yêu cầu sẽ sử dụng một ID số theo trình tự, bắt đầu từ 0, cho các thao tác như tạo phòng hay xóa bộ nhớ.",
  T_49_META_EVT_16_P2: "ID Trả lời",
  T_49_META_EVT_16_P2_D: "Mỗi câu trả lời hoàn thiện sẽ có ID riêng",
  T_49_META_TYP_122_I19: "Chất liệu tùy chỉnh",
  T_49_META_TYP_122_I19_D: "Cho phép thay thế nền trời với chất liệu tùy chỉnh",
  T_49_META_TYP_14_I78_D: "Lấy hoặc thiết lập thực thể camera hiện đang render trường cảnh trên máy của người chơi. Chú ý: Thực thể camera đang biểu thị dữ liệu thiết lập để điều khiển camera máy khách.",
  T_49_META_TYP_335_I9: "Thời gian đã trôi qua (ms)",
  T_49_META_TYP_335_I9_D: "Thời lượng phát hiệu ứng âm thanh trong mili giây. Chỉ có thể truy cập thuộc tính này trong máy khách.",
  T_49_META_TYP_409_I13: "LLM_OK",
  T_49_META_TYP_409_I13_D: "LLM_OK",
  T_49_META_TYP_409_I14: "LLM_Thất bại",
  T_49_META_TYP_409_I14_D: "LLM_thất bại",
  T_49_META_TYP_409_I15: "LLM_hết giờ",
  T_49_META_TYP_409_I15_D: "LLM_hết giờ",
  T_49_META_TYP_409_I16: "LLM_Nhândạng_khônghợplệ",
  T_49_META_TYP_409_I16_D: "LLM_PhòngHoặcNhândạng_khônghợplệ",
  T_49_META_TYP_409_I17: "LLM_Giới hạn_Token",
  T_49_META_TYP_409_I17_D: "LLM_Giới hạn_Token",
  T_49_META_TYP_409_I18: "LLM_Vi phạm",
  T_49_META_TYP_409_I18_D: "LLM_Yêu cầu_Thường xuyên",
  T_49_META_TYP_409_I19: "LLM_Yêu cầu_Thường xuyên",
  T_49_META_TYP_409_I19_D: "LLM_Yêu cầu_Thường xuyên",
  T_49_META_TYP_441: "ID Trình diễn",
  T_49_META_TYP_445: "ID điều khiển thực thể có thể chơi",
  T_49_META_TYP_446: "Có thể gắn điều khiển thực thể có thể chơi",
  T_49_META_TYP_446_I0: "Điều khiển thực thể có thể chơi",
  T_49_META_TYP_447: "Điều khiển cho bộ phận xương",
  T_49_META_TYP_448: "Điều khiển cho bộ phận xương đối mặt",
  T_49_META_TYP_448_I0: "Đối tượng được điều khiển",
  T_49_META_TYP_448_I1: "Mục tiêu được đối mặt",
  T_49_META_TYP_449: "Camera tùy chỉnh",
  T_49_META_TYP_449_I2: "Kích cỡ phép chiếu 2D",
  T_49_META_TYP_449_I2_D: "Điều khiển kích cỡ vùng camera có thể thấy",
  T_49_META_TYP_450: "Chuỗi dấu thời gian cục bộ (ms)",
  T_49_META_TYPE_449_D: "Camera tùy chỉnh được điều khiển bởi người phát triển, camera điều khiển tầm nhìn người chơi trong trận",
  T_49_META_TYPE_450_D: "Chuyển mốc thời gian cấp mili giây sang định dạng văn bản có thể đọc",
  T_49_SD_SEARCH_ICONDESC: "Liên kết Thông minh",
  T_49_SD_SEARCHKEY_ACTION: "Hành động",
  T_49_SD_SEARCHKEY_ANICLIPID: "ID clip hoạt ảnh",
  T_49_SD_SEARCHKEY_AS: "Là",
  T_49_SD_SEARCHKEY_ATTACHMENTENUM: "ID Phụ kiện",
  T_49_SD_SEARCHKEY_AUDIOENUM: "Kiểu hiệu ứng âm thanh",
  T_49_SD_SEARCHKEY_BAGSKINID: "ID trang phục balo",
  T_49_SD_SEARCHKEY_BEZIER: "Đường cong bezier",
  T_49_SD_SEARCHKEY_BOOL: "Boolean",
  T_49_SD_SEARCHKEY_BREAK: "Ngắt",
  T_49_SD_SEARCHKEY_BTREEID: "ID Cây hành vi",
  T_49_SD_SEARCHKEY_BUTTONCLICK: "Khi nhấn nút",
  T_49_SD_SEARCHKEY_BUTTONDOUBLECLICK: "Khi nhấn đúp nút",
  T_49_SD_SEARCHKEY_BUTTONPRESS: "Khi nhấn nút",
  T_49_SD_SEARCHKEY_BUTTONRELEASE: "Khi nhả nút",
  T_49_SD_SEARCHKEY_CLOTHENUM: "Kiểu trang phục",
  T_49_SD_SEARCHKEY_COLOR: "Màu",
  T_49_SD_SEARCHKEY_COMMENT: "Ghi chú",
  T_49_SD_SEARCHKEY_COMPARER: "= > < ≠",
  T_49_SD_SEARCHKEY_COMPONENTENUM: "Liệt kê thành phần",
  T_49_SD_SEARCHKEY_CONCANT: "Kết nối",
  T_49_SD_SEARCHKEY_CONTINUE: "Tiếp",
  T_49_SD_SEARCHKEY_CUSTOMHUD: "HUD Tùy chỉnh",
  T_49_SD_SEARCHKEY_CUSTOMHUDWIDGET: "HUD tùy chỉnh cho tiện ích",
  T_49_SD_SEARCHKEY_DYNAMICITEMENUM: "Kiểu vật thể tạo cấp động",
  T_49_SD_SEARCHKEY_E: "E",
  T_49_SD_SEARCHKEY_EFFECTENUM: "Kiểu hiệu ứng hình ảnh",
  T_49_SD_SEARCHKEY_ENTITY: "Chọn đối tượng cảnh",
  T_49_SD_SEARCHKEY_FLOAT: "Số thực",
  T_49_SD_SEARCHKEY_FOR: "Cho chỉ mục",
  T_49_SD_SEARCHKEY_FOREACH: "Cho mỗi",
  T_49_SD_SEARCHKEY_FUNCTION: "Hàm",
  T_49_SD_SEARCHKEY_GETCSV: "Lấy CSV",
  T_49_SD_SEARCHKEY_GETREGISTERED: "Lấy tài nguyên được đăng ký qua từ khóa",
  T_49_SD_SEARCHKEY_GETVALUE: "Lấy giá trị thuộc tính",
  T_49_SD_SEARCHKEY_GLOBALVARGET: "Lấy biến toàn cục",
  T_49_SD_SEARCHKEY_GLOBALVARSET: "Đặt Biến Toàn cục",
  T_49_SD_SEARCHKEY_IF: "Nếu",
  T_49_SD_SEARCHKEY_IFELSE: "if else",
  T_49_SD_SEARCHKEY_IMGENUM: "Kiểu hình ảnh",
  T_49_SD_SEARCHKEY_INT: "Số nguyên",
  T_49_SD_SEARCHKEY_INTERNALHUD: "Kiểu HUD",
  T_49_SD_SEARCHKEY_ITEMENUM: "Loại vật phẩm",
  T_49_SD_SEARCHKEY_LISTAPPEND: "Nối phần tử danh sách",
  T_49_SD_SEARCHKEY_LISTAPPENDRANGE: "Liệt kê phạm vi thêm",
  T_49_SD_SEARCHKEY_LISTCLEAR: "Xóa danh sách",
  T_49_SD_SEARCHKEY_LISTCLONE: "Bản sao danh sách",
  T_49_SD_SEARCHKEY_LISTCONTAIN: "Liệt kê bao gồm",
  T_49_SD_SEARCHKEY_LISTCREATE: "Tạo danh sách",
  T_49_SD_SEARCHKEY_LISTDELETE: "Xóa danh sách",
  T_49_SD_SEARCHKEY_LISTGET: "Lấy danh sách",
  T_49_SD_SEARCHKEY_LISTINDEXOF: "Liệt kê chỉ mục của",
  T_49_SD_SEARCHKEY_LISTINSERT: "Thêm danh sách",
  T_49_SD_SEARCHKEY_LISTLASTINDEXOF: "Liệt kê mục lục cuối của",
  T_49_SD_SEARCHKEY_LISTLENGTH: "Độ dài danh sách",
  T_49_SD_SEARCHKEY_LISTREVERSE: "Liệt kê ngược",
  T_49_SD_SEARCHKEY_LISTSET: "Đặt danh sách",
  T_49_SD_SEARCHKEY_LISTSHUFFLE: "Trộn danh sách",
  T_49_SD_SEARCHKEY_LOCALKEY: "Khóa đã bản địa hóa",
  T_49_SD_SEARCHKEY_LOCALVAR: "Biến cục bộ",
  T_49_SD_SEARCHKEY_LOGICAL: "Và hoặc",
  T_49_SD_SEARCHKEY_LOGINFO: "In thông tin lưu lại",
  T_49_SD_SEARCHKEY_MAPALLKEYS: "lấy hết khóa từ điển lấy hết khóa từ điển",
  T_49_SD_SEARCHKEY_MAPCLEAR: "xóa nội dung từ điển xóa nội dung từ điển",
  T_49_SD_SEARCHKEY_MAPCONTAIN: "từ điển có khóa từ điển có khóa",
  T_49_SD_SEARCHKEY_MAPCREATE: "tạo từ điển tạo từ điển",
  T_49_SD_SEARCHKEY_MAPGET: "lấy giá trị từ điển bằng khóa lấy giá trị từ điển bằng khóa",
  T_49_SD_SEARCHKEY_MAPLENGTH: "độ dài từ điển độ dài từ điển",
  T_49_SD_SEARCHKEY_MAPREMOVE: "xóa từ điển xóa từ điển",
  T_49_SD_SEARCHKEY_MAPSET: "đặt giá trị từ điển đặt giá trị từ điển",
  T_49_SD_SEARCHKEY_MATH: "Cộng trừ nhân chia",
  T_49_SD_SEARCHKEY_NEWLIST: "Danh sách mới",
  T_49_SD_SEARCHKEY_NULL: "Không có gì",
  T_49_SD_SEARCHKEY_NUMTOSTRING: "Số thành chuỗi",
  T_49_SD_SEARCHKEY_PARTICLESENUM: "Thuộc tính hiệu ứng hạt",
  T_49_SD_SEARCHKEY_PERSONA: "Nhân dạng",
  T_49_SD_SEARCHKEY_PI: "Số Pi",
  T_49_SD_SEARCHKEY_PLAYERDATAID: "ID dữ liệu người chơi",
  T_49_SD_SEARCHKEY_PLAYERSKILLENUM: "Loại kỹ năng nhân vật",
  T_49_SD_SEARCHKEY_PREEFFECT: "Sticker đặc biệt",
  T_49_SD_SEARCHKEY_PREFAB: "Nội dung đặt trước",
  T_49_SD_SEARCHKEY_RAWID: "ID",
  T_49_SD_SEARCHKEY_READSTATIS: "Đọc dữ liệu tích lũy",
  T_49_SD_SEARCHKEY_RESOURCEENUM: "UUID Tài nguyên",
  T_49_SD_SEARCHKEY_RETURN: "Trở lại",
  T_49_SD_SEARCHKEY_SCENEENUM: "Tệp trường cảnh",
  T_49_SD_SEARCHKEY_SCRIPTID: "Tập lệnh",
  T_49_SD_SEARCHKEY_SETVALUE: "Đặt giá trị thuộc tính",
  T_49_SD_SEARCHKEY_SPECIALITEMENUM: "Kiểu ID vật thể đặc biệt",
  T_49_SD_SEARCHKEY_TEXT: "Văn bản",
  T_49_SD_SEARCHKEY_TEXTUREID: "Kiểu texture",
  T_49_SD_SEARCHKEY_THISENTITY: "Thực thể này",
  T_49_SD_SEARCHKEY_TIMELINE: "Dòng thời gian",
  T_49_SD_SEARCHKEY_TYPEENUM: "Bất kỳ kiểu nào",
  T_49_SD_SEARCHKEY_V2VCREATE: "Tạo Vector2",
  T_49_SD_SEARCHKEY_V2VGET: "Lấy thành phần Vector2",
  T_49_SD_SEARCHKEY_V2VOPERATION: "Chạy Vector2 cộng trừ nhân tích vô hướng khoảng cách góc",
  T_49_SD_SEARCHKEY_V2VSET: "Đặt thành phần Vector2",
  T_49_SD_SEARCHKEY_V3VCREATE: "Tạo Vector3",
  T_49_SD_SEARCHKEY_V3VGET: "Lấy thành phần Vector3",
  T_49_SD_SEARCHKEY_V3VOPERATION: "Chạy Vector3 cộng trừ nhân tích vô hướng khoảng cách góc",
  T_49_SD_SEARCHKEY_V3VSET: "Đặt thành phần Vector3",
  T_49_SD_SEARCHKEY_VEHICLEENUM: "ID trang phục phương tiện",
  T_49_SD_SEARCHKEY_WEAPONSKINENUM: "ID Ngoại trang vũ khí",
  T_49_SD_SEARCHKEY_WHILE: "Trong khi",
  T_49_SD_SEARCHKEY_WRITESTATIS: "Viết giá trị bù dữ liệu tích lũy",
  T_49_SD_SEARCHKEY_WRITESTATISCROSS: "In cơ sở dữ liệu tích lũy được bù bởi mã bản đồ",
  T_49_XXJ_WS_DURATIONS: "Thời lượng (giây)",
  T_49_XXJ_WS_EDITPERFORMANCE: "Điều chỉnh Trình diễn",
  T_49_XXJ_WS_PERFORMANCE: "Trình diễn",
  T_49_XXJ_WS_PERFORMANCE_DELETE: "Xóa Trình diễn",
  T_49_XXJ_WS_PERFORMANCE_DELETECONFIRM: "Không thể khôi phục trình diễn bị xóa, tiếp tục?",
  T_49_XXJ_WS_PERFORMANCE_EDITING: "Đang chỉnh {0}",
  T_49_XXJ_WS_PERFORMANCE_NAME_EXCEPTION: "Tên đã được sử dụng, vui lòng đổi tên và thử lại",
  T_49_XXJ_WS_PERFORMANCENAME: "Tên Trình diễn",
  T_49_XXJ_WS_TIMELINE_ADD_KEYFRAME: "Thêm keyframe",
  T_49_XXJ_WS_TIMELINE_ADD_SUB_TRACK: "Thêm Sub-Track",
  T_49_XXJ_WS_TIMELINE_ADD_TRACK: "Thêm Track",
  T_49_XXJ_WS_TIMELINE_DEL_TRACK: "Xóa Track",
  T_49_XXJ_WS_TIMELINE_ENTITY_TRACK: "Track Diễn viên",
  T_49_XXJ_WS_TIMELINE_EVENT_TRACK: "Track Sự kiện",
  T_49_XXJ_WS_TIMELINE_EXISTED_KEYFRAME: "Đã có keyframe",
  T_49_XXJ_WS_TIMELINE_EXISTED_TRACK: "Track Diễn viên tương ứng đã tồn tại",
  T_49_XXJ_WS_TIMELINE_FRAME_SETTING: "Nội dung",
  T_49_XXJ_WS_TIMELINE_NAME_EXCEPTION: "Phát hiện tên track trùng lặp. Vui lòng đổi tên và thử lại.",
  T_49_XXJ_WS_TIMELINE_OPEN_RECORD: "Hãy bắt đầu ghi hoặc chọn keyframe trước",
  T_49_XXJ_WS_TIMELINE_RECORDING: "Đang ghi...",
  T_49_XXJ_WS_TIMELINE_REMOVE_KEYFRAME: "Xóa keyframe",
  T_49_XXJ_WS_TIMELINE_SCENE_EDIT_MODE: "Xem Trường cảnh",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP: "Chọn vật thể hoặc nhấn trực tiếp nút Thêm Track để tạo Track",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP_1: "Nhấn nút Thêm Track để tạo Track mới",
  T_49_XXJ_WS_TIMELINE_SUB_TRACK_TITLE: "Sub-Track",
  T_49_XXJ_WS_TIMELINE_TRACK: "Track",
  T_49_XXJ_WS_TIMELINE_TRACK_EDIT_MODE: "Xem Track",
  T_49_XYL_WS_DAILYPROPS: "Cơ bản",
  T_49_XYL_WS_STOREGAMPLAY: "Cơ chế chơi",
  T_49_YU_QCITEM_ALL_11: "Tung Tung Tung Sahur!",
  T_50_H_M4A1_VA_N: "M4A1 - Ma Quái",
  T_50_H_MACHETE_VA_N: "Đao - Ma Quái",
  T_50_HJ_LEADERBOARD_SETTING_HEADER: "Mục Bảng Xếp Hạng",
  T_50_HJ_OVERFLOW_RESIZEFREELY: "Tràn văn bản",
  T_50_HJ_OVERFLOW_RESIZEHEIGHT: "Xuống dòng",
  T_50_HJ_OVERFLOW_SHRINKCONTENT: "Thu nhỏ văn bản",
  T_50_HJ_SEARCHKEY_TUPLECREATE: "Tạo Tuple",
  T_50_HJ_SEARCHKEY_TUPLEGET: "Nhận Tuple",
  T_50_HJ_SEARCHKEY_TUPLESET: "Thiết lập Tuple",
  T_50_HJ_TEXTOBGJ_H: "Độ cao",
  T_50_HJ_TEXTOBGJ_OVERFLOW: "Cài đặt Tràn văn bản",
  T_50_HJ_TEXTOBGJ_W: "Độ rộng",
  T_50_HZY_REVIEW_TEXTOBJ: "Nội dung của vật thể văn bản",
  T_50_JH_WS_HIDEMAPERROR: "Không thể giấu bản đồ nhỏ khi không có ảnh nền tùy chỉnh",
  T_50_JH_WS_HIDEMAPTIP: "Sẽ không dùng bản đồ nhỏ làm ảnh nền nếu bị giấu đi",
  T_50_JH_WS_HIDEMINIMAP: "Giấu bản đồ nhỏ",
  T_50_META_API_10073_P0: "Tên tệp",
  T_50_META_API_10073_P0_D: "Tên tệp",
  T_50_META_API_10073_P1_D: "Kết quả của thao tác thực thi. Kiểm tra enum Mã Trạng Thái.",
  T_50_META_API_1102: "Đọc giá trị cột của bảng cơ sở dữ liệu",
  T_50_META_API_1102_D: "Lấy giá trị của cột nhất định cho một khóa nhất định từ một bảng cơ sở dữ liệu tiêu chuẩn",
  T_50_META_API_1102_P3: "Chỉ số cột",
  T_50_META_API_1102_P3_D: "Chỉ số cột của bảng cơ sở dữ liệu (0 = cột đầu tiên)",
  T_50_META_API_1106: "Tạo Trình Diễn",
  T_50_META_API_1106_D: "Tạo thực thể trình diễn",
  T_50_META_API_1106_P0_D: "Tài nguyên trình diễn",
  T_50_META_API_1111: "Đọc giá trị liên quan của cơ sở dữ liệu bảng xếp hạng",
  T_50_META_API_1111_D: "Đọc kết hợp giá trị tương ứng từ bảng BXH và các bảng liên quan trong dữ liệu",
  T_50_META_API_1111_P5: "Mã trạng thái liên kết",
  T_50_META_API_1111_P5_D: "Mã lỗi liên kết",
  T_50_META_API_1112: "Đọc giá trị liên quan của cơ sở dữ liệu bảng xếp hạng theo phạm vi",
  T_50_META_API_1112_D: "Đọc giá trị từ bảng BXH trong một phạm vi xếp hạng chỉ định, đọc giá trị tương ứng của các khóa được lấy từ bảng tương ứng, và kết hợp chúng.",
  T_50_META_API_1112_P6: "Mã trạng thái liên kết",
  T_50_META_API_1112_P6_D: "Mã lỗi liên kết",
  T_50_META_API_1113: "Viết giá trị liên quan của cơ sở dữ liệu bảng xếp hạng",
  T_50_META_API_1113_D: "Ghi giá trị cho một khóa lên bảng BXH và các bảng liên quan trong cơ sở dữ liệu",
  T_50_META_API_1113_P5: "Mã trạng thái liên kết",
  T_50_META_API_1113_P5_D: "Mã lỗi liên kết",
  T_50_META_API_114_D: "Tạo UI tùy chỉnh",
  T_50_META_API_114_P0_D: "Mã được sử dụng làm tên thông số để tạo thực thể giao diện, và giá trị biến cục bộ tương ứng làm đại diện cho thực thể giao diện được tạo.",
  T_50_META_API_114_P1_D: "Thuộc về thực thể người chơi, chỉ có thể thấy bởi người chơi.",
  T_50_META_API_114_P2: "ID Tài nguyên UI",
  T_50_META_API_114_P2_D: "ID tài nguyên UI tùy chỉnh",
  T_50_META_API_115_D: "Tạo UI tùy chỉnh đã chỉ định",
  T_50_META_API_116: "Đặt hightlight cấp bậc vật thể",
  T_50_META_API_116_D: "Thiết lập trạng thái highlight của vật thể. Có thể bị ảnh hưởng bởi logic trong trò chơi khác.",
  T_50_META_API_116_P0_D: "Vật thể chỉ định",
  T_50_META_API_116_P1_D: "Trạng thái highlight",
  T_50_META_API_117: "Bitwise Phổ biến",
  T_50_META_API_117_D: "Bitwise và/hoặc/xor/chuyển trái/chuyển phải",
  T_50_META_API_117_P0_D: "Giá trị trái",
  T_50_META_API_117_P1_D: "Giá trị phải",
  T_50_META_API_117_P2_D: "Kiểu thực thi",
  T_50_META_API_118: "Bitwise Not",
  T_50_META_API_118_D: "Bitwise NOT, còn được biết đến là bổ sung bitwise",
  T_50_META_API_118_P0_D: "Giá trị",
  T_50_META_API_119: "Danh sách bitwise sang số nguyên",
  T_50_META_API_119_D: "Thực thi hành động OR bitwise lên các thành phần danh sách và đổi kết quả thành giá trị số nguyên.",
  T_50_META_API_119_P0: "Mảng Bit",
  T_50_META_API_119_P0_D: "Mảng bitwise",
  T_50_META_API_120: "Số nguyên bitwise sang danh sách",
  T_50_META_API_120_D: "Chuyển giá trị thập phân dưới dạng bit ở vị trí 1 của số nguyên ở dạng nhị phân thành danh sách",
  T_50_META_API_120_P0_D: "Số nguyên",
  T_50_META_API_121: "Góc Quaternion",
  T_50_META_API_121_D: "Tính góc của hai quaternion",
  T_50_META_API_121_P0_D: "Quaternion 1",
  T_50_META_API_121_P1_D: "Quaternion 2",
  T_50_META_API_122: "Chấm Quaternion",
  T_50_META_API_122_D: "Tính sản phẩm dot của hai quaternion",
  T_50_META_API_123: "Nghịch đảo Quaternion",
  T_50_META_API_123_D: "Tính nghịch đảo của Quaternion",
  T_50_META_API_123_P0_D: "Quaternion",
  T_50_META_API_124: "Xoay Quaternion từ sang",
  T_50_META_API_124_D: 'Tính quaternion xoay từ "from" thành "to"',
  T_50_META_API_124_P0_D: "Điểm bắt đầu",
  T_50_META_API_124_P1_D: "Điểm kết thúc",
  T_50_META_API_125: "Xoay Quaternion về",
  T_50_META_API_125_D: 'Tính quaternion xoay từ "from" thành "to". Delta góc tối đa là góc xoay tối đa.',
  T_50_META_API_125_P0: "Từ",
  T_50_META_API_125_P0_D: "Quaternion đầu",
  T_50_META_API_125_P1: "Đến",
  T_50_META_API_125_P1_D: "Quaternion chỉ định",
  T_50_META_API_125_P2: "Delta góc tối đa",
  T_50_META_API_125_P2_D: "Góc xoay tối đa",
  T_50_META_API_126: "Lấy góc xoay gyroscope",
  T_50_META_API_126_D: "Vị trí của thiết bị trong không gian 3D, phản ánh góc quay của 3 trục.",
  T_50_META_API_127: "Lấy trọng lực gyroscope",
  T_50_META_API_127_D: "Thành phần trọng lực được phát hiện bởi cảm biến trên thiết bị của bạn",
  T_50_META_API_128: "Lấy tỉ lệ xoay gyroscope",
  T_50_META_API_128_D: "Phản ánh tỉ lệ xoay của thiết bị. Là thuật ngữ liên quan đến các cảm biến gyroscope miêu tả tốc độ xoay của thiết bị trong môi trường 3D.",
  T_50_META_API_129: "Lấy góc xoay không chệch của gyroscope",
  T_50_META_API_129_D: "Miêu tả tỉ lệ xoay của thiết bị và cung cấp kết quả chuẩn hơn bằng cách bù đắp âm thanh hoặc độ lệch của cảm biến thiết bị.",
  T_50_META_API_130: "Lấy gia tốc gyroscope của người dùng",
  T_50_META_API_130_D: "Phần gia tốc của thiết bị mà không có thành phần trọng lực, là gia tốc tạo bởi thao tác người dùng hoặc lực ngoài.",
  T_50_META_API_131: "Lấy thông tin chạm",
  T_50_META_API_131_D: "Lấy thông tin chỉ số chạm màn hình nhất định (bao gồm vị trí, sự dịch chuyển và thời gian thay đổi).",
  T_50_META_API_131_P0_D: "Phân bố ID điểm chạm, bắt đầu từ 0",
  T_50_META_API_131_P1_D: "Vị trí chạm",
  T_50_META_API_131_P2: "Delta vị trí",
  T_50_META_API_131_P2_D: "Thay đổi vị trí so với khung cuối",
  T_50_META_API_131_P3: "Delta thời gian",
  T_50_META_API_131_P3_D: "Thời gian đã trôi qua từ khung cuối cùng",
  T_50_META_API_132: "Lấy số lần chạm màn hình",
  T_50_META_API_132_D: "Lấy số lượng điểm chạm hiện tại trên màn hình",
  T_50_META_API_133: "Rung thiết bị",
  T_50_META_API_133_D: "Làm thiết bị rung một lần",
  T_50_META_API_134_D: "Thông báo máy người chơi phát âm thanh",
  T_50_META_API_134_P0_D: "Người chơi chỉ định",
  T_50_META_API_134_P1_D: "Tài nguyên âm thanh",
  T_50_META_API_134_P2_D: "Tốc độ phát (tầm khả thi: 0.1~3.0; 1 = bình thường, <1 = chậm lại, >1 = nhanh lên)",
  T_50_META_API_135_D: "Phát tệp âm thanh một lần",
  T_50_META_API_135_P0_D: "Tài nguyên âm thanh",
  T_50_META_API_135_P1_D: "Tốc độ chơi",
  T_50_META_API_136: "Format chuỗi",
  T_50_META_API_136_D: "Format chuỗi",
  T_50_META_API_136_P0_D: "Chuỗi đã định dạng dùng điều khiển định dạng động từ Go",
  T_50_META_API_136_P1: "Mảng thông số",
  T_50_META_API_136_P1_D: "Danh sách thông số",
  T_50_META_API_137: "Dán thành phần",
  T_50_META_API_137_D: "Sao chép hoặc thêm dữ liệu thành phần",
  T_50_META_API_137_P0: "Nguồn",
  T_50_META_API_137_P0_D: "Thực thể gốc",
  T_50_META_API_137_P1_D: "Thực thể chỉ định",
  T_50_META_API_137_P2: "Kiểu thành phần",
  T_50_META_API_137_P2_D: "Kiểu thành phần",
  T_50_META_API_137_P3: "Là thành công",
  T_50_META_API_137_P3_D: "Nó có thành công hay không",
  T_50_META_API_138: "Hồi sinh ở khung tiếp theo",
  T_50_META_API_138_D: "Hồi sinh ở khung tiếp theo",
  T_50_META_API_139: "Diệt ở khung tiếp theo",
  T_50_META_API_139_D: "Diệt thực thể chiến đấu ở khung tiếp theo",
  T_50_META_API_139_P0_D: "Thực thể chiến đấu",
  T_50_META_API_140: "Thoát trò chơi ở khung tiếp theo",
  T_50_META_API_140_D: "Thoát trò chơi ở khung tiếp theo",
  T_50_META_API_141: "Lấy âm lượng mic",
  T_50_META_API_141_D: "Lấy âm lượng mic. Trả lại trang thái khi người chơi tắt mic hoặc khi không được cấp quyền.",
  T_50_META_API_141_P0: "Âm lượng",
  T_50_META_API_141_P0_D: "Âm lượng mic",
  T_50_META_API_141_P1_D: "Mic đang mở hay đóng",
  T_50_META_API_142: "Lấy chất lượng hình ảnh",
  T_50_META_API_142_D: "Lấy chất lượng hình ảnh hiện tại (enum: Thấp/Trung bình/Cao/Rất cao)",
  T_50_META_API_143: "Lấy độ phân giải hình ảnh",
  T_50_META_API_143_D: "Lấy độ phân giải kết xuất hiện tại",
  T_50_META_API_144: "Liên kết người chơi tùy chỉnh",
  T_50_META_API_144_D: "Thiết lập một cách sinh động mục tiêu người chơi liên kết với, sẽ ghi đè các liên kết hiện tại. Trả lại false nếu thất bại.",
  T_50_META_API_144_P0: "Người chơi tùy chỉnh",
  T_50_META_API_144_P0_D: "Sau khi liên kết người chơi tùy chỉnh này với người chơi, sẽ tự động đồng bộ hóa dữ liệu như vị trí và hướng",
  T_50_META_API_144_P1_D: "Người chơi chỉ định",
  T_50_META_API_145: "Hủy liên kết người chơi tùy chỉnh",
  T_50_META_API_145_D: "Hủy liên kết. Trả lại false nếu thất bại.",
  T_50_META_API_145_P0: "Người chơi tùy chỉnh",
  T_50_META_API_145_P0_D: "Hủy mọi liên kết với mục tiêu. Sau khi gỡ liên kết, sẽ không tự động đồng bộ hóa dữ liệu như vị trí và hướng nữa.",
  T_50_META_API_146_P0_D: "Người chơi tùy chỉnh",
  T_50_META_API_147: "Đặt trạng thái người chơi tùy chỉnh",
  T_50_META_API_147_D: "Tự động tải lên máy chủ và đồng bộ hóa với mọi máy khách. Trả lại false nếu thất bại.",
  T_50_META_API_147_P0: "Người chơi tùy chỉnh",
  T_50_META_API_147_P1: "Trạng thái",
  T_50_META_API_147_P1_D: "Hay dùng để lưu lại trạng thái hoạt ảnh. Lấy trạng thái đã đồng bộ hóa với Trạng thái Lấy Người chơi Tùy chỉnh.",
  T_50_META_API_148: "Lấy trạng thái người chơi tùy chỉnh",
  T_50_META_API_148_D: "Dữ liệu trạng thái được tự động đồng bộ hóa với máy chủ. Trả lại false nếu thất bại.",
  T_50_META_API_148_P0: "Người chơi tùy chỉnh",
  T_50_META_API_148_P1: "Trạng thái",
  T_50_META_API_148_P1_D: "Thiết lập trạng thái với Thiết Lập Trạng thái Người chơi Tùy Chỉnh",
  T_50_META_API_149: "Đặt khoảng cách âm lượng",
  T_50_META_API_149_D: "Thiết lập phạm vi khoảng cách giữa các người chơi để thiết lập âm lượng một cách sinh động.",
  T_50_META_API_149_P0: "Danh sách khoảng cách",
  T_50_META_API_149_P0_D: "Danh sách khoảng cách, mỗi khoảng cách tương ứng với một thành phần trong danh sách âm lượng.",
  T_50_META_API_149_P1: "Danh sách âm lượng",
  T_50_META_API_149_P1_D: "Danh sách âm lượng, mỗi âm lượng tương ứng với một thành phần trong danh sách khoảng cách.",
  T_50_META_API_150: "Lấy bạn bè",
  T_50_META_API_150_D: "Lấy danh sách ID bạn của người chơi",
  T_50_META_API_151: "Lấy thông tin UI mặc định",
  T_50_META_API_151_D: "Lấy vị trí UI mặc định của người chơi",
  T_50_META_API_151_P0_D: "Giao diện mặc định",
  T_50_META_API_151_P1_D: "Trạng thái",
  T_50_META_API_151_P2_D: "Vị trí UI",
  T_50_META_API_151_P3: "Kích cỡ",
  T_50_META_API_151_P3_D: "Kích cỡ UI",
  T_50_META_API_152: "Thông báo sự kiện ngẫu nhiên",
  T_50_META_API_152_D: "Phát sự kiện tùy chỉnh cho bất cứ thực thể nào để nhận (nghe)",
  T_50_META_API_153: "Gửi sự kiện đến vật thể",
  T_50_META_API_153_D: "Gửi sự kiện tùy chỉnh tới thực thể chỉ định",
  T_50_META_EVT_17: "Khi bắt đầu nhấn vào màn hình",
  T_50_META_EVT_17_D: "Bắt đầu sự kiện khi nhấn vào màn hình",
  T_50_META_EVT_17_P0: "Chỉ số chạm",
  T_50_META_EVT_17_P0_D: "Chỉ số điểm chạm",
  T_50_META_EVT_17_P1_D: "Vị trí chạm",
  T_50_META_EVT_18: "Khi nhấn xong màn hình",
  T_50_META_EVT_18_D: "Kết thúc sự kiện khi chạm màn hình",
  T_50_META_EVT_18_P0: "Chỉ số chạm",
  T_50_META_EVT_18_P0_D: "Chỉ số điểm chạm",
  T_50_META_EVT_18_P1_D: "Vị trí chạm trên màn hình",
  T_50_META_EVT_19: "Khi nhận kết quả nhân dạng tạo phòng",
  T_50_META_EVT_19_D: "Nhận kết quả tương ứng khi tạo phòng trò chuyện cho nhân dạng thất bại",
  T_50_META_EVT_19_P1: "ID phòng",
  T_50_META_EVT_19_P1_D: "ID phòng",
  T_50_META_EVT_20: "Khi người dùng thoát hoặc khi trận kết thúc",
  T_50_META_EVT_20_D: "Kích hoạt khi người dùng thoát trận hoặc khi trận kết thúc",
  T_50_META_TYP_11_I44: "Âm lượng của khoảng cách",
  T_50_META_TYP_11_I44_D: "Điều chỉnh sinh động âm lượng dựa vào khoảng cách giữa các người chơi",
  T_50_META_TYP_22_I9_D: "ID tài nguyên dùng để tạo UI",
  T_50_META_TYP_244_I12_D: "Độ rộng của hộp văn bản",
  T_50_META_TYP_244_I13_D: "Độ cao của văn bản hội thoại",
  T_50_META_TYP_244_I14_D: "Kiểu tràn văn bản",
  T_50_META_TYP_335_I10_D: "Tốc độ phát lại (giá trị khả thi> 0, mặc định = 1)",
  T_50_META_TYP_409_I20: "IO_Tạo_Tệp_Thấtbại",
  T_50_META_TYP_409_I20_D: "Thao tác IO thất bại: Có lỗi xảy ra trong quá trình tạo tệp",
  T_50_META_TYP_409_I21: "IO_Tên_Tệp_khônghợplệ",
  T_50_META_TYP_409_I21_D: "Thao tác IO thất bại. Tên tệp không hợp lệ.",
  T_50_META_TYP_448_I0_D: "Phần xương được điều khiển",
  T_50_META_TYP_448_I1_D: "Mục tiêu bộ phận xương đang tập trung vào",
  T_50_META_TYP_451: "Kiểu tràn",
  T_50_META_TYP_451_D: "Phương pháp xử lý tràn văn bản",
  T_50_META_TYP_452: "ID tài nguyên UI tùy chỉnh",
  T_50_META_TYP_452_D: "ID mô tả tài nguyên HUD tùy chỉnh",
  T_50_META_TYP_453: "Kiểu chất lượng kết xuất",
  T_50_META_TYP_453_D: "Enum của chất lượng kết xuất",
  T_50_META_TYPE_448_D: "Thực thể này được dùng để điều khiển bộ phận xương tập trung vào một mục tiêu",
  T_50_SD_WS_MAPTAG_AI3DGEN: "Vật thể 3D tạo bản đồ",
  T_50_SD_WS_MAPTAG_AIRACING: "Tạo Bản đồ bằng AI Đua xe",
  T_50_XXJ_WS_ANIMATIONSTATENAME: "Enum tên của trạng thái hoạt ảnh",
  T_50_XXJ_WS_DISABLEFOOTSTEP: "Tắt rung tiếng chân",
  T_50_XXJ_WS_NOPERFORMANCE: "Không có tệp trình diễn",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS: "Phiên bản beta",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS_DESC: "Chào nhà sáng tạo, trình điều chỉnh trình diễn vẫn đang được thử nghiệm. Sẽ có lỗi hoặc thiếu tính năng chính.",
  T_50_XXJ_WS_PERFORMANCE_NEW: "thêm Trình diễn",
  T_50_XXJ_WS_TIMELINE_ADD_KEYCLIP: "Thêm key clip",
  T_50_XXJ_WS_TIMELINE_ALONGPATH_TRACK: "Track theo đường đi",
  T_50_XXJ_WS_TIMELINE_ANIMATION_CLIP: "Hoạt ảnh",
  T_50_XXJ_WS_TIMELINE_ANIMATION_TRACK: "Track Hoạt ảnh",
  T_50_XXJ_WS_TIMELINE_AUDIO_TRACK: "Track âm thanh",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_HOLD: "Giữ",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_LOOPFOREVER: "Lặp lại vĩnh viễn",
  T_50_XXJ_WS_TIMELINE_DURATION: "Thời lượng: {0} giây",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_AVATAR: "Có khác biệt giữa hoạt ảnh và mô hình",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_CLIP_OVERLAP: "Key clip bị đè",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_ENTITY_MISSING: "Thiếu thực thể bị liên kết",
  T_50_XXJ_WS_TIMELINE_NAME_EMPTY: "Không được bỏ trống tên Track",
  T_50_XXJ_WS_TIMELINE_NPC_TRACK: "Track NPC",
  T_50_XXJ_WS_TIMELINE_PROP_TRACK: "Track Thuộc tính",
  T_50_XXJ_WS_TIMELINE_REMOVE_KEYCLIP: "Xóa key clip",
  T_50_XXJ_WS_TIMELINE_TIME_SUFFIX: "{0} giây",
  T_50_XXJ_WS_TIMELINE_TRACK_MAX_LIMIT: "Đạt quá giới hạn số Track",
  T_50_XYL_WS_AIGETERATESHOW: "Khối xây dựng",
  T_50_YU_F_B_VA_WITCH: "Phù Thủy Siêu Quậy (Quần)",
  T_50_YU_F_H_VA_WITCH: "Phù Thủy Siêu Quậy (Đầu)",
  T_50_YU_F_HA_VA_WITCH: "Phù Thủy Siêu Quậy (Vẽ mặt)",
  T_50_YU_F_S_VA_WITCH: "Phù Thủy Siêu Quậy (Giày)",
  T_50_YU_F_T_VA_WITCH: "Phù Thủy Siêu Quậy (Áo)",
  T_50_ZCS_CLCUSTOMEVE_CUSTOMEVENT: "Sự kiện Tùy chỉnh",
  T_51_GT_WS_BASIC: "Cơ bản",
  T_51_GT_WS_GLOBALEVENT: "Sự Kiện Toàn Cầu",
  T_51_GT_WS_PRIVATEEVENT: "Sự Kiện Riêng Tư",
  T_51_GT_WS_STORY: "Cốt truyện",
  T_51_GT_WS_UI: "UI",
  T_51_JH_WS_MINTIP1: "",
  T_51_META_API_1114: "Tin nhắn người chơi đến phản hồi thoại Nhân dạng",
  T_51_META_API_1114_D: "Gửi lời nhắn của người dùng cho Nhân dạng và nhận phản hồi từ Nhân dạng",
  T_51_META_API_1114_P2_D: "Nếu giá trị là true, phản hồi giọng nói sẽ tự động phát khi nhận; nếu false, cần gọi API để phát",
  T_51_META_API_1115: "Thông báo hệ thống tới phản hồi giọng nói của Nhân dạng",
  T_51_META_API_1115_D: "Gửi tin nhắn hệ thống tới nhân dạng và nhận phản hồi giọng nói từ nhân dạng đó",
  T_51_META_API_1116: "Phát giọng nói đã lưu của Nhân dạng",
  T_51_META_API_1116_D: "Phát phản hồi giọng nói đã lưu của Nhân dạng. Có thể lưu tới 10 phản hồi",
  T_51_META_API_144_P2_D: "Thực thi có thành công hay không",
  T_51_META_API_154: "Lấy tên kiểu",
  T_51_META_API_154_D: "Trả về tên của kiểu đối tượng mục tiêu",
  T_51_META_API_154_P0_D: "Đối tượng mục tiêu để lấy tên kiểu",
  T_51_META_API_155: "Lấy Hộp giới hạn",
  T_51_META_API_155_D: "Lấy Hộp giới hạn của đối tượng trong trường cảnh",
  T_51_META_API_155_P0_D: "Trường cảnh cần lấy Hộp giới hạn",
  T_51_META_API_155_P1_D: "Tâm của Hộp giới hạn",
  T_51_META_API_155_P2: "Kích cỡ",
  T_51_META_API_155_P2_D: "Kích cỡ của Hộp giới hạn",
  T_51_META_API_156: "Tạo thực thể",
  T_51_META_API_156_D: "Tạo một thực thể. Bạn có thể chỉ định chủ sở hữu (một client người chơi cụ thể). Kết hợp với API AddComponent, bạn có thể đồng bộ dữ liệu hướng tới đúng client đó.",
  T_51_META_API_156_P0_D: "Thực thể mục tiêu cần tạo",
  T_51_META_API_156_P1_D: "Kiểu thành phần tùy chỉnh được tạo",
  T_51_META_API_156_P2_D: "Chủ sở hữu của thực thể",
  T_51_META_API_156_P3: "Cờ",
  T_51_META_API_156_P3_D: "Cờ của thực thể. Xem enum Entity Flag để biết chi tiết. Có thể sử dụng kết hợp.",
  T_51_META_API_157: "Đặt thuộc tính vật liệu",
  T_51_META_API_157_D: "API này cho phép bạn chỉnh sửa một số thuộc tính vật liệu của đối tượng.",
  T_51_META_API_157_P0_D: "Đối tượng mục tiêu cần lấy thuộc tính vật liệu",
  T_51_META_API_157_P1: "Tên thuộc tính",
  T_51_META_API_157_P1_D: "Đặt tên cho thuộc tính",
  T_51_META_API_157_P2: "Giá trị thuộc tính",
  T_51_META_API_157_P2_D: "Đặt giá trị cho thuộc tính",
  T_51_META_API_157_P3: "Thành công",
  T_51_META_API_157_P3_D: "Đặt trạng thái thành công hay không",
  T_51_META_API_158: "Xóa thuộc tính vật liệu",
  T_51_META_API_158_D: "Xóa thuộc tính đã đặt",
  T_51_META_API_158_P0_D: "Đối tượng mục tiêu cần xóa thuộc tính vật liệu",
  T_51_META_EVT_21: "Khi thuộc tính tùy chỉnh thay đổi",
  T_51_META_EVT_21_D: `Khi một thuộc tính tùy chỉnh được giám sát thay đổi, sự kiện này sẽ được kích hoạt.
Lưu ý: trong cùng một khung hình, dù thuộc tính bị thay đổi nhiều lần thì sự kiện vẫn chỉ kích hoạt một lần. Khi máy chủ thay đổi thuộc tính tùy chỉnh, sự kiện sẽ được gửi tới cả hai phía; khi máy khách thay đổi thuộc tính tùy chỉnh của thực thể cục bộ, sự kiện chỉ được gửi ở phía máy đó.`,
  T_51_META_EVT_21_P0: "Chỉ số thuộc tính",
  T_51_META_EVT_21_P0_D: "Chỉ số của thuộc tính",
  T_51_META_EVT_21_P1_D: "Giá trị mới của thuộc tính",
  T_51_META_EVT_22: "Khi trạng thái của người chơi thay đổi",
  T_51_META_EVT_22_D: "Sự kiện này sẽ kích hoạt khi trạng thái của người chơi tùy chỉnh thay đổi",
  T_51_META_EVT_22_P0: "Trạng thái người chơi tùy chỉnh",
  T_51_META_EVT_22_P0_D: "Trạng thái của người chơi tùy chỉnh",
  T_51_META_EVT_23: "Khi nhận phản hồi giọng nói từ Nhân dạng",
  T_51_META_EVT_23_D: "Kích hoạt sự kiện này khi nhận được phản hồi giọng nói của Nhân dạng",
  T_51_META_EVT_24: "Khi Phát Thoại Xong Từ Nhân Dạng",
  T_51_META_EVT_24_D: "Kích hoạt sự kiện này khi phản hồi giọng nói của Nhân dạng đã phát xong",
  T_51_META_TYP_14_I79: "Người chơi đã liên kết",
  T_51_META_TYP_14_I79_D: "Khi được gắn với Người chơi tùy chỉnh, mô hình nhân vật mặc định sẽ bị ẩn, và vị trí, góc xoay (hướng nhìn), cùng các dữ liệu khác của đối tượng mục tiêu sẽ được đồng bộ với nó",
  T_51_META_TYP_15_I6: "Hiển thị tên đồng đội",
  T_51_META_TYP_15_I6_D: "Có hiển thị tên đồng đội trên đầu hay không",
  T_51_META_TYP_247_I31: "Cứu",
  T_51_META_TYP_247_I31_D: "Cứu",
  T_51_META_TYP_247_I32: "Bỏ cuộc",
  T_51_META_TYP_247_I32_D: "Bỏ cuộc",
  T_51_META_TYP_247_I33: "Tấn công 2",
  T_51_META_TYP_247_I33_D: "Tấn công 2",
  T_51_META_TYP_247_I34: "Kết hợp vũ khí",
  T_51_META_TYP_247_I34_D: "Kết hợp vũ khí",
  T_51_META_TYP_247_I35: "Ván lướt",
  T_51_META_TYP_247_I35_D: "Ván lướt",
  T_51_META_TYP_313_I2_D: "Sát thương ngoài vùng an toàn mỗi giây",
  T_51_META_TYP_409_I22: "Lỗi thông số",
  T_51_META_TYP_409_I22_D: "Lỗi thông số",
  T_51_META_TYP_440_I1_D: "ID Tài nguyên trình diễn",
  T_51_META_TYP_454: "Thuộc tính vật liệu",
  T_51_META_TYP_454_D: "Dùng để thiết lập thuộc tính vật liệu cho một đối tượng",
  T_51_META_TYP_455: "Cờ thực thể",
  T_51_META_TYP_455_D: "Cờ thuộc tính của một thực thể cụ thể, có thể sử dụng kết hợp",
  T_51_META_TYP_455_I0_D: "Thuộc tính mặc định",
  T_51_META_TYP_455_I1: "Tĩnh",
  T_51_META_TYP_455_I1_D: "Thực thể tĩnh",
  T_51_META_TYP_455_I2: "Cục bộ",
  T_51_META_TYP_455_I2_D: "Thực thể cục bộ",
  T_51_META_TYP_455_I3: "Chỉ render",
  T_51_META_TYP_455_I3_D: "Chỉ Render",
  T_51_MX_WS_ACTION_BITE: "Giòn Rụm",
  T_51_MX_WS_ACTION_BOUNCE: "",
  T_51_MX_WS_ACTION_DOOR_CREAK: "",
  T_51_MX_WS_ACTION_FALL_HIT: "Đập Đất",
  T_51_MX_WS_ACTION_GULP: "",
  T_51_MX_WS_ACTION_RUNAWAY_DUST: "",
  T_51_MX_WS_ACTION_RUNNING_STEPS: "",
  T_51_MX_WS_ACTION_SPIN_LOOP: "",
  T_51_MX_WS_ACTION_STOMACH_GROWL: "Stomach Growling",
  T_51_MX_WS_AMBIENT_BIRDS: "Bird Chirping",
  T_51_MX_WS_AMBIENT_CAFE_AMBIENCE: "Không Khí Quán Cà Phê",
  T_51_MX_WS_AMBIENT_CLASSROOM_OFFICE: "Classroom Ambience",
  T_51_MX_WS_AMBIENT_NIGHT_CRICKETS: "",
  T_51_MX_WS_AMBIENT_RAIN: "Mưa",
  T_51_MX_WS_AMBIENT_STREET_TRAFFIC: "Giao thông đường phố",
  T_51_MX_WS_AMBIENT_WAVES: "",
  T_51_MX_WS_ATMOSPHERE_APPLAUSE_LAUGH: "",
  T_51_MX_WS_ATMOSPHERE_BASS_DRUM: "",
  T_51_MX_WS_ATMOSPHERE_BELL: "Bell Ringing",
  T_51_MX_WS_ATMOSPHERE_JINGLE: "Bell Jingling",
  T_51_MX_WS_ATMOSPHERE_WIND: "Howling Wind",
  T_51_MX_WS_COMEDY_AIR_WHIP: "",
  T_51_MX_WS_COMEDY_CAMERA_CLICK: "Bấm Máy Ảnh",
  T_51_MX_WS_COMEDY_FAIL_WAHWAH: "",
  T_51_MX_WS_COMEDY_FART: "Tiếng Xì Hơi Buồn Cười",
  T_51_MX_WS_COMEDY_FUNNY_LAUGH: "Cười",
  T_51_MX_WS_COMEDY_HEAD_SLAP: "",
  T_51_MX_WS_COMEDY_IDEA_DING: "",
  T_51_MX_WS_COMEDY_RECORD_SCRATCH: "",
  T_51_MX_WS_COMEDY_VICTORY_DING: "",
  T_51_MX_WS_EMOTION_AWKWARD: "",
  T_51_MX_WS_EMOTION_BLINK_SWITCH: "",
  T_51_MX_WS_EMOTION_CONFIDENT_VICTORY: "",
  T_51_MX_WS_EMOTION_CONFUSED: "",
  T_51_MX_WS_EMOTION_HAPPY_NOTIFICATION: "",
  T_51_MX_WS_EMOTION_HEARTBEAT_LOVE: "Heart Beating",
  T_51_MX_WS_EMOTION_PHONE_VIBRATION: "",
  T_51_MX_WS_EMOTION_SIGH_SAD: "Thở dài",
  T_51_MX_WS_EMOTION_SNORT: "",
  T_51_MX_WS_EMOTION_SPARKLE: "",
  T_51_MX_WS_EMOTION_SURPRISE_SHOCK: "",
  T_51_MX_WS_EMOTION_TEETH_CHATTER: "Teeth Chattering",
  T_51_MX_WS_FANTASY_MAGIC_CAST: "",
  T_51_MX_WS_FANTASY_TRANSFORM: "",
  T_51_MX_WS_FX_EXPLOSION: "Explosion Impace",
  T_51_MX_WS_FX_FIRE_BURN: "Lửa Nổ Tanh Tách",
  T_51_MX_WS_FX_ICE_CRACK: "",
  T_51_MX_WS_FX_LIGHTNING: "Sét",
  T_51_MX_WS_FX_SPLASH: "Nước Bắn Tung Tóe",
  T_51_MX_WS_MECHANIC_BOX_OPEN: "Mở hộp",
  T_51_MX_WS_MECHANIC_GEAR_SPIN: "Gear Rotating",
  T_51_MX_WS_MECHANIC_LOCK_UNLOCK: "",
  T_51_MX_WS_MECHANIC_OPEN_CLOSE: "",
  T_51_MX_WS_MECHANIC_POURING: "",
  T_51_MX_WS_RHYTHM_BREAK_BEAT: "",
  T_51_MX_WS_RHYTHM_CLAP: "Vỗ tay",
  T_51_MX_WS_RHYTHM_DRUM_BEAT: "",
  T_51_MX_WS_SOUNDTYPE_INTERACTION: "",
  T_51_MX_WS_TRANSITION_GLITCH: "",
  T_51_MX_WS_TRANSITION_POPUP: "Window Pop-up",
  T_51_MX_WS_TRANSITION_REVERSE_SUCTION: "",
  T_51_MX_WS_TRANSITION_WHOOSH: "",
  T_51_MX_WS_TRANSPORT_AIRCRAFT: "",
  T_51_MX_WS_TRANSPORT_BIKE_SKATE: "",
  T_51_MX_WS_TRANSPORT_CAR_DRIVE: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHDECEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOOP: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWDECEL: "",
  T_51_MX_WS_TRANSPORT_STREAM_FLOW: "Dòng Nước Hỗn Loạn",
  T_51_MX_WS_TRANSPORT_TRAIN_BEEP: "",
  T_51_MX_WS_UI_ACHIEVEMENT_UNLOCK: "",
  T_51_MX_WS_UI_BUTTON_CLICK: "Bấm nút",
  T_51_MX_WS_UI_CANCEL: "",
  T_51_MX_WS_UI_CONFIRM: "",
  T_51_MX_WS_UI_LIST_SCROLL: "",
  T_51_MX_WS_UI_LOADING: "Loading Progress",
  T_51_TYC_API_OUTLINE: "Đặt đường viền thực thể",
  T_51_TYC_API_OUTLINE_ALPHA: "Độ mờ đường viền",
  T_51_TYC_API_OUTLINE_ALPHA_D: "Giá trị ở giữa 0 và 1 (0 = hoàn toàn trong suốt,1 = hoàn toàn mờ đục)",
  T_51_TYC_API_OUTLINE_COLOR: "Màu đường viền",
  T_51_TYC_API_OUTLINE_COLOR_D: "Màu dùng để vẽ đường viền",
  T_51_TYC_API_OUTLINE_D: "Chỉ định một thực thể để làm nổi bật viền ngoài. Các kiểu được hỗ trợ bao gồm: Người chơi, Tùy chỉnh hiển thị, NPC, Ngoại hình và Ngoại hình cơ bản.",
  T_51_TYC_API_OUTLINE_TARGET: "Thực thể mục tiêu",
  T_51_TYC_API_OUTLINE_TARGET_D: "Thực thể cần được tô viền",
  T_51_TYC_API_OUTLINE_TOPMOST: "Luôn ở trên",
  T_51_TYC_API_OUTLINE_TOPMOST_D: "Khiến đường viền được hiển thị xuyên qua mọi vật thể, luôn nổi bật trên cùng.",
  T_51_TYC_API_OUTLINE_WIDTH: "Độ rộng đường viền",
  T_51_TYC_API_OUTLINE_WIDTH_D: "Giá trị ở giữa 0 và 1 (0 = không có viền, 1 = viền đậm tối đa)",
  T_51_XJ_WS_BASIC_SETTING: "Cài đặt cơ bản",
  T_51_XJ_WS_GAME_START_TIME_UNIT: "Giây",
  T_51_XJ_WS_GMSTART_TIME: "Thời gian chuẩn bị trước trận đấu",
  T_51_ZCS_SPAWNPOINT_NAME: "",
  T_OB47_M_WS_READ: "Tài nguyên chỉ đọc",
  TXT_AVATAR_FEMALE_JACKET_BLACK: "Áo da nữ (Đen)",
  TXT_AVATAR_FEMALE_PANTS_MARIO: "Quần thợ ống nước (Nữ)",
  TXT_AVATAR_FEMALE_SHOE_COS_HOODSHIRT_BLACK: "Giày Thể thao (Nữ)",
  TXT_AVATAR_FEMALE_SHORTPANT_COS_GSL_BLACK: "Quần ngắn Garena (Nữ)",
  TXT_AVATAR_FEMALE_SKIRT_COS_GSL_BLACK: "Váy Garena (Nữ)",
  TXT_AVATAR_FEMALE_TOP_COS_HOODSHIRT_BLACK: "Áo Thể thao (Nữ)",
  TXT_AVATAR_FEMALE_TOP_COS_SONGKRAN_2018: "Sơ-mi Songkran nữ (Đen)",
  TXT_AVATAR_FEMALE_TSHIRT_MARIO: "Áo Thợ ống nước (Nữ)",
  TXT_AVATAR_FEMALE_VEST_COS_GSL_BLACK: "Áo Garena (Nữ)",
  TXT_AVATAR_MALE_BOTTOM_COS_CNY_RED: "Quần Sườn xám",
  TXT_AVATAR_MALE_BOTTOM_COS_GANGS_BLACK: "Quần Mafia Đen",
  TXT_AVATAR_MALE_BOTTOM_COS_MOB_YELLOW: "Quần Đầu lâu",
  TXT_AVATAR_MALE_BOTTOM_COS_OUTDOOR_BLACK: "Quần rừng sâu",
  TXT_AVATAR_MALE_PANTS_MARIO: "Quần thợ ống nước (Nam)",
  TXT_AVATAR_MALE_SHOE_COS_CANVAS_BLACK: "Giày rừng sâu",
  TXT_AVATAR_MALE_SHOE_RED: "Bốt đỏ (Nam)",
  TXT_AVATAR_MALE_TOP_COS_CNY_RED: "Vest Sườn xám",
  TXT_AVATAR_MALE_TOP_COS_GANGS_BLACK: "Áo Mafia Đen",
  TXT_AVATAR_MALE_TOP_COS_HOODIE_BRICKR: "Áo Nổi Loạn",
  TXT_AVATAR_MALE_TOP_COS_HOODSHIRT_BLACK: "Áo Thể thao (Nam)",
  TXT_AVATAR_MALE_TOP_COS_MOB_DGREEN: "Áo Đầu lâu",
  TXT_AVATAR_MALE_TOP_COS_OUTDOOR_GREY: "Áo rừng sâu",
  TXT_AVATAR_MALE_TSHIRT_MARIO: "Áo Thợ ống nước (Nam)",
  TXT_AVATAR_OB10_LZW_FEMALE_TOP_COS_SPONSOR: "Áo khoác da Tay đua (Nữ)",
  TXT_AVATAR_OB10_LZW_MALE_HAIR_COS_CLOWN: "Mặt nạ Chú hề ma quái",
  TXT_AVATAR_OB10_LZW_MALE_TOP_COS_SPONSOR: "Áo khoác da Tay đua (Nam)",
  TXT_AVATAR_OB10_LZW_TOP_SLEEVELESS: "Áo khoác cộc",
  TXT_AVATAR_OB11_LZW_COS_NYARUKO: "Bạch tuộc Baby",
  TXT_AVATAR_OB11_LZW_MALE_ACCESSORY_COS_ZOMBIE: "Mặt nạ Quỷ kiếm dạ xoa",
  TXT_AVATAR_OB11_LZW_MALE_TOP_COS_PINK_JAZZ: "6 múi Phong cách Gangster",
  "TXT_AVATAR_OB7_LZW_FEMALE_A-SKIRT_BLACK": "Bao bọc",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_CNY_RED_OBT7TH: "Quần Victoria (2018)",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "Quần Thám hiểm lỗi lạc (Nữ)",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_JAPANESESTYLE_PINK: "Quần Kitsune",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_COS_JAPANESESTYLE_PINK: "Guốc Kitsune",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_SPORTS_08: "Giày thể thao (Hồng)",
  TXT_AVATAR_OB7_LZW_FEMALE_SHORTPANTS_FLAP_BLUE: "Quần lửng (Nữ)",
  TXT_AVATAR_OB7_LZW_FEMALE_TOP_COS_JAPANESESTYLE_PINK: "Áo kitsune",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_BATTLE_BROWN: "Quần Combat (Nam)",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "Quần Thám hiểm lỗi lạc (Nam)",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_JAPANESESTYLE_PURPLE: "Quần Bushido",
  TXT_AVATAR_OB7_LZW_MALE_HOODIE_ZIPPER_GREY: "Zipper xám",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_CASUAL: "Giày thường",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_JAPANESESTYLE_PURPLE: "Guốc Bushido",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_TECHWEAR_OBT7TH: "Giày Siêu Hacker (Nam)",
  TXT_AVATAR_OB7_LZW_MALE_SHORTPANTS_FLAP_BLUE: "Quần Denim",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_BATTLE_BROWN: "Áo Combat (Nam)",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_CASUAL: "Áo dạ tiệc",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_JAPANESESTYLE_PURPLE: "Áo Bushido",
  TXT_AVATAR_OB8_LZW_BALLPANTS_WHITE: "Ánh sáng",
  TXT_AVATAR_OB8_LZW_FEMALE_BOTTOM_COS_BASEBALL_GREEN: "Quần Bóng chày (Nữ)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_ASUS_JACKET: "Áo khoác da Biker (nữ)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_COS_BASEBALL_GREEN: "Áo Bóng chày (Nữ)",
  TXT_AVATAR_OB8_LZW_MALE_BOTTOM_COS_BASEBALL_YELLOW: "Quần Bóng chày (Nam)",
  "TXT_AVATAR_OB8_LZW_MALE_HAIR_COS_HIP-HOP": "Đường phố (Đầu)",
  TXT_AVATAR_OB8_LZW_MALE_SHOE_COS_BASEBALL_YELLOW: "Giày Bóng chày (Nam)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_ASUS_JACKET: "Áo khoác da Biker (Nam)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_BASEBALL_YELLOW: "Áo Bóng chày (Nam)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_DINOSAUR_GREEN: "Khủng long",
  TXT_AVATAR_OB8_LZW_SHOE_SOCCER_SILVER: "Giày bạc",
  TXT_AVATAR_OB8_LZW_TSHIRT_ENGLAND_B: "Anh",
  TXT_AVATAR_OB9_LZW_MALE_ACCESSORY_COS_TUXEDO: "Mặt nạ Tuxedo",
  TXT_AVATAR_OB9_LZW_MALE_HAIR_COS_TUXEDO: "Mũ phớt Tuxedo",
  TXT_AVATAR_PARACHUTE_8: "Dù Mặt Cười",
  TXT_AVATAR_SHIRT_PLAID_2: "Sơ-mi lập trình viên (Đỏ)",
  TXT_AVATAR_SHOES_1: "Sneaker (Trắng)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_2: "Áo nữ sinh (Cam)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_3: "Áo nữ sinh (Đỏ)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_4: "Áo nữ sinh (Vàng)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_5: "Áo nữ sinh (Tím)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_6: "Áo nữ sinh (Be)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_7: "Áo nữ sinh (Thủy thủ)",
  TXT_AVATAR_TSHIRT_WEEK_007: "Chủ nhật rực rỡ",
  TXT_BANNER_NAME_MISHA: "Nền Misha",
  TXT_CHARACTER_ADAM_NAME: "Primis",
  TXT_CHARACTER_BODYGUARD_NAME: "Nikita",
  TXT_CHARACTER_COP_NAME: "Andrew",
  TXT_CHARACTER_EVA_NAME: "Nulla",
  TXT_CHARACTER_NURSE_NAME: "Olivia",
  TXT_CHARACTER_RACERGIRL_NAME: "Misha",
  TXT_CHARACTER_RUNNER_NAME: "Kelly",
  TXT_CHARACTER_SEAMAN_NAME: "Ford",
  TXT_CLAN_NAME: "Tên",
  TXT_COLLECTION_DESCRIPTION: "Mô tả",
  TXT_COLLECTION_HEADPORTRAIT: "Ảnh",
  TXT_INVENTORY_TITLE_EQUIPMENT: "Trang bị",
  TXT_ITEM_AK: "AK47",
  TXT_ITEM_ARAMMO: "Đạn Súng trường",
  TXT_ITEM_AWM: "AWM",
  TXT_ITEM_BAG1: "Balo Lv1",
  TXT_ITEM_BAG2: "Balo Lv2",
  TXT_ITEM_BAG3: "Balo Lv3",
  TXT_ITEM_BASEBALLPOLE: "Gậy bóng chày",
  TXT_ITEM_BOWAMMO: "Nỏ",
  TXT_ITEM_CHANGUO: "Chảo",
  TXT_ITEM_CROSSBOW: "Nỏ",
  TXT_ITEM_DESC_FLASH: "Làm choáng kẻ địch trong thời gian ngắn",
  TXT_ITEM_EAGLE: "Desert Eagle",
  TXT_ITEM_FAK: "Túi cứu thương",
  TXT_ITEM_FAMAS: "FAMAS",
  TXT_ITEM_FIST: "Tay",
  TXT_ITEM_FLASH: "Lựu choáng",
  TXT_ITEM_FOREGRIP1: "Tay súng Lv1",
  TXT_ITEM_FOREGRIP2: "Tay súng Lv2",
  TXT_ITEM_FOREGRIP3: "Tay súng Lv3",
  TXT_ITEM_G18: "G18",
  TXT_ITEM_GRENADE: "Lựu đạn",
  TXT_ITEM_GROZA: "GROZA",
  TXT_ITEM_HANDCANNON: "Pháo cầm tay",
  TXT_ITEM_HEATSIGHT: "Ống ngắm nhiệt",
  TXT_ITEM_HELMET1: "Mũ Lv1",
  TXT_ITEM_HELMET2: "Mũ Lv2",
  TXT_ITEM_HELMET3: "Mũ Lv3",
  TXT_ITEM_HGAMMO: "Đạn súng lục",
  TXT_ITEM_KAR98K: "Kar98k",
  TXT_ITEM_LANUNCHERAMMO: "Đạn 40mm",
  TXT_ITEM_M1014: "M1014",
  TXT_ITEM_M14: "M14",
  TXT_ITEM_M1873: "M1873",
  TXT_ITEM_M249: "M249",
  TXT_ITEM_M4A1: "M4A1",
  TXT_ITEM_M500: "M500",
  TXT_ITEM_M79: "M79",
  TXT_ITEM_MACHETE: "Dao",
  TXT_ITEM_MAGEZINE1: "Băng đạn Lv1",
  TXT_ITEM_MAGEZINE2: "Băng đạn Lv2",
  TXT_ITEM_MAGEZINE3: "Băng đạn Lv3",
  TXT_ITEM_MP40: "MP40",
  TXT_ITEM_MP5: "MP5",
  TXT_ITEM_MUZZLE1: "Nòng Lv1",
  TXT_ITEM_MUZZLE2: "Nòng Lv2",
  TXT_ITEM_MUZZLE3: "Nòng Lv3",
  TXT_ITEM_SCAR: "SCAR",
  TXT_ITEM_SGAMMO: "Đạn Shotgun",
  TXT_ITEM_SIGHT2: "Ống ngắm 2x",
  TXT_ITEM_SIGHT4: "Ống ngắm 4x",
  TXT_ITEM_SILENCER1: "Giảm thanh",
  TXT_ITEM_SKS: "SKS",
  TXT_ITEM_SMGAMMO: "Đạn súng tiểu liên",
  TXT_ITEM_SNAMMO: "Đạn súng ngắm",
  TXT_ITEM_SPAS12: "SPAS12",
  TXT_ITEM_SVD: "SVD",
  TXT_ITEM_UMP: "UMP",
  TXT_ITEM_USP: "USP",
  TXT_ITEM_VEST1: "Giáp Lv1",
  TXT_ITEM_VEST2: "Giáp Lv2",
  TXT_ITEM_VEST3: "Giáp Lv3",
  TXT_ITEM_VSS: "VSS",
  TXT_ITEM_XM8: "XM8",
  TXT_MATCHRESULT_TITLE: "Kết quả",
  TXT_MESSAGEBOX_ERROR: "Lỗi",
  TXT_OB10_HQW_ITEM_BIPOD: "Giá đỡ súng",
  TXT_OB10_HQW_ITEM_M60: "M60",
  TXT_OB10_JRW_CAMOUFLAGE_OILDRUM_NAME: "Thùng dầu",
  TXT_OB10_JRW_CHARACTER_BRAZILSOLDIER_NAME: "Miguel",
  TXT_OB10_JRW_SKILL_NAME_BRAZILSOLDIER: "Kẻ cuồng sát",
  TXT_OB10_ZXR_BASEBALLBAT_CORN_NAME: "Gậy Bắp nướng Mexico",
  TXT_OB10_ZXR_GRENADESKIN_RANGE: "Vùng sát thương",
  TXT_OB10_ZXR_MACHETE_RANKMASTER_NAME: "Đao Kẻ Hành Quyết",
  TXT_OB11_HQW_ITEM_MGL140: "MGL140",
  TXT_OB11_HQW_ITEM_P90: "P90",
  TXT_OB11_HQW_LANDMINE: "Mìn",
  TXT_OB11_HQW_LANDMINE_DESC: "Mìn có thể chôn dưới đất. Chú ý đừng tự dẫm phải!",
  TXT_OB11_JRW_CHARACTER_RICHGIRL_NAME: "Caroline",
  TXT_OB11_JRW_EMOTE_CLAP_NAME: "Vỗ tay",
  TXT_OB11_JRW_EMOTE_DAB_NAME: "Dab",
  TXT_OB11_JRW_EMOTE_FUNKYCHICKEN_NAME: "Gà!",
  TXT_OB11_JRW_EMOTE_HELLO_NAME: "Xin chào!",
  TXT_OB11_JRW_EMOTE_LOL_NAME: "LOL",
  TXT_OB11_JRW_EMOTE_PROVOKE_NAME: "Khiêu khích",
  TXT_OB11_JRW_SKILL_DESC_RICHGIRL: "Khi cầm shotgun, tốc độ chạy tăng [FFB300]{0}%[-].",
  TXT_OB11_JRW_SKILL_NAME_RICHGIRL: "Dẻo dai",
  TXT_OB11_ZXR_SCAR_CHEETAH_NAME: "SCAR Báo đốm",
  TXT_OB11_ZXR_SCAR_TOPGAMER_NAME: "SCAR Game thủ",
  TXT_OB16_Q_ITEM_ARMORREPAIR: "Bộ sửa chữa",
  TXT_OB5_HISTORY_HEADSHOOT: "Headshot",
  TXT_OB5_HISTORY_LIVE: "Sống sót",
  TXT_OB7_JRW_CHARACTER_FOODIEBOY_NAME: "Maxim",
  TXT_OB7_JRW_SKILL_DESC_FOODIEBOY: "Giảm thời gian ăn nấm và sử dụng hộp cứu thương [FFB300]{0}%[-].",
  TXT_OB7_JRW_SKILL_NAME_FOODIEBOY: "Ham ăn",
  TXT_OB7_ZC_CLAN_NICKNAME: "Tên",
  TXT_OB7_ZJS_HISTORY_TIME: "Thời gian",
  TXT_OB8_HQW_NEWLOADOUT_BONFIRE: "Lửa trại",
  TXT_OB8_JYF_PARACHUTE_THUNDER_NAME: "Dù Thiên Lôi",
  TXT_OB8_SQ_CHARACTER_THAIBOXER_NAME: "Kla",
  TXT_OB8_SQ_SKILL_DESC_THAIBOXER: "Sát thương tay tăng [FFB300]{0}%[-]",
  TXT_OB8_SQ_SKILL_NAME_THAIBOXER: "Muay Thai",
  TXT_OB8_ZXR_AWM_CAMO_NAME: "AWM Rằn ri",
  TXT_OB8_ZXR_G18_CAMO_NAME: "G18 Rằn ri",
  TXT_OB8_ZXR_M249_CAMO_NAME: "M249 Rằn ri",
  TXT_OB8_ZXR_M79_CAMO_NAME: "M79 Rằn ri",
  TXT_OB8_ZXR_USP_CAMO_NAME: "USP Rằn ri",
  TXT_OB9_JRW_CHARACTER_ARMSDEALER_NAME: "Paloma",
  TXT_OB9_JRW_SKILL_NAME_ARMSDEALER: "Trùm vũ khí",
  TXT_OB9_JYF_SKYBOARD_BOOYAH_NAME: "Ván Chiến Thắng",
  TXT_OB9_SQ_ITEM_GLOOSHIELD: "Bom keo",
  TXT_OB9_ZXR_AK47_DIGI_CAMO_NAME: "AK47 Rằn ri 2.0",
  TXT_OB9_ZXR_FAMAS_RED_NAME: "FAMAS Nhuốm máu",
  TXT_OB9_ZXR_G18_CAMO_02_NAME: "G18 Rằn ri",
  TXT_OB9_ZXR_GROZA_CAMO_NAME: "GROZA Rằn ri",
  TXT_OB9_ZXR_M1014_CAMO_02_NAME: "M1014 Lễ hội tím",
  TXT_OB9_ZXR_M14_CAMO_NAME: "M14 Rằn ri",
  TXT_OB9_ZXR_M1873_NAME: "M1873 Rằn ri",
  TXT_OB9_ZXR_MACHETE_FISH_NAME: "Đao Cá Kiếm",
  TXT_OB9_ZXR_MP5_CAMO_NAME: "MP5 Rằn ri",
  TXT_OB9_ZXR_SCAR_CAMO_BLUE_NAME: "SCAR Thạch anh tím",
  TXT_OB9_ZXR_SKS_CAMO_NAME: "SKS Rằn ri",
  TXT_OPTION_HIGH_BRIGHTNESS: "Sáng",
  TXT_PLAYER_RANK: "Xếp Hạng",
  TXT_ROOM_LOBBY_ID: "ID",
  TXT_ROOM_MAP_PARADISE: "Đảo Quân Sự",
  TXT_SETTING_CHANGEWEAPON: "Nút đổi vũ khí nhanh",
  TXT_SETTING_OB4_NOTREAL: "Bật",
  TXT_SKILL_DESC_COP: "Giảm hỏng giáp [FFB300]{0}%[-].",
  TXT_SKILL_DESC_RUNNER: "Tốc độ chạy khi chạy nhanh tăng [FFB300]{0}%[-].",
  TXT_SKILL_NAME_COP: "Siêu áo giáp",
  TXT_SKILL_NAME_NURSE: "Hồi phục",
  TXT_SKILL_NAME_RACERGIRL: "Bùng nổ",
  TXT_SKILL_NAME_RUNNER: "Vận động viên điền kinh",
  TXT_SKILL_NAME_SEAMAN: "Sắt đá",
  TXT_TUTORIAL_HUD: "GIAO DIỆN",
  TXT_TUTORIAL_HUD_LABEL10: "Chạy nhanh",
  TXT_TUTORIAL_PICKUP_LABEL0: "Vũ khí",
  T_34_M_WS_VFXTYPE: "Loại hiệu ứng VFX",
  T_40_XXJ_WS_MONSTERATTACKTARGETTYPE_NAMEKEY: "Mục tiêu tấn công",
  T_40_XXJ_WS_PLAYERUISWITCHTYPE_NAMEKEY: "Loại giao diện người chơi",
  T_41_XXJ_WS_MONSTERSKILLTYPE: "Loại kỹ năng quái vật",
  T_45_META_WS_DESCRIPTIVECOLOR: "Màu Mô tả",
  T_45_META_WS_GAMETIME: "Thời gian trận đấu",
  T_45_META_WS_PROPERTY: "Tài sản",
  T_45_XXJ_WS_UISOCIALBUTTONSTYLETYPE: "Loại kiểu nút",
  T_45_XXJ_WS_UISOCIALBUTTONTYPE: "Loại nút",
  T_46_META_WS_A_A: "A",
  T_46_META_WS_A_ACCELERATION: "Gia tốc",
  T_46_META_WS_A_ACCOUNTID: "ID tài khoản",
  T_46_META_WS_A_ACTIONTYPE: "Kiểu hành động",
  T_46_META_WS_A_ACTIVE: "Kích hoạt",
  T_46_META_WS_A_ANGLE: "Góc",
  T_46_META_WS_A_ANY: "Bất kỳ",
  T_46_META_WS_A_APPEARANCEGROUP: "Vị trí mục tiêu",
  T_46_META_WS_A_ASSERTIONEXPRESSION: "Biểu thức xác nhận",
  T_46_META_WS_A_ATTACHMENT: "Phụ kiện",
  T_46_META_WS_A_ATTACHMENTS: "Danh sách phụ kiện",
  T_46_META_WS_A_ATTACKABLE: "Có thể tấn công",
  T_46_META_WS_A_ATTACKER: "Kẻ tấn công",
  T_46_META_WS_A_ATTACKTARGET: "Mục tiêu tấn công",
  T_46_META_WS_A_AUTOPLAY: "Tự động phát",
  T_46_META_WS_A_AXIS: "Trục",
  T_46_META_WS_A_B: "B",
  T_46_META_WS_A_BASE: "Cơ số",
  T_46_META_WS_A_BOUNDTARGET: "Mục tiêu liên kết",
  T_46_META_WS_A_BTREE: "Cây hành vi",
  T_46_META_WS_A_BUFF: "Buff",
  T_46_META_WS_A_CAMERA: "Camera",
  T_46_META_WS_A_CAPICITY: "Dung lượng",
  T_46_META_WS_A_CENTER: "Trung tâm",
  T_46_META_WS_A_CHANGEROTATION: "Đổi góc xoay",
  T_46_META_WS_A_CHANNEL: "Kênh",
  T_46_META_WS_A_CHASEENEMY: "Kẻ địch truy đuổi",
  T_46_META_WS_A_CHILD: "Nút con",
  T_46_META_WS_A_COLOR: "Màu",
  T_46_META_WS_A_COLUMN: "Số cột",
  T_46_META_WS_A_COLUMNNAME: "Tên cột",
  T_46_META_WS_A_COMEBACK: "Chế độ tuần tra",
  T_46_META_WS_A_COMPONENT: "Thành phần",
  T_46_META_WS_A_CONTENT: "Nội dung",
  T_46_META_WS_A_COORDINATESYSTEM: "Hệ tọa độ",
  T_46_META_WS_A_COUNT: "Số lượng",
  T_46_META_WS_A_COUNTS: "Danh sách số lượng vật phẩm rơi",
  T_46_META_WS_A_CREATEDENTITY: "Thực thể được tạo",
  T_46_META_WS_A_CROSSPLATFORM: "Đa nền tảng",
  T_46_META_WS_A_CULLINGMASK: "Mặt nạ lớp",
  T_46_META_WS_A_CURVE: "Đường cong",
  T_46_META_WS_A_CUSTOMTAG: "Nhãn tùy chỉnh",
  T_46_META_WS_A_CUTRADIUS: "Bán kính cắt",
  T_46_META_WS_A_DAMAGE: "Lượng sát thương",
  T_46_META_WS_A_DAMAGESEGMENTS: "Phân đoạn sát thương",
  T_46_META_WS_A_DEGREE: "Góc",
  T_46_META_WS_A_DELTA: "Chênh lệch",
  T_46_META_WS_A_DEPTH: "Chiều sâu",
  T_46_META_WS_A_DESTVAL: "Giá trị mục tiêu",
  T_46_META_WS_A_DIFFICULTY: "Độ khó",
  T_46_META_WS_A_DIRECTION: "Hướng",
  T_46_META_WS_A_DISABLE: "Có tắt không",
  T_46_META_WS_A_DISPLACEMENT: "Chuyển dịch",
  T_46_META_WS_A_DISTANCE: "Khoảng cách",
  T_46_META_WS_A_DIVINGMAXSPEED: "Tốc độ tối đa khi rơi tự do",
  T_46_META_WS_A_DOTWEEN: "Thực hiện hoạt ảnh tween",
  T_46_META_WS_A_DURATION: "Thời gian duy trì (s)",
  T_46_META_WS_A_EMOTE: "Loại hành động",
  T_46_META_WS_A_ENABLE: "Bật",
  T_46_META_WS_A_ENDAREACENTER: "Trung tâm bo cuối",
  T_46_META_WS_A_ENDAREARANGE: "Phạm vi bo cuối",
  T_46_META_WS_A_ENDPOSITION: "Vị trí cuối",
  T_46_META_WS_A_ENDRANK: "Thứ hạng kết thúc",
  T_46_META_WS_A_EQUIPMENTS: "Trang bị",
  T_46_META_WS_A_EVENTID: "ID sự kiện tùy chỉnh",
  T_46_META_WS_A_EXPONENT: "Chỉ số",
  T_46_META_WS_A_FACTION: "Phe",
  T_46_META_WS_A_FACTORTYPE: "Loại phe",
  T_46_META_WS_A_FILTERTYPE: "Loại bộ lọc",
  T_46_META_WS_A_FINALRADIUS: "Bán kính cuối cùng",
  T_46_META_WS_A_FINDVALUE: "Chuỗi cần tìm",
  T_46_META_WS_A_FIXEDRANGE: "Khu vực cố định",
  T_46_META_WS_A_FOLLOWTARGET: "Theo dõi đối tượng",
  T_46_META_WS_A_FONTCOLOR: "Màu chữ",
  T_46_META_WS_A_FONTSIZE: "Kích thước chữ",
  T_46_META_WS_A_FOOTBALL: "Bóng đá",
  T_46_META_WS_A_FORCE: "Lực",
  T_46_META_WS_A_FORCEDPARACHUTEHEIGHT: "Độ cao mở dù bắt buộc",
  T_46_META_WS_A_FORCEMODE: "Loại lực",
  T_46_META_WS_A_FORWARD: "Hướng",
  T_46_META_WS_A_G: "G",
  T_46_META_WS_A_GAMEID: "ID Nhiệm vụ",
  T_46_META_WS_A_HALFEXTENTS: "Nửa kích thước",
  T_46_META_WS_A_HEIGHT: "Chiều cao",
  T_46_META_WS_A_HEIGHTSEGMENTS: "Phân đoạn chiều cao",
  T_46_META_WS_A_HITDISTANCE: "Khoảng cách trúng",
  T_46_META_WS_A_HITDISTANCES: "Khoảng cách trúng",
  T_46_META_WS_A_HITENTITIES: "Trúng Thực thể",
  T_46_META_WS_A_HITENTITY: "Trúng Thực thể",
  T_46_META_WS_A_HITNORMAL: "Pháp tuyến bề mặt điểm trúng",
  T_46_META_WS_A_HITNORMALS: "Pháp tuyến bề mặt điểm trúng",
  T_46_META_WS_A_HITPOINTS: "Điểm trúng",
  T_46_META_WS_A_HITPOSITION: "Vị trí trúng",
  T_46_META_WS_A_INCLUDETRIGGER: "Bao gồm trình kích hoạt",
  T_46_META_WS_A_INDEX: "Chỉ mục",
  T_46_META_WS_A_INDEXS: "Danh sách chỉ mục",
  T_46_META_WS_A_INITIALVELOCITY: "Tốc độ ban đầu",
  T_46_META_WS_A_INITRADIUS: "Bán kính ban đầu",
  T_46_META_WS_A_INWALLET: "Chuyển vào ví",
  T_46_META_WS_A_ISBOTTOMCOLLIDING: "Có chạm đáy không",
  T_46_META_WS_A_ISEXIST: "Có tồn tại không",
  T_46_META_WS_A_ISLOOP: "Có lặp lại không",
  T_46_META_WS_A_ISMAPPEDINSCREEN: "Có hiển thị trên màn hình không",
  T_46_META_WS_A_ISPAUSE: "Tạm dừng",
  T_46_META_WS_A_ISSIDECOLLIDING: "Có chạm vào bên cạnh không",
  T_46_META_WS_A_ISSUCCESS: "Có thành công không",
  T_46_META_WS_A_ISTOPCOLLIDING: "Có chạm vào đỉnh không",
  T_46_META_WS_A_ITEM: "Vật phẩm",
  T_46_META_WS_A_ITEMID: "ID Vật phẩm",
  T_46_META_WS_A_ITEMS: "Danh sách ID vật phẩm",
  T_46_META_WS_A_ITEMTYPE: "Kiểu vật phẩm",
  T_46_META_WS_A_JERSEYTYPE: "Kiểu quần áo",
  T_46_META_WS_A_KEEPVELOCITY: "Giữ tốc độ",
  T_46_META_WS_A_KEY: "Khóa",
  T_46_META_WS_A_KEYCOLUMN: "Cột khóa",
  T_46_META_WS_A_KEYS: "Danh sách tên trường",
  T_46_META_WS_A_LAYER: "Layer",
  T_46_META_WS_A_LAYERMASK: "Layer mask",
  T_46_META_WS_A_LEFT: "Trái",
  T_46_META_WS_A_LEFTVALUE: "Giá trị trái",
  T_46_META_WS_A_LENGTH: "Chiều dài",
  T_46_META_WS_A_LEVELOBJECT: "Cấp độ vật thể",
  T_46_META_WS_A_LOG: "Nhật ký",
  T_46_META_WS_A_LOOKATTARGET: "Chú ý mục tiêu",
  T_46_META_WS_A_LOOPTYPE: "Loại vòng lặp",
  T_46_META_WS_A_MAINCOLOR1: "Màu chủ đạo 1",
  T_46_META_WS_A_MAINCOLOR2: "Màu chủ đạo 2",
  T_46_META_WS_A_MAPCODE: "Mã bản đồ",
  T_46_META_WS_A_MAPPEDPOSITION: "Vị trí phản chiếu",
  T_46_META_WS_A_MAX: "Giá trị tối đa",
  T_46_META_WS_A_MAXDISPLACEMENT: "Độ dịch chuyển tối đa",
  T_46_META_WS_A_MAXDISTANCE: "Khoảng cách dò tìm",
  T_46_META_WS_A_MIN: "Giá trị nhỏ nhất",
  T_46_META_WS_A_MISSIONID: "MissionID",
  T_46_META_WS_A_MISSIONPROGRESS: "Tiến độ nhiệm vụ",
  T_46_META_WS_A_MODIFYTYPE: "Kiểu sửa đổi",
  T_46_META_WS_A_MONEYTYPE: "Loại tiền tệ",
  T_46_META_WS_A_MUST: "Phải bao gồm",
  T_46_META_WS_A_NAME: "Tên",
  T_46_META_WS_A_NEWVALUE: "Giá trị mới",
  T_46_META_WS_A_NODE: "Nút",
  T_46_META_WS_A_NORMAL: "Hướng mặc định",
  T_46_META_WS_A_NOT: "Không bao gồm",
  T_46_META_WS_A_OBSERVER: "Người quan sát",
  T_46_META_WS_A_OFFSET: "Độ lệch",
  T_46_META_WS_A_OLDVALUE: "Giá trị cũ",
  T_46_META_WS_A_OPERATIOMETHOD: "Phương thức tính toán",
  T_46_META_WS_A_OPTIONS: "Tùy chọn",
  T_46_META_WS_A_OTHERCOLOR: "Phối màu",
  T_46_META_WS_A_OUTFIT: "Trang phục",
  T_46_META_WS_A_OUTFITS: "Danh sách trang phục",
  T_46_META_WS_A_OUTWALLET: "Ví chuyển ra",
  T_46_META_WS_A_OWNER: "Người sở hữu",
  T_46_META_WS_A_PARACHUTINGMAXSPEED: "Tốc độ tối đa khi mở dù",
  T_46_META_WS_A_PARAMS: "Danh sách tham số",
  T_46_META_WS_A_PARENT: "Nút cha",
  T_46_META_WS_A_PARENTWIDGET: "Thành phần cha",
  T_46_META_WS_A_PATH: "Đường dẫn",
  T_46_META_WS_A_PATHPOINTS: "Điểm tìm đường",
  T_46_META_WS_A_PHASEINDEX: "Chỉ mục giai đoạn",
  T_46_META_WS_A_PLATFORM: "Nền tảng",
  T_46_META_WS_A_PLAYER: "Người chơi",
  T_46_META_WS_A_PLAYSPEED: "Tốc độ phát",
  T_46_META_WS_A_POSITION: "Vị trí",
  T_46_META_WS_A_POSITIONS: "Thiết lập điểm mục tiêu",
  T_46_META_WS_A_POSTION: "Vị trí",
  T_46_META_WS_A_PREFAB: "ID Prefab",
  T_46_META_WS_A_PROPERTY: "Tài nguyên",
  T_46_META_WS_A_PROPERTYID: "ID Tài nguyên",
  T_46_META_WS_A_PURSUITTARGET: "Mục tiêu truy đuổi",
  T_46_META_WS_A_R: "R",
  T_46_META_WS_A_RADIUS: "Bán kính",
  T_46_META_WS_A_RANDOMDECAY: "Hệ số suy giảm ngẫu nhiên",
  T_46_META_WS_A_RANDOMRANGE: "Phạm vi ngẫu nhiên",
  T_46_META_WS_A_RANDOMRATIO: "Hệ số ngẫu nhiên",
  T_46_META_WS_A_RANGE: "Phạm vi",
  T_46_META_WS_A_RANK: "Xếp hạng",
  T_46_META_WS_A_REALCOIN: "Tiền thật",
  T_46_META_WS_A_REALNUMBER: "Số thực",
  T_46_META_WS_A_RESET: "Đặt lại",
  T_46_META_WS_A_RESOURCE: "Tài nguyên",
  T_46_META_WS_A_RESULT: "Kết quả",
  T_46_META_WS_A_RIGHT: "Giá trị phải",
  T_46_META_WS_A_RIGHTVALUE: "Danh sách",
  T_46_META_WS_A_ROTATION: "Góc quay",
  T_46_META_WS_A_ROW: "Hàng",
  T_46_META_WS_A_SAMPLEPOINT: "Điểm lấy mẫu",
  T_46_META_WS_A_SCALE: "Thu phóng",
  T_46_META_WS_A_SCENEID: "ID cảnh",
  T_46_META_WS_A_SCORE: "Điểm số",
  T_46_META_WS_A_SCORENAME: "Tên Điểm số",
  T_46_META_WS_A_SCREENPOSITION: "Tọa độ màn hình",
  T_46_META_WS_A_SCRIPT: "ID tập lệnh",
  T_46_META_WS_A_SEAT: "Chỗ ngồi",
  T_46_META_WS_A_SEP: "Ký hiệu phân cách",
  T_46_META_WS_A_SEPSTR: "Dấu phân cách",
  T_46_META_WS_A_SHEETNAME: "Tên bảng",
  T_46_META_WS_A_SHOPITEM: "Vật phẩm trong cửa hàng",
  T_46_META_WS_A_SHOWBACKGROUND: "Hiển thị nền",
  T_46_META_WS_A_SHOWMATCHRESULT: "Hiển thị thông tin tổng kết trận",
  T_46_META_WS_A_SHOWMESSAGEWHENCANCEL: "Hiển thị cửa sổ xác nhận khi hủy",
  T_46_META_WS_A_SKILL: "Kỹ năng",
  T_46_META_WS_A_SKILLS: "Danh sách kỹ năng",
  T_46_META_WS_A_SKILLTARGET: "Mục tiêu kỹ năng",
  T_46_META_WS_A_SKIN: "Ngoại trang Balo",
  T_46_META_WS_A_SLOT: "Vị trí",
  T_46_META_WS_A_SRCVAL: "Giá trị khởi đầu",
  T_46_META_WS_A_SRCVALUE: "Giá trị khởi đầu",
  T_46_META_WS_A_STARTAREACENTER: "Trung tâm khu vực khởi đầu",
  T_46_META_WS_A_STARTAREARANGE: "Phạm vi khu vực khởi đầu",
  T_46_META_WS_A_STARTINDEX: "Chỉ mục vị trí bắt đầu",
  T_46_META_WS_A_STARTPOSITION: "Điểm bắt đầu",
  T_46_META_WS_A_STARTRANK: "Thứ hạng ban đầu",
  T_46_META_WS_A_STATE: "Trạng thái hoạt ảnh",
  T_46_META_WS_A_STATUS: "Trạng thái",
  T_46_META_WS_A_STATUSCODE: "Mã trạng thái",
  T_46_META_WS_A_STYLE: "Phong cách",
  T_46_META_WS_A_SURFINGMAXSPEED: "Tốc độ tối đa khi lướt",
  T_46_META_WS_A_TARGET: "Mục tiêu",
  T_46_META_WS_A_TARGETPOSITION: "Vị trí mục tiêu",
  T_46_META_WS_A_TEAMSEQ: "Đội ngũ",
  T_46_META_WS_A_THRESHOLD: "Ngưỡng",
  T_46_META_WS_A_TIMESTAMP: "Dấu thời gian",
  T_46_META_WS_A_TIPS: "Lời khuyên",
  T_46_META_WS_A_TITLE: "Tiêu đề",
  T_46_META_WS_A_TOKENCOUNT: "Số lượng Token",
  T_46_META_WS_A_TOKENID: "ID Token",
  T_46_META_WS_A_TORQUE: "Lực mô-men",
  T_46_META_WS_A_TOUCHPOINT: "Điểm tiếp xúc",
  T_46_META_WS_A_TRANSITIONTIME: "Thời gian chuyển đổi (ms)",
  T_46_META_WS_A_TRANSITIONTYPE: "Cách thức chuyển đổi",
  T_46_META_WS_A_TRIGGER: "Trigger",
  T_46_META_WS_A_TYPE: "Kiểu",
  T_46_META_WS_A_UI: "HUD",
  T_46_META_WS_A_UIID: "ID của HUD",
  T_46_META_WS_A_UPWARD: "Hướng phía trên",
  T_46_META_WS_A_VALUE: "Giá trị",
  T_46_META_WS_A_VALUEA: "Giá trị trái",
  T_46_META_WS_A_VALUEB: "Giá trị phải",
  T_46_META_WS_A_VALUES: "Danh sách giá trị",
  T_46_META_WS_A_VALUET: "Nội suy",
  T_46_META_WS_A_VALUETYPE: "Kiểu giá trị",
  T_46_META_WS_A_VEHICLE: "Phương tiện",
  T_46_META_WS_A_VEHICLESKIN: "Skin phương tiện",
  T_46_META_WS_A_VELOCITY: "Tốc độ",
  T_46_META_WS_A_VELOCITYXZ: "Vectơ XZ",
  T_46_META_WS_A_VELOCITYY: "Vectơ Y",
  T_46_META_WS_A_VISIBLE: "Có thể thấy",
  T_46_META_WS_A_WAITTIME: "Thời gian chờ (s)",
  T_46_META_WS_A_WALLET: "Ví tiền",
  T_46_META_WS_A_WEAPON: "Vũ khí",
  T_46_META_WS_A_WEAPONSKIN: "Skin súng",
  T_46_META_WS_A_WIDGETID: "ID Widget",
  T_46_META_WS_A_WIDGETTYPE: "Kiểu Widget",
  T_46_META_WS_A_WIDTH: "Chiều rộng",
  T_46_META_WS_A_WORLDPOSITION: "Tọa độ thế giới",
  T_46_META_WS_A_WORLDPOSITIONSTAYS: "Giữ nguyên tọa thế giới",
  T_46_META_WS_A_X: "X",
  T_46_META_WS_A_Y: "Y",
  T_46_META_WS_ABS: "Giá trị tuyệt đối",
  T_46_META_WS_ACOS: "Acos",
  T_46_META_WS_ADDAOISPECIALFOLLOW: "Thêm AOI theo dõi đặc biệt",
  T_46_META_WS_ADDATTACHMENTS: "Thêm phụ kiện",
  T_46_META_WS_ADDBUFF: "Thêm buff",
  T_46_META_WS_ADDCOMPONENT: "Thêm thành phần",
  T_46_META_WS_ADDFOOTBALLVELOCITY: "Tăng tốc cho bóng",
  T_46_META_WS_ADDFORCE: "Tác động lực",
  T_46_META_WS_ADDFORCEATPOSITION: "Tác động lực tại điểm",
  T_46_META_WS_ADDFORMULAPROPERTYFACTOR: "Thêm yếu tố thuộc tính công thức ",
  T_46_META_WS_ADDGAMEEVENTLOG: "Thêm nhật ký sự kiện game",
  T_46_META_WS_ADDHP: "Hồi máu",
  T_46_META_WS_ADDITEM: "Thêm vật phẩm",
  T_46_META_WS_ADDITEMINSCENE: "Tạo vật phẩm trong trường cảnh",
  T_46_META_WS_ADDITEMTOSHOPITEM: "Thêm vật phẩm vào cửa hàng",
  T_46_META_WS_ADDMONEY: "Thêm tiền tệ",
  T_46_META_WS_ADDSCRIPT: "Thêm tập lệnh",
  T_46_META_WS_ADDTAG: "Thêm nhãn",
  T_46_META_WS_ADDTOKEN: "Thêm Token",
  T_46_META_WS_ADDTORQUE: "Thêm mô-men",
  T_46_META_WS_ADDUSEREVENTLOG: "Thêm nhật ký người dùng",
  T_46_META_WS_ANGEL: "Góc hai vector",
  T_46_META_WS_APPEND: "Nối phần tử danh sách",
  T_46_META_WS_APPENDRANGE: "Nối danh sách",
  T_46_META_WS_APPLYQUITMIDWAYUICONFIG: "Cấu hình giao diện thoát giữa trận",
  T_46_META_WS_ASIN: "ASin",
  T_46_META_WS_ASSERT: "Gửi kết quả xác nhận",
  T_46_META_WS_ASSISTPLAYER: "Hỗ trợ người chơi",
  T_46_META_WS_ATAN2: "ATan2",
  T_46_META_WS_ATTACKER: "Kẻ tấn công",
  T_46_META_WS_ATTACKTARGET: "Mục tiêu tấn công",
  T_46_META_WS_AXISANGLETOQUATERNION: "Chuyển đổi Góc trục sang Quaternion",
  T_46_META_WS_BOXCAST: "Quét hộp",
  T_46_META_WS_BOXOVERLAP: "Phát hiện hộp chồng lấp",
  T_46_META_WS_BUTTONNAME: "Tên nút",
  T_46_META_WS_C_ACTIONTYPE: "Kiểu hành động",
  T_46_META_WS_C_AIMABLE: "Thành phần có thể bị ngắm",
  T_46_META_WS_C_AIMASSISTABLE: "Có hỗ trợ ghim tâm",
  T_46_META_WS_C_AIMASSISTTYPE: "Kiểu hỗ trợ ghim tâm",
  T_46_META_WS_C_AIRDROP: "Thính",
  T_46_META_WS_C_AMMO: "Đạn",
  T_46_META_WS_C_AMMOTYPE: "Kiểu đạn",
  T_46_META_WS_C_AMPHIBIAN: "Xe đa năng",
  T_46_META_WS_C_ANIMATIONCLIP: "Clip hoạt ảnh",
  T_46_META_WS_C_ANIMATIONCLIPID: "ID Clip hoạt ảnh",
  T_46_META_WS_C_ANIMATIONCONTROLLER: "Bộ điều khiển hoạt ảnh",
  T_46_META_WS_C_ANIMATIONCONTROLLERATTACHABLE: "Bộ điều khiển hoạt ảnh có thể đính kèm",
  T_46_META_WS_C_ANIMATIONCONTROLLERID: "ID bộ điều khiển hoạt ảnh",
  T_46_META_WS_C_ANIMATIONSTATE: "Trạng thái hoạt ảnh",
  T_46_META_WS_C_ANIMATIONTRIGGER: "Bộ kích hoạt hoạt ảnh",
  T_46_META_WS_C_APPEARENCE: "Thành phần thay đổi trang phục",
  T_46_META_WS_C_ASSETCONFIGID: "ID cấu hình tài sản",
  T_46_META_WS_C_ASSETID: "ID tài sản",
  T_46_META_WS_C_ATTACHMENT: "Phụ kiện",
  T_46_META_WS_C_ATTACKABLETYPE: "Kiểu mục tiêu có thể tấn công",
  T_46_META_WS_C_AUDIOID: "ID Âm thanh",
  T_46_META_WS_C_BACKPACK: "Thành phần Balo",
  T_46_META_WS_C_BACKPACKSKINID: "ID Skin Balo",
  T_46_META_WS_C_BASEDATAALIAS: "Biệt danh dữ liệu cơ bản",
  T_46_META_WS_C_BASICAPPEARANCE: "Ngoại hình cơ bản",
  T_46_META_WS_C_BASICCYLINDER: "Hình nón hoặc hình trụ cơ bản",
  T_46_META_WS_C_BASICSCALABLE: "Khối vuông hoặc dốc cơ bản",
  T_46_META_WS_C_BASICSPHERE: "Hình cầu cơ bản",
  T_46_META_WS_C_BATCHCOMBINERENDER: "Kết xuất hợp nhất",
  T_46_META_WS_C_BEVTREE: "Cây hành vi",
  T_46_META_WS_C_BEVTREEATTACHABLE: "Có thể gắn Thực thể cây hành vi",
  T_46_META_WS_C_BEVTREECUSTOMNODE: "Tùy chỉnh nút cây hành vi",
  T_46_META_WS_C_BEVTREEID: "ID tài sản cây hành vi",
  T_46_META_WS_C_BEVTREENODESTATUS: "Trạng thái hoạt động của nút cây hành vi",
  T_46_META_WS_C_BEVTREENODETYPE: "Loại nút cây hành vi",
  T_46_META_WS_C_BEZIERCURVE: "Đường cong Bézier",
  T_46_META_WS_C_BOOL: "Kiểu Boolean",
  T_46_META_WS_C_BOTDIFFICULTYTYPE: "Kiểu độ khó bot",
  T_46_META_WS_C_BOUNCINGTIRE: "Lốp xe nảy",
  T_46_META_WS_C_BUFFABLE: "Có thể dùng hệ thống FFBuff",
  T_46_META_WS_C_BUFFGENERATOR: "Tạo Buff",
  T_46_META_WS_C_BUFFTYPE: "Loại Buff",
  T_46_META_WS_C_BUILTINRENDER: "Thành phần kết xuất cầu nối",
  T_46_META_WS_C_BUILTINUI: "UI tích hợp",
  T_46_META_WS_C_BUILTINUITYPE: "Kiểu UI tích hợp",
  T_46_META_WS_C_CAMERA: "Máy ảnh",
  T_46_META_WS_C_CAMERABLOCKMODE: "Chế độ che máy ảnh",
  T_46_META_WS_C_CAMERAPROJECTIONMODE: "Chế độ chiếu máy ảnh",
  T_46_META_WS_C_CAMERARAYCASTUI: "Chụp X quang bằng máy ảnh",
  T_46_META_WS_C_CAMERATRANSITIONTYPE: "Kiểu chuyển đổi camera",
  T_46_META_WS_C_CAMERATYPE: "Kiểu góc nhìn camera",
  T_46_META_WS_C_CAMERAVIEWINGANGLERESTRICTIONTYPE: "Kiểu giới hạn góc camera",
  T_46_META_WS_C_CAPSULETRIGGER: "Viên nang Trigger",
  T_46_META_WS_C_CAR: "Thành phần phương tiện",
  T_46_META_WS_C_CHARACTERCONTROLLER: "Điểu khiển nhân vật",
  T_46_META_WS_C_CHATCHANNEL: "Kênh chat",
  T_46_META_WS_C_CHATCHANNELTYPE: "Kiểu kênh chat",
  T_46_META_WS_C_CHECKPOINTTRIGGER: "Thành phần trigger check point",
  T_46_META_WS_C_COINGENERATOR: "Máy tạo xu",
  T_46_META_WS_C_COLLECTIONID: "ID bộ sưu tập",
  T_46_META_WS_C_COLLIDER: "Bộ va chạm",
  T_46_META_WS_C_COLLIDERCOLLECTION: "Hình dạng va chạm",
  T_46_META_WS_C_COLLIDERCOLLECTIONID: "ID Hình dạng va chạm",
  T_46_META_WS_C_COLORDRUM: "Thùng nhuộm",
  T_46_META_WS_C_COMBATABLE: "Đơn vị chiến đấu",
  T_46_META_WS_C_COMPONENT: "Thành phần cơ bản",
  T_46_META_WS_C_CONDITION: "Điều kiện",
  T_46_META_WS_C_CONTAINER: "Thực thể chứa",
  T_46_META_WS_C_COORDINATESYSTEMTYPE: "Kiểu hệ tọa độ",
  T_46_META_WS_C_CROSSBOW: "Đạo cụ cung tên",
  T_46_META_WS_C_CSVID: "ID CSV",
  T_46_META_WS_C_CUSTOMIZETRIGGER: "Trigger tùy chỉnh",
  T_46_META_WS_C_CUSTOMLEVELOBJECT: "Vật thể tùy chỉnh",
  T_46_META_WS_C_CUSTOMPATH: "Đường dẫn tùy chỉnh",
  T_46_META_WS_C_CUSTOMUI: "UI tùy chỉnh",
  T_46_META_WS_C_CUSTOMUIID: "ID UI tùy chỉnh",
  T_46_META_WS_C_CUSTOMUIORWIDGET: "Widget hoặc UI tùy chỉnh",
  T_46_META_WS_C_CUSTOMUIWIDGETID: "ID Widget UI tùy chỉnh",
  T_46_META_WS_C_DAMAGEDBODYPARTTYPE: "Loại bộ phận cơ thể bị đánh trúng",
  T_46_META_WS_C_DAMAGETYPE: "Kiểu sát thương",
  T_46_META_WS_C_DEATHORINVINCIBILITYTRIGGER: "Kích hoạt khi bị hạ hoặc bất tử",
  T_46_META_WS_C_DESTRUCTIBLELEVELOBJECT: "Đối tượng có thể phá hủy",
  T_46_META_WS_C_DICE: "Xúc xắc",
  T_46_META_WS_C_DOUBLEJUMPSHOES: "Giày nhảy đôi",
  T_46_META_WS_C_DRUMMUSIC: "Nhạc trống",
  T_46_META_WS_C_DUALWIELDWEAPONTYPE: "Kiểu vũ khí hai tay",
  T_46_META_WS_C_DUMMYLEVELOBJECT: "Vật phẩm ải thường",
  T_46_META_WS_C_DYNAMICCREATELEVELOBJECTTYPE: "Kiểu vật phẩm có thể tạo động",
  T_46_META_WS_C_DYNAMICFENCE: "Hàng rào động",
  T_46_META_WS_C_EFFECT: "Hiệu ứng đặc biệt",
  T_46_META_WS_C_EFFECTCONTAINER: "Vật chứa hiệu ứng đặc biệt",
  T_46_META_WS_C_EFFECTID: "ID hiệu ứng",
  T_46_META_WS_C_EMOTETYPE: "Loại Hành động",
  T_46_META_WS_C_ENDPOINTTRIGGER: "Thành phần đích",
  T_46_META_WS_C_ENTITY: "Kiểu thực thể",
  T_46_META_WS_C_ENTITYORPREFABID: "ID thực thể hoặc prefab",
  T_46_META_WS_C_EQUIPMENTATTACHMENT: "Đạo cụ phụ kiện trang bị",
  T_46_META_WS_C_EQUIPMENTSLOTTYPE: "Kiểu slot trang bị",
  T_46_META_WS_C_EQUIPMENTTYPE: "Kiểu trang bị",
  T_46_META_WS_C_EVENTID: "ID sự kiện",
  T_46_META_WS_C_FACTION: "Phe phái",
  T_46_META_WS_C_FILLDIRECTIONTYPE: "Hướng điền ",
  T_46_META_WS_C_FILLTYPE: "Kiểu điền",
  T_46_META_WS_C_FIRETYPE: "Kiểu bắn",
  T_46_META_WS_C_FLOAT: "Kiểu Float",
  T_46_META_WS_C_FOLDWING: "Cánh gập",
  T_46_META_WS_C_FOLLOW: "Thực thể hoạt hình theo vị trí",
  T_46_META_WS_C_FONTTYPE: "Liệt kê phông chữ",
  T_46_META_WS_C_FOOTBALL: "Bóng đá",
  T_46_META_WS_C_FORCETYPE: "Loại lực tác dụng lên vật rắn",
  T_46_META_WS_C_FORMULABLE: "Thực thể có thuộc tính công thức hóa",
  T_46_META_WS_C_FRAMESELFRELATIVE: "Chuyển động mỗi khung hình so với bản thân",
  T_46_META_WS_C_GAMERESULTTYPE: "Loại kết quả trận đấu",
  T_46_META_WS_C_GENDERTYPE: "Giới tính",
  T_46_META_WS_C_GENERALSPAWNPOINT: "Điểm xuất hiện chung",
  T_46_META_WS_C_GRENADEDEICEWALL: "Thành phần lựu đạn băng",
  T_46_META_WS_C_GRENADEFLASHBANG: "Lựu choáng",
  T_46_META_WS_C_GRENADEFROZEN: "Lựu choáng băng",
  T_46_META_WS_C_GRENADELAUNCHER: "Súng phóng lựu",
  T_46_META_WS_C_GRENADESMOKE: "Lựu đạn khói",
  T_46_META_WS_C_GRENADEWEAPON: "Lựu đạn",
  T_46_META_WS_C_GRID: "Lưới",
  T_46_META_WS_C_HANDCANNON: "Đạo cụ lựu đạn",
  T_46_META_WS_C_HELMET: "Mũ",
  T_46_META_WS_C_HIERARCHICAL: "Thực thể có thể gắn nút con",
  T_46_META_WS_C_HOOKGUN: "Súng dây móc",
  T_46_META_WS_C_HORIZALINE: "Bộ hồi phục",
  T_46_META_WS_C_HUDTRANSFORM_DEPRECATED: "Thành phần UI Transform",
  T_46_META_WS_C_HUMANMODELID: "ID Mô hình người",
  T_46_META_WS_C_ICEWALL: "Tường băng bom keo",
  T_46_META_WS_C_ICEWALLCREATED: "Đối tượng tạo tường băng",
  T_46_META_WS_C_ICEWALLMAKER: "Máy tạo bom keo",
  T_46_META_WS_C_ICON: "Biểu tượng",
  T_46_META_WS_C_ICONTYPE: "Loại biểu tượng",
  T_46_META_WS_C_INHALER: "Mặt nạ hồi máu",
  T_46_META_WS_C_INT: "Int",
  T_46_META_WS_C_INT64: "Int64",
  T_46_META_WS_C_INTEGERMAPTEMPLATE: "Mẫu bản đồ số nguyên",
  T_46_META_WS_C_INTORINTLIST: "Số nguyên hoặc danh sách số nguyên",
  T_46_META_WS_C_INVENTORYTYPE: "Kiểu vật phẩm",
  T_46_META_WS_C_ITEMBASE: "Lớp cơ sở tài nguyên vật phẩm",
  T_46_META_WS_C_ITEMCONTAINER: "Thực thể chứa",
  T_46_META_WS_C_ITEMID: "ID Vật phẩm",
  T_46_META_WS_C_ITEMIDTYPE: "Kiểu ID Vật phẩm",
  "T_46_META_WS_C_JERSEY STYLE": "Kiểu áo đấu",
  T_46_META_WS_C_JERSEYMACHINE: "Máy thay trang phục",
  T_46_META_WS_C_JETSHOES: "Giày phản lực",
  T_46_META_WS_C_KEYBOARD: "Bàn phím",
  T_46_META_WS_C_KNOCKDOWNTYPE: "Kiểu trạng thái hạ gục",
  T_46_META_WS_C_LANDMINE: "Mìn",
  T_46_META_WS_C_LANDMINECREATED: "Đối tượng sau khi tạo mìn",
  "T_46_META_WS_C_LAUNCH PAD LEVEL OBJECT": "Cấp vật thể máy phóng",
  T_46_META_WS_C_LAUNCHPAD: "Máy phóng di động",
  T_46_META_WS_C_LAYOUTSORTTYPE: "Loại sắp xếp bố cục",
  T_46_META_WS_C_LEAD1MUSIC: "Thành phần nhạc Lead1",
  T_46_META_WS_C_LEAD2MUSIC: "Thành phần nhạc Lead2",
  T_46_META_WS_C_LEAD3MUSIC: "Thành phần Lead3",
  T_46_META_WS_C_LEVELOBJECTID: "ID cấp độ vật thể",
  T_46_META_WS_C_LEVELOBJECTTYPE: "Kiểu cấp độ vật thể",
  T_46_META_WS_C_LIST: "Danh sách",
  T_46_META_WS_C_LISTORMAP: "Danh sách hoặc Bản đồ",
  T_46_META_WS_C_LISTT: "Mẫu danh sách",
  T_46_META_WS_C_LISTT_BOOL: "Danh sách Kiểu Boolean",
  T_46_META_WS_C_LISTT_CONDITION: "Danh sách Điều kiện",
  T_46_META_WS_C_LISTT_ENTITY: "Danh sách Thực thể",
  T_46_META_WS_C_LISTT_FLOAT: "Danh sách số Float",
  T_46_META_WS_C_LISTT_INT: "Danh sách số Int",
  T_46_META_WS_C_LISTT_ITEMGOODSIDTYPE: "Danh sách Vật phẩm",
  T_46_META_WS_C_LISTT_LEVELOBJECT: "Danh sách Cấp vật thể",
  T_46_META_WS_C_LISTT_LOCKEY: "Danh sách khóa bản địa hóa",
  T_46_META_WS_C_LISTT_PLAYABLE: "Danh sách Playable",
  T_46_META_WS_C_LISTT_PLAYER: "Danh sách Người chơi",
  T_46_META_WS_C_LISTT_SKILLID: "Danh sách ID kỹ năng",
  T_46_META_WS_C_LISTT_SOUNDEFFECT: "Danh sách Hiệu ứng âm thanh",
  T_46_META_WS_C_LISTT_STRING: "Danh sách String",
  T_46_META_WS_C_LISTT_TEAM: "Danh sách Đội",
  T_46_META_WS_C_LISTT_TYPE: "Danh sách Kiểu",
  T_46_META_WS_C_LISTT_VECTOR3: "Danh sách 3D Vector",
  T_46_META_WS_C_LOCKEY: "Chuỗi bản địa hóa",
  T_46_META_WS_C_LOOKAT: "Thực thể hoạt ảnh theo dõi",
  T_46_META_WS_C_LOOPABLE: "Có thể lặp lại",
  T_46_META_WS_C_LOOPTYPE: "Kiểu vòng lặp",
  T_46_META_WS_C_LOOTAMMOTYPE: "Kiểu đạn Loot",
  T_46_META_WS_C_LOOTARMOR: "Giáp Loot",
  T_46_META_WS_C_LOOTARMORTYPE: "Kiểu đạn Loot",
  T_46_META_WS_C_LOOTCONSUMABLE: "Vật phẩm tiêu hao Loot",
  T_46_META_WS_C_LOOTCONSUMABLETYPE: "Kiểu vật phẩm tiêu hao Loot",
  T_46_META_WS_C_LOOTIAMMO: "Đạn Loot",
  T_46_META_WS_C_LOOTITEMBOXSOCCER: "Vật phẩm bóng đá Loot",
  T_46_META_WS_C_LOOTSCOPE: "Ống ngắm Loot",
  T_46_META_WS_C_LOOTSCOPETYPE: "Kiểu ống ngắm Loot",
  T_46_META_WS_C_LOOTSOCCERTYPE: "Vật phẩm bóng đá Loot",
  T_46_META_WS_C_LOOTTHROWABLE: "Lựu ném Loot",
  T_46_META_WS_C_LOOTTHROWABLETYPE: "Kiểu lựu ném Loot",
  T_46_META_WS_C_LOOTWEAPON: "Vũ khí Loot",
  T_46_META_WS_C_LOOTWEAPONTYPE: "Kiểu vũ khí Loot",
  T_46_META_WS_C_LOWGRAVITY: "Khu vực trọng lực thấp",
  T_46_META_WS_C_MAP: "Bản đồ",
  T_46_META_WS_C_MAPT: "Mẫu bản đồ",
  T_46_META_WS_C_MATERIALID: "ID tài sản chất liệu",
  T_46_META_WS_C_MEDKIT: "Túi cứu thương",
  T_46_META_WS_C_MESHID: "ID tài sản lưới",
  T_46_META_WS_C_MIDGAMEEXITCONFIG: "Cấu hình thoát giữa chừng",
  T_46_META_WS_C_MINIMAP: "Thành phần Thực thể Minimap",
  T_46_META_WS_C_MINIMAPICON: "Thành phần Thực thể Biểu tượng Minimap",
  T_46_META_WS_C_MINIMAPPIXELRENDERER: "Thành phần Thực thể Pixel Minimap",
  T_46_META_WS_C_MINISENTRY: "Tháp pháo mini",
  T_46_META_WS_C_MINISENTRYATTACKRANGETYPE: "Kiểu tầm bắn tháp pháo mini",
  T_46_META_WS_C_MINISENTRYCREATED: "Đã tạo tháp pháo mini",
  T_46_META_WS_C_MONEY: "Thực thể tiền tệ",
  T_46_META_WS_C_MONEYTYPE: "Danh sách kiểu tiền tệ",
  T_46_META_WS_C_MONSTER: "Quái vật",
  T_46_META_WS_C_MONSTERSPAWN: "Máy tạo quái vật",
  T_46_META_WS_C_MONSTERTYPE: "Kiểu quái vật",
  T_46_META_WS_C_MORPHABLEOBJECT: "Vật thể có thể biến hình",
  T_46_META_WS_C_MORPHOBJECT: "Vật thể biến hình",
  T_46_META_WS_C_MOTOBIKE: "Xe máy",
  T_46_META_WS_C_MOVEPLATFORM: "Nền tảng di chuyển",
  T_46_META_WS_C_MOVEPLATFORMTYPE: "Kiểu nền tảng di chuyển",
  T_46_META_WS_C_MUSHROOM: "Nấm",
  T_46_META_WS_C_NATURALCONSTANTTYPE: "Kiểu hằng số tự nhiên",
  T_46_META_WS_C_NPC: "Thực thể NPC",
  T_46_META_WS_C_NUMBER: "Số",
  T_46_META_WS_C_OBJECT: "Đối tượng",
  T_46_META_WS_C_OILDRUM: "Thùng dầu",
  T_46_META_WS_C_OUTFITID: "ID Trang phục",
  T_46_META_WS_C_OUTFITSLOTTYPE: "Kiểu vị trí trang phục",
  T_46_META_WS_C_PATHPOINT: "Điểm dò đường",
  T_46_META_WS_C_PATROLSTYLETYPE: "Kiểu tuần tra",
  T_46_META_WS_C_PATROLTYPE: "Cách tuần tra",
  T_46_META_WS_C_PERSONA: "Nhân dạng",
  T_46_META_WS_C_PHASE: "Thành phần Trạng thái",
  T_46_META_WS_C_PHYSICALMOVER: "Nền tảng di chuyển vật lý",
  T_46_META_WS_C_PHYSICALOBJECT: "Đối tượng vật lý",
  T_46_META_WS_C_PLATFORMTYPE: "Kiểu nền tảng",
  T_46_META_WS_C_PLAYABLE: "Có thể chơi",
  T_46_META_WS_C_PLAYABLEORPLAYABLES: "Có thể chơi hoặc mảng Có thể chơi",
  T_46_META_WS_C_PLAYER: "Thành phần đơn vị người chơi",
  T_46_META_WS_C_PLAYERBACKPACK: "Balo người chơi",
  T_46_META_WS_C_PLAYERBEHAVIORSTATUSTYPE: "Loại trạng thái hành vi của người chơi",
  T_46_META_WS_C_PLAYERBEHAVIORTYPE: "Loại hành vi của người chơi",
  T_46_META_WS_C_PLAYERCCT: "CCT người chơi",
  T_46_META_WS_C_PLAYERDATAID: "Kiểu nhân vật mặc định",
  T_46_META_WS_C_PLAYERORTRANSFORM: "Người chơi hoặc Thực thể Transform",
  T_46_META_WS_C_PLAYERORVEHICLE: "Người chơi hoặc Thực thể Phương tiện",
  T_46_META_WS_C_PLAYEROUTFIT: "Trang phục người chơi",
  T_46_META_WS_C_PLAYERPOSETYPE: "Kiểu tư thế người chơi",
  T_46_META_WS_C_PLAYERREVIVESOURCETYPE: "Kiểu nguồn hồi sinh người chơi",
  T_46_META_WS_C_PLAYERSTATETYPE: "Loại trạng thái người chơi",
  T_46_META_WS_C_POINTLIGHT: "Nguồn sáng điểm",
  T_46_META_WS_C_PORTAL: "Cổng dịch chuyển",
  T_46_META_WS_C_PREFABID: "ID Prefab",
  T_46_META_WS_C_PRESENTEFFECTGENERATOR_DEPRECATED: "Máy tạo hiệu ứng",
  T_46_META_WS_C_PRESENTEFFECTTEXTURETYPE_DEPRECATED: "Kiểu hiệu ứng đặc biệt",
  T_46_META_WS_C_PROFILEPICTUREWIDGET: "Widget ảnh hồ sơ cá nhân",
  T_46_META_WS_C_PROPERTY: "Thuộc tính",
  T_46_META_WS_C_PROPERTYFORMULA: "Thành phần công thức thuộc tính",
  T_46_META_WS_C_PROPERTYFORMULAFACTORTYPE: "Kiểu yếu tố thuộc tính được công thức hóa",
  T_46_META_WS_C_PROPERTYMODIFYTYPE: "Kiểu cách thức chỉnh sửa thuộc tính",
  T_46_META_WS_C_QUATERNION: "Quaternion",
  T_46_META_WS_C_RANKABLE: "Thành phần Thực thể có thể xếp hạng",
  T_46_META_WS_C_RAYCASTLAYERTYPE: "Kiểu tia",
  T_46_META_WS_C_REPAIRKIT: "Hộp sửa giáp",
  T_46_META_WS_C_RESETABLE: "Có thể đặt lại",
  T_46_META_WS_C_RIGIDBODY: "Rigidbody",
  T_46_META_WS_C_RIGIDBODYCONSTRAINTYPE: "Kiểu ràng buộc Rigidbody",
  T_46_META_WS_C_RIGIDBODYTYPE: "Kiểu Rigidbody",
  T_46_META_WS_C_ROUND: "Vòng đấu",
  T_46_META_WS_C_SAFEZONE: "Vòng bo",
  T_46_META_WS_C_SCOREABLE: "Thành phần thực thể tính điểm",
  T_46_META_WS_C_SCRIPTID: "ID Tập lệnh",
  T_46_META_WS_C_SEATTYPE: "Kiểu ghế ngồi",
  T_46_META_WS_C_SELFRELATIVE: "Chuyển động tự thân tương đối ",
  T_46_META_WS_C_SHOP: "Cửa hàng",
  T_46_META_WS_C_SHOPITEM: "Vật phẩm cửa hàng",
  T_46_META_WS_C_SHOPSHELF: "Kệ hàng cửa hàng",
  T_46_META_WS_C_SKATEBOARD: "Ván trượt",
  T_46_META_WS_C_SKELETON: "Khung xương",
  T_46_META_WS_C_SKELETONPART: "Phần khung xương",
  T_46_META_WS_C_SKILLID: "ID kỹ năng",
  T_46_META_WS_C_SKYBLASTER: "Chiến cơ",
  T_46_META_WS_C_SKYBOX: "Skybox",
  T_46_META_WS_C_SKYBOXTYPE: "Kiểu Skybox",
  T_46_META_WS_C_SOCIALISLANDSNOWBALL: "Cầu tuyết Đảo Kết nối",
  T_46_META_WS_C_SORTTYPE: "Kiểu sắp xếp",
  T_46_META_WS_C_SOUNDDRUMTYPE: "Kiểu nhạc trống",
  T_46_META_WS_C_SOUNDEFFECT: "Hiệu ứng âm thanh",
  T_46_META_WS_C_SOUNDEFFECTORSOUNDEFFECTLIST: "SoundEntity hoặc mảng SoundEntity",
  T_46_META_WS_C_SOUNDEFFECTTYPE: "Loại âm thanh",
  T_46_META_WS_C_SOUNDLEAD1TYPE: "Loại nhạc Lead1",
  T_46_META_WS_C_SOUNDLEAD2TYPE: "Loại nhạc Lead2",
  T_46_META_WS_C_SOUNDLEAD3TYPE: "Loại nhạc Lead3",
  T_46_META_WS_C_SOUNDPIANOTYPE: "Loại nhạc phím đàn",
  T_46_META_WS_C_SPAWN: "Máy tạo thực thể",
  T_46_META_WS_C_SPAWNABLE: "Thực thể có thể tạo",
  T_46_META_WS_C_SPAWNBOX: "Khu vực xuất hiện",
  T_46_META_WS_C_SPAWNPOSITION: "Vị trí xuất hiện",
  T_46_META_WS_C_SPECIALITEMIDTYPE: "ID vật phẩm đặc biệt",
  T_46_META_WS_C_SPHERETRIGGER: "Trigger hình cầu",
  T_46_META_WS_C_SPORTSCAR: "Xe thể thao",
  T_46_META_WS_C_SPRAYCOLOR: "Màu sơn",
  T_46_META_WS_C_SPRAYGUN: "Súng phun sơn",
  T_46_META_WS_C_SPRAYRESULTUI: "UI tổng kết sơn",
  T_46_META_WS_C_SPRAYRIFLE: "Súng phun sơn (súng trường)",
  T_46_META_WS_C_SPRITEID: "ID Sprite",
  T_46_META_WS_C_STATICSCRIPTID: "ID tập lệnh tĩnh",
  T_46_META_WS_C_STRING: "Chuỗi",
  T_46_META_WS_C_STRINGORLOCSTRING: "Chuỗi hoặc chuỗi địa phương hóa",
  T_46_META_WS_C_SUPPLYBOXTRIGGER: "Trigger Hộp tiếp tế",
  T_46_META_WS_C_SWINGGUN: "Súng dây móc",
  T_46_META_WS_C_SWITCHEQUIPSLOT: "Chuyển đổi khe đạo cụ",
  T_46_META_WS_C_TEAM: "Đội",
  T_46_META_WS_C_TERRAIN: "Địa hình",
  T_46_META_WS_C_TEXT: "Văn bản",
  T_46_META_WS_C_TEXTUREID: "ID Lớp phủ",
  T_46_META_WS_C_TEXTURETYPE: "Lớp phủ vật thể",
  T_46_META_WS_C_TIMER: "Bộ đếm giờ",
  T_46_META_WS_C_TIMESTAMPFORMATSTYLETYPE: "Định dạng hiển thị dấu thời gian",
  T_46_META_WS_C_TIMESTAMPLOCSTRING: "Chuỗi bản địa hóa dấu thời gian",
  T_46_META_WS_C_TRAJECTORY: "Hoạt ảnh đạn đạo",
  T_46_META_WS_C_TRANSFORM: "Biến đổi",
  T_46_META_WS_C_TUKTUK: "Xe Tuk Tuk",
  T_46_META_WS_C_TURRET: "Tháp phòng thủ",
  T_46_META_WS_C_TWEEN: "Tween",
  T_46_META_WS_C_TWEENCURVE_DEPRECATED: "TweenCurve",
  T_46_META_WS_C_TWEENSTYLE: "TweenStyle",
  T_46_META_WS_C_TYPE: "Kiểu",
  T_46_META_WS_C_TYPEENUM: "Kiểu Enum",
  T_46_META_WS_C_TYPEORTYPELIST: "Kiểu hoặc Mảng Kiểu",
  T_46_META_WS_C_UIADDSCORE: "UI cộng điểm",
  T_46_META_WS_C_UIANITRIGGERHUD: "UI kích hoạt hoạt ảnh",
  T_46_META_WS_C_UIBUILTINSWITCH: "UI công tắc thông dụng",
  T_46_META_WS_C_UIBUILTINUISWITCHCONTROLLER: "UI công tắc HUD thông dụng",
  T_46_META_WS_C_UICARDSELECTIONPANEL: "UI chọn thẻ",
  T_46_META_WS_C_UICHECKPOINTINDICATOR: "UI chỉ thị check point",
  T_46_META_WS_C_UICOMPASS: "UI la bàn",
  T_46_META_WS_C_UICOUNTDOWN5: "UI đếm ngược 5 giây",
  T_46_META_WS_C_UICOUNTDOWNHINT: "UI thông báo đếm ngược",
  T_46_META_WS_C_UICOUNTDOWNREMINDER: "UI thông nhắc nhở đếm ngược",
  T_46_META_WS_C_UIFOLLOWHEADLTHBAR: "UI theo thanh máu",
  T_46_META_WS_C_UIHEALTHBAR: "UI thanh máu",
  T_46_META_WS_C_UIHEARTBEAT: "UI nhịp tim",
  T_46_META_WS_C_UIICONNOTIFICATION: "UI thông báo biểu tượng",
  T_46_META_WS_C_UIIDENTITYNOTIFICATION: "UI thông báo định danh",
  T_46_META_WS_C_UIINTERACTIONBUTTON: "UI nút tương tác",
  T_46_META_WS_C_UILEADERBOARDBUTTON: "UI nút bảng xếp hạng",
  T_46_META_WS_C_UIMATCHSUBTITLE: "UI phụ đề trận đấu",
  T_46_META_WS_C_UIMONSTERLEVEL: "UI cấp quái vật",
  T_46_META_WS_C_UIMONSTERUI: "UI HUD quái vật",
  T_46_META_WS_C_UIMULTIPLETEAMLEADERBOARD: "UI BXH đa đội",
  T_46_META_WS_C_UIMULTITEAMRESULTPANEL: "UI bảng kết quả đa đội",
  T_46_META_WS_C_UIOPENINGBANNER: "UI biểu ngữ mở đầu",
  T_46_META_WS_C_UIPANEL: "UI bảng điều khiển",
  T_46_META_WS_C_UIPANELEMPTY: "UI bảng điều khiển trống",
  T_46_META_WS_C_UIPHASETIMER: "UI thời gian giai đoạn",
  T_46_META_WS_C_UIPROGRESSBAR: "UI thanh tiến độ",
  T_46_META_WS_C_UIPROGRESSCIRCLE: "UI vòng tròn tiến độ",
  T_46_META_WS_C_UIPROGRESSSKILLBUTTON: "UI nút kỹ năng tiến độ",
  T_46_META_WS_C_UIREQUESTPURCHASETYPE: "UI kiểu yêu cầu mua hàng",
  T_46_META_WS_C_UIROUNDINFOBANNER: "UI biểu ngữ thông tin vòng đấu",
  T_46_META_WS_C_UIROUNDNUMBER: "UI số vòng đấu",
  T_46_META_WS_C_UIROUNDRESULTBANNER: "UI biểu ngữ tổng kết vòng đấu",
  T_46_META_WS_C_UIROUNDSTARTBANNER: "UI biểu ngữ bắt đầu vòng đấu",
  T_46_META_WS_C_UIROUNDTRANSITION: "UI chuyển vòng đấu",
  T_46_META_WS_C_UISCOREBAR: "UI thanh điểm số",
  T_46_META_WS_C_UISCROLLPANEL: "UI bảng cuộn",
  T_46_META_WS_C_UISIMPLEROUNDSCOREBANNER: "UI biểu ngữ điểm vòng đấu đơn giản",
  T_46_META_WS_C_UISIMPLEROUNDSTARTBANNER: "UI biểu ngữ bắt đầu vòng đấu đơn giản",
  T_46_META_WS_C_UISIMPLETIP: "UI mẹo đơn giản",
  T_46_META_WS_C_UISIMPLEVERSUSBANNER: "UI biểu ngữ thông tin phe đơn giản",
  T_46_META_WS_C_UISKILLBUTTON: "UI nút kỹ năng",
  T_46_META_WS_C_UISOCIALBUTTONWIDGET: "UI Widget nút kết nối",
  T_46_META_WS_C_UISOLOLEADERBOARD: "UI BXH đấu đơn",
  T_46_META_WS_C_UISTORE: "UI giao diện cửa hàng",
  T_46_META_WS_C_UITEAMMATCHINFO: "UI thông tin đội",
  T_46_META_WS_C_UITEXTTIP: "UI mẹo văn bản",
  T_46_META_WS_C_UITIMERINFO: "UI thông tin đếm giờ",
  T_46_META_WS_C_UITIPBUTTON: "UI nút gợi ý",
  T_46_META_WS_C_UITITLEBANNER: "UI biểu ngữ tiêu đề",
  T_46_META_WS_C_UITWEENTIP: "UI mẹo Tween",
  T_46_META_WS_C_UITWOTEAMBRIEFINFO: "UI Thông tin thi đấu đơn giản của hai đội",
  T_46_META_WS_C_UITWOTEAMINFO: "UI Thông tin hai đội",
  T_46_META_WS_C_UITWOTEAMLEADERBOARD: "UI BXH thi đấu của hai đội",
  T_46_META_WS_C_UITWOTEAMRESULTPANEL: "UI Bảng tổng kết kết quả hai đội",
  T_46_META_WS_C_UITWOTEAMROUNDSCOREBANNER: "UI Biểu ngữ tính điểm vòng đấu hai đội",
  T_46_META_WS_C_UITWOTEAMSCOREPANEL: "UI Giao diện tổng kết hai đội",
  T_46_META_WS_C_UIVERSUSBANNER: "UI biểu ngữ đối kháng",
  T_46_META_WS_C_UIWIDGET: "UI Widget",
  T_46_META_WS_C_UIWIDGETBUTTON: "UI nút Widget",
  T_46_META_WS_C_UIWIDGETCONTAINER: "UI bộ chứa Widget",
  T_46_META_WS_C_UIWIDGETEMPTY: "UI Widget rỗng",
  T_46_META_WS_C_UIWIDGETIMAGE: "UI Widget hình ảnh",
  T_46_META_WS_C_UIWIDGETINPUTLABLE: "UI Widget InputLable",
  T_46_META_WS_C_UIWIDGETJOYSTICK: "UI Widget cần điều khiển",
  T_46_META_WS_C_UIWIDGETLABEL: "UI Widget nhãn văn bản",
  T_46_META_WS_C_UIWIDGETLAYOUT: "UI Widget bố cục",
  T_46_META_WS_C_UIWIDGETPROFILE: "UI Widget hồ sơ",
  T_46_META_WS_C_UIWIDGETTEXTURE: "UI Widget lớp phủ",
  T_46_META_WS_C_UIWIDGETTOGGLE: "UI Widget bật tắt",
  T_46_META_WS_C_UIWIDGETTOUCHPAD: "UI Widget TouchPad",
  T_46_META_WS_C_UIWINORLOSEBANNER: "UI Biểu ngữ kết quả thắng thua",
  T_46_META_WS_C_UNITSPAWN: "Thực thể tạo máy",
  T_46_META_WS_C_UUID: "UUID",
  T_46_META_WS_C_VAULTTRIGGER: "Vật thể Logic Nhảy Qua Cửa Sổ",
  T_46_META_WS_C_VECTOR2: "Vector2",
  T_46_META_WS_C_VECTOR3: "Vector3",
  T_46_META_WS_C_VEHICLE: "Phương tiện",
  T_46_META_WS_C_VEHICLEIDTYPE: "ID Kiểu phương tiện",
  T_46_META_WS_C_VEHICLESKINID: "ID Skin phương tiện",
  T_46_META_WS_C_VENDINGMACHINE: "Máy bán hàng",
  T_46_META_WS_C_VEST: "Giáp",
  T_46_META_WS_C_VFXREPLACETEXTPRESENT: "Lớp phủ VFX có thể thay thế",
  T_46_META_WS_C_VFXTEXTURE: "Lớp phủ VFX không thể thay thế",
  T_46_META_WS_C_VISIBILITY: "Độ hiển thị",
  T_46_META_WS_C_WALLET: "Ví tiền",
  T_46_META_WS_C_WALLETHUD: "UI Ví tiền",
  T_46_META_WS_C_WATERZONE: "Vùng nước",
  T_46_META_WS_C_WAVECOUNTTYPE: "Kiểu sóng",
  T_46_META_WS_C_WAVEINTERVALTYPE: "Kiểu khoảng cách mỗi đợt sóng",
  T_46_META_WS_C_WEAPON: "Vũ khí",
  T_46_META_WS_C_WEAPONGENERATOR: "Máy tạo vũ khí",
  T_46_META_WS_C_WEAPONSKINID: "ID skin súng",
  T_46_META_WS_C_WEAPONTYPE: "Loại vũ khí",
  T_46_META_WS_C_WIDGETTYPE: "Kiểu Widget",
  T_46_META_WS_C_ZIPLINE: "Dây trượt",
  T_46_META_WS_CAMERADIRECTION: "Hướng camera",
  T_46_META_WS_CAMERAPOSITION: "Vị trí camera",
  T_46_META_WS_CAPSULECAST: "Quét viên nhộng",
  T_46_META_WS_CAPSULEOVERLAP: "Kiểm tra chồng lấp viên nhộng",
  T_46_META_WS_CEIL: "Làm tròn lên",
  T_46_META_WS_CHATCHANNEL: "Kênh trò chuyện",
  T_46_META_WS_CHECKTRIGGERBYORDER: "Kiểm tra trigger theo thứ tự",
  T_46_META_WS_CLAMP: "Kẹp",
  T_46_META_WS_CLEAR: "Xóa hết",
  T_46_META_WS_CLEARALLCHILDREN: "Xóa tất cả các nút con",
  T_46_META_WS_CLEARAOISPECIALFOLLOW: "Xóa AOI đặc biệt quan tâm",
  T_46_META_WS_CLEARBACKPACK: "Xóa Balo",
  T_46_META_WS_CLEARFORMULAPROPERTYFACTOR: "Xóa tất cả các yếu tố thuộc tính công thức hóa",
  T_46_META_WS_CLEARRESIDUALLEVELOBJECTS: "Dọn dẹp vật thể còn lại",
  T_46_META_WS_CLIPNAME: "Tên clip",
  T_46_META_WS_CLONE: "Bản sao",
  T_46_META_WS_COLLIDEDENTITY: "Thực thể va chạm",
  T_46_META_WS_COLORGET: "Lấy giá trị màu",
  T_46_META_WS_COMPLETECUSTOMMISSION: "Hoàn thành nhiệm vụ tùy chỉnh",
  T_46_META_WS_CONNECT: "Kết nối",
  T_46_META_WS_CONSUMABLEID: "ID vật phẩm tiêu thụ",
  T_46_META_WS_CONTAIN: "Chứa",
  T_46_META_WS_CONTAINKEY: "Chứa Khóa",
  T_46_META_WS_COPYTOMORPH: "Nhân bản như đối tượng trường cảnh",
  T_46_META_WS_COS: "Cos",
  T_46_META_WS_COSTMONEY: "Tiêu hao tiền tệ",
  T_46_META_WS_COSTTOKEN: "Tiêu hao huy hiệu",
  T_46_META_WS_CREATEAIRDROP: "Tạo Hòm thính",
  T_46_META_WS_CREATEBOT: "Tạo Bot",
  T_46_META_WS_CREATEBUILTINUI: "Tạo giao diện tích hợp",
  T_46_META_WS_CREATEBUILTINUICLIENT: "Tạo giao diện tích hợp",
  T_46_META_WS_CREATECAMERA: "Tạo camera",
  T_46_META_WS_CREATECURVE: "Tạo đường cong",
  T_46_META_WS_CREATECUSTOMUI: "Tạo UI tùy chỉnh",
  T_46_META_WS_CREATECUSTOMUICLIENT: "Tạo UI tùy chỉnh",
  T_46_META_WS_CREATECUSTOMUIWIDGET: "Tạo điều khiển UI tùy chỉnh",
  T_46_META_WS_CREATEDAMAGENUM: "Tạo chữ nhảy sát thương",
  T_46_META_WS_CREATEEFFECT: "Tạo hiệu ứng đặc biệt",
  T_46_META_WS_CREATEEFFECTCLIENT: "Tạo hiệu ứng đặc biệt",
  T_46_META_WS_CREATEFACTION: "Tạo phe",
  T_46_META_WS_CREATEFOLLOW: "Tạo vị trí theo dõi",
  T_46_META_WS_CREATEFRAMESELFRELATIVE: "Tạo chuyển động tương đối của mỗi khung hình",
  T_46_META_WS_CREATEFROMPREFAB: "Tạo từ prefab",
  T_46_META_WS_CREATELEVELOBJECT: "Tạo vật thể vòng chơi",
  T_46_META_WS_CREATELOOKAT: "Tạo mắt theo dõi",
  T_46_META_WS_CREATEMINIMAPICON: "Tạo biểu tượng Minimap",
  T_46_META_WS_CREATEMINIMAPPIXEL: "Tạo pixel Minimap",
  T_46_META_WS_CREATEMONSTER: "Tạo quái vật",
  T_46_META_WS_CREATEMORPH: "Tạo phân thân",
  T_46_META_WS_CREATESELFRELATIVE: "Tạo chuyển động tương đối với bản thân",
  T_46_META_WS_CREATESHOP: "Tạo cửa hàng",
  T_46_META_WS_CREATESHOPITEM: "Tạo vật phẩm cửa hàng",
  T_46_META_WS_CREATESHOPSHELF: "Tạo kệ hàng cửa hàng",
  T_46_META_WS_CREATESOUND: "Tạo âm thanh",
  T_46_META_WS_CREATESOUNDCLIENT: "Tạo âm thanh",
  T_46_META_WS_CREATETOKENINSCENE: "Tạo Token trong cảnh",
  T_46_META_WS_CREATETRAJECTORY: "Tạo chuyển động đạn đạo",
  T_46_META_WS_CREATETWEEN: "Tạo chuyển động nội suy",
  T_46_META_WS_CREATEWALLET: "Tạo ví",
  T_46_META_WS_CROSS: "Tích chéo vector",
  T_46_META_WS_CSVCOLUMNNAMETOINT: "Chuyển cột tên CSV thành Int",
  T_46_META_WS_CURRENTAMMOCOUNT: "Số đạn còn lại hiện tại",
  T_46_META_WS_DAMAGE: "Sát thương",
  T_46_META_WS_DAMAGEDBODYPART: "Vị trí sát thương",
  T_46_META_WS_DAMAGEDPLAYERS: "Người chơi bị sát thương",
  T_46_META_WS_DAMAGETYPE: "Kiểu sát thương",
  T_46_META_WS_DEALDAMAGE: "Gây sát thương",
  T_46_META_WS_DELETE: "Xóa",
  T_46_META_WS_DELETEAT: "Xóa tại",
  T_46_META_WS_DELETECUSTOMUI: "Xóa UI tùy chỉnh",
  T_46_META_WS_DELETEFROMDATABASE: "Xóa giá trị bảng cơ sở dữ liệu",
  T_46_META_WS_DELETEFROMDATASTORE: "Xóa giá trị bảng cơ sở dữ liệu",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYKEY: "Xóa cơ sở dữ liệu bảng xếp hạng theo khóa",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYRANK: "Xóa cơ sở dữ liệu bảng xếp hạng theo xếp hạng",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYKEY: "Xóa kho dữ liệu bảng xếp hạng theo khóa",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYRANK: "Xóa kho dữ liệu bảng xếp hạng theo xếp hạng",
  T_46_META_WS_DELETETAG: "Xóa nhãn",
  T_46_META_WS_DELTA: "Delta",
  T_46_META_WS_DESTROY: "Tiêu diệt",
  T_46_META_WS_DESTROYBOT: "Tiêu diệt Bot",
  T_46_META_WS_DESTROYBUILTINUI: "Hủy UI tích hợp",
  T_46_META_WS_DESTROYEQUIPMENT: "Hủy trang bị",
  T_46_META_WS_DESTROYITEM: "Hủy vật phẩm",
  T_46_META_WS_DIRECTIONTOEULERANGLE: "Chuyển đổi Vector sang góc Euler",
  T_46_META_WS_DISABLESAFEZONE: "Hủy vòng bo",
  T_46_META_WS_DISPATCHEVENT: "Gửi sự kiện tùy chỉnh",
  T_46_META_WS_DISPATCHEVENTWITHPLATFORM: "Gửi sự kiện tùy chỉnh với nền tảng",
  T_46_META_WS_DISTANCE: "Khoảng cách",
  T_46_META_WS_DOT: "Tích vô hướng",
  T_46_META_WS_DROPITEM: "Vứt bỏ vật phẩm",
  T_46_META_WS_DYEATAREA: "Nhuộm màu khu vực",
  T_46_META_WS_DYEATPLANE: "Nhuộm màu bề mặt",
  T_46_META_WS_DYEATPOSITION: "Nhuộm màu điểm mục tiêu",
  T_46_META_WS_E_ABNORMALGRAVZONE: "Khu vực trọng lực thấp",
  T_46_META_WS_E_AC80: "AC80",
  T_46_META_WS_E_ACCELERATION: "Gia tốc",
  T_46_META_WS_E_ACTIONNODE: "Nút hành động",
  T_46_META_WS_E_ACTIVE: "Tấn công chủ động",
  T_46_META_WS_E_ACTIVESKILL: "Kỹ năng chủ động",
  T_46_META_WS_E_ADBOARD: "Biển quảng cáo",
  T_46_META_WS_E_ADD: "Tăng",
  T_46_META_WS_E_ADDFRIEND: "Thêm bạn",
  T_46_META_WS_E_AGENCYFB: "AgencyFB",
  T_46_META_WS_E_AIM: "Nhắm",
  T_46_META_WS_E_AIR: "Không khí",
  T_46_META_WS_E_AIRCONDITIONERA: "Điều hòa",
  T_46_META_WS_E_AIRDROP: "Hòm thính, Zombie tự sát",
  T_46_META_WS_E_AK: "AK",
  T_46_META_WS_E_AK2: "AK2",
  T_46_META_WS_E_ALIVE: "Sống",
  T_46_META_WS_E_AMMO: "VFX tia đạn",
  T_46_META_WS_E_AMPHIBIANCAR: "Xe đa năng",
  T_46_META_WS_E_AN94: "AN94",
  T_46_META_WS_E_APPARITION: "Tiểu quỷ nô đùa",
  T_46_META_WS_E_AR: "Súng trường",
  T_46_META_WS_E_AR15: "AR15",
  T_46_META_WS_E_ARAMMO: "Đạn AR",
  T_46_META_WS_E_ARMAGAZINE: "Băng đạn AR",
  T_46_META_WS_E_ARMOR: "Giáp",
  T_46_META_WS_E_ARMORBUFF: "Buff giáp",
  T_46_META_WS_E_ARMORLV1: "Giáp Lv1",
  T_46_META_WS_E_ARMORLV2: "Giáp Lv2",
  T_46_META_WS_E_ARMORLV3: "Giáp Lv3",
  T_46_META_WS_E_ARMORPIERCING: "Phá Giáp",
  T_46_META_WS_E_ARMORSPECIALIST: "Kỹ Năng 1",
  T_46_META_WS_E_ARROW: "Mũi tên",
  T_46_META_WS_E_ASC: "Tăng dần",
  T_46_META_WS_E_ASCIGNOREZERO: "Tăng dần bỏ qua giá trị bằng 0",
  T_46_META_WS_E_ATMOSPHEREEXPLOSION: "Vụ nổ khí ",
  T_46_META_WS_E_ATTACHMENT1FORCOMPATIBILITY: "Attachment1ForCompatibility",
  T_46_META_WS_E_ATTACHMENT4FORCOMPATIBILITY: "Attachment1ForCompatibility",
  T_46_META_WS_E_ATTACHMENT5FORCOMPATIBILITY: "Attachment1ForCompatibility",
  T_46_META_WS_E_ATTACHMENT6FORCOMPATIBILITY: "Attachment1ForCompatibility",
  T_46_META_WS_E_ATTACHMENT8FORCOMPATIBILITY: "Attachment1ForCompatibility",
  T_46_META_WS_E_ATTACK: "Tấn công",
  T_46_META_WS_E_ATTACKGRENADE: "Lựu tấn công",
  T_46_META_WS_E_AUG: "AUG",
  T_46_META_WS_E_AUTO: "Tự động",
  T_46_META_WS_E_AWM: "AWM",
  T_46_META_WS_E_AWM2: "AWM2",
  T_46_META_WS_E_BACK: "Quay lại",
  T_46_META_WS_E_BACKANDFORTH: "Đi lại",
  T_46_META_WS_E_BAG: "Balo",
  T_46_META_WS_E_BAG1: "Túi1",
  T_46_META_WS_E_BAG2: "Túi2",
  T_46_META_WS_E_BAG3: "Túi3",
  T_46_META_WS_E_BAMBOOA: "Tre A",
  T_46_META_WS_E_BANANATREE: "Cây chuối",
  T_46_META_WS_E_BASEBALLPOLE: "Gậy bóng chày",
  T_46_META_WS_E_BASECOEFFICIENT: "Hệ số cơ bản",
  T_46_META_WS_E_BASIC: "Loại cơ bản",
  T_46_META_WS_E_BASICCONE: "Hình nón cơ bản",
  T_46_META_WS_E_BASICCYLINDER: "Hình trụ cơ bản",
  T_46_META_WS_E_BASICSPHERE: "Hình cầu cơ bản",
  T_46_META_WS_E_BATTLEINSTYLE: "Xu hướng chiến đấu",
  T_46_META_WS_E_BELL: "Chuông gió",
  T_46_META_WS_E_BENCH: "Ghế dài",
  T_46_META_WS_E_BIGHEADHAMMER: "Búa to",
  T_46_META_WS_E_BILLBOARD: "Màn hình lớn",
  T_46_META_WS_E_BIPOD: "Bipod",
  T_46_META_WS_E_BISGRAFFITIWALL: "Tường chủ đề BIS",
  T_46_META_WS_E_BIZON: "PP19",
  T_46_META_WS_E_BLACKHOLE: "Hiệu ứng nổ hố đen",
  T_46_META_WS_E_BLACKHOLEBOOM: "Hiệu ứng quả cầu pha lê",
  T_46_META_WS_E_BLAST: "Nổ",
  T_46_META_WS_E_BLOCK: "Hình vuông",
  T_46_META_WS_E_BLOODBALL: "Hiệu ứng hố đen",
  T_46_META_WS_E_BLT: "BLT",
  T_46_META_WS_E_BLT2: "BLT2",
  T_46_META_WS_E_BLUE: "Màu xanh lam",
  T_46_META_WS_E_BLUEDOLL: "Búp Bê Băng",
  T_46_META_WS_E_BOARD: "Nền Di Chuyển",
  T_46_META_WS_E_BODY: "Cơ Thể",
  T_46_META_WS_E_BOMBINDICATION: "Gợi Ý Bom",
  T_46_META_WS_E_BOMBPLIERS: "Kìm Gỡ Bom",
  T_46_META_WS_E_BONFIRE: "Đống lửa đang cháy",
  T_46_META_WS_E_BOOM: "Vòng tròn",
  T_46_META_WS_E_BOOYAH: "Chiến thắng",
  T_46_META_WS_E_BOTH: "Hai đầu",
  T_46_META_WS_E_BOUNCETIRE: "Lốp xe",
  T_46_META_WS_E_BOWAMMO: "Đạn cung tên",
  T_46_META_WS_E_BREAKABLEBOX: "Thùng gỗ có thể phá hủy",
  T_46_META_WS_E_BREAKABLECONTAINER: "Container có thể phá hủy",
  T_46_META_WS_E_BREAKABLEFENCE: "Hàng rào có thể phá hủy",
  T_46_META_WS_E_BRICKA: "Gạch A",
  T_46_META_WS_E_BRICKB: "Gạch B",
  T_46_META_WS_E_BRICKC: "Gạch C",
  T_46_META_WS_E_BRICKHOUSEA: "Nhà nhỏ A",
  T_46_META_WS_E_BRIGHT: "Ánh sáng",
  T_46_META_WS_E_BUBBLE: "Bong bóng",
  T_46_META_WS_E_BUFFGENERATOR: "BuffGen",
  T_46_META_WS_E_BULLETBUFF: "Buff đạn",
  T_46_META_WS_E_BULLETHITTING: "Đạn trúng mục tiêu",
  T_46_META_WS_E_BUMPERCAR: "Xe điện đụng",
  T_46_META_WS_E_BUMPERCARFACTORY: "Nhà máy xe điện đụng",
  T_46_META_WS_E_BURNING: "ST cháy khi phương tiện nổ",
  T_46_META_WS_E_BUSHES: "Bụi cỏ",
  T_46_META_WS_E_BUSSTOP: "Trạm xe buýt",
  T_46_META_WS_E_BUTTOM: "Trang phục dưới",
  T_46_META_WS_E_BUTTONWIDGET: "Nút điều khiển",
  T_46_META_WS_E_BYHIERARCHY: "Theo cấu trúc phân cấp",
  T_46_META_WS_E_CABINET: "Tủ đựng đồ",
  T_46_META_WS_E_CACTUS: "Xương rồng",
  T_46_META_WS_E_CAMOUFLAGE: "Kỹ năng 6",
  T_46_META_WS_E_CAPSULETRIGGER: "Kích hoạt viên nang",
  T_46_META_WS_E_CARDIOTONIC: "Cardiotonic",
  T_46_META_WS_E_CASUALGAMEBGM: "Nhạc nền game giải trí",
  T_46_META_WS_E_CEMENTA: "Xi măng A",
  T_46_META_WS_E_CG15: "CG15",
  T_46_META_WS_E_CHANNELA: "Kênh thoại rảnh rỗi 1",
  T_46_META_WS_E_CHANNELB: "Kênh thoại rảnh 2",
  T_46_META_WS_E_CHANNELC: "Kênh thoại rảnh 3",
  T_46_META_WS_E_CHANNELD: "Kênh thoại rảnh 4",
  T_46_META_WS_E_CHANNELE: "Kênh thoại rảnh 5",
  T_46_META_WS_E_CHANNELF: "Kênh thoại rảnh 6",
  T_46_META_WS_E_CHARACTERSKILL: "Kỹ năng Ảnh",
  T_46_META_WS_E_CHARACTOR: "Nhân vật",
  T_46_META_WS_E_CHARGE: "Nạp năng lượng 1",
  T_46_META_WS_E_CHARGEBUSTER: "Súng Sạc",
  T_46_META_WS_E_CHECKPOINT: "Checkpoint",
  T_46_META_WS_E_CHEER: "Hoan hô",
  T_46_META_WS_E_CHERRYBLOSSOM: "Cây anh đào",
  T_46_META_WS_E_CIRCLE: "Tròn",
  T_46_META_WS_E_CIRCLEBACK: "Tuần hoàn",
  T_46_META_WS_E_CIRCLEOFHEAT: "Cột sáng dưới chân",
  T_46_META_WS_E_CITY: "Thành phố",
  T_46_META_WS_E_CLAPS: "Tiếng vỗ tay",
  T_46_META_WS_E_CLEAR: "Xóa",
  T_46_META_WS_E_CLIENT: "Ứng dụng",
  T_46_META_WS_E_CLONE: "Biến hình",
  T_46_META_WS_E_CLONEKILL: "Phân thân bị tiêu diệt",
  T_46_META_WS_E_CLOSE: "Đóng",
  T_46_META_WS_E_CLOTHES: "Quần áo",
  T_46_META_WS_E_COINGENERATOR: "Máy tạo vàng",
  T_46_META_WS_E_COLDAIR: "Sương",
  T_46_META_WS_E_COLORBLOCK: "Khối nhuộm màu",
  T_46_META_WS_E_COLOROILBARREL: "Thùng dầu nhuộm màu",
  T_46_META_WS_E_COMBINEALL: "Kết hợp tất cả",
  T_46_META_WS_E_COMBINESELF: "Kết hợp với bản thân",
  T_46_META_WS_E_COMBOKEYA1: "Nốt nhạc - Synthesizer A",
  T_46_META_WS_E_COMBOKEYA2: "Nốt Nhạc - Synthesizer A",
  T_46_META_WS_E_COMBOKEYB1: "Nốt nhạc - Synthesizer B",
  T_46_META_WS_E_COMBOKEYB2: "Nốt nhạc - Synthesizer B",
  T_46_META_WS_E_COMBOKEYC1: "Nốt nhạc - Synthesizer C",
  T_46_META_WS_E_COMBOKEYC2: "Nốt nhạc - Synthesizer C",
  T_46_META_WS_E_CONCRETEPILLAR: "Cột bê tông",
  T_46_META_WS_E_CONDITIONNODE: "Nút điều kiện",
  T_46_META_WS_E_CONTAINERA: "Container A",
  T_46_META_WS_E_CONTAINERB: "Container B",
  T_46_META_WS_E_CONTAINERC: "Container C",
  T_46_META_WS_E_CONTAINERWIDGET: "Trình điều khiển container",
  T_46_META_WS_E_CONTINUOUS: "Tạo liên tục",
  T_46_META_WS_E_COUNTDOWN: "Đếm thời gian",
  T_46_META_WS_E_COUNTDOWNDENGDENG: "Đếm ngược",
  T_46_META_WS_E_COUNTDOWNDIDI: "Tiếng tích tắc của đếm ngược",
  T_46_META_WS_E_COUNTDOWNMECHANICAL: "Đếm ngược",
  T_46_META_WS_E_COUNTDOWNWITHINGAME: "Đếm ngược 3",
  T_46_META_WS_E_CROSS: "Thập tự",
  T_46_META_WS_E_CROSSBOW: "Nỏ",
  T_46_META_WS_E_CROSSHAIR: "Tâm ngắm",
  T_46_META_WS_E_CROSSHAIRS: "UI tâm ngắm",
  T_46_META_WS_E_CROUCH: "UI Ngồi",
  T_46_META_WS_E_CROUCHING: "Ngồi",
  T_46_META_WS_E_CROWCAW: "Tiếng quạ kêu",
  T_46_META_WS_E_CROWN: "Vương miện",
  T_46_META_WS_E_CUBE: "Cơ chế khối",
  T_46_META_WS_E_CURSE: "Bùa",
  T_46_META_WS_E_CURSEEXPLOSION: "Bùa phát nổ",
  T_46_META_WS_E_CUSTOM: "Máy ảnh tùy chỉnh",
  T_46_META_WS_E_CUSTOMTRIGGER: "Kích hoạt tùy chỉnh",
  T_46_META_WS_E_CUSTOMWATERZONE: "Tùy chỉnh vùng nước",
  T_46_META_WS_E_CYCLICCOMBUSTION: "Đốt cháy tuần hoàn",
  T_46_META_WS_E_CYLIC: "Tuần hoàn",
  T_46_META_WS_E_DAGGER: "Phi đao",
  T_46_META_WS_E_DAMAGEDTRUCK: "Xe tải hỏng",
  T_46_META_WS_E_DAMAGEZONE: "Khu vực DMG",
  T_46_META_WS_E_DANGERALARM: "Âm cảnh báo nguy hiểm 2",
  T_46_META_WS_E_DANGERVIBRATING: "Âm cảnh báo nguy hiểm 1",
  T_46_META_WS_E_DARK: "Màu tối",
  T_46_META_WS_E_DARKNESS: "Bóng tối",
  T_46_META_WS_E_DASHATTACK: "Lướt tấn công",
  T_46_META_WS_E_DATASTORAGELIMITEXCEEDED: "Lưu trữ dữ liệu vượt quá giới hạn",
  T_46_META_WS_E_DATASTORAGEPARAMETERERROR: "Sai tham số lưu trữ dữ liệu",
  T_46_META_WS_E_DATASTORAGETIMEOUT: "Lưu trữ dữ liệu quá thời gian",
  T_46_META_WS_E_DATETIME: "DateTime",
  T_46_META_WS_E_DAY: "Ban ngày",
  T_46_META_WS_E_DEAD: "Chết",
  T_46_META_WS_E_DEATH: "Trạng thái chết",
  T_46_META_WS_E_DEFAULT: "Mặc định",
  T_46_META_WS_E_DEFAULTFIST: "Nắm đấm",
  T_46_META_WS_E_DEFENCEGRENADE: "Lựu phòng thủ",
  T_46_META_WS_E_DESC: "Giảm dần",
  T_46_META_WS_E_DIALOGUE: "Đối thoại",
  T_46_META_WS_E_DIAMOND: "Kim cương",
  T_46_META_WS_E_DIRECTIONSIGN: "Biển chỉ dẫn",
  T_46_META_WS_E_DIRVEVEHICLE: "Điều khiển Phương tiện",
  T_46_META_WS_E_DISABLE: "Vô hiệu hóa",
  T_46_META_WS_E_DISABLED: "Đã vô hiệu hóa",
  T_46_META_WS_E_DISAPPEARNOTIFICATION: "Thông báo biến mất",
  T_46_META_WS_E_DISCONNECT: "Mất kết nối",
  T_46_META_WS_E_DISGUISE: "Phân thân",
  T_46_META_WS_E_DOGHOUSE: "Nhà cún",
  T_46_META_WS_E_DOOR: "Cửa",
  T_46_META_WS_E_DOUBLE: "Đôi",
  T_46_META_WS_E_DOUBLEDOOR: "Cửa đôi",
  T_46_META_WS_E_DOUBLEJUMPSHOE: "Giày Nhảy Kép",
  T_46_META_WS_E_DOUBLEMAGEZINE: "Băng Đạn Kép",
  T_46_META_WS_E_DRAW: "Hòa",
  T_46_META_WS_E_DRILLZOMBIE: "Thây Ma Đào Đất",
  T_46_META_WS_E_DRIVE: "Lái Xe",
  T_46_META_WS_E_DRIVER: "Người lái xe",
  T_46_META_WS_E_DROPBEAT: "Kỹ năng 4",
  T_46_META_WS_E_DRUMKEY1: "Nốt nhạc - Trống",
  T_46_META_WS_E_DRUMKEY2: "Nốt Nhạc - Trống",
  T_46_META_WS_E_DUEL: "Quyết đấu",
  T_46_META_WS_E_DUMMY: "Dummy",
  T_46_META_WS_E_DUMMYGRENADE: "Ma nơ canh",
  T_46_META_WS_E_DUMP: "Ném",
  T_46_META_WS_E_DUSK: "Hoàng hôn",
  T_46_META_WS_E_DUST: "Khói bụi",
  T_46_META_WS_E_DYNAMIC: "Động",
  T_46_META_WS_E_E: "Hằng số tự nhiên",
  T_46_META_WS_E_EAGLE: "EAGLE",
  T_46_META_WS_E_EASY: "Dễ dàng",
  T_46_META_WS_E_ELECTRICSHOCK: "Điện giật",
  T_46_META_WS_E_ELECTRICSURFBOARD: "ElectricSurfboard",
  T_46_META_WS_E_ELECTRICZONE: "Vùng nguy hiểm",
  T_46_META_WS_E_ELECTRONICBGM: "Nhạc nền điện tử mộng mơ dễ thương",
  T_46_META_WS_E_ELIMINATEDBOSS: "Bãi nhiệm Trưởng quân đoàn",
  T_46_META_WS_E_ELIMINATIONNOTIFICATION: "Thông báo hạ gục",
  T_46_META_WS_E_EMOTE: "Hành động",
  T_46_META_WS_E_ENABLE: "Kích hoạt",
  T_46_META_WS_E_ENERGETIC: "Đầy năng lượng",
  T_46_META_WS_E_ENTERVEHICLE: "Vào phương tiện",
  T_46_META_WS_E_EP: "UI EP",
  T_46_META_WS_E_EXCLAMATIONMARK: "Dấu chấm than",
  T_46_META_WS_E_EXIT: "Thoát",
  T_46_META_WS_E_EXITVEHICLE: "Rời khỏi phương tiện",
  T_46_META_WS_E_EXPLODE: "Tự phát nổ",
  T_46_META_WS_E_EXPLOSION: "Hiệu ứng nổ",
  T_46_META_WS_E_EXPLOSIVEBLAZE: "Ánh sáng nổ tung",
  T_46_META_WS_E_EXPLOSIVEPAINTSKILL: "Kỹ năng Cầu Năng Lượng",
  T_46_META_WS_E_EXPLOSIVEZOMBIE: "Xác sống tự nổ",
  T_46_META_WS_E_EYE: "Kính mắt",
  T_46_META_WS_E_FACEPAINT: "Trang điểm",
  T_46_META_WS_E_FACTION: "Phe phái",
  T_46_META_WS_E_FALLING: "Rơi",
  T_46_META_WS_E_FALLINGSTAR: "Nhận vật phẩm tiêu thụ",
  T_46_META_WS_E_FALSE: "Không",
  T_46_META_WS_E_FAMAS: "FAMAS",
  T_46_META_WS_E_FAN: "Cơ chế cánh quạt",
  T_46_META_WS_E_FAR: "RangeFar",
  T_46_META_WS_E_FEATHER: "Lông vũ",
  T_46_META_WS_E_FEMALE: "Nữ",
  T_46_META_WS_E_FENCE: "Hàng rào",
  T_46_META_WS_E_FGL24: "FGL24",
  T_46_META_WS_E_FIGHTINGENTITY: "Thực thể chiến đấu",
  T_46_META_WS_E_FILLED: "Điền đầy",
  T_46_META_WS_E_FINISH: "Hoàn thành",
  T_46_META_WS_E_FINISHINGPOINT: "Điểm cuối",
  T_46_META_WS_E_FINISHLINEARCH: "Biểu ngữ đích đến",
  T_46_META_WS_E_FIRE: "Lửa",
  T_46_META_WS_E_FIRECHARGE: "Đạn lửa",
  T_46_META_WS_E_FIREWORK: "Pháo hoa",
  T_46_META_WS_E_FIRINGEFFECT: "VFX bắn súng",
  T_46_META_WS_E_FIRSTPERSON: "Camera góc nhìn thứ nhất",
  T_46_META_WS_E_FIRSTPERSONCLASSIC: "Camera góc nhìn thứ nhất (FF cổ điển)",
  T_46_META_WS_E_FIST: "Nắm đấm",
  T_46_META_WS_E_FIT: "Tự thích ứng",
  T_46_META_WS_E_FLAG: "Cờ",
  T_46_META_WS_E_FLAME: "Lửa",
  T_46_META_WS_E_FLAMEGUN: "FlameGun",
  T_46_META_WS_E_FLAMETHROWER: "Súng phun lửa",
  T_46_META_WS_E_FLASH: "Lựu choáng",
  T_46_META_WS_E_FLASHBANG: "Flashbang",
  T_46_META_WS_E_FLASHBANGSPARKS: "Lựu khói choáng",
  T_46_META_WS_E_FLASHFREEZE: "Lựu choáng băng",
  T_46_META_WS_E_FLEXWALL: "Tường co giãn",
  T_46_META_WS_E_FLICKER: "Nhấp nháy",
  T_46_META_WS_E_FLOWER: "Hoa",
  T_46_META_WS_E_FLYBOMBBEE: "Thây Ma Bay",
  T_46_META_WS_E_FLYPAN: "Cơ chế chảo",
  T_46_META_WS_E_FLYSHOE: "Flyshoe",
  T_46_META_WS_E_FOLDER: "Thư Mục",
  T_46_META_WS_E_FOLDWINGS: "Cánh Gập",
  T_46_META_WS_E_FOODTRUCK: "Xe bán đồ ăn nhỏ",
  T_46_META_WS_E_FOODTRUCKB: "Xe bán đồ ăn nhỏb",
  T_46_META_WS_E_FOOTBALL: "Bóng đá",
  T_46_META_WS_E_FOOTBALLGUN: "Máy bắn bóng",
  T_46_META_WS_E_FOOTBALLICE: "FootballIce",
  T_46_META_WS_E_FOOTBALLSHIELD: "FootballShield",
  T_46_META_WS_E_FOOTBALLSHOOTER: "Máy bắn bóng",
  T_46_META_WS_E_FORCE: "Lực tuyến tính",
  T_46_META_WS_E_FOREGRIP_MR: "FOREGRIP_MR",
  T_46_META_WS_E_FOREGRIP1: "Tay cầm trước 1",
  T_46_META_WS_E_FOREGRIP2: "Tay cầm trước 2",
  T_46_META_WS_E_FOREGRIP3: "Tay cầm trước 3",
  T_46_META_WS_E_FORWARD: "Tiến lên",
  T_46_META_WS_E_FOUNTAIN: "Đài phun nước",
  T_46_META_WS_E_FREE: "Tự do",
  T_46_META_WS_E_FREEZEALL: "Giới hạn dịch chuyển và xoay tất cả các trục",
  T_46_META_WS_E_FREEZEPOSITION: "Giới hạn dịch chuyển tất cả các trục",
  T_46_META_WS_E_FREEZEPOSITIONX: "Giới hạn dịch chuyển trục X",
  T_46_META_WS_E_FREEZEPOSITIONY: "Giới hạn dịch chuyển trục Y",
  T_46_META_WS_E_FREEZEPOSITIONZ: "Giới hạn dịch chuyển trục Z",
  T_46_META_WS_E_FREEZEROTATION: "Giới hạn xoay tất cả các trục",
  T_46_META_WS_E_FREEZEROTATIONX: "Giới hạn xoay trục X",
  T_46_META_WS_E_FREEZEROTATIONY: "Giới hạn xoay trục Y",
  T_46_META_WS_E_FREEZEROTATIONZ: "Giới hạn xoay trục Z",
  T_46_META_WS_E_FREEZEZONE: "Khu vực băng giá",
  "T_46_META_WS_E_FROST GALAXY": "Bầu trời cực quang",
  T_46_META_WS_E_FROZEN: "Đóng băng",
  T_46_META_WS_E_FROZENGRENADE: "Lựu choáng băng",
  T_46_META_WS_E_FUNCTIONALITEMS: "Vật phẩm chức năng",
  T_46_META_WS_E_FZLANTINGHEI: "FZLanTingHei",
  T_46_META_WS_E_G18: "G18",
  T_46_META_WS_E_G36: "G36",
  T_46_META_WS_E_GAME: "Trò chơi",
  T_46_META_WS_E_GAMEOVER: "Kết thúc 2",
  T_46_META_WS_E_GAMESTART: "Bắt đầu trò chơi",
  T_46_META_WS_E_GARAGE: "Gara",
  T_46_META_WS_E_GATLING: "Gatling",
  T_46_META_WS_E_GEARSWITCHEDON: "Kích hoạt cơ quan",
  T_46_META_WS_E_GENTLETAP: "Nhấp nhẹ",
  T_46_META_WS_E_GETITEM: "Nhận vật phẩm 2",
  T_46_META_WS_E_GFFLATIN: "GFFLatin",
  T_46_META_WS_E_GHOST: "Hồn ma",
  T_46_META_WS_E_GIANTDICE: "Xúc xắc",
  T_46_META_WS_E_GIANTLOLLIPOP: "Kẹo mút khổng lồ",
  T_46_META_WS_E_GIFT: "Quà tặng",
  T_46_META_WS_E_GLOOWALL: "Bom keo",
  T_46_META_WS_E_GOLD_HEATGUN_I: "GOLD_HEATGUN_I",
  T_46_META_WS_E_GOLD_HEATGUN_II: "GOLD_HEATGUN_II",
  T_46_META_WS_E_GOLD_HEATGUN_III: "GOLD_HEATGUN_III",
  T_46_META_WS_E_GOLD_M1014_I: "GOLD_M1014_I",
  T_46_META_WS_E_GOLD_M1014_II: "GOLD_M1014_II",
  T_46_META_WS_E_GOLD_M1014_III: "GOLD_M1014_III",
  T_46_META_WS_E_GOLD_SCAR_I: "GOLD_SCAR_I",
  T_46_META_WS_E_GOLD_SCAR_II: "GOLD_SCAR_II",
  T_46_META_WS_E_GOLD_SCAR_III: "GOLD_SCAR_III",
  T_46_META_WS_E_GOLDAWM: "GoldAWM",
  T_46_META_WS_E_GOLDFAMAS_I: "GoldFamas_I",
  T_46_META_WS_E_GOLDFAMAS_II: "GoldFamas_II",
  T_46_META_WS_E_GOLDFAMAS_III: "GoldFamas_III",
  T_46_META_WS_E_GOLDGROZA: "GoldGroza",
  T_46_META_WS_E_GOLDKAR98K_I: "GoldKar98K_I",
  T_46_META_WS_E_GOLDKAR98K_II: "GoldKar98K_II",
  T_46_META_WS_E_GOLDKAR98K_III: "GoldKar98K_III",
  T_46_META_WS_E_GOLDKAR98K_III_FORINFECTION: "GoldKar98K_III_ForInfection",
  T_46_META_WS_E_GOLDM14_I: "GoldM14_I",
  T_46_META_WS_E_GOLDM14_II: "GoldM14_II",
  T_46_META_WS_E_GOLDM14_III: "GoldM14_III",
  T_46_META_WS_E_GOLDM14_III_FORINFECTION: "GoldM14_III_ForInfection",
  T_46_META_WS_E_GOLDM4A1_I: "GoldM4A1_I",
  T_46_META_WS_E_GOLDM4A1_II: "GoldM4A1_II",
  T_46_META_WS_E_GOLDM4A1_III: "GoldM4A1_III",
  T_46_META_WS_E_GOLDM4A1_III_FORINFECTION: "GoldM4A1_III_ForInfection",
  T_46_META_WS_E_GOLDM60_I: "GoldM60_I",
  T_46_META_WS_E_GOLDM60_II: "GoldM60_II",
  T_46_META_WS_E_GOLDM60_III: "GoldM60_III",
  T_46_META_WS_E_GOLDM60_III_FORINFECTION: "GoldM60_III_ForInfection",
  T_46_META_WS_E_GOLDMP5_I: "GoldMP5_I",
  T_46_META_WS_E_GOLDMP5_II: "GoldMP5_II",
  T_46_META_WS_E_GOLDMP5_III: "GoldMP5_III",
  T_46_META_WS_E_GOLDMP5_III_FORINFECTION: "GoldMP5_III_ForInfection",
  T_46_META_WS_E_GOLDSVD: "GoldSVD",
  T_46_META_WS_E_GOLDVSS_I: "GoldVSS_I",
  T_46_META_WS_E_GOLDVSS_II: "GoldVSS_II",
  T_46_META_WS_E_GOLDVSS_III: "GoldVSS_III",
  T_46_META_WS_E_GRAFFITIFLOWERBED: "Bồn hoa chủ đề BIS",
  T_46_META_WS_E_GRAFFITIWALL: "Tường vẽ graffiti",
  T_46_META_WS_E_GRAPPLINGHOOKGUN: "Súng dây móc",
  T_46_META_WS_E_GREATCONDUCTOR: "Chỉ huy vĩ đại",
  T_46_META_WS_E_GREEN: "Màu xanh lá",
  T_46_META_WS_E_GRENADE: "Lựu đạn",
  T_46_META_WS_E_GRID: "Lưới",
  T_46_META_WS_E_GROZA: "GROZA",
  T_46_META_WS_E_GROZA2: "GROZA2",
  T_46_META_WS_E_GUARDTOWER: "Tháp pháo",
  T_46_META_WS_E_GUILD: "Quân đoàn",
  T_46_META_WS_E_GUN: "Súng",
  T_46_META_WS_E_GUNFIRE: "Súng lửa",
  T_46_META_WS_E_HALO: "Vầng hào quang",
  T_46_META_WS_E_HAMMER: "Cơ chế búa khổng lồ",
  T_46_META_WS_E_HANDCANNON: "Pháo cầm tay",
  T_46_META_WS_E_HANGER: "Giá phơi đồ",
  T_46_META_WS_E_HARD: "Khó",
  T_46_META_WS_E_HATTRICK: "Kỹ năng 8",
  T_46_META_WS_E_HAYSTACK: "Đống cỏ khô",
  T_46_META_WS_E_HEAD: "Phụ kiện đầu",
  T_46_META_WS_E_HEADSHOOT: "Headshot",
  T_46_META_WS_E_HEALINGGUN_SNIPER: "Súng ngắm điện",
  T_46_META_WS_E_HEALINGPISTOL_X: "Súng lục điện",
  T_46_META_WS_E_HEALPISTOL: "Súng hồi máu",
  T_46_META_WS_E_HEART: "Nhịp Tim",
  T_46_META_WS_E_HEARTBEAT: "Tim Đập",
  T_46_META_WS_E_HEATGUN: "Súng nhiệt",
  T_46_META_WS_E_HEAVYWEAPON: "Vũ Khí Hạng Nặng",
  T_46_META_WS_E_HELL: "Rất khó",
  T_46_META_WS_E_HELMET: "Mũ",
  T_46_META_WS_E_HELMET1: "Mũ1",
  T_46_META_WS_E_HELMET2: "Mũ2",
  T_46_META_WS_E_HELMET3: "Mũ3",
  T_46_META_WS_E_HEXAGON: "Lục giác",
  T_46_META_WS_E_HGAMMO: "Đạn HG",
  T_46_META_WS_E_HIDEANDSEEKFLAMETHROWER: "Súng Phun Lửa Trốn Tìm",
  T_46_META_WS_E_HIDERKILL: "Người tìm bị tiêu diệt",
  T_46_META_WS_E_HIHATS: "Đóng bẫy",
  T_46_META_WS_E_HINDSILIGURI: "HindSiliguri",
  T_46_META_WS_E_HITBLUNT: "Đòn đánh mạnh",
  T_46_META_WS_E_HITEFFECT: "Hiệu ứng trúng đạn",
  T_46_META_WS_E_HITFEEDBACK: "Phản hồi bắn",
  T_46_META_WS_E_HOOK: "Dây móc",
  T_46_META_WS_E_HOOKGUN: "Súng dây móc",
  T_46_META_WS_E_HOOKGUNAMMO: "Đạn HookGun",
  T_46_META_WS_E_HORIZALINE: "Bộ hồi phục",
  T_46_META_WS_E_HORIZONTAL: "Trình độ",
  T_46_META_WS_E_HORN: "Loa",
  T_46_META_WS_E_HORROR: "Kinh dị",
  T_46_META_WS_E_HOURGLASS: "Đồng hồ cát",
  T_46_META_WS_E_HOUSE: "Nhà ở",
  T_46_META_WS_E_HOUSEA: "Nhà một tầng",
  T_46_META_WS_E_HOUSEB: "Nhà hai tầng",
  T_46_META_WS_E_HOUSEC: "Nhà ba tầng",
  T_46_META_WS_E_HP: "HP",
  T_46_META_WS_E_HPBUFF: "Tăng HP",
  T_46_META_WS_E_HUT: "Nhà nhỏ",
  T_46_META_WS_E_ICEA: "Băng A",
  T_46_META_WS_E_ICEGUN: "Súng băng",
  T_46_META_WS_E_ICEWALLMAKER: "Máy tạo keo",
  T_46_META_WS_E_ICONOBJECT: "Biểu tượng",
  T_46_META_WS_E_IMAGEWIDGET: "Widget hình ảnh",
  T_46_META_WS_E_IMPULSE: "Va chạm",
  T_46_META_WS_E_INHALER: "Mặt nạ hồi phục",
  T_46_META_WS_E_INJUREDFEMALE: "Tiếng hét khi bị tấn công (nữ)",
  T_46_META_WS_E_INJUREDMALE: "Tiếng hét khi bị tấn công (nam)",
  T_46_META_WS_E_INK: "VFX Mực",
  T_46_META_WS_E_INPUTLABLEWIDGET: "Widget nhập văn bản",
  T_46_META_WS_E_INSECTCHIRPING: "Tiếng côn trùng kêu",
  T_46_META_WS_E_INTERVAL10SECONDS: "10 giây",
  T_46_META_WS_E_INTERVAL15SECONDS: "15 giây",
  T_46_META_WS_E_INTERVAL30SECONDS: "30 giây",
  T_46_META_WS_E_INTERVAL3SECONDS: "3 giây",
  T_46_META_WS_E_INTERVAL5SECONDS: "5 giây",
  T_46_META_WS_E_INTERVAL9999SECONDS: "9999 giây",
  T_46_META_WS_E_INVISIBLE: "Vô hình",
  T_46_META_WS_E_IPIPE: "Ống thẳng",
  T_46_META_WS_E_IRONFENCE: "Hàng rào",
  T_46_META_WS_E_IRONFENCEB: "Hàng rào B",
  T_46_META_WS_E_IRONPLATFORM: "Bàn sắt",
  T_46_META_WS_E_ITEMENTITY: "Máy tạo vật phẩm tiêu thụ",
  T_46_META_WS_E_JEEP: "Xe Jeep",
  T_46_META_WS_E_JERRYCAN: "Thùng dầu",
  T_46_META_WS_E_JERSEYMACHINE: "Máy bán áo đấu",
  T_46_META_WS_E_JOINEDGAMEDULL: "Tham gia trận chiến",
  T_46_META_WS_E_JOINGAME: "Tham gia trò chơi",
  T_46_META_WS_E_JOYSTICKWIDGET: "Điều khiển cần gạt",
  T_46_META_WS_E_JUMP: "Nhảy",
  T_46_META_WS_E_JUMPATTACK: "Nhảy chém",
  T_46_META_WS_E_JUSTPATROL: "Chỉ tuần tra",
  T_46_META_WS_E_KAR98K: "Kar98k",
  T_46_META_WS_E_KATANA: "Katana",
  T_46_META_WS_E_KEY: "Chìa khóa",
  T_46_META_WS_E_KICK: "Trống bass",
  T_46_META_WS_E_KILLINGTIPS: "Mẹo hạ gục",
  T_46_META_WS_E_KILLZONE: "Khu vực tiêu diệt",
  T_46_META_WS_E_KINEMATIC: "Động học",
  T_46_META_WS_E_KNIFE: "Dao",
  T_46_META_WS_E_KNOCKDOWN: "Hạ gục",
  T_46_META_WS_E_KNOCKEDDOWN: "Bị hạ gục",
  T_46_META_WS_E_KORD: "Kord",
  T_46_META_WS_E_LABELWIDGET: "Widget văn bản",
  T_46_META_WS_E_LANDINGA: "Sàn thang A",
  T_46_META_WS_E_LANDINGB: "Sàn thang B",
  T_46_META_WS_E_LANDINGC: "Sàn thang C",
  T_46_META_WS_E_LANDMINE: "Mìn",
  T_46_META_WS_E_LANUNCHERAMMO: "Đạn phóng lựu",
  T_46_META_WS_E_LASER: "Hiệu ứng laser",
  T_46_META_WS_E_LASERSKILL: "Kỹ năng laser",
  T_46_META_WS_E_LATTICESCREEN: "Màn hình",
  T_46_META_WS_E_LAWNA: "Bãi cỏ A",
  T_46_META_WS_E_LAWNB: "Bãi cỏ B",
  T_46_META_WS_E_LAYOUTWIDGET: "Bố trí điều khiển",
  T_46_META_WS_E_LEAD1A2: "Lead1A2",
  T_46_META_WS_E_LEAD1A2SHARP: "Lead1A2#",
  T_46_META_WS_E_LEAD1B2: "Lead1B2",
  T_46_META_WS_E_LEAD1C2: "Lead1C2",
  T_46_META_WS_E_LEAD1C2SHARP: "Lead1C2#",
  T_46_META_WS_E_LEAD1D2: "Lead1D2",
  T_46_META_WS_E_LEAD1D2SHARP: "Lead1D2#",
  T_46_META_WS_E_LEAD1E2: "Lead1E2",
  T_46_META_WS_E_LEAD1F2: "Lead1F2",
  T_46_META_WS_E_LEAD1F2SHARP: "Lead1F2#",
  T_46_META_WS_E_LEAD1G2: "Lead1G2",
  T_46_META_WS_E_LEAD1G2SHARP: "Lead1G2#",
  T_46_META_WS_E_LEAD2A2: "Lead2A2",
  T_46_META_WS_E_LEAD2A2SHARP: "Lead2A2#",
  T_46_META_WS_E_LEAD2B2: "Lead2B2",
  T_46_META_WS_E_LEAD2C2: "Lead2C2",
  T_46_META_WS_E_LEAD2C2SHARP: "Lead2C2#",
  T_46_META_WS_E_LEAD2D2: "Lead2D2",
  T_46_META_WS_E_LEAD2D2SHARP: "Lead2D2#",
  T_46_META_WS_E_LEAD2E2: "Lead2E2",
  T_46_META_WS_E_LEAD2F2: "Lead2F2",
  T_46_META_WS_E_LEAD2F2SHARP: "Lead2F2#",
  T_46_META_WS_E_LEAD2G2: "Lead2G2",
  T_46_META_WS_E_LEAD2G2SHARP: "Lead2G2#",
  T_46_META_WS_E_LEAD3A2: "Lead3A2",
  T_46_META_WS_E_LEAD3A2SHARP: "Lead3A2#",
  T_46_META_WS_E_LEAD3B2: "Lead3B2",
  T_46_META_WS_E_LEAD3C2: "Lead3C2",
  T_46_META_WS_E_LEAD3C2SHARP: "Lead3C2#",
  T_46_META_WS_E_LEAD3D2: "Lead3D2",
  T_46_META_WS_E_LEAD3D2SHARP: "Lead3D2#",
  T_46_META_WS_E_LEAD3E2: "Lead3E2",
  T_46_META_WS_E_LEAD3F2: "Lead3F2",
  T_46_META_WS_E_LEAD3F2SHARP: "Lead3F2#",
  T_46_META_WS_E_LEAD3G2: "Lead3G2",
  T_46_META_WS_E_LEAD3G2SHARP: "Lead3G2#",
  T_46_META_WS_E_LEAFLESSTREE: "Cây khô",
  T_46_META_WS_E_LEVELMAXED: "Tối đa",
  T_46_META_WS_E_LEVELUP: "Nâng cấp",
  T_46_META_WS_E_LEVELUPDISCARDED: "Nâng cấp",
  T_46_META_WS_E_LIGHTBEAM: "Tia sáng",
  T_46_META_WS_E_LIGHTBEAMPREDISCARDED: "Cột sáng",
  T_46_META_WS_E_LIGHTEFFECT: "Hiệu ứng ánh sáng",
  T_46_META_WS_E_LIGHTNING: "Sấm sét",
  T_46_META_WS_E_LIMB: "Tứ chi",
  T_46_META_WS_E_LINE: "Dây",
  T_46_META_WS_E_LIQUID: "Chất lỏng",
  T_46_META_WS_E_LOCAL: "Nội địa",
  T_46_META_WS_E_LOCALPOSITION: "Tọa độ nội địa",
  T_46_META_WS_E_LOCK: "Khóa",
  T_46_META_WS_E_LONGBOX: "Hộp gỗ dài",
  T_46_META_WS_E_LOOP: "Vòng lặp",
  T_46_META_WS_E_LOOTITEMBOX: "Vũ khí Loot",
  T_46_META_WS_E_LOOTITEMBOXAMMO: "Đạn Loot",
  T_46_META_WS_E_LOOTITEMBOXARMOR: "Giáp Loot",
  T_46_META_WS_E_LOOTITEMBOXCONSUMABLEITEM: "Vật phẩm tiêu thụ Loot",
  T_46_META_WS_E_LOOTITEMBOXPROJECTILE: "Lựu ném loot",
  T_46_META_WS_E_LOOTITEMBOXSIGHT: "Ống ngắm loot",
  T_46_META_WS_E_LOOTITEMBOXSOCCER: "Vật phẩm bóng đá Loot",
  T_46_META_WS_E_LOOTSOCCERICE: "Vật phẩm bóng đá băng Loot",
  T_46_META_WS_E_LOOTSOCCERRANDOM: "Vật phẩm bóng đá ngẫu nhiên Loot",
  T_46_META_WS_E_LOOTSOCCERSHIELD: "Lá chắn bóng đá Loot",
  T_46_META_WS_E_LOOTWEAPONRANDOM: "Vũ khí ngẫu nhiên Loot",
  T_46_META_WS_E_LOSE: "Thất bại",
  T_46_META_WS_E_LOUDSPEAKER: "Loa",
  T_46_META_WS_E_LOWFALLING: "Ngã thấp",
  T_46_META_WS_E_M1014: "M1014",
  T_46_META_WS_E_M10142: "M10142",
  T_46_META_WS_E_M14: "M14",
  T_46_META_WS_E_M1873: "M1873",
  T_46_META_WS_E_M1887: "M1887",
  T_46_META_WS_E_M18872: "M1887",
  T_46_META_WS_E_M1887X: "M1887",
  T_46_META_WS_E_M1917: "M1917",
  T_46_META_WS_E_M21A5: "M21A5",
  T_46_META_WS_E_M24: "M24",
  T_46_META_WS_E_M249: "M249",
  T_46_META_WS_E_M2492: "M249",
  T_46_META_WS_E_M4A1: "M4A1",
  T_46_META_WS_E_M500: "M500",
  T_46_META_WS_E_M60: "M60",
  T_46_META_WS_E_M79: "M79",
  T_46_META_WS_E_M79AMMO: "Lựu đạn M79",
  T_46_META_WS_E_M79AMMO_EXCLUSIVE: "Lựu đạn chuyên dụng M79",
  T_46_META_WS_E_MAC10: "MAC10",
  T_46_META_WS_E_MACHETE: "Đao",
  T_46_META_WS_E_MACHINEGUN: "Súng tiểu liên",
  T_46_META_WS_E_MAG7: "MAG-7",
  T_46_META_WS_E_MAG72: "MAG-7 2",
  T_46_META_WS_E_MAGEZINE1: "Băng đạn 1",
  T_46_META_WS_E_MAGEZINE2: "Băng đạn 2",
  T_46_META_WS_E_MAGEZINE3: "Băng đạn 3",
  T_46_META_WS_E_MAGMAA: "Dung nham A",
  T_46_META_WS_E_MAGNIFYINGGLASS: "Kính lúp",
  T_46_META_WS_E_MALE: "Nam",
  T_46_META_WS_E_MARK: "Đánh dấu",
  T_46_META_WS_E_MARKER: "Đánh dấu",
  T_46_META_WS_E_MASK: "Trang trí mặt",
  T_46_META_WS_E_MAXVALUE: "Giá trị tối đa",
  T_46_META_WS_E_MECHANICAL: "Tiếng va chạm kim loại dày đặc 2",
  T_46_META_WS_E_MECHANICALDEVICEECHO: "Tiếng vọng cơ khí",
  T_46_META_WS_E_MEDICALPROPS: "Dụng cụ y tế",
  T_46_META_WS_E_MEDICALTENT: "Lều y tế",
  T_46_META_WS_E_MEDIUMHEARTBEAT: "Hồi hộp",
  T_46_META_WS_E_MEDKIT: "Túi cứu thương",
  T_46_META_WS_E_MELEE: "Vũ khí cận chiến",
  T_46_META_WS_E_MELEEWEAPONS: "Vũ khí cận chiến",
  T_46_META_WS_E_MGL140: "MGL140",
  T_46_META_WS_E_MICROPHONE: "Microphone",
  T_46_META_WS_E_MIDDLE: "RangeMiddle",
  T_46_META_WS_E_MINIHANDLE: "MiniHandle",
  T_46_META_WS_E_MINIMAP: "UI Bản đồ nhỏ",
  T_46_META_WS_E_MINISENTRY: "Tháp phòng thủ",
  T_46_META_WS_E_MINVALUE: "Giá trị nhỏ nhất",
  T_46_META_WS_E_MISSILEEXPLODE: "Vũ khí loại tên lửa",
  T_46_META_WS_E_MISSIONCOMPLETE: "Thông báo nhiệm vụ thành công 1",
  T_46_META_WS_E_MISTAKE: "Lỗi",
  T_46_META_WS_E_MODERATE: "Trung bình",
  T_46_META_WS_E_MONEY: "Tiền",
  T_46_META_WS_E_MONSTER: "Xác sống",
  T_46_META_WS_E_MONSTERSPAWN: "Điểm sinh quái vật",
  T_46_META_WS_E_MONSTERTRUCK: "Xe Thính",
  T_46_META_WS_E_MOON: "Mặt trăng",
  T_46_META_WS_E_MOSQUITO: "Muỗi",
  T_46_META_WS_E_MOTIONTRAIL: "Đuôi xe",
  T_46_META_WS_E_MOTOBIKE: "Motobike",
  T_46_META_WS_E_MOTORBIKE: "Motorbike",
  T_46_META_WS_E_MOVE: "Di chuyển",
  T_46_META_WS_E_MOVEMENT: "Di chuyển",
  T_46_META_WS_E_MOVINGJOYSTICK: "Di chuyển cần điều khiển",
  T_46_META_WS_E_MP40: "MP40",
  T_46_META_WS_E_MP402: "MP402",
  T_46_META_WS_E_MP5: "MP5",
  T_46_META_WS_E_MRV: "Mr V",
  T_46_META_WS_E_MULTIPLIER: "Số nhân",
  T_46_META_WS_E_MULTIPLY: "Nhân",
  T_46_META_WS_E_MULTIPLYACCUMULATE: "Bộ tích lũy nhân",
  T_46_META_WS_E_MUSHROOM1: "Nấm1",
  T_46_META_WS_E_MUSHROOM2: "Nấm2",
  T_46_META_WS_E_MUSHROOM3: "Nấm3",
  T_46_META_WS_E_MUSHROOM4: "Nấm4",
  T_46_META_WS_E_MUSHSHADE: "Cụm Nấm Khổng Lồ",
  T_46_META_WS_E_MUSIC: "Âm nhạc",
  T_46_META_WS_E_MUZZLE1: "Nòng súng1",
  T_46_META_WS_E_MUZZLE2: "Nòng súng2",
  T_46_META_WS_E_MUZZLE3: "Nòng súng3",
  T_46_META_WS_E_NEAR: "Tầm gần",
  T_46_META_WS_E_NIGHT: "Ban đêm",
  T_46_META_WS_E_NOATTACK: "Không tấn công",
  T_46_META_WS_E_NODUALWIELDING: "Không thể cầm hai tay",
  T_46_META_WS_E_NOERROR: "Không lỗi",
  T_46_META_WS_E_NONE: "Không giới hạn",
  T_46_META_WS_E_NORMAL: "Bình thường",
  T_46_META_WS_E_NOSKIPKNOCKDOWN: "Không bỏ qua hạ gục",
  T_46_META_WS_E_NOTONASTALIQURDU: "NotoNastaliqUrdu",
  T_46_META_WS_E_NUTTYMOVEMENT: "Kỹ năng 7",
  T_46_META_WS_E_OBTAINEDCOINS: "Nhận Vàng",
  T_46_META_WS_E_OBTAINEDMANYCOINS: "Nhận Vàng lớn",
  T_46_META_WS_E_OBTAINEDSOMECOINS: "Nhận Vàng nhỏ",
  T_46_META_WS_E_OILDRUMEXPLODE: "Thùng dầu nổ",
  T_46_META_WS_E_ONCE: "Một lần",
  T_46_META_WS_E_ONEWAY: "Một hướng một lần",
  T_46_META_WS_E_OPENFOLDER: "Thư mục đã mở",
  T_46_META_WS_E_OPENHIHATS: "Chũm chọe đã mở",
  T_46_META_WS_E_OPENINGBOX: "Hộp đã mở",
  T_46_META_WS_E_OPENINGGUILDSUPPLY: "Hộp quà quân đoàn",
  T_46_META_WS_E_OPENINGWARCHEST: "Lưu trữ kho",
  T_46_META_WS_E_ORANGE: "Màu cam",
  T_46_META_WS_E_ORTHOGONAL: "Chính quy",
  T_46_META_WS_E_OUTPOST: "Phòng bảo vệ",
  T_46_META_WS_E_P90: "P90",
  T_46_META_WS_E_P902: "P902",
  T_46_META_WS_E_PAINTEDWALLS: "Tường vẽ",
  T_46_META_WS_E_PAINTSHIELDSKILL: "Kỹ năng hồ máu",
  T_46_META_WS_E_PALM: "Vải",
  T_46_META_WS_E_PANEL: "Bảng điều khiển",
  T_46_META_WS_E_PARAFAL: "PARAFAL",
  T_46_META_WS_E_PARAFAL2: "PARAFAL2",
  T_46_META_WS_E_PASSENGERA: "Ghế hành khách 1",
  T_46_META_WS_E_PASSENGERB: "Ghế hành khách 2",
  T_46_META_WS_E_PASSENGERC: "Ghế hành khách 3",
  T_46_META_WS_E_PASSIVE: "Bị động",
  T_46_META_WS_E_PASSIVESKILL: "Kỹ năng bị động",
  T_46_META_WS_E_PATROLWHILEATTACK: "Vừa tuần tra, vừa tấn công",
  T_46_META_WS_E_PERSONALUAV: "UAV cá nhân",
  T_46_META_WS_E_PERSPECTIVE: "Xuyên thấu",
  T_46_META_WS_E_PETTABBG: "Trợ thủ",
  T_46_META_WS_E_PHASESTART: "Bắt đầu giai đoạn",
  T_46_META_WS_E_PHONEBOOTH: "Bốt điện thoại",
  T_46_META_WS_E_PI: "Π",
  T_46_META_WS_E_PIANOA3: "PianoA3",
  T_46_META_WS_E_PIANOA3SHARP: "PianoA3#",
  T_46_META_WS_E_PIANOA4: "PianoA4",
  T_46_META_WS_E_PIANOA4SHARP: "PianoA4#",
  T_46_META_WS_E_PIANOB3: "PianoB3",
  T_46_META_WS_E_PIANOB4: "PianoB4",
  T_46_META_WS_E_PIANOC3: "PianoC3",
  T_46_META_WS_E_PIANOC3SHARP: "PianoC3#",
  T_46_META_WS_E_PIANOC4: "PianoC4",
  T_46_META_WS_E_PIANOC4SHARP: "PianoC4#",
  T_46_META_WS_E_PIANOD3: "PianoD3",
  T_46_META_WS_E_PIANOD3SHARP: "PianoD3#",
  T_46_META_WS_E_PIANOD4: "PianoD4",
  T_46_META_WS_E_PIANOD4SHARP: "PianoD4#",
  T_46_META_WS_E_PIANOE3: "PianoE3",
  T_46_META_WS_E_PIANOE4: "PianoE4",
  T_46_META_WS_E_PIANOF3: "PianoF3",
  T_46_META_WS_E_PIANOF3SHARP: "PianoF3#",
  T_46_META_WS_E_PIANOF4: "PianoF4",
  T_46_META_WS_E_PIANOF4SHARP: "PianoF4#",
  T_46_META_WS_E_PIANOG3: "PianoG3",
  T_46_META_WS_E_PIANOG3SHARP: "PianoG3#",
  T_46_META_WS_E_PIANOG4: "PianoG4",
  T_46_META_WS_E_PIANOG4SHARP: "PianoG4#",
  T_46_META_WS_E_PIANOKEY1: "Nốt nhạc - Piano",
  T_46_META_WS_E_PIANOKEY2: "Nốt nhạc - Piano",
  T_46_META_WS_E_PICKUPS: "Đồ nhặt",
  T_46_META_WS_E_PICKUPTRUCK: "SUV",
  T_46_META_WS_E_PILLAR: "Cột bê tông",
  T_46_META_WS_E_PIN: "Đánh dấu",
  T_46_META_WS_E_PINGPONG: "PingPong",
  T_46_META_WS_E_PIPECORNER: "Ống chuyển hướng",
  T_46_META_WS_E_PIPEINTERSECTION: "Ống chữ thập",
  T_46_META_WS_E_PISTOL: "Súng lục",
  T_46_META_WS_E_PISTOLAMMO: "Đạn súng lục",
  T_46_META_WS_E_PLAIDAMUSEMENTPARKCUBE: "Khối công viên giải trí caro",
  T_46_META_WS_E_PLASMA_X: "PLASMA_X",
  T_46_META_WS_E_PLAYER: "Người chơi",
  T_46_META_WS_E_PLUS: "Thêm",
  T_46_META_WS_E_PODIUM: "Bục nhận thưởng",
  T_46_META_WS_E_POISONGAS: "Khí độc",
  T_46_META_WS_E_POISONGASPREDISCARDED: "Khí độc",
  T_46_META_WS_E_PORTAL: "Cổng dịch chuyển",
  T_46_META_WS_E_POSTACCUMULATOR: "Bộ tích lũy sau",
  T_46_META_WS_E_POT: "Pot",
  T_46_META_WS_E_POUNDINGHEART: "Tim đập nhanh",
  T_46_META_WS_E_PREACCUMULATOR: "Bộ tích lũy trước",
  T_46_META_WS_E_PRIMARYWEAPONA: "Vũ khí chính 1",
  T_46_META_WS_E_PRIMARYWEAPONB: "Vũ khí chính 2",
  T_46_META_WS_E_PRIOREXPLOSION: "Trước khi bom nổ",
  T_46_META_WS_E_PROFILEWIDGET: "Widget hồ sơ",
  T_46_META_WS_E_PRONE: "Nằm",
  T_46_META_WS_E_PUMPKIN: "Bí ngô",
  T_46_META_WS_E_PURPLE: "Màu tím",
  T_46_META_WS_E_QUADRILATERAL: "Tứ giác",
  T_46_META_WS_E_QUESTIONMARK: "Dấu chấm hỏi",
  T_46_META_WS_E_QUICKCHAT: "UI Tin nhắn nhanh",
  T_46_META_WS_E_QUICKCHATSHOW: "UI Tin nhắn nhanh bên cạnh danh sách đội",
  T_46_META_WS_E_RADIAL180: "Hình quạt 180 độ",
  T_46_META_WS_E_RADIAL360: "Hình quạt 360 độ",
  T_46_META_WS_E_RADIAL90: "Hình quạt 90 độ",
  T_46_META_WS_E_RAMPAGE: "Rampage",
  T_46_META_WS_E_RANDOM: "Ngẫu nhiên",
  T_46_META_WS_E_RANDOMBUFF: "Buff ngẫu nhiên",
  T_46_META_WS_E_RANKDOWN: "Giáng hạng",
  T_46_META_WS_E_REACTION: "Phản hồi",
  T_46_META_WS_E_RECOVER: "Hồi phục",
  T_46_META_WS_E_RECYCLE: "Tái chế",
  T_46_META_WS_E_RED: "Đỏ",
  T_46_META_WS_E_REFINERYTANK: "Bình nước lớn",
  T_46_META_WS_E_REFLECTIVECUBE: "Khối cơ bản phản chiếu màu đơn 1",
  T_46_META_WS_E_REFRESH: "Làm mới",
  T_46_META_WS_E_RELEASINGSKILL: "Hiệu ứng kỹ năng",
  T_46_META_WS_E_RELOAD: "UI Thay đạn",
  T_46_META_WS_E_REMINDER: "Lời nhắc",
  T_46_META_WS_E_REPAIR: "Sửa chữa",
  T_46_META_WS_E_REPAIREQUIP: "Thiết bị sửa chữa",
  T_46_META_WS_E_REPAIRKIT: "Bộ sửa chữa",
  T_46_META_WS_E_REPLACER: "Bộ thay thế",
  T_46_META_WS_E_REPORT: "Báo Cáo",
  T_46_META_WS_E_REST: "Nghỉ Ngơi",
  T_46_META_WS_E_RG550: "RG550",
  T_46_META_WS_E_RIDES: "Chũm chọe",
  T_46_META_WS_E_RIDICULE: "Chế giễu",
  T_46_META_WS_E_RIDICULEFUNNY: "Chế giễu hài hước",
  T_46_META_WS_E_RIFLE: "Súng trường",
  T_46_META_WS_E_RIFLEAMMO: "Đạn Súng trường",
  T_46_META_WS_E_RIGHT: "Đối với",
  T_46_META_WS_E_RIGHTTRAPEZOID: "Hình thang vuông",
  T_46_META_WS_E_RING: "Cơ quan vòng tròn",
  T_46_META_WS_E_RINGPREDISCARDED: "Vòng tròn",
  T_46_META_WS_E_RIPTIDERHYTHM: "Kỹ năng 9",
  T_46_META_WS_E_RISINGPARTICLE: "Hạt nổi lên",
  T_46_META_WS_E_ROADBLOCK: "Chướng ngại vật",
  T_46_META_WS_E_ROTATE: "Xoay",
  T_46_META_WS_E_RUNNING: "Đang chạy",
  T_46_META_WS_E_RUSHTIME: "Bạo hành",
  T_46_META_WS_E_SAMURAI: "Xác sống Samurai",
  T_46_META_WS_E_SANDA: "Cát A",
  T_46_META_WS_E_SANDSTRUCTURE: "Tượng cát",
  T_46_META_WS_E_SCALE: "Thu phóng",
  T_46_META_WS_E_SCAR: "SCAR",
  T_46_META_WS_E_SCAR2: "SCAR2",
  T_46_META_WS_E_SCARECROW: "Bù Nhìn",
  T_46_META_WS_E_SCISSORS: "Kéo",
  T_46_META_WS_E_SCOPE2X: "Ống Ngắm 2x",
  T_46_META_WS_E_SCOPE4X: "Ống Ngắm 4x",
  T_46_META_WS_E_SCROLLPANEL: "Bảng cuộn",
  T_46_META_WS_E_SECONDARYWEAPON: "Vũ khí phụ",
  T_46_META_WS_E_SENSESSHOCKWAVE: "Kỹ năng 10",
  T_46_META_WS_E_SERVER: "Máy chủ",
  T_46_META_WS_E_SET: "Bộ trang phục",
  T_46_META_WS_E_SETTING: "Thiết lập",
  T_46_META_WS_E_SETTINGS: "UI Cài đặt",
  T_46_META_WS_E_SG: "Súng ngắn",
  T_46_META_WS_E_SGAMMO: "Đạn SN",
  T_46_META_WS_E_SHARPMECHANICAL: "Đạn dày đặc 1",
  T_46_META_WS_E_SHIELD: "Phòng thủ",
  T_46_META_WS_E_SHIELDBROKEN: "Tấn công phá khiên",
  T_46_META_WS_E_SHIELDGUN: "Súng Khiên",
  T_46_META_WS_E_SHIELDUP: "Tấn công giơ khiên",
  T_46_META_WS_E_SHOCKWAVE: "Sóng xung kích",
  T_46_META_WS_E_SHOES: "Giày",
  T_46_META_WS_E_SHOOTINGTARGET: "Mục tiêu di động",
  T_46_META_WS_E_SHORTDATE: "Ngày ngắn",
  T_46_META_WS_E_SHORTDATETIME: "Ngày giờ ngắn",
  T_46_META_WS_E_SHORTTIME: "Giờ ngắn",
  T_46_META_WS_E_SHOTGUN: "Đạn Shotgun",
  T_46_META_WS_E_SHOTGUNAMMO: "Đạn súng Shotgun",
  T_46_META_WS_E_SHOTGUNMUZZLE: "Nòng súng Shotgun",
  T_46_META_WS_E_SHOW: "Hiển thị",
  T_46_META_WS_E_SHRUB: "Thùng gỗ dài có bụi rậm",
  T_46_META_WS_E_SICKLE: "Sickle",
  T_46_META_WS_E_SIDESCROLLING: "Cuộn ngang",
  T_46_META_WS_E_SIGNAL: "UI tín hiệu",
  T_46_META_WS_E_SIGNOUT: "Thoát",
  T_46_META_WS_E_SILENCER: "Giảm thanh",
  T_46_META_WS_E_SIMPLE: "Đơn giản",
  T_46_META_WS_E_SIMPLEWIDGET: "Điều khiển nút",
  T_46_META_WS_E_SIMPLIFIEDARABIC: "SimplifiedArabic",
  T_46_META_WS_E_SINGLE: "Đơn lẻ",
  T_46_META_WS_E_SITEHUT: "Nhà container",
  T_46_META_WS_E_SKILLCHARGINGCOMPLETE: "Kỹ năng sạc đầy",
  T_46_META_WS_E_SKILLRECOVER: "Kỹ năng hồi phục",
  T_46_META_WS_E_SKIPKNOCKDOWN: "Bỏ qua hạ gục",
  T_46_META_WS_E_SKS: "SKS",
  T_46_META_WS_E_SLICED: "Bàn cờ 9 ô",
  T_46_META_WS_E_SLOPE: "Dốc",
  T_46_META_WS_E_SLOWHEARTBEAT: "Nhịp tim chậm",
  T_46_META_WS_E_SMG: "Súng tiểu liên",
  T_46_META_WS_E_SMGAMMO: "Đạn súng tiểu liên",
  T_46_META_WS_E_SMGMUZZLE: "Nòng súng tiểu liên",
  T_46_META_WS_E_SMILEY: "Mặt cười",
  T_46_META_WS_E_SMOKE: "Khói",
  T_46_META_WS_E_SMOKEGRENADE: "Lựu đạn khói",
  T_46_META_WS_E_SMOKEY: "Khói",
  T_46_META_WS_E_SMOOTH: "Tiến dần",
  T_46_META_WS_E_SNAMMO: "Đạn SN",
  T_46_META_WS_E_SNARES: "Trống quân đội",
  T_46_META_WS_E_SNEAKERS: "Hiệu ứng giày chạy",
  T_46_META_WS_E_SNIPER: "Súng ngắm",
  T_46_META_WS_E_SNIPERAMMO: "Đạn súng ngắm",
  T_46_META_WS_E_SNOWA: "Tuyết A",
  T_46_META_WS_E_SNOWFLAKE: "Bông tuyết",
  T_46_META_WS_E_SOCCER: "Bóng đá",
  T_46_META_WS_E_SOCIALBUTTONWIDGET: "Widget nút kết nối xã hội",
  T_46_META_WS_E_SOLARPANEL: "Pin năng lượng mặt trời",
  T_46_META_WS_E_SORTBYPRIORITYHIGHTOLOW: "Theo thứ tự ưu tiên từ cao đến thấp",
  T_46_META_WS_E_SORTBYPRIORITYLOWTOHIGH: "Theo thứ tự ưu tiên từ thấp đến cao",
  T_46_META_WS_E_SPAS12: "SPAS12",
  T_46_META_WS_E_SPAS122: "SPAS122",
  T_46_META_WS_E_SPAWNPOINT: "Hiệu ứng đặc biệt tại điểm hồi sinh",
  T_46_META_WS_E_SPEAKER: "Nút bật/tắt loa",
  T_46_META_WS_E_SPECIALFIRINGSOUND: "Âm thanh súng đặc biệt",
  T_46_META_WS_E_SPECIALGUN: "Súng đặc biệt",
  T_46_META_WS_E_SPHERE: "Quả cầu",
  T_46_META_WS_E_SPHERETRIGGER: "Kích hoạt va chạm quả cầu",
  T_46_META_WS_E_SPIDERWEB: "Hiệu ứng kỹ năng",
  T_46_META_WS_E_SPORTSCAR: "Siêu xe",
  T_46_META_WS_E_SPOTLIGHT: "Đèn",
  T_46_META_WS_E_SPREADOFPOISONGAS: "Lan tỏa khí độc",
  T_46_META_WS_E_SPRINT: "Chạy nhanh",
  T_46_META_WS_E_SQUARE: "Hình vuông",
  T_46_META_WS_E_SQUAREBOX: "Thùng gỗ hình vuông",
  T_46_META_WS_E_SR: "Súng ngắm",
  T_46_META_WS_E_STABLE: "Lều cỏ",
  T_46_META_WS_E_STAIRS: "Cầu thang",
  T_46_META_WS_E_STANDING: "Đứng",
  T_46_META_WS_E_STAR: "Ngôi sao",
  T_46_META_WS_E_STATIC: "Tĩnh",
  T_46_META_WS_E_STATUSTRIGGER: "Kích hoạt chết hoặc bất tử",
  T_46_META_WS_E_STEP: "Bước chân",
  T_46_META_WS_E_STEPTRIGGER: "Kích hoạt cơ quan",
  T_46_META_WS_E_STOCK_S: "STOCK_S",
  T_46_META_WS_E_STOCK_SR: "STOCK_SR",
  T_46_META_WS_E_STOCK1: "Stock1",
  T_46_META_WS_E_STOCK2: "Stock2",
  T_46_META_WS_E_STOCK3: "Stock3",
  T_46_META_WS_E_STONE: "Đá",
  T_46_META_WS_E_STONEBRIDGE: "Cầu vòm đá",
  T_46_META_WS_E_STONELANTERN: "Đèn lồng cung đình",
  T_46_META_WS_E_STONESPLASH: "Đá bắn tung tóe",
  T_46_META_WS_E_STORE: "Cửa hàng",
  T_46_META_WS_E_STREETLAMP: "Đèn đường",
  T_46_META_WS_E_STYLEA: "Kiểu một",
  T_46_META_WS_E_STYLEB: "Kiểu hai",
  T_46_META_WS_E_STYLEC: "Kiểu ba",
  T_46_META_WS_E_SUBMACHINEGUN: "Súng tiểu liên",
  T_46_META_WS_E_SUBMACHINEGUNAMMO: "Đạn súng tiểu liên",
  T_46_META_WS_E_SUCCESSFULHIT: "Bắn trúng",
  T_46_META_WS_E_SUN: "Mặt trời",
  T_46_META_WS_E_SUNSHADE: "Bộ bàn dù",
  T_46_META_WS_E_SUPERCAR: "Xe đua",
  T_46_META_WS_E_SUPERMARKET: "Siêu thị",
  T_46_META_WS_E_SURPRISEFIND: "Khám phá bất ngờ",
  T_46_META_WS_E_SUV: "SUV",
  T_46_META_WS_E_SVD: "SVD",
  T_46_META_WS_E_SVD2: "SVD2",
  T_46_META_WS_E_SWEAPWEAPONQUICK: "Nút đổi vũ khí nhanh",
  T_46_META_WS_E_SWIMRING: "Phao bơi",
  T_46_META_WS_E_SWORD: "Kiếm",
  T_46_META_WS_E_SYMBOLIC: "Dấu vết trên mặt đất",
  T_46_META_WS_E_TANKZOMBIE: "Quái khiên",
  T_46_META_WS_E_TAP: "Nhấp",
  T_46_META_WS_E_TAPPINGBUTTON: "Nhấp nút",
  T_46_META_WS_E_TAPPINGDISABLEDBUTTON: "Nhấp nút vô hiệu hóa",
  T_46_META_WS_E_TEAM: "Đội hình",
  T_46_META_WS_E_TEAMMATESINFO: "Giao diện thông tin đồng đội",
  T_46_META_WS_E_TELEPORT: "Vòng tròn",
  T_46_META_WS_E_TELEPORTCORRECT: "Âm thanh khi dịch chuyển đến khu vực đúng",
  T_46_META_WS_E_TELEPORTWRONG: "Âm thanh khi dịch chuyển đến khu vực sai",
  T_46_META_WS_E_TEXT: "Văn bản",
  T_46_META_WS_E_TEXTOBJECT: "Thực thể văn bản",
  T_46_META_WS_E_TEXTUREWIDGET: "Điều khiển hình ảnh",
  T_46_META_WS_E_THERMALSCOPE: "Kính nhiệt",
  T_46_META_WS_E_THIRDPERSON: "Camera góc nhìn thứ ba",
  T_46_META_WS_E_THIRDPERSONCLASSIC: "Camera góc nhìn thứ ba cổ điển",
  T_46_META_WS_E_THIRDPERSONLOCK: "Góc nhìn thứ ba (camera theo sau)",
  T_46_META_WS_E_THOMPSON: "THOMPSON",
  T_46_META_WS_E_THOMPSON2: "THOMPSON2",
  T_46_META_WS_E_THOWINGKNIFE2FORCOMPATIBILITY: "ThowingKnife2ForCompatibility",
  T_46_META_WS_E_THRILLBATTLE: "Kỹ năng 5",
  T_46_META_WS_E_THROWATTACK: "Lựu đạn",
  T_46_META_WS_E_THROWINGKNIFE: "Phi đao",
  T_46_META_WS_E_THROWREDZOMBIE: "Dị nhân ném zombie",
  T_46_META_WS_E_THROWZOMBIE: "Ném zombie",
  T_46_META_WS_E_THUMBSUP: "Thích",
  T_46_META_WS_E_THUNDER: "Điện giật",
  T_46_META_WS_E_TILEA: "Gạch men A",
  T_46_META_WS_E_TILEB: "Gạch men B",
  T_46_META_WS_E_TILEC: "Gạch men C",
  T_46_META_WS_E_TILED: "Lát sàn",
  T_46_META_WS_E_TIPSSOUND: "Hiển thị gợi ý",
  T_46_META_WS_E_TOGGLEWIDGET: "Chuyển đổi nút điều khiển",
  T_46_META_WS_E_TOILETBOWL: "Bồn cầu",
  T_46_META_WS_E_TONEA: "Tảng đá A",
  T_46_META_WS_E_TOP: "Trang phục trên",
  T_46_META_WS_E_TOPDOWN: "Góc nhìn từ trên xuống",
  T_46_META_WS_E_TORII: "Cổng Torii",
  T_46_META_WS_E_TOUCHPADWIDGET: "Bảng điều khiển cảm ứng",
  T_46_META_WS_E_TOWER: "Pháo đài",
  T_46_META_WS_E_TPIPE: "Đường ống chữ T",
  T_46_META_WS_E_TRACINGSTEPS: "Kỹ năng 3",
  T_46_META_WS_E_TRAILER: "Xe kéo",
  T_46_META_WS_E_TRANSFORMATION: "Biến hình",
  T_46_META_WS_E_TRANSPARENT: "Xuyên thấu",
  T_46_META_WS_E_TRAPEZOID: "Hình thang",
  T_46_META_WS_E_TRASHCAN: "Thùng rác",
  T_46_META_WS_E_TRIANGLE: "Hình tam giác",
  T_46_META_WS_E_TRIGGERS: "Kích hoạt",
  T_46_META_WS_E_TRIPLE: "Bắn ba phát",
  T_46_META_WS_E_TROPHY: "Cúp",
  T_46_META_WS_E_TRUE: "TRUE",
  T_46_META_WS_E_TUKTUK: "TukTuk",
  T_46_META_WS_E_TUTUCAR: "TukTuk",
  T_46_META_WS_E_TYRANTZOMBIE: "Zombie kéo",
  T_46_META_WS_E_UAVLITE: "UAV Lite",
  T_46_META_WS_E_UIFINISH: "Kết thúc",
  T_46_META_WS_E_UITAP: "Nhấp vào giao diện",
  T_46_META_WS_E_UMP: "UMP",
  T_46_META_WS_E_UMP2: "UMP2",
  T_46_META_WS_E_UNITGENERATOR: "Máy tạo đơn vị",
  T_46_META_WS_E_UPWARDTURBULENCE: "Luồng khí đi lên",
  T_46_META_WS_E_USP: "USP",
  T_46_META_WS_E_USP_2: "USP_2",
  T_46_META_WS_E_UZI: "UZI",
  T_46_META_WS_E_VAULTOVER: "Nhảy Qua Cửa Sổ",
  T_46_META_WS_E_VECTOR: "Vector",
  T_46_META_WS_E_VEHICLE: "Phương tiện",
  T_46_META_WS_E_VEHICLEEXPLODE: "Phương tiện nổ",
  T_46_META_WS_E_VELOCITY: "Tốc độ",
  T_46_META_WS_E_VENDINGMACHINE: "Máy bán hàng tự động",
  T_46_META_WS_E_VERTICAL: "Dọc",
  T_46_META_WS_E_VEST: "Áo ba lỗ",
  T_46_META_WS_E_VEST1: "Vest1",
  T_46_META_WS_E_VEST2: "Vest2",
  T_46_META_WS_E_VEST3: "Giáp3",
  T_46_META_WS_E_VEST4: "Giáp4",
  T_46_META_WS_E_VISUALEFFECTS: "Hiệu ứng hình ảnh",
  T_46_META_WS_E_VSK94: "VSK94",
  T_46_META_WS_E_VSS: "VSS",
  T_46_META_WS_E_WALLA: "Tường A",
  T_46_META_WS_E_WALLBRAWL: "Kỹ năng 2",
  T_46_META_WS_E_WARNING: "Cảnh báo",
  T_46_META_WS_E_WATERRING: "Nước bắn",
  T_46_META_WS_E_WAVE1: "Wave 1",
  T_46_META_WS_E_WAVE2: "Wave2",
  T_46_META_WS_E_WAVE3: "Wave3",
  T_46_META_WS_E_WEAPONGENERATOR: "Thực thể vũ khí",
  T_46_META_WS_E_WEAPONSLOT: "Giao diện thanh vũ khí",
  T_46_META_WS_E_WHISTLE: "Đánh bại kẻ địch",
  T_46_META_WS_E_WIDERANGE: "Phạm vi rộng",
  T_46_META_WS_E_WIN: "Chiến thắng",
  T_46_META_WS_E_WINDATTACK: "Xoáy kiếm",
  T_46_META_WS_E_WOODA: "Gỗ A",
  T_46_META_WS_E_WOODCUTZOMBIE: "Zombie cầm rìu",
  T_46_META_WS_E_WOODENPLANK: "Cầu gỗ",
  T_46_META_WS_E_WORLDPOSITION: "Tọa độ thế giới",
  T_46_META_WS_E_WRECKEDBUS: "Xe buýt hỏng",
  T_46_META_WS_E_WRECKEDCAR: "Xe hơi hỏng",
  T_46_META_WS_E_WRONG: "Sai",
  T_46_META_WS_E_XM8: "XM8",
  T_46_META_WS_E_XM82: "XM82",
  T_46_META_WS_E_ZOMBIE: "Thực thể zombie",
  T_46_META_WS_E_ZOMBIES: "Zombie",
  T_46_META_WS_E_ZOOM: "Phóng to",
  T_46_META_WS_ELIMINATE: "Tiêu diệt",
  T_46_META_WS_ELIMINATEDENTITY: "Đối tượng bị tiêu diệt",
  T_46_META_WS_ELIMINATEDPLAYER: "Người chơi bị tiêu diệt",
  T_46_META_WS_ENABLEDEFAULTBTREE: "Kích hoạt cây hành vi mặc định",
  T_46_META_WS_ENABLEMOVINGSAFEZONE: "Mở Vùng an toàn di động",
  T_46_META_WS_ENABLESAFEZONE: "Mở Vùng an toàn",
  T_46_META_WS_ENDCURRENTPHASE: "Kết thúc giai đoạn hiện tại",
  T_46_META_WS_ENDMORPH: "Khôi phục hình ảnh ban đầu",
  T_46_META_WS_ENDPOSITION: "Vị trí",
  T_46_META_WS_ENTERVEHICLE: "Lên xe",
  T_46_META_WS_ENTITY: "Thực thể",
  T_46_META_WS_EQUIPMENTID: "ID trang bị",
  T_46_META_WS_EULERANGLETOQUATERNION: "Chuyển góc Euler sang Quaternion",
  T_46_META_WS_EXITVEHICLE: "Bắt buộc xuống xe",
  T_46_META_WS_EXPONENTIATION: "Tính lũy thừa",
  T_46_META_WS_FILTERENTITY: "Bộ lọc thực thể",
  T_46_META_WS_FILTERLEVELOBJECTS: "Lọc vật phẩm bản đồ",
  T_46_META_WS_FIND: "Tìm kiếm Chuỗi",
  T_46_META_WS_FINDAT: "Truy cập giá trị trong chuỗi",
  T_46_META_WS_FINDPATH: "Tìm đường",
  T_46_META_WS_FLOOR: "Làm tròn xuống",
  T_46_META_WS_FOOTBALLGOAL: "Khung thành",
  T_46_META_WS_FORMAT: "Định dạng chuỗi",
  T_46_META_WS_GETALLKEYS: "Lấy tất cả khóa",
  T_46_META_WS_GETALLPLAYERS: "Lấy tất cả người chơi",
  T_46_META_WS_GETALLSHOPS: "Lấy tất cả cửa hàng",
  T_46_META_WS_GETALLTEAMS: "Lấy tất cả đội",
  T_46_META_WS_GETATTACKABLEENTITY: "Lấy mục tiêu có thể tấn công của Thực thể",
  T_46_META_WS_GETATTACKABLEFACTIONS: "Lấy mục tiêu có thể tấn công của phe",
  T_46_META_WS_GETBACKPACKSKIN: "Lấy skin Balo",
  T_46_META_WS_GETBLACKBOARDVALUE: "Lấy Biến bảng đen",
  T_46_META_WS_GETBUFFS: "Lấy Buff",
  T_46_META_WS_GETCHATCHANNEL: "Lấy kênh thoại",
  T_46_META_WS_GETCHILDBYINDEX: "Lấy nút con theo chỉ mục",
  T_46_META_WS_GETCHILDBYNAME: "Lấy nút con theo tên",
  T_46_META_WS_GETCHILDREN: "Lấy tất cả nút con",
  T_46_META_WS_GETCOLORCHANNEL: "Lấy giá trị màu (kênh RGBA)",
  T_46_META_WS_GETCONSUMABLES: "Lấy vật phẩm trong Balo",
  T_46_META_WS_GETCULLINGMASK: "Lấy lớp mặt nạ máy ảnh",
  T_46_META_WS_GETCURRENTCAMERA: "Lấy máy ảnh hiện tại",
  T_46_META_WS_GETCURRENTCHATCHANNEL: "Lấy kênh hiện tại của người chơi",
  T_46_META_WS_GETCUSTOMMISSIONPROGRESS: "Lấy tiến độ nhiệm vụ tùy chỉnh",
  T_46_META_WS_GETDYEDCOUNT: "Lấy số lượng nhuộm",
  T_46_META_WS_GETDYEDSTATUS: "Lấy trạng thái nhuộm màu",
  T_46_META_WS_GETEQUIPMENTS: "Lấy vật phẩm trong trang bị balo",
  T_46_META_WS_GETFACTION: "Lấy phe phái",
  T_46_META_WS_GETGLOBALSLEEPTHRESHOLD: "Lấy ngưỡng ngủ toàn cầu",
  T_46_META_WS_GETITEMCOUNT: "Lấy số lượng vật phẩm",
  T_46_META_WS_GETLOADEDSCENES: "Lấy cảnh đã tải",
  T_46_META_WS_GETLOCALAIMDIRECTION: "Lấy hướng ngắm mục tiêu địa phương",
  T_46_META_WS_GETLOCALPLAYER: "Lấy người chơi hiện tại",
  T_46_META_WS_GETLOCALTIMESTAMP: "Lấy dấu thời gian địa phương",
  T_46_META_WS_GETMAPID: "Lấy ID bản đồ cảnh",
  T_46_META_WS_GETMINIMAP: "Lấy Minimap",
  T_46_META_WS_GETMONEY: "Lấy tiền tệ",
  T_46_META_WS_GETMONEYCOUNT: "Lấy số lượng tiền tệ",
  T_46_META_WS_GETMORPH: "Lấy Thực thể biến hình",
  T_46_META_WS_GETNODEVARIABLE: "Lấy tham số nút",
  T_46_META_WS_GETOUTFIT: "Lấy trang phục",
  T_46_META_WS_GETOWNER: "Lấy người sở hữu",
  T_46_META_WS_GETPARENT: "Lấy nút cha",
  T_46_META_WS_GETPOSITIONNEARTEAMMATE: "Lấy vị trí gần đồng đội",
  T_46_META_WS_GETRANDOMSPAWNPOSITION: "Lấy điểm xuất hiện ngẫu nhiên",
  T_46_META_WS_GETRESULTFROMCURVE: "Lấy giá trị tính toán qua Curve",
  T_46_META_WS_GETSCENESKYBOX: "Lấy hộp trời của cảnh",
  T_46_META_WS_GETSERVERREGION: "Lấy khu vực máy chủ",
  T_46_META_WS_GETSERVERTIMESTAMP: "Lấy dấu thời gian của máy chủ",
  T_46_META_WS_GETSKELETONPARTBYNAME: "Lấy bộ phận xương qua tên",
  T_46_META_WS_GETSKILLS: "Lấy kỹ năng",
  T_46_META_WS_GETSLEEPTHRESHOLD: "Lấy ngưỡng ngủ đông",
  T_46_META_WS_GETTOKENCOUNT: "Lấy dữ liệu token của người chơi",
  T_46_META_WS_GETTOKENCOUNTTODAY: "Lấy dữ liệu token hôm nay của người chơi",
  T_46_META_WS_GETTYPE: "Lấy loại Biến",
  T_46_META_WS_GETVEHICLESKIN: "Lấy skin xe",
  T_46_META_WS_GETWALLET: "Lấy ví",
  T_46_META_WS_GETWEAPONSKIN: "Lấy súng",
  T_46_META_WS_GETWIDGETBYPATH: "Lấy điều khiển qua đường dẫn",
  T_46_META_WS_GETWIDGETFROMCUSTOMUI: "Lấy điều khiển",
  T_46_META_WS_GIVEJAILBREAKITEM: "GiveJailBreakItem",
  T_46_META_WS_GIVEJAILBREAKREWARD: "GiveJailBreakReward",
  T_46_META_WS_HASAOISPECIALFOLLOW: "Có theo dõi đặc biệt của AOI không",
  T_46_META_WS_HASCOMPONENT: "Có tồn tại thành phần không",
  T_46_META_WS_HASSCRIPT: "Có tồn tại tập lệnh không",
  T_46_META_WS_HASTAG: "Có chứa nhãn không",
  T_46_META_WS_HELPEDPLAYER: "Người chơi được hỗ trợ",
  T_46_META_WS_HELPPLAYER: "Người chơi hỗ trợ",
  T_46_META_WS_HIDEAPPEARANCEGROUP: "Ẩn ngoại hình nhóm",
  T_46_META_WS_HITENTITY: "Đánh trúng Thực thể",
  T_46_META_WS_HITFLY: "Đánh bay",
  T_46_META_WS_HITNORMAL: "Trúng pháp tuyến",
  T_46_META_WS_HITOBJECT: "Trúng vật thể",
  T_46_META_WS_HITPOSITION: "Vị trí trúng đòn",
  T_46_META_WS_INDEXOF: "Kích hoạt vị trí xuất hiện đầu tiên của nguyên tố",
  T_46_META_WS_INFECTIONZOMBIEGROWUP: "Chế độ lây nhiễm zombie ",
  T_46_META_WS_INSERT: "Chèn vào",
  T_46_META_WS_ISATTACKABLE: "Có thể tấn công không",
  T_46_META_WS_ISCHATCHANNELEMPTY: "Kênh có trống không",
  T_46_META_WS_ISEQUAL: "Có giống nhau không",
  T_46_META_WS_ISFRIEND: "Có phải bạn bè không",
  T_46_META_WS_ISHIT: "Có trúng không",
  T_46_META_WS_ISINSIDEBOX: "Có trong hộp không",
  T_46_META_WS_ISINSIDECYLINDER: "Có trong trụ không",
  T_46_META_WS_ISINSIDESECTOR: "Có trong hình quạt không",
  T_46_META_WS_ISINSIDESPHERE: "Có trong hình cầu không",
  T_46_META_WS_ISSLEEPING: "Rigid body có đang ở trạng thái nghỉ không",
  T_46_META_WS_ISSUBTYPEOF: "Có cùng loại hoặc kế thừa hay không",
  T_46_META_WS_ITEM: "Vật phẩm",
  T_46_META_WS_ITEMID: "ID vật phẩm",
  T_46_META_WS_JOIN: "Kết nối chuỗi với định danh chỉ định",
  T_46_META_WS_JOINCHATCHANNEL: "Tham gia kênh chat",
  T_46_META_WS_JOINFACTION: "Tham gia phe phái",
  T_46_META_WS_LASTINDEXOF: "Kích hoạt vị trí xuất hiện cuối cùng của nguyên tố",
  T_46_META_WS_LENGTH: "Chiều dài",
  T_46_META_WS_LERP: "Lerp",
  T_46_META_WS_LOADSCENE: "Tải trường cảnh",
  T_46_META_WS_LOGARITHM: "Tính logarit",
  T_46_META_WS_LOGERROR: "In lỗi",
  T_46_META_WS_LOGINFO: "In thông báo",
  T_46_META_WS_LOGWARNING: "In cảnh báo",
  T_46_META_WS_LOOKROTATION: "Tạo góc xoay nhìn về hướng mục tiêu.",
  T_46_META_WS_MAGNITUDE: "Độ lớn",
  T_46_META_WS_MAKER: "Người gây ra",
  T_46_META_WS_MAX: "Max",
  T_46_META_WS_MECHANISM: "Cơ quan",
  T_46_META_WS_MIN: "Min",
  T_46_META_WS_MONSTERUSESKILL: "Sử dụng kỹ năng",
  T_46_META_WS_MORPHOBJECT: "Người chơi biến thành Thực thể",
  T_46_META_WS_MORPHTO: "Người chơi biến thành một vật thể trong cảnh",
  T_46_META_WS_MORPHTOBYITEMID: "Người chơi biến thành một vật thể trong cảnh",
  T_46_META_WS_MOVECCT: "Di chuyển bộ điều khiển Ảnh một lần",
  T_46_META_WS_MOVEPOSITION: "Di chuyển Thực thể",
  T_46_META_WS_MOVEROTATION: "Xoay vật thể cứng",
  T_46_META_WS_MULTIPLYQUATERNION: "Nhân quaternion",
  T_46_META_WS_MULTIRAYCAST: "Kiểm tra tia trả về nhiều đối tượng",
  T_46_META_WS_NEGATE: "Giá trị âm",
  T_46_META_WS_NEW: "Cấu tạo",
  T_46_META_WS_NODENAME: "Tên nút",
  T_46_META_WS_NORMALIZE: "Chuẩn hóa vector",
  T_46_META_WS_NOTIFYPLAYEFFECT: "Thông báo client phát hiệu ứng đặc biệt",
  T_46_META_WS_NOTIFYPLAYICONANIMATION: "Thông báo client phát hiệu ứng hoạt ảnh biểu tượng",
  T_46_META_WS_NOTIFYPLAYSOUND: "Thông báo phát âm thanh",
  T_46_META_WS_NOTIFYSHOWTIPS: "Thông báo hiển thị chữ nổi",
  T_46_META_WS_NUMTOSTRING: "Chuyển số thành Chuỗi",
  T_46_META_WS_ONACCESSEQUIPMENT: "Khi nhận được trang bị",
  T_46_META_WS_ONACCESSITEM: "Khi nhận được vật phẩm",
  T_46_META_WS_ONACCESSWEAPON: "Khi nhận được vũ khí",
  T_46_META_WS_ONACE: "Khi cả đội bị tiêu diệt",
  T_46_META_WS_ONAIMED: "Khi bị nhắm mục tiêu",
  T_46_META_WS_ONAIMING: "Khi nhắm mục tiêu",
  T_46_META_WS_ONASSIST: "Khi hỗ trợ",
  T_46_META_WS_ONATTACK: "Khi tấn công",
  T_46_META_WS_ONATTACKSTOP: "Khi ngừng tấn công",
  T_46_META_WS_ONAWAKE: "Khi Thực thể được tạo",
  T_46_META_WS_ONBEKNOCKEDDOWN: "Khi người chơi bị hạ gục",
  T_46_META_WS_ONBOUNCEDBYTIRE: "Khi bị lốp xe bật lên",
  T_46_META_WS_ONBOUNCEENTITY: "Khi Thực thể bật lên",
  T_46_META_WS_ONBUILTINBUTTONTAPPED: "Khi nút trong giao diện UI được nhấn",
  T_46_META_WS_ONBULLETHIT: "Khi đạn bắn trúng",
  T_46_META_WS_ONCAMERARAYCAST: "Máy khách kích hoạt kiểm tra tia camera",
  T_46_META_WS_ONCHARACTERCONTROLLERHIT: "Khi chạm vào Thực thể",
  T_46_META_WS_ONCHASE: "Khi truy đuổi",
  T_46_META_WS_ONCHASESTOP: "Khi dừng truy đuổi",
  T_46_META_WS_ONCLIPEND: "Khi đoạn phim hoàn thành",
  T_46_META_WS_ONCOLLISIONENTER: "Khi xảy ra va chạm",
  T_46_META_WS_ONCOLLISIONEXIT: "Khi va chạm kết thúc",
  T_46_META_WS_ONCOUNTDOWNFINISHED: "Khi đếm ngược kết thúc",
  T_46_META_WS_ONCREEP: "Khi người chơi nằm",
  T_46_META_WS_ONCROUCH: "Khi người chơi ngồi",
  T_46_META_WS_ONDEALDAMAGE: "Khi gây DMG",
  T_46_META_WS_ONDESTROY: "Khi thực thể bị phá hủy",
  T_46_META_WS_ONDISABLE: "Khi Thực thể không khả dụng",
  T_46_META_WS_ONDISCONNECT: "Khi mất kết nối",
  T_46_META_WS_ONDOUBLETAPPED: "Khi nhấp đúp",
  T_46_META_WS_ONDRAG: "Khi trượt",
  T_46_META_WS_ONDRAGEND: "Khi kết thúc trượt",
  T_46_META_WS_ONDRAGSTART: "Khi bắt đầu trượt",
  T_46_META_WS_ONDRIVED: "Khi phương tiện được thực thể điều khiển",
  T_46_META_WS_ONDRIVEVEHICLE: "Khi lái phương tiện",
  T_46_META_WS_ONDROPCONSUMABLE: "Khi vứt bỏ đạo cụ",
  T_46_META_WS_ONDROPPED: "Khi bị vứt bỏ",
  T_46_META_WS_ONDROPWEAPON: "Khi vứt bỏ vũ khí",
  T_46_META_WS_ONEACHLOOP: "Khi mỗi vòng lặp",
  T_46_META_WS_ONELIMINATE: "Khi tiêu diệt",
  T_46_META_WS_ONELIMINATED: "Khi bị tiêu diệt",
  T_46_META_WS_ONENABLE: "Khi Thực thể có sẵn",
  T_46_META_WS_ONEND: "Khi kết thúc phát",
  T_46_META_WS_ONENTERED: "Khi phương tiện bị thực thể xâm nhập",
  T_46_META_WS_ONENTERVEHICLE: "Khi vào phương tiện",
  T_46_META_WS_ONENTITYENTER: "Khi kích hoạt vào",
  T_46_META_WS_ONENTITYEXIT: "Khi kích hoạt rời",
  T_46_META_WS_ONEQUIPARMOR: "Khi trang bị giáp",
  T_46_META_WS_ONEQUIPED: "Khi được trang bị",
  T_46_META_WS_ONEQUIPWEAPON: "Khi trang bị vũ khí",
  T_46_META_WS_ONEXPLODE: "Khi nổ",
  T_46_META_WS_ONFALL: "Khi rơi",
  T_46_META_WS_ONFALLSTOP: "Khi kết thúc rơi",
  T_46_META_WS_ONFIRE: "Khi mỗi lần bắn",
  T_46_META_WS_ONFIXEDUPDATE: "Khi cập nhật khung cố định",
  T_46_META_WS_ONFOOTBALLCOLLIDED: "Khi bóng đá và Thực thể va chạm",
  T_46_META_WS_ONFRIENDSUPDATE: "Khi cập nhật quan hệ bạn bè",
  T_46_META_WS_ONGAMEEND: "Khi trò chơi kết thúc",
  T_46_META_WS_ONGAMEPAUSE: "Khi trò chơi tạm dừng",
  T_46_META_WS_ONGAMERESUME: "Khi trò chơi tiếp tục",
  T_46_META_WS_ONGAMESTART: "Khi trò chơi bắt đầu",
  T_46_META_WS_ONGOAL: "Khi ghi bàn",
  T_46_META_WS_ONHITBYBULLET: "Khi bị đạn bắn trúng",
  T_46_META_WS_ONHITFLY: "Khi bị đánh bay",
  T_46_META_WS_ONHITFLYENTITY: "Khi đánh bay Thực thể",
  T_46_META_WS_ONHOOKGUNFIRE: "Khi bắn",
  T_46_META_WS_ONIDLE: "Khi chờ đợi",
  T_46_META_WS_ONJAILBREAKAREABEGIN: "JailBreakArea Begin",
  T_46_META_WS_ONJAILBREAKAREAEND: "JailBreakArea End",
  T_46_META_WS_ONJAILBREAKPLAYERJOIN: "JailBreak Player Join",
  T_46_META_WS_ONJAILBREAKPLAYERQUIT: "JailBreak Player Quit",
  T_46_META_WS_ONJOINCHATCHANNELSUCCESSFULLY: "Khi tham gia kênh thoại thành công",
  T_46_META_WS_ONJOYSTICKMOVE: "Khi cần điều khiển di chuyển",
  T_46_META_WS_ONJOYSTICKPRESSED: "Khi nhấn",
  T_46_META_WS_ONJOYSTICKRELEASED: "Khi thả ra",
  T_46_META_WS_ONJUMP: "Khi người chơi nhảy lên",
  T_46_META_WS_ONJUMPSTOP: "Khi kết thúc nhảy",
  T_46_META_WS_ONLANDMINEACTIVE: "Khi mìn kích hoạt",
  T_46_META_WS_ONLANDMINETRIGGER: "Khi mìn kích nổ",
  T_46_META_WS_ONLEAVECHATCHANNEL: "Khi người chơi thoát kênh thoại",
  T_46_META_WS_ONLEAVEVEHICLE: "Khi rời khỏi phương tiện",
  T_46_META_WS_ONLEFT: "Khi phương tiện bị thực thể rời khỏi",
  T_46_META_WS_ONLEVELOBJECTBEMORPHED: "Khi vật phẩm trong cảnh bị biến hình",
  T_46_META_WS_ONMOVE: "Khi di chuyển",
  T_46_META_WS_ONNODEENTER: "Khi nút vào",
  T_46_META_WS_ONNODEEXIT: "Khi nút thoát",
  T_46_META_WS_ONPAUSE: "Khi tạm dừng phát",
  T_46_META_WS_ONPHASEEND: "Khi giai đoạn kết thúc",
  T_46_META_WS_ONPHASESTART: "Khi giai đoạn bắt đầu",
  T_46_META_WS_ONPICKEDUP: "Khi được nhặt",
  T_46_META_WS_ONPLAYERASSIST: "Khi người chơi hỗ trợ",
  T_46_META_WS_ONPLAYERBEELIMINATED: "Khi người chơi tử vong",
  T_46_META_WS_ONPLAYERBEKNOCKEDDOWN: "Khi người chơi bị hạ gục",
  T_46_META_WS_ONPLAYERDEALDAMAGE: "Khi người chơi gây DMG",
  T_46_META_WS_ONPLAYERELIMINATE: "Khi người chơi hạ gục đối thủ",
  T_46_META_WS_ONPLAYERENTER: "Khi người chơi vào kích hoạt",
  T_46_META_WS_ONPLAYERJOIN: "Khi người chơi tham gia trò chơi",
  T_46_META_WS_ONPLAYERJOINCHATCHANNELFAILURE: "Khi tham gia kênh thoại thất bại",
  T_46_META_WS_ONPLAYERLEAVE: "Khi người chơi rời khỏi kích hoạt",
  T_46_META_WS_ONPLAYERPURCHASEREQUEST: "Khi người chơi yêu cầu mua hàng",
  T_46_META_WS_ONPLAYERQUIT: "Khi người chơi thoát giữa chừng",
  T_46_META_WS_ONPLAYERRANKCHANGE: "Khi thứ hạng của người chơi thay đổi",
  T_46_META_WS_ONPLAYERREQUESTFORPURCHASEFULFILLED: "Khi yêu cầu mua hàng của người chơi được đáp ứng",
  T_46_META_WS_ONPLAYERREVIVED: "Khi người chơi hồi sinh",
  T_46_META_WS_ONPLAYERREVIVEDINSPAWNPOS: "Khi người chơi hồi sinh",
  T_46_META_WS_ONPLAYERSCORECHANGE: "Khi điểm của người chơi thay đổi",
  T_46_META_WS_ONPLAYERSWITCHSCENE: "Khi người chơi chuyển cảnh",
  T_46_META_WS_ONPREDEALDAMAGE: "Khi gây DMG trước",
  T_46_META_WS_ONPREPURCHASE: "Khi mua hàng trong cửa hàng trước",
  T_46_META_WS_ONPRESSED: "Khi nhấn",
  T_46_META_WS_ONPRETAKEDAMAGE: "Khi nhận DMG trước",
  T_46_META_WS_ONPURCHASE: "Khi mua hàng trong cửa hàng",
  T_46_META_WS_ONRANKCHANGED: "Khi thứ hạng Thực thể thay đổi",
  T_46_META_WS_ONRECONNECT: "Khi kết nối lại",
  T_46_META_WS_ONRELEASED: "Khi nâng lên",
  T_46_META_WS_ONRELOAD: "Khi thay đạn vũ khí",
  T_46_META_WS_ONRESUME: "Khi tiếp tục phát",
  T_46_META_WS_ONREVIVED: "Khi hồi sinh",
  T_46_META_WS_ONROUNDEND: "Khi kết thúc lượt",
  T_46_META_WS_ONROUNDSTART: "Khi bắt đầu lượt",
  T_46_META_WS_ONSCENELOAD: "Khi tải cảnh",
  T_46_META_WS_ONSCENESWITCH: "Khi chuyển cảnh",
  T_46_META_WS_ONSCORECHANGE: "Khi điểm Thực thể thay đổi",
  T_46_META_WS_ONSHOTBYFOOTBALLSHOOTER: "Khi bị Máy bắn bóng bắn trúng",
  T_46_META_WS_ONSLEEP: "Khi đang ngủ đông",
  T_46_META_WS_ONSPAWN: "Khi Máy tạo thực thể tạo ra Thực thể",
  T_46_META_WS_ONSPRAY: "Khi bị súng sơn bắn trúng",
  T_46_META_WS_ONSPRAYED: "Khi bị bắn bởi súng sơn",
  T_46_META_WS_ONSPRINT: "Khi đang chạy nhanh",
  T_46_META_WS_ONSPRINTSTOP: "Khi kết thúc chạy nhanh",
  T_46_META_WS_ONSTANDUP: "Khi người chơi đứng dậy",
  T_46_META_WS_ONSTART: "Khi bắt đầu phát",
  T_46_META_WS_ONSTARTFIRE: "Khi bắt đầu khai hỏa",
  T_46_META_WS_ONSTATEEND: "Khi hoàn tất phát hoạt ảnh",
  T_46_META_WS_ONSURFING: "Khi sử dụng ván trượt nước",
  T_46_META_WS_ONSURFINGSTOP: "Khi kết thúc ván trượt nước",
  T_46_META_WS_ONSWITCHHANDHELD: "Khi chuyển đổi vật phẩm cầm tay",
  T_46_META_WS_ONTAKEDAMAGE: "Khi bị DMG",
  T_46_META_WS_ONTAPPED: "Khi nhấp",
  T_46_META_WS_ONTEAMACE: "Khi đội bị tiêu diệt hoàn toàn",
  T_46_META_WS_ONTEAMADD: "Khi thêm vào đội",
  T_46_META_WS_ONTEAMREMOVE: "Khi loại khỏi đội",
  T_46_META_WS_ONTEAMROUNDRANKCHANGE: "Khi thứ hạng đội thay đổi",
  T_46_META_WS_ONTEAMSCORECHANGE: "Khi điểm số đội thay đổi",
  T_46_META_WS_ONTELEPORTENTITY: "Khi truyền Thực thể",
  T_46_META_WS_ONTEXTCHANGE: "Khi văn bản thay đổi",
  T_46_META_WS_ONTHROWABLEEXPLODE: "Khi ném trúng và phát nổ",
  T_46_META_WS_ONTOGGLE: "Khi trạng thái thay đổi",
  T_46_META_WS_ONTOUCHDOWN: "Khi nhấn",
  T_46_META_WS_ONTOUCHUP: "Khi thả ra",
  T_46_META_WS_ONUIHIDE: "Khi đóng UI",
  T_46_META_WS_ONUISHOW: "Khi mở UI",
  T_46_META_WS_ONUPDATE: "Khi cập nhật",
  T_46_META_WS_ONUSEAVATARSKILL: "Khi sử dụng kỹ năng người chơi",
  T_46_META_WS_ONUSECONSUMABLE: "Khi sử dụng vật phẩm",
  T_46_META_WS_ONUSED: "Khi bị sử dụng",
  T_46_META_WS_ONUSEPORTAL: "Khi sử dụng cổng dịch chuyển",
  T_46_META_WS_ONWAKEUP: "Khi bị đánh thức",
  T_46_META_WS_ONWEAPONBEEQUIPED: "Khi vũ khí được trang bị",
  T_46_META_WS_ONWEAPONDEALDAMAGE: "Khi vũ khí gây sát thương",
  T_46_META_WS_ONWEAPONELIMINATE: "Khi vũ khí tiêu diệt đơn vị",
  T_46_META_WS_ONWEAPONSTOPFIRING: "Khi vũ khí ngừng bắn",
  T_46_META_WS_OWNER: "Người sở hữu",
  T_46_META_WS_P_ACCELERATE: "Tăng tốc",
  T_46_META_WS_P_ACCELERATION: "Gia tốc",
  T_46_META_WS_P_ACCOUNTID: "ID Tài khoản",
  T_46_META_WS_P_ACCURACY: "Tỷ lệ trúng",
  T_46_META_WS_P_ACTIONTYPE: "Chế độ tấn công",
  T_46_META_WS_P_ACTIVATEDALPHA: "Kích hoạt Alpha",
  T_46_META_WS_P_ACTIVE: "Kích hoạt",
  T_46_META_WS_P_ACTIVEINHIERARCHY: "Kích hoạt trong hệ thống",
  T_46_META_WS_P_ACTIVESELF: "Tự kích hoạt",
  T_46_META_WS_P_ACTIVETEXT: "Kích hoạt văn bản",
  T_46_META_WS_P_ACTUALPOSITION: "Vị trí thực tế",
  T_46_META_WS_P_AFTERACCUMULATOR: "Bộ tích lũy sau",
  T_46_META_WS_P_AIMASSISTCENTEROFFSET: "Có thể bị lệch so với tâm hỗ trợ ngắm",
  T_46_META_WS_P_AIMASSISTDISTANCE: "Khoảng cách hỗ trợ ngắm",
  T_46_META_WS_P_AIMASSISTTYPE: "Loại hỗ trợ ngắm",
  T_46_META_WS_P_AIRDROPSTATE: "Trạng thái thính rơi",
  T_46_META_WS_P_ALIGNMENTHORIZONTAL: "Căn chỉnh ngang",
  T_46_META_WS_P_ALIGNMENTVERTICAL: "Căn chỉnh dọc",
  T_46_META_WS_P_ALLITEMS: "Tất cả vật phẩm",
  T_46_META_WS_P_ALLMEMBERS: "Tất cả thành viên",
  T_46_META_WS_P_ALLOWLOCKBYAIMASSIST: "Có thể bị khóa tâm bởi hỗ trợ nhắm không",
  T_46_META_WS_P_ALLOWPRESSEDOUTSIDE: "Cho phép kích hoạt ngoài khu vực",
  T_46_META_WS_P_ALLPLAYERS: "Tất cả người chơi",
  T_46_META_WS_P_ALLTEAMMATES: "Tất cả đồng đội",
  T_46_META_WS_P_ALPHA: "Alpha",
  T_46_META_WS_P_ALWAYSSHOWMARK: "Luôn hiển thị trên thước đo",
  T_46_META_WS_P_AMBIENTCOLOR: "Màu sắc ánh sáng môi trường",
  T_46_META_WS_P_AMMOCLIPSIZE: "Điều chỉnh số lượng băng đạn",
  T_46_META_WS_P_AMMOMAGSIZE: "Số lượng đạn trong băng",
  T_46_META_WS_P_AMMOPERSHOT: "Số lượng đạn bắn mỗi lần",
  T_46_META_WS_P_AMMOTYPE: "Loại đạn",
  T_46_META_WS_P_ANCHORMAX: "Giá trị tối đa của điểm neo",
  T_46_META_WS_P_ANCHORMIN: "Giá trị tối thiểu của điểm neo",
  T_46_META_WS_P_ANCHOROBJECT: "Đối tượng điểm neo",
  T_46_META_WS_P_ANCHORPOSITION: "Tọa độ điểm neo",
  T_46_META_WS_P_ANCHORTYPE: "Kiểu điểm neo",
  T_46_META_WS_P_ANGLE: "Góc xoay",
  T_46_META_WS_P_ANGLEDOWN: "Góc xuống",
  T_46_META_WS_P_ANGLEUP: "Góc lên",
  T_46_META_WS_P_ANGULARDRAG: "Góc kéo",
  T_46_META_WS_P_ANGULARSPEED: "Tốc độ góc",
  T_46_META_WS_P_ANGULARVELOCITY: "Vận tốc góc góc (rad/s)",
  T_46_META_WS_P_ANIMATIONCLIP: "Tên hoạt ảnh",
  T_46_META_WS_P_ANIMATIONCONTROLLER: "Bộ điều khiển hoạt ảnh",
  T_46_META_WS_P_ANIMATIONCONTROLLERRESID: "ID tài nguyên bộ điều khiển hoạt ảnh",
  T_46_META_WS_P_ARMORPENETRATION: "Xuyên Giáp",
  T_46_META_WS_P_ARMORPENETRATIONFACTOR: "Hệ Số Xuyên Giáp",
  T_46_META_WS_P_ARMORTYPE: "Loại Trang Bị",
  T_46_META_WS_P_ARROWOFFSET: "Độ lệch mũi tên chỉ hướng",
  T_46_META_WS_P_ARROWSIZE: "Kích thước mũi tên chỉ hướng",
  T_46_META_WS_P_ARROWSPRITE: "Hình ảnh mũi tên chỉ hướng",
  T_46_META_WS_P_ASKBUYTARGET: "Yêu cầu mua mục tiêu",
  T_46_META_WS_P_ATTACHTARGET: "Mục tiêu đính kèm",
  T_46_META_WS_P_ATTACKABLEFACTIONS: "Phe có thể tấn công",
  T_46_META_WS_P_ATTACKDAMAGE: "Sát thương tấn công",
  T_46_META_WS_P_ATTACKINTERVAL: "Khoảng cách thời gian tấn công",
  T_46_META_WS_P_ATTACKRANGE: "Phạm vi tấn công",
  T_46_META_WS_P_ATTACKTARGET: "Đối tượng tấn công",
  T_46_META_WS_P_ATTTACKABLETARGETS: "Mục tiêu có thể tấn công",
  T_46_META_WS_P_AUTOPLAY: "Trạng thái tự động phát",
  T_46_META_WS_P_AVAILABLEPOINT: "Điểm khả dụng",
  T_46_META_WS_P_AVATAR: "Ảnh đại diện",
  T_46_META_WS_P_AVATARID: "ID Ảnh đại diện",
  T_46_META_WS_P_BACKGROUND: "Nền",
  T_46_META_WS_P_BACKGROUNDALPHA: "Độ trong suốt nền",
  T_46_META_WS_P_BACKGROUNDCOLOR: "Màu nền",
  T_46_META_WS_P_BACKGROUNDCOLOR1: "Màu nền 1",
  T_46_META_WS_P_BACKGROUNDCOLOR2: "Màu nền 2",
  T_46_META_WS_P_BACKGROUNDFILL: "Điền nền",
  T_46_META_WS_P_BACKGROUNDICONNAME: "Tên biểu tượng nền",
  T_46_META_WS_P_BACKGROUNDNAME: "Tên nền",
  T_46_META_WS_P_BACKGROUNDOFFSET: "Độ lệch nền",
  T_46_META_WS_P_BACKGROUNDRADIUS: "Bán kính nền",
  T_46_META_WS_P_BACKGROUNDSIZEDELTA: "Delta Kích cỡ nền",
  T_46_META_WS_P_BACKGROUNDSPRITE: "Sprite",
  T_46_META_WS_P_BACKPACK: "Balo người chơi",
  T_46_META_WS_P_BACKPACKSKINID: "ID skin Balo",
  T_46_META_WS_P_BACKWARDSPEED: "Tốc độ lùi (lực)",
  T_46_META_WS_P_BANNERID: "ID biểu ngữ",
  T_46_META_WS_P_BASEHORIZONTALSPEED: "Tốc độ ngang cơ bản",
  T_46_META_WS_P_BASEMULTIPLIER: "Hệ số cơ bản",
  T_46_META_WS_P_BASETIME: "Thời điểm bắt đầu",
  T_46_META_WS_P_BASEVERTICALSPEED: "Tốc độ dọc cơ bản",
  T_46_META_WS_P_BEFOREACCUMULATOR: "Bộ tích lũy trước",
  T_46_META_WS_P_BEVTREEID: "ID cây hành vi",
  T_46_META_WS_P_BINDPROPERTYID: "Thuộc tính mục tiêu",
  T_46_META_WS_P_BODY: "Thân",
  T_46_META_WS_P_BODYDAMAGEFACTOR: "Hệ số ST thân",
  T_46_META_WS_P_BONEPOSITION: "Vị trí xương",
  T_46_META_WS_P_BONESCALE: "Tỷ lệ xương",
  T_46_META_WS_P_BOOSTCD: "Hồi chiêu Tăng tốc",
  T_46_META_WS_P_BOOSTDURATION: "Thời gian duy trì Tăng tốc",
  T_46_META_WS_P_BOOSTSPEED: "Tốc độ Tăng tốc",
  T_46_META_WS_P_BORDERLR: "Biên trái phải",
  T_46_META_WS_P_BORDERTB: "Biên trên dưới",
  T_46_META_WS_P_BOTTOMALPHA: "Độ trong suốt nền",
  T_46_META_WS_P_BOUNDWALLET: "Liên kết ví",
  T_46_META_WS_P_BRAKEHORSEPOWER: "Lực phanh",
  T_46_META_WS_P_BRAKETORQUE: "Momen phanh",
  T_46_META_WS_P_BRRANK: "Hạng BR",
  T_46_META_WS_P_BUFFTYPE: "Loại Máy tạo thực thể Buff",
  T_46_META_WS_P_BURNDAMAGE: "DMG đốt cháy",
  T_46_META_WS_P_BURNINGDAMAGEINTERVAL: "Khoảng cách DMG đốt cháy",
  T_46_META_WS_P_BURNTIME: "Thời gian cháy",
  T_46_META_WS_P_BUTTOM: "Trang phục dưới",
  T_46_META_WS_P_BUTTONCOLORS: "Mảng màu nút",
  T_46_META_WS_P_BUTTONNAMES: "Mảng tên nút",
  T_46_META_WS_P_BUTTONSTYLE: "Kiểu dáng nút",
  T_46_META_WS_P_CAMERABLOCKMODE: "Chế độ che chắn máy ảnh",
  T_46_META_WS_P_CAMERAPROJECTIONMODE: "Loại chiếu máy ảnh",
  T_46_META_WS_P_CAMERATYPE: "Loại máy ảnh",
  T_46_META_WS_P_CANCELDRAGIFFITS: "Bỏ cuộn nếu vừa khung hình",
  T_46_META_WS_P_CANCOSTDURABILITY: "Có bị mất độ bền không",
  T_46_META_WS_P_CANDAMAGED: "Có nhận sát thương không không",
  T_46_META_WS_P_CANDESTROY: "Có thể phá hủy không",
  T_46_META_WS_P_CANDESTROYED: "Có thể bị phá hủy không",
  T_46_META_WS_P_CANSELFTRIGGER: "Có thể tự kích hoạt không",
  T_46_META_WS_P_CANTEAMTRIGGER: "Đồng đội có thể kích hoạt không",
  "T_46_META_WS_P_CANTRIGGEREDBY SELF": "Có thể tự kích hoạt không",
  "T_46_META_WS_P_CANTRIGGEREDBY TEAM": "Đồng đội có thể kích hoạt không",
  "T_46_META_WS_P_CANTRIGGEREDBY VEHICLE": "Phương tiện có thể kích hoạt không",
  T_46_META_WS_P_CANVEHICLETRIGGER: "Phương tiện có thể kích hoạt không",
  T_46_META_WS_P_CELLSIZE: "Chiều rộng và chiều cao của ô con",
  T_46_META_WS_P_CELLSPACE: "Khoảng cách giữa các ô con",
  T_46_META_WS_P_CENTER: "Trung tâm bản đồ",
  T_46_META_WS_P_CENTERINVISIBLE: "Trung tâm bản đồ không thể nhìn thấy",
  T_46_META_WS_P_CENTEROFFSET: "Độ lệch điểm trung tâm",
  T_46_META_WS_P_CENTEROFMASS: "Trọng tâm",
  T_46_META_WS_P_CENTERRANGE: "Phạm vi trung tâm",
  T_46_META_WS_P_CENTRALFLASHTIME: "Thời gian nhấp nháy trung tâm",
  T_46_META_WS_P_CENTRALLINEACTIVE: "Có hiển thị đường trung tâm không",
  T_46_META_WS_P_CENTRALLINEPOSITION: "Vị trí đường trung tâm",
  T_46_META_WS_P_CHANNELID: "ID Kênh chat",
  T_46_META_WS_P_CHARGEMAX: "Giới hạn số Bom Keo",
  T_46_META_WS_P_CHASETARGET: "Đối tượng bị AI truy đuổi",
  T_46_META_WS_P_CHATCHANNEL: "Thực thể kênh",
  T_46_META_WS_P_CHECKPOINTID: "ID Checkpoint",
  T_46_META_WS_P_CHILDINDEX: "Chỉ mục nút con",
  T_46_META_WS_P_CHIPEXP: "Chip kinh nghiệm máy tạo keo",
  T_46_META_WS_P_CLICKSIZE: "Nhấp vào khu vực",
  T_46_META_WS_P_CLIPLENGTH: "Độ dài clip",
  T_46_META_WS_P_CLIPPINGTYPE: "Kiểu Clip",
  T_46_META_WS_P_COLLIDERID: "ID tài nguyên va chạm",
  T_46_META_WS_P_CONSTRAIN: "Ràng buộc vật lý",
  T_46_META_WS_P_CONSTRAINT: "Giới hạn",
  T_46_META_WS_P_CONSTRAINTCOUNT: "Giới hạn số lượng",
  T_46_META_WS_P_CONSUMABLETYPE: "Loại đạo cụ",
  T_46_META_WS_P_CONTENT: "Nội dung",
  T_46_META_WS_P_CONTENTORIGIN: "Hướng ban đầu",
  T_46_META_WS_P_CONTROLPOINTS: "Điểm điều khiển",
  T_46_META_WS_P_COORDINATESYSTEM: "Hệ tọa độ",
  T_46_META_WS_P_COUNT: "Số lượng",
  T_46_META_WS_P_COUNTDOWNENDTIME: "Thời gian đếm ngược kết thúc (s)",
  T_46_META_WS_P_COUNTDOWNKEY: "Khóa đếm ngược",
  T_46_META_WS_P_COUNTDOWNTIME: "Thời lượng đếm ngược, tính bằng giây",
  T_46_META_WS_P_COUNTPERWAVE: "Số lượng mỗi đợt",
  T_46_META_WS_P_CRASHMAXDAMAGE: "Sát thương va chạm tối đa",
  T_46_META_WS_P_CRASHMAXSPEED: "Tốc độ va chạm tối đa",
  T_46_META_WS_P_CRASHMESSFACTOR: "Tham số khối lượng va chạm",
  T_46_META_WS_P_CRASHMINDAMAGE: "Sát thương va chạm tối thiểu",
  T_46_META_WS_P_CRAWLSPEEDSCALE: "Tỉ lệ giảm tốc độ di chuyển khi nằm",
  T_46_META_WS_P_CREATEDENTITY: "Thực thể được tạo ra",
  T_46_META_WS_P_CROUCHWALKSPEEDSCALE: "Tỉ lệ giảm tốc độ di chuyển khi ngồi",
  T_46_META_WS_P_CSRANK: "Hạng tử chiến",
  "T_46_META_WS_P_CURRENT AMMO": "Số đạn hiện tại",
  T_46_META_WS_P_CURRENTANIMATIONRESOURCE: "ID tài nguyên hoạt hình Hành động hiện tại",
  T_46_META_WS_P_CURRENTCLIP: "Clip hiện tại",
  T_46_META_WS_P_CURRENTCLIPPROGRESS: "Tiến độ phát Clip hiện tại",
  T_46_META_WS_P_CURRENTDURABILITY: "Độ bền hiện tại",
  T_46_META_WS_P_CURRENTENERGY: "Giá trị năng lượng hiện tại",
  T_46_META_WS_P_CURRENTHANDHELDITEM: "Vật phẩm hiện tại",
  T_46_META_WS_P_CURRENTHP: "Lượng HP hiện tại",
  T_46_META_WS_P_CURRENTPHASEINDEX: "Chỉ số giai đoạn hiện tại",
  T_46_META_WS_P_CURRENTPROGRESS: "Tiến độ hiện tại",
  T_46_META_WS_P_CURRENTROUNDINDEX: "Chỉ số lượt hiện tại",
  T_46_META_WS_P_CURRENTSTATE: "Trạng thái hiện tại",
  T_46_META_WS_P_CURRENTVALUE: "Giá trị hiện tại",
  T_46_META_WS_P_CURRENTWAVE: "Số đợt hiện tại",
  T_46_META_WS_P_CUSTOMCHARACTERRESOURCE: "Tài nguyên người chơi tùy chỉnh",
  T_46_META_WS_P_CUSTOMGAMERESULT: "Tùy chỉnh kết trận",
  T_46_META_WS_P_CUSTOMGRAVITY: "Tùy chỉnh trọng lực",
  T_46_META_WS_P_CUSTOMPUSHFORCE: "Tùy chỉnh lực đẩy",
  T_46_META_WS_P_CUSTOMXY: "Lượng kéo XY",
  T_46_META_WS_P_DAMAGE: "Sát thương",
  "T_46_META_WS_P_DAMAGE RANGE": "Phạm vi",
  T_46_META_WS_P_DAMAGEFACTOR: "Hệ số sát thương",
  T_46_META_WS_P_DAMAGEINTERVAL: "Khoảng sát thương (giây)",
  T_46_META_WS_P_DAMAGERADIUS: "Bán kính sát thương",
  T_46_META_WS_P_DAMAGERATIOHEAD: "Hệ số sát thương headshot",
  T_46_META_WS_P_DAMAGERATIOLIMB: "Hệ số sát thương tay chân",
  T_46_META_WS_P_DAMAGEREDUCTIONFACTOR: "Hệ số giảm sát thương",
  T_46_META_WS_P_DAMAGETAKENPCT: "Phần trăm sát thương nhận",
  T_46_META_WS_P_DAMAGETAKENPERCENT: "Phần trăm sát thương nhận",
  T_46_META_WS_P_DAMAGEVALUE: "Lượng sát thương",
  T_46_META_WS_P_DARKNESS: "Bóng tối toàn bản đồ",
  T_46_META_WS_P_DECELERATIONPERCENT: "Tỷ lệ giảm tốc",
  T_46_META_WS_P_DEFAULTTEXT: "Văn bản mặc định",
  T_46_META_WS_P_DEFENSE: "Phần trăm phòng thủ",
  T_46_META_WS_P_DEFENSERATE: "Tỉ lệ phòng thủ (0~1)",
  T_46_META_WS_P_DELTA: "Delta",
  T_46_META_WS_P_DELTATIME: "Khoảng cách khung logic",
  T_46_META_WS_P_DELTAVALUE: "Giá trị thay đổi",
  T_46_META_WS_P_DEPTH: "Tầng Hud",
  T_46_META_WS_P_DESC: "Mô tả",
  T_46_META_WS_P_DESCRIPTION: "Văn bản mô tả",
  T_46_META_WS_P_DESCRIPTIONKEY: "Thông tin mô tả Key",
  T_46_META_WS_P_DESCRIPTIONPARAMS: "Thông số mô tả thông tin gợi ý",
  T_46_META_WS_P_DESTVAL: "DestVal",
  T_46_META_WS_P_DETECTRANGE: "Phạm vi truy kích",
  T_46_META_WS_P_DIFFUSEALPHA: "Độ trong suốt bề mặt",
  T_46_META_WS_P_DIFFUSECOLOR: "Màu sắc bề mặt",
  T_46_META_WS_P_DIFFUSETEXTURE: "Kết cấu bề mặt",
  T_46_META_WS_P_DISABLECOLOR: "Màu bị cấm",
  T_46_META_WS_P_DISABLEFALLDAMAGE: "Miễn thương khi rơi",
  T_46_META_WS_P_DISABLEITEMDROP: "Tắt vứt bỏ vật phẩm",
  T_46_META_WS_P_DISABLEITEMPICKUP: "Tắt nhặt vật phẩm",
  T_46_META_WS_P_DISABLEMANUALCLOSING: "Tắt đóng thủ công",
  T_46_META_WS_P_DISABLEQUICKCHAT: "Tắt trò chuyện nhanh",
  T_46_META_WS_P_DISABLERECIPROCATING: "Tắt chuyển động qua lại",
  T_46_META_WS_P_DISABLEVOICECHAT: "Tắt voice chat",
  T_46_META_WS_P_DISTANCE: "Khoảng cách",
  T_46_META_WS_P_DOUBLEGUNTYPE: "Loại cầm hai tay",
  T_46_META_WS_P_DOWNEDCRAWLSPEEDSCALE: "Tỷ lệ thu nhỏ tốc độ di chuyển",
  T_46_META_WS_P_DOWNSPEED: "Tốc độ rơi",
  T_46_META_WS_P_DRAG: "Hệ số cản trở di chuyển",
  T_46_META_WS_P_DRIVER: "Người lái",
  T_46_META_WS_P_DROPITEMS: "Vật phẩm rơi",
  T_46_META_WS_P_DURABILITY: "Độ bền",
  T_46_META_WS_P_DURABILITYRECOVERY: "Phục hồi độ bền",
  T_46_META_WS_P_DURATION: "Thời gian duy trì",
  T_46_META_WS_P_EDGEFLASHTIME: "Thời gian cạnh nhấp nháy",
  T_46_META_WS_P_EFFECTACTIVE: "Hiển thị hiệu ứng đặc biệt",
  T_46_META_WS_P_EFFECTCOLOR: "Màu hiệu ứng",
  T_46_META_WS_P_EFFECTDURATION: "Thời gian hiệu ứng",
  T_46_META_WS_P_EFFECTIVETIMEINTERVAL: "Khoảng cách thời gian hiệu lực",
  T_46_META_WS_P_EFFECTRESID: "Đường dẫn tài nguyên",
  T_46_META_WS_P_ENABLE: "Bật",
  T_46_META_WS_P_ENABLEATTACK: "Bật tấn công",
  T_46_META_WS_P_ENABLEBOTREVIVE: "Bật hồi sinh cho bot",
  T_46_META_WS_P_ENABLEDEPTHMAP: "Bật bản đồ sâu",
  T_46_META_WS_P_ENABLEDROPONDEATH: "Bật rơi đồ khi chết",
  T_46_META_WS_P_ENABLELOCALIZATION: "Bật bản địa hóa",
  T_46_META_WS_P_ENABLEMOVEINMIDAIR: "Bật di chuyển trên không",
  T_46_META_WS_P_ENABLEPLAYERREVIVE: "Bật hồi sinh người chơi",
  T_46_META_WS_P_ENABLEPLAYERVIEW: "Bật xem trước người chơi",
  T_46_META_WS_P_ENABLEROTATEWITHGRAVITY: "Bật xoay theo trọng lực",
  T_46_META_WS_P_ENABLESKINATTRIBUTES: "Bật thuộc tính skin súng",
  T_46_META_WS_P_ENABLESWINGING: "Bật đu đưa",
  T_46_META_WS_P_ENABLETRACTION: "Bật sức kéo",
  T_46_META_WS_P_ENDPOSITION: "Vị trí đích",
  T_46_META_WS_P_ENDRADIUS: "Bán kính kết thúc",
  T_46_META_WS_P_ENDTIME: "Thời gian hết hiệu lực (giây)",
  T_46_META_WS_P_ENDTIMES: "Thời gian kết thúc",
  T_46_META_WS_P_ENDVALUE: "Giá trị cuối cùng",
  T_46_META_WS_P_ENERGY: "Giá trị sửa đổi EP",
  T_46_META_WS_P_ENERGYCOST: "Tiêu hao EP mỗi giây",
  T_46_META_WS_P_ENERGYRECOVERY: "Hồi EP mỗi giây",
  T_46_META_WS_P_ENGINEHORSEPOWER: "Công suất động cơ",
  T_46_META_WS_P_ENGINETORQUE: "Momen động cơ",
  T_46_META_WS_P_EP: "Bật HUD EP",
  T_46_META_WS_P_EPMAX: "EP tối đa",
  T_46_META_WS_P_EPRECOVERYAMOUNT: "Lượng hồi EP",
  T_46_META_WS_P_EVENTS: "Sự kiện",
  T_46_META_WS_P_EXPLODEDAMAGE: "Sát thương nổ",
  T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR: "Hệ số giảm ST nổ",
  T_46_META_WS_P_EXPLODEDELAY: "Độ trễ nổ",
  T_46_META_WS_P_EXPLODERANGE: "Phạm vi nổ",
  T_46_META_WS_P_EXPLOSIONDELAY: "Trì hoãn nổ",
  T_46_META_WS_P_EXPLOSIONRANGE: "Phạm vi vụ nổ",
  T_46_META_WS_P_EXPLOSIONTIME: "Thời gian nổ",
  T_46_META_WS_P_EXPPERDAMAGE: "Exp mỗi sát thương",
  T_46_META_WS_P_EXPPERMOVEMILE: "Exp mỗi khoảng cách di chuyển",
  T_46_META_WS_P_EXPPERSECOND: "Exp mỗi giây",
  T_46_META_WS_P_EXTRABACKPACKCAPACITY: "Sức chứa balo bổ sung",
  T_46_META_WS_P_EXTRABAGCAPACITY: "Không gian balo bổ sung",
  T_46_META_WS_P_EXTRAHPRATIO: "Tỉ lệ HP bổ sung",
  T_46_META_WS_P_FACEPAINT: "Vẽ mặt",
  T_46_META_WS_P_FACTION: "Thực thể phe",
  T_46_META_WS_P_FALLINGDAMAGERATIO: "Tỷ lệ ST rơi",
  T_46_META_WS_P_FALLSPEED: "Tốc độ rơi",
  T_46_META_WS_P_FASTAUTORELOADSPEED: "Tốc độ thay đạn tự động",
  T_46_META_WS_P_FILEID: "ID file",
  T_46_META_WS_P_FILL: "Điền vào",
  T_46_META_WS_P_FILLAMOUNT: "Giá trị điền vào",
  T_46_META_WS_P_FILLDIRECTION: "Hướng điền",
  T_46_META_WS_P_FILLTYPE: "Loại điền vào",
  T_46_META_WS_P_FIREANGLELIMIT: "Giới hạn góc bắn",
  T_46_META_WS_P_FIRETYPE: "Loại bắn",
  T_46_META_WS_P_FIRSTSCOREPARAMS: "Tham số điểm loại 1",
  T_46_META_WS_P_FIRSTSCORETITLE: "Tựa đề điểm loại 1",
  T_46_META_WS_P_FIRSTSCOREVALUE: "Key điểm loại 1",
  T_46_META_WS_P_FIXEDDELTATIME: "Khoảng cách cập nhật khung hình cố định",
  T_46_META_WS_P_FLASHBANGHITEFFECTSWITCH: "Bật tắt hiệu ứng trúng lựu choáng",
  T_46_META_WS_P_FLIP: "Lật",
  T_46_META_WS_P_FLIPTYPE: "Kiểu lật",
  T_46_META_WS_P_FLYMAXHEIGHT: "Độ cao bay tối đa",
  T_46_META_WS_P_FLYSPEEDHORIZONTAL: "Tốc độ bay theo chiều ngang",
  T_46_META_WS_P_FLYSPEEDVERTICAL: "Tốc độ bay theo chiều dọc",
  T_46_META_WS_P_FOGCOLOR: "Màu sương mù",
  T_46_META_WS_P_FOLLOWTARGET: "Theo mục tiêu",
  T_46_META_WS_P_FONT: "Phông chữ",
  T_46_META_WS_P_FONTSIZE: "Kích thước phông chữ",
  T_46_META_WS_P_FONTSTYLE: "Kiểu phông chữ",
  T_46_META_WS_P_FONTTYPE: "Phông chữ",
  T_46_META_WS_P_FORCESYNCTOCLIENT: "Đồng bộ bắt buộc trạng thái máy khách",
  T_46_META_WS_P_FORWARD: "Phía trước",
  T_46_META_WS_P_FORWARDSPEED: "Tốc độ tiến lên (Lực)",
  T_46_META_WS_P_FOV: "Trường Nhìn",
  T_46_META_WS_P_FREEZEDURATION: "Thời gian đóng băng (s)",
  T_46_META_WS_P_FRIENDFACTIONS: "Phe đồng minh",
  T_46_META_WS_P_FRIENDLYPLAYERS: "Người chơi đồng minh",
  T_46_META_WS_P_FULLDAMAGEDISTANCE: "Khoảng cách gây sát thương tối đa",
  T_46_META_WS_P_FUNCTIONTYPE: "Loại chức năng",
  T_46_META_WS_P_GAINHPCOLOR: "Màu HP tăng",
  T_46_META_WS_P_GAMEFRAMECOUNT: "Tổng số khung hình",
  T_46_META_WS_P_GAMETIMECOUNT: "Thời gian chơi",
  T_46_META_WS_P_GEARSHIFTINGDELAY: "Độ trễ chuyển đổi cấp độ",
  T_46_META_WS_P_GENDER: "Giới tính",
  T_46_META_WS_P_GETONBOOSTCD: "Hồi chiêu tăng tốc sau khi lên ván trượt",
  T_46_META_WS_P_GETONBOOSTCDSWITCH: "Bật/Tắt hồi chiêu tăng tốc sau khi lên Ván trượt",
  T_46_META_WS_P_GETONSKATEBOARDCD: "Hồi chiêu lên ván trượt",
  T_46_META_WS_P_GRADIENT: "Gradient",
  T_46_META_WS_P_GRADIENTBOTTOM: "Gradient dưới",
  T_46_META_WS_P_GRADIENTTOP: "Gradient trên",
  T_46_META_WS_P_GRAVITY: "Trọng lực",
  T_46_META_WS_P_GRENADEMAXDAMAGE: "ST lựu đạn tối đa",
  T_46_META_WS_P_GRENADEMINDAMAGE: "ST lựu đạn tối thiểu",
  T_46_META_WS_P_GRENADERANGE: "Phạm vi lựu đạn",
  T_46_META_WS_P_GROUPID: "GroupID",
  T_46_META_WS_P_HEAD: "Đầu",
  T_46_META_WS_P_HEADDAMAGEFACTOR: "Hệ số sát thương headsshot",
  T_46_META_WS_P_HEADSHOTDAMAGEREDUCTION: "Tỉ lệ giảm sát thương headshot",
  T_46_META_WS_P_HEIGHT: "Chiều cao",
  T_46_META_WS_P_HELMET: "Mũ",
  T_46_META_WS_P_HIGHESTBRRANK: "Xếp hạng Sinh tồn cao nhất",
  T_46_META_WS_P_HIGHESTCSRANK: "Xếp hạng Tử Chiến cao nhất",
  T_46_META_WS_P_HIGHSHOOTANGLEMIN: "Góc bắn cao tối thiểu",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLE: "Góc quay ở tốc độ cao",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED: "Góc chuyển hướng ở tốc độ cao",
  T_46_META_WS_P_HITPOINTEFFECT: "Hiệu ứng thanh máu",
  T_46_META_WS_P_HORIZONTALBAR: "Thanh ngang",
  T_46_META_WS_P_HORIZONTALOFFSET: "Độ lệch theo chiều ngang",
  T_46_META_WS_P_HOSTILETEAMS: "Đội địch",
  T_46_META_WS_P_HOSTTEAM: "Đội mình",
  T_46_META_WS_P_HP: "Máu hiện tại",
  T_46_META_WS_P_HPMAX: "Máu tối đa",
  T_46_META_WS_P_HPRECOVERYAMOUNT: "Lượng hồi HP",
  T_46_META_WS_P_HPRECOVERYSPEED: "Tốc độ hồi HP",
  T_46_META_WS_P_ICON: "Biểu tượng",
  T_46_META_WS_P_ICONCOLOR: "Màu biểu tượng",
  T_46_META_WS_P_ICONNAME: "Tên biểu tượng",
  T_46_META_WS_P_ICONRESOURCE: "Tài nguyên biểu tượng",
  T_46_META_WS_P_ID: "ID",
  "T_46_META_WS_P_IDAMAGE NTERVAL": "Khoảng sát thương (ms)",
  T_46_META_WS_P_IDLEBRAKEINPUT: "Tỷ lệ mã lực khi dừng điều khiển",
  T_46_META_WS_P_INACTIVATEDALPHA: "Alpha chưa kích hoạt",
  T_46_META_WS_P_INDEX: "Chỉ mục",
  T_46_META_WS_P_INITIALMAGCOUNT: "Số lượng đạn ban đầu",
  T_46_META_WS_P_INITIALSPEED: "Tốc độ ban đầu",
  T_46_META_WS_P_INITIALVALUE: "Giá trị khởi đầu",
  T_46_META_WS_P_INITIALWORLDPOSITION: "Vị trí thế giới ban đầu",
  T_46_META_WS_P_INSCENE: "Trong trường cảnh",
  T_46_META_WS_P_INSTANCEID: "ID thực thể",
  T_46_META_WS_P_INTENSITY: "Cường độ ánh sáng",
  T_46_META_WS_P_INVERTFILL: "Điền ngược",
  T_46_META_WS_P_INVINCIBLE: "Bất tử",
  "T_46_META_WS_P_IS SHOW": "Có hiển thị không",
  T_46_META_WS_P_IS3D: "Có phải 3D không",
  T_46_META_WS_P_ISACE: "Có tiêu diệt toàn bộ không",
  T_46_META_WS_P_ISACED: "Có bị tiêu diệt toàn bộ không",
  T_46_META_WS_P_ISAI: "Có phải là AI không",
  T_46_META_WS_P_ISALWAYSINSCREEN: "Có luôn trong màn hình không",
  T_46_META_WS_P_ISAPPLYSHADOW: "Có áp dụng bóng không",
  T_46_META_WS_P_ISATTACKABLE: "Có thể bị tấn công không",
  T_46_META_WS_P_ISAUTOCHASEENEMY: "Có tự động tìm mục tiêu không",
  T_46_META_WS_P_ISAUTOPLAY: "Có tự phát không",
  T_46_META_WS_P_ISAUTOTELEPORT: "Có tự động dịch chuyển không",
  T_46_META_WS_P_ISBILLBOARD: "Có phải là billboard không",
  T_46_META_WS_P_ISBOLD: "Có in đậm không",
  T_46_META_WS_P_ISBOTTOMCOLLIDING: "Có va chạm ở phần đáy không",
  T_46_META_WS_P_ISCENTERPOS: "Có phải là trung điểm không",
  T_46_META_WS_P_ISCONSUMEAMMO: "Có tiêu hao đạn không",
  T_46_META_WS_P_ISCONTINUOUS: "Có liên tục không",
  T_46_META_WS_P_ISCOUNTDOWN: "Có đếm ngược không",
  T_46_META_WS_P_ISCURRENTANIMATIONLOOP: "Có lặp lại hoạt ảnh hiện tại không",
  T_46_META_WS_P_ISDEADDROP: "Có rơi đồ khi chết không",
  T_46_META_WS_P_ISDEATHTRIGGER: "Có kích hoạt khi chết không",
  T_46_META_WS_P_ISDEBUG: "Bật Debug",
  T_46_META_WS_P_ISDEFAULTSPAWNPOINT: "Có phải là điểm xuất hiện mặc định không",
  T_46_META_WS_P_ISDROPONELIMINATED: "Có rơi trang bị khi chết không",
  T_46_META_WS_P_ISEND: "Có phải kết thúc không",
  T_46_META_WS_P_ISFEBUTTON: "Có phải nút FE không",
  T_46_META_WS_P_ISGREY: "Có chuyển xám không",
  T_46_META_WS_P_ISGROUNDED: "Có chạm đất không",
  T_46_META_WS_P_ISIGNOREDEPTH: "Có bỏ qua độ sâu không",
  T_46_META_WS_P_ISINVINCIBLE: "Có vô địch không",
  T_46_META_WS_P_ISITALIC: "Có in nghiên không",
  T_46_META_WS_P_ISLASTROUND: "Có phải vòng cuối không",
  T_46_META_WS_P_ISLOCALPOS: "Có phải vị trí cục bộ không",
  T_46_META_WS_P_ISLOOP: "Có lặp lại không",
  T_46_META_WS_P_ISMATCHPOINT: "Có phải là trận quyết định không",
  T_46_META_WS_P_ISMOVEABLE: "Có thể di chuyển không",
  T_46_META_WS_P_ISOCCUPIED: "Đã bị chiếm dụng chưa",
  T_46_META_WS_P_ISOPENTWEEN: "Kích hoạt hiệu ứng thay đổi HP",
  T_46_META_WS_P_ISPLAYING: "Trạng thái phát",
  T_46_META_WS_P_ISPURCHASABLE: "Có thể mua không",
  T_46_META_WS_P_ISREVERSE: "Đảo ngược",
  T_46_META_WS_P_ISSERVERDRIVEN: "Có do máy chủ điều khiển không",
  T_46_META_WS_P_ISSHOW: "Có hiển thị không",
  T_46_META_WS_P_ISSHOWHUDNAME: "Có hiển thị tên HUD không",
  T_46_META_WS_P_ISSHOWMAPINFO: "Có hiển thị thông tin bản đồ không",
  T_46_META_WS_P_ISSHOWQUICKMESSAGE: "Có hiển thị tin nhắn nhanh không",
  T_46_META_WS_P_ISSHOWSCAN: "Có hiển thị scan không",
  T_46_META_WS_P_ISSHOWTAG: "Có hiển thị tag không",
  T_46_META_WS_P_ISSIDECOLLIDING: "Có chạm vào bên cạnh không",
  T_46_META_WS_P_ISSILENCE: "Tắt tiếng không",
  T_46_META_WS_P_ISSINGLESHOT: "Có bắn từng phát không",
  T_46_META_WS_P_ISSKIPSTAGGERANIMATION: "Có bỏ qua khóa hoạt ảnh khi rơi không",
  T_46_META_WS_P_ISSLIDING: "Có đang trượt xuống không",
  T_46_META_WS_P_ISTOPCOLLIDING: "Có chạm vào phần trên không",
  T_46_META_WS_P_ISUNDERLINE: "Có gạch dưới không",
  T_46_META_WS_P_ISVISIBLE: "Có thể nhìn thấy không",
  T_46_META_WS_P_ITEMBACKGROUNDCOLORS: "Màu nền vật phẩm",
  T_46_META_WS_P_ITEMBACKGROUNDS: "Nền vật phẩm",
  T_46_META_WS_P_ITEMCOUNTS: "Số lượng vật phẩm",
  T_46_META_WS_P_ITEMDESCRIPTIONS: "Mô tả vật phẩm",
  T_46_META_WS_P_ITEMICONS: "Biểu tượng vật phẩm",
  T_46_META_WS_P_ITEMID: "ID vật phẩm",
  T_46_META_WS_P_ITEMIDS: "ID vật phẩm",
  T_46_META_WS_P_ITEMNAMES: "Tên vật phẩm",
  T_46_META_WS_P_ITEMPICKUPBANLIST: "Danh sách cấm nhặt vật phẩm",
  T_46_META_WS_P_JOYSTICKDRAGRADIUS: "Bán kính kéo cần điều khiển",
  T_46_META_WS_P_JOYSTICKIMAGE: "Hình ảnh cần điều khiển",
  T_46_META_WS_P_JOYSTICKRADIUS: "Bán kính cần điều khiển",
  T_46_META_WS_P_JUMPCD: "Thời gian hồi nhảy",
  T_46_META_WS_P_JUMPHEIGHT: "Độ cao nhảy",
  T_46_META_WS_P_JUMPHEIGHTSCALE: "Tỉ lệ độ cao nhảy",
  T_46_META_WS_P_KNOCKDOWNDAMAGEBONUS: "Sát thương thêm lên người bị hạ gục",
  T_46_META_WS_P_KNOCKDOWNSTATUS: "Trạng thái hạ gục",
  T_46_META_WS_P_LABEL: "Nhãn",
  T_46_META_WS_P_LABELCOLOR: "Màu nhãn",
  T_46_META_WS_P_LABELKEY: "Khóa nhãn",
  T_46_META_WS_P_LABELPARAMS: "Tham số nội dung nhãn",
  T_46_META_WS_P_LASTCHECKPOINTID: "ID điểm kiểm tra hiện tại",
  T_46_META_WS_P_LASTSURVIVALTIME: "Thời gian sống sót",
  T_46_META_WS_P_LAYERTYPE: "Kiểu layer",
  T_46_META_WS_P_LAYOUTTYPE: "Kiểu Layout",
  T_46_META_WS_P_LEFTARM: "Cánh tay trái",
  T_46_META_WS_P_LEFTBACKGROUNDCOLOR: "Màu nền bên trái",
  T_46_META_WS_P_LEFTCOLOR: "Màu bên trái",
  T_46_META_WS_P_LEFTDESCRIPTION: "Mô tả đội bên trái",
  T_46_META_WS_P_LEFTEFFECTACTIVE: "Hiển thị hiệu ứng bên trái",
  T_46_META_WS_P_LEFTFIRINGARCANGLE: "Góc bắn bên trái",
  T_46_META_WS_P_LEFTFOOT: "Chân trái",
  T_46_META_WS_P_LEFTHAND: "Tay trái",
  T_46_META_WS_P_LEFTICON: "Biểu tượng bên trái",
  T_46_META_WS_P_LEFTICONNAME: "Tên biểu tượng bên trái",
  T_46_META_WS_P_LEFTLEG: "Chân trái",
  T_46_META_WS_P_LEFTPLAYERS: "Mảng người chơi bên trái",
  T_46_META_WS_P_LEFTSCORE: "Điểm số bên trái",
  T_46_META_WS_P_LEFTSCOREAFTER: "Điểm cuối cùng bên trái",
  T_46_META_WS_P_LEFTSCORETEXT: "Văn bản điểm số bên trái",
  T_46_META_WS_P_LEFTTEAM: "Đội/Nhóm bên trái",
  T_46_META_WS_P_LEFTTEAMINDEX: "Chỉ số đội bên trái",
  T_46_META_WS_P_LEFTTEAMMATEALIVENUM: "Số người sống sót bên trái",
  T_46_META_WS_P_LEFTTEAMMATEFLAGCOUNT: "Số cờ của đội bên trái",
  T_46_META_WS_P_LEFTTEAMMATESTATES: "Trạng thái của đội viên bên trái",
  T_46_META_WS_P_LEFTTEAMNAME: "Tên đội bên trái",
  T_46_META_WS_P_LEFTTEAMSCORE: "Điểm đội bên trái",
  T_46_META_WS_P_LEFTTEXT: "Văn bản bên trái",
  T_46_META_WS_P_LENGTH: "Độ dài HUD",
  T_46_META_WS_P_LENSFLARE: "Cường độ hào quang",
  T_46_META_WS_P_LEVEL: "Cấp độ",
  T_46_META_WS_P_LIFETIME: "Thời gian tồn tại tháp pháo (giây)",
  T_46_META_WS_P_LIGHTCOLOR: "Màu nguồn sáng chính",
  T_46_META_WS_P_LIGHTINTENSITY: "Cường độ ánh sáng chính",
  T_46_META_WS_P_LIMBDAMAGEFACTOR: "Hệ số sát thương lên tay chân",
  T_46_META_WS_P_LINESPACING: "Khoảng cách dòng",
  T_46_META_WS_P_LOCALPOSITION: "Vị trí tương đối",
  T_46_META_WS_P_LOCALROTATION: "Góc Euler xoay cục bộ (độ)",
  T_46_META_WS_P_LOCALROTATIONQ: "Quaternions xoay cục bộ",
  T_46_META_WS_P_LOCALSCALE: "Kích thước thu nhỏ cục bộ",
  T_46_META_WS_P_LOCKEY: "Khóa bản địa hóa",
  T_46_META_WS_P_LOOPCOUNT: "Số lần lặp lại",
  T_46_META_WS_P_LOOTSOCCER: "Điểm Loot bóng đá",
  T_46_META_WS_P_LOSEHPCOLOR: "Màu HP mất",
  T_46_META_WS_P_LOSEMVPS: "Danh sách MVP thất bại",
  T_46_META_WS_P_LOSETEXT: "Thông báo thất bại",
  "T_46_META_WS_P_MAIN CAMERA": "Camera chính",
  T_46_META_WS_P_MAINCOLOR: "Màu chính",
  T_46_META_WS_P_MAINSCORELIST: "Điểm tổng",
  T_46_META_WS_P_MAINSCORETITLE: "Tựa đề điểm tổng",
  T_46_META_WS_P_MAINWEAPON: "Vũ khí chính hiện tại",
  T_46_META_WS_P_MAPSIZE: "Kích thước bản đồ",
  T_46_META_WS_P_MASK: "Mặt nạ",
  T_46_META_WS_P_MASKNAME: "Tên mặt nạ",
  T_46_META_WS_P_MASS: "Khối lượng (kg)",
  T_46_META_WS_P_MATCHTITLELEFT: "Tiêu đề trận đấu trái",
  T_46_META_WS_P_MATCHTITLERIGHT: "Tiêu đề trận đấu phải",
  T_46_META_WS_P_MAXCAPACITY: "Sức chứa tối đa",
  T_46_META_WS_P_MAXCOUNT: "Số lượng tối đa",
  T_46_META_WS_P_MAXDAMAGE: "Sát thương tối đa",
  T_46_META_WS_P_MAXDEPRESSIONANGLE: "Góc cúi xuống tối đa",
  T_46_META_WS_P_MAXDISPLACEMENT: "Chuyển dịch tối đa",
  T_46_META_WS_P_MAXDISTANCE: "Khoảng cách tối đa",
  T_46_META_WS_P_MAXDURABILITY: "Độ bền tối đa",
  T_46_META_WS_P_MAXDURABILITYRATIO: "Hệ số giới hạn độ bền",
  T_46_META_WS_P_MAXENERGY: "Năng lượng tối đa",
  T_46_META_WS_P_MAXEP: "EP tối đa",
  T_46_META_WS_P_MAXHP: "HP tối đa",
  T_46_META_WS_P_MAXJUMPCOUNT: "Số lần nhảy tối đa",
  T_46_META_WS_P_MAXJUMPHEIGHT: "Độ cao nhảy tối đa",
  T_46_META_WS_P_MAXLENGTH: "Chiều dài tối đa",
  T_46_META_WS_P_MAXPROGRESS: "Tiến độ tối đa",
  T_46_META_WS_P_MAXSCATTERRATIO: "Độ tán xạ tối đa",
  T_46_META_WS_P_MAXSPEED: "Tốc độ di chuyển tối đa",
  T_46_META_WS_P_MAXTURRETCOUNT: "Số lượng tháp pháo tối đa",
  T_46_META_WS_P_MAXVALUE: "Giá trị tối đa",
  T_46_META_WS_P_MAXWIDGETID: "WidgetID tối đa",
  T_46_META_WS_P_MINDAMAGE: "Sát thương tối thiểu",
  T_46_META_WS_P_MINDAMAGEDISTANCE: "Khoảng cách sát thương tối thiểu",
  T_46_META_WS_P_MINDISTANCE: "Khoảng cách tối thiểu",
  T_46_META_WS_P_MINELEVATIONANGLE: "Góc ngẩng lên tối thiểu",
  T_46_META_WS_P_MINENDHEIGHT: "Độ cao kết thúc tối thiểu",
  T_46_META_WS_P_MINFLYHEIGHT: "Độ cao cất cánh tối thiểu",
  T_46_META_WS_P_MINMOVEDISTANCE: "Khoảng cách di chuyển tối thiểu",
  T_46_META_WS_P_MINVALUE: "Giá trị tối thiểu",
  T_46_META_WS_P_MISSILEMAXDAMAGE: "Sát thương tên lửa tối đa",
  T_46_META_WS_P_MISSILEMINDAMAGE: "Sát thương tên lửa tối thiểu",
  T_46_META_WS_P_MISSILERANGE: "Phạm vi tên lửa",
  T_46_META_WS_P_MODEL: "Mô hình",
  T_46_META_WS_P_MODELVISIBILITY: "Độ hiển thị mô hình",
  T_46_META_WS_P_MODELVISIBLE: "Hiển thị mô hình",
  T_46_META_WS_P_MONEY: "Tiền tệ",
  T_46_META_WS_P_MONEYLIST: "Danh sách tiền tệ đã liên kết",
  T_46_META_WS_P_MONEYS: "Tiền tệ",
  T_46_META_WS_P_MONEYTYPE: "Loại tiền tệ",
  T_46_META_WS_P_MONSTERTYPE: "Loại quái vật",
  T_46_META_WS_P_MOTIONTYPE: "Kiểu di chuyển",
  T_46_META_WS_P_MOTIONVALUEX: "Theo trục X",
  T_46_META_WS_P_MOTIONVALUEY: "Theo trục Y",
  T_46_META_WS_P_MOTIONVALUEZ: "Theo trục Z",
  T_46_META_WS_P_MOVEMENTDURATION: "Thời gian di chuyển",
  T_46_META_WS_P_MULTIPLIER: "Bộ đếm",
  T_46_META_WS_P_MUSICELEMENTTYPE: "Kiểu thành phần nhạc",
  T_46_META_WS_P_MUZZLEVELOCITY: "Tốc độ nòng súng",
  T_46_META_WS_P_MVP: "MVP",
  T_46_META_WS_P_NAME: "Tên",
  T_46_META_WS_P_NEXTROUNDINDEX: "Chỉ số lượt tiếp theo",
  T_46_META_WS_P_NICKNAME: "Biệt danh",
  T_46_META_WS_P_NORMALCOLOR: "Màu mặc định",
  T_46_META_WS_P_NORMALIZEDPOSITION: "Vị trí HUD",
  T_46_META_WS_P_NUMBERINFACTION: "Số thứ tự của người chơi trong phe",
  T_46_META_WS_P_OBJECTID: "ID đối tượng",
  T_46_META_WS_P_OFFSET: "Độ lệch",
  T_46_META_WS_P_OPTIONS: "Lựa chọn",
  T_46_META_WS_P_OTHERDAMAGEFACTOR: "Hệ số sát thương đối với vật thể khác",
  T_46_META_WS_P_OUTFIT: "Trang phục",
  T_46_META_WS_P_OVERFLOW: "Tràn",
  T_46_META_WS_P_OVERHEIGHTFALLSPEED: "Tốc độ rơi sau khi quá cao",
  T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION: "Ưu tiên cấu hình người chơi",
  T_46_META_WS_P_OWNER: "Chủ sở hữu",
  T_46_META_WS_P_PARAMS: "Tham số",
  T_46_META_WS_P_PARENT: "Nút cha",
  T_46_META_WS_P_PARENTID: "EntityID của nút cha",
  T_46_META_WS_P_PARENTUI: "UI nút cha",
  T_46_META_WS_P_PARENTWIDGETENTITYID: "EntityID nút cha",
  T_46_META_WS_P_PARENTWIDGETFILEID: "FileID nút cha",
  T_46_META_WS_P_PARTMASKA: "Mặt nạ hiển thị bộ phận 1",
  T_46_META_WS_P_PASSENGERS: "Hành khách",
  T_46_META_WS_P_PATHID: "ID đường dẫn",
  T_46_META_WS_P_PAUSEEVENT: "Tạm dừng sự kiện",
  T_46_META_WS_P_PERSONAID: "ID nhân dạng",
  T_46_META_WS_P_PHASEDURATION: "Thời gian duy trì (ms)",
  T_46_META_WS_P_PHASEENDTIME: "Thời gian kết thúc (ms)",
  T_46_META_WS_P_PHYSICALLAYER: "Cấp độ vật lý",
  T_46_META_WS_P_PINID: "ID Pin",
  T_46_META_WS_P_PITCH: "Góc nhìn lên/xuống",
  T_46_META_WS_P_PIVOT: "Trục xoay",
  T_46_META_WS_P_PLAYER: "Người chơi",
  T_46_META_WS_P_PLAYERAIMINGSPEEDFACTOR: "Hệ số tốc độ di chuyển khi bật ngắm",
  T_46_META_WS_P_PLAYERLIST: "Danh sách người chơi",
  T_46_META_WS_P_PLAYERNAME: "Tên người chơi",
  T_46_META_WS_P_PLAYERRANK: "Xếp hạng người chơi",
  T_46_META_WS_P_PLAYERRANKS: "Xếp hạng người chơi",
  T_46_META_WS_P_PLAYERS: "Người chơi",
  T_46_META_WS_P_PLAYERSCORETYPES: "Kiểu điểm người chơi",
  T_46_META_WS_P_PLAYERSPEEDFACTOR: "Hệ số tốc độ di chuyển của người chơi",
  T_46_META_WS_P_PLAYERSPEEDFACTORWHILEFIRING: "Hệ số tốc độ của người chơi khi tấn công",
  T_46_META_WS_P_PLAYERSTATUS: "Trạng thái người chơi",
  T_46_META_WS_P_PLAYERTRACTIONSPEED: "Tốc độ kéo người chơi",
  T_46_META_WS_P_PLAYINGSTATUS: "Trạng thái phát",
  T_46_META_WS_P_PLAYSPEED: "Tốc độ phát",
  T_46_META_WS_P_POINTPOSITION: "Vị trí điểm",
  T_46_META_WS_P_POINTS: "Điểm số",
  T_46_META_WS_P_POSITION: "Vị trí",
  T_46_META_WS_P_PREFABID: "ID Prefab",
  T_46_META_WS_P_PRESSEDCOLOR: "Màu khi nhấn",
  T_46_META_WS_P_PRESSEDSPRITE: "Hình ảnh khi nhấn",
  T_46_META_WS_P_PRESSEDSPRITETYPE: "Loại hình ảnh khi nhấn",
  T_46_META_WS_P_PRICE: "Giá cả",
  T_46_META_WS_P_PRIORITY: "Ưu tiên",
  T_46_META_WS_P_PROFILEINFO: "Thẻ hồ sơ",
  T_46_META_WS_P_PROGRESS: "Tiến độ [0,1]",
  T_46_META_WS_P_PROGRESSICON: "Biểu tượng tiến độ",
  T_46_META_WS_P_PROGRESSICONNAME: "Tên biểu tượng tiến độ",
  T_46_META_WS_P_PROPID: "ID đạo cụ",
  T_46_META_WS_P_PURCHASELIMIT: "Số lượng giới hạn mua",
  T_46_META_WS_P_RADIUS: "Bán kính",
  T_46_META_WS_P_RANGE: "Phạm vi chiếu sáng",
  T_46_META_WS_P_RANK: "Xếp hạng",
  T_46_META_WS_P_RATIOSELFFACTOR: "Hệ số sát thương bản thân",
  T_46_META_WS_P_RATIOTEAMMATEFACTOR: "Hệ số sát thương đồng đội",
  T_46_META_WS_P_RATIOVEHICLEFACTOR: "Hệ số sát thương phương tiện",
  T_46_META_WS_P_REFRESHTIME: "Thời gian làm mới (s)",
  T_46_META_WS_P_RELOADSPEED: "Tốc độ thay đạn",
  T_46_META_WS_P_RELOADSPEEDFACTOR: "Hệ số tốc độ thay đạn",
  T_46_META_WS_P_REMAINJUMPCOUNT: "Số lần nhảy liên tiếp còn lại",
  T_46_META_WS_P_REMAINQUANTITY: "Số lượng còn lại",
  T_46_META_WS_P_RENDERTYPE: "Kiểu kết xuất",
  T_46_META_WS_P_REPEATTIMES: "Số lần lặp lại",
  T_46_META_WS_P_REPLACEMENTPRIORITY: "Ưu tiên thay thế",
  T_46_META_WS_P_REQUESTEDITEMLIST: "Danh sách vật phẩm được yêu cầu",
  T_46_META_WS_P_REQUESTTYPE: "Loại yêu cầu",
  T_46_META_WS_P_RESETPERROUND: "Đặt lại mỗi lượt",
  T_46_META_WS_P_RESETPOSITION: "Vị trí đặt lại",
  T_46_META_WS_P_RESETTIME: "Thời gian đặt lại",
  T_46_META_WS_P_RESOURCE: "Tài nguyên",
  T_46_META_WS_P_RESOURCEID: "ID tài nguyên",
  T_46_META_WS_P_RESTRICTWITHINPANEL: "Giới hạn nội dung trong khung nhìn",
  T_46_META_WS_P_RESULT: "Thắng Thua Hòa",
  T_46_META_WS_P_RESULTTYPE: "Hiển thị kết quả",
  T_46_META_WS_P_REVIVALPOINT: "Điểm hồi sinh",
  T_46_META_WS_P_REVIVECD: "Thời gian hồi sinh",
  T_46_META_WS_P_RIGHT: "Bên phải",
  T_46_META_WS_P_RIGHTARM: "Cánh tay phải",
  T_46_META_WS_P_RIGHTBACKGROUNDCOLOR: "Màu nền bên phải",
  T_46_META_WS_P_RIGHTCOLOR: "Màu bên phải",
  T_46_META_WS_P_RIGHTDESCRIPTION: "Mô tả đội bên phải",
  T_46_META_WS_P_RIGHTEFFECTACTIVE: "Hiển thị hiệu ứng bên phải hay không",
  T_46_META_WS_P_RIGHTFIRINGARCANGLE: "Góc bắn bên phải",
  T_46_META_WS_P_RIGHTFOOT: "Chân phải",
  T_46_META_WS_P_RIGHTHAND: "Bàn tay phải",
  T_46_META_WS_P_RIGHTICON: "Biểu tượng bên phải",
  T_46_META_WS_P_RIGHTICONNAME: "Tên biểu tượng bên phải",
  T_46_META_WS_P_RIGHTLEG: "Chân phải",
  T_46_META_WS_P_RIGHTPLAYERS: "Mảng người chơi bên phải",
  T_46_META_WS_P_RIGHTSCORE: "Điểm bên phải",
  T_46_META_WS_P_RIGHTSCOREAFTER: "Điểm cuối cùng bên phải",
  T_46_META_WS_P_RIGHTSCORETEXT: "Văn bản điểm bên phải",
  T_46_META_WS_P_RIGHTTEAM: "Đội bên phải",
  T_46_META_WS_P_RIGHTTEAMINDEX: "Chỉ số đội bên phải",
  T_46_META_WS_P_RIGHTTEAMMATEALIVENUM: "Số lượng thành viên còn sống bên phải",
  T_46_META_WS_P_RIGHTTEAMMATEFLAGCOUNT: "Số cờ của thành viên bên phải",
  T_46_META_WS_P_RIGHTTEAMMATESTATES: "Mảng trạng thái thành viên bên phải",
  T_46_META_WS_P_RIGHTTEAMNAME: "Tên đội bên phải",
  T_46_META_WS_P_RIGHTTEAMSCORE: "Điểm số đội bên phải",
  T_46_META_WS_P_RIGHTTEXT: "Văn bản bên phải",
  T_46_META_WS_P_RIMALPHA: "Độ trong suốt viền",
  T_46_META_WS_P_RIMCOLOR: "Màu viền",
  T_46_META_WS_P_RIMTEXTURE: "Kết cấu viền",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFF: "Hệ số ma sát",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFFRUSHING: "Hệ số ma sát (va chạm)",
  T_46_META_WS_P_ROTATION: "Xoay",
  T_46_META_WS_P_ROTATIONANGLE: "Góc xoay",
  T_46_META_WS_P_ROTATIONQ: "Xoay Quaternion",
  T_46_META_WS_P_ROUNDINCOME: "Thu nhập mỗi vòng",
  T_46_META_WS_P_ROUNDINCOMEDETAILNUMS: "Danh sách chi tiết giá trị thu nhập mỗi vòng",
  T_46_META_WS_P_ROUNDINCOMEDETAILTITLES: "Danh sách tiêu đề chi tiết thu nhập mỗi vòng",
  T_46_META_WS_P_ROUNDINCOMETITLE: "Thu nhập theo vòng",
  T_46_META_WS_P_ROUNDNUM: "Số vòng đấu",
  T_46_META_WS_P_ROUNDNUMKEY: "Khóa số vòng đấu",
  T_46_META_WS_P_ROUNDNUMLOCKEYPARAMS: "Mảng tham số số vòng đấu",
  T_46_META_WS_P_RUNSPEED: "Tốc độ hành động",
  T_46_META_WS_P_RUNSPEEDSCALE: "Tỷ lệ tốc độ di chuyển",
  T_46_META_WS_P_RUSHDISTANCE: "Khoảng cách lao tới",
  T_46_META_WS_P_RUSHENERGYCOST: "Tiêu hao năng lượng khi chạy",
  T_46_META_WS_P_RUSHVERTICALSPEED: "Tốc độ thẳng đứng khi chạy",
  T_46_META_WS_P_SCALE: "Thu phóng",
  T_46_META_WS_P_SCATTERINCREASESPEED: "Hệ số mở rộng tán xạ",
  T_46_META_WS_P_SCATTERMAX: "Ngưỡng tán xạ tối đa",
  T_46_META_WS_P_SCATTERMULTIPLIERWHILEMOVING: "Hệ số mở rộng tán xạ khi di chuyển",
  T_46_META_WS_P_SCATTERRECOVERSPEED: "Tốc độ hồi phục tán xạ",
  T_46_META_WS_P_SCATTERSPEED: "Tốc độ tán xạ",
  T_46_META_WS_P_SCATTERSPEEDCROUCHPRONE: "Ngồi hoặc nằm để giảm tán xạ",
  T_46_META_WS_P_SCATTERTHRESHOLD: "Ngưỡng bắt đầu tán xạ",
  T_46_META_WS_P_SCOPETYPE: "Loại ống ngắm",
  T_46_META_WS_P_SCORE: "Điểm số",
  T_46_META_WS_P_SCORES1: "Danh sách điểm 1",
  T_46_META_WS_P_SCORES2: "Danh sách điểm 2",
  T_46_META_WS_P_SCORES3: "Danh sách điểm 3",
  T_46_META_WS_P_SCORES4: "Danh sách điểm 4",
  T_46_META_WS_P_SCORES5: "Danh sách điểm 5",
  T_46_META_WS_P_SCORETEXTKEY: "Khóa điểm số văn bản",
  T_46_META_WS_P_SCORETEXTKEYPARAMS: "Tham số văn bản điểm số",
  T_46_META_WS_P_SCROLLCONTINUITY: "Hệ số quán tính cuộn",
  T_46_META_WS_P_SCROLLDIRECTION: "Hướng cuộn",
  T_46_META_WS_P_SCROLLEFFECT: "Hiệu ứng cuộn",
  T_46_META_WS_P_SCROLLWHEELSPEED: "Tốc độ con lăn",
  T_46_META_WS_P_SECONDSCORETITLE: "Tiêu đề điểm số thứ hai",
  T_46_META_WS_P_SECONDSCOREVALUE: "Giá trị điểm số thứ hai",
  T_46_META_WS_P_SECONDSCOREVALUEPARAMS: "Mảng tham số giá trị điểm số thứ hai",
  T_46_META_WS_P_SELECTEDCOLOR: "Màu sắc được chọn",
  T_46_META_WS_P_SELECTEDINDEX: "Chỉ mục được chọn",
  T_46_META_WS_P_SELECTEDSPRITE: "Hình ảnh được chọn",
  T_46_META_WS_P_SELECTEDTYPE: "Kiểu được chọn",
  T_46_META_WS_P_SELF: "Thực thể bản thân",
  T_46_META_WS_P_SELFDAMAGEFACTOR: "Hệ số sát thương bản thân",
  T_46_META_WS_P_SET: "Bộ trang phục",
  T_46_META_WS_P_SHADERNAME: "Tên đổ bóng",
  T_46_META_WS_P_SHADOWCOLOR: "Màu đổ bóng",
  T_46_META_WS_P_SHADOWOFFSET: "Độ lệch đổ bóng",
  T_46_META_WS_P_SHADOWSTRENGTH: "Cường độ tối",
  T_46_META_WS_P_SHELFS: "Danh sách kệ hàng",
  T_46_META_WS_P_SHOES: "Giày",
  T_46_META_WS_P_SHOOTANGLEMAX: "Góc sút tối đa",
  T_46_META_WS_P_SHOOTANGLEMIN: "Góc sút tối thiểu",
  T_46_META_WS_P_SHOP: "Cửa hàng",
  T_46_META_WS_P_SHOPITEMS: "Vật phẩm cửa hàng",
  T_46_META_WS_P_SHOWADDFRIEND: "Hiển thị thêm bạn",
  T_46_META_WS_P_SHOWATTACKGRENADE: "Hiển thị lựu tấn công",
  T_46_META_WS_P_SHOWBACKGROUND: "Hiển thị nền",
  T_46_META_WS_P_SHOWCROUCH: "Hiển thị nút ngồi",
  T_46_META_WS_P_SHOWDAMAGENUMBER: "Hiển thị sát thương",
  T_46_META_WS_P_SHOWDEFENCEGRENADE: "Hiển thị lưu phòng thủ",
  T_46_META_WS_P_SHOWECCONOMY: "Hiển thị kinh tế",
  T_46_META_WS_P_SHOWECONOMY: "Hiển thị kinh tế",
  T_46_META_WS_P_SHOWFIRE: "Hiển thị bắn",
  T_46_META_WS_P_SHOWFRAME: "Hiển thị khung",
  T_46_META_WS_P_SHOWGIFT: "Hiển thị quà tặng",
  T_46_META_WS_P_SHOWHITPOINTEFFECT: "Hiển thị hiệu ứng HP",
  T_46_META_WS_P_SHOWJUMP: "Hiển thị nhảy",
  T_46_META_WS_P_SHOWLIKE: "Hiển thị lượt thích",
  T_46_META_WS_P_SHOWLOBBY: "Hiển thị trở về sảnh",
  T_46_META_WS_P_SHOWMAPEVALUATE: "Hiển thị đánh giá bản đồ",
  T_46_META_WS_P_SHOWMATCHDETAIL: "Hiển thị chi tiết trận đấu",
  T_46_META_WS_P_SHOWMOVINGJOYSTICK: "Hiểu thị cần điều khiển",
  T_46_META_WS_P_SHOWNAME: "Hiển thị biệt danh",
  T_46_META_WS_P_SHOWPIN: "Hiển thị Pin",
  T_46_META_WS_P_SHOWPRONE: "Hiển thị nút nằm",
  T_46_META_WS_P_SHOWRANK: "Hiển thị hạng",
  T_46_META_WS_P_SHOWREPLAY: "Hiển thị phát lại",
  T_46_META_WS_P_SHOWREPORT: "Hiển thị báo cáo",
  T_46_META_WS_P_SHOWSHARE: "Hiển thị chia sẻ",
  T_46_META_WS_P_SHOWSPRINT: "Hiển thị chạy nhanh",
  T_46_META_WS_P_SHOWTAG: "Hiển thị nhãn",
  T_46_META_WS_P_SHOWTEAMMATESINFO: "Hiển thị thông tin đồng đội",
  T_46_META_WS_P_SHOWTEAMMATESTATE: "Hiển thị trạng thái đồng đội",
  T_46_META_WS_P_SHOWTEAMSCORE: "Hiển thị điểm số đội",
  T_46_META_WS_P_SHOWTIMETYPE: "Hiển thị kết quả",
  T_46_META_WS_P_SHOWTWOTEAMSCORE: "Hiển thị điểm số 2 đội",
  T_46_META_WS_P_SHRINKDURATION: "Thời gian thu hẹp vòng bo (ms)",
  T_46_META_WS_P_SHRINKENDTIME: "Thời gian kết thúc thu hẹp bo (ms)",
  T_46_META_WS_P_SHRINKSPEED: "Tốc độ thu hẹp",
  T_46_META_WS_P_SHRINKSTARTTIME: "Thời gian bắt đầu thu hẹp vòng (giây)",
  T_46_META_WS_P_SIGHTAIMASSIST: "Cho phép hỗ trợ nhắm khi mở ống ngắm",
  T_46_META_WS_P_SIGHTAIMASSISTDISTFALLOFF: "Hệ số suy giảm khoảng cách hỗ trợ nhắm (0-1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOCOEF: "Hệ số ưu tiên khoảng cách hỗ trợ nhắm (>=1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMAX: "Khoảng cách tối đa ưu tiên hỗ trợ nhắm",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMIN: "Khoảng cách tối thiểu ưu tiên hỗ trợ nhắm",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIORITY: "Cho phép ưu tiên khoảng cách hỗ trợ nhắm",
  T_46_META_WS_P_SIGHTAIMASSISTSNAPRANGE: "Tỷ lệ kéo phạm vi màn hình tâm hỗ trợ nhắm (0-1)",
  T_46_META_WS_P_SIGHTAMPLIFYRATIO: "Tỉ lệ phóng đại tầm nhìn",
  T_46_META_WS_P_SIGHTFOVAMPLIFYRATIO: "Độ phóng đại FOV",
  T_46_META_WS_P_SIGHTROTSENSITIVENESS: "Hệ số nhạy cảm xoay ADS",
  T_46_META_WS_P_SIGHTSHOOTMINDAMAGE: "Hệ số sát thương qua ống ngắm theo khoảng cách",
  T_46_META_WS_P_SIGHTUIACTIONEXPAND: "Thời gian phóng đại của kính ngắm",
  T_46_META_WS_P_SIGHTUIACTIONRATIO: "Độ phóng đại của kính ngắm",
  T_46_META_WS_P_SIGHTUIACTIONRECOVERY: "Thời gian hồi phục kính ngắm",
  T_46_META_WS_P_SIZE: "Kích thước",
  T_46_META_WS_P_SIZEDELTA: "Kích thước khác với khung neo",
  T_46_META_WS_P_SKELETON: "Khung xương",
  T_46_META_WS_P_SKIN: "Trang phục",
  T_46_META_WS_P_SKINID: "ID Trang phục",
  T_46_META_WS_P_SKINWIDTH: "Độ dày lớp da",
  T_46_META_WS_P_SKYBOXENV: "Skybox",
  T_46_META_WS_P_SKYBOXRESOURCE: "Tài nguyên skybox",
  T_46_META_WS_P_SLOPELIMIT: "Góc dốc tối đa",
  T_46_META_WS_P_SMOOTHSCROLLSTART: "Bắt đầu cuộn mềm",
  T_46_META_WS_P_SOFTNESS: "Độ mềm mại",
  T_46_META_WS_P_SORTTYPE: "Cách sắp xếp",
  T_46_META_WS_P_SPAWNCOUNTPERWAVE: "Số lượng mỗi đợt",
  T_46_META_WS_P_SPAWNPOINT: "Vị trí xuất hiện",
  T_46_META_WS_P_SPAWNPOINTCOUNT: "Số lượng vị trí xuất hiện",
  T_46_META_WS_P_SPAWNPOSITION: "Tọa độ điểm xuất hiện",
  T_46_META_WS_P_SPEED: "Tốc độ",
  T_46_META_WS_P_SPEEDWHILEAIMING: "Tỷ lệ tốc độ di chuyển khi mở ống ngắm",
  T_46_META_WS_P_SPRAYCOLOR: "Màu sơn",
  T_46_META_WS_P_SPRINTENERGYCOST: "Tiêu hao năng lượng mỗi giây khi chạy nhanh",
  T_46_META_WS_P_SPRINTHORIZONTALSPEED: "Tốc độ ngang khi chạy nhanh",
  T_46_META_WS_P_SPRINTSPEEDSCALE: "Tỷ lệ tốc độ di chuyển",
  T_46_META_WS_P_SPRITENAME: "Hình dạng Sprite",
  T_46_META_WS_P_SPRITERESOURCE: "Tài nguyên Sprite",
  T_46_META_WS_P_SRCVAL: "Giá trị nguồn",
  T_46_META_WS_P_STARTDROPTIME: "Thời gian bắt đầu rơi Hòm thính (ms)",
  T_46_META_WS_P_STARTEVENT: "Sự kiện bắt đầu",
  T_46_META_WS_P_STARTPOSITION: "Vị trí ban đầu",
  T_46_META_WS_P_STARTRADIUS: "Bán kính bắt đầu",
  T_46_META_WS_P_STARTSPAWNTIME: "Thời gian bắt đầu sinh ra",
  T_46_META_WS_P_STARTTIME: "Thời gian bắt đầu (giây)",
  T_46_META_WS_P_STARTVALUE: "Giá trị ban đầu",
  T_46_META_WS_P_STATICICONCOLORS: "Màu biểu tượng tĩnh",
  T_46_META_WS_P_STATICICONS: "Biểu tượng tĩnh",
  T_46_META_WS_P_STATUS: "Trạng thái tháp pháo mini",
  T_46_META_WS_P_STEPOFFSET: "Độ lệch bước chân",
  T_46_META_WS_P_STOPDURATION: "Thời gian dừng",
  T_46_META_WS_P_STOPEVENT: "Sự kiện dừng",
  T_46_META_WS_P_STORE: "Cửa hàng",
  T_46_META_WS_P_STROPID: "ID Strop",
  T_46_META_WS_P_STYLE: "Kiểu",
  T_46_META_WS_P_SUBTITLE: "Phụ đề",
  T_46_META_WS_P_SUMMULTIPLIER: "Hệ số cộng dồn",
  T_46_META_WS_P_SWINGEXITACCELERATION: "Tăng tốc đu dây ",
  T_46_META_WS_P_SWINGINGSPEED: "Tốc độ đu dây",
  T_46_META_WS_P_TAGS: "Danh sách nhãn",
  T_46_META_WS_P_TARGETCHECKPOINTID: "ID Checkpoint mục tiêu",
  T_46_META_WS_P_TARGETICONCOLORS: "Màu biểu tượng mục tiêu",
  T_46_META_WS_P_TARGETICONS: "Biểu tượng mục tiêu",
  T_46_META_WS_P_TARGETID: "ID mục tiêu",
  T_46_META_WS_P_TARGETITEMID: "ID vật phẩm mục tiêu",
  T_46_META_WS_P_TARGETROTATION: "Hướng xoay mục tiêu",
  T_46_META_WS_P_TARGETSCALE: "Tỉ lệ mục tiêu",
  T_46_META_WS_P_TEAMCOLOR: "Màu đội",
  T_46_META_WS_P_TEAMCOLORS: "Mảng màu đội",
  T_46_META_WS_P_TEAMINDEXS: "Mảng chỉ mục đội",
  T_46_META_WS_P_TEAMMATEDAMAGEFACTOR: "Hệ số sát thương đồng đội",
  T_46_META_WS_P_TEAMMEMBERNUM: "Số lượng thành viên đội",
  T_46_META_WS_P_TEAMNUM: "Số lượng đội",
  T_46_META_WS_P_TEAMRANK: "Xếp hạng đội",
  T_46_META_WS_P_TEAMRANKDISPLAY: "Hiển thị xếp hạng đội",
  T_46_META_WS_P_TEAMRANKS: "Mảng xếp hạng đội",
  T_46_META_WS_P_TEAMSCORES: "Mảng điểm số đội",
  T_46_META_WS_P_TEAMSEQ: "Thứ tự đội",
  T_46_META_WS_P_TEMPLATEENTITY: "Thực thể mẫu",
  T_46_META_WS_P_TEMPORARYSHIELDPOINTS: "Lá chắn tạm thời",
  T_46_META_WS_P_TERRAINWETNESS: "Độ ẩm mặt đất",
  T_46_META_WS_P_TEXT: "Văn bản",
  T_46_META_WS_P_TEXTCOLOR: "Màu văn bản",
  T_46_META_WS_P_TEXTKEY: "Khóa văn bản",
  T_46_META_WS_P_TEXTKEYPARAMS: "Tham số tương ứng của khóa văn bản",
  T_46_META_WS_P_TEXTURERESOURCE: "Tài nguyên lớp phủ",
  T_46_META_WS_P_THEMECOLOR: "Màu chủ đề",
  T_46_META_WS_P_THROWABLETYPE: "Loại lựu",
  T_46_META_WS_P_THROWINGSPEED: "Tốc độ ném",
  T_46_META_WS_P_THROWSPEED: "Tốc độ bay",
  T_46_META_WS_P_TICKINTERVAL: "Khoảng thời gian tick",
  T_46_META_WS_P_TIMEREQUIRED: "Thời gian cần (ms)",
  T_46_META_WS_P_TIPSTYPE: "Loại thông báo chữ nổi",
  T_46_META_WS_P_TITLE: "Tiêu đề",
  T_46_META_WS_P_TITLELIST: "Danh sách tiêu đề",
  T_46_META_WS_P_TITLES: "Danh sách tiêu đề",
  T_46_META_WS_P_TOP: "Trang phục trên",
  T_46_META_WS_P_TOPALPHA: "Độ trong suốt trên",
  T_46_META_WS_P_TOTALHP: "Tổng lượng HP",
  T_46_META_WS_P_TOTALLEVEL: "Tổng cấp độ",
  T_46_META_WS_P_TOTALROUNDCOUNT: "Tổng số vòng chơi",
  T_46_META_WS_P_TOWSPEED: "Tốc độ kéo người chơi",
  T_46_META_WS_P_TRANSITIONSTAGE: "Chuyển giai đoạn",
  T_46_META_WS_P_TRANSITIONTYPE: "Kiểu chuyển giao",
  T_46_META_WS_P_TRIGGERPLAYERID: "ID Thực thể kích hoạt",
  T_46_META_WS_P_TRIGGERRADIUS: "Phạm vi kích hoạt",
  T_46_META_WS_P_TRIGGERRANGE: "Phạm vi kích hoạt",
  T_46_META_WS_P_TRIGGERTIME: "Thời gian kích hoạt",
  T_46_META_WS_P_TURNSPEED: "Tốc độ quay (độ/giây)",
  T_46_META_WS_P_TWEENERENABLED: "Bật UITweener",
  T_46_META_WS_P_TWEENSTYLE: "Kiểu Tween",
  T_46_META_WS_P_TYPE: "Loại",
  T_46_META_WS_P_UNSELECTEDCOLOR: "Màu Sprite chưa chọn",
  T_46_META_WS_P_UNSELECTEDSPRITE: "Sprite chưa chọn",
  T_46_META_WS_P_UNSELECTEDTYPE: "Kiểu Sprite chưa chọn",
  T_46_META_WS_P_UP: "Phía trên",
  T_46_META_WS_P_UPDATETYPE: "Loại cập nhật",
  T_46_META_WS_P_UPENERGYCOST: "Tiêu hao năng lượng mỗi giây",
  T_46_META_WS_P_UPSPEED: "Tốc độ lên (lực)",
  T_46_META_WS_P_USECUSTOMPUSHFORCE: "Có sử dụng lực đẩy tùy chỉnh không",
  T_46_META_WS_P_USECUSTOMRESOURCE: "Có sử dụng tài nguyên tùy chỉnh không",
  T_46_META_WS_P_USEDCAPACITY: "Không gian đã chiếm dụng",
  T_46_META_WS_P_USEGRAVITY: "Có chịu tác động của trọng lực không",
  T_46_META_WS_P_USEPHYSICALCCT: "Sử dụng CCT hiệu ứng vật lý",
  T_46_META_WS_P_USERUID: "UserUID",
  T_46_META_WS_P_UVOFFSET: "Độ lệch UV",
  T_46_META_WS_P_UVSIZE: "Chiều rộng và chiều cao UV",
  T_46_META_WS_P_VALUE: "Giá trị [0, 1]",
  T_46_META_WS_P_VAULTDISTANCE: "Khoảng cách vượt qua",
  T_46_META_WS_P_VAULTHEIGHT: "Chiều cao vượt qua",
  T_46_META_WS_P_VEHICLEDAMAGEFACTOR: "Hệ số DMG phương tiện",
  T_46_META_WS_P_VEHICLESKINID: "ID xe",
  T_46_META_WS_P_VEHICLESKINIDS: "ID xe",
  T_46_META_WS_P_VELOCITY: "Tốc độ tuyến tính (m/s)",
  T_46_META_WS_P_VELOCITYXZ: "Tốc độ trục XZ",
  T_46_META_WS_P_VELOCITYY: "Tốc độ trục Y",
  T_46_META_WS_P_VERTICALBAR: "Trục dọc",
  T_46_META_WS_P_VERTICALOFFSET: "Độ lệch theo chiều dọc",
  T_46_META_WS_P_VEST: "Giáp",
  T_46_META_WS_P_VFXTEXTURETYPE: "Kiểu hiệu ứng VFX",
  T_46_META_WS_P_VIEWINGANGLERESTRICTION: "Giới hạn góc nhìn",
  T_46_META_WS_P_VISIBILITYLAYER: "Lớp hiển thị",
  T_46_META_WS_P_VISIBLE: "Hiển thị",
  T_46_META_WS_P_VISIBLEONBACK: "Hiển thị khi đeo sau lưng",
  T_46_META_WS_P_VISIBLEPLAYERS: "Hiển thị người chơi",
  T_46_META_WS_P_VOLUME: "Âm lượng",
  T_46_META_WS_P_WALLETID: "ID Ví",
  T_46_META_WS_P_WANDERRANGE: "Khoảng cách lang thang",
  T_46_META_WS_P_WAVECOUNT: "Số đợt",
  T_46_META_WS_P_WAVEINTERVAL: "Khoảng đợt",
  T_46_META_WS_P_WEAPONDAMAGERATE: "Tỷ lệ sát thương",
  T_46_META_WS_P_WEAPONSKINIDS: "ID Skin súng của người chơi",
  T_46_META_WS_P_WEAPONSUBTYPE: "Phân loại phụ của vũ khí",
  T_46_META_WS_P_WEAPONTYPE: "Loại vũ khí",
  T_46_META_WS_P_WIDTH: "Chiều rộng",
  T_46_META_WS_P_WINMVPS: "MVP chiến thắng",
  T_46_META_WS_P_WINTEXT: "Văn bản thông báo chiến thắng",
  T_46_META_WS_P_WORDWRAP: "Tự động xuống dòng",
  T_46_META_WS_P_WORLDPOSITION: "Tọa độ thế giới",
  T_46_META_WS_P_YAW: "Góc ngang",
  T_46_META_WS_PATROLALONG: "Tuần tra dọc theo",
  T_46_META_WS_PATROLTO: "Tuần tra đến",
  T_46_META_WS_PAUSE: "Tạm dừng",
  T_46_META_WS_PAUSEEMOTE: "Tạm dừng hành động",
  T_46_META_WS_PAUSEFIXEDUPDATE: "Tạm dừng cập nhật cố định",
  T_46_META_WS_PHASE: "Giai đoạn",
  T_46_META_WS_PLAY: "Phát",
  T_46_META_WS_PLAYANIMATION: "Phát hoạt ảnh",
  T_46_META_WS_PLAYCHARACTERANIMATIONCLIP: "Phát Clip Hoạt ảnh nhân vật",
  T_46_META_WS_PLAYEMOTE: "Phát Hành động",
  T_46_META_WS_PLAYER: "Người chơi",
  T_46_META_WS_PORTAL: "Cổng dịch chuyển ",
  T_46_META_WS_POSE: "Tư thế",
  T_46_META_WS_POSITION: "Vị trí",
  T_46_META_WS_PREPOSE: "Tư thế",
  T_46_META_WS_PROFANITYFILTER: "Lọc từ bẩn",
  T_46_META_WS_PURSUITTARGET: "Mục tiêu truy kích",
  T_46_META_WS_QUATERNIONTOAXISANGLE: "Chuyển Quaternion thành hệ tọa độ trục",
  T_46_META_WS_QUATERNIONTOEULERANGLE: "Chuyển Quaternion thành Euler",
  T_46_META_WS_QUITCHATCHANNEL: "Người chơi thoát khỏi kênh",
  T_46_META_WS_QUITFACTION: "Thoát khỏi phe",
  T_46_META_WS_QUITGAME: "Thoát khỏi trò chơi",
  T_46_META_WS_QUITJAILBREAKMINIGAME: "Thoát Minigame Jail Break",
  T_46_META_WS_RANDOMFLOAT: "Số thập phân ngẫu nhiên",
  T_46_META_WS_RANDOMINT: "Số nguyên ngẫu nhiên",
  T_46_META_WS_RANK: "Xếp hạng",
  T_46_META_WS_READCSV: "Đọc CSV",
  T_46_META_WS_READCSVCELL: "Đọc ô CSV",
  T_46_META_WS_READCSVCELLBYNAME: "Đọc ô CSV theo tên",
  T_46_META_WS_READCSVCELLFROMSERVER: "Đọc ô CSV từ máy chủ",
  T_46_META_WS_READCSVCOLUMN: "Đọc cột CSV",
  T_46_META_WS_READCSVCOLUMNFROMSERVER: "Đọc cột CSV từ máy chủ",
  T_46_META_WS_READCSVFROMSERVER: "Đọc CSV từ máy chủ",
  T_46_META_WS_READCSVROW: "Đọc hàng CSV ",
  T_46_META_WS_READCSVROWBYKEY: "Đọc hàng CSV theo Key",
  T_46_META_WS_READCSVROWFROMSERVER: "Đọc một hàng CSV từ máy chủ",
  T_46_META_WS_READFROMACCUMULATEDDATASTORE: "Đọc giá trị bảng dữ liệu tích lũy",
  T_46_META_WS_READFROMDATASTORE: "Đọc giá trị bảng dữ liệu",
  T_46_META_WS_READFROMLEADBOARDDATASTORE: "Đọc giá trị BXH trong cơ sở dữ liệu",
  T_46_META_WS_READFROMLEADBOARDDATASTOREBYRANK: "Đọc giá trị BXH trong cơ sở dữ liệu theo thứ hạng",
  T_46_META_WS_REMOVEAOISPECIALFOLLOW: "Loại bỏ theo dõi AOI",
  T_46_META_WS_REMOVEBACKPACKSKIN: "Loại bỏ skin balo",
  T_46_META_WS_REMOVEBUFF: "Loại bỏ buff",
  T_46_META_WS_REMOVECOMPONENT: "Loại bỏ thành phần",
  T_46_META_WS_REMOVEFORMULAPROPERTYFACTOR: "Loại bỏ một yếu tố thuộc tính công thức",
  T_46_META_WS_REMOVEOUTFIT: "Loại bỏ trang phục",
  T_46_META_WS_REMOVESCRIPT: "Loại bỏ tập lệnh",
  T_46_META_WS_REMOVEVEHICLESKIN: "Loại bỏ skin xe",
  T_46_META_WS_REMOVEWEAPONSKIN: "Loại bỏ skin súng",
  T_46_META_WS_REPLACE: "Thay thế",
  T_46_META_WS_REQUESTMATCHMAKING: "Yêu cầu ghép trận",
  T_46_META_WS_RESET: "Đặt lại",
  T_46_META_WS_RESETBACKPACKSKIN: "Khôi phục skin Balo",
  T_46_META_WS_RESETDYEING: "Đặt lại màu nhuộm",
  T_46_META_WS_RESETJERSEY: "Xóa áo đấu",
  T_46_META_WS_RESETOUTFIT: "Khôi phục trang phục mặc định",
  T_46_META_WS_RESETVEHICLESKIN: "Khôi phục skin xe mặc định",
  T_46_META_WS_RESETWEAPONSKIN: "Khôi phục skin súng mặc định",
  T_46_META_WS_RESUMEFIXEDUPDATE: "Khôi phục cập nhật khung hình cố định",
  T_46_META_WS_REVERSE: "Danh sách đảo ngược",
  T_46_META_WS_REVIVALSOURCE: "Nguồn hồi sinh",
  T_46_META_WS_REVIVE: "Hồi sinh",
  T_46_META_WS_ROUND: "Làm tròn",
  T_46_META_WS_ROUNDINDEX: "Chỉ số lượt chơi",
  T_46_META_WS_SAMPLEONCURVE: "Lấy mẫu trên Curve",
  T_46_META_WS_SCENENAME: "Tên cảnh",
  T_46_META_WS_SCORE: "Điểm số",
  T_46_META_WS_SCORER: "Người ghi bàn",
  T_46_META_WS_SCORETYPE: "Loại điểm",
  T_46_META_WS_SCREENMULTIRAYCAST: "Kiểm tra tia phản hồi đa điểm cảm ứng màn hình",
  T_46_META_WS_SCREENSINGLERAYCAST: "Kiểm tra tia phản hồi đơn điểm cảm ứng màn hình",
  T_46_META_WS_SCREENTOUCHRAY: "Nhận tia qua cảm ứng màn hình",
  T_46_META_WS_SCREENTOWORLDPOINT: "Chuyển tọa độ màn hình sang tọa độ thế giới",
  T_46_META_WS_SENDEVENT: "Gửi sự kiện",
  T_46_META_WS_SETACTIVE: "Set trạng thái hoạt động",
  T_46_META_WS_SETALLPLAYERSMOVESTATUS: "Set người chơi có thể di chuyển hay không",
  T_46_META_WS_SETATTACKABLEENTITY: "Set mục tiêu có thể tấn công của thực thể",
  T_46_META_WS_SETATTACKABLEFACTION: "Set mục tiêu tấn công của phe",
  T_46_META_WS_SETATTACKABLETEAM: "Set mục tiêu tấn công của đội",
  T_46_META_WS_SETBACKPACKSKIN: "Set skin Balo",
  T_46_META_WS_SETBEHAVIORSTATUS: "Set trạng thái hành vi",
  T_46_META_WS_SETBLACKBOARDVALUE: "Set Biến bảng đen",
  T_46_META_WS_SETBUNDLE: "Set trang phục",
  T_46_META_WS_SETCAMERAFOCUS: "Set Camera tập trung mục tiêu",
  T_46_META_WS_SETCAMERAFOLLOW: "Set Camera theo dõi mục tiêu",
  T_46_META_WS_SETCHARACTER: "Set Ảnh",
  T_46_META_WS_SETCULLINGMASK: "Set lớp mặt nạ máy ảnh",
  T_46_META_WS_SETCULLINGMASKLAYER: "Set lớp mặt nạ kết xuất của máy ảnh",
  T_46_META_WS_SETDEFAULTUISTATUS: "Set trạng thái giao diện mặc định",
  T_46_META_WS_SETDROPSTATUS: "Set trạng thái vứt bỏ",
  T_46_META_WS_SETFALLINGDAMAGE: "Set sát thương rơi",
  T_46_META_WS_SETFOOTBALLPOSITION: "Set vị trí bóng đá",
  T_46_META_WS_SETFORMULAPROPERTYABSOLUTE: "Set thuộc tính công thức",
  T_46_META_WS_SETFORMULAPROPERTYRELATIVE: "Set thuộc tính công thức",
  T_46_META_WS_SETFORWARD: "Set hướng",
  T_46_META_WS_SETGLOBALSLEEPTHRESHOLD: "Set ngưỡng tạm dừng toàn cục",
  T_46_META_WS_SETINVINCIBILITY: "Set trạng thái vô địch",
  T_46_META_WS_SETJERSEY: "Thay đổi áo đấu",
  T_46_META_WS_SETOUTFIT: "Set trang phục",
  T_46_META_WS_SETPARENT: "Set nút cha",
  T_46_META_WS_SETPARENTCLIENT: "Set thực thể vật phẩm của nút cha",
  T_46_META_WS_SETPICKUPSTATUS: "Set trạng thái nhặt",
  T_46_META_WS_SETPLAYERQUICKMESSAGESTATUS: "Set trạng thái chat nhanh của người chơi",
  T_46_META_WS_SETPLAYERVOICESTATUS: "Set trạng thái chat thoại của người chơi",
  T_46_META_WS_SETPROPERTYSMOOTHLY: "Set thuộc tính thực thể (mượt mà)",
  T_46_META_WS_SETSKILLS: "Set kỹ năng",
  T_46_META_WS_SETSKYBOX: "Set skybox",
  T_46_META_WS_SETSLEEPTHRESHOLD: "Set ngưỡng nghỉ",
  T_46_META_WS_SETSPECIALITEMSTATUS: "Set trạng thái vật phẩm đặc biệt",
  T_46_META_WS_SETVEHICLESKIN: "Set skin xe",
  T_46_META_WS_SETWEAPONSKIN: "Set skin súng",
  T_46_META_WS_SETWIDGETPARENT: "Set nút Widget cha",
  T_46_META_WS_SHOPITEM: "Vật phẩm cửa hàng",
  T_46_META_WS_SHOWAPPEARANCEGROUP: "Hiển thị ngoại hình nhóm",
  T_46_META_WS_SHUFFLE: "Xáo trộn",
  T_46_META_WS_SIN: "Sin",
  T_46_META_WS_SINGLERAYCAST: "Kiểm tra tia đơn",
  T_46_META_WS_SKILL: "Kỹ năng",
  T_46_META_WS_SLEEP: "Cưỡng chế ngủ",
  T_46_META_WS_SLERPQUATERNION: "Nội suy quaternion",
  T_46_META_WS_SPAWNABLES: "Danh sách thực thể đơn vị",
  T_46_META_WS_SPAWNEDITEM: "Tạo thực thể sau",
  T_46_META_WS_SPAWNNEXTWAVE: "Làm mới đợt tiếp theo",
  T_46_META_WS_SPHERECAST: "Quét hình cầu",
  T_46_META_WS_SPHEREOVERLAP: "Kiểm tra chồng lấn hình cầu",
  T_46_META_WS_SPLIT: "Cắt chuỗi",
  T_46_META_WS_SQRT: "Căn bậc hai",
  T_46_META_WS_STARTPARACHUTE: "Bắt đầu bật dù",
  T_46_META_WS_STARTPOSITION: "Vị trí bắt đầu",
  T_46_META_WS_STATENAME: "Tên trạng thái",
  T_46_META_WS_STATUS: "Trạng thái",
  T_46_META_WS_STRINGTOFLOAT: "Chuyển chuỗi sang kiểu số thực",
  T_46_META_WS_STRINGTOINT: "Chuyển chuỗi sang số nguyên",
  T_46_META_WS_STRIP: "Loại bỏ khoảng trắng hai bên chuỗi",
  T_46_META_WS_SUB: "Cắt chuỗi",
  T_46_META_WS_SWITCHAOIPROXYOBSERVER: "Chuyển người quan sát AOI",
  T_46_META_WS_SWITCHAPPEARANCEGROUP: "Chuyển nhóm ngoại hình",
  T_46_META_WS_SWITCHAREA: "Chuyển khu vực",
  T_46_META_WS_SWITCHCAMERA: "Chuyển camera",
  T_46_META_WS_SWITCHPHASE: "Chuyển giai đoạn",
  T_46_META_WS_SWITCHSCENE: "Chuyển cảnh",
  T_46_META_WS_SWITCHWEAPON: "Chuyển vũ khí",
  T_46_META_WS_TAN: "Tan",
  T_46_META_WS_TARGET: "Mục tiêu truy kích",
  T_46_META_WS_TEAM: "Đội",
  T_46_META_WS_TELEPORT: "Dịch chuyển",
  T_46_META_WS_TELEPORTCCT: "CCT dịch chuyển",
  T_46_META_WS_TEXT: "Nội dung văn bản",
  "T_46_META_WS_TIMESTAMPTO LOCALSTRING": "Dấu thời gian chuỗi bản địa hóa",
  T_46_META_WS_TIRE: "Tire",
  T_46_META_WS_TOLOWER: "Chuyển thành chữ thường",
  T_46_META_WS_TOSTRING: "Chuyển thành chuỗi",
  T_46_META_WS_TOUPPER: "Chuyển thành chữ hoa",
  T_46_META_WS_TRANSFERMONEY: "Tiền giao dịch",
  T_46_META_WS_TRIGGER: "Kích hoạt",
  T_46_META_WS_TYPEIS: "Thuộc kiểu",
  T_46_META_WS_UNLOADSCENE: "Gỡ cài đặt cảnh",
  T_46_META_WS_UPDATEJAILBREAKMISSION: "UpdateJailBreakMission",
  T_46_META_WS_UPLOADGAMERESULT: "Tải lên thông tin kết thúc trò chơi",
  T_46_META_WS_VALUE: "Lượng DMG",
  T_46_META_WS_VECTOR2ANGLE: "Góc giữa 2D Vector",
  T_46_META_WS_VECTOR2DISTANCE: "Khoảng cách 2D Vector",
  T_46_META_WS_VECTOR2DOT: "Tích vô hướng 2D Vector",
  T_46_META_WS_VECTOR2MAGNITUDE: "Độ lớn 2D Vector",
  T_46_META_WS_VECTOR2NORMALIZE: "Chuẩn hóa 2D Vector",
  T_46_META_WS_VECTOR2REFLECT: "Phản xạ 2D Vector",
  T_46_META_WS_VECTOR2TOVECTOR3: "Chuyển 2D Vector sang 3D Vector",
  T_46_META_WS_VECTOR3REFLECT: "Phản xạ 3D Vector",
  T_46_META_WS_VECTOR3TOVECTOR2: "Chuyển 3D Vector sang 2D Vector",
  T_46_META_WS_VEHICLE: "Phương tiện",
  T_46_META_WS_VELOCITY: "Tốc độ",
  T_46_META_WS_WAITFORMILESECOND: "Chờ đợi đến mili giây tiếp theo",
  T_46_META_WS_WAITFORNEXTFRAME: "Chờ đợi đến khung hình tiếp theo",
  T_46_META_WS_WAKEUP: "Kích hoạt Rigidbody",
  T_46_META_WS_WAVES: "Số đợt",
  T_46_META_WS_WEAPON: "Vũ khí",
  T_46_META_WS_WORLDTOSCREENPOINT: "Tọa độ thế giới chuyển thành tọa độ màn hình",
  T_46_META_WS_WRITETOACCUMULATEDDATASTORE: "Ghi vào bảng cơ sở dữ liệu tích lũy",
  T_46_META_WS_WRITETODATASTORE: "Ghi vào cơ sở dữ liệu",
  T_46_META_WS_WRITETOLEADBOARDDATASTORE: "Ghi vào bảng xếp hạng trong cơ sở dữ liệu",
  T_48_META_API_1_D: "Nhận tất cả người chơi trong trò chơi hiện tại và quay lại danh sách người chơi.",
  T_48_META_API_1_R_D: "danh sách người chơi",
  T_48_META_API_10_D: "Nhận đối tượng cảnh",
  T_48_META_API_10_P0_D: "Loại đối tượng cảnh nào cần lọc",
  T_48_META_API_10_R_D: "Danh sách đối tượng cảnh",
  T_48_META_API_100_D: "Đang tải cảnh sẽ không tự động tải các cảnh đã tải.",
  T_48_META_API_100_P0_D: "ID cảnh để tải",
  T_48_META_API_10000_D: "Trả về thực thể được liên kết với tập lệnh hiện tại",
  T_48_META_API_10000_R_D: "Thực thể được liên kết với tập lệnh hiện tại",
  T_48_META_API_10001_D: "Sử dụng ID thực thể để tìm thực thể tương ứng. API này chỉ được người chỉnh sửa sử dụng. Việc sử dụng API này ở phía người dùng không thể đảm bảo tính tương thích của nó, chẳng hạn như việc xóa hoặc điều chỉnh.",
  T_48_META_API_10001_P0_D: "ID thực thể mục tiêu",
  T_48_META_API_10001_R_D: "thực thể",
  T_48_META_API_10002_D: "Nhận thực thể toàn cầu của trò chơi",
  T_48_META_API_10002_R_D: "thực thể toàn cầu",
  T_48_META_API_10003_D: "Dịch chuyển người chơi đến tọa độ cụ thể (lỗi thời, vui lòng sử dụng Dịch chuyển)",
  T_48_META_API_10003_P0_D: "Người chơi được dịch chuyển",
  T_48_META_API_10003_P1_D: "Tọa độ của điểm được dịch chuyển",
  T_48_META_API_10004_D: "Lấy vị trí gần đồng đội và tránh vị trí người chơi không đứng được (lỗi thời, vui lòng sử dụng GetTeammateNearPosition)",
  T_48_META_API_10004_P0_D: "người chơi mục tiêu",
  T_48_META_API_10004_R_D: "Tọa độ gần đồng đội",
  T_48_META_API_10005_D: "Nhận người chơi sở hữu thực thể",
  T_48_META_API_10005_P0_D: "Thực thể mục tiêu, thực thể sẽ chỉ được đồng bộ hóa với người chơi mà nó thuộc về",
  T_48_META_API_10005_R_D: "Người chơi mà thực thể mục tiêu thuộc về",
  T_48_META_API_10006_D: "Làm cho người chơi bất khả chiến bại",
  T_48_META_API_10006_P0_D: "người chơi mục tiêu",
  T_48_META_API_10006_P1_D: "Thời gian của hiệu ứng bất khả chiến bại, tính bằng giây",
  T_48_META_API_10007_D: "Sao chép thực thể đã chọn và tất cả thuộc tính của nó ở vị trí ban đầu",
  T_48_META_API_10007_P0_D: "Thực thể đã được tạo",
  T_48_META_API_10007_P1_D: "Thực thể được nhân bản",
  T_48_META_API_10008_D: "Gây sát thương cho người chơi Nếu không chọn nguồn sát thương, mục tiêu sẽ nhận sát thương từ hệ thống.",
  T_48_META_API_10008_P0_D: "Thực thể trò chơi bị hư hỏng",
  T_48_META_API_10008_P1_D: "Thực thể trò chơi gây thiệt hại",
  T_48_META_API_10008_P2_D: "loại thiệt hại",
  T_48_META_API_10008_P3_D: "Hư hại",
  T_48_META_API_10009_D: "Sự hồi sinh của người chơi được chỉ định",
  T_48_META_API_10009_P0_D: "Người chơi hồi sinh",
  T_48_META_API_1001_D: "Nếu các điều kiện được đáp ứng, nút trong IF sẽ được chạy. Khi các điều kiện không được đáp ứng, nếu có ELSE, hãy chạy nút bên dưới ELSE, nếu không thì kết thúc câu lệnh IF.",
  T_48_META_API_1001_P0_D: "Danh sách điều kiện cần phải nhất quán với số lượng danh sách quy trình con (danh sách nhánh logic)",
  T_48_META_API_10010_D: "Tạo một mục hoặc danh sách các mục tại một vị trí được chỉ định.",
  T_48_META_API_10010_P0_D: "Vị trí tạo vật phẩm",
  T_48_META_API_10010_P1_D: "Mục đã tạo hoặc danh sách các mục",
  T_48_META_API_10010_P2_D: "Số lượng mặt hàng được tạo khi tạo danh sách mặt hàng bạn cần điền vào danh sách số lượng mặt hàng tương ứng với thứ tự của danh sách mặt hàng.",
  T_48_META_API_10011_D: "Thực thể AI tuần tra đến điểm mục tiêu",
  T_48_META_API_10011_P0_D: "thực thể AI mục tiêu",
  T_48_META_API_10011_P1_D: "điểm mục tiêu di chuyển",
  T_48_META_API_10011_P2_D: "Có quay lại điểm xuất phát hay không",
  T_48_META_API_10011_P3_D: "Có phát hiện và tấn công các mục tiêu thù địch trong khi tuần tra hay không",
  T_48_META_API_10012_D: "Các thực thể AI tuần tra theo thứ tự theo danh sách tọa độ",
  T_48_META_API_10012_P0_D: "thực thể AI mục tiêu",
  T_48_META_API_10012_P1_D: "Danh sách điểm tọa độ di chuyển",
  T_48_META_API_10012_P2_D: "Loại tuần tra, bạn có thể chọn một chuyến, khứ hồi hoặc theo chu kỳ",
  T_48_META_API_10012_P3_D: "Có phát hiện và tấn công các mục tiêu thù địch trong khi tuần tra hay không",
  T_48_META_API_10013_D: "Trình tạo ngay lập tức làm mới làn sóng đơn vị tiếp theo",
  T_48_META_API_10013_P0_D: "thực thể máy phát điện",
  T_48_META_API_10014_D: "Các hệ số tính toán được thêm vào cho các thuộc tính có thể tính toán sẽ tính toán kết quả cuối cùng thông qua công thức bao gồm các hệ số.",
  T_48_META_API_10014_P0_D: "thực thể mục tiêu",
  T_48_META_API_10014_P1_D: "Các loại thuộc tính có thể tính toán",
  T_48_META_API_10014_P2_D: "Tính loại hệ số",
  T_48_META_API_10014_P3_D: "Tính giá trị hệ số",
  T_48_META_API_10015_D: "Xóa các hệ số tính toán cho thuộc tính được tính toán",
  T_48_META_API_10015_P0_D: "thực thể mục tiêu",
  T_48_META_API_10015_P1_D: "Các loại thuộc tính có thể tính toán",
  T_48_META_API_10016_D: "Xóa tất cả các hệ số được tính toán cho tất cả thuộc tính được tính toán của thực thể đích",
  T_48_META_API_10016_P0_D: "thực thể mục tiêu",
  T_48_META_API_10017_D: "Sửa đổi thuộc tính",
  T_48_META_API_10017_P0_D: "thực thể mục tiêu",
  T_48_META_API_10017_P1_D: "Loại tài sản",
  T_48_META_API_10017_P2_D: "Phương pháp sửa đổi",
  T_48_META_API_10017_P3_D: "giá trị",
  T_48_META_API_10018_D: "Đặt giá trị của thuộc tính được tính toán",
  T_48_META_API_10018_P0_D: "thực thể mục tiêu",
  T_48_META_API_10018_P1_D: "Loại tài sản",
  T_48_META_API_10018_P2_D: "giá trị",
  T_48_META_API_10019_D: "Xóa một sửa đổi thuộc tính được tính toán",
  T_48_META_API_10019_P0_D: "thực thể mục tiêu",
  T_48_META_API_10019_P1_D: "Loại tài sản",
  T_48_META_API_1002_D: "Tham số i bắt đầu từ giá trị tối thiểu và mỗi lần nút thấp hơn được chạy, i sẽ tăng giá trị bước cho đến khi i lớn hơn hoặc bằng giá trị tối đa.",
  T_48_META_API_1002_P0_D: "Tên của chỉ mục vòng lặp, có thể được sử dụng để lấy giá trị chỉ mục vòng lặp trên biến cục bộ",
  T_48_META_API_1002_P1_D: "giá trị ban đầu của vòng lặp",
  T_48_META_API_1002_P2_D: "giá trị cuối vòng lặp",
  T_48_META_API_1002_P3_D: "Kích thước bước vòng lặp, khi giá trị đầu nhỏ hơn giá trị cuối, kích thước bước phải lớn hơn 0; khi giá trị đầu lớn hơn giá trị cuối, kích thước bước phải nhỏ hơn 0;",
  T_48_META_API_10020_D: "Nhận tất cả các thực thể trong trò chơi đáp ứng các điều kiện lọc",
  T_48_META_API_10020_P0_D: "Kết quả lọc phải chứa loại được nhập trong tham số này",
  T_48_META_API_10020_P1_D: "Kết quả lọc không được chứa loại được nhập trong tham số này",
  T_48_META_API_10020_P2_D: "Kết quả lọc chứa ít nhất một trong các loại được nhập trong tham số này",
  T_48_META_API_10020_R_D: "Lọc danh sách thực thể kết quả",
  T_48_META_API_10021_D: "Thêm tốc độ vào quả bóng Tốc độ sẽ thay đổi do tăng tốc theo cùng một hướng.",
  T_48_META_API_10021_P0_D: "mục tiêu bóng đá",
  T_48_META_API_10021_P1_D: "Đã thêm vận tốc không gian 3D",
  T_48_META_API_10022_D: "Phá hủy thực thể được chỉ định",
  T_48_META_API_10022_P0_D: "Thực thể mục tiêu cần bị tiêu diệt",
  T_48_META_API_10023_D: "Thêm thẻ vào thực thể",
  T_48_META_API_10023_P0_D: "thực thể mục tiêu",
  T_48_META_API_10023_P1_D: "Nhãn tùy chỉnh",
  T_48_META_API_10024_D: "Xóa nhãn khỏi thực thể",
  T_48_META_API_10024_P0_D: "thực thể mục tiêu",
  T_48_META_API_10024_P1_D: "Nhãn tùy chỉnh",
  T_48_META_API_10025_D: "Xác định xem thực thể đích có chứa thẻ được chỉ định hay không",
  T_48_META_API_10025_P0_D: "thực thể mục tiêu",
  T_48_META_API_10025_P1_D: "Nhãn tùy chỉnh",
  T_48_META_API_10025_R_D: "Có bao gồm thẻ được chỉ định hay không",
  T_48_META_API_10026_D: "Đặt vị trí bóng đá",
  T_48_META_API_10026_P0_D: "thực thể bóng đá",
  T_48_META_API_10026_P1_D: "Vị trí",
  T_48_META_API_10026_P2_D: "duy trì tốc độ",
  T_48_META_API_10027_D: "Lấy thực thể camera hiện đang được người chơi mục tiêu sử dụng",
  T_48_META_API_10027_P0_D: "người chơi mục tiêu",
  T_48_META_API_10027_R_D: "Thực thể máy ảnh hiện đang được sử dụng",
  T_48_META_API_10028_D: "Chuyển camera của người chơi mục tiêu sang camera mục tiêu,",
  T_48_META_API_10028_P0_D: "người chơi mục tiêu",
  T_48_META_API_10028_P1_D: "máy ảnh mục tiêu",
  T_48_META_API_10028_P2_D: "Chế độ chuyển đổi, bạn có thể chọn giữ logic gốc hoặc lũy tiến",
  T_48_META_API_10028_P3_D: "Thời gian chuyển đổi là thời gian chuyển đổi camera ở chế độ lũy tiến",
  T_48_META_API_10029_D: "Tạo một máy ảnh",
  T_48_META_API_10029_P0_D: "Đã tạo loại máy ảnh",
  T_48_META_API_10029_P1_D: "Thực thể máy ảnh đã tạo",
  T_48_META_API_1003_D: "Thực hiện truyền tải vùng chứa dữ liệu, lấy từng phần tử phụ và chứa các quy trình con. Phần thân vòng lặp là quy trình phụ.",
  T_48_META_API_1003_P0_D: "Tra cứu tên của phần tử con, bạn có thể sử dụng nó để lấy giá trị phần tử con trên biến cục bộ",
  T_48_META_API_1003_P1_D: "Tên của chỉ mục vòng lặp, có thể được sử dụng để lấy giá trị chỉ mục vòng lặp trên biến cục bộ",
  T_48_META_API_1003_P2_D: "Vùng chứa dữ liệu cần duyệt hiện hỗ trợ các loại sau: kiểu mảng",
  T_48_META_API_10030_D: "Tiêu diệt các thực thể có thể chiến đấu",
  T_48_META_API_10030_P0_D: "Thực thể mục tiêu, phải là thực thể có khả năng chiến đấu",
  T_48_META_API_10031_D: "Đặt trạng thái hoạt động của thực thể đích và các nút con của nó. Tính khả dụng, khả năng hiển thị, xung đột, v.v. của các đối tượng không hoạt động sẽ bị tắt.",
  T_48_META_API_10031_P0_D: "thực thể mục tiêu",
  T_48_META_API_10031_P1_D: "Nó có hoạt động không?",
  T_48_META_API_10032_D: "Đặt vị trí của thực thể camera để luôn đi theo thực thể mục tiêu",
  T_48_META_API_10032_P0_D: "thực thể máy ảnh mục tiêu",
  T_48_META_API_10032_P1_D: "đối tượng mục tiêu để theo dõi",
  T_48_META_API_10032_P2_D: "bù đắp từ tọa độ thực thể mục tiêu",
  T_48_META_API_10032_P3_D: "hệ tọa độ offset",
  T_48_META_API_10033_D: "Đặt thực thể camera luôn hướng về thực thể mục tiêu",
  T_48_META_API_10033_P0_D: "thực thể máy ảnh mục tiêu",
  T_48_META_API_10033_P1_D: "thực thể mục tiêu",
  T_48_META_API_10033_P2_D: "Độ lệch của điểm cố định so với tọa độ đích",
  T_48_META_API_10033_P3_D: "hệ tọa độ offset",
  T_48_META_API_10034_D: "Tạo thanh thiếu niên",
  T_48_META_API_10034_P0_D: "thực thể mục tiêu",
  T_48_META_API_10034_P1_D: "ID thuộc tính",
  T_48_META_API_10034_P2_D: "SrcVal",
  T_48_META_API_10034_P3_D: "DestVal",
  T_48_META_API_10034_P4_D: "Phong cách",
  T_48_META_API_10034_P5_D: "Đường cong",
  T_48_META_API_10034_P6_D: "Khoảng thời gian",
  T_48_META_API_10034_P7_D: "thực thể giữa",
  T_48_META_API_10035_D: "Đặt nút cha, yêu cầu cả nút cha và nút con phải có thành phần Transform",
  T_48_META_API_10035_P0_D: "nút cha",
  T_48_META_API_10035_P1_D: "nút con",
  T_48_META_API_10035_P2_D: "Liệu có giữ nguyên vị trí thế giới hiện tại hay không, việc xoay và chia tỷ lệ các nút con hay không Mục này không hợp lệ khi cài đặt giao diện người dùng.",
  T_48_META_API_10036_D: "NewCurve (không được dùng nữa, vui lòng sử dụng CreateTweenCurve)",
  T_48_META_API_10036_P0_D: "Điểm kiểm soát",
  T_48_META_API_10036_R_D: "Thực thể đường cong Twenn",
  T_48_META_API_10037_D: "Cố gắng phát thực thể mục tiêu, thực thể này phải có các thành phần có thể phát được",
  T_48_META_API_10037_P0_D: "nhắm mục tiêu thực thể có thể chơi được",
  T_48_META_API_10037_P1_D: `Có phát lại hay không
Đúng: Phát lại
Sai: Tiếp tục chơi`,
  T_48_META_API_10038_D: "Tạm dừng thực thể có thể chơi được",
  T_48_META_API_10038_P0_D: "nhắm mục tiêu thực thể có thể chơi được",
  T_48_META_API_10039_D: "Tạo chuyển động đạn đạo, sẽ mang lại cho thực thể mục tiêu một vận tốc ban đầu và gia tốc theo hướng",
  T_48_META_API_10039_P0_D: "thực thể mục tiêu",
  T_48_META_API_10039_P1_D: "vận tốc ban đầu của chuyển động",
  T_48_META_API_10039_P2_D: "gia tốc chuyển động",
  T_48_META_API_10039_P3_D: "Khoảng cách dịch chuyển tối đa",
  T_48_META_API_10039_P4_D: "Đã tạo thực thể chuyển động đạn đạo",
  T_48_META_API_10039_P5_D: "Có tự động bắt đầu phát sau khi tạo hay không",
  T_48_META_API_1004_D: "Ngắt quá trình vòng lặp hiện tại và thoát khỏi vòng lặp",
  T_48_META_API_10040_D: "Tạo vị trí theo chuyển động, thực thể mục tiêu sẽ theo chuyển động của đối tượng được chỉ định",
  T_48_META_API_10040_P0_D: "thực thể mục tiêu",
  T_48_META_API_10040_P1_D: "Các thực thể đối tượng theo chuyển động",
  T_48_META_API_10040_P2_D: "Khoảng cách tuân theo độ lệch của tọa độ đích",
  T_48_META_API_10040_P3_D: "Hệ tọa độ được sử dụng",
  T_48_META_API_10040_P4_D: "Đã tạo thực thể chuyển động sau",
  T_48_META_API_10040_P5_D: "Có tự động bắt đầu phát sau khi tạo hay không",
  T_48_META_API_10041_D: "Tạo chuyển động theo hướng nhìn trong đó thực thể mục tiêu sẽ vẫn hướng về đối tượng được chỉ định",
  T_48_META_API_10041_P0_D: "thực thể mục tiêu",
  T_48_META_API_10041_P1_D: "thực thể đối tượng đang được theo dõi",
  T_48_META_API_10041_P2_D: "Độ lệch của điểm nhìn từ thực thể đối tượng",
  T_48_META_API_10041_P3_D: "Hệ tọa độ được sử dụng",
  T_48_META_API_10041_P4_D: "Đã tạo thực thể chuyển động theo hướng nhìn",
  T_48_META_API_10041_P5_D: "Có tự động bắt đầu phát sau khi tạo hay không",
  T_48_META_API_10042_D: "Không dùng nữa",
  T_48_META_API_10042_P0_D: "thực thể người chơi",
  T_48_META_API_10042_P1_D: "kết quả trận đấu",
  T_48_META_API_10042_P2_D: "Không dùng nữa",
  T_48_META_API_10042_P3_D: "Không dùng nữa",
  T_48_META_API_10042_P4_D: "Không dùng nữa",
  T_48_META_API_10043_D: "Thiết lập trơn tru các thuộc tính của thực thể mục tiêu. Các thuộc tính sẽ thay đổi ngay lập tức, nhưng máy khách sẽ thực hiện chuyển đổi mượt mà.",
  T_48_META_API_10043_P0_D: "thực thể mục tiêu",
  T_48_META_API_10043_P1_D: "một thuộc tính của thực thể mục tiêu",
  T_48_META_API_10043_P2_D: "Giá trị đích cần phải phù hợp với loại được yêu cầu khi thuộc tính được xác định.",
  T_48_META_API_10044_D: "Thực hiện phát hiện tia và trả về thực thể đầu tiên được đánh theo hướng tia. Thực thể bị đánh cần có thành phần va chạm. Nếu tham số cấp độ được điền vào chỗ trống, địa hình có thể được phát hiện.",
  T_48_META_API_10044_P0_D: "Tọa độ vị trí bắt đầu",
  T_48_META_API_10044_P1_D: "Hướng phát hiện tia",
  T_48_META_API_10044_P2_D: "Khoảng cách phát hiện tia, chỉ chấp nhận giá trị dương",
  T_48_META_API_10044_P3_D: "Mặt nạ lớp phát hiện tia, chỉ những cấp độ đã điền mới tham gia quét, để trống nghĩa là tất cả các cấp độ sẽ tham gia quét",
  T_48_META_API_10044_P4_D: "Có thể quét ra các kích hoạt?",
  T_48_META_API_10044_P5_D: "thực thể đánh",
  T_48_META_API_10044_P6_D: "tọa độ điểm nhấn",
  T_48_META_API_10044_P7_D: "Khoảng cách từ điểm đánh đến điểm bắt đầu",
  T_48_META_API_10044_P8_D: "Đánh bề mặt bình thường",
  T_48_META_API_10045_D: "Thực hiện phát hiện tia và trả về tất cả các thực thể bị bắn trúng theo hướng tia từ gần đến xa. Nếu tham số cấp độ được điền vào chỗ trống, địa hình có thể được phát hiện.",
  T_48_META_API_10045_P0_D: "Tọa độ vị trí bắt đầu",
  T_48_META_API_10045_P1_D: "Hướng phát hiện tia",
  T_48_META_API_10045_P2_D: "Khoảng cách phát hiện tia, chỉ chấp nhận giá trị dương",
  T_48_META_API_10045_P3_D: "Mặt nạ lớp, chỉ những lớp đã điền mới tham gia quét, để trống nghĩa là tất cả các lớp sẽ tham gia quét",
  T_48_META_API_10045_P4_D: "Có thể phát hiện các tác nhân",
  T_48_META_API_10045_P5_D: "danh sách các thực thể truy cập",
  T_48_META_API_10045_P6_D: "danh sách truy cập",
  T_48_META_API_10045_P7_D: "Danh sách khoảng cách điểm bắt đầu khoảng cách điểm nhấn",
  T_48_META_API_10045_P8_D: "Đánh bề mặt bình thường",
  T_48_META_API_10046_D: "Tạo các thực thể cho mẫu bằng cách sử dụng prefabs",
  T_48_META_API_10046_P0_D: "Thực thể đã được tạo",
  T_48_META_API_10046_P1_D: "ID nhà lắp ghép",
  T_48_META_API_10047_D: "nhuộm",
  T_48_META_API_10047_P0_D: "Đặt đối tượng bình thường",
  T_48_META_API_10047_P1_D: "Đặt điểm nhuộm",
  T_48_META_API_10047_P2_D: "màu sắc",
  T_48_META_API_10048_D: "tình trạng nhuộm màu",
  T_48_META_API_10048_P0_D: "Đặt điểm nhuộm",
  T_48_META_API_10048_P1_D: "Đặt hướng",
  T_48_META_API_10048_P2_D: "Đặt khoảng cách",
  T_48_META_API_10048_R_D: "Màu sắc",
  T_48_META_API_10049_D: "Thống kê nhuộm màu",
  T_48_META_API_10049_P0_D: "màu sắc",
  T_48_META_API_10049_R_D: "Số lượng nhuộm",
  T_48_META_API_1005_D: "Bỏ qua nội dung vòng lặp còn lại và chuyển thẳng đến vòng lặp tiếp theo",
  T_48_META_API_10050_D: "Nhuộm phạm vi phẳng",
  T_48_META_API_10050_P0_D: "Đặt đối tượng bình thường",
  T_48_META_API_10050_P1_D: "Đặt điểm nhuộm",
  T_48_META_API_10050_P2_D: "Đặt phạm vi nhuộm",
  T_48_META_API_10050_P3_D: "màu sắc",
  T_48_META_API_10050_P4_D: "Số lượng nhuộm",
  T_48_META_API_10051_D: "nhuộm vùng",
  T_48_META_API_10051_P0_D: "Đặt đối tượng bình thường",
  T_48_META_API_10051_P1_D: "Đặt điểm nhuộm",
  T_48_META_API_10051_P2_D: "Đặt phạm vi nhuộm",
  T_48_META_API_10051_P3_D: "màu sắc",
  T_48_META_API_10051_P4_D: "Cố định vùng bị ố",
  T_48_META_API_10051_P5_D: "hệ số ngẫu nhiên",
  T_48_META_API_10051_P6_D: "Hệ số suy giảm ngẫu nhiên",
  T_48_META_API_10051_P7_D: "Số lượng nhuộm",
  T_48_META_API_10052_D: "Nhận tất cả các nút con của thực thể nút cha đích",
  T_48_META_API_10052_P0_D: "thực thể nút cha",
  T_48_META_API_10052_R_D: "Danh sách các nút con",
  T_48_META_API_10053_D: "Lấy nút con được chỉ định của thực thể nút cha đích dựa trên chỉ mục",
  T_48_META_API_10053_P0_D: "thực thể nút cha",
  T_48_META_API_10053_P1_D: "Chỉ số nút con",
  T_48_META_API_10053_R_D: "thực thể nút con",
  T_48_META_API_10054_D: "Lấy nút cha của thực thể nút con mục tiêu",
  T_48_META_API_10054_P0_D: "thực thể nút con",
  T_48_META_API_10054_R_D: "thực thể nút cha",
  T_48_META_API_10055_D: "Xóa tất cả các nút con trong thực thể nút cha được chỉ định. Nút này phải có thành phần Chuyển đổi.",
  T_48_META_API_10055_P0_D: "thực thể nút cha",
  T_48_META_API_10056_D: "Dịch chuyển mục tiêu đến vị trí được chỉ định",
  T_48_META_API_10056_P0_D: "Đơn vị được dịch chuyển",
  T_48_META_API_10056_P1_D: "Tọa độ điểm dịch chuyển",
  T_48_META_API_10056_P2_D: "Định hướng của đơn vị sau khi dịch chuyển",
  T_48_META_API_10057_D: "Lấy vị trí gần đồng đội ngẫu nhiên, trả tọa độ gần mình khi không có đồng đội, tránh vị trí người chơi không đứng được.",
  T_48_META_API_10057_P0_D: "người chơi mục tiêu",
  T_48_META_API_10057_R_D: "Tọa độ gần đồng đội của người chơi mục tiêu",
  T_48_META_API_10058_D: "Xóa tình trạng nhuộm màu",
  T_48_META_API_10059_D: "Phát hiệu ứng âm thanh được chỉ định. Nếu có nhiều thuộc tính cần được đặt, hãy đặt thêm các thuộc tính thực thể của nó thông qua thực thể.",
  T_48_META_API_10059_P0_D: "Mã được sử dụng để biểu thị tên của tham số chính thức tạo ra thực thể hiệu ứng âm thanh và giá trị biến cục bộ tương ứng của nó là thực thể tạo ra hiệu ứng âm thanh.",
  T_48_META_API_10059_P1_D: "Thực thể người chơi mà nó thuộc về, chỉ hiển thị với người chơi này",
  T_48_META_API_10059_P2_D: "Loại hiệu ứng âm thanh, loại hiệu ứng âm thanh mà người chơi có thể lựa chọn",
  T_48_META_API_1006_D: "Kết thúc quá trình thực hiện hiện tại và quay lại trực tiếp vị trí gọi. Bạn có thể quay lại với dữ liệu.",
  T_48_META_API_1006_P0_D: "Dữ liệu dự kiến sẽ được trả về vị trí gọi",
  T_48_META_API_10060_D: "Đá người chơi mục tiêu khỏi trò chơi",
  T_48_META_API_10060_P0_D: "người chơi mục tiêu",
  T_48_META_API_10060_P1_D: "Có hiển thị thông tin thanh toán hay không",
  T_48_META_API_10061_D: "Người chơi mục tiêu yêu cầu khớp với bản đồ được chỉ định",
  T_48_META_API_10061_P0_D: "người chơi mục tiêu",
  T_48_META_API_10061_P1_D: "mã chiến trường",
  T_48_META_API_10061_P2_D: "Có cửa sổ bật lên nhắc bạn quay lại trò chơi gốc khi hủy trận đấu hay không",
  T_48_META_API_10062_D: "Làm gián đoạn thực thể hiệu ứng âm thanh đang phát",
  T_48_META_API_10062_P0_D: "Thực thể hiệu ứng âm thanh cần được tạm dừng",
  T_48_META_API_10063_D: "Tiếp tục phát hiệu ứng âm thanh, bạn có thể chọn có bắt đầu phát lại từ đầu hay không",
  T_48_META_API_10063_P0_D: "Các thực thể hiệu ứng âm thanh cần tiếp tục phát sau khi bị tạm dừng",
  T_48_META_API_10063_P1_D: "Có nên bắt đầu lại từ đầu không",
  T_48_META_API_10064_D: "Tạo airdrop có ba giai đoạn: 1. Chuẩn bị, 2. Rơi, 3. Hạ cánh Các thuộc tính của airdrop chỉ có thể được sửa đổi ở trạng thái 1.",
  T_48_META_API_10064_P0_D: "Đã tạo thực thể hộp airdrop",
  T_48_META_API_1007_D: "Triển khai một vòng lặp tiếp tục thực thi dựa trên việc điều kiện có đúng hay không cho đến khi điều kiện sai và vòng lặp kết thúc.",
  T_48_META_API_1007_P0_D: "Khi điều kiện đúng thì vòng lặp tiếp tục, khi điều kiện sai thì vòng lặp kết thúc.",
  T_48_META_API_1008_D: `Đợi cho đến khi bắt đầu khung logic tiếp theo
Trên máy chủ, nếu bật chế độ tốc độ khung hình thấp, thời gian chờ sẽ lâu hơn
Trên máy khách, thời gian chờ bị ảnh hưởng bởi hiệu suất thiết bị và độ phức tạp logic của khung hình hiện tại
Sử dụng API này H`,
  T_48_META_API_1009_D: "Sau khi chờ một khoảng thời gian nhất định, hàm sử dụng API này cần được khai báo là không đồng bộ.",
  T_48_META_API_1009_P0_D: "Thời gian chờ đợi, tính bằng mili giây",
  T_48_META_API_101_D: "Gỡ cài đặt cảnh được chỉ định",
  T_48_META_API_101_P0_D: "ID cảnh sẽ được gỡ cài đặt",
  T_48_META_API_1010: "Sự kiện gọi lại",
  T_48_META_API_1010_D: "Một hành động được kích hoạt khi một sự kiện xảy ra",
  T_48_META_API_1010_P0: "Tên tham số sự kiện",
  T_48_META_API_1010_P0_D: "Tên tham số chính thức của tham số sự kiện, qua đó có thể lấy được giá trị tham số thực tế trên biến cục bộ",
  T_48_META_API_1011: "Khối mã",
  T_48_META_API_1011_D: "Một khối mã mang sự kết hợp của các API",
  T_48_META_API_1011_P0: "Tên tham số",
  T_48_META_API_1011_P0_D: "Tên tham số chính thức khi khối mã là một hàm tùy chỉnh",
  T_48_META_API_1012: "Tìm và gọi API tùy chỉnh bằng Serial",
  T_48_META_API_1012_D: "Gọi hàm tùy chỉnh theo cách nối tiếp. Nếu có thời gian chờ trong hàm tùy chỉnh, vị trí gọi cũng sẽ chờ.",
  T_48_META_API_1012_P0_D: "Thực thể chứa hàm tùy chỉnh",
  T_48_META_API_1012_P1: "ID đồ thị",
  T_48_META_API_1012_P1_D: "ID tập lệnh nơi đặt chức năng tùy chỉnh",
  T_48_META_API_1012_P2: "ID chức năng",
  T_48_META_API_1012_P2_D: "ID chức năng được gọi bởi mục tiêu",
  T_48_META_API_1012_P3_D: "Danh sách các đối số được truyền cho hàm tùy chỉnh",
  T_48_META_API_1013: "Tìm và gọi API tùy chỉnh với Parallel",
  T_48_META_API_1013_D: "Gọi song song một chức năng tùy chỉnh. Bất kể có chờ đợi trong chức năng tùy chỉnh hay không, nó sẽ ngay lập tức quay trở lại vị trí gọi và tiếp tục thực hiện.",
  T_48_META_API_1013_P0_D: "Thực thể chứa hàm tùy chỉnh",
  T_48_META_API_1013_P1: "ID đồ thị",
  T_48_META_API_1013_P1_D: "ID tập lệnh nơi đặt chức năng tùy chỉnh",
  T_48_META_API_1013_P2: "ID chức năng",
  T_48_META_API_1013_P2_D: "ID chức năng được gọi bởi mục tiêu",
  T_48_META_API_1013_P3_D: "Danh sách các đối số được truyền cho hàm tùy chỉnh",
  T_48_META_API_1014: "Tìm và gọi API tùy chỉnh của Self với Serial",
  T_48_META_API_1014_D: "Gọi hàm tùy chỉnh trong tập lệnh hiện tại ở chế độ nối tiếp. Nếu có thời gian chờ trong hàm tùy chỉnh, vị trí gọi cũng sẽ chờ.",
  T_48_META_API_1014_P0: "ID chức năng",
  T_48_META_API_1014_P0_D: "ID chức năng được gọi bởi mục tiêu",
  T_48_META_API_1014_P1_D: "Danh sách các đối số được truyền cho hàm tùy chỉnh",
  T_48_META_API_1015: "Tìm và Gọi API Tùy chỉnh Tự động với Parallel",
  T_48_META_API_1015_D: "Gọi song song một chức năng tùy chỉnh. Bất kể có chờ đợi trong chức năng tùy chỉnh hay không, nó sẽ ngay lập tức quay trở lại vị trí gọi và tiếp tục thực hiện.",
  T_48_META_API_1015_P0: "Đặt Biến cục bộ theo Chỉ mục",
  T_48_META_API_1015_P0_D: "ID chức năng được gọi bởi mục tiêu",
  T_48_META_API_1015_P1_D: "Danh sách các đối số được truyền cho hàm tùy chỉnh",
  T_48_META_API_1016_D: "Nhận loại mục tiêu khi gọi API này",
  T_48_META_API_1016_P0_D: "Mục tiêu đang được truy vấn",
  T_48_META_API_1016_R_D: "Loại biến",
  T_48_META_API_1017_D: "Xác định xem biến mục tiêu có thuộc loại được chỉ định hay không",
  T_48_META_API_1017_P0_D: "Mục tiêu đang được truy vấn",
  T_48_META_API_1017_P1_D: "loại được so sánh",
  T_48_META_API_1017_R_D: "Nó có nhất quán không?",
  T_48_META_API_1018_D: "Xác định xem biến mục tiêu có phải là lớp con của một loại nhất định hay không và giá trị trả về có phải là giá trị Boolean hay không",
  T_48_META_API_1018_P0_D: "Biến mục tiêu đang được truy vấn",
  T_48_META_API_1018_P1_D: "loại được so sánh",
  T_48_META_API_1018_R_D: "Cho dù đó là một lớp con",
  T_48_META_API_1019_D: "Khiến thực thể mục tiêu kích hoạt sự kiện tùy chỉnh được chỉ định",
  T_48_META_API_1019_P0_D: "Đã gửi ID sự kiện tùy chỉnh",
  T_48_META_API_1019_P1_D: "thực thể mục tiêu",
  T_48_META_API_1019_P2_D: "Danh sách tham số",
  T_48_META_API_102_D: "Chuyển sang cảnh được chỉ định sẽ dỡ bỏ các cảnh đã tải khác.",
  T_48_META_API_102_P0_D: "ID cảnh để chuyển sang",
  T_48_META_API_1020_D: "Thực hiện truyền tải vùng chứa và lấy từng cặp khóa-giá trị, bao gồm cả các quy trình con. Phần thân vòng lặp là quy trình phụ.",
  T_48_META_API_1020_P0_D: "Tra cứu tên của khóa, bạn có thể sử dụng nó để lấy giá trị khóa trên biến cục bộ",
  T_48_META_API_1020_P1_D: "Duyệt tới tên của giá trị, có thể được sử dụng để lấy giá trị trên biến cục bộ",
  T_48_META_API_1020_P2_D: "thùng chứa đi qua",
  T_48_META_API_1021_D: "Phá hủy Bot được chỉ định",
  T_48_META_API_1021_P0_D: "Người chơi bot cần phải bị tiêu diệt",
  T_48_META_API_1022_D: "Buộc người chơi mục tiêu rời khỏi xe",
  T_48_META_API_1022_P0_D: "người chơi mục tiêu",
  T_48_META_API_1023_D: "Tạo từ nhảy sát thương",
  T_48_META_API_1023_P0_D: "Bỏ qua nội dung từ",
  T_48_META_API_1023_P1_D: "cỡ chữ",
  T_48_META_API_1023_P2_D: "Màu chữ",
  T_48_META_API_1023_P3_D: "Thời gian lưu trú tính bằng mili giây",
  T_48_META_API_1023_P4_D: "Thực thể bị tổn hại",
  T_48_META_API_1023_P5_D: "Độ lệch của từ nhảy sát thương so với tọa độ thế giới của thực thể mục tiêu",
  T_48_META_API_1023_P6_D: "Kích thước phạm vi điều chỉnh vị trí ngẫu nhiên một lần nữa ở vị trí nhảy sát thương",
  T_48_META_API_1023_P7_D: "Có thực hiện hoạt ảnh tween hay không",
  T_48_META_API_1024_D: "Không dùng nữa",
  T_48_META_API_1024_P0_D: "Không dùng nữa",
  T_48_META_API_1024_P1_D: "thực thể mục tiêu",
  T_48_META_API_1024_P2_D: "Sau khi chọn, nếu gọi ở server thì sẽ gửi về client, nếu gọi ở client thì sẽ gửi về server.",
  T_48_META_API_1024_P3_D: "Danh sách tham số",
  T_48_META_API_1025_D: "Truy vấn tiến trình nhiệm vụ tùy chỉnh",
  T_48_META_API_1025_P0_D: "người chơi mục tiêu",
  T_48_META_API_1025_P1_D: "ID nhiệm vụ tùy chỉnh",
  T_48_META_API_1025_R_D: "Tiến độ nhiệm vụ",
  T_48_META_API_1026_D: "Nhận skin ba lô của người chơi mục tiêu",
  T_48_META_API_1026_P0_D: "người chơi mục tiêu",
  T_48_META_API_1026_R_D: "ID da ba lô",
  T_48_META_API_1027_D: "Đặt skin ba lô của người chơi mục tiêu",
  T_48_META_API_1027_P0_D: "người chơi mục tiêu",
  T_48_META_API_1027_P1_D: "ID da ba lô",
  T_48_META_API_1028_D: "Khôi phục da ba lô của người chơi mục tiêu về cấu hình bên ngoài mặc định",
  T_48_META_API_1028_P0_D: "người chơi mục tiêu",
  T_48_META_API_1029_D: "Xóa skin ba lô của người chơi mục tiêu",
  T_48_META_API_1029_P0_D: "người chơi mục tiêu",
  T_48_META_API_103_D: "Thay đổi phong cách môi trường skybox của trò chơi, bạn có thể chọn ngày, hoàng hôn, đêm, v.v.",
  T_48_META_API_103_P0_D: "Loại Skybox",
  T_48_META_API_1030_D: "Lấy vị trí điểm treo xương theo tên",
  T_48_META_API_1030_P0_D: "thực thể mục tiêu",
  T_48_META_API_1030_P1_D: "Tên điểm treo xương",
  T_48_META_API_1030_R_D: "điểm treo khung",
  T_48_META_API_1031_D: "Đặt nút cha của thực thể đối tượng, hỗ trợ các thực thể được gắn với các thành phần Transform, SkeletonPart, Player và MountPoint.",
  T_48_META_API_1031_P0_D: "nút cha",
  T_48_META_API_1031_P1_D: "nút con",
  T_48_META_API_1031_P2_D: "Liệu có giữ nguyên vị trí thế giới hiện tại hay không, việc xoay và chia tỷ lệ của các nút con Mục này không hợp lệ nếu được thiết lập bởi giao diện người dùng.",
  T_48_META_API_1032_D: "Phát hiệu ứng hoạt hình biểu tượng, biểu tượng dịch từ vị trí bắt đầu sang vị trí kết thúc ở tốc độ phát lại",
  T_48_META_API_1032_P0_D: "ID tài nguyên biểu tượng",
  T_48_META_API_1032_P1_D: "màu sắc",
  T_48_META_API_1032_P2_D: "Thu phóng biểu tượng",
  T_48_META_API_1032_P3_D: "trung tâm vị trí xuất phát",
  T_48_META_API_1032_P4_D: "Phạm vi khu vực bắt đầu",
  T_48_META_API_1032_P5_D: "tâm vị trí cuối",
  T_48_META_API_1032_P6_D: "phạm vi vị trí kết thúc",
  T_48_META_API_1032_P7_D: "Tốc độ phát lại là khoảng cách mỗi giây mà biểu tượng di chuyển",
  T_48_META_API_1033_D: "Thực hiện phép tính arctang để thu được góc",
  T_48_META_API_1033_P0_D: "tọa độ trục Y",
  T_48_META_API_1033_P1_D: "tọa độ trục X",
  T_48_META_API_1033_R_D: "Góc, phạm vi (-180, 180]",
  T_48_META_API_1034_D: "Thêm thành phần vào thực thể. Chỉ hỗ trợ các thành phần tùy chỉnh do người dùng tạo.",
  T_48_META_API_1034_P0_D: "thực thể mục tiêu",
  T_48_META_API_1034_P1_D: "ID loại thành phần, chỉ hỗ trợ các thành phần tùy chỉnh do người dùng tạo",
  T_48_META_API_1034_P2_D: "Cho dù nó được thêm thành công thì các thành phần hiện có hoặc các thành phần không tùy chỉnh sẽ không được thêm vào.",
  T_48_META_API_1035_D: "Xóa các thành phần khỏi thực thể và chỉ hỗ trợ các thành phần tùy chỉnh",
  T_48_META_API_1035_P0_D: "thực thể mục tiêu",
  T_48_META_API_1035_P1_D: "ID loại thành phần, chỉ hỗ trợ các thành phần tùy chỉnh do người dùng tạo",
  T_48_META_API_1035_P2_D: "Việc xóa có thành công hay không. Các thành phần không tồn tại hoặc các thành phần không tùy chỉnh sẽ không bị xóa.",
  T_48_META_API_1036_D: "Tùy chỉnh giao diện thoát trình phát giữa chừng",
  T_48_META_API_1036_P0_D: "tiêu đề",
  T_48_META_API_1036_P1_D: "nội dung",
  T_48_META_API_1036_P2_D: "Tùy chọn",
  T_48_META_API_1036_P3_D: "Có hiển thị nền hay không",
  T_48_META_API_1037_D: "Nhận tất cả các cảnh hiện đang được tải",
  T_48_META_API_1037_R_D: "danh sách cảnh",
  T_48_META_API_1038_D: "Nhận hướng nhắm địa phương của người chơi",
  T_48_META_API_1038_R_D: "hướng nhắm",
  T_48_META_API_1039_D: "Nhận dấu thời gian địa phương",
  T_48_META_API_1039_R_D: "Dấu thời gian",
  T_48_META_API_104_D: "Chuyển trình phát sang vị trí đã chỉ định của cảnh đã chỉ định sẽ tự động được tải và các cảnh đã tải sẽ không tự động được tải.",
  T_48_META_API_104_P0_D: "người chơi",
  T_48_META_API_104_P1_D: "ID cảnh để tải",
  T_48_META_API_104_P2_D: "Vị trí của người chơi trong bối cảnh mới",
  T_48_META_API_104_P3_D: "Định hướng của người chơi trong bối cảnh mới",
  T_48_META_API_1040_D: "Tạm dừng cập nhật khung cố định của nền tảng hiện tại Sau khi tạm dừng, sự kiện cập nhật khung cố định của nền tảng sẽ không còn được kích hoạt.",
  T_48_META_API_1041_D: "Tiếp tục cập nhật khung cố định của nền tảng hiện tại Sau khi khôi phục, sự kiện cập nhật khung cố định của nền tảng sẽ bắt đầu kích hoạt lại.",
  T_48_META_API_1042_D: "Xác định mối quan hệ bạn bè giữa người chơi mục tiêu và người chơi khách hàng hiện tại. Bản thân khách hàng hiện tại không phải là bạn bè của khách hàng hiện tại.",
  T_48_META_API_1042_P0_D: "người chơi mục tiêu",
  T_48_META_API_1042_R_D: "Cho dù bạn là bạn bè với khách hàng hiện tại",
  T_48_META_API_1043_D: "Kích hoạt sự kiện tùy chỉnh",
  T_48_META_API_1043_P0_D: "ID sự kiện tùy chỉnh",
  T_48_META_API_1043_P1_D: "thực thể mục tiêu",
  T_48_META_API_1043_P2_D: "Nền tảng đang chạy là máy chủ hoặc máy khách",
  T_48_META_API_1043_P3_D: "Danh sách tham số",
  T_48_META_API_1044_D: "Bắt đầu nhảy dù",
  T_48_META_API_1044_P0_D: "người chơi mục tiêu",
  T_48_META_API_1044_P1_D: "Dưới độ cao này, chiếc dù sẽ buộc phải mở ra",
  T_48_META_API_1044_P2_D: "Tốc độ khi lướt, thành phần X biểu thị tốc độ ngang và thành phần Y biểu thị tốc độ dọc khi thành phần Y âm, người chơi tiếp đất hướng xuống;",
  T_48_META_API_1044_P3_D: "Tốc độ khi lặn, thành phần X biểu thị tốc độ ngang, thành phần Y biểu thị tốc độ dọc; khi thành phần Y âm, người chơi rơi xuống;",
  T_48_META_API_1044_P4_D: "Tốc độ khi mở ô, thành phần X đại diện cho tốc độ ngang và thành phần Y đại diện cho tốc độ dọc khi thành phần Y âm, người chơi rơi xuống;",
  T_48_META_API_1045_D: "Đọc giá trị tương ứng với mã định danh được chỉ định trong bảng dữ liệu",
  T_48_META_API_1045_P0_D: "tên bảng trong cơ sở dữ liệu",
  T_48_META_API_1045_P1_D: "ID duy nhất của người chơi",
  T_48_META_API_1045_P2_D: "Chỉ định mã định danh",
  T_48_META_API_1045_P3_D: "Đọc kết quả",
  T_48_META_API_1045_P4_D: "Mã chiến trường tương ứng với cơ sở dữ liệu, có thể điền vào chỗ trống, biểu thị mã chiến trường của bản đồ hiện tại",
  T_48_META_API_1045_P5_D: "mã lỗi",
  T_48_META_API_1046_D: "Đọc giá trị tương ứng với định danh được chỉ định trong bảng dữ liệu xếp hạng",
  T_48_META_API_1046_P0_D: "Tên bảng xếp hạng trong cơ sở dữ liệu",
  T_48_META_API_1046_P1_D: "Chỉ định mã định danh",
  T_48_META_API_1046_P2_D: "Đọc kết quả",
  T_48_META_API_1046_P3_D: "Mã chiến trường tương ứng với cơ sở dữ liệu, có thể điền vào chỗ trống, biểu thị mã chiến trường của bản đồ hiện tại",
  T_48_META_API_1046_P4_D: "mã lỗi",
  T_48_META_API_1047_D: "Đọc giá trị khoảng xếp hạng được chỉ định trong bảng dữ liệu xếp hạng",
  T_48_META_API_1047_P0_D: "Tên bảng xếp hạng trong cơ sở dữ liệu",
  T_48_META_API_1047_P1_D: "Thứ hạng bắt đầu phải nhỏ hơn hoặc bằng thứ hạng kết thúc và thứ hạng bắt đầu từ 1",
  T_48_META_API_1047_P2_D: "xếp hạng cuối cùng",
  T_48_META_API_1047_P3_D: "Đọc kết quả",
  T_48_META_API_1047_P4_D: "Mã chiến trường tương ứng với cơ sở dữ liệu, có thể điền vào chỗ trống, biểu thị mã chiến trường của bản đồ hiện tại",
  T_48_META_API_1047_P5_D: "mã lỗi",
  T_48_META_API_1048_D: "Đọc giá trị tương ứng với mã định danh được chỉ định trong bảng dữ liệu tích lũy",
  T_48_META_API_1048_P0_D: "Tên bảng dữ liệu tích lũy trong cơ sở dữ liệu",
  T_48_META_API_1048_P1_D: "Chỉ định mã định danh",
  T_48_META_API_1048_P2_D: "Đọc kết quả",
  T_48_META_API_1048_P3_D: "Mã chiến trường tương ứng với cơ sở dữ liệu, có thể điền vào chỗ trống, biểu thị mã chiến trường của bản đồ hiện tại",
  T_48_META_API_1048_P4_D: "mã lỗi",
  T_48_META_API_1049_D: "Viết giá trị tương ứng với định danh được chỉ định trong bảng dữ liệu",
  T_48_META_API_1049_P0_D: "tên bảng trong cơ sở dữ liệu",
  T_48_META_API_1049_P1_D: "ID duy nhất của người chơi",
  T_48_META_API_1049_P2_D: "Chỉ định mã định danh",
  T_48_META_API_1049_P3_D: "giá trị được viết",
  T_48_META_API_1049_P4_D: "Mã chiến trường tương ứng với cơ sở dữ liệu, có thể điền vào chỗ trống, biểu thị mã chiến trường của bản đồ hiện tại",
  T_48_META_API_1049_P5_D: "mã lỗi",
  T_48_META_API_105_D: "Nhận skybox của cảnh",
  T_48_META_API_105_P0_D: "ID cảnh",
  T_48_META_API_105_R_D: "hộp bầu trời",
  T_48_META_API_1050_D: "Lấy số phần tử trong danh sách",
  T_48_META_API_1050_P0_D: "danh sách mục tiêu",
  T_48_META_API_1050_R_D: "Số phần tử",
  T_48_META_API_1051_D: "Lấy giá trị phần tử tại chỉ mục đã chỉ định trong danh sách",
  T_48_META_API_1051_P0_D: "danh sách mục tiêu",
  T_48_META_API_1051_P1_D: "Giá trị chỉ mục, bắt đầu từ 0",
  T_48_META_API_1051_R_D: "giá trị phần tử",
  T_48_META_API_1052_D: "Đặt giá trị phần tử tương ứng với chỉ mục đã chỉ định trong danh sách",
  T_48_META_API_1052_P0_D: "danh sách mục tiêu",
  T_48_META_API_1052_P1_D: "Giá trị chỉ mục, bắt đầu từ 0",
  T_48_META_API_1052_P2_D: "giá trị phần tử",
  T_48_META_API_1053_D: "Nối các phần tử vào cuối danh sách",
  T_48_META_API_1053_P0_D: "danh sách mục tiêu",
  T_48_META_API_1053_P1_D: "các yếu tố cần thêm",
  T_48_META_API_1054_D: "Xóa phần tử tương ứng với chỉ mục đã chỉ định khỏi danh sách",
  T_48_META_API_1054_P0_D: "danh sách mục tiêu",
  T_48_META_API_1054_P1_D: "Giá trị chỉ mục, bắt đầu từ 0",
  T_48_META_API_1055_D: "Xóa tất cả các phần tử trong danh sách",
  T_48_META_API_1055_P0_D: "danh sách mục tiêu",
  T_48_META_API_1056_D: "Đảo ngược danh sách đã chỉ định. Thứ tự của các phần tử trong danh sách sẽ bị đảo ngược.",
  T_48_META_API_1056_P0_D: "danh sách mục tiêu",
  T_48_META_API_1057_D: "sao chép một danh sách",
  T_48_META_API_1057_P0_D: "danh sách mục tiêu",
  T_48_META_API_1057_R_D: "Đã sao chép danh sách mới",
  T_48_META_API_1058_D: "Chèn một phần tử mới vào vị trí chỉ mục đã chỉ định trong danh sách. Các phần tử ở vị trí chỉ mục ban đầu và sau đó sẽ lần lượt được lùi lại một vị trí.",
  T_48_META_API_1058_P0_D: "danh sách mục tiêu",
  T_48_META_API_1058_P1_D: "Vị trí chỉ mục cần chèn, chỉ số được tính từ 0",
  T_48_META_API_1058_P2_D: "giá trị phần tử mới cần chèn",
  T_48_META_API_1059_D: "Sắp xếp lại ngẫu nhiên các phần tử trong danh sách",
  T_48_META_API_1059_P0_D: "danh sách mục tiêu",
  T_48_META_API_1060_D: "So sánh các tham số ở cả hai bên và trả về đúng hoặc sai",
  T_48_META_API_1060_P0_D: "lvalue được sử dụng để so sánh",
  T_48_META_API_1060_P1_D: "Phương pháp so sánh hỗ trợ các phương pháp sau: >,>=,==,!=,<=,<,And (loại bool giới hạn), Or (loại bool giới hạn)",
  T_48_META_API_1060_P2_D: "lvalue được sử dụng để so sánh",
  T_48_META_API_1060_R_D: "So sánh kết quả",
  T_48_META_API_1061_D: "Bốn phép tính số học cơ bản bao gồm cộng, trừ, nhân, chia và số dư. Phép toán còn lại chỉ hỗ trợ số nguyên và phần còn lại của phép toán hỗ trợ số nguyên hoặc số thập phân.",
  T_48_META_API_1061_P0_D: "giá trị hoạt động",
  T_48_META_API_1061_P1_D: "Bốn loại phép tính số học, bao gồm cộng, trừ, nhân, chia và phép tính số dư không hỗ trợ số thập phân.",
  T_48_META_API_1061_P2_D: "giá trị hoạt động",
  T_48_META_API_1061_R_D: "Kết quả tính toán",
  T_48_META_API_1062_D: "Tạo ngẫu nhiên một số nguyên giữa số nguyên nhỏ nhất (bao gồm) và số nguyên lớn nhất (độc quyền)",
  T_48_META_API_1062_P0_D: "Khoảng bên trái của phạm vi ngẫu nhiên, có thể đạt ngẫu nhiên giá trị điền vào",
  T_48_META_API_1062_P1_D: "Khoảng bên phải của phạm vi ngẫu nhiên sẽ không ngẫu nhiên với giá trị được điền vào.",
  T_48_META_API_1062_R_D: "kết quả ngẫu nhiên, số nguyên",
  T_48_META_API_1063_D: "Tạo ngẫu nhiên một số thập phân giữa giá trị thập phân nhỏ nhất (đã bao gồm) và giá trị thập phân lớn nhất (độc quyền)",
  T_48_META_API_1063_P0_D: "Khoảng bên trái của phạm vi ngẫu nhiên, có khả năng nhỏ giá trị được điền sẽ là ngẫu nhiên.",
  T_48_META_API_1063_P1_D: "Khoảng bên phải của phạm vi ngẫu nhiên sẽ không ngẫu nhiên với giá trị được điền vào.",
  T_48_META_API_1063_R_D: "Kết quả ngẫu nhiên, số thập phân, chính xác đến 7 chữ số thập phân",
  T_48_META_API_1064_D: "Xác định xem đối tượng có trống không",
  T_48_META_API_1064_P0_D: "Đối tượng được đánh giá là trống rỗng",
  T_48_META_API_1064_R_D: "Nó có trống không",
  T_48_META_API_1065_D: "Phủ định logic, giá trị đầu vào: đúng hoặc sai, giá trị trả về: sai hoặc đúng",
  T_48_META_API_1065_P0_D: "Cần tìm giá trị của non",
  T_48_META_API_1065_R_D: "Kết quả âm tính",
  T_48_META_API_1066_D: "Lấy giá trị tuyệt đối, hỗ trợ số nguyên và số thập phân",
  T_48_META_API_1066_P0_D: "Cần tìm giá trị tuyệt đối của giá trị",
  T_48_META_API_1066_R_D: "Kết quả lấy giá trị tuyệt đối",
  T_48_META_API_1067_D: "Tính căn bậc hai",
  T_48_META_API_1067_P0_D: "Cần tìm căn bậc hai của giá trị",
  T_48_META_API_1067_R_D: "Kết quả tìm căn bậc hai",
  T_48_META_API_1068_D: "Tính giá trị âm",
  T_48_META_API_1068_P0_D: "Cần tìm giá trị âm",
  T_48_META_API_1068_R_D: "kết quả âm tính",
  T_48_META_API_1069_D: "Nối hai chuỗi lại với nhau",
  T_48_META_API_1069_P0_D: "giá trị chuỗi",
  T_48_META_API_1069_P1_D: "giá trị chuỗi",
  T_48_META_API_1069_R_D: "Kết quả nối chuỗi",
  T_48_META_API_1070_D: "Nhận độ dài chuỗi",
  T_48_META_API_1070_P0_D: "sợi dây",
  T_48_META_API_1070_R_D: "độ dài chuỗi",
  T_48_META_API_1071_D: "Làm tròn giá trị đã chỉ định thành số nguyên gần nhất",
  T_48_META_API_1071_P0_D: "Giá trị cần làm tròn xuống",
  T_48_META_API_1071_R_D: "Kết quả làm tròn xuống",
  T_48_META_API_1072_D: "Làm tròn giá trị đã chỉ định thành số nguyên gần nhất",
  T_48_META_API_1072_P0_D: "Giá trị cần làm tròn",
  T_48_META_API_1072_R_D: "Kết quả làm tròn",
  T_48_META_API_1073_D: "Làm tròn giá trị đã chỉ định thành số nguyên",
  T_48_META_API_1073_P0_D: "Các giá trị cần làm tròn",
  T_48_META_API_1073_R_D: "kết quả làm tròn",
  T_48_META_API_1074_D: "Sau khi thay thế tất cả các chuỗi được chỉ định trong chuỗi đích, xuất chuỗi mới",
  T_48_META_API_1074_P0_D: "chuỗi mục tiêu",
  T_48_META_API_1074_P1_D: "Dây cũ cần được thay thế",
  T_48_META_API_1074_P2_D: "chuỗi mới để thay thế bằng",
  T_48_META_API_1074_R_D: "Thay thế chuỗi đã hoàn thành",
  T_48_META_API_1075_D: "Tìm kiếm chuỗi đích để tìm lần xuất hiện đầu tiên của một chuỗi được chỉ định.",
  T_48_META_API_1075_P0_D: "chuỗi mục tiêu",
  T_48_META_API_1075_P1_D: "Chuỗi được chỉ định để tìm",
  T_48_META_API_1075_P2_D: "Tìm chuỗi từ vị trí bắt đầu, vị trí chuỗi được tính từ 0",
  T_48_META_API_1075_R_D: "Chỉ định vị trí xuất hiện đầu tiên của chuỗi trong chuỗi đích. Vị trí chuỗi được tính từ 0.",
  T_48_META_API_1076_D: "Sau khi chặn một chuỗi có độ dài xác định bắt đầu từ vị trí đã chỉ định, xuất ra một chuỗi mới",
  T_48_META_API_1076_P0_D: "chuỗi mục tiêu",
  T_48_META_API_1076_P1_D: "Vị trí bắt đầu đánh chặn. Vị trí chuỗi được tính từ 0.",
  T_48_META_API_1076_P2_D: "Cắt bớt độ dài theo mặc định, nó cắt đến cuối chuỗi.",
  T_48_META_API_1076_R_D: "Chuỗi bị chặn",
  T_48_META_API_1077_D: "So sánh xem các phần tử của hai danh sách có giống hệt nhau hay không. Dung lượng danh sách không ảnh hưởng đến kết quả so sánh.",
  T_48_META_API_1077_P0_D: "Liệt kê các giá trị được sử dụng để so sánh",
  T_48_META_API_1077_P1_D: "Liệt kê các giá trị được sử dụng để so sánh",
  T_48_META_API_1077_R_D: "So sánh kết quả, nếu nội dung nhất quán thì trả về True; nếu nội dung không nhất quán thì trả về False.",
  T_48_META_API_1078_D: "Sử dụng chuỗi được chỉ định làm dấu phân cách, cắt chuỗi mục tiêu thành nhiều lát và xuất ra một chuỗi mới. Các dấu phân cách N liên tiếp sẽ được cắt thành khoảng trắng nửa chiều rộng N-1 và xuất ra dưới dạng các thành phần danh sách chuỗi.",
  T_48_META_API_1078_P0_D: "chuỗi mục tiêu",
  T_48_META_API_1078_P1_D: "chuỗi phân cách",
  T_48_META_API_1078_R_D: "Danh sách chuỗi đầu ra luôn kết thúc bằng phần tử khoảng trắng có độ rộng bằng một nửa.",
  T_48_META_API_1079_D: "Trích xuất các ký tự theo danh sách vị trí chuỗi và kết hợp chúng thành đầu ra chuỗi mới",
  T_48_META_API_1079_P0_D: "chuỗi mục tiêu",
  T_48_META_API_1079_P1_D: "Danh sách vị trí chuỗi, vị trí chuỗi được tính bắt đầu từ 0",
  T_48_META_API_1079_R_D: "chuỗi đầu ra",
  T_48_META_API_1080_D: "Chuyển đổi các ký tự chuỗi đích thành tất cả chữ hoa",
  T_48_META_API_1080_P0_D: "chuỗi mục tiêu",
  T_48_META_API_1080_R_D: "chuỗi đầu ra",
  T_48_META_API_1081_D: "Chuyển đổi tất cả các ký tự chuỗi mục tiêu thành chữ thường",
  T_48_META_API_1081_P0_D: "chuỗi mục tiêu",
  T_48_META_API_1081_R_D: "chuỗi đầu ra",
  T_48_META_API_1082_D: "Xóa tất cả khoảng trắng trước ký tự không phải khoảng trắng đầu tiên và sau ký tự không phải khoảng trắng cuối cùng của chuỗi đích",
  T_48_META_API_1082_P0_D: "chuỗi mục tiêu",
  T_48_META_API_1082_R_D: "chuỗi đầu ra",
  T_48_META_API_1083_D: "Xuất ra một chuỗi mới sau khi liên kết với mã định danh được chỉ định",
  T_48_META_API_1083_P0_D: "danh sách chuỗi mục tiêu",
  T_48_META_API_1083_P1_D: "Mã định danh được chỉ định dùng để nối chuỗi",
  T_48_META_API_1083_R_D: "chuỗi đầu ra",
  T_48_META_API_1084_D: "Viết giá trị tương ứng với định danh được chỉ định vào bảng dữ liệu xếp hạng",
  T_48_META_API_1084_P0_D: "Tên bảng xếp hạng trong cơ sở dữ liệu",
  T_48_META_API_1084_P1_D: "Chỉ định mã định danh",
  T_48_META_API_1084_P2_D: "giá trị được viết",
  T_48_META_API_1084_P3_D: "Mã chiến trường tương ứng với cơ sở dữ liệu, có thể điền vào chỗ trống, biểu thị mã chiến trường của bản đồ hiện tại",
  T_48_META_API_1084_P4_D: "mã lỗi",
  T_48_META_API_1085_D: "Viết giá trị offset tương ứng với định danh đã chỉ định trong bảng dữ liệu tích lũy",
  T_48_META_API_1085_P0_D: "Tên bảng dữ liệu tích lũy trong cơ sở dữ liệu",
  T_48_META_API_1085_P1_D: "Chỉ định mã định danh",
  T_48_META_API_1085_P2_D: "Bốn loại phép tính số học",
  T_48_META_API_1085_P3_D: "Giá trị bù đắp được viết",
  T_48_META_API_1085_P4_D: "Mã chiến trường tương ứng với cơ sở dữ liệu, có thể điền vào chỗ trống, biểu thị mã chiến trường của bản đồ hiện tại",
  T_48_META_API_1085_P5_D: "mã lỗi",
  T_48_META_API_1086_D: "Xóa giá trị tương ứng với định danh được chỉ định trong bảng dữ liệu",
  T_48_META_API_1086_P0_D: "tên bảng trong cơ sở dữ liệu",
  T_48_META_API_1086_P1_D: "ID duy nhất của người chơi",
  T_48_META_API_1086_P2_D: "Chỉ định mã định danh",
  T_48_META_API_1086_P3_D: "Mã chiến trường tương ứng với cơ sở dữ liệu, có thể điền vào chỗ trống, biểu thị mã chiến trường của bản đồ hiện tại",
  T_48_META_API_1086_P4_D: "mã lỗi",
  T_48_META_API_1087_D: "Xóa giá trị tương ứng với định danh được chỉ định trong bảng dữ liệu xếp hạng",
  T_48_META_API_1087_P0_D: "Tên bảng xếp hạng trong cơ sở dữ liệu",
  T_48_META_API_1087_P1_D: "Chỉ định mã định danh",
  T_48_META_API_1087_P2_D: "Mã chiến trường tương ứng với cơ sở dữ liệu, có thể điền vào chỗ trống, biểu thị mã chiến trường của bản đồ hiện tại",
  T_48_META_API_1087_P3_D: "mã lỗi",
  T_48_META_API_1088_D: "Xóa giá trị tương ứng với thứ hạng đã chỉ định trong bảng dữ liệu thứ hạng",
  T_48_META_API_1088_P0_D: "Tên bảng xếp hạng trong cơ sở dữ liệu",
  T_48_META_API_1088_P1_D: "Chỉ định thứ hạng",
  T_48_META_API_1088_P2_D: "Mã chiến trường tương ứng với cơ sở dữ liệu, có thể điền vào chỗ trống, biểu thị mã chiến trường của bản đồ hiện tại",
  T_48_META_API_1088_P3_D: "mã lỗi",
  T_48_META_API_1089_D: "Gửi tin nhắn người dùng tới Persona",
  T_48_META_API_1089_P0_D: "ID cá nhân mục tiêu",
  T_48_META_API_1089_P1_D: "Nội dung tin nhắn",
  T_48_META_API_1090_D: "Gửi tin nhắn hệ thống tới Persona",
  T_48_META_API_1090_P0_D: "ID cá nhân mục tiêu",
  T_48_META_API_1090_P1_D: "Nội dung tin nhắn",
  T_48_META_API_1091_D: "Xóa bộ nhớ Persona",
  T_48_META_API_1091_P0_D: "mã lỗi",
  T_48_META_API_1092_D: "Trung tâm thành viên khơi dậy",
  T_48_META_API_1092_P0_D: "mã lỗi",
  T_48_META_API_1093_D: "Nhận dấu thời gian hết hạn thành viên",
  T_48_META_API_1093_P0_D: "người chơi mục tiêu",
  T_48_META_API_1093_P1_D: "Dấu thời gian",
  T_48_META_API_1093_P2_D: "mã lỗi",
  T_48_META_API_1094_D: "Xác định xem người chơi có phải là thành viên hay không",
  T_48_META_API_1094_P0_D: "mã lỗi",
  T_48_META_API_1094_P1_D: "Bạn có phải là thành viên?",
  T_48_META_API_1095_D: "Nhận dấu thời gian hết hạn thành viên",
  T_48_META_API_1095_P0_D: "Dấu thời gian",
  T_48_META_API_1095_P1_D: "mã lỗi",
  T_48_META_API_1096_D: "Xác định xem người chơi có phải là thành viên hay không",
  T_48_META_API_1096_P0_D: "người chơi mục tiêu",
  T_48_META_API_1096_P1_D: "mã lỗi",
  T_48_META_API_1096_P2_D: "Bạn có phải là thành viên?",
  T_48_META_API_1097_D: "Trung tâm thành viên khơi dậy",
  T_48_META_API_1097_P0_D: "người chơi mục tiêu",
  T_48_META_API_1097_P1_D: "mã lỗi",
  T_48_META_API_1099_D: "Thiết lập người quan sát Persona và các cuộc hội thoại tiếp theo với Persona cũng sẽ được gửi tới người quan sát.",
  T_48_META_API_1099_P0_D: "ID cá nhân mục tiêu",
  T_48_META_API_1099_P1_D: "danh sách quan sát",
  T_48_META_API_11_D: "Kết thúc giai đoạn hiện tại và chuyển sang giai đoạn tiếp theo",
  T_48_META_API_1100_D: "Gửi tin nhắn của người dùng tới Persona bằng tính năng phát trực tuyến",
  T_48_META_API_1100_P0_D: "ID cá nhân mục tiêu",
  T_48_META_API_1100_P1_D: "Nội dung tin nhắn",
  T_48_META_API_1101_D: "Gửi tin nhắn hệ thống tới Persona bằng tính năng phát trực tuyến",
  T_48_META_API_1101_P0_D: "ID cá nhân mục tiêu",
  T_48_META_API_1101_P1_D: "Nội dung tin nhắn",
  T_48_META_API_1101_P2_D: "Có trả lời hay không",
  T_48_META_API_1103_D: "Tạo một hạt giống ngẫu nhiên",
  T_48_META_API_1103_P0_D: "hạt giống",
  T_48_META_API_1103_R_D: "trình tạo số ngẫu nhiên",
  T_48_META_API_1104_D: "Lấy số ngẫu nhiên tiếp theo từ trình tạo số ngẫu nhiên được chỉ định, giá trị tối đa là 32767",
  T_48_META_API_1104_P0_D: "trình tạo số ngẫu nhiên",
  T_48_META_API_1104_P1_D: "phạm vi tối thiểu",
  T_48_META_API_1104_P2_D: "Phạm vi tối đa",
  T_48_META_API_1104_R_D: "số ngẫu nhiên",
  T_48_META_API_1108_D: "Nhận ngôn ngữ máy khách được người chơi sử dụng",
  T_48_META_API_12_D: "In nhật ký ra bàn điều khiển",
  T_48_META_API_12_P0_D: "Những gì cần in",
  T_48_META_API_13_D: "Xuất ra một chuỗi có tham số",
  T_48_META_API_13_P0_D: "Sử dụng trình giữ chỗ %v để biểu thị một tham số. Số lượng %v và số lượng tham số cần phải nhất quán.",
  T_48_META_API_13_P1_D: "Danh sách tham số tham gia đầu ra cần phải nhất quán với số %v trong mô tả định dạng.",
  T_48_META_API_13_R_D: "chuỗi đầu ra",
  T_48_META_API_14_D: "Dọn dẹp dư lượng đối tượng trên bản đồ, bao gồm hộp chết, đối tượng được tạo, đối tượng được đặt, dư lượng đạn, v.v.",
  T_48_META_API_15_D: "Tùy chỉnh nhật ký điểm thi đấu để phân tích dữ liệu trải nghiệm người dùng",
  T_48_META_API_15_P0_D: "Danh sách tên trường cần báo cáo",
  T_48_META_API_15_P1_D: "Danh sách các giá trị trường sẽ được báo cáo",
  T_48_META_API_1500_D: "Lấy thành phần X của vectơ ba chiều",
  T_48_META_API_1500_P0_D: "vectơ 3D",
  T_48_META_API_1500_R_D: "Thành phần X vectơ ba chiều",
  T_48_META_API_1501_D: "Lấy thành phần Y của vectơ ba chiều",
  T_48_META_API_1501_P0_D: "vectơ 3D",
  T_48_META_API_1501_R_D: "Thành phần Y vectơ ba chiều",
  T_48_META_API_1502_D: "Lấy thành phần Z của vectơ ba chiều",
  T_48_META_API_1502_P0_D: "vectơ 3D",
  T_48_META_API_1502_R_D: "Thành phần Z vector ba chiều",
  T_48_META_API_1503_D: "Đặt thành phần X của vectơ ba chiều",
  T_48_META_API_1503_P0_D: "vectơ 3D",
  T_48_META_API_1503_P1_D: "thành phần X",
  T_48_META_API_1504_D: "Đặt thành phần Y của vectơ ba chiều",
  T_48_META_API_1504_P0_D: "vectơ 3D",
  T_48_META_API_1504_P1_D: "thành phần Y",
  T_48_META_API_1505_D: "Đặt thành phần Z của vectơ ba chiều",
  T_48_META_API_1505_P0_D: "vectơ 3D",
  T_48_META_API_1505_P1_D: "thành phần Z",
  T_48_META_API_1506_D: "Thêm hai vectơ ba chiều",
  T_48_META_API_1506_P0_D: "Giá trị trái",
  T_48_META_API_1506_P1_D: "Giá trị phải",
  T_48_META_API_1506_R_D: "Kết quả cộng vector ba chiều",
  T_48_META_API_1507_D: "Trừ hai vectơ ba chiều",
  T_48_META_API_1507_P0_D: "Giá trị trái",
  T_48_META_API_1507_P1_D: "Giá trị phải",
  T_48_META_API_1507_R_D: "Kết quả của việc trừ giá trị rvalue khỏi giá trị của vectơ ba chiều",
  T_48_META_API_1508_D: "Chia tỷ lệ vectơ ba chiều",
  T_48_META_API_1508_P0_D: "Vector 3D được thu nhỏ",
  T_48_META_API_1508_P1_D: "Số lượng tỷ lệ vectơ 3D",
  T_48_META_API_1508_R_D: "Kết quả chia tỷ lệ vector 3D",
  T_48_META_API_1509_D: "Tích vô hướng hai vectơ ba chiều, kết quả của tích vô hướng là vô hướng",
  T_48_META_API_1509_P0_D: "Giá trị trái",
  T_48_META_API_1509_P1_D: "Giá trị phải",
  T_48_META_API_1509_R_D: "Kết quả nhân chấm",
  T_48_META_API_1510_D: "Nhân chéo hai vectơ ba chiều Kết quả của phép nhân chéo là một vectơ, vuông góc với mặt phẳng chứa hai vectơ.",
  T_48_META_API_1510_P0_D: "Giá trị trái",
  T_48_META_API_1510_P1_D: "Giá trị phải",
  T_48_META_API_1510_R_D: "Kết quả của tích chéo, hướng vuông góc với mặt phẳng chứa hai vectơ liên quan đến phép toán.",
  T_48_META_API_1511_D: "Chuẩn hóa vectơ ba chiều",
  T_48_META_API_1511_P0_D: "vectơ 3D",
  T_48_META_API_1511_R_D: "Trả về một vectơ chuẩn hóa mới. Chiều dài khuôn là 1",
  T_48_META_API_1512_D: "Modulo một vectơ ba chiều",
  T_48_META_API_1512_P0_D: "vectơ 3D",
  T_48_META_API_1512_R_D: "Kết quả mô đun là độ dài của mô đun vectơ",
  T_48_META_API_1513_D: "Tính khoảng cách Euclide của hai vectơ ba chiều",
  T_48_META_API_1513_P0_D: "Giá trị trái",
  T_48_META_API_1513_P1_D: "Giá trị phải",
  T_48_META_API_1513_R_D: "Sau khi trừ hai vectơ, độ dài mô đun của vectơ kết quả",
  T_48_META_API_1514_D: "Tính góc giữa hai vectơ ba chiều",
  T_48_META_API_1514_P0_D: "Giá trị trái",
  T_48_META_API_1514_P1_D: "Giá trị phải",
  T_48_META_API_1514_R_D: "Góc vectơ, phạm vi góc 0-180",
  T_48_META_API_1515_D: "Tạo vectơ 3D",
  T_48_META_API_1515_P0_D: "Thành phần X của vectơ ba chiều",
  T_48_META_API_1515_P1_D: "Thành phần Y của vectơ ba chiều",
  T_48_META_API_1515_P2_D: "Thành phần Z của vectơ ba chiều",
  T_48_META_API_1515_R_D: "Vector ba chiều được tạo",
  T_48_META_API_1516_D: "Nhận điểm định hướng mới được xây dựng (không dùng nữa, không sử dụng)",
  T_48_META_API_1516_P0_D: "Vị trí",
  T_48_META_API_1516_P1_D: "đối với",
  T_48_META_API_1516_R_D: "DirectPoint",
  T_48_META_API_1517_D: "Lấy vị trí điểm định hướng (lỗi thời, vui lòng không sử dụng)",
  T_48_META_API_1517_P0_D: "điểm định hướng",
  T_48_META_API_1517_R_D: "Chức vụ",
  T_48_META_API_1518_D: "Nhận định hướng của điểm định hướng (lỗi thời, vui lòng không sử dụng)",
  T_48_META_API_1518_P0_D: "điểm định hướng",
  T_48_META_API_1518_R_D: "Phía trước",
  T_48_META_API_1519_D: "Tạo một danh sách",
  T_48_META_API_1519_P0_D: "Độ dài ban đầu của danh sách phải nhỏ hơn hoặc bằng dung lượng ban đầu",
  T_48_META_API_1519_P1_D: "Dung lượng ban đầu của danh sách phải lớn hơn hoặc bằng độ dài ban đầu. Dung lượng có thể được mở rộng một cách linh hoạt, nhưng nó sẽ tiêu tốn một lượng hiệu suất nhất định. Nên đặt một giá trị phù hợp khi xây dựng.",
  T_48_META_API_1519_R_D: "Danh sách đã tạo",
  T_48_META_API_1520_D: "Kiểm tra xem danh sách có chứa phần tử được chỉ định hay không",
  T_48_META_API_1520_P0_D: "danh sách mục tiêu",
  T_48_META_API_1520_P1_D: "Phần tử được chỉ định để kiểm tra",
  T_48_META_API_1520_R_D: "Có chứa phần tử được chỉ định hay không",
  T_48_META_API_1521_D: "Nối nhiều phần tử vào cuối danh sách mục tiêu",
  T_48_META_API_1521_P0_D: "danh sách mục tiêu",
  T_48_META_API_1521_P1_D: "nối thêm danh sách",
  T_48_META_API_1522_D: "Xóa phần tử được chỉ định khỏi danh sách",
  T_48_META_API_1522_P0_D: "danh sách mục tiêu",
  T_48_META_API_1522_P1_D: "giá trị phần tử cần loại bỏ",
  T_48_META_API_1523_D: "Lấy chỉ mục vị trí nơi phần tử trong danh sách xuất hiện đầu tiên. Nếu không có phần tử đích trong danh sách, -1 sẽ được trả về.",
  T_48_META_API_1523_P0_D: "danh sách mục tiêu",
  T_48_META_API_1523_P1_D: "giá trị phần tử",
  T_48_META_API_1523_R_D: "chỉ số vị trí",
  T_48_META_API_1524_D: "Lấy chỉ số lần xuất hiện cuối cùng của phần tử trong danh sách, nếu không có phần tử đích trong danh sách thì trả về -1.",
  T_48_META_API_1524_P0_D: "danh sách mục tiêu",
  T_48_META_API_1524_P1_D: "giá trị phần tử",
  T_48_META_API_1524_R_D: "chỉ số vị trí",
  T_48_META_API_1525_D: "Tìm sin của một góc",
  T_48_META_API_1525_P0_D: "Góc, 360 tượng trưng cho 360 độ",
  T_48_META_API_1525_R_D: "giá trị sin",
  T_48_META_API_1526_D: "Tìm cosin của một góc",
  T_48_META_API_1526_P0_D: "Góc, 360 tượng trưng cho 360 độ",
  T_48_META_API_1526_R_D: "cô sin",
  T_48_META_API_1527_D: "Tìm tang của một góc",
  T_48_META_API_1527_P0_D: "Góc, 360 tượng trưng cho 360 độ",
  T_48_META_API_1527_R_D: "đường tiếp tuyến",
  T_48_META_API_1528_D: "Xây dựng một giá trị màu với độ trong suốt cố định ở số thập phân 255. Đầu tiên chuyển đổi kênh thành số nhị phân. Mỗi 8 bit đại diện cho một kênh. Ghép nó theo R, G, B và độ trong suốt. trả lại nó.",
  T_48_META_API_1528_P0_D: "Giá trị kênh màu đỏ của màu, phạm vi giá trị là [0,255]. Nếu vượt quá phạm vi, nó sẽ được giới hạn ở giá trị hợp pháp.",
  T_48_META_API_1528_P1_D: "Giá trị kênh màu xanh lá cây của màu, phạm vi giá trị là [0,255]. Nếu vượt quá phạm vi, nó sẽ được giới hạn ở giá trị hợp pháp.",
  T_48_META_API_1528_P2_D: "Giá trị kênh màu xanh lam của màu, phạm vi giá trị là [0,255]. Nếu vượt quá phạm vi, nó sẽ được giới hạn ở giá trị hợp pháp.",
  T_48_META_API_1528_R_D: "giá trị màu được xây dựng",
  T_48_META_API_1529_D: "Thực hiện phép toán arcsine để thu được góc",
  T_48_META_API_1529_P0_D: "Giá trị cho phép toán arcsine, phạm vi giá trị là [-1,1]",
  T_48_META_API_1529_R_D: "góc",
  T_48_META_API_1530_D: "Thực hiện phép tính cung cosin để thu được góc",
  T_48_META_API_1530_P0_D: "Giá trị cho phép tính arc cosine, phạm vi giá trị là [-1,1]",
  T_48_META_API_1530_R_D: "góc",
  T_48_META_API_1531_D: "Thực hiện phép tính arctang để thu được góc",
  T_48_META_API_1531_P0_D: "Giá trị để thực hiện phép toán arctang trên",
  T_48_META_API_1531_R_D: "góc",
  T_48_META_API_1532_D: "Xác định xem thực thể đích có nằm trong phạm vi phạm vi được chỉ định hay không. Nếu thực thể không có thuộc tính vị trí, giá trị sai sẽ được trả về.",
  T_48_META_API_1532_P0_D: "thực thể mục tiêu",
  T_48_META_API_1532_P1_D: "Xác định tâm của hình cầu",
  T_48_META_API_1532_P2_D: "Xác định bán kính của hình cầu",
  T_48_META_API_1532_R_D: "Kết quả phán quyết",
  T_48_META_API_1533_D: "Xác định xem thực thể đích có nằm trong phạm vi hình trụ được chỉ định hay không. Nếu thực thể không có thuộc tính vị trí, giá trị sai sẽ được trả về.",
  T_48_META_API_1533_P0_D: "thực thể mục tiêu",
  T_48_META_API_1533_P1_D: "Xác định điểm trung tâm của hình trụ",
  T_48_META_API_1533_P2_D: "Xác định bán kính mặt cắt ngang của hình trụ",
  T_48_META_API_1533_P3_D: "Xác định chiều cao của hình trụ",
  T_48_META_API_1533_P4_D: "Xác định góc quay Euler ba chiều của hình trụ xung quanh điểm trung tâm",
  T_48_META_API_1533_R_D: "Kết quả phán quyết",
  T_48_META_API_1534_D: "Đoán định liệu thực thể mục tiêu có nằm trong phạm vi hộp lập phương quy định hay không",
  T_48_META_API_1534_P0_D: "thực thể mục tiêu",
  T_48_META_API_1534_P1_D: "Xác định điểm trung tâm của khối",
  T_48_META_API_1534_P2_D: "Xác định chiều dài của khối",
  T_48_META_API_1534_P3_D: "Chỉ định chiều rộng của khối",
  T_48_META_API_1534_P4_D: "Xác định chiều cao của khối",
  T_48_META_API_1534_P5_D: "Xác định phép quay ba chiều Góc Euler của khối xung quanh điểm trung tâm",
  T_48_META_API_1534_R_D: "Kết quả phán quyết",
  T_48_META_API_1535_D: "Xác định xem thực thể mục tiêu có nằm trong phạm vi trụ ngành được chỉ định hay không",
  T_48_META_API_1535_P0_D: "thực thể mục tiêu",
  T_48_META_API_1535_P1_D: "Xác định tâm của phần giữa của hình trụ hình cung",
  T_48_META_API_1535_P2_D: "Xác định bán kính tiết diện giữa của hình trụ hình cung",
  T_48_META_API_1535_P3_D: "Bán kính tiết diện của hình trụ hình cung không được kiểm tra, lấy điểm ở tâm là tâm của hình tròn thì diện tích hình trụ hình cung nhỏ sẽ không được kiểm tra, chỉ chênh lệch giữa hình trụ hình cung quy định và chủ đề hình khu vực nhỏ sẽ được phát hiện",
  T_48_META_API_1535_P4_D: "Chỉ định chiều cao của hình trụ khu vực",
  T_48_META_API_1535_P5_D: "Góc trung tâm của phần hình trụ để phát hiện. Nếu lớn hơn 360, nó sẽ được phát hiện ở dạng hình trụ. Nếu nhỏ hơn 0 thì kích thước vùng phát hiện sẽ là 0.",
  T_48_META_API_1535_P6_D: "Xác định góc quay Euler ba chiều của hình trụ cung quanh điểm trung tâm",
  T_48_META_API_1535_R_D: "Kết quả phán quyết",
  T_48_META_API_1536_D: "So sánh giá trị của hai số và trả về số lớn hơn",
  T_48_META_API_1536_P0_D: "Giá trị trái",
  T_48_META_API_1536_P1_D: "Giá trị phải",
  T_48_META_API_1536_R_D: "số lớn hơn",
  T_48_META_API_1537_D: "Trả về giá trị lớn nhất trong danh sách",
  T_48_META_API_1537_P0_D: "Danh sách mục tiêu, chỉ chấp nhận loại phần tử danh sách dưới dạng số",
  T_48_META_API_1537_P1_D: "Kết quả so sánh Nếu không có chữ số trong danh sách, việc so sánh không thành công và trả về sai.",
  T_48_META_API_1537_P2_D: "Trả về giá trị lớn nhất trong danh sách nếu so sánh thành công và trả về 0 nếu so sánh không thành công.",
  T_48_META_API_1538_D: "So sánh giá trị của hai số và trả về số nhỏ hơn",
  T_48_META_API_1538_P0_D: "Giá trị trái",
  T_48_META_API_1538_P1_D: "Giá trị phải",
  T_48_META_API_1538_R_D: "số nhỏ hơn",
  T_48_META_API_1539_D: "Trả về giá trị nhỏ nhất trong danh sách.",
  T_48_META_API_1539_P0_D: "Danh sách mục tiêu, chỉ chấp nhận loại phần tử danh sách dưới dạng số",
  T_48_META_API_1539_P1_D: "Kết quả so sánh Nếu không có chữ số trong danh sách, việc so sánh không thành công và trả về sai.",
  T_48_META_API_1539_P2_D: "Trả về giá trị nhỏ nhất trong danh sách nếu so sánh thành công và trả về 0 nếu so sánh không thành công.",
  T_48_META_API_1540_D: "Nội suy tuyến tính, trả về giá trị tương ứng với tiến trình nội suy giữa giá trị đầu và giá trị đích, hệ số nội suy [0,1]",
  T_48_META_API_1540_P0_D: "Giá trị bắt đầu của phép nội suy tuyến tính. Giá trị này được trả về khi tiến trình nội suy là 0.",
  T_48_META_API_1540_P1_D: "Giá trị mục tiêu nội suy tuyến tính, giá trị này được trả về khi tiến trình nội suy là 1",
  T_48_META_API_1540_P2_D: "Tiến trình nội suy, phạm vi giá trị [0,1], khi giá trị bằng 0, trả về giá trị bắt đầu, khi giá trị bằng 1, trả về giá trị đích, khi giá trị bằng 0,5, trả về giá trị trung bình của giá trị bắt đầu và giá trị đích giá trị được trả về",
  T_48_META_API_1540_R_D: "giá trị trả về nội suy tuyến tính",
  T_48_META_API_1541_D: "Giới hạn phạm vi của giá trị đích và lấy giá trị ở giữa trong số ba tham số đầu vào; chức năng của nó là giới hạn giá trị đích trong phạm vi đã chỉ định. Nếu giá trị đích nhỏ hơn giá trị tối thiểu thì giá trị tối thiểu sẽ được trả về. giá trị đích lớn hơn",
  T_48_META_API_1541_P0_D: "giá trị mục tiêu",
  T_48_META_API_1541_P1_D: "Giá trị tối thiểu của phạm vi giới hạn",
  T_48_META_API_1541_P2_D: "Giá trị tối đa của phạm vi giới hạn",
  T_48_META_API_1541_R_D: "Giá trị trả về sau khi hạn chế",
  T_48_META_API_1542_D: "Lấy giá trị kênh của màu mục tiêu",
  T_48_META_API_1542_P0_D: "màu mục tiêu",
  T_48_META_API_1542_P1_D: "Giá trị R của màu, phạm vi [0, 255]",
  T_48_META_API_1542_P2_D: "Giá trị G của màu, phạm vi [0, 255]",
  T_48_META_API_1542_P3_D: "Giá trị B của màu, phạm vi [0, 255]",
  T_48_META_API_1542_P4_D: "Giá trị màu, phạm vi [0, 255]",
  T_48_META_API_1543_D: "lũy thừa",
  T_48_META_API_1543_P0_D: "số cơ sở",
  T_48_META_API_1543_P1_D: "chỉ mục",
  T_48_META_API_1543_R_D: "Kết quả tính toán",
  T_48_META_API_1544_D: "Phép toán logarit",
  T_48_META_API_1544_P0_D: "số cơ sở",
  T_48_META_API_1544_P1_D: "số thực",
  T_48_META_API_1544_R_D: "Kết quả tính toán",
  T_48_META_API_1545_D: "Vectơ chỉ phương góc Euler",
  T_48_META_API_1545_P0_D: "vectơ phương hướng",
  T_48_META_API_1545_R_D: "góc Euler",
  T_48_META_API_1546_D: "Vectơ hướng quay góc Euler",
  T_48_META_API_1546_P0_D: "góc Euler",
  T_48_META_API_1546_R_D: "vectơ phương hướng",
  T_48_META_API_1547_D: "Số nguyên cho số dấu phẩy động",
  T_48_META_API_1547_P0_D: "số nguyên",
  T_48_META_API_1547_R_D: "số dấu phẩy động",
  T_48_META_API_1548_D: "Xoay vectơ mục tiêu theo quaternion",
  T_48_META_API_1548_P0_D: "vectơ mục tiêu",
  T_48_META_API_1548_P1_D: "Xoay Quaternion",
  T_48_META_API_1548_R_D: "vectơ xoay",
  T_48_META_API_1549_D: "Chuyển đổi số mục tiêu thành chuỗi",
  T_48_META_API_1549_P0_D: "Số mục tiêu được chuyển đổi thành một chuỗi",
  T_48_META_API_1549_P1_D: "Định dạng chuỗi số đầu ra",
  T_48_META_API_1549_R_D: "sợi dây",
  T_48_META_API_1598_D: "Nhận dấu thời gian của máy chủ",
  T_48_META_API_1598_R_D: "Trả về số giây kể từ 0:00:00 ngày 1 tháng 1 năm 1970",
  T_48_META_API_1599_D: "Nhận khu vực máy chủ",
  T_48_META_API_1599_R_D: "Trả về tên viết tắt của vùng (BR, SAC, ID, NA, US, IND, SG, BD, VN, TH, ME, RU, EU, PK, TW)",
  T_48_META_API_16_D: "Nhật ký theo dõi người dùng được tùy chỉnh để phân tích dữ liệu trải nghiệm người dùng",
  T_48_META_API_16_P0_D: "Người chơi sẽ được báo cáo",
  T_48_META_API_16_P1_D: "Danh sách tên trường cần báo cáo",
  T_48_META_API_16_P2_D: "Danh sách các giá trị trường sẽ được báo cáo",
  T_48_META_API_1601_D: "Tạo một từ điển",
  T_48_META_API_1601_R_D: "từ điển đã tạo",
  T_48_META_API_1602_D: "Nhận giá trị tương ứng với khóa được chỉ định trong từ điển",
  T_48_META_API_1602_P0_D: "từ điển mục tiêu",
  T_48_META_API_1602_P1_D: "Khóa",
  T_48_META_API_1602_R_D: "Giá trị",
  T_48_META_API_1603_D: "Đặt giá trị tương ứng với khóa được chỉ định trong từ điển",
  T_48_META_API_1603_P0_D: "từ điển mục tiêu",
  T_48_META_API_1603_P1_D: "Khóa",
  T_48_META_API_1603_P2_D: "Giá trị",
  T_48_META_API_1604_D: "Xóa cặp khóa-giá trị đã chỉ định khỏi từ điển",
  T_48_META_API_1604_P0_D: "từ điển mục tiêu",
  T_48_META_API_1604_P1_D: "Khóa",
  T_48_META_API_1605_D: "Xóa tất cả các cặp khóa-giá trị trong từ điển",
  T_48_META_API_1605_P0_D: "từ điển mục tiêu",
  T_48_META_API_1606_D: "Lấy số cặp khóa-giá trị trong từ điển",
  T_48_META_API_1606_P0_D: "từ điển mục tiêu",
  T_48_META_API_1606_R_D: "Độ dài từ điển",
  T_48_META_API_1607_D: "Xác định xem một khóa có tồn tại trong từ điển hay không",
  T_48_META_API_1607_P0_D: "từ điển mục tiêu",
  T_48_META_API_1607_P1_D: "Khóa",
  T_48_META_API_1607_R_D: "Có tồn tại không",
  T_48_META_API_1608_D: "Lấy tất cả các khóa của từ điển, trả về dưới dạng danh sách",
  T_48_META_API_1608_P0_D: "từ điển mục tiêu",
  T_48_META_API_1608_R_D: "Danh sách tất cả các giá trị chính",
  T_48_META_API_17_D: "Sử dụng vùng chuyển động tuyến tính hình hộp để phát hiện và trả về tất cả các thực thể gặp phải trên đường đi của vùng hình hộp từ gần đến xa. Nếu ban đầu chúng nằm trong phạm vi hình hộp, chúng sẽ không bị phát hiện; nếu các tham số phân cấp được điền vào chỗ trống, chúng có thể được phát hiện.",
  T_48_META_API_17_P0_D: "Một nửa chiều dài ba cạnh của khu vực hộp, chỉ chấp nhận giá trị dương",
  T_48_META_API_17_P1_D: "điểm trung tâm của khu vực hộp",
  T_48_META_API_17_P2_D: "Xoay vùng hộp",
  T_48_META_API_17_P3_D: "Hướng di chuyển của khu vực hộp",
  T_48_META_API_17_P4_D: "Khoảng cách di chuyển của khu vực hộp, chỉ chấp nhận giá trị dương",
  T_48_META_API_17_P5_D: "Mặt nạ lớp, chỉ những lớp đã điền mới tham gia quét, để trống nghĩa là tất cả các lớp sẽ tham gia quét",
  T_48_META_API_17_P6_D: "Có thể phát hiện các tác nhân",
  T_48_META_API_17_P7_D: "danh sách các thực thể truy cập",
  T_48_META_API_1700_D: "Chuyển đổi chuỗi đã chỉ định thành số nguyên",
  T_48_META_API_1700_P0_D: "chuỗi mục tiêu",
  T_48_META_API_1700_P1_D: "số nguyên kết quả",
  T_48_META_API_1700_P2_D: "Việc chuyển đổi có thành công không?",
  T_48_META_API_1701_D: "Chuyển đổi chuỗi đã chỉ định thành số dấu phẩy động",
  T_48_META_API_1701_P0_D: "chuỗi mục tiêu",
  T_48_META_API_1701_P1_D: "Kết quả nổi",
  T_48_META_API_1701_P2_D: "Việc chuyển đổi có thành công không?",
  T_48_META_API_18_D: "Sử dụng khu vực hình cầu chuyển động theo đường thẳng để phát hiện và trả về tất cả các thực thể gặp phải trên tuyến khu vực hình cầu từ gần đến xa. Nếu ban đầu chúng ở trong khu vực hình cầu, chúng sẽ không bị phát hiện nếu tham số cấp độ được điền vào chỗ trống; , địa hình có thể được phát hiện",
  T_48_META_API_18_P0_D: "Bán kính diện tích hình cầu, chỉ chấp nhận giá trị dương",
  T_48_META_API_18_P1_D: "Tâm của diện tích hình cầu",
  T_48_META_API_18_P2_D: "Hướng di chuyển của diện tích hình cầu",
  T_48_META_API_18_P3_D: "Quãng đường di chuyển của diện tích hình cầu, chỉ chấp nhận giá trị dương",
  T_48_META_API_18_P4_D: "Mặt nạ lớp, chỉ những lớp đã điền mới tham gia quét, để trống nghĩa là tất cả các lớp sẽ tham gia quét",
  T_48_META_API_18_P5_D: "Có thể phát hiện các tác nhân",
  T_48_META_API_18_P6_D: "danh sách các thực thể truy cập",
  T_48_META_API_19_D: "Sử dụng khu vực viên nang chuyển động tuyến tính để phát hiện và trả về tất cả các thực thể gặp phải trên tuyến đường của khu vực viên nang từ gần đến xa. Nếu ban đầu chúng ở trong khu vực viên nang, chúng sẽ không bị phát hiện nếu tham số cấp độ được điền vào; có thể được phát hiện địa hình.",
  T_48_META_API_19_P0_D: "Bán kính bán cầu ở hai đầu của khu vực viên nang, chỉ chấp nhận giá trị dương",
  T_48_META_API_19_P1_D: "Khoảng cách giữa tâm của các bán cầu ở hai đầu của khu vực hình nang phải lớn hơn hai lần bán kính của các bán cầu ở cả hai đầu.",
  T_48_META_API_19_P2_D: "Điểm trung tâm của khu vực viên nang",
  T_48_META_API_19_P3_D: "Xoay khu vực viên nang",
  T_48_META_API_19_P4_D: "Hướng di chuyển của khu vực viên nang",
  T_48_META_API_19_P5_D: "Khoảng cách đã đi trong khu vực nắp, chỉ chấp nhận các giá trị dương",
  T_48_META_API_19_P6_D: "Mặt nạ lớp, chỉ những lớp đã điền mới tham gia quét, để trống nghĩa là tất cả các lớp sẽ tham gia quét",
  T_48_META_API_19_P7_D: "Có thể phát hiện các tác nhân",
  T_48_META_API_19_P8_D: "danh sách các thực thể truy cập",
  T_48_META_API_2_D: "Nhận tất cả các đội trong trò chơi hiện tại và quay lại danh sách đội.",
  T_48_META_API_2_R_D: "Danh sách đội",
  T_48_META_API_20_D: "Sử dụng khu vực hình hộp tĩnh để phát hiện và trả về tất cả các thực thể trong khu vực hình hộp. Nếu tham số cấp độ được điền vào chỗ trống, địa hình có thể được phát hiện.",
  T_48_META_API_20_P0_D: "Một nửa chiều dài ba cạnh của khu vực hộp, chỉ chấp nhận giá trị dương",
  T_48_META_API_20_P1_D: "điểm trung tâm của khu vực hộp",
  T_48_META_API_20_P2_D: "Xoay vùng hộp",
  T_48_META_API_20_P3_D: "Mặt nạ lớp, chỉ những lớp đã điền mới tham gia quét, để trống nghĩa là tất cả các lớp sẽ tham gia quét",
  T_48_META_API_20_P4_D: "Có thể phát hiện các tác nhân",
  T_48_META_API_20_P5_D: "danh sách các thực thể truy cập",
  T_48_META_API_2000_D: "Đặt giá trị thuộc tính của thực thể đích, yêu cầu thuộc tính đó đã được xác định",
  T_48_META_API_2000_P0_D: "thực thể mục tiêu",
  T_48_META_API_2000_P1_D: "một thuộc tính của thực thể mục tiêu",
  T_48_META_API_2000_P2_D: "Giá trị đích cần phải phù hợp với loại được yêu cầu khi thuộc tính được xác định.",
  T_48_META_API_2000_P3_D: "Chế độ hoạt động, tất cả các loại đều hỗ trợ gán và các loại số cũng hỗ trợ tự cộng, tự trừ, tự nhân, tự chia và tự dư.",
  T_48_META_API_2001_D: "Lấy giá trị thuộc tính của một thực thể",
  T_48_META_API_2001_P0_D: "thực thể mục tiêu",
  T_48_META_API_2001_P1_D: "ID thuộc tính của thực thể",
  T_48_META_API_2001_R_D: "giá trị thuộc tính",
  T_48_META_API_2002: "Thiết lập Thuộc tính Đồ thị",
  T_48_META_API_2002_D: "Đặt biến tập lệnh",
  T_48_META_API_2002_P0_D: "thực thể mục tiêu",
  T_48_META_API_2002_P1: "ID đồ thị",
  T_48_META_API_2002_P1_D: "ID tập lệnh mục tiêu",
  T_48_META_API_2002_P2: "ID tài sản",
  T_48_META_API_2002_P2_D: "ID thuộc tính thành viên được xác định trong tập lệnh",
  T_48_META_API_2002_P3: "Giá trị tài sản",
  T_48_META_API_2002_P3_D: "Giá trị đích cần phải phù hợp với loại được yêu cầu khi thuộc tính được xác định.",
  T_48_META_API_2002_P4_D: "Chế độ hoạt động, tất cả các loại đều hỗ trợ gán và các loại số cũng hỗ trợ tự cộng, tự trừ, tự nhân, tự chia và tự dư.",
  T_48_META_API_2003: "Nhận Thuộc tính Đồ thị",
  T_48_META_API_2003_D: "Nhận các biến tập lệnh",
  T_48_META_API_2003_P0_D: "thực thể mục tiêu",
  T_48_META_API_2003_P1: "ID đồ thị",
  T_48_META_API_2003_P1_D: "ID tập lệnh mục tiêu",
  T_48_META_API_2003_P2: "ID tài sản",
  T_48_META_API_2003_P2_D: "ID thuộc tính mục tiêu",
  T_48_META_API_2003_R_D: "giá trị thuộc tính",
  T_48_META_API_2004_D: "Xác định và khởi tạo một biến cục bộ. Phạm vi của biến cục bộ là từ vị trí khai báo đến cuối khối câu lệnh.",
  T_48_META_API_2004_P0_D: "tên biến",
  T_48_META_API_2004_P1_D: "giá trị ban đầu thay đổi",
  T_48_META_API_2004_P2_D: "Kiểu khai báo biến Khi gán một giá trị, nó cần phải tuân theo kiểu khai báo.",
  T_48_META_API_2005_D: "Đặt giá trị của biến cục bộ. Phạm vi của biến cục bộ là từ vị trí khai báo đến cuối khối câu lệnh.",
  T_48_META_API_2005_P0_D: "tên biến",
  T_48_META_API_2005_P1: "Giá trị biến đổi",
  T_48_META_API_2005_P1_D: "giá trị biến",
  T_48_META_API_2005_P2_D: "Chế độ hoạt động, tất cả các loại đều hỗ trợ gán và các loại số cũng hỗ trợ tự cộng, tự trừ, tự nhân, tự chia và tự dư.",
  T_48_META_API_2006: "Lấy biến cục bộ",
  T_48_META_API_2006_D: "Lấy giá trị của biến cục bộ. Phạm vi của biến cục bộ là từ vị trí khai báo đến cuối khối câu lệnh.",
  T_48_META_API_2006_P0: "Tên biến",
  T_48_META_API_2006_P0_D: "tên biến",
  T_48_META_API_2006_R_D: "giá trị biến",
  T_48_META_API_2009: "Tìm và gọi API tùy chỉnh toàn cầu với Serial",
  T_48_META_API_2009_D: "Gọi hàm tùy chỉnh chung theo cách nối tiếp. Nếu có sự chờ đợi trong hàm tùy chỉnh, vị trí gọi cũng sẽ chờ.",
  T_48_META_API_2009_P0: "ID đồ thị",
  T_48_META_API_2009_P0_D: "ID tập lệnh nơi đặt chức năng tùy chỉnh",
  T_48_META_API_2009_P1: "ID chức năng",
  T_48_META_API_2009_P1_D: "ID chức năng tùy chỉnh được gọi là",
  T_48_META_API_2009_P2_D: "Danh sách các tham số được truyền cho hàm tùy chỉnh",
  T_48_META_API_2010: "Tìm và gọi API tùy chỉnh toàn cầu với Parallel",
  T_48_META_API_2010_D: "Gọi song song chức năng tùy chỉnh toàn cầu. Bất kể có chờ đợi trong chức năng tùy chỉnh hay không, nó sẽ ngay lập tức quay trở lại vị trí gọi và tiếp tục thực hiện.",
  T_48_META_API_2010_P0: "ID đồ thị",
  T_48_META_API_2010_P0_D: "ID tập lệnh nơi đặt chức năng tùy chỉnh",
  T_48_META_API_2010_P1: "ID chức năng",
  T_48_META_API_2010_P1_D: "ID chức năng tùy chỉnh được gọi là",
  T_48_META_API_2010_P2_D: "Danh sách các tham số được truyền cho hàm tùy chỉnh",
  T_48_META_API_2013: "Thiết lập Thuộc tính Đồ thị Tự",
  T_48_META_API_2013_D: "Đặt biến cho tập lệnh hiện tại",
  T_48_META_API_2013_P0: "ID tài sản",
  T_48_META_API_2013_P0_D: "ID thuộc tính mục tiêu",
  T_48_META_API_2013_P1: "Giá trị tài sản",
  T_48_META_API_2013_P1_D: "giá trị mục tiêu",
  T_48_META_API_2013_P2_D: "Chế độ hoạt động, tất cả các loại đều hỗ trợ gán và các loại số cũng hỗ trợ tự cộng, tự trừ, tự nhân, tự chia và tự dư.",
  T_48_META_API_2014: "Nhận Thuộc tính Đồ thị Tự thân",
  T_48_META_API_2014_D: "Lấy các biến của tập lệnh hiện tại",
  T_48_META_API_2014_P0: "ID tài sản",
  T_48_META_API_2014_P0_D: "ID thuộc tính mục tiêu",
  T_48_META_API_2014_R_D: "giá trị thuộc tính",
  T_48_META_API_21_D: "Sử dụng một khu vực hình cầu tĩnh để phát hiện và trả về tất cả các thực thể trong khu vực hình cầu. Nếu tham số cấp độ được điền vào chỗ trống, địa hình có thể được phát hiện.",
  T_48_META_API_21_P0_D: "Bán kính diện tích hình cầu, chỉ chấp nhận giá trị dương",
  T_48_META_API_21_P1_D: "Tâm của diện tích hình cầu",
  T_48_META_API_21_P2_D: "Mặt nạ lớp, chỉ những lớp đã điền mới tham gia quét, để trống nghĩa là tất cả các lớp sẽ tham gia quét",
  T_48_META_API_21_P3_D: "Có thể phát hiện các tác nhân",
  T_48_META_API_21_P4_D: "danh sách các thực thể truy cập",
  T_48_META_API_22_D: "Sử dụng khu vực viên nang tĩnh để phát hiện và trả về tất cả các thực thể trong khu vực viên nang. Nếu tham số cấp độ được điền vào, địa hình có thể được phát hiện.",
  T_48_META_API_22_P0_D: "Bán kính bán cầu ở hai đầu của khu vực viên nang, chỉ chấp nhận giá trị dương",
  T_48_META_API_22_P1_D: "Khoảng cách giữa tâm của các bán cầu ở hai đầu của khu vực hình nang phải lớn hơn hai lần bán kính của các bán cầu ở cả hai đầu.",
  T_48_META_API_22_P2_D: "Điểm trung tâm của khu vực viên nang",
  T_48_META_API_22_P3_D: "Xoay khu vực viên nang",
  T_48_META_API_22_P4_D: "Mặt nạ lớp, chỉ những lớp đã điền mới tham gia quét, để trống nghĩa là tất cả các lớp sẽ tham gia quét",
  T_48_META_API_22_P5_D: "Có thể phát hiện các tác nhân",
  T_48_META_API_22_P6_D: "danh sách các thực thể truy cập",
  T_48_META_API_23_D: "Đặt trạng thái vật phẩm đặc biệt cho người chơi Bạn chỉ có thể có một vật phẩm đặc biệt.",
  T_48_META_API_23_P0_D: "người chơi",
  T_48_META_API_23_P1_D: "Mã mặt hàng",
  T_48_META_API_23_P2_D: "Có bật mục này hay không",
  T_48_META_API_23_P3_D: "thực thể hạng mục đặc biệt",
  T_48_META_API_24_D: "Tác dụng một lực lên mục tiêu, mục tiêu phải là một vật thể",
  T_48_META_API_24_P0_D: "đối tượng vật lý mục tiêu",
  T_48_META_API_24_P1_D: "vectơ lực",
  T_48_META_API_24_P2_D: "loại lực lượng",
  T_48_META_API_25_D: "Tác dụng lực một lần vào một điểm nhất định, mục tiêu phải là một vật thể cứng nhắc",
  T_48_META_API_25_P0_D: "mục tiêu cơ thể cứng nhắc",
  T_48_META_API_25_P1_D: "vectơ lực",
  T_48_META_API_25_P2_D: "Buộc ứng tuyển vị trí",
  T_48_META_API_25_P3_D: "loại lực lượng",
  T_48_META_API_26_D: "Tác dụng một mô-men xoắn lên mục tiêu, mục tiêu phải là một vật rắn",
  T_48_META_API_26_P0_D: "mục tiêu cơ thể cứng nhắc",
  T_48_META_API_26_P1_D: "mô-men xoắn",
  T_48_META_API_26_P2_D: "Loại lực",
  T_48_META_API_27_D: "Di chuyển vật cứng mục tiêu đến vị trí đã chỉ định",
  T_48_META_API_27_P0_D: "mục tiêu cơ thể cứng nhắc",
  T_48_META_API_27_P1_D: "Chỉ định vị trí",
  T_48_META_API_28_D: "Xoay cơ thể cứng nhắc của mục tiêu",
  T_48_META_API_28_P0_D: "mục tiêu cơ thể cứng nhắc",
  T_48_META_API_28_P1_D: "Xoay Quaternion",
  T_48_META_API_29_D: "Tạo chuyển động nội suy và các thuộc tính được chỉ định của thực thể mục tiêu sẽ di chuyển trơn tru theo cài đặt",
  T_48_META_API_29_P0_D: "thực thể mục tiêu",
  T_48_META_API_29_P1_D: "ID thuộc tính cần thay đổi",
  T_48_META_API_29_P2_D: "giá trị bắt đầu thuộc tính",
  T_48_META_API_29_P3_D: "giá trị cuối thuộc tính",
  T_48_META_API_29_P4_D: `Bạn có thể chọn đơn, vòng lặp và qua lại. 
 Vòng lặp có nghĩa là sau khi mỗi chuyển động hoàn tất, thực thể sẽ di chuyển lại từ giá trị bắt đầu. Qua lại có nghĩa là sau khi chuyển động từ giá trị bắt đầu đến giá trị mục tiêu hoàn tất, thực thể sẽ di chuyển lại từ giá trị mục tiêu đến giá trị bắt đầu, sau đó lặp lại quá trình`,
  T_48_META_API_29_P5_D: "Điểm kiểm soát đường cong Bezier",
  T_48_META_API_29_P6_D: "Khoảng thời gian thay đổi, tính bằng mili giây",
  T_48_META_API_29_P7_D: "Đã tạo thực thể chuyển động nội suy",
  T_48_META_API_29_P8_D: "Có tự động bắt đầu phát sau khi tạo hay không",
  T_48_META_API_3_D: "Chuyển trò chơi sang giai đoạn mục tiêu và vòng đấu cũng là một giai đoạn đặc biệt. Khi chuyển sang một pha trong một lượt, số lượt là 0.",
  T_48_META_API_3_P0_D: "Chỉ số của vòng hoặc giai đoạn mục tiêu",
  T_48_META_API_30_D: "Buộc người chơi mục tiêu vào phương tiện được chỉ định",
  T_48_META_API_30_P0_D: "người chơi mục tiêu",
  T_48_META_API_30_P1_D: "thực thể xe",
  T_48_META_API_30_P2_D: "Số ghế",
  T_48_META_API_30_P3_D: "Liệu người chơi có được phép vào xe thành công hay không",
  T_48_META_API_3001_D: "Khiến người chơi mục tiêu đánh rơi vật phẩm",
  T_48_META_API_3001_P0_D: "người chơi mục tiêu",
  T_48_META_API_3001_P1_D: "Thực thể mục",
  T_48_META_API_3002_D: "Nhận tọa độ có sẵn trong điểm sinh sản ngẫu nhiên hiện có nhưng chưa bị chiếm dụng hoàn toàn (lỗi thời, vui lòng sử dụng GetRandomSpawnPosition)",
  T_48_META_API_3002_P0_D: "Người chơi cần chỉ định khu vực sinh sản",
  T_48_META_API_3002_R_D: "Tọa độ điểm ngẫu nhiên được gán ngẫu nhiên",
  T_48_META_API_3003_D: "Lấy tổng giá trị điểm của loại điểm được chỉ định của người chơi",
  T_48_META_API_3003_P0_D: "người chơi",
  T_48_META_API_3003_P1_D: "Loại điểm",
  T_48_META_API_3003_R_D: "Giá trị điểm",
  T_48_META_API_3004_D: "Đặt giá trị điểm làm tròn cho loại điểm do người chơi chỉ định",
  T_48_META_API_3004_P0_D: "thực thể người chơi",
  T_48_META_API_3004_P1_D: "Loại điểm",
  T_48_META_API_3004_P2_D: "Giá trị điểm",
  T_48_META_API_3005_D: "Lấy tổng giá trị điểm của loại điểm được chỉ định cho đội",
  T_48_META_API_3005_P0_D: "Thực thể nhóm",
  T_48_META_API_3005_P1_D: "Loại điểm",
  T_48_META_API_3005_R_D: "Giá trị điểm",
  T_48_META_API_3006_D: "Đặt giá trị điểm làm tròn cho loại điểm được chỉ định của đội",
  T_48_META_API_3006_P0_D: "Thực thể nhóm",
  T_48_META_API_3006_P1_D: "Loại điểm",
  T_48_META_API_3006_P2_D: "Giá trị điểm",
  T_48_META_API_3007_D: "Nhận điểm của người chơi cho vòng và loại điểm được chỉ định",
  T_48_META_API_3007_P0_D: "thực thể người chơi",
  T_48_META_API_3007_P1_D: "chỉ số tròn",
  T_48_META_API_3007_P2_D: "Loại điểm",
  T_48_META_API_3007_R_D: "Giá trị điểm",
  T_48_META_API_3008_D: "Nhận điểm của đội cho vòng và loại điểm được chỉ định",
  T_48_META_API_3008_P0_D: "Thực thể nhóm",
  T_48_META_API_3008_P1_D: "chỉ số tròn",
  T_48_META_API_3008_P2_D: "Loại điểm",
  T_48_META_API_3008_R_D: "Giá trị điểm",
  T_48_META_API_3009_D: "Nhận tổng xếp hạng trò chơi của người chơi",
  T_48_META_API_3009_P0_D: "thực thể người chơi",
  T_48_META_API_3009_R_D: "Xếp hạng",
  T_48_META_API_3011_D: "Nhận thứ hạng tổng thể của trò chơi của đội",
  T_48_META_API_3011_P0_D: "Không dùng nữa",
  T_48_META_API_3011_R_D: "Xếp hạng",
  T_48_META_API_3013_D: "Nhận thứ hạng vòng được chỉ định của người chơi",
  T_48_META_API_3013_P0_D: "thực thể người chơi",
  T_48_META_API_3013_P1_D: "chỉ số tròn",
  T_48_META_API_3013_R_D: "Xếp hạng",
  T_48_META_API_3014_D: "Nhận thứ hạng vòng được chỉ định của đội",
  T_48_META_API_3014_P0_D: "Không dùng nữa",
  T_48_META_API_3014_P1_D: "chỉ số tròn",
  T_48_META_API_3014_R_D: "Xếp hạng",
  T_48_META_API_3015_D: "Lấy ví của thực thể mục tiêu",
  T_48_META_API_3015_P0_D: "thực thể mục tiêu",
  T_48_META_API_3015_P1_D: "Ví có tồn tại không?",
  T_48_META_API_3015_P2_D: "Thực thể ví thu được",
  T_48_META_API_3016_D: "Tạo ví cho người chơi mục tiêu. Nếu người chơi đã có ví, nó sẽ không hợp lệ.",
  T_48_META_API_3016_P0_D: "người chơi mục tiêu",
  T_48_META_API_3016_P1_D: "Thực thể bị ràng buộc với ví, chủ sở hữu của ví",
  T_48_META_API_3016_P2_D: "thực thể ví",
  T_48_META_API_3017_D: "Thêm tiền vào ví được chỉ định",
  T_48_META_API_3017_P0_D: "ví mục tiêu",
  T_48_META_API_3017_P1_D: "Đã thêm loại tiền tệ",
  T_48_META_API_3017_P2_D: "Số tiền tệ tăng thêm",
  T_48_META_API_3018_D: "Giảm tiền tệ cho ví được chỉ định",
  T_48_META_API_3018_P0_D: "ví mục tiêu",
  T_48_META_API_3018_P1_D: "Các loại tiền tệ giảm",
  T_48_META_API_3018_P2_D: "Số tiền giảm",
  T_48_META_API_3019_D: "Chuyển tiền từ ví này sang ví khác",
  T_48_META_API_3019_P0_D: "Ví để chuyển tiền từ",
  T_48_META_API_3019_P1_D: "Loại tiền được chuyển",
  T_48_META_API_3019_P2_D: "Số tiền được chuyển",
  T_48_META_API_3019_P3_D: "Ví để chuyển tiền tới",
  T_48_META_API_3020_D: "Nhận số lượng loại tiền được chỉ định trong ví được chỉ định",
  T_48_META_API_3020_P0_D: "ví mục tiêu",
  T_48_META_API_3020_P1_D: "Loại tiền tệ truy vấn",
  T_48_META_API_3020_R_D: "số lượng tiền tệ",
  T_48_META_API_3021_D: "Lấy thực thể của loại tiền tệ được chỉ định trong ví được chỉ định",
  T_48_META_API_3021_P0_D: "ví mục tiêu",
  T_48_META_API_3021_P1_D: "Loại tiền tệ truy vấn",
  T_48_META_API_3021_R_D: "thực thể tiền tệ",
  T_48_META_API_3022_D: "Nhận tất cả các cửa hàng trong game, trả về dưới dạng danh sách",
  T_48_META_API_3022_R_D: "Danh sách thực thể cửa hàng",
  T_48_META_API_3023_D: "Thay thế diện mạo của người chơi mục tiêu bằng diện mạo của đối tượng cảnh được chỉ định",
  T_48_META_API_3023_P0_D: "người chơi mục tiêu",
  T_48_META_API_3023_P1_D: "Đối tượng cảnh mục tiêu thay thế",
  T_48_META_API_3023_P2_D: "Thành phần ngụy trang chuyển đổi người chơi được tạo sau khi thay thế",
  T_48_META_API_3024_D: "Hủy bỏ trạng thái ngụy trang của người chơi",
  T_48_META_API_3024_P0_D: "người chơi mục tiêu",
  T_48_META_API_3025_D: "Tạo một bản sao của thực thể cảnh tại trình phát mục tiêu",
  T_48_META_API_3025_P0_D: "người chơi mục tiêu",
  T_48_META_API_3025_P1_D: "Các thực thể cảnh được sử dụng cho hình đại diện",
  T_48_META_API_3025_P2_D: "Đã tạo thực thể nhân bản",
  T_48_META_API_3026_D: "Nhận thực thể cải trang của người chơi",
  T_48_META_API_3026_P0_D: "người chơi",
  T_48_META_API_3026_R_D: "Thực thể cải trang người chơi",
  T_48_META_API_3027_D: "Nhận thực thể kênh trò chuyện dựa trên chỉ mục",
  T_48_META_API_3027_P0_D: "Chỉ số kênh trò chuyện, phạm vi [1,8]",
  T_48_META_API_3027_R_D: "Thực thể kênh trò chuyện",
  T_48_META_API_3028_D: "Nhận thực thể kênh trò chuyện nơi người chơi được chỉ định hiện đang ở",
  T_48_META_API_3028_P0_D: "người chơi mục tiêu",
  T_48_META_API_3028_R_D: "Thực thể kênh trò chuyện",
  T_48_META_API_3029_D: "Cho phép người chơi tham gia kênh trò chuyện được chỉ định. Nếu người chơi đã ở kênh trò chuyện khác, anh ta sẽ chuyển sang kênh mục tiêu.",
  T_48_META_API_3029_P0_D: "người chơi mục tiêu",
  T_48_META_API_3029_P1_D: "Thực thể kênh trò chuyện",
  T_48_META_API_3030_D: "Khiến người chơi thoát khỏi kênh hiện tại và sau đó rơi vào trạng thái không tham gia bất kỳ kênh trò chuyện nào",
  T_48_META_API_3030_P0_D: "người chơi mục tiêu",
  T_48_META_API_3031_D: "Không dùng nữa",
  T_48_META_API_3031_P0_D: "Thực thể kênh trò chuyện, trống khi không có người chơi trong kênh",
  T_48_META_API_3032_D: "Đặt trạng thái hành vi của người chơi",
  T_48_META_API_3032_P0_D: "người chơi mục tiêu",
  T_48_META_API_3032_P1_D: "Kiểu hành vi của người chơi",
  T_48_META_API_3032_P2_D: `Đã bật: Có nút HUD và có thể được sử dụng bình thường
Đã tắt: Nút HUD bị tắt và không thể vào trạng thái hành vi một cách chủ động hoặc thụ động
Shield: Nút HUD bị ẩn và không thể chủ động vào trạng thái hành vi, nhưng có thể vào một cách thụ động trạng`,
  T_48_META_API_3033_D: "Người chơi biến thành một đối tượng cảnh được chỉ định",
  T_48_META_API_3033_P0_D: "người chơi mục tiêu",
  T_48_META_API_3033_P1_D: "Đối tượng cần chuyển đổi thành",
  T_48_META_API_3033_P2_D: "Thực thể được tạo sau khi chuyển đổi",
  T_48_META_API_3034_D: "Người chơi tạo một bản sao của chính mình",
  T_48_META_API_3034_P0_D: "người chơi mục tiêu",
  T_48_META_API_3034_P1_D: "Đã tạo thực thể nhân bản",
  T_48_META_API_3035_D: "Tạo một cửa hàng tùy chỉnh trong đó cấp độ tiếp theo của cửa hàng là kệ",
  T_48_META_API_3035_P0_D: "Đã tạo thực thể cửa hàng",
  T_48_META_API_3036_D: "Tạo một kệ tùy chỉnh. Cấp trên của kệ là cửa hàng và cấp tiếp theo là sản phẩm.",
  T_48_META_API_3036_P0_D: "Đã tạo thực thể kệ",
  T_48_META_API_3037_D: "Tạo một sản phẩm tùy chỉnh có thể thêm các mặt hàng",
  T_48_META_API_3037_P0_D: "Thực thể sản phẩm đã tạo",
  T_48_META_API_3038_D: "Thêm các mục vào một sản phẩm Có thể thêm nhiều mục vào một sản phẩm bằng cách sử dụng nguyên thủy này nhiều lần.",
  T_48_META_API_3038_P0_D: "Thực thể hàng hóa",
  T_48_META_API_3038_P1_D: "Các mục cần thêm",
  T_48_META_API_3038_P2_D: "Số lượng mặt hàng",
  T_48_META_API_3039_D: "Trao phần thưởng bẻ khóa",
  T_48_META_API_3039_P0_D: "thực thể người chơi",
  T_48_META_API_3039_P1_D: "Số lượng",
  T_48_META_API_3039_P2_D: "tiền thật",
  T_48_META_API_3040_D: "Cập nhật nhiệm vụ bẻ khóa",
  T_48_META_API_3040_P0_D: "thực thể người chơi",
  T_48_META_API_3040_P1_D: "ID nhiệm vụ",
  T_48_META_API_3040_P2_D: "giá trị",
  T_48_META_API_3041_D: "Việc lấy tọa độ điểm sinh sản ngẫu nhiên sẽ chỉ ngẫu nhiên từ các điểm sinh sản có sẵn nhưng chưa bị chiếm đóng hoàn toàn.",
  T_48_META_API_3041_P0_D: "người chơi mục tiêu",
  T_48_META_API_3041_R_D: "Tọa độ điểm sinh ngẫu nhiên Nếu không có điểm sinh nào thỏa mãn điều kiện thì sẽ trả về vị trí gần (0, 0, 0).",
  T_48_META_API_3042_D: "Thoát khỏi trò chơi mini jailbreak",
  T_48_META_API_3042_P0_D: "thực thể người chơi",
  T_48_META_API_3042_P1_D: "ID nhiệm vụ",
  T_48_META_API_3043_D: "Dựa trên đạo cụ bẻ khóa",
  T_48_META_API_3043_P0_D: "thực thể người chơi",
  T_48_META_API_3043_P1_D: "Loại chống đỡ",
  T_48_META_API_3043_P2_D: "ID dự án",
  T_48_META_API_31_D: "Tạo chuyển động tự tương đối và thực thể mục tiêu thay đổi tương ứng với giá trị thuộc tính hiện tại của nó mỗi lần",
  T_48_META_API_31_P0_D: "thực thể mục tiêu",
  T_48_META_API_31_P1_D: "Thuộc tính yêu cầu thay đổi chuyển động",
  T_48_META_API_31_P2_D: "lượng thay đổi trên mỗi chuyển động",
  T_48_META_API_31_P3_D: "Điểm kiểm soát đường cong Bezier",
  T_48_META_API_31_P4_D: `Đơn: Dừng khi thuộc tính thay đổi lượng Delta
Vòng lặp: Lặp lại chuyển động, mỗi lần thuộc tính thay đổi lượng Delta`,
  T_48_META_API_31_P5_D: "Khoảng thời gian thay đổi, tính bằng mili giây",
  T_48_META_API_31_P6_D: "Thực thể tự di chuyển tương đối được tạo",
  T_48_META_API_31_P7_D: "Có tự động bắt đầu phát sau khi tạo hay không",
  T_48_META_API_3100_D: "Mục tiêu phát hoạt ảnh ở trạng thái được chỉ định",
  T_48_META_API_3100_P0_D: "Một thành phần thực thể có thể được gắn với bộ điều khiển hoạt ảnh để phát hoạt ảnh",
  T_48_META_API_3100_P1_D: "Trạng thái được chỉ định của bộ điều khiển hoạt ảnh",
  T_48_META_API_3100_P2_D: "Chia tỷ lệ tốc độ phát lại hoạt ảnh",
  T_48_META_API_3100_P3_D: "Loại vòng lặp, bạn có thể giữ logic gốc của hoạt ảnh, chỉ phát một lần hoặc phát theo vòng lặp",
  T_48_META_API_3101_D: "Chơi hoạt hình nhân vật và hỗ trợ tài nguyên hoạt hình tùy chỉnh",
  T_48_META_API_3101_P0_D: "người chơi mục tiêu",
  T_48_META_API_3101_P1_D: "ID tài nguyên hoạt ảnh tùy chỉnh",
  T_48_META_API_3101_P2_D: "Có lặp lại hay không",
  T_48_META_API_3102_D: "Đặt tài nguyên nhân vật của người chơi được chỉ định",
  T_48_META_API_3102_P0_D: "người chơi mục tiêu",
  T_48_META_API_3102_P1_D: "ID tài nguyên vai trò tùy chỉnh",
  T_48_META_API_3109_D: "Bật vùng an toàn sẽ di chuyển thuận lợi về điểm cuối",
  T_48_META_API_3109_P0_D: "Vị trí bắt đầu của vùng an toàn",
  T_48_META_API_3109_P1_D: "Vị trí cuối vùng an toàn",
  T_48_META_API_3109_P2_D: "Bán kính ban đầu của vùng an toàn",
  T_48_META_API_3109_P3_D: "bán kính cuối cùng của vùng an toàn",
  T_48_META_API_3109_P4_D: "Thời gian cần thiết để vùng an toàn đạt đến trạng thái cuối cùng, tính bằng giây",
  T_48_META_API_3109_P5_D: "Lượng sát thương nhận được mỗi giây ngoài vùng an toàn",
  T_48_META_API_3110_D: "Chuyển đổi nhóm xuất hiện nhân vật",
  T_48_META_API_3110_P0_D: "Mục tiêu",
  T_48_META_API_3110_P1_D: "nhóm xuất hiện",
  T_48_META_API_3111_D: "Hiển thị nhóm ngoại hình nhân vật",
  T_48_META_API_3111_P0_D: "Mục tiêu",
  T_48_META_API_3111_P1_D: "nhóm xuất hiện",
  T_48_META_API_3112_D: "Ẩn nhóm ngoại hình nhân vật",
  T_48_META_API_3112_P0_D: "Mục tiêu",
  T_48_META_API_3112_P1_D: "nhóm xuất hiện",
  T_48_META_API_3121_D: "Gửi kết quả xác nhận tới việc sử dụng số liệu thống kê của Craftland Studio PC",
  T_48_META_API_3121_P0_D: "biểu thức khẳng định",
  T_48_META_API_3121_P1_D: "gợi ý",
  T_48_META_API_32_D: "Nhận dữ liệu mã thông báo ngày hôm nay của người chơi",
  T_48_META_API_32_P0_D: "người chơi mục tiêu",
  T_48_META_API_32_P1_D: "tokenID",
  T_48_META_API_32_P2_D: "Số lượng token",
  T_48_META_API_32_P3_D: "Liệu nguyên thủy có được gọi thành công hay không",
  T_48_META_API_3200_D: "Thêm vật phẩm vào trình phát và trả lại danh sách vật phẩm đã phát hành",
  T_48_META_API_3200_P0_D: "người chơi",
  T_48_META_API_3200_P1_D: "Mã mặt hàng",
  T_48_META_API_3200_P2_D: "Số lượng mặt hàng",
  T_48_META_API_3200_P3_D: "Danh sách các mục được thêm cho người chơi, được trả về dưới dạng danh sách ngay cả khi chỉ thêm một mục",
  T_48_META_API_3201_D: "Khôi phục lượng máu của người chơi được chỉ định mà không vượt quá giới hạn trên của lượng máu.",
  T_48_META_API_3201_P0_D: "người chơi mục tiêu",
  T_48_META_API_3201_P1_D: "Giá trị thêm máu cho người chơi chỉ được chấp nhận.",
  T_48_META_API_3202_D: "Đặt danh sách kỹ năng của người chơi mục tiêu",
  T_48_META_API_3202_P0_D: "người chơi mục tiêu",
  T_48_META_API_3202_P1_D: "Danh sách kỹ năng",
  T_48_META_API_3203_D: "Lấy danh sách kỹ năng của người chơi mục tiêu",
  T_48_META_API_3203_P0_D: "người chơi mục tiêu",
  T_48_META_API_3203_R_D: "Danh sách kỹ năng",
  T_48_META_API_3205_D: "Xóa một số vật phẩm nhất định khỏi trình phát",
  T_48_META_API_3205_P0_D: "người chơi mục tiêu",
  T_48_META_API_3205_P1_D: "Loại mục cần xóa",
  T_48_META_API_3205_P2_D: "Số lượng cần xóa, nếu vượt quá số lượng người chơi nắm giữ thì chỉ những vật phẩm đang giữ mới bị xóa.",
  T_48_META_API_3206_D: "Lấy số lượng vật phẩm được chỉ định mà người chơi nắm giữ",
  T_48_META_API_3206_P0_D: "người chơi mục tiêu",
  T_48_META_API_3206_P1_D: "Loại mặt hàng",
  T_48_META_API_3206_R_D: "Số tiền người chơi nắm giữ",
  T_48_META_API_3207_D: "Kiểm tra xem người chơi có thể kích hoạt điểm kiểm tra hiện tại không",
  T_48_META_API_3207_P0_D: "người chơi mục tiêu",
  T_48_META_API_3207_P1_D: "Bộ kích hoạt",
  T_48_META_API_3207_R_D: "Đúng: có thể kích hoạt, Sai: không thể kích hoạt",
  T_48_META_API_3208_D: "Chế độ lây nhiễm zombie tiến hóa",
  T_48_META_API_3208_P0_D: "người chơi mục tiêu",
  T_48_META_API_3209_D: "Các thực thể AI dừng/thực thi cây hành vi mặc định",
  T_48_META_API_3209_P0_D: "Để kích hoạt mục tiêu cây hành vi",
  T_48_META_API_3209_P1_D: "Có thực thi cây hành vi mặc định hay không",
  T_48_META_API_3210_D: "Các thực thể AI đuổi theo các mục tiêu được chỉ định",
  T_48_META_API_3210_P0_D: "Thực thể AI thực hiện việc truy đuổi",
  T_48_META_API_3210_P1_D: "Mục tiêu đang theo đuổi",
  T_48_META_API_3211_D: "Phá hủy các vật phẩm của người chơi (không dùng nữa, sử dụng Xóa trang bị)",
  T_48_META_API_3211_P0_D: "Người chơi có vật phẩm bị phá hủy",
  T_48_META_API_3211_P1_D: "Loại vật phẩm bị phá hủy",
  T_48_META_API_3211_P2_D: "Khe vũ khí, chỉ hiệu quả với vũ khí",
  T_48_META_API_3212_D: "Thay áo đấu",
  T_48_META_API_3212_P0_D: "người chơi mục tiêu",
  T_48_META_API_3212_P1_D: "Phong cách quần áo",
  T_48_META_API_3212_P2_D: "màu chính một",
  T_48_META_API_3212_P3_D: "Màu chủ đạo hai",
  T_48_META_API_3212_P4_D: "Cấu hình",
  T_48_META_API_3213_D: "Khôi phục áo đấu của cầu thủ về trạng thái ban đầu",
  T_48_META_API_3213_P0_D: "người chơi mục tiêu",
  T_48_META_API_3214_D: "Bật và tắt trò chuyện bằng giọng nói của người chơi",
  T_48_META_API_3214_P0_D: "người chơi mục tiêu",
  T_48_META_API_3214_P1_D: "Có tắt voice chat hay không, Đúng: tắt Sai: bật",
  T_48_META_API_3215_D: "Chuyển đổi người chơi trò chuyện nhanh",
  T_48_META_API_3215_P0_D: "người chơi mục tiêu",
  T_48_META_API_3215_P1_D: "Có đóng trò chuyện nhanh hay không, Đúng: đóng Sai: mở",
  T_48_META_API_3216_D: "Đặt xem người chơi mục tiêu có thể nhặt vật phẩm hay không",
  T_48_META_API_3216_P0_D: "người chơi mục tiêu",
  T_48_META_API_3216_P1_D: "Có cấm nhặt đồ hay không, Đúng: Cấm nhặt đồ, Sai: Có thể nhặt được",
  T_48_META_API_3217_D: "Đặt xem người chơi mục tiêu có thể đánh rơi vật phẩm hay không",
  T_48_META_API_3217_P0_D: "người chơi mục tiêu",
  T_48_META_API_3217_P1_D: "Có cấm đánh rơi đồ hay không, đúng: cấm nhặt, sai: có thể nhặt được",
  T_48_META_API_3218_D: "Phá hủy vũ khí trong ô được chỉ định của người chơi",
  T_48_META_API_3218_P0_D: "người chơi mục tiêu",
  T_48_META_API_3218_P1_D: "Khe vũ khí để tiêu diệt",
  T_48_META_API_3218_P2_D: "số lượng để tiêu diệt",
  T_48_META_API_3218_P3_D: "Cho dù nó có bị tiêu diệt thành công hay không thì nếu không có vũ khí được trang bị trong khe vũ khí thì việc tiêu diệt sẽ thất bại.",
  T_48_META_API_3219_D: "Xóa tất cả vật phẩm khỏi ba lô của người chơi mục tiêu, bao gồm cả vật phẩm được trang bị",
  T_48_META_API_3219_P0_D: "người chơi mục tiêu",
  T_48_META_API_3220_D: "Đặt hướng người chơi",
  T_48_META_API_3220_P0_D: "người chơi mục tiêu",
  T_48_META_API_3220_P1_D: "Hướng người chơi",
  T_48_META_API_3221_D: "(Không được dùng nữa, vui lòng không sử dụng. Để biết thông tin liên quan, hãy xem thuộc tính <Player>:Skeleton)",
  T_48_META_API_3221_P0_D: "thực thể người chơi",
  T_48_META_API_3221_P1_D: "phần thu phóng",
  T_48_META_API_3221_P2_D: "giá trị thu phóng",
  T_48_META_API_3222_D: "Cấp hiệu ứng đẩy lui cho người chơi, người chơi mục tiêu sẽ rơi với tốc độ tăng cố định và hiệu ứng đẩy lui sẽ bị dừng buộc khi xảy ra va chạm trong không khí",
  T_48_META_API_3222_P0_D: "người chơi mục tiêu",
  T_48_META_API_3222_P1_D: "Hướng bay",
  T_48_META_API_3222_P2_D: "Thời gian kích hoạt",
  T_48_META_API_3222_P3_D: "Vận tốc ban đầu của trục Y khi bay",
  T_48_META_API_3222_P4_D: "Vận tốc ban đầu của máy bay Xperia khi bay",
  T_48_META_API_3222_P5_D: "Có thay đổi hướng của người chơi hay không",
  T_48_META_API_3223_D: "Lấy ID quần áo của người chơi hoặc NPC mục tiêu",
  T_48_META_API_3223_P0_D: "Người chơi mục tiêu hoặc NPC",
  T_48_META_API_3223_P1_D: "loại quần áo",
  T_48_META_API_3223_R_D: "ID quần áo",
  T_48_META_API_3224_D: "Đặt ID quần áo của người chơi hoặc NPC mục tiêu",
  T_48_META_API_3224_P0_D: "Người chơi mục tiêu hoặc NPC",
  T_48_META_API_3224_P1_D: "ID quần áo",
  T_48_META_API_3225_D: "Khôi phục trang phục mặc định của người chơi mục tiêu, trang phục này không thể áp dụng cho NPC.",
  T_48_META_API_3225_P0_D: "người chơi mục tiêu",
  T_48_META_API_3226_D: "Thực thể AI tấn công mục tiêu được chỉ định",
  T_48_META_API_3226_P0_D: "Thực thể AI thực hiện cuộc tấn công",
  T_48_META_API_3226_P1_D: "mục tiêu tấn công",
  T_48_META_API_3227_D: "Chuyển vũ khí của người chơi sang vũ khí trong slot được chỉ định",
  T_48_META_API_3227_P0_D: "người chơi mục tiêu",
  T_48_META_API_3227_P1_D: "Khe vũ khí để chuyển đổi",
  T_48_META_API_3227_P2_D: "Việc chuyển đổi có thành công hay không. Nếu không có vũ khí được trang bị trong khe vũ khí, việc chuyển đổi sẽ thất bại.",
  T_48_META_API_3228_D: "Nhận skin vũ khí của người chơi mục tiêu hoặc NPC",
  T_48_META_API_3228_P0_D: "Người chơi mục tiêu hoặc NPC",
  T_48_META_API_3228_P1_D: "ID da vũ khí",
  T_48_META_API_3228_R_D: "ID da vũ khí",
  T_48_META_API_3229_D: "Đặt giao diện vũ khí của người chơi mục tiêu hoặc NPC",
  T_48_META_API_3229_P0_D: "Người chơi mục tiêu hoặc NPC",
  T_48_META_API_3229_P1_D: "ID da vũ khí",
  T_48_META_API_3230_D: "Khôi phục giao diện vũ khí mặc định của người chơi mục tiêu, không thể áp dụng cho NPC.",
  T_48_META_API_3230_P0_D: "người chơi mục tiêu",
  T_48_META_API_3230_P1_D: "ID vũ khí",
  T_48_META_API_3231_D: "Thiết lập trang phục cầu thủ",
  T_48_META_API_3231_P0_D: "người chơi mục tiêu",
  T_48_META_API_3231_P1_D: "Danh sách trang phục",
  T_48_META_API_3232_D: "Loại bỏ tất cả quần áo thuộc loại quần áo được chỉ định khỏi người chơi hoặc NPC mục tiêu",
  T_48_META_API_3232_P0_D: "Người chơi mục tiêu hoặc NPC",
  T_48_META_API_3232_P1_D: "loại quần áo",
  T_48_META_API_3233_D: "Loại bỏ lớp vỏ vũ khí do người chơi hoặc NPC chỉ định",
  T_48_META_API_3233_P0_D: "Người chơi mục tiêu hoặc NPC",
  T_48_META_API_3233_P1_D: "ID vũ khí",
  T_48_META_API_3234_D: "Thêm buff vào mục tiêu",
  T_48_META_API_3234_P0_D: "Thực thể mục tiêu phải là thực thể có thể thêm Buff",
  T_48_META_API_3234_P1_D: "Id hỗ trợ",
  T_48_META_API_3235_D: "Loại bỏ buff khỏi mục tiêu",
  T_48_META_API_3235_P0_D: "Thực thể mục tiêu phải là thực thể có thể thêm Buff",
  T_48_META_API_3235_P1_D: "Id hỗ trợ",
  T_48_META_API_3236_D: "Nhận Buff hiện tại của mục tiêu",
  T_48_META_API_3236_P0_D: "Thực thể mục tiêu phải là thực thể có thể thêm Buff",
  T_48_META_API_3236_R_D: "Danh sách hỗ trợ",
  T_48_META_API_3237_D: "Nhận các vật phẩm trong túi đồ của người chơi mục tiêu",
  T_48_META_API_3237_P0_D: "người chơi mục tiêu",
  T_48_META_API_3237_P1_D: "Danh sách đạo cụ",
  T_48_META_API_3238_D: "Thêm phụ kiện vào vũ khí trong khe được chỉ định. Phụ kiện không khớp với khe sẽ không được thêm vào; phụ kiện trùng lặp sẽ thay thế phụ kiện gốc sẽ được gửi vào ba lô của người chơi. , các phụ kiện ban đầu sẽ được thêm vào vị trí hiện tại của người chơi.",
  T_48_META_API_3238_P0_D: "người chơi mục tiêu",
  T_48_META_API_3238_P1_D: "Khe cắm thiết bị",
  T_48_META_API_3238_P2_D: "Phụ kiện",
  T_48_META_API_3238_P3_D: `Phụ kiện đã được thêm thành công hay chưa
Đúng: Phụ kiện đã được trang bị cho vũ khí trong khe tương ứng
Sai: Phụ kiện không được thêm vào và sẽ không xuất hiện trong ba lô của người chơi`,
  T_48_META_API_3238_P4_D: "Đã thêm phụ kiện, trống nếu thất bại",
  T_48_META_API_3239_D: "Lấy trang bị ở cột trang bị ba lô",
  T_48_META_API_3239_P0_D: "người chơi mục tiêu",
  T_48_META_API_3239_P1_D: "Khe cắm thiết bị",
  T_48_META_API_3239_P2_D: "Thiết bị trong ô được chỉ định Nếu không có thiết bị, nó sẽ trống.",
  T_48_META_API_3239_P3_D: "Tất cả các phụ kiện cho thiết bị này",
  T_48_META_API_3240_D: "Lấy thành phần X của vectơ hai chiều",
  T_48_META_API_3240_P0_D: "vectơ 2D",
  T_48_META_API_3240_R_D: "Thành phần vectơ X hai chiều",
  T_48_META_API_3241_D: "Lấy thành phần Y của vectơ hai chiều",
  T_48_META_API_3241_P0_D: "vectơ 2D",
  T_48_META_API_3241_R_D: "Thành phần Y vector hai chiều",
  T_48_META_API_3242_D: "Bộ vectơ 2D thành phần X",
  T_48_META_API_3242_P0_D: "vectơ 2D",
  T_48_META_API_3242_P1_D: "Thành phần vectơ X hai chiều",
  T_48_META_API_3243_D: "Bộ vectơ 2D thành phần Y",
  T_48_META_API_3243_P0_D: "vectơ 2D",
  T_48_META_API_3243_P1_D: "Thành phần Y vector hai chiều",
  T_48_META_API_3244_D: "Thêm hai vectơ 2D",
  T_48_META_API_3244_P0_D: "Giá trị trái",
  T_48_META_API_3244_P1_D: "Giá trị phải",
  T_48_META_API_3244_R_D: "Kết quả cộng vector hai chiều",
  T_48_META_API_3245_D: "Trừ hai vectơ 2D",
  T_48_META_API_3245_P0_D: "Giá trị trái",
  T_48_META_API_3245_P1_D: "Giá trị phải",
  T_48_META_API_3245_R_D: "Kết quả trừ vector hai chiều",
  T_48_META_API_3246_D: "Nhân vectơ hai chiều",
  T_48_META_API_3246_P0_D: "vectơ 2D",
  T_48_META_API_3246_P1_D: "Giá trị tỷ lệ vectơ 2D",
  T_48_META_API_3246_R_D: "Kết quả nhân vectơ hai chiều",
  T_48_META_API_3247_D: "Tích vô hướng hai vectơ hai chiều Kết quả của tích vô hướng là góc giữa hai vectơ.",
  T_48_META_API_3247_P0_D: "Giá trị trái",
  T_48_META_API_3247_P1_D: "Giá trị phải",
  T_48_META_API_3247_R_D: "Kết quả nhân chấm",
  T_48_META_API_3248_D: "Tính khoảng cách Euclide của hai vectơ 2D",
  T_48_META_API_3248_P0_D: "Giá trị trái",
  T_48_META_API_3248_P1_D: "Giá trị phải",
  T_48_META_API_3248_R_D: "Sau khi trừ hai vectơ, độ dài mô đun của vectơ kết quả",
  T_48_META_API_3249_D: "Tính góc giữa hai vectơ hai chiều",
  T_48_META_API_3249_P0_D: "Giá trị trái",
  T_48_META_API_3249_P1_D: "Giá trị phải",
  T_48_META_API_3249_R_D: "Góc vectơ, phạm vi góc 0-180",
  T_48_META_API_3250_D: "Chuẩn hóa vectơ 2D",
  T_48_META_API_3250_P0_D: "vectơ 2D",
  T_48_META_API_3250_R_D: "Kết quả chuẩn hóa là một vectơ có chiều dài 1 mét cùng hướng.",
  T_48_META_API_3251_D: "Modulo một vectơ hai chiều",
  T_48_META_API_3251_P0_D: "vectơ 2D",
  T_48_META_API_3251_R_D: "Kết quả modulo là độ dài của vectơ",
  T_48_META_API_3252_D: "Tính vectơ của vectơ hai chiều được phản xạ bởi một đường thẳng đứng pháp tuyến",
  T_48_META_API_3252_P0_D: "Vectơ 2D sự cố",
  T_48_META_API_3252_P1_D: "Vectơ 2D bình thường",
  T_48_META_API_3252_R_D: "Vector phản chiếu 2D",
  T_48_META_API_3253_D: "Tính vectơ của vectơ ba chiều được phản xạ bởi một mặt phẳng vuông góc với pháp tuyến",
  T_48_META_API_3253_P0_D: "Vector ba chiều sự cố",
  T_48_META_API_3253_P1_D: "Vectơ 3D bình thường",
  T_48_META_API_3253_R_D: "Vector phản chiếu 3D",
  T_48_META_API_3254_D: "Chuyển đổi vectơ ba chiều thành vectơ hai chiều và xóa thành phần Z của vectơ ba chiều",
  T_48_META_API_3254_P0_D: "Vectơ 3D mục tiêu",
  T_48_META_API_3254_R_D: "Chuyển đổi vectơ hai chiều",
  T_48_META_API_3255_D: "Chuyển đổi vectơ hai chiều thành vectơ ba chiều và đặt thành phần Z của vectơ ba chiều thành 0",
  T_48_META_API_3255_P0_D: "Vectơ mục tiêu 2D",
  T_48_META_API_3255_R_D: "Chuyển đổi vector ba chiều",
  T_48_META_API_3256_D: "Tạo vectơ 2D",
  T_48_META_API_3256_P0_D: "Thành phần X của vectơ hai chiều",
  T_48_META_API_3256_P1_D: "Thành phần Y của vectơ hai chiều",
  T_48_META_API_3256_R_D: "Vector hai chiều được tạo",
  T_48_META_API_3257_D: "Tùy chỉnh nhật ký điểm thi đấu để phân tích dữ liệu trải nghiệm người dùng",
  T_48_META_API_3257_P0_D: "nhật ký",
  T_48_META_API_3258_D: "Tùy chỉnh nhật ký điểm thi đấu để phân tích dữ liệu trải nghiệm người dùng",
  T_48_META_API_3258_P0_D: "Người chơi sẽ được báo cáo",
  T_48_META_API_3258_P1_D: "nhật ký",
  T_48_META_API_33_D: "Bộ lọc từ bẩn",
  T_48_META_API_33_P0_D: "Văn bản gốc cần được lọc từ bẩn",
  T_48_META_API_33_R_D: "văn bản được lọc",
  T_48_META_API_3301_D: "Tạo một thực thể trại",
  T_48_META_API_3301_P0_D: "Thực thể phe phái",
  T_48_META_API_3302_D: "Thực thể mục tiêu tham gia nhóm được chỉ định",
  T_48_META_API_3302_P0_D: "thực thể mục tiêu",
  T_48_META_API_3302_P1_D: "Thực thể phe phái",
  T_48_META_API_3303_D: "Nhận trại có thể tấn công của trại",
  T_48_META_API_3303_P0_D: "trại tấn công",
  T_48_META_API_3303_R_D: "Danh sách thực thể phe phái",
  T_48_META_API_3304_D: "Đặt trại có thể tấn công của trại",
  T_48_META_API_3304_P0_D: "trại tấn công",
  T_48_META_API_3304_P1_D: "trại mục tiêu",
  T_48_META_API_3304_P2_D: "Nó có thể bị tấn công không?",
  T_48_META_API_3305_D: "Thiết lập để tấn công người chơi",
  T_48_META_API_3305_P0_D: "người chơi",
  T_48_META_API_3305_P1_D: "Có thể tấn công người chơi",
  T_48_META_API_3305_P2_D: "Nó có thể bị tấn công không?",
  T_48_META_API_3306_D: "Đặt các đội có thể tấn công của đội",
  T_48_META_API_3306_P0_D: "đội tấn công",
  T_48_META_API_3306_P1_D: "đội mục tiêu",
  T_48_META_API_3306_P2_D: "Nó có thể bị tấn công không?",
  T_48_META_API_3307_D: "Không dùng nữa",
  T_48_META_API_3307_P0_D: "Không dùng nữa",
  T_48_META_API_3307_R_D: "Danh sách thực thể người chơi",
  T_48_META_API_3308_D: "Thực thể được chỉ định thoát khỏi nhóm hiện tại",
  T_48_META_API_3308_P0_D: "thực thể mục tiêu",
  T_48_META_API_3309_D: "Lấy phe của mục tiêu",
  T_48_META_API_3309_P0_D: "thực thể mục tiêu",
  T_48_META_API_3309_R_D: "Thực thể phe phái",
  T_48_META_API_3310_D: "Xác định xem mục tiêu có thể bị tấn công hay không",
  T_48_META_API_3310_P0_D: "kẻ tấn công",
  T_48_META_API_3310_P1_D: "thực thể mục tiêu",
  T_48_META_API_3310_R_D: "Nó có thể bị tấn công không?",
  T_48_META_API_3311_D: "Đặt mục tiêu có thể tấn công cho các thực thể",
  T_48_META_API_3311_P0_D: "kẻ tấn công",
  T_48_META_API_3311_P1_D: "thực thể mục tiêu",
  T_48_META_API_3311_P2_D: "Nó có thể bị tấn công không?",
  T_48_META_API_3312_D: "Lấy các mục tiêu có thể tấn công của một thực thể",
  T_48_META_API_3312_P0_D: "kẻ tấn công",
  T_48_META_API_3312_R_D: "Danh sách các thực thể có thể tấn công",
  T_48_META_API_34_D: "Xác định xem thực thể mục tiêu có các thành phần hay không",
  T_48_META_API_34_P0_D: "thực thể mục tiêu",
  T_48_META_API_34_P1_D: "Loại thành phần",
  T_48_META_API_34_R_D: "Có tồn tại không",
  T_48_META_API_35_D: "Thêm Bot",
  T_48_META_API_35_P0_D: "Mức độ khó của bot",
  T_48_META_API_35_P1_D: "Đội mà Bot thuộc về",
  T_48_META_API_35_P2_D: "Thực thể người chơi Bot đã tạo",
  T_48_META_API_3500_D: "Nhận dữ liệu mã thông báo người chơi",
  T_48_META_API_3500_P0_D: "người chơi mục tiêu",
  T_48_META_API_3500_P1_D: "tokenID",
  T_48_META_API_3500_P2_D: "Số lượng token",
  T_48_META_API_3500_P3_D: "Nó có thành công không?",
  T_48_META_API_3501_D: "Thêm dữ liệu mã thông báo cho người chơi",
  T_48_META_API_3501_P0_D: "người chơi mục tiêu",
  T_48_META_API_3501_P1_D: "tokenID",
  T_48_META_API_3501_P2_D: "Số lượng token",
  T_48_META_API_3501_P3_D: "Liệu nguyên thủy có được gọi thành công hay không",
  T_48_META_API_3502_D: "Tiêu thụ mã thông báo của người chơi mục tiêu",
  T_48_META_API_3502_P0_D: "người chơi mục tiêu",
  T_48_META_API_3502_P1_D: "tokenID",
  T_48_META_API_3502_P2_D: "Số lượng token",
  T_48_META_API_3502_P3_D: "Liệu nguyên thủy có được gọi thành công hay không",
  T_48_META_API_3503_D: "Thêm mã thông báo tại vị trí được chỉ định",
  T_48_META_API_3503_P0_D: "Vị trí",
  T_48_META_API_3503_P1_D: "tokenID",
  T_48_META_API_3503_P2_D: "Số lượng token",
  T_48_META_API_3503_P3_D: "Liệu nguyên thủy có được gọi thành công hay không",
  T_48_META_API_3504_D: "AI mục tiêu phát hành các kỹ năng cụ thể",
  T_48_META_API_3504_P0_D: "AI mục tiêu",
  T_48_META_API_3504_P1_D: "Kỹ năng",
  T_48_META_API_3504_P2_D: "Mục tiêu kỹ năng",
  T_48_META_API_3504_P3_D: "Liệu kỹ năng có được phát hành thành công hay không",
  T_48_META_API_3505_D: "Tạo đường dẫn tìm đường từ điểm bắt đầu đến điểm cuối, đường này sẽ vượt qua chướng ngại vật và có thể được sử dụng để tìm đường AI.",
  T_48_META_API_3505_P0_D: "tọa độ điểm đầu",
  T_48_META_API_3505_P1_D: "Tọa độ điểm cuối",
  T_48_META_API_3505_P2_D: "Liệu đường dẫn tìm đường có được thiết lập thành công hay không",
  T_48_META_API_3505_P3_D: "thu thập điểm tìm đường",
  T_48_META_API_3506_D: "Đặt các biến bảng đen cây hành vi",
  T_48_META_API_3506_P0_D: "cây hành vi mục tiêu",
  T_48_META_API_3506_P1_D: "tên biến",
  T_48_META_API_3506_P2_D: "giá trị biến",
  T_48_META_API_3507_D: "Nhận các biến bảng đen cây hành vi",
  T_48_META_API_3507_P0_D: "cây hành vi mục tiêu",
  T_48_META_API_3507_P1_D: "tên biến",
  T_48_META_API_3507_P2_D: "giá trị biến",
  T_48_META_API_3508_D: "Nhận tham số nút cây hành vi",
  T_48_META_API_3508_P0_D: "nút cây hành vi mục tiêu",
  T_48_META_API_3508_P1_D: "Tên tham số",
  T_48_META_API_3508_P2_D: "Giá trị tham số",
  T_48_META_API_3509_D: "Lấy skin xe của người chơi mục tiêu",
  T_48_META_API_3509_P0_D: "người chơi mục tiêu",
  T_48_META_API_3509_P1_D: "Mã xe",
  T_48_META_API_3509_R_D: "da xe",
  T_48_META_API_3510_D: "Đặt giao diện xe của người chơi mục tiêu",
  T_48_META_API_3510_P0_D: "người chơi mục tiêu",
  T_48_META_API_3510_P1_D: "ID vỏ xe",
  T_48_META_API_3511_D: "Xóa dah máy chở động cần có tên của người chơi đề bảo",
  T_48_META_API_3511_P0_D: "người chơi mục tiêu",
  T_48_META_API_3511_P1_D: "Mã xe",
  T_48_META_API_3512_D: "Khôi phục giao diện xe mặc định của người chơi mục tiêu",
  T_48_META_API_3512_P0_D: "người chơi mục tiêu",
  T_48_META_API_3512_P1_D: "Mã xe",
  T_48_META_API_36_D: "Mục tiêu ngủ, chỉ có thể được sử dụng cho các thân cứng loại Động",
  T_48_META_API_36_P0_D: "mục tiêu cơ thể cứng nhắc",
  T_48_META_API_37_D: "Đánh thức mục tiêu, chỉ có thể sử dụng cho thân cứng loại Động",
  T_48_META_API_37_P0_D: "mục tiêu cơ thể cứng nhắc",
  T_48_META_API_38_D: "Kiểm tra xem cơ thể cứng nhắc mục tiêu có đang ngủ không",
  T_48_META_API_38_P0_D: "mục tiêu cơ thể cứng nhắc",
  T_48_META_API_38_R_D: "Nó đang ngủ à",
  T_48_META_API_39_D: "Đặt ngưỡng ngủ",
  T_48_META_API_39_P0_D: "mục tiêu cơ thể cứng nhắc",
  T_48_META_API_39_P1_D: "Ngưỡng giáng đoạn, khi chuyển động và xoay của vật thể cứng đi dưới giá trị này trong một khoảng thời gian, vật thể sẽ vào trạng thái ngủ. Trong trạng thái ngủ, vật thể cứng không còn được tính toán vật lý.",
  T_48_META_API_4_D: "Đặt xem tất cả người chơi có thể di chuyển hay không",
  T_48_META_API_4_P0_D: `Đúng: có thể di chuyển được
Sai: không thể di chuyển được`,
  T_48_META_API_40_D: "Nhận ngưỡng ngủ",
  T_48_META_API_40_P0_D: "mục tiêu cơ thể cứng nhắc",
  T_48_META_API_40_R_D: "Ngưỡng giáng đoạn, khi chuyển động và xoay của vật thể cứng đi dưới giá trị này trong một khoảng thời gian, vật thể sẽ vào trạng thái ngủ. Trong trạng thái ngủ, vật thể cứng không còn được tính toán vật lý.",
  T_48_META_API_4000_D: "Đọc nội dung của toàn bộ bảng và trả về mảng hai chiều theo thứ tự hàng.",
  T_48_META_API_4000_P0_D: "tên bảng",
  T_48_META_API_4000_R_D: "nội dung bảng",
  T_48_META_API_4001_D: "Đọc nội dung một hàng của bảng và trả về một mảng",
  T_48_META_API_4001_P0_D: "tên bảng",
  T_48_META_API_4001_P1_D: "Số hàng cần đọc, bắt đầu từ 1",
  T_48_META_API_4001_R_D: "Bảng chỉ định nội dung của một hàng",
  T_48_META_API_4002_D: "Đọc nội dung một cột của bảng và trả về một mảng",
  T_48_META_API_4002_P0_D: "tên bảng",
  T_48_META_API_4002_P1_D: "Số cột cần đọc, bắt đầu từ 1",
  T_48_META_API_4002_R_D: "Bảng xác định nội dung của một cột",
  T_48_META_API_4003_D: "Đọc nội dung của một ô trong bảng",
  T_48_META_API_4003_P0_D: "tên bảng",
  T_48_META_API_4003_P1_D: "Số hàng cần đọc, bắt đầu từ 1",
  T_48_META_API_4003_P2_D: "Số cột cần đọc, bắt đầu từ 1",
  T_48_META_API_4003_R_D: "Nội dung của ô được chỉ định trong bảng",
  T_48_META_API_4004_D: "Đọc nội dung của một ô nhất định trong bảng theo số hàng và tên cột",
  T_48_META_API_4004_P0_D: "tên bảng",
  T_48_META_API_4004_P1_D: "Số hàng cần đọc, bắt đầu từ 1",
  T_48_META_API_4004_P2_D: "Tên cột để đọc",
  T_48_META_API_4004_R_D: "Nội dung của ô được chỉ định trong bảng",
  T_48_META_API_4005_D: "Đọc nội dung của toàn bộ bảng và trả về mảng hai chiều",
  T_48_META_API_4005_P0_D: "tên bảng",
  T_48_META_API_4005_R_D: "Nội dung của bảng, mảng hai chiều",
  T_48_META_API_4006_D: "Đọc nội dung của một hàng nhất định trong toàn bộ bảng và trả về một mảng",
  T_48_META_API_4006_P0_D: "tên bảng",
  T_48_META_API_4006_P1_D: "Số hàng cần đọc, bắt đầu từ 1",
  T_48_META_API_4006_R_D: "Bảng xác định nội dung của một hàng, một mảng",
  T_48_META_API_4007_D: "Đọc nội dung một cột của toàn bộ bảng và trả về một mảng",
  T_48_META_API_4007_P0_D: "tên bảng",
  T_48_META_API_4007_P1_D: "Số cột cần đọc, bắt đầu từ 1",
  T_48_META_API_4007_R_D: "Bảng xác định nội dung của một cột, một mảng",
  T_48_META_API_4008_D: "Đọc nội dung của một ô trong bảng",
  T_48_META_API_4008_P0_D: "tên bảng",
  T_48_META_API_4008_P1_D: "Số hàng cần đọc, bắt đầu từ 1",
  T_48_META_API_4008_P2_D: "Số cột cần đọc, bắt đầu từ 1",
  T_48_META_API_4008_R_D: "Nội dung của ô được chỉ định trong bảng",
  T_48_META_API_4009_D: "Tìm hàng được chỉ định theo số cột và giá trị ô",
  T_48_META_API_4009_P0_D: "tên bảng",
  T_48_META_API_4009_P1_D: "Số cột cần đọc",
  T_48_META_API_4009_P2_D: "Giá trị ô cần tìm",
  T_48_META_API_4009_R_D: "Nội dung của hàng, mảng tìm được",
  T_48_META_API_4010_D: "Lấy số cột theo tên cột",
  T_48_META_API_4010_P0_D: "tên bảng",
  T_48_META_API_4010_P1_D: "Tên cột để kiểm tra số serial",
  T_48_META_API_4010_R_D: "Số cột, tính từ 1",
  T_48_META_API_41_D: "Đặt ngưỡng ngủ chung, ngưỡng này chỉ hợp lệ cho các thân cứng kiểu Động mới được tạo.",
  T_48_META_API_41_P0_D: "Ngưỡng giáng đoạn, khi chuyển động và xoay của vật thể cứng đi dưới giá trị này trong một khoảng thời gian, vật thể sẽ vào trạng thái ngủ. Trong trạng thái ngủ, vật thể cứng không còn được tính toán vật lý.",
  T_48_META_API_42_D: "Nhận ngưỡng giấc ngủ toàn cầu",
  T_48_META_API_42_R_D: "Ngưỡng ngủ, mặc định là 0,005. Cơ thể cứng nhắc sẽ chuyển sang trạng thái ngủ sau khi chuyển động và xoay nhỏ hơn giá trị này trong một khoảng thời gian.",
  T_48_META_API_43_D: "Chuyển đổi quaternion đã cho thành các góc Euler. Thứ tự xoay của các góc Euler là YXZ. Nếu truyền quaternion là không hợp lệ, hãy trả về (0,0,0).",
  T_48_META_API_43_P0_D: "Đầu vào quaternion",
  T_48_META_API_43_R_D: "Góc Euler trả về",
  T_48_META_API_44_D: "Chuyển đổi các góc Euler đã cho thành quaternions",
  T_48_META_API_44_P0_D: "Nhập góc Euler",
  T_48_META_API_44_R_D: "Đệ tứ trở lại",
  T_48_META_API_45_D: "Chuyển đổi phép quay được biểu thị bằng góc trục thành quaternion",
  T_48_META_API_45_P0_D: "trục quay",
  T_48_META_API_45_P1_D: "Góc quay theo chiều kim đồng hồ quanh trục quay",
  T_48_META_API_45_R_D: "Đệ tứ trở lại",
  T_48_META_API_46_D: "Chuyển đổi quaternion sang biểu diễn góc trục",
  T_48_META_API_46_P0_D: "Đầu vào quaternion",
  T_48_META_API_46_P1_D: "trục quay",
  T_48_META_API_46_P2_D: "Góc quay theo chiều kim đồng hồ quanh trục quay",
  T_48_META_API_47_D: "Đặt tiến độ hoàn thành nhiệm vụ tùy chỉnh",
  T_48_META_API_47_P0_D: "người chơi mục tiêu",
  T_48_META_API_47_P1_D: "ID nhiệm vụ",
  T_48_META_API_47_P2_D: "Tiến độ hoàn thành, không được phép số âm",
  T_48_META_API_48_D: "Tạo đường cong Bezier có thể được sử dụng để nội suy chuyển động",
  T_48_META_API_48_P0_D: "điểm kiểm soát đường cong",
  T_48_META_API_48_R_D: "Đường cong Bezier",
  T_48_META_API_49_D: "Nhận ID bản đồ cảnh",
  T_48_META_API_49_P0_D: "ID cảnh",
  T_48_META_API_49_R_D: "Mã bản đồ",
  T_48_META_API_5_D: "Xóa các đối tượng đã đặt trong cảnh (lỗi thời, vui lòng sử dụng DeleteEntity)",
  T_48_META_API_5_P0_D: "Thực thể đối tượng cần xóa",
  T_48_META_API_50_D: "Tạo một chuyển động tương đối với chính nó trong mỗi khung hình. Thực thể đích thay đổi các thuộc tính của chính nó một lần trong mỗi khung hình và mỗi lần nó thay đổi so với giá trị thuộc tính hiện tại của nó.",
  T_48_META_API_50_P0_D: "thực thể mục tiêu",
  T_48_META_API_50_P1_D: "Thuộc tính yêu cầu thay đổi chuyển động",
  T_48_META_API_50_P2_D: "lượng thay đổi trên mỗi chuyển động",
  T_48_META_API_50_P3_D: `Cấu hình khi được sử dụng kết hợp với các chế độ chuyển động khác
Đúng: Có thể được sử dụng kết hợp với chuyển động tương đối
Sai: Có thể được sử dụng kết hợp với chuyển động tuyệt đối`,
  T_48_META_API_50_P4_D: "Thực thể chuyển động được tạo so với chính nó trên mỗi khung hình",
  T_48_META_API_50_P5_D: "Có tự động bắt đầu phát sau khi tạo hay không",
  T_48_META_API_5000_D: "Đọc giá trị tương ứng với Key trong bảng trong cơ sở dữ liệu",
  T_48_META_API_5000_P0_D: "tên bảng trong cơ sở dữ liệu",
  T_48_META_API_5000_P1_D: "Đánh dấu người chơi và xử lý các tình huống đồng thời",
  T_48_META_API_5000_P2_D: "Tên tùy chỉnh được sử dụng để xác định dữ liệu",
  T_48_META_API_5000_P3_D: "Trả về kết quả đã đọc",
  T_48_META_API_5000_P4_D: "Mã chiến trường tương ứng với cơ sở dữ liệu",
  T_48_META_API_5001_D: "Viết giá trị tương ứng với Key vào một bảng trong cơ sở dữ liệu",
  T_48_META_API_5001_P0_D: "tên bảng trong cơ sở dữ liệu",
  T_48_META_API_5001_P1_D: "Đánh dấu người chơi và xử lý các tình huống đồng thời",
  T_48_META_API_5001_P2_D: "Tên tùy chỉnh được sử dụng để xác định dữ liệu",
  T_48_META_API_5001_P3_D: "giá trị được viết",
  T_48_META_API_5001_P4_D: "Mã chiến trường tương ứng với cơ sở dữ liệu, có thể điền vào chỗ trống, biểu thị mã chiến trường của bản đồ hiện tại",
  T_48_META_API_5002_D: "Xóa giá trị tương ứng với một Key nhất định trong một bảng nhất định trong cơ sở dữ liệu",
  T_48_META_API_5002_P0_D: "tên bảng trong cơ sở dữ liệu",
  T_48_META_API_5002_P1_D: "Đánh dấu người chơi và xử lý các tình huống đồng thời",
  T_48_META_API_5002_P2_D: "Tên tùy chỉnh được sử dụng để xác định dữ liệu",
  T_48_META_API_5002_P3_D: "Mã chiến trường tương ứng với cơ sở dữ liệu",
  T_48_META_API_5003_D: "Đọc giá trị tương ứng với một Key trong bảng xếp hạng trong cơ sở dữ liệu",
  T_48_META_API_5003_P0_D: "Tên bảng xếp hạng trong cơ sở dữ liệu",
  T_48_META_API_5003_P1_D: "Tên tùy chỉnh được sử dụng để xác định dữ liệu",
  T_48_META_API_5003_P2_D: "Trả về kết quả đã đọc",
  T_48_META_API_5003_P3_D: "Mã chiến trường tương ứng với cơ sở dữ liệu",
  T_48_META_API_5004_D: "Viết giá trị tương ứng với Key vào bảng xếp hạng trong cơ sở dữ liệu",
  T_48_META_API_5004_P0_D: "Tên bảng xếp hạng trong cơ sở dữ liệu",
  T_48_META_API_5004_P1_D: "Tên tùy chỉnh được sử dụng để xác định dữ liệu",
  T_48_META_API_5004_P2_D: "giá trị được viết",
  T_48_META_API_5004_P3_D: "Mã chiến trường tương ứng với cơ sở dữ liệu",
  T_48_META_API_5005_D: "Xóa giá trị tương ứng với Key trong bảng xếp hạng trong cơ sở dữ liệu",
  T_48_META_API_5005_P0_D: "tên bảng trong cơ sở dữ liệu",
  T_48_META_API_5005_P1_D: "Tên tùy chỉnh được sử dụng để xác định dữ liệu",
  T_48_META_API_5005_P2_D: "Mã chiến trường tương ứng với cơ sở dữ liệu",
  T_48_META_API_5006_D: "Xóa giá trị tương ứng với thứ hạng nhất định trong bảng xếp hạng trong cơ sở dữ liệu",
  T_48_META_API_5006_P0_D: "tên bảng trong cơ sở dữ liệu",
  T_48_META_API_5006_P1_D: "Vị trí trên bảng xếp hạng",
  T_48_META_API_5006_P2_D: "Mã chiến trường tương ứng với cơ sở dữ liệu",
  T_48_META_API_5007_D: "Đọc các giá trị từ thứ hạng nhất định đến thứ hạng nhất định trong bảng xếp hạng trong cơ sở dữ liệu",
  T_48_META_API_5007_P0_D: "tên bảng trong cơ sở dữ liệu",
  T_48_META_API_5007_P1_D: "Xếp hạng bắt đầu",
  T_48_META_API_5007_P2_D: "xếp hạng cuối cùng",
  T_48_META_API_5007_P3_D: "Trả về kết quả đã đọc",
  T_48_META_API_5007_P4_D: "Mã chiến trường tương ứng với cơ sở dữ liệu",
  T_48_META_API_5008_D: "Đọc giá trị tương ứng với Khóa trong bảng trong cơ sở dữ liệu tích lũy",
  T_48_META_API_5008_P0_D: "tên bảng trong cơ sở dữ liệu",
  T_48_META_API_5008_P1_D: "Tên tùy chỉnh được sử dụng để xác định dữ liệu",
  T_48_META_API_5008_P2_D: "Trả về kết quả đã đọc",
  T_48_META_API_5008_P3_D: "Mã chiến trường tương ứng với cơ sở dữ liệu",
  T_48_META_API_5009_D: "Viết giá trị offset tương ứng với một khóa trong bảng trong cơ sở dữ liệu tích lũy",
  T_48_META_API_5009_P0_D: "tên bảng trong cơ sở dữ liệu",
  T_48_META_API_5009_P1_D: "Tên tùy chỉnh được sử dụng để xác định dữ liệu",
  T_48_META_API_5009_P2_D: "Bốn loại phép toán số học hiện hỗ trợ các loại sau: Kiểu Int hỗ trợ cộng, trừ, nhân, chia và số dư; Kiểu Float hỗ trợ cộng, trừ, nhân và chia;",
  T_48_META_API_5009_P3_D: "Giá trị bù đắp được viết",
  T_48_META_API_5009_P4_D: "Mã chiến trường tương ứng với cơ sở dữ liệu",
  T_48_META_API_51_D: "Đặt lại thực thể có thể chơi được và khôi phục thực thể có thể chơi được về dạng ban đầu mà không thay đổi trạng thái phát lại.",
  T_48_META_API_51_P0_D: "nhắm mục tiêu thực thể có thể chơi được",
  T_48_META_API_52_D: "Nhân hai bậc bốn A*B có nghĩa là xoay A trước rồi xoay B. Thứ tự xoay khác nhau sẽ dẫn đến kết quả khác nhau.",
  T_48_META_API_52_P0_D: "giá trị bậc bốn",
  T_48_META_API_52_P1_D: "giá trị bậc bốn",
  T_48_META_API_52_R_D: "Kết quả bậc bốn",
  T_48_META_API_53_D: "Tạo một quaternion quay hướng về hướng đã chỉ định",
  T_48_META_API_53_P0_D: "Chỉ định hướng",
  T_48_META_API_53_P1_D: "hướng đi lên",
  T_48_META_API_53_R_D: "Số vòng quay cần thiết để căn chỉnh theo hướng đã chỉ định",
  T_48_META_API_54_D: "Nội suy hình cầu Quaternion từ A đến B",
  T_48_META_API_54_P0_D: "Giá trị A",
  T_48_META_API_54_P1_D: "Giá trị B",
  T_48_META_API_54_P2_D: "Tiến trình nội suy, phạm vi giá trị [0,1], khi giá trị bằng 0 thì trả về giá trị bắt đầu, khi giá trị bằng 1 thì trả về giá trị đích",
  T_48_META_API_54_R_D: "Kết quả bậc bốn",
  T_48_META_API_57_D: "In dữ liệu mục tiêu ra bàn điều khiển dưới dạng cảnh báo",
  T_48_META_API_57_P0_D: "Những gì cần in",
  T_48_META_API_58_D: "In dữ liệu đích ra bàn điều khiển ở dạng lỗi",
  T_48_META_API_58_P0_D: "Những gì cần in",
  T_48_META_API_59_D: "Lấy giá trị trên đường cong",
  T_48_META_API_59_P0_D: "đường cong",
  T_48_META_API_59_P1_D: "Điểm lấy mẫu, phạm vi giá trị [0,1]",
  T_48_META_API_59_R_D: "kết quả",
  T_48_META_API_6_D: "Tạo các đối tượng cảnh theo tọa độ được chỉ định",
  T_48_META_API_6_P0_D: "Đã tạo thực thể đối tượng cảnh",
  T_48_META_API_6_P1_D: "Vị trí nơi đối tượng được tạo ra",
  T_48_META_API_6_P2_D: "Khi sử dụng ID loại đối tượng đã tạo trong tập lệnh mã, bạn cần đăng ký trước bảng liệt kê đối tượng cấp độ trong đăng ký tài sản.",
  T_48_META_API_60_D: "Nội suy từ đường cong",
  T_48_META_API_60_P0_D: "loại giá trị",
  T_48_META_API_60_P1_D: "giá trị bắt đầu",
  T_48_META_API_60_P2_D: "giá trị mục tiêu",
  T_48_META_API_60_P3_D: "đường cong",
  T_48_META_API_60_P4_D: "Điểm lấy mẫu, phạm vi giá trị [0,1]",
  T_48_META_API_60_R_D: "kết quả",
  T_48_META_API_6000_D: "Thêm tập lệnh cho thực thể mục tiêu",
  T_48_META_API_6000_P0_D: "thực thể mục tiêu",
  T_48_META_API_6000_P1_D: "ID tập lệnh",
  T_48_META_API_6001_D: "Gỡ cài đặt tập lệnh cho thực thể đích",
  T_48_META_API_6001_P0_D: "thực thể mục tiêu",
  T_48_META_API_6001_P1_D: "ID tập lệnh",
  T_48_META_API_6002_D: "Kiểm tra xem tập lệnh đã chỉ định có tồn tại trong thực thể đích không",
  T_48_META_API_6002_P0_D: "thực thể mục tiêu",
  T_48_META_API_6002_P1_D: "ID tập lệnh",
  T_48_META_API_6002_R_D: "Tập lệnh được chỉ định có tồn tại hay không",
  T_48_META_API_61_D: "Đặt nút cha của điều khiển giao diện người dùng",
  T_48_META_API_61_P0_D: "Nút cha, bạn có thể chỉ định điều khiển giao diện người dùng hoặc giao diện người dùng tùy chỉnh",
  T_48_META_API_61_P1_D: "nút con",
  T_48_META_API_62_D: "Không dùng nữa",
  T_48_META_API_62_P0_D: "Không dùng nữa",
  T_48_META_API_62_P1_D: "Không dùng nữa",
  T_48_META_API_62_P2_D: "Không dùng nữa",
  T_48_META_API_62_P3_D: "Không dùng nữa",
  T_48_META_API_62_P4_D: "Không dùng nữa",
  T_48_META_API_63_D: "Tạo tia từ camera hiện tại đến điểm chạm màn hình",
  T_48_META_API_63_P0_D: "điểm chạm màn hình",
  T_48_META_API_63_P1_D: "điểm bắt đầu",
  T_48_META_API_63_P2_D: "hướng tia",
  T_48_META_API_64_D: "Tải lên thông tin thanh toán tùy chỉnh",
  T_48_META_API_64_P0_D: "thực thể người chơi",
  T_48_META_API_64_P1_D: "kết quả trận đấu",
  T_48_META_API_64_P2_D: "Tiêu đề điểm",
  T_48_META_API_64_P3_D: "Giá trị điểm",
  T_48_META_API_65_D: "Phát hiệu ứng âm thanh được chỉ định. Nếu có nhiều thuộc tính cần được đặt, bạn có thể đặt thuộc tính thực thể của nó.",
  T_48_META_API_65_P0_D: "Đã tạo thực thể hiệu ứng âm thanh",
  T_48_META_API_65_P1_D: "Người chơi mục tiêu, chỉ người chơi mục tiêu mới có thể nghe thấy hiệu ứng âm thanh",
  T_48_META_API_65_P2_D: "Loại hiệu ứng âm thanh",
  T_48_META_API_65_P3_D: "Loại vòng lặp",
  T_48_META_API_65_P4_D: "Có nên chơi ngay không",
  T_48_META_API_66_D: "Tạo hiệu ứng hình ảnh được chỉ định. Nếu có nhiều thuộc tính cần được đặt, bạn có thể đặt thuộc tính thực thể của nó.",
  T_48_META_API_66_P0_D: "Đã tạo thực thể hiệu ứng đặc biệt",
  T_48_META_API_66_P1_D: "Người chơi mục tiêu, chỉ hiển thị người chơi mục tiêu",
  T_48_META_API_66_P2_D: "Loại hiệu ứng đặc biệt",
  T_48_META_API_66_P3_D: "Loại vòng lặp",
  T_48_META_API_66_P4_D: "Có nên chơi ngay không",
  T_48_META_API_67_D: "Tạo hiệu ứng âm thanh được chỉ định. Nếu có nhiều thuộc tính cần được đặt, bạn có thể đặt thuộc tính thực thể của nó.",
  T_48_META_API_67_P0_D: "Đã tạo thực thể hiệu ứng âm thanh",
  T_48_META_API_67_P1_D: "Loại hiệu ứng âm thanh",
  T_48_META_API_67_P2_D: "Loại vòng lặp",
  T_48_META_API_67_P3_D: "Có nên chơi ngay không",
  T_48_META_API_68_D: "Chuyển đổi tọa độ thế giới sang tọa độ màn hình",
  T_48_META_API_68_P0_D: "tọa độ thế giới",
  T_48_META_API_68_P1_D: "Có nên lập bản đồ trên màn hình hay không",
  T_48_META_API_68_P2_D: "Bản đồ vị trí",
  T_48_META_API_69_D: "Chuyển đổi tọa độ màn hình sang tọa độ thế giới",
  T_48_META_API_69_P0_D: "màn hình tọa độ",
  T_48_META_API_69_P1_D: "Khoảng cách từ màn hình",
  T_48_META_API_69_P2_D: "tọa độ thế giới",
  T_48_META_API_7_D: "Chuyển đổi giá trị mục tiêu thành chuỗi",
  T_48_META_API_7_P0_D: "Giá trị mục tiêu được chuyển đổi thành một chuỗi",
  T_48_META_API_7_R_D: "sợi dây",
  T_48_META_API_70_D: "Thực hiện phát hiện tia thông qua thao tác chạm vào màn hình và trả về thực thể được đánh đầu tiên",
  T_48_META_API_70_P0_D: "Màn hình chính cảm ứng",
  T_48_META_API_70_P1_D: "Khoảng cách phát hiện",
  T_48_META_API_70_P2_D: "Mặt nạ lớp, chỉ những lớp đã điền mới tham gia quét, để trống nghĩa là tất cả các lớp sẽ tham gia quét",
  T_48_META_API_70_P3_D: "Có thể phát hiện các tác nhân",
  T_48_META_API_70_P4_D: "thực thể đánh",
  T_48_META_API_70_P5_D: "tọa độ điểm nhấn",
  T_48_META_API_70_P6_D: "Khoảng cách từ điểm đánh đến điểm bắt đầu",
  T_48_META_API_70_P7_D: "Đánh bề mặt bình thường",
  T_48_META_API_71_D: "Phát hiện tia thông qua chạm vào màn hình, trả về tất cả các thực thể trúng đích",
  T_48_META_API_71_P0_D: "Màn hình chính cảm ứng",
  T_48_META_API_71_P1_D: "Khoảng cách phát hiện",
  T_48_META_API_71_P2_D: "Mặt nạ lớp, chỉ những lớp đã điền mới tham gia quét, để trống nghĩa là tất cả các lớp sẽ tham gia quét",
  T_48_META_API_71_P3_D: "Có thể phát hiện các tác nhân",
  T_48_META_API_71_P4_D: "danh sách các thực thể truy cập",
  T_48_META_API_71_P5_D: "Danh sách tọa độ điểm nhấn",
  T_48_META_API_71_P6_D: "Danh sách khoảng cách giữa điểm nhấn và điểm xuất phát",
  T_48_META_API_71_P7_D: "Đánh vào danh sách bề mặt bình thường",
  T_48_META_API_72_D: "Tạo hiệu ứng hình ảnh được chỉ định. Nếu có nhiều thuộc tính cần được đặt, bạn có thể đặt thuộc tính thực thể của nó.",
  T_48_META_API_72_P0_D: "Đã tạo thực thể hiệu ứng đặc biệt",
  T_48_META_API_72_P1_D: "Loại hiệu ứng đặc biệt",
  T_48_META_API_72_P2_D: "Loại vòng lặp",
  T_48_META_API_72_P3_D: "Có nên chơi ngay không",
  T_48_META_API_73_D: "Tạo giao diện người dùng tích hợp không được đồng bộ hóa với các ứng dụng khách khác",
  T_48_META_API_73_P0_D: "Đã tạo các thực thể UI tích hợp",
  T_48_META_API_73_P1_D: "Các loại giao diện người dùng tích hợp",
  T_48_META_API_74_D: "Tạo giao diện người dùng tùy chỉnh sẽ không được đồng bộ hóa với các ứng dụng khách khác",
  T_48_META_API_74_P0_D: "Đã tạo các thực thể giao diện người dùng tùy chỉnh",
  T_48_META_API_74_P1_D: "Chỉ mục giao diện người dùng tùy chỉnh",
  T_48_META_API_75_D: "Nhận trình phát tương ứng với khách hàng hiện tại",
  T_48_META_API_75_R_D: "thực thể người chơi",
  T_48_META_API_76_D: "Tạo quái vật AI",
  T_48_META_API_76_P0_D: "AI mục tiêu",
  T_48_META_API_76_P1_D: "Tạo vị trí",
  T_48_META_API_76_P2_D: "loại AI",
  T_48_META_API_76_P3_D: "Đội",
  T_48_META_API_76_P4_D: "Có tự động tìm kiếm kẻ thù hay không",
  T_48_META_API_76_P5_D: "chế độ tấn công",
  T_48_META_API_76_P6_D: "con đường du lịch",
  T_48_META_API_77_D: "Đặt thành phần đầu tiên của vectơ",
  T_48_META_API_77_P0_D: "vectơ",
  T_48_META_API_77_P1_D: "giá trị thành phần đầu tiên",
  T_48_META_API_77_R_D: "Vector sau khi sửa đổi thành phần đầu tiên",
  T_48_META_API_78_D: "Đặt thành phần thứ hai của vectơ",
  T_48_META_API_78_P0_D: "vectơ",
  T_48_META_API_78_P1_D: "giá trị thành phần thứ hai",
  T_48_META_API_78_R_D: "Vector sau khi sửa đổi thành phần thứ hai",
  T_48_META_API_79_D: "Đặt thành phần thứ ba của vectơ",
  T_48_META_API_79_P0_D: "vectơ",
  T_48_META_API_79_P1_D: "Giá trị thành phần thứ ba",
  T_48_META_API_79_R_D: "Vector sau khi sửa đổi thành phần thứ ba",
  T_48_META_API_8_D: "Bật vùng an toàn sẽ co lại về điểm tọa độ trung tâm",
  T_48_META_API_8_P0_D: "điểm trung tâm của vùng an toàn",
  T_48_META_API_8_P1_D: "bán kính vùng an toàn",
  T_48_META_API_8_P2_D: "Thời gian chờ, tính bằng giây, sau đó vùng an toàn sẽ bắt đầu co lại về phía điểm trung tâm",
  T_48_META_API_8_P3_D: "Thời gian cần thiết để vùng an toàn co lại về điểm trung tâm, tính bằng giây",
  T_48_META_API_8_P4_D: "Lượng sát thương nhận được mỗi giây ngoài vùng an toàn",
  T_48_META_API_80_D: "Đặt thành phần đầu tiên của vectơ hai chiều",
  T_48_META_API_80_P0_D: "vectơ 2D",
  T_48_META_API_80_P1_D: "giá trị thành phần đầu tiên",
  T_48_META_API_80_R_D: "Vector hai chiều sau khi sửa đổi thành phần đầu tiên",
  T_48_META_API_81_D: "Đặt thành phần thứ hai của vectơ 2D",
  T_48_META_API_81_P0_D: "vectơ 2D",
  T_48_META_API_81_P1_D: "giá trị thành phần thứ hai",
  T_48_META_API_81_R_D: "Vector hai chiều sau khi sửa đổi thành phần thứ hai",
  T_48_META_API_82_D: "Di chuyển bộ điều khiển nhân vật đến vị trí đã chỉ định. Nếu nó ảnh hưởng đến người chơi, người chơi phải bật bộ điều khiển nhân vật sử dụng hiệu ứng vật lý để có hiệu lực.",
  T_48_META_API_82_P0_D: "bộ điều khiển ký tự mục tiêu",
  T_48_META_API_82_P1_D: "Chỉ định vị trí",
  T_48_META_API_83_D: "Lấy nút con được chỉ định của thực thể nút cha đích dựa trên tên của nó",
  T_48_META_API_83_P0_D: "thực thể nút cha",
  T_48_META_API_83_P1_D: "Tên nút con",
  T_48_META_API_83_R_D: "thực thể nút con",
  T_48_META_API_84_D: "Thêm AOI đặc biệt chú ý, luôn đồng bộ bất kể khoảng cách",
  T_48_META_API_84_P0_D: "Các mục tiêu đặc biệt quan tâm",
  T_48_META_API_84_P1_D: "người quan sát",
  T_48_META_API_85_D: "Loại bỏ sự chú ý đặc biệt của AOI và hủy bỏ đồng bộ hóa AOI ngoài tầm nhìn",
  T_48_META_API_85_P0_D: "Các mục tiêu đặc biệt quan tâm",
  T_48_META_API_85_P1_D: "người quan sát",
  T_48_META_API_86_D: "Xóa tất cả AOI của mục tiêu được chỉ định. Đặc biệt chú ý.",
  T_48_META_API_86_P0_D: "Các mục tiêu đặc biệt quan tâm",
  T_48_META_API_87_D: "Xác định xem có mối quan ngại đặc biệt về AOI hay không",
  T_48_META_API_87_P0_D: "Các mục tiêu đặc biệt quan tâm",
  T_48_META_API_87_P1_D: "Không dùng nữa",
  T_48_META_API_87_R_D: "Có tồn tại không",
  T_48_META_API_88_D: "Chuyển đổi trình quan sát proxy của người chơi",
  T_48_META_API_88_P0_D: "người chơi",
  T_48_META_API_88_P1_D: "người quan sát proxy",
  T_48_META_API_89_D: "Di chuyển bộ điều khiển nhân vật một lần. Nếu nó ảnh hưởng đến người chơi, người chơi phải bật bộ điều khiển người chơi sử dụng hiệu ứng vật lý để có hiệu lực.",
  T_48_META_API_89_P0_D: "Đối tượng mục tiêu, nếu là người chơi, người chơi phải bật bộ điều khiển người chơi bằng vật lý để hiệu ứng có hiệu lực",
  T_48_META_API_89_P1_D: "vectơ dịch chuyển",
  T_48_META_API_9_D: "Tắt cơ chế vùng an toàn Khi vùng an toàn bị giảm xuống mức tối thiểu, người chơi ở ngoài vùng an toàn sẽ tiếp tục bị tổn hại. Sau khi tắt cơ chế vùng an toàn, người chơi sẽ được an toàn trở lại.",
  T_48_META_API_90_D: "Đặt xem người chơi có thể thoát tự do hay không",
  T_48_META_API_90_P0_D: "người chơi mục tiêu",
  T_48_META_API_90_P1_D: "Có thể thoát ra tự do được không?",
  T_48_META_API_9000_D: "Tạo giao diện người dùng tích hợp mà chỉ những người chơi được chỉ định mới có thể nhìn thấy",
  T_48_META_API_9000_P0_D: "Đã tạo các thực thể UI tích hợp",
  T_48_META_API_9000_P1_D: "Thực thể người chơi chứa giao diện người dùng, chỉ hiển thị với người chơi này",
  T_48_META_API_9000_P2_D: "Các loại giao diện người dùng tích hợp",
  T_48_META_API_9001_D: "Xóa giao diện người dùng trò chơi tích hợp",
  T_48_META_API_9001_P0_D: "Thực thể UI tích hợp để xóa",
  T_48_META_API_9002_D: "Tạo một biểu tượng bằng cách sử dụng loại biểu tượng đã chỉ định. Nếu có nhiều thuộc tính cần được đặt, hãy đặt thêm các thuộc tính thực thể của nó thông qua thực thể (lỗi thời, vui lòng sử dụng CreateLevelObject)",
  T_48_META_API_9002_P0_D: "Mã được sử dụng để biểu thị tên của tham số chính thức tạo thực thể biểu tượng và giá trị biến cục bộ tương ứng của nó là thực thể tạo biểu tượng.",
  T_48_META_API_9002_P1_D: "Thực thể người chơi mà nó thuộc về, chỉ hiển thị với người chơi này",
  T_48_META_API_9002_P2_D: "Đường dẫn tài nguyên, đường dẫn tài nguyên tương ứng với biểu tượng được người chơi lựa chọn",
  T_48_META_API_9003_D: "Xóa biểu tượng đã chỉ định (không được dùng nữa, vui lòng sử dụng DeleteEntity)",
  T_48_META_API_9003_P0_D: "Thực thể biểu tượng cần xóa",
  T_48_META_API_9004_D: "Tạo một văn bản bằng cách sử dụng nội dung văn bản đã chỉ định. Nếu có nhiều thuộc tính cần được đặt, hãy đặt thêm các thuộc tính thực thể của nó thông qua thực thể (lỗi thời, vui lòng sử dụng CreateLevelObject)",
  T_48_META_API_9004_P0_D: "Mã được sử dụng để thể hiện tên của tham số chính thức tạo ra thực thể văn bản và giá trị biến cục bộ tương ứng của nó là thực thể tạo ra văn bản.",
  T_48_META_API_9004_P1_D: "Thực thể người chơi mà nó thuộc về, chỉ hiển thị với người chơi này",
  T_48_META_API_9004_P2_D: "Nội dung văn bản cần hiển thị",
  T_48_META_API_9005_D: "Xóa văn bản đã chỉ định (không được dùng nữa, vui lòng sử dụng DeleteEntity)",
  T_48_META_API_9005_P0_D: "thực thể văn bản cần xóa",
  T_48_META_API_9006_D: "Tạo một biểu tượng bằng cách sử dụng loại hiệu ứng đã chỉ định. Nếu có nhiều thuộc tính cần được đặt, hãy đặt thêm các thuộc tính thực thể của nó thông qua thực thể (lỗi thời, vui lòng sử dụng CreateEffect)",
  T_48_META_API_9006_P0_D: "Mã được sử dụng để thể hiện tên của tham số hình thức tạo ra thực thể hiệu ứng đặc biệt và giá trị biến cục bộ tương ứng của nó là thực thể tạo ra hiệu ứng đặc biệt.",
  T_48_META_API_9006_P1_D: "Thực thể người chơi mà nó thuộc về, chỉ hiển thị với người chơi này",
  T_48_META_API_9006_P2_D: "Loại hiệu ứng đặc biệt, loại hiệu ứng đặc biệt mà người chơi có thể lựa chọn",
  T_48_META_API_9007_D: "Xóa hiệu ứng đã chỉ định (không được dùng nữa, vui lòng sử dụng DeleteEntity)",
  T_48_META_API_9007_P0_D: "Thực thể hiệu ứng cần loại bỏ",
  T_48_META_API_9008_D: "Tạo giao diện người dùng tùy chỉnh mà chỉ những người chơi được chỉ định mới có thể nhìn thấy",
  T_48_META_API_9008_P0_D: "Đã tạo các thực thể giao diện người dùng tùy chỉnh",
  T_48_META_API_9008_P1_D: "Thực thể người chơi chứa giao diện người dùng, chỉ hiển thị với người chơi này",
  T_48_META_API_9008_P2_D: "Chỉ mục giao diện người dùng tùy chỉnh",
  T_48_META_API_9009_D: "Xóa giao diện người dùng trò chơi tùy chỉnh",
  T_48_META_API_9009_P0_D: "Thực thể giao diện người dùng tùy chỉnh cần xóa",
  T_48_META_API_9010_D: "Nhận điều khiển giao diện người dùng từ giao diện người dùng tùy chỉnh",
  T_48_META_API_9010_P0_D: "Thực thể người chơi mà giao diện người dùng thuộc về",
  T_48_META_API_9010_P1_D: "Thực thể giao diện người dùng tùy chỉnh",
  T_48_META_API_9010_P2_D: "kiểm soát chỉ số duy nhất",
  T_48_META_API_9010_R_D: "Thực thể kiểm soát giao diện người dùng",
  T_48_META_API_9011_D: "Phát hiệu ứng âm thanh được chỉ định Nếu có nhiều thuộc tính cần được đặt, hãy đặt thêm các thuộc tính thực thể của nó thông qua thực thể (lỗi thời, vui lòng sử dụng CreateSound)",
  T_48_META_API_9011_P0_D: "Mã được sử dụng để biểu thị tên của tham số chính thức tạo ra thực thể hiệu ứng âm thanh và giá trị biến cục bộ tương ứng của nó là thực thể tạo ra hiệu ứng âm thanh.",
  T_48_META_API_9011_P1_D: "Thực thể người chơi mà nó thuộc về, chỉ hiển thị với người chơi này",
  T_48_META_API_9011_P2_D: "Loại hiệu ứng âm thanh, loại hiệu ứng âm thanh mà người chơi có thể lựa chọn",
  T_48_META_API_9012_D: "Xóa hiệu ứng âm thanh được chỉ định (không được dùng nữa, vui lòng sử dụng DeleteEntity)",
  T_48_META_API_9012_P0_D: "Thực thể âm thanh cần loại bỏ",
  T_48_META_API_9013_D: "Nhận quyền kiểm soát giao diện người dùng bằng đường dẫn từ giao diện người dùng tùy chỉnh",
  T_48_META_API_9013_P0_D: "Thực thể người chơi mà giao diện người dùng thuộc về",
  T_48_META_API_9013_P1_D: "Giao diện người dùng tùy chỉnh",
  T_48_META_API_9013_P2_D: "Đường dẫn điều khiển",
  T_48_META_API_9013_R_D: "Thực thể kiểm soát giao diện người dùng",
  T_48_META_API_9014_D: "Làm gián đoạn thực thể âm thanh đang phát (không được dùng nữa, vui lòng sử dụng PauseSound)",
  T_48_META_API_9014_P0_D: "Thực thể hiệu ứng âm thanh cần được tạm dừng",
  T_48_META_API_9015_D: "Tiếp tục phát hiệu ứng âm thanh, bạn có thể chọn có bắt đầu phát lại từ đầu hay không (lỗi thời, vui lòng sử dụng ResumeSound)",
  T_48_META_API_9015_P0_D: "Các thực thể hiệu ứng âm thanh cần tiếp tục phát sau khi bị tạm dừng",
  T_48_META_API_9015_P1_D: "Có nên bắt đầu lại từ đầu không",
  T_48_META_API_9016_D: "Tạo điều khiển giao diện người dùng tùy chỉnh",
  T_48_META_API_9016_P0_D: "Đã tạo thực thể kiểm soát tùy chỉnh",
  T_48_META_API_9016_P1_D: "Loại điều khiển được tạo",
  T_48_META_API_9016_P2_D: "Thực thể UI thuộc về",
  T_48_META_API_9016_P3_D: "Kiểm soát chính mà nó thuộc về. Nếu để trống, thực thể UI mà nó thuộc về sẽ là nút chính.",
  T_48_META_API_9017_D: "Đặt mặt nạ lớp máy ảnh mục tiêu",
  T_48_META_API_9017_P0_D: "thực thể máy ảnh mục tiêu",
  T_48_META_API_9017_P1_D: "Mặt nạ lớp, chỉ những lớp đã điền sẽ được hiển thị trong máy ảnh mục tiêu, để trống nghĩa là tất cả các lớp sẽ được hiển thị.",
  T_48_META_API_9018_D: "Nhận mặt nạ lớp máy ảnh mục tiêu",
  T_48_META_API_9018_P0_D: "thực thể máy ảnh mục tiêu",
  T_48_META_API_9018_R_D: "Mặt nạ lớp, chỉ các lớp trong mặt nạ lớp sẽ được hiển thị trong camera mục tiêu",
  T_48_META_API_9019_D: "Đặt mức độ được chỉ định có hiển thị với camera mục tiêu hay không",
  T_48_META_API_9019_P0_D: "thực thể máy ảnh mục tiêu",
  T_48_META_API_9019_P1_D: "mức độ hiển thị",
  T_48_META_API_9019_P2_D: "có thể nhìn thấy hay không",
  T_48_META_API_9020_D: "Đặt trạng thái hiển thị giao diện mặc định của trình phát mục tiêu",
  T_48_META_API_9020_P0_D: "người chơi mục tiêu",
  T_48_META_API_9020_P1_D: "Loại giao diện trình phát. Loại giao diện trình phát là thành phần UI được sử dụng để kiểm soát trình phát và nội dung liên quan đến trình phát.",
  T_48_META_API_9020_P2_D: "Giá trị chuyển đổi xác định khả năng hiển thị của giao diện trình phát.",
  T_48_META_API_9021_D: "Tạo chuỗi bản địa hóa dấu thời gian",
  T_48_META_API_9021_P0_D: "Dấu thời gian",
  T_48_META_API_9021_P1_D: "Kiểu định dạng",
  T_48_META_API_9021_R_D: "Chuỗi bản địa hóa dấu thời gian",
  T_48_META_API_9022_D: "Tạo biểu tượng bản đồ nhỏ",
  T_48_META_API_9022_P0_D: "Đã tạo thực thể biểu tượng bản đồ nhỏ",
  T_48_META_API_9022_P1_D: "Thuộc về người chơi. Biểu tượng bản đồ nhỏ được tạo chỉ hiển thị với người chơi đó.",
  T_48_META_API_9022_P2_D: "Đường dẫn tài nguyên biểu tượng Minimap",
  T_48_META_API_9023_D: "Tạo một biểu tượng bằng cách sử dụng loại hiệu ứng đặc biệt đã chỉ định. Nếu có nhiều thuộc tính cần được đặt, hãy đặt thêm các thuộc tính thực thể của nó thông qua thực thể.",
  T_48_META_API_9023_P0_D: "Mã được sử dụng để thể hiện tên của tham số hình thức tạo ra thực thể hiệu ứng đặc biệt và giá trị biến cục bộ tương ứng của nó là thực thể tạo ra hiệu ứng đặc biệt.",
  T_48_META_API_9023_P1_D: "Thực thể người chơi mà nó thuộc về, chỉ hiển thị với người chơi này",
  T_48_META_API_9023_P2_D: "Loại hiệu ứng đặc biệt, loại hiệu ứng đặc biệt mà người chơi có thể lựa chọn",
  T_48_META_API_9024_D: "Xóa hiệu ứng đã chỉ định (không được dùng nữa, vui lòng sử dụng DeleteEntity)",
  T_48_META_API_9024_P0_D: "Thực thể hiệu ứng cần loại bỏ",
  T_48_META_API_9025_D: "Tạo các pixel tĩnh trên bản đồ cho đối tượng mục tiêu. Các pixel tĩnh sẽ không di chuyển cùng với đối tượng mục tiêu.",
  T_48_META_API_9025_P0_D: "Đã tạo thực thể pixel tĩnh",
  T_48_META_API_9025_P1_D: "Thuộc về người chơi, pixel tĩnh được tạo chỉ hiển thị với người chơi",
  T_48_META_API_9025_P2_D: "thực thể đối tượng mục tiêu",
  T_48_META_API_9026_D: "Nhận thực thể bản đồ nhỏ của người chơi mục tiêu",
  T_48_META_API_9026_P0_D: "người chơi mục tiêu",
  T_48_META_API_9026_R_D: "Bản đồ nhỏ của người chơi hiện tại",
  T_48_META_API_9027_D: "Đặt sát thương rơi của người chơi có thể được đặt theo chiều cao.",
  T_48_META_API_9027_P0_D: "người chơi mục tiêu",
  T_48_META_API_9027_P1_D: "Danh sách được phân đoạn cao",
  T_48_META_API_9027_P2_D: "Danh sách phân đoạn thiệt hại",
  T_48_META_API_91_D: "Việc thêm mục tiêu vào đội được chỉ định sẽ khiến mục tiêu rời khỏi đội ban đầu.",
  T_48_META_API_91_P0_D: "Những mục tiêu cần bổ sung cho đội",
  T_48_META_API_91_P1_D: "Các đội tham gia",
  T_48_META_API_91_P2_D: "Nó có thành công không?",
  T_48_META_API_92_D: "Việc thêm mục tiêu vào đội mới sẽ khiến mục tiêu rời khỏi đội ban đầu.",
  T_48_META_API_92_P0_D: "Những mục tiêu cần bổ sung cho đội",
  T_48_META_API_92_P1_D: "Tên đội mới",
  T_48_META_API_92_P2_D: "Nó có thành công không?",
  T_48_META_API_94_D: "Đặt giá trị của biến cục bộ theo chỉ mục; trước khi đặt, biến phải được xác định trong quy trình gọi hiện tại",
  T_48_META_API_94_P0: "Mục lục",
  T_48_META_API_94_P0_D: "Lấy một biến theo chỉ số",
  T_48_META_API_94_P1: "Giá trị biến đổi",
  T_48_META_API_94_P1_D: "Giá trị biến mục tiêu",
  T_48_META_API_94_P2: "Kiểu số học",
  T_48_META_API_94_P2_D: "Phương pháp hoạt động; tất cả các kiểu đều hỗ trợ phép gán và các kiểu số cũng hỗ trợ các phép toán tăng, giảm, nhân, chia và lấy phần dư",
  T_48_META_API_94_P3: "Tên biến",
  T_48_META_API_94_P3_D: "Tên biến mục tiêu. Chỉ được sử dụng cho đầu ra lỗi",
  T_48_META_API_95: "Lấy biến cục bộ theo chỉ mục",
  T_48_META_API_95_D: "Nhận giá trị của một biến cục bộ; trước khi nhận, biến phải được định nghĩa trong quy trình gọi hiện tại",
  T_48_META_API_95_P0: "Mục lục",
  T_48_META_API_95_P0_D: "Chỉ số biến đổi",
  T_48_META_API_95_P1: "Tên biến",
  T_48_META_API_95_P1_D: "Tên biến mục tiêu. Chỉ được sử dụng cho đầu ra lỗi",
  T_48_META_API_9500_D: "Thông báo cho khách hàng của người chơi mục tiêu để phát các hiệu ứng đặc biệt",
  T_48_META_API_9500_P0_D: "người chơi mục tiêu",
  T_48_META_API_9500_P1_D: "Đường dẫn tài nguyên hiệu ứng đặc biệt",
  T_48_META_API_9500_P2_D: "màu sắc",
  T_48_META_API_9500_P3_D: "Kích thước thu phóng, mặc định là 1",
  T_48_META_API_9500_P4_D: "Đối tượng liên kết, các hiệu ứng đặc biệt sẽ được đính kèm dưới dạng các nút con của nó",
  T_48_META_API_9500_P5_D: "Độ lệch tọa độ thế giới so với đối tượng bị ràng buộc",
  T_48_META_API_9501_D: "Thông báo cho client của người chơi mục tiêu phát hiệu ứng âm thanh",
  T_48_META_API_9501_P0_D: "người chơi mục tiêu",
  T_48_META_API_9501_P1_D: "Loại hiệu ứng âm thanh",
  T_48_META_API_9502_D: 'Thông báo cho client của người chơi mục tiêu hiển thị từ "nổi"',
  T_48_META_API_9502_P0_D: "người chơi mục tiêu",
  T_48_META_API_9502_P1_D: "Nội dung Piaozi",
  T_48_META_API_9502_P2_D: "Màu của chữ nổi, kiểu là màu",
  T_48_META_API_9502_P3_D: "Thời lượng của các ký tự nổi tính bằng mili giây",
  T_48_META_API_9503_D: "Làm cho đơn vị mục tiêu phát biểu thức hành động Biểu cảm một lần",
  T_48_META_API_9503_P0_D: "Mục tiêu chơi Emote",
  T_48_META_API_9503_P1_D: "Loại biểu cảm",
  T_48_META_API_9504_D: "Tạm dừng/tiếp tục biểu thức hành động Biểu cảm của một đơn vị",
  T_48_META_API_9504_P0_D: "Tạm dừng/tiếp tục mục tiêu Biểu cảm",
  T_48_META_API_9504_P1_D: "Đúng: tạm dừng phát lại, Sai: tiếp tục phát lại",
  T_48_META_EVT_1_D: "Được kích hoạt khi trò chơi bắt đầu, máy chủ sẽ sẵn sàng sớm hơn máy khách một thời gian",
  T_48_META_EVT_10_D: "Kích hoạt trước khi thực thể hiện tại chịu thiệt hại",
  T_48_META_EVT_10_P0_D: "Thực thể kẻ tấn công, có thể trống",
  T_48_META_EVT_10_P1_D: "loại thiệt hại",
  T_48_META_EVT_10_P2_D: "Số lượng thiệt hại gây ra",
  T_48_META_EVT_10_P3_D: "Phần bị thương",
  T_48_META_EVT_1000_D: "Được kích hoạt khi điểm của người chơi thay đổi",
  T_48_META_EVT_1000_P0_D: "Người chơi có điểm đã thay đổi",
  T_48_META_EVT_1000_P1_D: "Loại điểm thay đổi",
  T_48_META_EVT_1000_P2_D: "Giá trị tích phân sau khi thay đổi tích phân",
  T_48_META_EVT_1001_D: "Được kích hoạt khi điểm của đội thay đổi",
  T_48_META_EVT_1001_P0_D: "Các đội có điểm thay đổi",
  T_48_META_EVT_1001_P1_D: "Loại điểm thay đổi",
  T_48_META_EVT_1001_P2_D: "Giá trị tích phân sau khi thay đổi tích phân",
  T_48_META_EVT_1002_D: "Được kích hoạt khi thứ hạng của người chơi thay đổi",
  T_48_META_EVT_1002_P0_D: "Người chơi có thứ hạng thay đổi",
  T_48_META_EVT_1002_P1_D: "Xếp hạng sau khi thay đổi thứ hạng",
  T_48_META_EVT_1003_D: "Không dùng nữa",
  T_48_META_EVT_1003_P0_D: "Không dùng nữa",
  T_48_META_EVT_1003_P1_D: "Xếp hạng sau khi thay đổi thứ hạng",
  T_48_META_EVT_11_D: "Kích hoạt khi người chơi thoát giữa chừng",
  T_48_META_EVT_11_P0_D: "Những người chơi thoát giữa chừng",
  T_48_META_EVT_12_D: "Được kích hoạt khi người điều khiển chạm vào một thực thể. Nó sẽ chỉ được kích hoạt khi người điều khiển chủ động di chuyển.",
  T_48_META_EVT_12_P0_D: "Các thực thể gặp phải",
  T_48_META_EVT_13_D: "Kích hoạt trước khi thực thể hiện tại gây sát thương",
  T_48_META_EVT_13_P0_D: "Đối tượng bị thiệt hại",
  T_48_META_EVT_13_P1_D: "loại thiệt hại",
  T_48_META_EVT_13_P2_D: "Số lượng thiệt hại gây ra",
  T_48_META_EVT_13_P3_D: "Phần bị thương",
  T_48_META_EVT_14_D: "Được kích hoạt mỗi khi thực thể có thể chơi được lặp lại Khi thực thể có thể chơi được là hiệu ứng âm thanh, hiệu ứng đặc biệt, v.v., sự kiện này chỉ có hiệu lực trên máy khách.",
  T_48_META_EVT_2_D: "Được kích hoạt khi khung logic được cập nhật. Tần suất kích hoạt sự kiện này sẽ khác nhau tùy thuộc vào nền tảng và cài đặt.",
  T_48_META_EVT_2002_D: "Kích hoạt khi người chơi chết",
  T_48_META_EVT_2002_P0_D: "người chơi đã chết",
  T_48_META_EVT_2003_D: "Được kích hoạt khi người chơi hỗ trợ",
  T_48_META_EVT_2003_P0_D: "Những cầu thủ đã nhận được sự hỗ trợ",
  T_48_META_EVT_2003_P1_D: "Người chơi bị giết",
  T_48_META_EVT_2004_D: "Kích hoạt khi người chơi gây sát thương",
  T_48_META_EVT_2004_P0_D: "Cầu thủ gây thiệt hại",
  T_48_META_EVT_2004_P1_D: "Những cầu thủ bị tổn hại",
  T_48_META_EVT_2004_P2_D: "loại thiệt hại",
  T_48_META_EVT_2004_P3_D: "Hư hại",
  T_48_META_EVT_2004_P4_D: "Phần bị thương",
  T_48_META_EVT_2005_D: "Được kích hoạt khi người chơi giết người",
  T_48_META_EVT_2005_P0_D: "Người chơi gây ra vụ giết người",
  T_48_META_EVT_2005_P1_D: "Người chơi bị giết",
  T_48_META_EVT_2005_P2_D: "loại thiệt hại",
  T_48_META_EVT_2006_D: "Được kích hoạt khi người chơi tham gia trò chơi",
  T_48_META_EVT_2006_P0_D: "Người chơi tham gia trò chơi",
  T_48_META_EVT_2007_D: "Kích hoạt khi người chơi được hồi sinh",
  T_48_META_EVT_2007_P0_D: "người chơi hồi sinh",
  T_48_META_EVT_2007_P1_D: "Nguồn hồi sinh",
  T_48_META_EVT_2008_D: "Kích hoạt khi người chơi bị hạ gục",
  T_48_META_EVT_2008_P0_D: "cầu thủ bị hạ gục",
  T_48_META_EVT_2008_P1_D: "Cầu thủ tấn công",
  T_48_META_EVT_2009_D: "Kích hoạt khi người chơi ngắt kết nối",
  T_48_META_EVT_2009_P0_D: "Trình phát bị ngắt kết nối",
  T_48_META_EVT_2010_D: "Kích hoạt khi người chơi kết nối lại",
  T_48_META_EVT_2010_P0_D: "Người chơi đang kết nối lại",
  T_48_META_EVT_2100_D: "Kích hoạt khi nhóm bị loại bỏ",
  T_48_META_EVT_2100_P0_D: "đội đã bị loại bỏ",
  T_48_META_EVT_2101_D: "Được kích hoạt khi thêm nhóm",
  T_48_META_EVT_2101_P0_D: "Đã thêm đội",
  T_48_META_EVT_2102_D: "Kích hoạt khi đội bị tiêu diệt",
  T_48_META_EVT_2102_P0_D: "Đội đã bị loại",
  T_48_META_EVT_3_D: "Kích hoạt khi trò chơi kết thúc. Sự kiện này được kích hoạt trước khi trò chơi kết thúc trên máy chủ.",
  T_48_META_EVT_30_D: "Được kích hoạt khi cảnh được tải thành công",
  T_48_META_EVT_30_P0_D: "tên cảnh",
  T_48_META_EVT_3000_D: "Kích hoạt sau khi thực thể hiện tại được tạo",
  T_48_META_EVT_3001_D: "Được kích hoạt trước khi thực thể hiện tại bị hủy",
  T_48_META_EVT_3002_D: "Kích hoạt khi người chơi bấm cò",
  T_48_META_EVT_3002_P0_D: "người chơi đang kích hoạt",
  T_48_META_EVT_3003_D: "Bắn khi người chơi rời khỏi cò súng",
  T_48_META_EVT_3003_P0_D: "trình kích hoạt rời đi của người chơi",
  T_48_META_EVT_3004_D: "Được kích hoạt sau khi nhấp vào nút điều khiển giao diện người dùng",
  T_48_META_EVT_3004_P0_D: "Người chơi đã nhấp vào",
  T_48_META_EVT_3005_D: "Được kích hoạt khi nhấp vào một nút trong giao diện người dùng tích hợp",
  T_48_META_EVT_3005_P0_D: "Tên của điều khiển nút bấm",
  T_48_META_EVT_3006_D: "Được kích hoạt khi người chơi đang sử dụng Wakeboard",
  T_48_META_EVT_3007_D: "Kích hoạt sau khi thực thể hiện tại có sẵn",
  T_48_META_EVT_3008_D: "Kích hoạt sau khi thực thể hiện tại không khả dụng",
  T_48_META_EVT_3009_D: "Được kích hoạt khi một thực thể nhập vào một trigger. Khi một sự kiện trigger được kích hoạt, cả hai bên đều nhận được sự kiện. Một bên phải là một vật thể rắn và bên kia phải là một trigger. Đặc biệt, khi trigger là một đối tượng trigger tùy chỉnh, chỉ trigger mới nhận được sự kiện.",
  T_48_META_EVT_3009_P0_D: "Thực thể đối tác khi sự kiện kích hoạt xảy ra",
  T_48_META_EVT_3010_D: "Được kích hoạt khi thực thể rời khỏi trigger. Khi sự kiện được kích hoạt, cả hai bên đều nhận được sự kiện. Một bên phải là vật thể rắn và bên kia phải là trigger. Đặc biệt, khi trigger là đối tượng trigger tùy chỉnh, chỉ trigger mới nhận được sự kiện.",
  T_48_META_EVT_3010_P0_D: "Thực thể đối tác khi sự kiện kích hoạt xảy ra",
  T_48_META_EVT_3011_D: "Được kích hoạt sau khi thực thể hiện tại bị hủy",
  T_48_META_EVT_3011_P0_D: "Thực thể kẻ tấn công, có thể trống",
  T_48_META_EVT_3011_P1_D: "loại thiệt hại",
  T_48_META_EVT_3011_P2_D: "Phần bị thương",
  T_48_META_EVT_3012_D: "Được kích hoạt sau khi thực thể hiện tại bị tấn công",
  T_48_META_EVT_3012_P0_D: "Thực thể kẻ tấn công, có thể trống",
  T_48_META_EVT_3012_P1_D: "loại thiệt hại",
  T_48_META_EVT_3012_P2_D: "Số lượng thiệt hại gây ra",
  T_48_META_EVT_3012_P3_D: "Phần bị thương",
  T_48_META_EVT_3013_D: "Kích hoạt sau khi thực thể hiện tại gây sát thương",
  T_48_META_EVT_3013_P0_D: "Đối tượng bị thiệt hại",
  T_48_META_EVT_3013_P1_D: "loại thiệt hại",
  T_48_META_EVT_3013_P2_D: "Số lượng thiệt hại gây ra",
  T_48_META_EVT_3013_P3_D: "Phần bị thương",
  T_48_META_EVT_3014_D: "Được kích hoạt sau khi thực thể hiện tại tiêu diệt các thực thể khác",
  T_48_META_EVT_3014_P0_D: "thực thể bị phá hủy",
  T_48_META_EVT_3014_P1_D: "Phần bị thương",
  T_48_META_EVT_3015_D: "Kích hoạt khi người chơi được hồi sinh",
  T_48_META_EVT_3015_P0_D: "Loại nguồn hồi sinh người chơi",
  T_48_META_EVT_3016_D: "Kích hoạt khi trình tạo tạo ra một thực thể",
  T_48_META_EVT_3016_P0_D: "Danh sách thực thể đã tạo",
  T_48_META_EVT_3016_P1_D: "Số sóng",
  T_48_META_EVT_3017_D: "Được gọi khi người chơi vào tư thế quỳ gối hạ gục",
  T_48_META_EVT_3018_D: "Kích hoạt khi tất cả thành viên trong nhóm chết",
  T_48_META_EVT_3019_D: "Kích hoạt khi trang bị mũ bảo hiểm, áo giáp hoặc ba lô",
  T_48_META_EVT_3019_P0_D: "Mã thiết bị",
  T_48_META_EVT_3020_D: "Được kích hoạt khi cầm vũ khí chính, phụ hoặc cận chiến, kể cả khi chuyển sang nắm đấm",
  T_48_META_EVT_3020_P0_D: "Thực thể vũ khí được trang bị khi được kích hoạt",
  T_48_META_EVT_3021_D: "Được kích hoạt sau khi sử dụng đạo cụ yêu cầu thời gian sẽ kích hoạt sự kiện này sau khi hoàn thành sử dụng.",
  T_48_META_EVT_3021_P0_D: "ID dự án",
  T_48_META_EVT_3021_P1_D: "thực thể prop, có thể trống",
  T_48_META_EVT_3021_P2_D: "Thực thể prop mới được tạo bằng props, có thể trống",
  T_48_META_EVT_3022_D: "Kích hoạt khi có được một vật phẩm",
  T_48_META_EVT_3022_P0_D: "Loại mặt hàng",
  T_48_META_EVT_3022_P1_D: "Thực thể mục, có thể trống",
  T_48_META_EVT_3023_D: "Được kích hoạt khi điểm thực thể thay đổi",
  T_48_META_EVT_3023_P0_D: "Loại điểm thay đổi",
  T_48_META_EVT_3023_P1_D: "Giá trị tích phân sau khi thay đổi tích phân",
  T_48_META_EVT_3024_D: "Được kích hoạt khi thứ hạng của thực thể thay đổi",
  T_48_META_EVT_3024_P0_D: "Xếp hạng sau khi thay đổi thứ hạng",
  T_48_META_EVT_3025_D: "Kích hoạt khi được hỗ trợ",
  T_48_META_EVT_3025_P0_D: "Đối tượng bị giết",
  T_48_META_EVT_3026_D: "Được kích hoạt khi một thực thể đi vào phương tiện, bao gồm cả tài xế và hành khách",
  T_48_META_EVT_3026_P0_D: "Đối tượng vào xe",
  T_48_META_EVT_3026_P1_D: "Vào xe",
  T_48_META_EVT_3027_D: "Được kích hoạt khi thực thể rời khỏi phương tiện",
  T_48_META_EVT_3027_P0_D: "Đối tượng rời khỏi phương tiện",
  T_48_META_EVT_3027_P1_D: "Xe khởi hành",
  T_48_META_EVT_3028_D: "Được kích hoạt khi thực thể đang điều khiển phương tiện và là người điều khiển phương tiện đó.",
  T_48_META_EVT_3028_P0_D: "Đơn vị điều khiển phương tiện",
  T_48_META_EVT_3028_P1_D: "phương tiện điều khiển",
  T_48_META_EVT_3029_D: "Được kích hoạt khi phương tiện được nhập vào bởi một thực thể",
  T_48_META_EVT_3029_P0_D: "Thực thể kích hoạt",
  T_48_META_EVT_3030_D: "Được kích hoạt khi thực thể xe rời đi",
  T_48_META_EVT_3030_P0_D: "Thực thể kích hoạt",
  T_48_META_EVT_3031_D: "Được kích hoạt khi phương tiện được điều khiển bởi một thực thể",
  T_48_META_EVT_3031_P0_D: "Thực thể kích hoạt",
  T_48_META_EVT_3032_D: "Được kích hoạt sau khi thực thể sử dụng cổng để dịch chuyển tức thời (lỗi thời, vui lòng sử dụng OnBouncesOffTire)",
  T_48_META_EVT_3032_P0_D: "Các đơn vị sử dụng cổng thông tin",
  T_48_META_EVT_3032_P1_D: "Cổng thông tin được sử dụng",
  T_48_META_EVT_3033_D: "Được kích hoạt khi thực thể bị trả lại",
  T_48_META_EVT_3033_P0_D: "Thực thể kích hoạt",
  T_48_META_EVT_3033_P1_D: "Vật nảy được sử dụng",
  T_48_META_EVT_3034_D: "Được kích hoạt sau khi cổng dịch chuyển thực thể",
  T_48_META_EVT_3034_P0_D: "Thực thể truyền",
  T_48_META_EVT_3035_D: "Được kích hoạt sau khi lốp xe nảy lên thực thể",
  T_48_META_EVT_3035_P0_D: "Thực thể bị trả lại",
  T_48_META_EVT_3036_D: "Được kích hoạt khi cơ chế đánh bật thực thể lên không trung",
  T_48_META_EVT_3036_P0_D: "Các thực thể bị đánh bay",
  T_48_META_EVT_3036_P1_D: "Vật thể cơ khí",
  T_48_META_EVT_3037_D: "Kích hoạt khi một thực thể đi vào trình kích hoạt",
  T_48_META_EVT_3037_P0_D: "kích hoạt mục nhập",
  T_48_META_EVT_3038_D: "Kích hoạt khi một thực thể rời khỏi trigger",
  T_48_META_EVT_3038_P0_D: "kích hoạt khởi hành",
  T_48_META_EVT_3039_D: "Được kích hoạt khi thu được một thực thể vũ khí",
  T_48_META_EVT_3039_P0_D: "thực thể vũ khí",
  T_48_META_EVT_3040_D: "Được kích hoạt khi thực thể bị đánh bật bởi một cơ chế",
  T_48_META_EVT_3040_P0_D: "Các thực thể bị đánh bay",
  T_48_META_EVT_3040_P1_D: "Vật thể cơ khí",
  T_48_META_EVT_3041_D: "Được kích hoạt khi nhắm mục tiêu một thực thể có thể nhắm mục tiêu",
  T_48_META_EVT_3041_P0_D: "thực thể được nhắm mục tiêu",
  T_48_META_EVT_3042_D: "Được kích hoạt khi được người chơi nhắm mục tiêu",
  T_48_META_EVT_3042_P0_D: "Người chơi nhắm mục tiêu",
  T_48_META_EVT_3043_D: "Kích hoạt khi viên đạn chạm mục tiêu",
  T_48_META_EVT_3043_P0_D: "trúng mục tiêu",
  T_48_META_EVT_3043_P1_D: "Tọa độ thế giới nơi viên đạn trúng",
  T_48_META_EVT_3044_D: "Kích hoạt khi bị vũ khí tấn công",
  T_48_META_EVT_3044_P0_D: "cánh tay",
  T_48_META_EVT_3044_P1_D: "Tọa độ thế giới của khu vực bị tấn công",
  T_48_META_EVT_3045_D: "Được kích hoạt khi người chơi chọn biến thành vật thể ở cấp độ này",
  T_48_META_EVT_3045_P0_D: "Người chơi biến thành một thực thể chứ không phải chính đối tượng của cảnh",
  T_48_META_EVT_3046_D: "Được kích hoạt khi người chơi hồi sinh tại thời điểm hồi sinh này",
  T_48_META_EVT_3046_P0_D: "Người chơi được hồi sinh tại thời điểm hồi sinh này",
  T_48_META_EVT_3047_D: "Kích hoạt khi người chơi đánh rơi vũ khí",
  T_48_META_EVT_3047_P0_D: "thực thể vũ khí bị loại bỏ",
  T_48_META_EVT_3048_D: "Được kích hoạt khi người chơi đánh rơi một vật phẩm không phải là vũ khí",
  T_48_META_EVT_3048_P0_D: "Loại mặt hàng",
  T_48_META_EVT_3048_P1_D: "Thực thể mục, có thể trống",
  T_48_META_EVT_3049_D: "Kích hoạt khi bị trúng súng bóng đá",
  T_48_META_EVT_3049_P0_D: "người chơi",
  T_48_META_EVT_3049_P1_D: "tốc độ sau khi bị đánh",
  T_48_META_EVT_3050_D: "Được kích hoạt khi quả bóng va chạm với một thực thể",
  T_48_META_EVT_3050_P0_D: "Đối tượng va chạm",
  T_48_META_EVT_3050_P1_D: "vận tốc sau va chạm",
  T_48_META_EVT_3051_D: "Được kích hoạt khi người chơi tham gia thành công kênh thoại",
  T_48_META_EVT_3051_P0_D: "Thực thể kênh thoại",
  T_48_META_EVT_3052_D: "Được kích hoạt khi người chơi không tham gia được kênh thoại",
  T_48_META_EVT_3052_P0_D: "Thực thể kênh thoại",
  T_48_META_EVT_3053_D: "Được kích hoạt khi người chơi thoát khỏi kênh thoại",
  T_48_META_EVT_3053_P0_D: "Thực thể kênh thoại",
  T_48_META_EVT_3054_D: "Kích hoạt khi bóng đi vào khung thành",
  T_48_META_EVT_3054_P0_D: "mục tiêu",
  T_48_META_EVT_3054_P1_D: "Vua phá lưới, cầu thủ cuối cùng chạm bóng trước khi ghi bàn",
  T_48_META_EVT_3054_P2_D: "Hỗ trợ, cầu thủ áp chót chạm bóng trước khi vào khung thành",
  T_48_META_EVT_3055_D: "Kích hoạt khi người chơi nhấn nút bắn",
  T_48_META_EVT_3056_D: "Kích hoạt khi người chơi nhảy",
  T_48_META_EVT_3057_D: "Kích hoạt khi người chơi đang cúi xuống",
  T_48_META_EVT_3058_D: "Được kích hoạt khi người chơi nằm sấp",
  T_48_META_EVT_3059_D: "Được kích hoạt khi người chơi chạy nước rút",
  T_48_META_EVT_3060_D: "Được kích hoạt khi một mặt hàng được mua thành công trong cửa hàng",
  T_48_META_EVT_3060_P0_D: "Người chơi mua hàng",
  T_48_META_EVT_3060_P1_D: "hàng hóa",
  T_48_META_EVT_3061_D: "Được kích hoạt khi người chơi trang bị vũ khí",
  T_48_META_EVT_3061_P0_D: "Người chơi được trang bị vũ khí",
  T_48_META_EVT_3062_D: "Kích hoạt khi một đơn vị bị giết bằng vũ khí này",
  T_48_META_EVT_3062_P0_D: "Thực thể bị giết",
  T_48_META_EVT_3063_D: "Được kích hoạt khi vũ khí này được sử dụng để gây sát thương cho một đơn vị",
  T_48_META_EVT_3063_P0_D: "Thực thể bị tổn hại",
  T_48_META_EVT_3063_P1_D: "Hư hại",
  T_48_META_EVT_3064_D: "Kích hoạt khi vũ khí thay đạn",
  T_48_META_EVT_3065_D: "Được kích hoạt khi một thực thể bước vào xe. Sự kiện này có thể được kích hoạt với tư cách là người lái xe hoặc hành khách.",
  T_48_META_EVT_3065_P0_D: "Vào xe",
  T_48_META_EVT_3066_D: "Được kích hoạt khi thực thể rời khỏi phương tiện",
  T_48_META_EVT_3066_P0_D: "Xe khởi hành",
  T_48_META_EVT_3067_D: "Được kích hoạt khi một thực thể điều khiển một phương tiện",
  T_48_META_EVT_3067_P0_D: "phương tiện điều khiển",
  T_48_META_EVT_3068_D: "Được kích hoạt sau khi một thực thể dịch chuyển bằng cổng thông tin",
  T_48_META_EVT_3068_P0_D: "Cổng thông tin được sử dụng",
  T_48_META_EVT_3069_D: "Được kích hoạt sau khi thực thể bị lốp xe nảy lên",
  T_48_META_EVT_3069_P0_D: "Lốp đã qua sử dụng",
  T_48_META_EVT_3070_D: "Được kích hoạt khi thực thể bị đánh bật bởi một cơ chế",
  T_48_META_EVT_3070_P0_D: "Vật thể cơ khí",
  T_48_META_EVT_3071_D: "Được kích hoạt sau khi người chơi nhấn nút điều khiển giao diện người dùng",
  T_48_META_EVT_3071_P0_D: "trình phát kích hoạt",
  T_48_META_EVT_3072_D: "Kích hoạt sau khi điều khiển nút UI được nâng lên",
  T_48_META_EVT_3072_P0_D: "trình phát kích hoạt",
  T_48_META_EVT_3073_D: "Được kích hoạt sau khi người chơi nhấp đúp vào nút điều khiển giao diện người dùng",
  T_48_META_EVT_3073_P0_D: "trình phát kích hoạt",
  T_48_META_EVT_3074_D: "Khu vực jailbreak bắt đầu",
  T_48_META_EVT_3075_D: "Kết thúc khu vực jailbreak",
  T_48_META_EVT_3076_D: "Được kích hoạt khi người chơi ngừng sử dụng Wakeboard",
  T_48_META_EVT_3077_D: "Được kích hoạt khi nội dung văn bản của điều khiển hộp nhập giao diện người dùng bị người chơi thay đổi",
  T_48_META_EVT_3077_P0_D: "trình phát kích hoạt",
  T_48_META_EVT_3077_P1_D: "Nội dung văn bản đã thay đổi",
  T_48_META_EVT_3078_D: "Kích hoạt khi một thực thể có thể chơi được bắt đầu phát",
  T_48_META_EVT_3078_P0_D: "Thực thể có thể chơi được",
  T_48_META_EVT_3079_D: "Được kích hoạt khi thực thể có thể chơi được kết thúc phát. Khi thực thể có thể chơi được là hiệu ứng âm thanh, hiệu ứng đặc biệt, v.v., sự kiện này chỉ có hiệu lực trên máy khách.",
  T_48_META_EVT_3079_P0_D: "Thực thể có thể chơi được",
  T_48_META_EVT_3080_D: "Kích hoạt khi thực thể có thể chơi được tiếp tục chơi",
  T_48_META_EVT_3080_P0_D: "Thực thể có thể chơi được",
  T_48_META_EVT_3081_D: "Được kích hoạt khi thực thể có thể chơi tạm dừng phát lại",
  T_48_META_EVT_3081_P0_D: "Thực thể có thể chơi được",
  T_48_META_EVT_3082_D: "Người chơi đã jailbreak tham gia",
  T_48_META_EVT_3082_P0_D: "trình phát kích hoạt",
  T_48_META_EVT_3083_D: "Người chơi đã jailbreak thoát ra",
  T_48_META_EVT_3083_P0_D: "trình phát kích hoạt",
  T_48_META_EVT_3084_D: "Cháy vào cuối thời gian đếm ngược",
  T_48_META_EVT_3084_P0_D: "Chủ thể sở hữu",
  T_48_META_EVT_3085_D: "Kích hoạt khi một vật phẩm được nhặt",
  T_48_META_EVT_3085_P0_D: "Người chơi nhặt vật phẩm",
  T_48_META_EVT_3086_D: "Kích hoạt khi một vật phẩm bị rơi",
  T_48_META_EVT_3086_P0_D: "Người chơi đánh rơi vật phẩm",
  T_48_META_EVT_3087_D: "Kích hoạt khi trang bị vật phẩm này",
  T_48_META_EVT_3088_D: "Kích hoạt khi đối tượng bắt đầu sau khi mỏ được tạo",
  T_48_META_EVT_3089_D: "Kích hoạt khi đối tượng kích hoạt sau khi mỏ được tạo",
  T_48_META_EVT_3089_P0_D: "Kích hoạt mục tiêu của đối tượng sau khi mỏ được tạo",
  T_48_META_EVT_3090_D: "Kích hoạt trước khi mua vật phẩm trong cửa hàng",
  T_48_META_EVT_3090_P0_D: "Người chơi mua hàng",
  T_48_META_EVT_3090_P1_D: "hàng hóa",
  T_48_META_EVT_3091_D: "Kích hoạt khi thiết bị này được sử dụng",
  T_48_META_EVT_3092_D: "Được kích hoạt khi súng vật lộn được bắn",
  T_48_META_EVT_3093_D: "Được kích hoạt khi đạn phát nổ sau khi được ném đi",
  T_48_META_EVT_3093_P0_D: "điểm nổ",
  T_48_META_EVT_3094_D: "Kích hoạt khi bị súng phun bắn trúng",
  T_48_META_EVT_3094_P0_D: "Thực thể súng phun",
  T_48_META_EVT_3094_P1_D: "điểm nhấn",
  T_48_META_EVT_3094_P2_D: "đánh bình thường",
  T_48_META_EVT_3095_D: "Kích hoạt khi bị súng sơn bắn trúng",
  T_48_META_EVT_3095_P0_D: "đánh vào vật thể",
  T_48_META_EVT_3095_P1_D: "điểm nhấn",
  T_48_META_EVT_3095_P2_D: "đánh bình thường",
  T_48_META_EVT_3096_D: "Được kích hoạt khi xe hoặc thùng thuốc nhuộm phát nổ",
  T_48_META_EVT_3096_P0_D: "Cầu thủ gây ra vụ nổ",
  T_48_META_EVT_3096_P1_D: "Danh sách cầu thủ bị ảnh hưởng bởi vụ nổ",
  T_48_META_EVT_3097_D: "Bắn khi vũ khí ngừng bắn",
  T_48_META_EVT_3097_P0_D: "Lượng đạn còn lại trong băng đạn hiện tại khi ngừng bắn",
  T_48_META_EVT_3098_D: "Kích hoạt khi mục tiêu truy đuổi đi vào phạm vi truy đuổi",
  T_48_META_EVT_3099_D: "Kích hoạt khi mục tiêu truy đuổi rời khỏi phạm vi truy đuổi",
  T_48_META_EVT_31_D: "Được kích hoạt khi chuyển đổi cảnh thành công",
  T_48_META_EVT_31_P0_D: "tên cảnh",
  T_48_META_EVT_3100_D: "Kích hoạt khi mục tiêu tấn công đi vào phạm vi tấn công",
  T_48_META_EVT_3101_D: "Kích hoạt khi mục tiêu tấn công rời khỏi phạm vi tấn công",
  T_48_META_EVT_3102_D: "Sự kiện này được kích hoạt khi tính năng phát hiện tia camera được kích hoạt thông qua sự kiện nhấp chuột của máy khách",
  T_48_META_EVT_3102_P0_D: "trình phát kích hoạt",
  T_48_META_EVT_3102_P1_D: "Liệu tia camera có chạm vào vật thể hay không",
  T_48_META_EVT_3102_P2_D: "Tia camera chạm tới vị trí",
  T_48_META_EVT_3102_P3_D: "Hướng camera của khách hàng",
  T_48_META_EVT_3102_P4_D: "Vị trí camera của khách hàng",
  T_48_META_EVT_3102_P5_D: "thực thể đánh",
  T_48_META_EVT_3103_D: "Được kích hoạt khi giao diện cửa hàng được mở",
  T_48_META_EVT_3103_P0_D: "trình phát kích hoạt",
  T_48_META_EVT_3104_D: "Được kích hoạt khi đóng giao diện cửa hàng",
  T_48_META_EVT_3104_P0_D: "trình phát kích hoạt",
  T_48_META_EVT_3105_D: "Được kích hoạt khi logic cây hành vi đi vào nút này",
  T_48_META_EVT_3105_P0_D: "Tên nút",
  T_48_META_EVT_3105_P1_D: "Chủ thể sở hữu",
  T_48_META_EVT_3106_D: "Được kích hoạt khi logic cây hành vi thoát khỏi nút",
  T_48_META_EVT_3106_P0_D: "Tên nút",
  T_48_META_EVT_3106_P1_D: "Chủ thể sở hữu",
  T_48_META_EVT_3107_D: "Kích hoạt khi cơ thể cứng nhắc được đánh thức",
  T_48_META_EVT_3108_D: "Kích động khi cơ thể cứng ngắc đi vào giấc ngủ",
  T_48_META_EVT_3109_D: "Kích hoạt khi người chơi di chuyển",
  T_48_META_EVT_3109_P0_D: "thái độ",
  T_48_META_EVT_3110_D: "Được kích hoạt khi người chơi không hoạt động",
  T_48_META_EVT_3110_P0_D: "thái độ",
  T_48_META_EVT_3111_D: "Kích hoạt khi người chơi sử dụng kỹ năng",
  T_48_META_EVT_3111_P0_D: "Kỹ năng được sử dụng",
  T_48_META_EVT_3112_D: "Được kích hoạt khi người chơi chạy nước rút xong",
  T_48_META_EVT_3113_D: "Được kích hoạt khi lấy vật phẩm tương ứng với vị trí trong bảng liệt kê SwitchEquipSlot",
  T_48_META_EVT_3113_P0_D: "Thực thể mục thu được",
  T_48_META_EVT_3114_D: "Được kích hoạt khi chuyển đổi vật phẩm cầm tay, kể cả khi chuyển sang nắm đấm",
  T_48_META_EVT_3114_P0_D: "Thực thể của mục được giữ sau khi chuyển đổi",
  T_48_META_EVT_3115_D: "Được kích hoạt khi người chơi trong cửa hàng yêu cầu người khác mua hàng",
  T_48_META_EVT_3115_P0_D: "Người chơi đã yêu cầu sản phẩm",
  T_48_META_EVT_3115_P1_D: "hàng hóa",
  T_48_META_EVT_3116_D: "Được kích hoạt khi người chơi trong cửa hàng yêu cầu người khác mua hàng và yêu cầu được chấp nhận.",
  T_48_META_EVT_3116_P0_D: "Người chơi giúp mua",
  T_48_META_EVT_3116_P1_D: "Người chơi yêu cầu trợ giúp mua hàng",
  T_48_META_EVT_3116_P2_D: "hàng hóa",
  T_48_META_EVT_3117_D: "Được kích hoạt khi cập nhật khung cố định, tần số cố định ở mức 30 lần mỗi giây",
  T_48_META_EVT_3118_D: "Được kích hoạt sau khi gọi API trò chơi tạm dừng",
  T_48_META_EVT_3119_D: "Được kích hoạt sau khi gọi API sơ yếu lý lịch trò chơi",
  T_48_META_EVT_3120_D: "Được kích hoạt khi người chơi thêm hoặc xóa bạn bè",
  T_48_META_EVT_3121_D: "Kích hoạt khi nhận thông tin Persona",
  T_48_META_EVT_3121_P0_D: "Nội dung thông tin",
  T_48_META_EVT_3121_P1_D: "Người gửi",
  T_48_META_EVT_3122_D: "Bắn vào cuối bước nhảy của người chơi",
  T_48_META_EVT_3123_D: "Kích hoạt khi người chơi ngã",
  T_48_META_EVT_3124_D: "Được kích hoạt khi người chơi kết thúc việc rơi",
  T_48_META_EVT_3125_D: "Được kích hoạt khi nhận được hành vi của Persona",
  T_48_META_EVT_3125_P0_D: "Hành vi",
  T_48_META_EVT_3125_P1_D: "Người gửi",
  T_48_META_EVT_3126_D: "Kích hoạt khi thông tin thành viên thay đổi",
  T_48_META_EVT_3126_P0_D: "Trạng thái thành viên sau khi thay đổi",
  T_48_META_EVT_3127_D: "Kích hoạt khi vào trung tâm thành viên",
  T_48_META_EVT_3128_D: "Kích hoạt khi rời khỏi trung tâm thành viên",
  T_48_META_EVT_3129_D: "Được kích hoạt khi người chơi rơi vào trạng thái suy sụp",
  T_48_META_EVT_3129_P0_D: "Thực thể kẻ tấn công, có thể trống",
  T_48_META_EVT_3130_D: "Được kích hoạt khi nhận được trạng thái Persona",
  T_48_META_EVT_3130_P0_D: "Người gửi",
  T_48_META_EVT_3130_P1_D: "mã lỗi",
  T_48_META_EVT_3131_D: "Được kích hoạt khi gửi thông tin tới Persona thông qua UI",
  T_48_META_EVT_3131_P0_D: "Nội dung thông tin",
  T_48_META_EVT_3131_P1_D: "Người gửi",
  T_48_META_EVT_3132_D: "Kích hoạt khi nhận được kết thúc của Persona",
  T_48_META_EVT_3132_P0_D: "Người gửi",
  T_48_META_EVT_3132_P1_D: "mã lỗi",
  T_48_META_EVT_32_D: "Được kích hoạt khi người chơi chuyển cảnh",
  T_48_META_EVT_32_P0_D: "tên cảnh",
  T_48_META_EVT_3200_D: "Kích hoạt khi clip hoạt hình đã phát xong",
  T_48_META_EVT_3200_P0_D: "Tên clip hoạt hình",
  T_48_META_EVT_3201_D: "Được kích hoạt khi quá trình phát lại trạng thái hoạt ảnh hoàn tất",
  T_48_META_EVT_3201_P0_D: "Tên trạng thái hoạt ảnh",
  T_48_META_EVT_3204_D: "Kích hoạt khi trạng thái của Toggle thay đổi.",
  T_48_META_EVT_3204_P0_D: "trình phát kích hoạt",
  T_48_META_EVT_3204_P1_D: "tình trạng",
  T_48_META_EVT_3260_D: "Kích hoạt khi người chơi nhấn bàn di chuột",
  T_48_META_EVT_3260_P0_D: "trình phát kích hoạt",
  T_48_META_EVT_3260_P1_D: "Vị trí nhấn",
  T_48_META_EVT_3261_D: "Kích hoạt khi bàn di chuột được nâng lên",
  T_48_META_EVT_3261_P0_D: "trình phát kích hoạt",
  T_48_META_EVT_3261_P1_D: "vị trí nâng cao",
  T_48_META_EVT_3262_D: "Kích hoạt khi bàn di chuột bắt đầu trượt",
  T_48_META_EVT_3262_P0_D: "trình phát kích hoạt",
  T_48_META_EVT_3262_P1_D: "Bắt đầu vị trí trượt",
  T_48_META_EVT_3263_D: "Được kích hoạt trong quá trình trượt bàn di chuột Trong quá trình trượt, sự kiện này sẽ được kích hoạt một lần trong mỗi khung hình.",
  T_48_META_EVT_3263_P0_D: "trình phát kích hoạt",
  T_48_META_EVT_3263_P1_D: "Bắt đầu vị trí trượt",
  T_48_META_EVT_3263_P2_D: "Sự dịch chuyển",
  T_48_META_EVT_3264_D: "Kích hoạt ở cuối trang trình bày trên bàn di chuột",
  T_48_META_EVT_3264_P0_D: "trình phát kích hoạt",
  T_48_META_EVT_3264_P1_D: "Vị trí trượt cuối",
  T_48_META_EVT_3265_D: "Kích hoạt khi nhấn JoyStick",
  T_48_META_EVT_3265_P0_D: "trình phát kích hoạt",
  T_48_META_EVT_3266_D: "Kích hoạt khi JoyStick được nâng lên",
  T_48_META_EVT_3266_P0_D: "trình phát kích hoạt",
  T_48_META_EVT_3267_D: "Kích hoạt khi sử dụng JoyStick",
  T_48_META_EVT_3267_P0_D: "trình phát kích hoạt",
  T_48_META_EVT_3267_P1_D: "Chuyển vị đầu ra",
  T_48_META_EVT_3268_D: "Được kích hoạt khi người chơi đứng lên từ một tư thế khác",
  T_48_META_EVT_3268_P0_D: "Tư thế của cầu thủ trước khi đứng lên",
  T_48_META_EVT_3269_D: "Kích hoạt khi vũ khí được bắn",
  T_48_META_EVT_4_D: "Kích hoạt vào đầu mỗi vòng",
  T_48_META_EVT_4_P0_D: "Chỉ số làm tròn, bắt đầu từ 0",
  T_48_META_EVT_5_D: "Kích hoạt vào cuối mỗi vòng",
  T_48_META_EVT_5_P0_D: "Chỉ số làm tròn, bắt đầu từ 0",
  T_48_META_EVT_6_D: "Được kích hoạt khi một thực thể va chạm. Chỉ những thực thể có bộ phận thân cứng được gắn mới hỗ trợ sự kiện này.",
  T_48_META_EVT_6_P0_D: "Các thực thể gặp phải",
  T_48_META_EVT_7_D: "Kích hoạt vào đầu mỗi giai đoạn",
  T_48_META_EVT_7_P0_D: "thực thể sân khấu",
  T_48_META_EVT_8_D: "Kích hoạt vào cuối mỗi giai đoạn",
  T_48_META_EVT_8_P0_D: "thực thể sân khấu",
  T_48_META_EVT_9_D: "Được kích hoạt khi kết thúc xung đột thực thể. Chỉ những thực thể có bộ phận cơ thể cứng được gắn mới hỗ trợ sự kiện này.",
  T_48_META_EVT_9_P0_D: "Các thực thể gặp phải",
  T_49_META_TYP_10_I1_D: "Danh sách Tag",
  T_49_META_TYP_10_I2_D: "Có sẵn không?",
  T_49_META_TYP_10_I3_D: "Có phải tất cả các nút cha đều khả dụng không?",
  T_49_META_TYP_10_I4_D: "Có sẵn trong cảnh đó không?",
  T_49_META_TYP_10_I5_D: "Có nên bật cập nhật logic hay không. Khi tắt, tập lệnh trên thực thể sẽ dừng cập nhật mọi khung hình.",
  T_49_META_TYP_10_I6_D: "Tên thực thể",
  T_49_META_TYP_10_I7_D: "Tùy chọn lọc khu vực, 0 có nghĩa là tính toán tự động có được kiểm soát hay không, 1 có nghĩa là không được kiểm soát và luôn được đồng bộ hóa, 2 có nghĩa là được kiểm soát",
  T_49_META_TYP_100_I0_D: "Thiết lập phạm vi kích hoạt",
  T_49_META_TYP_100_I1_D: "Độ hiển thị mô hình",
  T_49_META_TYP_101_I0_D: "Người chơi",
  T_49_META_TYP_101_I1_D: "ID vật phẩm mục tiêu",
  T_49_META_TYP_101_I2_D: "Hướng xoay mục tiêu",
  T_49_META_TYP_101_I3_D: "Tỉ lệ mục tiêu",
  T_49_META_TYP_1010_I1_D: "Khoảng thời gian tính bằng giây",
  T_49_META_TYP_1010_I2_D: "Thời gian bắt đầu đếm ngược, tính bằng giây trong trò chơi",
  T_49_META_TYP_1010_I3_D: "Loại cập nhật thời gian, xem `EUITimeUpdateType`, tùy chọn: tĩnh, thời gian, đếm ngược",
  T_49_META_TYP_1010_I4_D: "Vị trí hiển thị, khi có mục tiêu để theo dõi, đó là độ lệch so với gốc mục tiêu, khi không có mục tiêu để theo dõi, đó là tọa độ màn hình",
  T_49_META_TYP_1011_I10_D: "Tên biểu tượng tiến độ",
  T_49_META_TYP_1011_I2_D: "Màu chủ đề",
  T_49_META_TYP_1011_I3_D: "Có nên bật hiển thị cục bộ không",
  T_49_META_TYP_1011_I4_D: "Tiêu đề",
  T_49_META_TYP_1011_I5_D: "Văn bản mô tả",
  T_49_META_TYP_1011_I6_D: "Tên tài nguyên biểu tượng",
  T_49_META_TYP_1011_I7_D: "Tiến độ tối đa",
  T_49_META_TYP_1011_I8_D: "Tiến độ hiện tại",
  T_49_META_TYP_1011_I9_D: "Biểu tượng tiến độ",
  T_49_META_TYP_1012_I1_D: "Có nên bật bản địa hóa không",
  T_49_META_TYP_1012_I2_D: "Số tròn Văn bản",
  T_49_META_TYP_1012_I3_D: "Mảng tham số số vòng đấu",
  T_49_META_TYP_1012_I5_D: "Màu bên trái",
  T_49_META_TYP_1012_I6_D: "Màu bên phải",
  T_49_META_TYP_1013_I2_D: "Số tròn Văn bản",
  T_49_META_TYP_1013_I3_D: "Mảng tham số số vòng đấu",
  T_49_META_TYP_1014_I2_D: "Tiêu đề văn bản điểm số đầu tiên",
  T_49_META_TYP_1014_I3_D: "Giá trị điểm đầu tiên",
  T_49_META_TYP_1014_I4_D: "Tham số điểm loại 1",
  T_49_META_TYP_1014_I5_D: "Tiêu đề bản nhạc thứ hai",
  T_49_META_TYP_1014_I6_D: "Giá trị điểm thứ hai",
  T_49_META_TYP_1014_I7_D: "Mảng tham số giá trị điểm số thứ hai",
  T_49_META_TYP_1016_I1_D: "Hiển thị trạng thái tương ứng theo giá trị, thắng (1), thua (2), hòa (3), booyah (4)",
  T_49_META_TYP_1016_I2_D: "Hiển thị điểm số của 2 đội. Nếu đúng, điểm số sẽ được hiển thị, nếu không sẽ bị ẩn.",
  T_49_META_TYP_1016_I3_D: "Điểm đội bên trái",
  T_49_META_TYP_1016_I4_D: "Điểm số đội bên phải",
  T_49_META_TYP_1016_I5_D: "Dấu thời gian kết thúc giai đoạn",
  T_49_META_TYP_1017_I1_D: "Tên đội bên trái",
  T_49_META_TYP_1017_I2_D: "Mô tả đội bên trái",
  T_49_META_TYP_1017_I3_D: "Tên đội bên phải",
  T_49_META_TYP_1017_I4_D: "Mô tả đội bên phải",
  T_49_META_TYP_1018_I1_D: "Số vòng đấu",
  T_49_META_TYP_1018_I4_D: "Điểm của đội bên trái",
  T_49_META_TYP_1018_I6_D: "Điểm của đội phải",
  T_49_META_TYP_1019_I1_D: "Thắng, thua và hòa tương ứng với 1 2 3",
  T_49_META_TYP_102_I0_D: "Loại nguồn hồi sinh, người chơi được hồi sinh từ cõi chết",
  T_49_META_TYP_102_I1_D: "Loại nguồn hồi sinh, người chơi hồi sinh từ trạng thái bị đánh gục",
  T_49_META_TYP_1020_I2_D: "Phím văn bản sẽ được hiển thị",
  T_49_META_TYP_1020_I3_D: "Mảng tham số tương ứng với khóa văn bản",
  T_49_META_TYP_1021_I1_D: "Thời gian cơ sở tính bằng giây",
  T_49_META_TYP_1021_I2_D: "Thời gian tính bằng giây",
  T_49_META_TYP_1021_I3_D: "Hiển thị vị trí. Khi có mục tiêu để theo dõi, đó là độ lệch so với gốc mục tiêu. Khi không có mục tiêu để theo dõi, đó là tọa độ màn hình. Giá trị mặc định là Vector3(0)",
  T_49_META_TYP_1022_I2_D: "Phím văn bản sẽ được hiển thị",
  T_49_META_TYP_1022_I3_D: "Mảng tham số tương ứng với khóa văn bản",
  T_49_META_TYP_1023_I1_D: "Hiển thị điểm số của đội được hiển thị khi đúng, nếu không thì đóng",
  T_49_META_TYP_1023_I4_D: "Hiển thị khi trạng thái của người chơi là đúng, nếu không thì đóng",
  T_49_META_TYP_1023_I5_D: "Mảng trạng thái của người chơi bên trái, 0: số người chơi còn sống, 1: số người chơi đã chết, 2: số người chơi đã ngã",
  T_49_META_TYP_1023_I6_D: "Mảng trạng thái của người chơi bên phải, 0: số người chơi còn sống, 1: số người chơi đã chết, 2: số người chơi đã ngã",
  T_49_META_TYP_1023_I7_D: "Số cờ của đội bên trái",
  T_49_META_TYP_1023_I8_D: "Số cờ của thành viên bên phải",
  T_49_META_TYP_1024_I2_D: "Bù lại",
  T_49_META_TYP_1024_I3_D: "Xếp hạng",
  T_49_META_TYP_1024_I4_D: "Màu đội",
  T_49_META_TYP_1024_I5_D: "Tên biểu tượng",
  T_49_META_TYP_1024_I6_D: "Nếu đường viền là đúng thì nó sẽ được hiển thị, nếu không thì nó sẽ bị đóng lại.",
  T_49_META_TYP_1024_I7_D: "Khóa điểm số văn bản",
  T_49_META_TYP_1024_I8_D: "Tham số văn bản điểm số",
  T_49_META_TYP_1028_I1_D: "Số người sống sót bên trái",
  T_49_META_TYP_1028_I2_D: "Số lượng thành viên còn sống bên phải",
  T_49_META_TYP_1028_I3_D: "Màu nền bên trái",
  T_49_META_TYP_1028_I4_D: "Màu nền bên phải",
  T_49_META_TYP_1028_I5_D: "Tên biểu tượng bên trái",
  T_49_META_TYP_1028_I6_D: "Tên biểu tượng bên phải",
  T_49_META_TYP_1029_I1_D: "Tên biểu tượng",
  T_49_META_TYP_1029_I2_D: "Tên biểu tượng nền",
  T_49_META_TYP_103_I0_D: "Vũ khí chính 1",
  T_49_META_TYP_103_I1_D: "Vũ khí chính 2",
  T_49_META_TYP_103_I10_D: "Bom đóng băng",
  T_49_META_TYP_103_I11_D: "Bức tường băng",
  T_49_META_TYP_103_I12_D: "Mìn",
  T_49_META_TYP_103_I13_D: "Tháp pháo tự động",
  T_49_META_TYP_103_I14_D: "Ma nơ canh",
  T_49_META_TYP_103_I16_D: "Ván trượt, ngụy trang...",
  T_49_META_TYP_103_I2_D: "Vũ khí phụ",
  T_49_META_TYP_103_I3_D: "Vũ khí nổ",
  T_49_META_TYP_103_I5_D: "Vũ Khí Hạng Nặng",
  T_49_META_TYP_1030_I3_D: "Số người sống sót bên trái",
  T_49_META_TYP_1030_I4_D: "Số lượng thành viên còn sống bên phải",
  T_49_META_TYP_1030_I5_D: "Tên biểu tượng nhóm ở bên trái",
  T_49_META_TYP_1030_I6_D: "Tên biểu tượng nhóm ở bên phải",
  T_49_META_TYP_1031_I2_D: "Mô tả thông tin nhanh chóng",
  T_49_META_TYP_1031_I3_D: "Dấu thời gian bắt đầu đếm ngược tính bằng giây",
  T_49_META_TYP_1031_I4_D: "Thông số mô tả thông tin gợi ý",
  T_49_META_TYP_1032_I1_D: "Loại thông báo chữ nổi",
  T_49_META_TYP_1032_I3_D: "Tham số",
  T_49_META_TYP_1033_I1_D: "Chuyển đổi giai đoạn, 0 có nghĩa là vòng hiện tại đã được giải quyết, 1 có nghĩa là vòng tiếp theo bắt đầu",
  T_49_META_TYP_1033_I10_D: "Văn bản nhắc nhở lỗi, để trống theo mặc định",
  T_49_META_TYP_1033_I11_D: "Thu nhập theo vòng",
  T_49_META_TYP_1033_I12_D: "Thu nhập mỗi vòng",
  T_49_META_TYP_1033_I13_D: "Danh sách tiêu đề chi tiết thu nhập mỗi vòng",
  T_49_META_TYP_1033_I14_D: "Danh sách chi tiết các giá trị thu nhập vòng tròn tương ứng với danh sách tiêu đề chi tiết ở trên.",
  T_49_META_TYP_1033_I15_D: "Biệt danh của cầu thủ MVP",
  T_49_META_TYP_1033_I16_D: "Chỉ số lượt tiếp theo",
  T_49_META_TYP_1033_I17_D: "Có phải là trận quyết định không",
  T_49_META_TYP_1033_I18_D: "Có phải vòng cuối không",
  T_49_META_TYP_1033_I6_D: "Tên biểu tượng nhóm ở bên trái",
  T_49_META_TYP_1033_I7_D: "Tên biểu tượng nhóm ở bên phải",
  T_49_META_TYP_1033_I8_D: "Hiển thị trạng thái tương ứng theo giá trị, chiến thắng (1), thất bại (2)",
  T_49_META_TYP_1033_I9_D: "Văn bản nhắc nhở chiến thắng, để trống theo mặc định",
  T_49_META_TYP_1036_I1_D: "Chỉ ra có bao nhiêu cấp độ",
  T_49_META_TYP_1036_I2_D: "Chỉ ra cấp độ zombie hiện tại",
  T_49_META_TYP_1037_I1_D: "Chỉ ra có bao nhiêu điểm được hiển thị",
  T_49_META_TYP_1039_I3_D: "Dấu thời gian bắt đầu đếm ngược tính bằng giây",
  T_49_META_TYP_104_I0_D: "Kiểu một",
  T_49_META_TYP_104_I1_D: "Kiểu hai",
  T_49_META_TYP_104_I2_D: "Kiểu ba",
  T_49_META_TYP_1040_I10_D: "Mô tả vật phẩm",
  T_49_META_TYP_1040_I11_D: "Chỉ số của mục được chọn, bắt đầu từ 0. Nếu chỉ số này nhỏ hơn 0, điều đó có nghĩa là bỏ chọn.",
  T_49_META_TYP_1040_I12_D: "Mảng tên nút",
  T_49_META_TYP_1040_I13_D: "Mảng màu nút",
  T_49_META_TYP_1040_I2_D: "Khóa đếm ngược",
  T_49_META_TYP_1040_I3_D: "Thời lượng đếm ngược, tính bằng giây",
  T_49_META_TYP_1040_I4_D: "Thông tin mô tả Key",
  T_49_META_TYP_1040_I5_D: "Mảng tham số thông tin mô tả",
  T_49_META_TYP_1040_I6_D: "Nền vật phẩm",
  T_49_META_TYP_1040_I7_D: "Màu nền vật phẩm",
  T_49_META_TYP_1040_I8_D: "Biểu tượng vật phẩm",
  T_49_META_TYP_1040_I9_D: "Tên vật phẩm",
  T_49_META_TYP_1041_I2_D: "Vị trí",
  T_49_META_TYP_1041_I3_D: "Biểu tượng hình ảnh",
  T_49_META_TYP_1041_I4_D: "Nhãn",
  T_49_META_TYP_1041_I5_D: "Màu nền",
  T_49_META_TYP_1042_I1_D: "Vị trí tương đối",
  T_49_META_TYP_1043_I4_D: "Màu văn bản",
  T_49_META_TYP_1043_I5_D: "Khóa nhãn",
  T_49_META_TYP_1043_I6_D: "Tham số nội dung nhãn",
  T_49_META_TYP_1045_I2_D: "Biểu tượng nút",
  T_49_META_TYP_1045_I3_D: "Màu biểu tượng",
  T_49_META_TYP_1045_I4_D: "Kích thước, chiều rộng và chiều cao đều giống nhau",
  T_49_META_TYP_1045_I5_D: "Vị trí so với điểm neo dưới cùng bên phải",
  T_49_META_TYP_1045_I6_D: "Số lượng phí, ẩn nếu nhỏ hơn 0",
  T_49_META_TYP_1045_I7_D: "Thời gian bắt đầu CD, tính bằng mili giây",
  T_49_META_TYP_1045_I8_D: "Thời lượng CD tính bằng mili giây",
  T_49_META_TYP_1045_I9_D: "Nếu Đúng, nút sẽ chuyển sang màu xám, và nếu Sai, nút sẽ được khôi phục.",
  T_49_META_TYP_106_I1_D: "Kích hoạt",
  T_49_META_TYP_106_I2_D: "Vô hiệu hóa",
  T_49_META_TYP_109_I0_D: "ID Kênh chat",
  T_49_META_TYP_109_I1_D: "Danh sách Người chơi",
  T_49_META_TYP_11_I0_D: "Trò chơi hiện tại có ở trạng thái bất hợp pháp không? Nếu ở trạng thái bất hợp pháp, điều đó có nghĩa là trò chơi đã mất giá trị đối đầu. Nên kết thúc trò chơi trực tiếp.",
  T_49_META_TYP_11_I1_D: "Thời lượng của trò chơi hiện tại, tính bằng mili giây",
  T_49_META_TYP_11_I10_D: "Có nên thiết lập lại thiết bị sau mỗi vòng không",
  T_49_META_TYP_11_I11_D: "Có nên kích hoạt cơ chế vòng tròn độc không",
  T_49_META_TYP_11_I12_D: "Kích thước Vòng bo",
  T_49_META_TYP_11_I13_D: "Thời gian bắt đầu thu bo",
  T_49_META_TYP_11_I14_D: "Thời gian thu bo",
  T_49_META_TYP_11_I15_D: "Sát thương ngoài bo",
  T_49_META_TYP_11_I18_D: "Kiểu hồi sinh",
  T_49_META_TYP_11_I2_D: "Chỉ số vòng hiện tại, thông qua đó có thể thu được thực thể vòng hiện tại",
  T_49_META_TYP_11_I27_D: "Tổng vòng đấu",
  T_49_META_TYP_11_I3_D: "Chỉ số giai đoạn hiện tại, thông qua đó có thể thu được thực thể giai đoạn hiện tại",
  T_49_META_TYP_11_I32_D: "Số lượng tiền vàng thu được khi bắt đầu vòng chơi",
  T_49_META_TYP_11_I33_D: "Số lượng tiền vàng nhận được khi giết",
  T_49_META_TYP_11_I34_D: "Số lượng tiền vàng nhận được khi chiến thắng",
  T_49_META_TYP_11_I35_D: "Có hiển thị giao diện ví không",
  T_49_META_TYP_11_I36_D: "Thực thể Skybox",
  T_49_META_TYP_11_I37_D: "Tổng số khung hình chạy kể từ khi trò chơi bắt đầu",
  T_49_META_TYP_11_I38_D: "Có thể di chuyển không",
  T_49_META_TYP_11_I39_D: "Có nên tùy chỉnh giải quyết không",
  T_49_META_TYP_11_I4_D: "ID mẫu của chế độ UGC được cài đặt trước",
  T_49_META_TYP_11_I40_D: "Có được phép tham gia giữa chừng không?",
  T_49_META_TYP_11_I41_D: "Bật chế độ tốc độ khung hình thấp, trò chơi sẽ chạy ở mức 15FPS, nếu không sẽ là 30FPS",
  T_49_META_TYP_11_I42_D: "Khoảng thời gian giữa hai lần cập nhật khung logic của máy chủ trò chơi",
  T_49_META_TYP_11_I43_D: "Khoảng thời gian cập nhật khung cố định tính bằng mili giây",
  T_49_META_TYP_11_I5_D: "Nếu tắt, chức năng hồi sinh người chơi sẽ bị vô hiệu hóa.",
  T_49_META_TYP_11_I6_D: "Nếu đóng, chức năng phục sinh Bot sẽ bị vô hiệu hóa",
  T_49_META_TYP_11_I7_D: "Thời gian hồi sinh, tính bằng giây",
  T_49_META_TYP_11_I8_D: "Tổng số đội trong trò chơi",
  T_49_META_TYP_11_I9_D: "Số lượng thành viên trong mỗi đội",
  T_49_META_TYP_110_I0_D: "Kênh thoại rảnh rỗi 1",
  T_49_META_TYP_110_I1_D: "Kênh thoại rảnh 2",
  T_49_META_TYP_110_I2_D: "Kênh thoại rảnh 3",
  T_49_META_TYP_110_I3_D: "Kênh thoại rảnh 4",
  T_49_META_TYP_110_I4_D: "Kênh thoại rảnh 5",
  T_49_META_TYP_110_I5_D: "Kênh thoại rảnh 6",
  T_49_META_TYP_111_I1_D: "Chạy nước rút",
  T_49_META_TYP_111_I2_D: "Tấn công",
  T_49_META_TYP_111_I3_D: "Nhảy",
  T_49_META_TYP_111_I4_D: "Nhảy Qua Cửa Sổ",
  T_49_META_TYP_111_I5_D: "Lái Xe",
  T_49_META_TYP_111_I6_D: "Vào phương tiện",
  T_49_META_TYP_111_I7_D: "Rời khỏi phương tiện",
  T_49_META_TYP_111_I8_D: "Điều khiển Phương tiện",
  T_49_META_TYP_112_I0_D: "Kích hoạt",
  T_49_META_TYP_112_I1_D: "Vô hiệu hóa",
  T_49_META_TYP_112_I2_D: "Vô hình",
  T_49_META_TYP_117_I0_D: "Tiếng vỗ tay",
  T_49_META_TYP_117_I1_D: "Đóng bẫy",
  T_49_META_TYP_117_I2_D: "Trống bass",
  T_49_META_TYP_117_I3_D: "Chũm chọe đã mở",
  T_49_META_TYP_117_I4_D: "Chũm chọe",
  T_49_META_TYP_117_I5_D: "Trống quân đội",
  T_49_META_TYP_118_I0_D: "Liệu tất cả các thành viên trong trại có chết không",
  T_49_META_TYP_118_I1_D: "Danh sách tất cả người chơi",
  T_49_META_TYP_118_I2_D: "Phe đồng minh",
  T_49_META_TYP_118_I3_D: "Phe có thể tấn công",
  T_49_META_TYP_118_I4_D: "Có hiển thị tên UI không",
  T_49_META_TYP_118_I5_D: "Có hiển thị thông tin bản đồ không",
  T_49_META_TYP_118_I6_D: "Có nên hiển thị không",
  T_49_META_TYP_118_I7_D: "Có nên hiển thị không",
  T_49_META_TYP_118_I8_D: "Tất cả thành viên",
  T_49_META_TYP_118_I9_D: "Có hiển thị tin nhắn nhanh không",
  T_49_META_TYP_119_I0_D: "ĐÚNG",
  T_49_META_TYP_119_I1_D: "SAI",
  T_49_META_TYP_120_I1_D: "Thực thể mục tiêu cần theo dõi, mặc định là trống",
  T_49_META_TYP_120_I2_D: "Màu sắc giao diện người dùng",
  T_49_META_TYP_120_I3_D: "Chiều dài UI",
  T_49_META_TYP_120_I4_D: "Giá trị tiến trình hiện tại, 0 đến 1.0",
  T_49_META_TYP_120_I5_D: "Hiển thị vị trí. Khi có mục tiêu để theo dõi, đó là độ lệch so với gốc mục tiêu. Khi không có mục tiêu để theo dõi, đó là tọa độ màn hình. Giá trị mặc định là Vector3(0)",
  T_49_META_TYP_121_I0_D: "3 giây",
  T_49_META_TYP_121_I1_D: "5 giây",
  T_49_META_TYP_121_I2_D: "10 giây",
  T_49_META_TYP_121_I3_D: "15 giây",
  T_49_META_TYP_121_I4_D: "30 giây",
  T_49_META_TYP_121_I5_D: "9999 giây",
  T_49_META_TYP_122_I0_D: "Tài nguyên skybox",
  T_49_META_TYP_122_I1_D: "Màu ánh sáng",
  T_49_META_TYP_122_I10_D: "GUID phụ cảnh",
  T_49_META_TYP_122_I11_D: "Công tắc hiệu ứng sương mù",
  T_49_META_TYP_122_I12_D: "Chế độ hiệu ứng sương mù",
  T_49_META_TYP_122_I13_D: "Mật độ sương mù theo cấp số nhân",
  T_49_META_TYP_122_I14_D: "Khoảng cách bắt đầu của sương mù tuyến tính",
  T_49_META_TYP_122_I15_D: "Khoảng cách cuối của sương mù tuyến tính",
  T_49_META_TYP_122_I16_D: "Bật tính năng hiệu ứng sương mù",
  T_49_META_TYP_122_I17_D: "Góc quay của nguồn sáng chính",
  T_49_META_TYP_122_I18_D: "Bật tính năng góc quay nguồn sáng chính",
  T_49_META_TYP_122_I2_D: "Cường độ sáng",
  T_49_META_TYP_122_I3_D: "Bóng tối",
  T_49_META_TYP_122_I4_D: "Cường độ đổ bóng",
  T_49_META_TYP_122_I5_D: "Độ ướt địa hình",
  T_49_META_TYP_122_I6_D: "Hiệu ứng Lens Flare",
  T_49_META_TYP_122_I7_D: "Sương Mù",
  T_49_META_TYP_122_I8_D: "Màu môi trường",
  T_49_META_TYP_123_I0_D: "Ngày",
  T_49_META_TYP_123_I1_D: "Đêm",
  T_49_META_TYP_123_I2_D: "Chiều",
  T_49_META_TYP_123_I3_D: "Cảnh thành phố",
  T_49_META_TYP_123_I4_D: "Bầu trời đa sắc",
  T_49_META_TYP_123_I5_D: "Trăng Lạnh",
  T_49_META_TYP_124_I0_D: "Tầm gần",
  T_49_META_TYP_124_I1_D: "Khoảng cách trung bình",
  T_49_META_TYP_124_I2_D: "Khoảng cách xa",
  T_49_META_TYP_125_I0_D: "Trải màu",
  T_49_META_TYP_125_I2_D: "Trải lớp phủ",
  T_49_META_TYP_125_I4_D: "Phủ Alpha",
  T_49_META_TYP_126_I1_D: "Tên",
  T_49_META_TYP_126_I2_D: "Giá trị tiến độ hiện tại",
  T_49_META_TYP_126_I3_D: "Giá trị tiến độ tối đa",
  T_49_META_TYP_126_I4_D: "Tọa độ màn hình, mặc định là Vector3(0)",
  T_49_META_TYP_126_I5_D: "Độ dài của thanh tiến trình. Giá trị mặc định hiện tại là độ dài của UI trên prefab.",
  T_49_META_TYP_127_I0_D: "Dịch chuyển theo một trục nhất định, ba trục có thể được kết hợp",
  T_49_META_TYP_127_I1_D: "Xoay dọc theo một trục nhất định, ba trục có thể được kết hợp",
  T_49_META_TYP_127_I2_D: "Phóng to theo một trục nhất định, bạn có thể kết hợp ba trục",
  T_49_META_TYP_128_I0_D: "Bụi cỏ",
  T_49_META_TYP_128_I1_D: "Bí ngô",
  T_49_META_TYP_128_I2_D: "Bù Nhìn",
  T_49_META_TYP_128_I3_D: "Tủ đựng đồ",
  T_49_META_TYP_129_I0_D: "Chiến lợi phẩm ngẫu nhiên",
  T_49_META_TYP_129_I1_D: "Đạn AR",
  T_49_META_TYP_129_I2_D: "Đạn súng tiểu liên",
  T_49_META_TYP_129_I3_D: "Đạn SN",
  T_49_META_TYP_129_I4_D: "Đạn HG",
  T_49_META_TYP_129_I5_D: "Đạn SG",
  T_49_META_TYP_129_I6_D: "Đạn cung tên",
  T_49_META_TYP_13_I1_D: "Tọa độ neo tương đối với nút cha",
  T_49_META_TYP_13_I10_D: "Sự khác biệt về kích thước của hộp tiện ích và hộp neo",
  T_49_META_TYP_13_I11_D: "Trục xoay",
  T_49_META_TYP_13_I12_D: "độ sâu",
  T_49_META_TYP_13_I14_D: "Thứ tự của tất cả các nút con dưới cùng một nút cha",
  T_49_META_TYP_13_I15_D: "EntityID của nút cha",
  T_49_META_TYP_13_I16_D: "ID duy nhất",
  T_49_META_TYP_13_I17_D: "Ưu tiên",
  T_49_META_TYP_13_I18_D: "Vị trí thực tế",
  T_49_META_TYP_13_I2_D: "Chiều rộng",
  T_49_META_TYP_13_I4_D: "Góc quay trục Z",
  T_49_META_TYP_13_I6_D: "ID nội bộ của điều khiển trong Prefab",
  T_49_META_TYP_13_I7_D: "Thực thể UI",
  T_49_META_TYP_13_I8_D: "Giá trị tối thiểu của điểm neo",
  T_49_META_TYP_13_I9_D: "Giá trị tối đa của điểm neo",
  T_49_META_TYP_130_I0_D: "Vật phẩm tiêu hao ngẫu nhiên",
  T_49_META_TYP_130_I1_D: "Túi cứu thương",
  T_49_META_TYP_130_I2_D: "Hộp sửa giáp",
  T_49_META_TYP_130_I3_D: "Bộ hồi phục",
  T_49_META_TYP_130_I4_D: "Mặt nạ hồi máu",
  T_49_META_TYP_131_I0_D: "Chiến lợi phẩm áo giáp ngẫu nhiên",
  T_49_META_TYP_131_I1_D: "Giáp cấp độ 1",
  T_49_META_TYP_131_I2_D: "Giáp cấp độ 2",
  T_49_META_TYP_131_I3_D: "Giáp cấp độ 3",
  T_49_META_TYP_132_I0_D: "Ném ngẫu nhiên",
  T_49_META_TYP_132_I1_D: "Lựu đạn",
  T_49_META_TYP_132_I4_D: "Lựu choáng băng",
  T_49_META_TYP_133_I0_D: "Phạm vi ngẫu nhiên",
  T_49_META_TYP_133_I1_D: "Ống Ngắm 2x",
  T_49_META_TYP_133_I2_D: "Ống Ngắm 4x",
  T_49_META_TYP_133_I3_D: "Kính nhiệt",
  T_49_META_TYP_134_I0_D: "Vũ khí ngẫu nhiên Loot",
  T_49_META_TYP_134_I5_D: "Súng ngắn",
  T_49_META_TYP_134_I8_D: "Máy bắn bóng",
  T_49_META_TYP_135_I0_D: "Điểm đạn chiến lợi phẩm",
  T_49_META_TYP_136_I0_D: "Điểm vật phẩm tiêu hao cướp được",
  T_49_META_TYP_137_I0_D: "Điểm vật phẩm tiêu hao cướp được",
  T_49_META_TYP_138_I0_D: "Điểm thu phóng chiến lợi phẩm",
  T_49_META_TYP_139_I0_D: "Điểm cướp áo giáp",
  T_49_META_TYP_14_I0_D: "Sức khỏe hiện tại của người chơi",
  T_49_META_TYP_14_I1_D: "Sức khỏe tối đa hiện tại của người chơi",
  T_49_META_TYP_14_I11_D: "Phe của người chơi",
  T_49_META_TYP_14_I12_D: "Hệ số sát thương của người chơi, chẳng hạn như 2x là 2.0",
  T_49_META_TYP_14_I13_D: "Sử dụng bộ xương giống hệt như nhân vật nam hoặc nữ. 0 có nghĩa là không thay thế mô hình",
  T_49_META_TYP_14_I14_D: "Sẽ không xung đột với tốc độ hiện tại",
  T_49_META_TYP_14_I15_D: "Sẽ không xung đột với thang đo chiều cao nhảy hiện có",
  T_49_META_TYP_14_I16_D: "Bản sắc, 0 Người chơi bình thường, 1 Thợ săn, 2 Zombie mẹ, 3 Zombie bình thường, 4 Zombie tiến hóa Loại 1, 5 Zombie tiến hóa Loại 2, 6 Zombie tiến hóa Loại 3",
  T_49_META_TYP_14_I17_D: "Cấp độ zombie, 1~3",
  T_49_META_TYP_14_I19_D: "Biệt danh của người chơi",
  T_49_META_TYP_14_I2_D: "Xác định xem người chơi hiện tại có phải là người chơi AI không. AI thường là NPC hoặc quái vật PVE.",
  T_49_META_TYP_14_I20_D: "Khi nhận sát thương, tỷ lệ sát thương có thể giảm hoặc tăng.",
  T_49_META_TYP_14_I21_D: "EP hiện tại của người chơi",
  T_49_META_TYP_14_I22_D: "EP người chơi tối đa",
  T_49_META_TYP_14_I23_D: "Vũ khí chính hiện đang có trong tay",
  T_49_META_TYP_14_I24_D: "Có rơi trang bị khi chết không",
  T_49_META_TYP_14_I26_D: "Kiểu hỗ trợ ghim tâm",
  T_49_META_TYP_14_I27_D: "Có thể bị khóa tâm bởi hỗ trợ nhắm không",
  T_49_META_TYP_14_I28_D: "Chuyển đổi trò chuyện bằng giọng nói: true tắt giọng nói, false bật giọng nói",
  T_49_META_TYP_14_I29_D: "Chuyển đổi trò chuyện nhanh: true tắt giọng nói, false bật giọng nói",
  T_49_META_TYP_14_I3_D: "Trạng thái người chơi",
  T_49_META_TYP_14_I30_D: "Kênh",
  T_49_META_TYP_14_I35_D: "Chuyển đổi mục lấy hàng: true để vô hiệu hóa lấy hàng, false để bật lấy hàng",
  T_49_META_TYP_14_I36_D: "Chuyển đổi mục loại bỏ: true để ngăn mục bị loại bỏ, false để cho phép mục bị loại bỏ",
  T_49_META_TYP_14_I37_D: "Mục tiêu có thể tấn công",
  T_49_META_TYP_14_I38_D: "Người chơi đồng minh",
  T_49_META_TYP_14_I39_D: "Thực thể phe",
  T_49_META_TYP_14_I4_D: "Thời gian sống sót của người chơi. Nếu người chơi chết, thời gian sẽ được tính toán lại.",
  T_49_META_TYP_14_I40_D: "Số thứ tự của người chơi trong phe",
  T_49_META_TYP_14_I41_D: "Máy ảnh mà người chơi đang sử dụng",
  T_49_META_TYP_14_I42_D: "Tùy chỉnh trọng lực",
  T_49_META_TYP_14_I43_D: "Mũ",
  T_49_META_TYP_14_I44_D: "Giáp",
  T_49_META_TYP_14_I5_D: "Sự bất khả chiến bại của người chơi",
  T_49_META_TYP_14_I52_D: "UID người dùng",
  T_49_META_TYP_14_I53_D: "Tỉ lệ giảm sát thương headshot",
  T_49_META_TYP_14_I54_D: "AVATAR dành cho người chơi",
  T_49_META_TYP_14_I55_D: "Giới tính",
  T_49_META_TYP_14_I56_D: "ID Skin súng của người chơi",
  T_49_META_TYP_14_I57_D: "Điểm xuất hiện của người chơi",
  T_49_META_TYP_14_I58_D: "Điểm hồi sinh của người chơi. Nếu không có hồ sơ điểm kiểm tra, điểm sinh sẽ được sử dụng, nếu không thì điểm kiểm tra sẽ được sử dụng.",
  T_49_META_TYP_14_I59_D: "Vị trí hiện tại của người chơi",
  T_49_META_TYP_14_I6_D: "Thực thể mà người chơi thuộc về",
  T_49_META_TYP_14_I60_D: "Hướng đi hiện tại của người chơi",
  T_49_META_TYP_14_I61_D: "Nút được sử dụng để tiếp cận xương da",
  T_49_META_TYP_14_I62_D: "Balo người chơi",
  T_49_META_TYP_14_I63_D: "Lá chắn tạm thời",
  T_49_META_TYP_14_I64_D: "ID xe",
  T_49_META_TYP_14_I65_D: "Có bỏ qua khóa hoạt ảnh khi rơi không",
  T_49_META_TYP_14_I66_D: "Miễn thương khi rơi",
  T_49_META_TYP_14_I67_D: "Vật phẩm hiện tại",
  T_49_META_TYP_14_I68_D: "Danh sách cấm nhặt vật phẩm",
  T_49_META_TYP_14_I69_D: "ID tài nguyên của người chơi",
  T_49_META_TYP_14_I7_D: "ID điểm kiểm tra hiện tại",
  T_49_META_TYP_14_I70_D: "Mục tiêu gửi tin nhắn yêu cầu mua hàng đến",
  T_49_META_TYP_14_I71_D: "ID của tài nguyên Emote hiện đang được phát",
  T_49_META_TYP_14_I72_D: "Cho dù Emote hiện đang phát có đang lặp lại không",
  T_49_META_TYP_14_I73_D: "Đối phó với trạng thái hạ gục",
  T_49_META_TYP_14_I74_D: "Có nên bật nhảy sát thương hay không, mặc định là Đúng, nghĩa là nó được bật",
  T_49_META_TYP_14_I76_D: "Tôi có thể bỏ cuộc giữa chừng được không?",
  T_49_META_TYP_14_I77_D: "Thông tin trang phục mà người chơi cần giữ lại khi biến thành nhân vật khác",
  T_49_META_TYP_14_I8_D: "ID điểm kiểm tra mà mục tiêu đang hướng tới",
  T_49_META_TYP_140_I0_D: "Sóng 1",
  T_49_META_TYP_140_I1_D: "Sóng 2",
  T_49_META_TYP_140_I2_D: "Sóng 3",
  T_49_META_TYP_140_I3_D: "Tạo liên tục",
  T_49_META_TYP_141_I0_D: "Vật phẩm bóng đá ngẫu nhiên Loot",
  T_49_META_TYP_141_I1_D: "Lá chắn bóng đá Loot",
  T_49_META_TYP_141_I2_D: "Lựu choáng băng",
  T_49_META_TYP_142_I0_D: "Điểm Loot bóng đá",
  T_49_META_TYP_143_I0_D: "Lead1C2",
  T_49_META_TYP_143_I1_D: "Lead1C2#",
  T_49_META_TYP_143_I10_D: "Lead1A2#",
  T_49_META_TYP_143_I11_D: "Lead1B2",
  T_49_META_TYP_143_I2_D: "Lead1D2",
  T_49_META_TYP_143_I3_D: "Lead1D2#",
  T_49_META_TYP_143_I4_D: "Lead1E2",
  T_49_META_TYP_143_I5_D: "Lead1F2",
  T_49_META_TYP_143_I6_D: "Lead1F2#",
  T_49_META_TYP_143_I7_D: "Lead1G2",
  T_49_META_TYP_143_I8_D: "Lead1G2#",
  T_49_META_TYP_143_I9_D: "Lead1A2",
  T_49_META_TYP_144_I0_D: "Lead2C2",
  T_49_META_TYP_144_I1_D: "Lead2C2#",
  T_49_META_TYP_144_I10_D: "Lead2A2#",
  T_49_META_TYP_144_I11_D: "Lead2B2",
  T_49_META_TYP_144_I2_D: "Lead2D2",
  T_49_META_TYP_144_I3_D: "Lead2D2#",
  T_49_META_TYP_144_I4_D: "Lead2E2",
  T_49_META_TYP_144_I5_D: "Lead2F2",
  T_49_META_TYP_144_I6_D: "Lead2F2#",
  T_49_META_TYP_144_I7_D: "Lead2G2",
  T_49_META_TYP_144_I8_D: "Lead2G2#",
  T_49_META_TYP_144_I9_D: "Lead2A2",
  T_49_META_TYP_145_I0_D: "Lead3C2",
  T_49_META_TYP_145_I1_D: "Lead3C2#",
  T_49_META_TYP_145_I10_D: "Lead3A2#",
  T_49_META_TYP_145_I11_D: "Lead3B2",
  T_49_META_TYP_145_I2_D: "Lead3D2",
  T_49_META_TYP_145_I3_D: "Lead3D2#",
  T_49_META_TYP_145_I4_D: "Lead3E2",
  T_49_META_TYP_145_I5_D: "Lead3F2",
  T_49_META_TYP_145_I6_D: "Lead3F2#",
  T_49_META_TYP_145_I7_D: "Lead3G2",
  T_49_META_TYP_145_I8_D: "Lead3G2#",
  T_49_META_TYP_145_I9_D: "Lead3A2",
  T_49_META_TYP_146_I0_D: "PianoC3",
  T_49_META_TYP_146_I1_D: "PianoC3#",
  T_49_META_TYP_146_I10_D: "PianoA3#",
  T_49_META_TYP_146_I11_D: "PianoB3",
  T_49_META_TYP_146_I12_D: "PianoC4",
  T_49_META_TYP_146_I13_D: "PianoC4#",
  T_49_META_TYP_146_I14_D: "PianoD4",
  T_49_META_TYP_146_I15_D: "PianoD4#",
  T_49_META_TYP_146_I16_D: "PianoE4",
  T_49_META_TYP_146_I17_D: "PianoF4",
  T_49_META_TYP_146_I18_D: "PianoF4#",
  T_49_META_TYP_146_I19_D: "PianoG4",
  T_49_META_TYP_146_I2_D: "PianoD3",
  T_49_META_TYP_146_I20_D: "PianoG4#",
  T_49_META_TYP_146_I21_D: "PianoA4",
  T_49_META_TYP_146_I22_D: "PianoA4#",
  T_49_META_TYP_146_I23_D: "PianoB4",
  T_49_META_TYP_146_I3_D: "PianoD3#",
  T_49_META_TYP_146_I4_D: "PianoE3",
  T_49_META_TYP_146_I5_D: "PianoF3",
  T_49_META_TYP_146_I6_D: "PianoF3#",
  T_49_META_TYP_146_I7_D: "PianoG3",
  T_49_META_TYP_146_I8_D: "PianoG3#",
  T_49_META_TYP_146_I9_D: "PianoA3",
  T_49_META_TYP_147_I0_D: "FF Classic (bắn súng)",
  T_49_META_TYP_147_I1_D: "Ngôi thứ ba",
  T_49_META_TYP_147_I2_D: "Góc nhìn thứ nhất (Bắn súng)",
  T_49_META_TYP_147_I3_D: "Nhìn từ trên xuống",
  T_49_META_TYP_147_I4_D: "Cuộn ngang",
  T_49_META_TYP_147_I5_D: "Máy ảnh tùy chỉnh",
  T_49_META_TYP_147_I6_D: "Đuổi",
  T_49_META_TYP_147_I7_D: "Camera do người chơi điều khiển, di chuyển tự do",
  T_49_META_TYP_147_I8_D: "Camera góc nhìn thứ nhất mới",
  T_49_META_TYP_148_I0_D: "Cung cấp nhiều loại camera cài đặt sẵn cũng như các loại camera tùy chỉnh",
  T_49_META_TYP_148_I1_D: "Trường nhìn là góc nhìn của máy ảnh",
  T_49_META_TYP_148_I10_D: "Loại hình ảnh động chuyển đổi camera",
  T_49_META_TYP_148_I11_D: "Chỉ có hiệu lực khi loại công tắc mượt mà. Thời gian chuyển đổi để chuyển sang camera này tính bằng mili giây.",
  T_49_META_TYP_148_I12_D: "Khi có vật cản giữa camera và đối tượng đang được theo dõi, chế độ chuyển động của camera",
  T_49_META_TYP_148_I13_D: "Máy ảnh tạo ra hình ảnh như thế nào",
  T_49_META_TYP_148_I14_D: "Thực hiện theo hệ tọa độ tham chiếu bù trừ đối tượng",
  T_49_META_TYP_148_I15_D: "Quan sát hệ tọa độ tham chiếu bù trừ đối tượng",
  T_49_META_TYP_148_I16_D: "Mặt nạ lớp kết xuất của máy ảnh có thể lọc các đối tượng được kết xuất của máy ảnh theo mức độ hiển thị",
  T_49_META_TYP_148_I17_D: "Giới hạn góc nhìn",
  T_49_META_TYP_148_I2_D: "Nói chung là độ lệch của vị trí camera so với vị trí gốc của người chơi. Ý nghĩa cụ thể khác nhau đối với các loại camera khác nhau.",
  T_49_META_TYP_148_I3_D: "Nói chung là độ lệch của điểm lấy nét của máy ảnh so với vị trí gốc của người chơi. Ý nghĩa cụ thể khác nhau đối với các loại máy ảnh khác nhau.",
  T_49_META_TYP_148_I4_D: "Góc quay dọc của máy ảnh",
  T_49_META_TYP_148_I5_D: "Góc quay ngang của máy ảnh",
  T_49_META_TYP_148_I7_D: "Mục tiêu mà máy ảnh theo dõi",
  T_49_META_TYP_148_I8_D: "Máy ảnh đang nhìn vào cái gì",
  T_49_META_TYP_148_I9_D: "Người chơi hiện đang sử dụng máy ảnh",
  T_49_META_TYP_15_I0_D: "Liệu tất cả thành viên trong nhóm hiện đã chết chưa",
  T_49_META_TYP_15_I1_D: "Danh sách tất cả các thành viên trong nhóm",
  T_49_META_TYP_15_I3_D: "Danh sách các đội địch",
  T_49_META_TYP_15_I4_D: "Danh sách đội bạn bè",
  T_49_META_TYP_15_I5_D: "Đội số",
  T_49_META_TYP_150_I0_D: "Độ bền",
  T_49_META_TYP_150_I1_D: "Bán kính của các bán cầu ở cả hai đầu của viên nang",
  T_49_META_TYP_150_I2_D: "Hệ số sát thương",
  T_49_META_TYP_152_I1_D: "Tùy chỉnh trọng lực",
  T_49_META_TYP_152_I2_D: "Có hiển thị kích hoạt hay không, True nghĩa là hiển thị",
  T_49_META_TYP_154_I0_D: "Không thể sử dụng cả hai vũ khí",
  T_49_META_TYP_154_I1_D: "Chỉ có thể sử dụng cả hai loại súng cùng loại",
  T_49_META_TYP_154_I2_D: "Có thể sử dụng song song với vũ khí khác hoặc với chính bạn",
  T_49_META_TYP_155_I0_D: "cấp",
  T_49_META_TYP_155_I1_D: "Độ bền tối đa",
  T_49_META_TYP_155_I2_D: "Độ bền hiện tại",
  T_49_META_TYP_155_I3_D: "Hệ số giảm sát thương",
  T_49_META_TYP_155_I4_D: "Hệ số giảm ST nổ",
  T_49_META_TYP_155_I5_D: "Có bị mất độ bền không",
  T_49_META_TYP_155_I6_D: "Có thể phá hủy không",
  T_49_META_TYP_156_I1_D: "Độ bền tối đa",
  T_49_META_TYP_156_I2_D: "Độ bền hiện tại",
  T_49_META_TYP_156_I3_D: "Hệ số giảm sát thương",
  T_49_META_TYP_156_I4_D: "Hệ số giảm ST nổ",
  T_49_META_TYP_156_I5_D: "Có bị mất độ bền không",
  T_49_META_TYP_156_I6_D: "Có thể phá hủy không",
  T_49_META_TYP_157_I0_D: "Không có hoạt hình",
  T_49_META_TYP_157_I1_D: "Tiến dần",
  T_49_META_TYP_158_I2_D: "Liệt kê loại neo UI, giá trị mặc định là 9 (Trung tâm)",
  T_49_META_TYP_158_I6_D: "Khóa nhãn",
  T_49_META_TYP_158_I7_D: "Tham số nội dung nhãn",
  T_49_META_TYP_158_I8_D: "Bật UITweener",
  T_49_META_TYP_16_I1_D: "ID mục tương ứng với thực thể",
  T_49_META_TYP_16_I2_D: "Chỉ được sử dụng khi tải các đối tượng tĩnh để xác định xem NavMesh có được tạo tĩnh hay không",
  T_49_META_TYP_16_I3_D: "Cho dù đó là chặn động của NavMesh",
  T_49_META_TYP_16_I4_D: "Tải không đồng bộ",
  T_49_META_TYP_160_I0_D: "Gạch A",
  T_49_META_TYP_160_I1_D: "Gạch men A",
  T_49_META_TYP_160_I10_D: "Cát A",
  T_49_META_TYP_160_I11_D: "Tuyết A",
  T_49_META_TYP_160_I12_D: "Gỗ A",
  T_49_META_TYP_160_I13_D: "Tảng đá A",
  T_49_META_TYP_160_I14_D: "Bãi cỏ B",
  T_49_META_TYP_160_I15_D: "Gạch B",
  T_49_META_TYP_160_I16_D: "Gạch C",
  T_49_META_TYP_160_I17_D: "Xóa",
  T_49_META_TYP_160_I2_D: "Gạch men B",
  T_49_META_TYP_160_I3_D: "Gạch men C",
  T_49_META_TYP_160_I4_D: "Tre A",
  T_49_META_TYP_160_I5_D: "Xi măng A",
  T_49_META_TYP_160_I6_D: "Container A",
  T_49_META_TYP_160_I7_D: "Bãi cỏ A",
  T_49_META_TYP_160_I8_D: "Băng A",
  T_49_META_TYP_160_I9_D: "Dung nham A",
  T_49_META_TYP_165_I0_D: "Có nên cho phép va chạm không",
  T_49_META_TYP_165_I1_D: "Có nên đóng vai trò là tác nhân kích hoạt không",
  T_49_META_TYP_165_I2_D: "Mức vật lý, cấu hình mức trong mô-đun vật lý, lên đến 16",
  T_49_META_TYP_166_I0_D: "Biểu tượng cảm xúc1",
  T_49_META_TYP_166_I1_D: "Biểu tượng cảm xúc2",
  T_49_META_TYP_166_I2_D: "Biểu tượng cảm xúc3",
  T_49_META_TYP_166_I3_D: "Biểu tượng cảm xúc4",
  T_49_META_TYP_166_I4_D: "Biểu tượng cảm xúc5",
  T_49_META_TYP_167_I0_D: "Kiểu hiệu ứng VFX",
  T_49_META_TYP_170_I0_D: "Có thể nhìn thấy không? Nếu không nhìn thấy, máy khách sẽ dừng hiển thị mục tiêu.",
  T_49_META_TYP_170_I1_D: "Mức độ có thể nhìn thấy, phạm vi giá trị [0,15], ảnh hưởng đến khả năng nhìn thấy trong camera",
  T_49_META_TYP_171_I0_D: "Giá trị sửa đổi EP",
  T_49_META_TYP_172_I0_D: "Số lượng đạn",
  T_49_META_TYP_173_I0_D: "Sức chứa balo bổ sung",
  T_49_META_TYP_173_I1_D: "Cấu hình giao diện của người chơi bên ngoài trò chơi được ưu tiên",
  T_49_META_TYP_173_I2_D: "ID skin ba lô, cấu hình skin ba lô",
  T_49_META_TYP_174_I2_D: "Sát thương tối đa",
  T_49_META_TYP_174_I4_D: "Tốc độ ném",
  T_49_META_TYP_174_I5_D: "Độ trễ nổ, tính bằng giây",
  T_49_META_TYP_174_I6_D: "Hệ số sát thương bản thân",
  T_49_META_TYP_174_I7_D: "Hệ số sát thương đồng đội",
  T_49_META_TYP_174_I8_D: "Hệ số sát thương phương tiện",
  T_49_META_TYP_174_I9_D: "Trang phục",
  T_49_META_TYP_175_I0_D: "Bán kính khu vực đóng băng",
  T_49_META_TYP_175_I1_D: "Thời gian đóng băng của khu vực, tính bằng giây",
  T_49_META_TYP_176_I0_D: "Loại vũ khí chính",
  T_49_META_TYP_176_I1_D: "Phân loại phụ của vũ khí",
  T_49_META_TYP_177_I0_D: "Khi có vật cản giữa camera và đối tượng đang theo dõi, camera sẽ không thực hiện bất kỳ thay đổi nào.",
  T_49_META_TYP_177_I1_D: "Khi có vật cản giữa camera và vật thể đang theo dõi, camera sẽ di chuyển đến gần vật thể đang theo dõi hơn.",
  T_49_META_TYP_177_I2_D: "Khi có vật cản giữa camera và vật thể theo dõi, vật cản sẽ trở nên trong suốt một phần",
  T_49_META_TYP_178_I0_D: "Khi máy ảnh quan sát một vật thể, các vật thể ở gần hơn sẽ có vẻ lớn hơn và các vật thể ở xa hơn sẽ có vẻ nhỏ hơn.",
  T_49_META_TYP_178_I1_D: "Khi máy ảnh quan sát một vật thể, các vật thể ở gần và xa đều có cùng kích thước",
  T_49_META_TYP_184_I0_D: "Chỉ định UUID của tài nguyên cần hiển thị.",
  T_49_META_TYP_185_I0_D: "Kết xuất lưới mô hình để sử dụng",
  T_49_META_TYP_185_I1_D: "Danh sách các vật liệu sử dụng để dựng hình",
  T_49_META_TYP_187_I0_D: "ID Vật phẩm",
  T_49_META_TYP_190_I0_D: "Trạng thái mở",
  T_49_META_TYP_190_I1_D: "Kết quả trò chơi",
  T_49_META_TYP_190_I10_D: "Danh sách điểm 1",
  T_49_META_TYP_190_I11_D: "Danh sách điểm 2",
  T_49_META_TYP_190_I12_D: "Danh sách điểm 3",
  T_49_META_TYP_190_I13_D: "MVP chiến thắng",
  T_49_META_TYP_190_I14_D: "Danh sách MVP thất bại",
  T_49_META_TYP_190_I15_D: "Hiển thị chi tiết trận đấu",
  T_49_META_TYP_190_I16_D: "Hiển thị đánh giá bản đồ",
  T_49_META_TYP_190_I17_D: "Hiển thị quà tặng",
  T_49_META_TYP_190_I18_D: "Hiển thị báo cáo",
  T_49_META_TYP_190_I19_D: "Hiển thị phát lại",
  T_49_META_TYP_190_I20_D: "Hiển thị chia sẻ",
  T_49_META_TYP_190_I21_D: "Hiển thị trở về sảnh",
  T_49_META_TYP_190_I22_D: "Hiển thị lượt thích",
  T_49_META_TYP_190_I23_D: "Hiển thị thêm bạn",
  T_49_META_TYP_190_I24_D: "Hiển thị kinh tế",
  T_49_META_TYP_190_I4_D: "Đội/Nhóm bên trái",
  T_49_META_TYP_190_I5_D: "Đội bên phải",
  T_49_META_TYP_190_I6_D: "Xếp hạng người chơi",
  T_49_META_TYP_190_I9_D: "Danh sách tiêu đề",
  T_49_META_TYP_191_I0_D: "Phạm vi trung tâm",
  T_49_META_TYP_191_I4_D: "Thời gian nháy trung tâm, tính bằng mili giây",
  T_49_META_TYP_191_I5_D: "Thời gian chớp sáng cạnh, tính bằng mili giây",
  T_49_META_TYP_191_I6_D: "Bật tắt hiệu ứng trúng lựu choáng",
  T_49_META_TYP_192_I3_D: "Thời gian hiệu ứng đặc biệt, tính bằng giây",
  T_49_META_TYP_193_I1_D: "Tiêu đề trận đấu trái",
  T_49_META_TYP_193_I10_D: "Danh sách điểm 1",
  T_49_META_TYP_193_I11_D: "Danh sách điểm 2",
  T_49_META_TYP_193_I12_D: "Danh sách điểm 3",
  T_49_META_TYP_193_I13_D: "Danh sách điểm 4",
  T_49_META_TYP_193_I14_D: "Danh sách điểm 5",
  T_49_META_TYP_193_I15_D: "MVP chiến thắng",
  T_49_META_TYP_193_I16_D: "Danh sách MVP thất bại",
  T_49_META_TYP_193_I17_D: "Hiển thị chi tiết trận đấu",
  T_49_META_TYP_193_I18_D: "Hiển thị đánh giá bản đồ",
  T_49_META_TYP_193_I19_D: "Hiển thị quà tặng",
  T_49_META_TYP_193_I2_D: "Tiêu đề trận đấu phải",
  T_49_META_TYP_193_I20_D: "Hiển thị báo cáo",
  T_49_META_TYP_193_I21_D: "Hiển thị phát lại",
  T_49_META_TYP_193_I22_D: "Hiển thị chia sẻ",
  T_49_META_TYP_193_I23_D: "Hiển thị trở về sảnh",
  T_49_META_TYP_193_I24_D: "Hiển thị lượt thích",
  T_49_META_TYP_193_I25_D: "Hiển thị thêm bạn",
  T_49_META_TYP_193_I26_D: "Hiển thị kinh tế",
  T_49_META_TYP_193_I3_D: "Kết quả trò chơi",
  T_49_META_TYP_193_I4_D: "Xếp hạng đội",
  T_49_META_TYP_193_I5_D: "Xếp hạng người chơi",
  T_49_META_TYP_193_I6_D: "Xếp hạng đội",
  T_49_META_TYP_193_I7_D: "Tựa đề điểm tổng",
  T_49_META_TYP_193_I8_D: "Điểm tổng",
  T_49_META_TYP_193_I9_D: "Danh sách tiêu đề",
  T_49_META_TYP_194_I0_D: "Thời gian tính bằng giây khi quả mìn có hiệu lực",
  T_49_META_TYP_194_I1_D: "Bán kính kích hoạt",
  T_49_META_TYP_194_I2_D: "Thời gian cần thiết để kích hoạt một quả mìn trong phạm vi mìn, tính bằng giây",
  T_49_META_TYP_194_I3_D: "Có thể tự kích hoạt không",
  T_49_META_TYP_194_I4_D: "Đồng đội có thể kích hoạt không",
  T_49_META_TYP_194_I5_D: "Phương tiện có thể kích hoạt không",
  T_49_META_TYP_194_I6_D: "Thời gian tồn tại của mìn, sẽ tự động nổ sau khi kết thúc. Thời gian bắt đầu từ lúc đặt mìn, tính bằng giây",
  T_49_META_TYP_194_I7_D: "Có thể bị tấn công không",
  T_49_META_TYP_194_I8_D: "Sức khỏe",
  T_49_META_TYP_195_I0_D: "Một lần",
  T_49_META_TYP_195_I2_D: "Sự qua lại",
  T_49_META_TYP_197_I0_D: "Có phải nó đang phát không?",
  T_49_META_TYP_197_I1_D: "Đánh dấu bit",
  T_49_META_TYP_197_I2_D: "Kiểm tra để phát tự động khi tạo",
  T_49_META_TYP_198_I0_D: "ID prop tương ứng với tệp đính kèm",
  T_49_META_TYP_199_I0_D: "EP tối đa",
  T_49_META_TYP_199_I1_D: "Tiêu hao EP mỗi giây",
  T_49_META_TYP_199_I10_D: "Tỷ lệ ST rơi",
  T_49_META_TYP_199_I11_D: "Giá trị năng lượng hiện tại",
  T_49_META_TYP_199_I2_D: "Tiêu hao năng lượng mỗi giây",
  T_49_META_TYP_199_I3_D: "Tiêu hao năng lượng mỗi giây khi chạy nhanh",
  T_49_META_TYP_199_I4_D: "Tiêu hao năng lượng khi chạy",
  T_49_META_TYP_199_I5_D: "Tốc độ ngang cơ bản",
  T_49_META_TYP_199_I6_D: "Tốc độ ngang khi chạy nhanh",
  T_49_META_TYP_199_I7_D: "Tốc độ dọc cơ bản",
  T_49_META_TYP_199_I8_D: "Tốc độ chạy nước rút theo chiều dọc",
  T_49_META_TYP_199_I9_D: "Khoảng cách lao tới",
  T_49_META_TYP_200_I0_D: "ID vùng",
  T_49_META_TYP_200_I1_D: "ID trò chơi",
  T_49_META_TYP_201_I0_D: "Tỷ lệ phần trăm chậm lại: Tỷ lệ phần trăm mà tốc độ của các vật thể nước trong vùng nước mở bị chậm lại",
  T_49_META_TYP_203_I0_D: "thực thể mục tiêu",
  T_49_META_TYP_203_I1_D: "ID đạo cụ",
  T_49_META_TYP_203_I10_D: "Thời gian máy chủ trò chơi bắt đầu tích tắc",
  T_49_META_TYP_203_I11_D: "Giá trị ban đầu",
  T_49_META_TYP_203_I12_D: "Giá trị cuối cùng",
  T_49_META_TYP_203_I13_D: "Tỷ lệ phần trăm đã vượt qua",
  T_49_META_TYP_203_I4_D: "Kiểu Tween",
  T_49_META_TYP_203_I6_D: "Thời lượng",
  T_49_META_TYP_203_I7_D: "Đảo ngược",
  T_49_META_TYP_203_I8_D: "Điểm kiểm soát",
  T_49_META_TYP_203_I9_D: "Buộc đồng bộ trạng thái máy chủ trò chơi",
  T_49_META_TYP_204_I0_D: "Độ cao nhảy tối đa",
  T_49_META_TYP_204_I1_D: "Tỷ lệ phần trăm thiệt hại khi rơi",
  T_49_META_TYP_204_I2_D: "Hồi EP mỗi giây",
  T_49_META_TYP_204_I3_D: "Tiêu thụ năng lượng",
  T_49_META_TYP_204_I4_D: "Năng lượng tối đa",
  T_49_META_TYP_205_I0_D: "Độ cao cất cánh tối thiểu",
  T_49_META_TYP_205_I1_D: "Độ cao kết thúc tối thiểu",
  T_49_META_TYP_205_I2_D: "Tốc độ bay theo chiều ngang",
  T_49_META_TYP_205_I3_D: "Tốc độ bay theo chiều dọc",
  T_49_META_TYP_205_I4_D: "Tốc độ rơi",
  T_49_META_TYP_205_I5_D: "Tốc độ quay (độ/giây)",
  T_49_META_TYP_205_I6_D: "Độ cao bay tối đa",
  T_49_META_TYP_205_I7_D: "Tốc độ rơi sau khi quá cao",
  T_49_META_TYP_205_I8_D: "Gia tốc tốc độ thay đổi",
  T_49_META_TYP_206_I0_D: "Tốc độ",
  T_49_META_TYP_206_I1_D: "Gia tốc",
  T_49_META_TYP_206_I10_D: "Ở tốc độ cao, góc lái tối đa",
  T_49_META_TYP_206_I11_D: "Tỷ lệ cơ sở nội suy góc lái tốc độ cao",
  T_49_META_TYP_206_I2_D: "Tốc độ Tăng tốc",
  T_49_META_TYP_206_I3_D: "Thời gian chạy nước rút tính bằng giây",
  T_49_META_TYP_206_I4_D: "Thời gian hồi chiêu, tính bằng giây",
  T_49_META_TYP_206_I6_D: "Nhảy CD, trong vài giây",
  T_49_META_TYP_206_I7_D: "Sprint CD sau khi lên ván trượt, đơn vị: giây",
  T_49_META_TYP_206_I8_D: "Bật/Tắt hồi chiêu tăng tốc sau khi lên Ván trượt",
  T_49_META_TYP_206_I9_D: "Đĩa CD trượt trên ván trượt, trong vài giây",
  T_49_META_TYP_207_I1_D: "Chỉ mục vị trí bắt đầu",
  T_49_META_TYP_207_I2_D: "Vị trí đích",
  T_49_META_TYP_207_I3_D: "Mã số Zipline",
  T_49_META_TYP_207_I4_D: "ID nhóm",
  T_49_META_TYP_207_I5_D: "Kết thúc rồi sao?",
  T_49_META_TYP_21_I0_D: "Mức độ cơ bản của UI",
  T_49_META_TYP_210_I1_D: "Tốc độ ban đầu",
  T_49_META_TYP_210_I2_D: "Gia tốc",
  T_49_META_TYP_210_I3_D: "Độ dịch chuyển tối đa",
  T_49_META_TYP_210_I4_D: "Vị trí thế giới ban đầu",
  T_49_META_TYP_210_I5_D: "Máy chủ trò chơi buộc phải đồng bộ hóa thông tin vị trí",
  T_49_META_TYP_211_I0_D: "Tọa độ nội địa",
  T_49_META_TYP_211_I1_D: "Tọa độ thế giới",
  T_49_META_TYP_212_I0_D: "Thực thể bản thân",
  T_49_META_TYP_212_I2_D: "Tọa độ bù trừ",
  T_49_META_TYP_213_I0_D: "Thực thể bản thân",
  T_49_META_TYP_213_I2_D: "Tọa độ bù trừ",
  T_49_META_TYP_215_I0_D: "Chiến thắng",
  T_49_META_TYP_215_I1_D: "Thất bại",
  T_49_META_TYP_215_I2_D: "Booyah",
  T_49_META_TYP_215_I3_D: "Hòa",
  T_49_META_TYP_218_I0_D: "Cường độ ánh sáng",
  T_49_META_TYP_218_I1_D: "Phạm vi chiếu sáng",
  T_49_META_TYP_218_I2_D: "Màu sáng",
  T_49_META_TYP_22_I0_D: "Nếu trạng thái mở là đúng thì nó sẽ được hiển thị, nếu không thì nó sẽ bị đóng.",
  T_49_META_TYP_22_I1_D: "ID Prefab",
  T_49_META_TYP_22_I2_D: "ID kiểm soát tối đa hiện tại",
  T_49_META_TYP_22_I3_D: "Mức độ cơ bản của UI",
  T_49_META_TYP_22_I4_D: "Bật xem trước người chơi",
  T_49_META_TYP_22_I5_D: "Tọa độ thế giới",
  T_49_META_TYP_22_I6_D: "Có trong cảnh đó không?",
  T_49_META_TYP_22_I7_D: "Quay trong tọa độ thế giới",
  T_49_META_TYP_22_I8_D: "Tỷ lệ trong tọa độ thế giới",
  T_49_META_TYP_221_I0_D: "Độ trễ chuyển số, giá trị càng lớn thì tốc độ chuyển số càng chậm",
  T_49_META_TYP_222_I0_D: "Độ trễ chuyển số, giá trị càng lớn thì tốc độ chuyển số càng chậm",
  T_49_META_TYP_225_I0_D: "Thiệt hại tháp pháo",
  T_49_META_TYP_225_I1_D: "Khoảng sát thương (ms)",
  T_49_META_TYP_225_I10_D: "Lửa trong góc",
  T_49_META_TYP_225_I11_D: "Tỷ lệ giảm thiệt hại",
  T_49_META_TYP_225_I12_D: "Xuyên Giáp",
  T_49_META_TYP_225_I2_D: "Tỷ lệ trúng",
  T_49_META_TYP_225_I3_D: "Phạm vi",
  T_49_META_TYP_225_I4_D: "Tốc độ góc",
  T_49_META_TYP_225_I5_D: "Góc lên",
  T_49_META_TYP_225_I6_D: "Góc xuống",
  T_49_META_TYP_225_I7_D: "Máu tối đa",
  T_49_META_TYP_225_I8_D: "Thời gian tồn tại tháp pháo (giây)",
  T_49_META_TYP_225_I9_D: "Số lượng tháp pháo tối đa",
  T_49_META_TYP_226_I0_D: "Sức khỏe hiện tại của tháp pháo",
  T_49_META_TYP_226_I1_D: "Bật tấn công",
  T_49_META_TYP_227_I0_D: "Widget đơn giản",
  T_49_META_TYP_227_I1_D: "Thành phần hình ảnh",
  T_49_META_TYP_227_I10_D: "Widget lớp phủ",
  T_49_META_TYP_227_I11_D: "Widget hồ sơ",
  T_49_META_TYP_227_I12_D: "Widget bật tắt",
  T_49_META_TYP_227_I13_D: "Widget touch pad",
  T_49_META_TYP_227_I14_D: "Widget cần điều khiển",
  T_49_META_TYP_227_I15_D: "Widget nút kết nối xã hội",
  T_49_META_TYP_227_I2_D: "Widget văn bản",
  T_49_META_TYP_227_I3_D: "Nút Widget",
  T_49_META_TYP_227_I4_D: "Widget nhập văn bản",
  T_49_META_TYP_227_I5_D: "Bảng điều khiển",
  T_49_META_TYP_227_I6_D: "Chế độ cuộn",
  T_49_META_TYP_227_I7_D: "Lưới",
  T_49_META_TYP_227_I8_D: "Widget bố cục",
  T_49_META_TYP_227_I9_D: "Thành phần chứa",
  T_49_META_TYP_231_I0_D: "Phục hồi độ bền",
  T_49_META_TYP_231_I1_D: "Khoảng thời gian có hiệu lực, tính bằng giây",
  T_49_META_TYP_233_I2_D: "Thời gian kết thúc của thời gian, tính bằng giây",
  T_49_META_TYP_233_I4_D: "Tên tài nguyên biểu tượng",
  T_49_META_TYP_234_I0_D: "Thời gian kích hoạt, tính bằng giây",
  T_49_META_TYP_234_I1_D: "Có thể tự kích hoạt không",
  T_49_META_TYP_234_I10_D: "Sức khỏe hiện tại",
  T_49_META_TYP_234_I2_D: "Đồng đội có thể kích hoạt không",
  T_49_META_TYP_234_I3_D: "Phương tiện có thể kích hoạt không",
  T_49_META_TYP_234_I4_D: "Thời lượng, tính bằng giây",
  T_49_META_TYP_234_I5_D: "Có thể bị tấn công không",
  T_49_META_TYP_234_I6_D: "Sức khỏe",
  T_49_META_TYP_235_I0_D: "Sức khỏe tối đa",
  T_49_META_TYP_235_I2_D: "Số lượng tối đa",
  T_49_META_TYP_237_I0_D: "Tốc độ bay",
  T_49_META_TYP_237_I1_D: "Tốc độ kéo người chơi",
  T_49_META_TYP_238_I0_D: "Màu sơn",
  T_49_META_TYP_239_I0_D: "Tốc độ ban đầu",
  T_49_META_TYP_239_I1_D: "Gia tốc (như trọng lực)",
  T_49_META_TYP_24_I0_D: "cận chiến",
  T_49_META_TYP_24_I1_D: "Súng",
  T_49_META_TYP_24_I10_D: "Sát thương thả dù, sát thương tự sát của quái vật",
  T_49_META_TYP_24_I11_D: "ST cháy khi phương tiện nổ",
  T_49_META_TYP_24_I12_D: "Thùng dầu nổ",
  T_49_META_TYP_24_I13_D: "Vũ khí loại tên lửa",
  T_49_META_TYP_24_I14_D: "Quái vật",
  T_49_META_TYP_24_I15_D: "Khu vực DMG",
  T_49_META_TYP_24_I17_D: "Kỹ năng Ảnh",
  T_49_META_TYP_24_I2_D: "Lựu đạn",
  T_49_META_TYP_24_I3_D: "Vòng bo",
  T_49_META_TYP_24_I4_D: "Phương tiện",
  T_49_META_TYP_24_I5_D: "Rơi",
  T_49_META_TYP_24_I6_D: "Khu vực tiêu diệt",
  T_49_META_TYP_24_I7_D: "Thoát",
  T_49_META_TYP_24_I8_D: "Mất kết nối",
  T_49_META_TYP_24_I9_D: "Phương tiện nổ",
  T_49_META_TYP_241_I0_D: "Tốc độ kéo",
  T_49_META_TYP_241_I1_D: "Tốc độ vung",
  T_49_META_TYP_241_I2_D: "Bật nút kéo",
  T_49_META_TYP_241_I3_D: "Bật nút xoay",
  T_49_META_TYP_241_I4_D: "Mỏ neo chuyển động",
  T_49_META_TYP_241_I5_D: "Tăng tốc đu dây",
  T_49_META_TYP_242_I2_D: "Hiển thị hiệu ứng bên trái",
  T_49_META_TYP_242_I3_D: "Hiển thị hiệu ứng bên phải hay không",
  T_49_META_TYP_242_I4_D: "Có hiển thị đường trung tâm không",
  T_49_META_TYP_242_I5_D: "Giá trị [0, 1]",
  T_49_META_TYP_242_I7_D: "Vị trí UI, chỉ có các thành phần XY là hợp lệ",
  T_49_META_TYP_242_I8_D: "Vị trí đường giữa [0,1]",
  T_49_META_TYP_243_I0_D: "Trang phục trên",
  T_49_META_TYP_243_I1_D: "Trang phục dưới",
  T_49_META_TYP_243_I2_D: "Giày",
  T_49_META_TYP_243_I3_D: "Trang điểm",
  T_49_META_TYP_243_I4_D: "Phụ kiện đầu",
  T_49_META_TYP_243_I5_D: "Bộ trang phục",
  T_49_META_TYP_243_I6_D: "Trang trí mặt",
  T_49_META_TYP_244_I0_D: "Văn bản sẽ được hiển thị",
  T_49_META_TYP_244_I10_D: "Danh sách người chơi có thể nhìn thấy thực thể này",
  T_49_META_TYP_244_I11_D: "Hiển thị phân cấp",
  T_49_META_TYP_244_I2_D: "Theo mục tiêu",
  T_49_META_TYP_244_I3_D: "Khi độ sâu bị bỏ qua, nó có thể được hiển thị xuyên qua tường, nếu không thì không thể hiển thị",
  T_49_META_TYP_244_I4_D: "Có phải là billboard không",
  T_49_META_TYP_244_I5_D: "Khi đặt thành true, vị trí sẽ được hiển thị trên màn hình khi nó nằm ngoài màn hình",
  T_49_META_TYP_244_I6_D: "Kiểu phông chữ",
  T_49_META_TYP_244_I7_D: "Kiểu phông chữ",
  T_49_META_TYP_244_I8_D: "Kích thước phông chữ",
  T_49_META_TYP_245_I0_D: "Đường dẫn tài nguyên",
  T_49_META_TYP_245_I11_D: "Hiển thị phân cấp",
  T_49_META_TYP_245_I3_D: "Khi độ sâu bị bỏ qua, nó có thể được hiển thị xuyên qua tường, nếu không thì không thể hiển thị",
  T_49_META_TYP_245_I4_D: "Khi đặt thành true, vị trí sẽ được hiển thị trên màn hình khi nó nằm ngoài màn hình",
  T_49_META_TYP_245_I5_D: "Có phải là billboard không",
  T_49_META_TYP_245_I6_D: "Kiểu kết xuất",
  T_49_META_TYP_245_I7_D: "Chiều rộng",
  T_49_META_TYP_246_I0_D: "Màu cam",
  T_49_META_TYP_246_I1_D: "Màu tím",
  T_49_META_TYP_246_I2_D: "Đỏ",
  T_49_META_TYP_246_I3_D: "Màu xanh lá",
  T_49_META_TYP_246_I4_D: "Màu xanh lam",
  T_49_META_TYP_247_I1_D: "Chạy nước rút",
  T_49_META_TYP_247_I14_D: "Hành động",
  T_49_META_TYP_247_I15_D: "UI Tin nhắn nhanh",
  T_49_META_TYP_247_I16_D: "Đồ nhặt",
  T_49_META_TYP_247_I17_D: "UI Tin nhắn nhanh bên cạnh danh sách đội",
  T_49_META_TYP_247_I18_D: "HP",
  T_49_META_TYP_247_I19_D: "UI EP",
  T_49_META_TYP_247_I2_D: "Tấn công",
  T_49_META_TYP_247_I20_D: "Giáp",
  T_49_META_TYP_247_I21_D: "UI Thay đạn",
  T_49_META_TYP_247_I22_D: "Nút thay đổi súng nhanh",
  T_49_META_TYP_247_I23_D: "Nút còi xe có thể bật/tắt",
  T_49_META_TYP_247_I24_D: "Nút giọng nói (micrô) để bật/tắt",
  T_49_META_TYP_247_I25_D: "Nút bật/tắt đánh dấu",
  T_49_META_TYP_247_I27_D: "Nút tín hiệu mạng có thể bật/tắt",
  T_49_META_TYP_247_I28_D: "Kỹ năng chủ động",
  T_49_META_TYP_247_I29_D: "UI tâm ngắm",
  T_49_META_TYP_247_I3_D: "Nhảy",
  T_49_META_TYP_247_I30_D: "Kỹ năng bị động",
  T_49_META_TYP_247_I4_D: "Mẹo hạ gục",
  T_49_META_TYP_247_I5_D: "Giao diện thanh vũ khí",
  T_49_META_TYP_247_I6_D: "UI Bản đồ nhỏ",
  T_49_META_TYP_247_I7_D: "Giao diện người dùng của Ba lô",
  T_49_META_TYP_247_I8_D: "Dụng cụ y tế",
  T_49_META_TYP_247_I9_D: "Nếu đúng thì sẽ hiển thị, nếu không thì sẽ đóng lại.",
  T_49_META_TYP_249_I3_D: "Vũ khí nổ",
  T_49_META_TYP_249_I5_D: "Vũ Khí Hạng Nặng",
  T_49_META_TYP_249_I8_D: "Bom đóng băng",
  T_49_META_TYP_249_I9_D: "Ma nơ canh",
  T_49_META_TYP_25_I0_D: "Chỉ mục của giai đoạn hiện tại, tương ứng với chỉ mục trong trình chỉnh sửa quy trình",
  T_49_META_TYP_25_I1_D: "Thời gian bắt đầu của giai đoạn hiện tại, tính bằng ms",
  T_49_META_TYP_25_I2_D: "Thời gian kết thúc của giai đoạn hiện tại, tính bằng ms",
  T_49_META_TYP_25_I3_D: "Thời gian của pha hiện tại, tính bằng ms",
  T_49_META_TYP_250_I1_D: "Màu hiệu ứng đặc biệt, RGBA bốn kênh, phạm vi giá trị kênh đơn 0~255, được lưu trữ trong Int32",
  T_49_META_TYP_250_I3_D: "Kiểu hiệu ứng VFX",
  T_49_META_TYP_250_I4_D: "Phủ Alpha",
  T_49_META_TYP_2500_I1_D: "Có phải là điểm xuất hiện mặc định không",
  T_49_META_TYP_2500_I3_D: "Đã có người chơi nào sinh ra ở khu vực sinh sản này chưa?",
  T_49_META_TYP_2500_I4_D: "Tọa độ của điểm sinh hiện tại có thể chỉ định",
  T_49_META_TYP_2502_I0_D: "Cho dù đó có phải là yếu tố kích hoạt tử vong hay không, thì đó cũng là yếu tố kích hoạt bất khả chiến bại. (Đây là vấn đề tồn tại từ OB32, vui lòng tách chức năng này ra trong tương lai!)",
  T_49_META_TYP_2502_I1_D: "Có hiển thị đường viền kích hoạt hay không, true có nghĩa là hiển thị",
  T_49_META_TYP_2503_I0_D: "ID Checkpoint",
  T_49_META_TYP_2503_I2_D: "Vị trí trạm kiểm soát",
  T_49_META_TYP_2507_I0_D: "Tháp phòng thủ thuộc về trại nào? Nếu cùng trại với người chơi, nó sẽ không tấn công người chơi.",
  T_49_META_TYP_2507_I1_D: "Máu hiện tại",
  T_49_META_TYP_2507_I10_D: "ID đối tượng",
  T_49_META_TYP_2507_I2_D: "HP tối đa",
  T_49_META_TYP_2507_I3_D: "Sát thương tấn công, sát thương mà một đòn tấn công duy nhất có thể gây ra cho người chơi",
  T_49_META_TYP_2507_I4_D: "Khoảng thời gian giữa hai lần tấn công, tính bằng giây",
  T_49_META_TYP_2507_I5_D: "Khu vực có tâm là tâm và bán kính có kích thước bất kỳ có thể bị tấn công",
  T_49_META_TYP_2507_I6_D: "Tỷ lệ giảm sát thương, số thập phân nhỏ hơn 1. Sát thương cuối cùng là sát thương nhân với (1-tỷ lệ giảm sát thương)",
  T_49_META_TYP_2507_I7_D: "Mục tiêu tấn công",
  T_49_META_TYP_2507_I8_D: "Góc xoay",
  T_49_META_TYP_2507_I9_D: "Trạng thái tháp pháo mini",
  T_49_META_TYP_2508_I0_D: "Số lượng zombie sẽ xuất hiện trong mỗi đợt",
  T_49_META_TYP_2508_I1_D: "Sẽ có bao nhiêu đợt zombie được tạo ra?",
  T_49_META_TYP_2508_I2_D: "Có nên tạo liên tục không, nhưng sẽ có giới hạn trên cùng một màn hình",
  T_49_META_TYP_2508_I3_D: "Sóng nào hiện đang được tạo ra?",
  T_49_META_TYP_2508_I5_D: "Loại zombie nào được sinh ra trong đợt hiện tại",
  T_49_META_TYP_2508_I6_D: "Liệu AI có đánh rơi trang bị hoặc vật phẩm khi chết không?",
  T_49_META_TYP_2508_I7_D: "Thời gian bắt đầu sinh ra",
  T_49_META_TYP_2508_I8_D: "Khoảng thời gian giữa sóng tiếp theo và sóng trước đó",
  T_49_META_TYP_2509_I0_D: "Số lượng đơn vị sẽ được sinh ra trong mỗi đợt",
  T_49_META_TYP_2509_I1_D: "Tổng cộng sẽ có bao nhiêu sóng máy phát điện đơn vị được tạo ra?",
  T_49_META_TYP_2509_I2_D: "Sóng nào hiện đang được tạo ra?",
  T_49_META_TYP_2509_I4_D: "Thực thể nào sẽ được sử dụng làm mẫu cho mỗi đợt sóng được tạo ra?",
  T_49_META_TYP_2509_I5_D: "Thời gian sinh sản của đơn vị",
  T_49_META_TYP_2509_I6_D: "Có nên tạo liên tục không, nhưng sẽ có giới hạn trên cùng một màn hình",
  T_49_META_TYP_2509_I7_D: "Khoảng thời gian giữa sóng tiếp theo và sóng trước đó",
  T_49_META_TYP_2509_I8_D: "prefabID của mẫu",
  T_49_META_TYP_2510_I0_D: "Số lượng vị trí xuất hiện",
  T_49_META_TYP_252_I1_D: "Biểu tượng bên trái",
  T_49_META_TYP_252_I2_D: "Văn bản bên trái",
  T_49_META_TYP_252_I3_D: "Văn bản điểm số bên trái",
  T_49_META_TYP_252_I5_D: "Biểu tượng bên phải",
  T_49_META_TYP_252_I6_D: "Văn bản bên phải",
  T_49_META_TYP_252_I7_D: "Văn bản điểm bên phải",
  T_49_META_TYP_252_I8_D: "Tiến độ [0,1]",
  T_49_META_TYP_253_I0_D: "Chọn biểu tượng",
  T_49_META_TYP_253_I1_D: "Văn bản",
  T_49_META_TYP_253_I2_D: "Hiển thị hiệu ứng đặc biệt",
  T_49_META_TYP_253_I3_D: "Vị trí UI",
  T_49_META_TYP_254_I1_D: "Ví dụ, 1,25 có nghĩa là gấp 1,25 lần tốc độ bình thường",
  T_49_META_TYP_254_I2_D: "Màu sắc",
  T_49_META_TYP_256_I0_D: "Hoàn toàn tĩnh lặng. Hiệu suất kinh tế nhất",
  T_49_META_TYP_256_I1_D: "Dùng lực một cách bình thường. Tiêu thụ hiệu suất nhiều nhất",
  T_49_META_TYP_256_I2_D: "Chuyển động có thể được kiểm soát bằng các tập lệnh và khối lượng có thể được coi là vô hạn",
  T_49_META_TYP_257_I0_D: "Các loại vật rắn khác nhau có chức năng khác nhau",
  T_49_META_TYP_257_I1_D: "Sử dụng Trọng lực",
  T_49_META_TYP_257_I2_D: "Khối lượng (kg), khối lượng hiệu dụng tối thiểu là 0,001kg. Nếu bằng 0, nghĩa là khối lượng vô hạn và sẽ không di chuyển dưới tác dụng của lực",
  T_49_META_TYP_257_I3_D: "Vị trí trọng tâm, hệ tọa độ cục bộ",
  T_49_META_TYP_257_I4_D: "Vận tốc tuyến tính của chuyển động vật rắn",
  T_49_META_TYP_257_I5_D: "Vận tốc góc của vật rắn",
  T_49_META_TYP_257_I6_D: "Hệ số suy giảm tự nhiên của tốc độ tuyến tính. Hệ số càng lớn, tốc độ chuyển động giảm càng nhanh.",
  T_49_META_TYP_257_I7_D: "Hệ số suy giảm tự nhiên của vận tốc góc. Hệ số càng lớn thì tốc độ chuyển động giảm càng nhanh.",
  T_49_META_TYP_257_I8_D: "Các ràng buộc áp đặt lên vật thể cứng là một tập hợp các RigidbodyConstrainType",
  T_49_META_TYP_258_I0_D: "2017-10-10 13:38:10 ",
  T_49_META_TYP_258_I1_D: "13:45 ",
  T_49_META_TYP_258_I2_D: "10/10/2017 1:45 PM ",
  T_49_META_TYP_258_I3_D: "10/10/2017",
  T_49_META_TYP_259_I0_D: "Nền",
  T_49_META_TYP_259_I1_D: "Văn bản",
  T_49_META_TYP_259_I2_D: "Vị trí UI",
  T_49_META_TYP_259_I4_D: "Màu văn bản",
  T_49_META_TYP_260_I0_D: "Chọn biểu tượng",
  T_49_META_TYP_260_I1_D: "Màu thanh tiến trình",
  T_49_META_TYP_260_I2_D: "Giá trị [0, 1]",
  T_49_META_TYP_260_I3_D: "Tốc độ, m/giây",
  T_49_META_TYP_260_I4_D: "Có hiển thị hiệu ứng đặc biệt không",
  T_49_META_TYP_260_I5_D: "Vị trí UI [0,1]",
  T_49_META_TYP_260_I6_D: "Tiến trình ban đầu của kỹ năng, giá trị là [0, 1]. Sau khi UI được tạo, tiến trình sẽ được đồng bộ hóa ngay lập tức với tiến trình hiện tại",
  T_49_META_TYP_260_I7_D: "Màu hiệu ứng",
  T_49_META_TYP_260_I8_D: "Đặt giá trị tỷ lệ của đối tượng",
  T_49_META_TYP_265_I1_D: "Có nên thực hiện điền nền không",
  T_49_META_TYP_265_I2_D: "Tên nền",
  T_49_META_TYP_265_I3_D: "Màu nền",
  T_49_META_TYP_265_I5_D: "BgAlpha",
  T_49_META_TYP_265_I6_D: "Loại cắt",
  T_49_META_TYP_265_I7_D: "Loại mặt nạ là tên của hình ảnh được chọn khi tạo mặt nạ",
  T_49_META_TYP_265_I8_D: "Đơn vị làm mềm cạnh",
  T_49_META_TYP_267_I0_D: "Điểm bắt đầu cuộn, mặc định là góc trên bên trái",
  T_49_META_TYP_267_I1_D: "Hỗ trợ nhiều hướng cuộn",
  T_49_META_TYP_267_I10_D: "Thanh ngang",
  T_49_META_TYP_267_I11_D: "Vị trí hiển thị",
  T_49_META_TYP_267_I2_D: "Kéo thành phần theo hướng XY",
  T_49_META_TYP_267_I3_D: "Hỗ trợ nhiều hiệu ứng kéo",
  T_49_META_TYP_267_I4_D: "Hệ số cuộn, giá trị càng lớn thì cuộn càng nhanh",
  T_49_META_TYP_267_I5_D: "Hệ số quán tính, giá trị càng lớn thì quán tính khi lăn càng lớn.",
  T_49_META_TYP_267_I6_D: "Cho dù việc kéo có bị giới hạn ở chế độ xem hay không, được chọn theo mặc định",
  T_49_META_TYP_267_I7_D: "Khi được chọn, thao tác kéo sẽ bắt đầu bằng chuyển động chậm, nếu không được chọn, thao tác kéo sẽ bắt đầu bằng tốc độ di chuyển của chuột",
  T_49_META_TYP_267_I8_D: "Khi nó phù hợp với khung nhìn, hãy thoát khỏi việc kéo",
  T_49_META_TYP_267_I9_D: "Trục dọc",
  T_49_META_TYP_268_I0_D: "Mặc định",
  T_49_META_TYP_268_I1_D: "Đóng",
  T_49_META_TYP_268_I2_D: "Hiển thị",
  T_49_META_TYP_269_I0_D: "Chủ sở hữu",
  T_49_META_TYP_269_I1_D: "Đặt ID",
  T_49_META_TYP_269_I2_D: "ID mũ đội đầu",
  T_49_META_TYP_269_I3_D: "Nhận diện khuôn mặt",
  T_49_META_TYP_269_I4_D: "ID trang điểm",
  T_49_META_TYP_269_I5_D: "ID thân trên",
  T_49_META_TYP_269_I6_D: "ID thân dưới",
  T_49_META_TYP_269_I7_D: "Mã số giày",
  T_49_META_TYP_272_I0_D: "Nữ",
  T_49_META_TYP_272_I1_D: "Nam",
  T_49_META_TYP_273_I0_D: "Tọa độ thế giới tương ứng với tâm của bản đồ nhỏ",
  T_49_META_TYP_273_I1_D: "Kích thước bản đồ nhỏ, chiều rộng và chiều cao đều giống nhau",
  T_49_META_TYP_273_I2_D: "Có nên bật chế độ hiển thị bản đồ độ sâu của bản đồ nhỏ không",
  T_49_META_TYP_274_I1_D: "Tỷ lệ",
  T_49_META_TYP_274_I4_D: "Mức hiển thị biểu tượng",
  T_49_META_TYP_275_I0_D: "Tỷ lệ xương",
  T_49_META_TYP_275_I1_D: "Tọa độ thế giới của nút xương",
  T_49_META_TYP_276_I0_D: "cái đầu",
  T_49_META_TYP_276_I1_D: "Cánh tay trái",
  T_49_META_TYP_276_I2_D: "Tay trái",
  T_49_META_TYP_276_I3_D: "Cánh tay phải",
  T_49_META_TYP_276_I4_D: "Bàn tay phải",
  T_49_META_TYP_276_I5_D: "Thân",
  T_49_META_TYP_276_I6_D: "Chân trái",
  T_49_META_TYP_276_I7_D: "Chân trái",
  T_49_META_TYP_276_I8_D: "Chân phải",
  T_49_META_TYP_276_I9_D: "Chân phải",
  T_49_META_TYP_277_I1_D: "Khoảng cách phát hiện tia camera",
  T_49_META_TYP_277_I2_D: "Mặt nạ lớp va chạm để phát hiện tia camera",
  T_49_META_TYP_277_I3_D: "Bù trừ vị trí nút",
  T_49_META_TYP_277_I4_D: "ID tài nguyên biểu tượng",
  T_49_META_TYP_277_I5_D: "Kích thước vùng nhấp chuột",
  T_49_META_TYP_277_I6_D: "Có hiển thị đối tượng tại điểm mục tiêu hay không",
  T_49_META_TYP_277_I7_D: "Đối tượng hiển thị điểm mục tiêu",
  T_49_META_TYP_278_I0_D: "Thực thể mục tiêu để tạo pixel bản đồ",
  T_49_META_TYP_28_I0_D: "Nó có thể được thiết lập lại sau mỗi vòng không?",
  T_49_META_TYP_280_I0_D: "Bán kính hình cầu",
  T_49_META_TYP_281_I0_D: "Bán kính của các bán cầu ở cả hai đầu của viên nang",
  T_49_META_TYP_29_I0_D: "Quả cầu",
  T_49_META_TYP_29_I1_D: "Cột sáng",
  T_49_META_TYP_29_I10_D: "Cột đèn ở lòng bàn chân hiện được sử dụng để phản hồi khi vào vạch đích",
  T_49_META_TYP_29_I11_D: "Đóng băng",
  T_49_META_TYP_29_I12_D: "Đèn",
  T_49_META_TYP_29_I13_D: "Luồng khí đi lên",
  T_49_META_TYP_29_I14_D: "Vụ nổ khí",
  T_49_META_TYP_29_I15_D: "Người tìm bị tiêu diệt",
  T_49_META_TYP_29_I16_D: "Rampage",
  T_49_META_TYP_29_I17_D: "Phân thân bị tiêu diệt",
  T_49_META_TYP_29_I18_D: "Phản hồi bắn",
  T_49_META_TYP_29_I19_D: "Phân thân bị tiêu diệt",
  T_49_META_TYP_29_I2_D: "Vòng tròn",
  T_49_META_TYP_29_I20_D: "Phân thân",
  T_49_META_TYP_29_I21_D: "Cổng dịch chuyển",
  T_49_META_TYP_29_I22_D: "Lựu khói choáng",
  T_49_META_TYP_29_I23_D: "Đạn lửa",
  T_49_META_TYP_29_I24_D: "Đốt cháy tuần hoàn",
  T_49_META_TYP_29_I25_D: "Khí độc",
  T_49_META_TYP_29_I26_D: "Nhịp Tim",
  T_49_META_TYP_29_I29_D: "Cửa",
  T_49_META_TYP_29_I30_D: "Pháo hoa",
  T_49_META_TYP_29_I31_D: "Hiệu ứng giày chạy",
  T_49_META_TYP_29_I32_D: "Hiệu ứng nổ",
  T_49_META_TYP_29_I33_D: "Hiệu ứng đặc biệt tại điểm hồi sinh",
  T_49_META_TYP_29_I34_D: "Hiệu ứng laser",
  T_49_META_TYP_29_I35_D: "Hiệu ứng kỹ năng",
  T_49_META_TYP_29_I36_D: "VFX tia đạn",
  T_49_META_TYP_29_I37_D: "Hiệu ứng trúng đạn",
  T_49_META_TYP_29_I38_D: "VFX bắn súng",
  T_49_META_TYP_29_I39_D: "Hiệu ứng kỹ năng",
  T_49_META_TYP_29_I40_D: "Vầng hào quang",
  T_49_META_TYP_29_I41_D: "bong bóng",
  T_49_META_TYP_29_I42_D: "Khói bụi",
  T_49_META_TYP_29_I43_D: "Đá bắn tung tóe",
  T_49_META_TYP_29_I44_D: "đường kẻ",
  T_49_META_TYP_29_I45_D: "Nhấp nháy",
  T_49_META_TYP_29_I47_D: "Hạt nổi lên",
  T_49_META_TYP_29_I48_D: "Khói",
  T_49_META_TYP_29_I49_D: "Bùa",
  T_49_META_TYP_29_I50_D: "Khu vực băng giá",
  T_49_META_TYP_29_I51_D: "Sương",
  T_49_META_TYP_29_I52_D: "Bông tuyết",
  T_49_META_TYP_29_I53_D: "Lửa",
  T_49_META_TYP_29_I54_D: "Tia sáng",
  T_49_META_TYP_29_I55_D: "Lan tỏa khí độc",
  T_49_META_TYP_29_I56_D: "Khí độc",
  T_49_META_TYP_29_I57_D: "Ánh sáng nổ tung",
  T_49_META_TYP_29_I58_D: "Hiệu ứng ánh sáng",
  T_49_META_TYP_29_I59_D: "Ngôi sao",
  T_49_META_TYP_29_I6_D: "Vầng hào quang dưới chân bạn",
  T_49_META_TYP_29_I60_D: "Đống lửa đang cháy",
  T_49_META_TYP_29_I61_D: "Nước bắn",
  T_49_META_TYP_29_I62_D: "Điện giật",
  T_49_META_TYP_29_I63_D: "VFX Mực",
  T_49_META_TYP_29_I64_D: "Hiệu ứng hố đen",
  T_49_META_TYP_29_I65_D: "Hiệu ứng nổ hố đen",
  T_49_META_TYP_29_I66_D: "Hiệu ứng quả cầu pha lê",
  T_49_META_TYP_29_I67_D: "Hiệu ứng đặc biệt của đạn laser",
  T_49_META_TYP_29_I68_D: "Hiệu ứng kéo theo",
  T_49_META_TYP_29_I69_D: "Hiệu ứng mây",
  T_49_META_TYP_29_I7_D: "Dấu vết trên mặt đất",
  T_49_META_TYP_29_I8_D: "Khói",
  T_49_META_TYP_29_I9_D: "Bùa phát nổ",
  T_49_META_TYP_290_I0_D: "Khoảng thời gian làm mới, số càng lớn thì tốc độ làm mới càng chậm, tính bằng mili giây",
  T_49_META_TYP_290_I1_D: "Có nên bật gỡ lỗi không",
  T_49_META_TYP_291_I0_D: "Nút điều kiện",
  T_49_META_TYP_291_I1_D: "Nút hành động",
  T_49_META_TYP_293_I0_D: "ID Cây hành vi",
  T_49_META_TYP_293_I1_D: "Mục tiêu đính kèm",
  T_49_META_TYP_294_I1_D: "Kiểu bố trí",
  T_49_META_TYP_294_I10_D: "Cách sắp xếp",
  T_49_META_TYP_294_I2_D: "Hướng ban đầu",
  T_49_META_TYP_294_I3_D: "Hướng sắp xếp",
  T_49_META_TYP_294_I4_D: "Chiều rộng và chiều cao của lưới mục con",
  T_49_META_TYP_294_I5_D: "Khoảng cách giữa các ô con",
  T_49_META_TYP_294_I6_D: "Giới hạn",
  T_49_META_TYP_294_I7_D: "Giới hạn số lượng",
  T_49_META_TYP_294_I8_D: "Độ lệch dọc",
  T_49_META_TYP_294_I9_D: "Độ lệch ngang",
  T_49_META_TYP_295_I2_D: "Tốc độ phát",
  T_49_META_TYP_296_I1_D: "Độ dài clip",
  T_49_META_TYP_297_I0_D: "Đối tượng bị ràng buộc",
  T_49_META_TYP_297_I4_D: "ID Tài nguyên",
  T_49_META_TYP_298_I0_D: "Mặc định",
  T_49_META_TYP_298_I2_D: "Một lần",
  T_49_META_TYP_30_I0_D: "Hình vuông",
  T_49_META_TYP_30_I1_D: "Tứ giác",
  T_49_META_TYP_30_I10_D: "Mũi tên",
  T_49_META_TYP_30_I11_D: "Đánh dấu",
  T_49_META_TYP_30_I12_D: "Đá",
  T_49_META_TYP_30_I13_D: "Kéo",
  T_49_META_TYP_30_I14_D: "Vải",
  T_49_META_TYP_30_I15_D: "Thích",
  T_49_META_TYP_30_I16_D: "Đối với",
  T_49_META_TYP_30_I17_D: "Sai",
  T_49_META_TYP_30_I18_D: "Thêm",
  T_49_META_TYP_30_I19_D: "tia chớp",
  T_49_META_TYP_30_I2_D: "Hình thang vuông",
  T_49_META_TYP_30_I20_D: "Trái tim",
  T_49_META_TYP_30_I21_D: "ngôi sao",
  T_49_META_TYP_30_I22_D: "Mặt trăng",
  T_49_META_TYP_30_I23_D: "Mặt trời",
  T_49_META_TYP_30_I24_D: "Kính mắt",
  T_49_META_TYP_30_I25_D: "Chìa khóa",
  T_49_META_TYP_30_I26_D: "Cúp",
  T_49_META_TYP_30_I27_D: "Cờ",
  T_49_META_TYP_30_I28_D: "Đồng hồ cát",
  T_49_META_TYP_30_I29_D: "Thư Mục",
  T_49_META_TYP_30_I3_D: "Hình thang",
  T_49_META_TYP_30_I30_D: "Thư mục đã mở",
  T_49_META_TYP_30_I31_D: "Nhà ở",
  T_49_META_TYP_30_I32_D: "Nghỉ Ngơi",
  T_49_META_TYP_30_I33_D: "Làm mới",
  T_49_META_TYP_30_I34_D: "Tuần hoàn",
  T_49_META_TYP_30_I35_D: "Kính lúp",
  T_49_META_TYP_30_I36_D: "Thùng rác",
  T_49_META_TYP_30_I37_D: "Quay lại",
  T_49_META_TYP_30_I38_D: "Kim cương",
  T_49_META_TYP_30_I39_D: "Phao bơi",
  T_49_META_TYP_30_I4_D: "Lục giác",
  T_49_META_TYP_30_I40_D: "Tiền",
  T_49_META_TYP_30_I41_D: "Khóa",
  T_49_META_TYP_30_I42_D: "Thiết lập",
  T_49_META_TYP_30_I43_D: "Thoát",
  T_49_META_TYP_30_I44_D: "Đối thoại",
  T_49_META_TYP_30_I45_D: "Tâm ngắm",
  T_49_META_TYP_30_I46_D: "súng",
  T_49_META_TYP_30_I47_D: "Kiếm",
  T_49_META_TYP_30_I48_D: "Nổ",
  T_49_META_TYP_30_I49_D: "Nhắm",
  T_49_META_TYP_30_I5_D: "Tròn",
  T_49_META_TYP_30_I50_D: "Thập tự",
  T_49_META_TYP_30_I51_D: "Phòng thủ",
  T_49_META_TYP_30_I52_D: "Xác sống",
  T_49_META_TYP_30_I53_D: "Tái chế",
  T_49_META_TYP_30_I54_D: "Quà tặng",
  T_49_META_TYP_30_I55_D: "Quần áo",
  T_49_META_TYP_30_I56_D: "Trò chơi",
  T_49_META_TYP_30_I57_D: "Người chơi",
  T_49_META_TYP_30_I58_D: "Cửa hàng",
  T_49_META_TYP_30_I59_D: "ra",
  T_49_META_TYP_30_I6_D: "Hình tam giác",
  T_49_META_TYP_30_I60_D: "Cảnh báo",
  T_49_META_TYP_30_I61_D: "Văn bản",
  T_49_META_TYP_30_I62_D: "Đối tượng hẹn giờ",
  T_49_META_TYP_30_I63_D: "Chuông gió",
  T_49_META_TYP_30_I64_D: "Trợ thủ",
  T_49_META_TYP_30_I65_D: "bom",
  T_49_META_TYP_30_I66_D: "Sửa chữa",
  T_49_META_TYP_30_I67_D: "Mặt cười",
  T_49_META_TYP_30_I68_D: "Loa",
  T_49_META_TYP_30_I7_D: "Dấu chấm than",
  T_49_META_TYP_30_I70_D: "Vương miện",
  T_49_META_TYP_30_I71_D: "Quyết đấu",
  T_49_META_TYP_30_I72_D: "Quân đoàn",
  T_49_META_TYP_30_I73_D: "Tim Đập",
  T_49_META_TYP_30_I74_D: "Âm nhạc",
  T_49_META_TYP_30_I75_D: "Phương tiện",
  T_49_META_TYP_30_I76_D: "Vũ khí cận chiến",
  T_49_META_TYP_30_I77_D: "Súng lục",
  T_49_META_TYP_30_I78_D: "Súng trường",
  T_49_META_TYP_30_I79_D: "Súng ngắm",
  T_49_META_TYP_30_I8_D: "Dấu chấm hỏi",
  T_49_META_TYP_30_I80_D: "Đạn Shotgun",
  T_49_META_TYP_30_I81_D: "Súng tiểu liên",
  T_49_META_TYP_30_I82_D: "Súng hồi máu",
  T_49_META_TYP_30_I83_D: "Phá Giáp",
  T_49_META_TYP_30_I84_D: "Headshot",
  T_49_META_TYP_30_I85_D: "Kỹ Năng 1",
  T_49_META_TYP_30_I86_D: "Kỹ năng 2",
  T_49_META_TYP_30_I87_D: "Kỹ năng 3",
  T_49_META_TYP_30_I88_D: "Kỹ năng 4",
  T_49_META_TYP_30_I89_D: "Kỹ năng 5",
  T_49_META_TYP_30_I9_D: "Đánh dấu",
  T_49_META_TYP_30_I90_D: "Kỹ năng 6",
  T_49_META_TYP_30_I91_D: "Kỹ năng 7",
  T_49_META_TYP_30_I92_D: "Kỹ năng 8",
  T_49_META_TYP_30_I93_D: "Kỹ năng 9",
  T_49_META_TYP_30_I94_D: "Kỹ năng 10",
  T_49_META_TYP_300_I0_D: "ID Tài nguyên",
  T_49_META_TYP_300_I2_D: "Xoay",
  T_49_META_TYP_300_I3_D: "Thực thể được tạo",
  T_49_META_TYP_301_I1_D: "Tự phát nổ",
  T_49_META_TYP_301_I2_D: "Lướt tấn công",
  T_49_META_TYP_301_I3_D: "Sóng xung kích",
  T_49_META_TYP_301_I4_D: "Xoáy kiếm",
  T_49_META_TYP_301_I5_D: "Nhảy chém",
  T_49_META_TYP_301_I6_D: "Tấn công giơ khiên",
  T_49_META_TYP_301_I7_D: "Tấn công phá khiên",
  T_49_META_TYP_302_I5_D: "Balo",
  T_49_META_TYP_302_I7_D: "Ván trượt, ngụy trang...",
  T_49_META_TYP_303_I0_D: "Thêm HP tối đa người chơi",
  T_49_META_TYP_303_I1_D: "Liên tục hồi HP cho người chơi",
  T_49_META_TYP_305_I0_D: "Hoàn thành",
  T_49_META_TYP_305_I1_D: "Đang chạy",
  T_49_META_TYP_307_I0_D: "Exp mỗi sát thương",
  T_49_META_TYP_307_I1_D: "Exp mỗi khoảng cách di chuyển",
  T_49_META_TYP_307_I2_D: "Exp mỗi giây",
  T_49_META_TYP_307_I3_D: "Chip kinh nghiệm máy tạo keo",
  T_49_META_TYP_307_I4_D: "Giới hạn số Bom Keo",
  T_49_META_TYP_308_I0_D: "Máy làm gel",
  T_49_META_TYP_31_I0_D: "Lựu đạn nổ",
  T_49_META_TYP_31_I1_D: "Tiếng súng",
  T_49_META_TYP_31_I10_D: "Hiệu ứng âm thanh gây sát thương",
  T_49_META_TYP_31_I11_D: "Hiệu ứng âm thanh được nâng cấp",
  T_49_META_TYP_31_I12_D: "Hiệu ứng âm thanh nhấp chuột yếu",
  T_49_META_TYP_31_I13_D: "Người chơi bước vào cơ chế hiệu ứng âm thanh",
  T_49_META_TYP_31_I14_D: "Hiệu ứng âm thanh sửa chữa thiết bị",
  T_49_META_TYP_31_I15_D: "Hiệu ứng âm thanh sửa chữa thiết bị",
  T_49_META_TYP_31_I16_D: "Hiệu ứng âm thanh bị lỗi hoặc bị thiếu",
  T_49_META_TYP_31_I17_D: "Hiệu ứng âm thanh nhắc nhở",
  T_49_META_TYP_31_I18_D: "Hiệu ứng âm thanh khi bóng đá tiếp đất",
  T_49_META_TYP_31_I19_D: "Hiệu ứng âm thanh cổ vũ",
  T_49_META_TYP_31_I2_D: "Tiếng tích tắc của đếm ngược",
  T_49_META_TYP_31_I20_D: "Hiệu ứng âm thanh cảnh báo bom",
  T_49_META_TYP_31_I21_D: "Hiệu ứng âm thanh bom nổ",
  T_49_META_TYP_31_I22_D: "Hiệu ứng âm thanh xuất hiện của thợ săn",
  T_49_META_TYP_31_I23_D: "Hiệu ứng âm thanh bgm cuối cùng",
  T_49_META_TYP_31_I24_D: "Hiệu ứng âm thanh làm mới hộp cung cấp",
  T_49_META_TYP_31_I25_D: "Hiệu ứng âm thanh tăng tốc",
  T_49_META_TYP_31_I26_D: "Hiệu ứng âm thanh nhắc nhở mất tích",
  T_49_META_TYP_31_I27_D: "Hiệu ứng hình ảnh hiệu ứng âm thanh",
  T_49_META_TYP_31_I28_D: "Hiệu ứng âm thanh côn trùng ban đêm",
  T_49_META_TYP_31_I29_D: "Hiệu ứng âm thanh đập mạnh",
  T_49_META_TYP_31_I3_D: "Nhấp vào giao diện",
  T_49_META_TYP_31_I30_D: "Hiệu ứng âm thanh phản hồi",
  T_49_META_TYP_31_I31_D: "Khám phá những hiệu ứng âm thanh đáng ngạc nhiên",
  T_49_META_TYP_31_I32_D: "Con ma nhỏ chơi hiệu ứng âm thanh",
  T_49_META_TYP_31_I33_D: "Hiệu ứng âm thanh bắt đầu pha",
  T_49_META_TYP_31_I34_D: "Hiệu ứng âm thanh của thây ma",
  T_49_META_TYP_31_I35_D: "Hiệu ứng âm thanh kinh dị",
  T_49_META_TYP_31_I36_D: "Hiệu ứng âm thanh biến đổi",
  T_49_META_TYP_31_I37_D: "Hiệu ứng âm thanh nhịp tim nhanh",
  T_49_META_TYP_31_I38_D: "Hiệu ứng âm thanh nhịp tim tốc độ trung bình",
  T_49_META_TYP_31_I39_D: "Hiệu ứng âm thanh nhịp tim chậm",
  T_49_META_TYP_31_I4_D: "Tiếng hét khi bị tấn công (nữ)",
  T_49_META_TYP_31_I40_D: "Hiệu ứng âm thanh Rage",
  T_49_META_TYP_31_I41_D: "Hiệu ứng âm thanh nhấp chuột",
  T_49_META_TYP_31_I42_D: "Hiệu ứng âm thanh phục hồi kỹ năng",
  T_49_META_TYP_31_I43_D: "Đã thêm hiệu ứng âm thanh trò chơi",
  T_49_META_TYP_31_I44_D: "Hiệu ứng âm thanh vang cơ học",
  T_49_META_TYP_31_I45_D: "Hiệu ứng âm thanh của muỗi",
  T_49_META_TYP_31_I46_D: "Hiệu ứng âm thanh Ding Ding Ding 1 mạnh mẽ",
  T_49_META_TYP_31_I47_D: "Hiệu ứng âm thanh Ding Ding Ding 2 chuyên sâu",
  T_49_META_TYP_31_I48_D: "Hiệu ứng âm thanh mở cơ chế",
  T_49_META_TYP_31_I49_D: "Hiệu ứng âm thanh sạc 1",
  T_49_META_TYP_31_I5_D: "Tiếng hét khi bị tấn công (nam)",
  T_49_META_TYP_31_I50_D: "Hiệu ứng âm thanh nhắc nhở tiếng bước chân",
  T_49_META_TYP_31_I51_D: "Lời nhắc thành công nhiệm vụ 1 hiệu ứng âm thanh",
  T_49_META_TYP_31_I52_D: "Âm thanh cảnh báo nguy hiểm 1 hiệu ứng âm thanh",
  T_49_META_TYP_31_I53_D: "Âm thanh cảnh báo nguy hiểm 2 hiệu ứng âm thanh",
  T_49_META_TYP_31_I54_D: "Hiệu ứng âm thanh đếm ngược 3",
  T_49_META_TYP_31_I55_D: "Hiển thị Mẹo hiệu ứng âm thanh",
  T_49_META_TYP_31_I56_D: "Hiệu ứng âm thanh xung quanh của tiếng quạ gọi",
  T_49_META_TYP_31_I57_D: "Hiệu ứng âm thanh khi dịch chuyển đến khu vực sai bằng cách sử dụng máy dịch chuyển",
  T_49_META_TYP_31_I58_D: "Hiệu ứng âm thanh khi dịch chuyển đến đúng khu vực bằng cách sử dụng điểm dịch chuyển",
  T_49_META_TYP_31_I59_D: "Truyền âm thanh",
  T_49_META_TYP_31_I6_D: "Hiệu ứng âm thanh nhặt đồng tiền vàng",
  T_49_META_TYP_31_I60_D: "Hiệu ứng âm thanh điện giật",
  T_49_META_TYP_31_I61_D: "Nhận hiệu ứng âm thanh đạo cụ",
  T_49_META_TYP_31_I62_D: "Hiệu ứng âm thanh nền nhạc điện tử dễ thương mơ mộng",
  T_49_META_TYP_31_I63_D: "Hiệu ứng âm thanh nhạc nền trò chơi thông thường",
  T_49_META_TYP_31_I64_D: "Hộp đã mở",
  T_49_META_TYP_31_I65_D: "Nâng cấp",
  T_49_META_TYP_31_I66_D: "Tối đa",
  T_49_META_TYP_31_I67_D: "Nhấp nút",
  T_49_META_TYP_31_I68_D: "Đếm ngược",
  T_49_META_TYP_31_I69_D: "Đánh bại kẻ địch",
  T_49_META_TYP_31_I7_D: "Kích hoạt hiệu ứng âm thanh khi vượt qua vạch đích trong cuộc đua",
  T_49_META_TYP_31_I70_D: "Kết thúc",
  T_49_META_TYP_31_I71_D: "Tiến lên",
  T_49_META_TYP_31_I72_D: "Chiến thắng",
  T_49_META_TYP_31_I73_D: "Điểm kiểm tra căn cứ huấn luyện",
  T_49_META_TYP_31_I74_D: "Đếm ngược",
  T_49_META_TYP_31_I75_D: "Bắt đầu trò chơi",
  T_49_META_TYP_31_I76_D: "Nhận Vàng lớn",
  T_49_META_TYP_31_I77_D: "Nhận Vàng",
  T_49_META_TYP_31_I78_D: "Nhận Vàng nhỏ",
  T_49_META_TYP_31_I79_D: "Tham gia trận chiến",
  T_49_META_TYP_31_I8_D: "Kích hoạt hiệu ứng âm thanh",
  T_49_META_TYP_31_I80_D: "Hộp quà quân đoàn",
  T_49_META_TYP_31_I81_D: "Loa",
  T_49_META_TYP_31_I82_D: "Bãi nhiệm Trưởng quân đoàn",
  T_49_META_TYP_31_I83_D: "Lưu trữ kho",
  T_49_META_TYP_31_I84_D: "Âm thanh súng đặc biệt",
  T_49_META_TYP_31_I85_D: "Đạn trúng mục tiêu",
  T_49_META_TYP_31_I86_D: "Di chuyển",
  T_49_META_TYP_31_I87_D: "Nhấp nút vô hiệu hóa",
  T_49_META_TYP_31_I88_D: "Kỹ năng sạc đầy",
  T_49_META_TYP_31_I89_D: "Kỹ năng laser",
  T_49_META_TYP_31_I9_D: "Hiệu ứng âm thanh bị suy giảm",
  T_49_META_TYP_31_I90_D: "Nhận vật phẩm 2",
  T_49_META_TYP_31_I91_D: "Đếm ngược 3",
  T_49_META_TYP_31_I92_D: "Kết thúc 2",
  T_49_META_TYP_31_I93_D: "Thông báo hạ gục",
  T_49_META_TYP_31_I94_D: "Nổ",
  T_49_META_TYP_31_I95_D: "Kỹ năng Cầu Năng Lượng",
  T_49_META_TYP_31_I96_D: "Kỹ năng hồ máu",
  T_49_META_TYP_311_I1_D: "Sát thương tối đa",
  T_49_META_TYP_311_I3_D: "Tốc độ bay của vật ném sau khi rời khỏi tay, tính bằng m/s",
  T_49_META_TYP_311_I4_D: "Khoảng thời gian từ khi vật ném được thả ra cho đến khi nó có hiệu lực, tính bằng giây",
  T_49_META_TYP_313_I0_D: "Bán kính khu vực",
  T_49_META_TYP_313_I1_D: "Thời gian của vùng phản công, tính bằng giây",
  T_49_META_TYP_314_I0_D: "ID tài nguyên bộ điều khiển hoạt hình",
  T_49_META_TYP_314_I1_D: "Điều khiển hoạt ảnh",
  T_49_META_TYP_315_I0_D: "Chủ sở hữu ba lô",
  T_49_META_TYP_315_I1_D: "Không gian ba lô",
  T_49_META_TYP_315_I2_D: "Dung lượng đã dùng",
  T_49_META_TYP_315_I3_D: "Tất cả tiếp tế",
  T_49_META_TYP_316_I0_D: "Tài nguyên lớp phủ",
  T_49_META_TYP_316_I1_D: "Tên đổ bóng",
  T_49_META_TYP_316_I11_D: "Phương pháp lật",
  T_49_META_TYP_316_I2_D: "Độ lệch UV",
  T_49_META_TYP_316_I3_D: "Chiều rộng và chiều cao UV",
  T_49_META_TYP_316_I4_D: "Kiểu điền",
  T_49_META_TYP_316_I5_D: "Biên trái phải",
  T_49_META_TYP_316_I6_D: "Biên trên dưới",
  T_49_META_TYP_317_I0_D: "Không",
  T_49_META_TYP_317_I1_D: "Khóa vị trí X",
  T_49_META_TYP_317_I2_D: "Khóa vị trí Y",
  T_49_META_TYP_317_I3_D: "Khóa vị trí Z",
  T_49_META_TYP_317_I4_D: "Giới hạn quay quanh trục X",
  T_49_META_TYP_317_I5_D: "Giới hạn quay quanh trục Y",
  T_49_META_TYP_317_I6_D: "Giới hạn quay quanh trục Z",
  T_49_META_TYP_317_I7_D: "Khóa vị trí",
  T_49_META_TYP_317_I8_D: "Khóa xoay",
  T_49_META_TYP_317_I9_D: "Khóa tất cả",
  T_49_META_TYP_318_I0_D: "Phạm vi",
  T_49_META_TYP_318_I1_D: "Khoảng cách gây sát thương tối đa",
  T_49_META_TYP_318_I10_D: "Hệ số tốc độ di chuyển khi bật ngắm",
  T_49_META_TYP_318_I11_D: "Tỉ lệ phóng đại tầm nhìn",
  T_49_META_TYP_318_I12_D: "Độ phóng đại FOV",
  T_49_META_TYP_318_I13_D: "Độ phóng đại của kính ngắm",
  T_49_META_TYP_318_I14_D: "Thời gian phóng đại của kính ngắm",
  T_49_META_TYP_318_I15_D: "Thời gian hồi phục kính ngắm",
  T_49_META_TYP_318_I16_D: "Hệ số hiệu chỉnh khoảng cách hư hỏng tối thiểu cho phạm vi",
  T_49_META_TYP_318_I17_D: "Cho phép hỗ trợ nhắm khi mở ống ngắm",
  T_49_META_TYP_318_I18_D: "Tỷ lệ kéo phạm vi màn hình tâm hỗ trợ nhắm (0-1)",
  T_49_META_TYP_318_I19_D: "Hệ số suy giảm khoảng cách hỗ trợ nhắm (0-1)",
  T_49_META_TYP_318_I2_D: "Khoảng cách sát thương tối thiểu",
  T_49_META_TYP_318_I20_D: "Cho phép ưu tiên khoảng cách hỗ trợ nhắm",
  T_49_META_TYP_318_I21_D: "Khoảng cách tối thiểu ưu tiên hỗ trợ nhắm",
  T_49_META_TYP_318_I22_D: "Khoảng cách tối đa ưu tiên hỗ trợ nhắm",
  T_49_META_TYP_318_I23_D: "Hệ số ưu tiên khoảng cách hỗ trợ nhắm (>=1)",
  T_49_META_TYP_318_I24_D: "Hệ số nhạy cảm xoay ADS",
  T_49_META_TYP_318_I25_D: "Tốc độ thu hẹp",
  T_49_META_TYP_318_I3_D: "Điều chỉnh số lượng băng đạn",
  T_49_META_TYP_318_I4_D: "Khoảng cách thời gian tấn công",
  T_49_META_TYP_318_I5_D: "Tốc độ thay đạn",
  T_49_META_TYP_318_I6_D: "Tốc độ thay đạn tự động",
  T_49_META_TYP_318_I7_D: "Tốc độ tán xạ",
  T_49_META_TYP_318_I8_D: "Tỷ lệ phân tán khi cúi xuống hoặc nằm xuống. Mỗi 0,1 có nghĩa là phạm vi ngắm tăng 10% cho mỗi viên đạn.",
  T_49_META_TYP_318_I9_D: "Ngưỡng tán xạ tối đa",
  T_49_META_TYP_319_I0_D: "Đơn giản",
  T_49_META_TYP_319_I1_D: "Bàn cờ 9 ô",
  T_49_META_TYP_319_I2_D: "Lát sàn",
  T_49_META_TYP_319_I3_D: "Điền đầy",
  T_49_META_TYP_319_I4_D: "Tự thích ứng",
  T_49_META_TYP_32_I0_D: "Người chơi đang ở trạng thái hoạt động bình thường",
  T_49_META_TYP_32_I1_D: "Người chơi đang trong trạng thái bị đánh gục",
  T_49_META_TYP_32_I2_D: "Người chơi đang ở trạng thái chết",
  T_49_META_TYP_320_I0_D: "Trình độ",
  T_49_META_TYP_320_I1_D: "Dọc",
  T_49_META_TYP_320_I2_D: "Hình quạt 90 độ",
  T_49_META_TYP_320_I3_D: "Hình quạt 180 độ",
  T_49_META_TYP_320_I4_D: "Hình quạt 360 độ",
  T_49_META_TYP_321_I0_D: "Khoảng cách tối đa để kích hoạt hỗ trợ ngắm",
  T_49_META_TYP_321_I1_D: "Độ lệch tâm ngắm khi chức năng ngắm hỗ trợ được kích hoạt. Nếu điểm lệch không nằm trong thực thể, chức năng ngắm hỗ trợ sẽ không thành công.",
  T_49_META_TYP_322_I0_D: "không có",
  T_49_META_TYP_322_I1_D: "cái đầu",
  T_49_META_TYP_322_I2_D: "Cơ Thể",
  T_49_META_TYP_322_I3_D: "Tứ chi",
  T_49_META_TYP_323_I0_D: "Thu phóng",
  T_49_META_TYP_323_I1_D: "ID Tài khoản",
  T_49_META_TYP_323_I2_D: "Thông tin hồ sơ người chơi",
  T_49_META_TYP_323_I3_D: "Kiểu",
  T_49_META_TYP_323_I4_D: "Hiển thị hạng",
  T_49_META_TYP_323_I5_D: "Hiển thị Pin",
  T_49_META_TYP_323_I6_D: "Hiển thị biệt danh",
  T_49_META_TYP_324_I0_D: "Tạo ra một lực có độ lớn xác định",
  T_49_META_TYP_324_I1_D: "Tạo ra gia tốc có độ lớn xác định",
  T_49_META_TYP_324_I2_D: "Tạo ra xung có kích thước xác định",
  T_49_META_TYP_324_I3_D: "Tạo ra tốc độ của kích thước được chỉ định",
  T_49_META_TYP_326_I0_D: "ID tài khoản",
  T_49_META_TYP_326_I1_D: "ID Ảnh đại diện",
  T_49_META_TYP_326_I2_D: "ID biểu ngữ",
  T_49_META_TYP_326_I3_D: "ID Pin",
  T_49_META_TYP_326_I4_D: "Biệt danh của người chơi",
  T_49_META_TYP_326_I5_D: "Hạng BR",
  T_49_META_TYP_326_I6_D: "Xếp hạng Sinh tồn cao nhất",
  T_49_META_TYP_326_I7_D: "Hạng tử chiến",
  T_49_META_TYP_326_I8_D: "Xếp hạng Tử Chiến cao nhất",
  T_49_META_TYP_327_I0_D: "ID tài nguyên",
  T_49_META_TYP_327_I1_D: "Mask thành phần 1",
  T_49_META_TYP_327_I2_D: "Mask thành phần 2",
  T_49_META_TYP_327_I3_D: "Mask thành phần 3",
  T_49_META_TYP_327_I4_D: "Mask thành phần 4",
  T_49_META_TYP_329_I0_D: "Người lái xe",
  T_49_META_TYP_329_I1_D: "Ghế hành khách 1",
  T_49_META_TYP_329_I2_D: "Ghế hành khách 2",
  T_49_META_TYP_329_I3_D: "Ghế hành khách 3",
  T_49_META_TYP_33_I0_D: "Theo thứ tự tăng dần, các giá trị bằng 0 sẽ bị bỏ qua và được sắp xếp cuối cùng.",
  T_49_META_TYP_33_I1_D: "Giảm dần, từ lớn đến nhỏ",
  T_49_META_TYP_33_I2_D: "Tăng dần, từ nhỏ đến lớn",
  T_49_META_TYP_330_I4_D: "Thời gian hiệu ứng bất khả chiến bại (đơn vị: s)",
  T_49_META_TYP_330_I5_D: "Điểm kiểm soát",
  T_49_META_TYP_330_I8_D: "Giá trị thay đổi",
  T_49_META_TYP_332_I0_D: "Có lặp lại không",
  T_49_META_TYP_333_I0_D: "FZLanTingHei",
  T_49_META_TYP_333_I1_D: "SimplifiedArabic",
  T_49_META_TYP_333_I2_D: "NotoNastaliqUrdu",
  T_49_META_TYP_333_I3_D: "GFFLatin",
  T_49_META_TYP_333_I4_D: "AgencyFB",
  T_49_META_TYP_333_I5_D: "Siêu thị",
  T_49_META_TYP_333_I6_D: "HindSiliguri",
  T_49_META_TYP_335_I0_D: "Đường dẫn tài nguyên, mặc định là trống",
  T_49_META_TYP_335_I1_D: "Số lần chơi, mặc định là 1",
  T_49_META_TYP_335_I2_D: "Âm lượng, mặc định là 50",
  T_49_META_TYP_335_I3_D: "Khoảng cách tối đa",
  T_49_META_TYP_335_I4_D: "Khoảng cách tối thiểu",
  T_49_META_TYP_335_I5_D: "Đây có phải là nhạc 3D không?",
  T_49_META_TYP_335_I6_D: "Ưu tiên",
  T_49_META_TYP_335_I7_D: "Thời gian chờ trước khi bắt đầu, tính bằng giây",
  T_49_META_TYP_335_I8_D: "Trạng thái phát",
  T_49_META_TYP_338_I0_D: "Trạng thái di động",
  T_49_META_TYP_338_I1_D: "Trạng thái chạy nước rút",
  T_49_META_TYP_338_I2_D: "Tình trạng tấn công",
  T_49_META_TYP_338_I3_D: "Trạng thái nhảy",
  T_49_META_TYP_338_I4_D: "Trạng thái leo núi",
  T_49_META_TYP_338_I5_D: "Nhập xe (lái xe)",
  T_49_META_TYP_338_I6_D: "Vào xe (hành khách)",
  T_49_META_TYP_338_I7_D: "Rời khỏi phương tiện",
  T_49_META_TYP_338_I8_D: "Lái Xe",
  T_49_META_TYP_339_I0_D: "Hệ số sát thương tay chân",
  T_49_META_TYP_339_I1_D: "Hệ số sát thương headshot",
  T_49_META_TYP_339_I2_D: "Hệ số giới hạn độ bền",
  T_49_META_TYP_339_I3_D: "Tỉ lệ HP bổ sung",
  T_49_META_TYP_339_I4_D: "Hệ số giảm thiệt hại do nổ bổ sung (%)",
  T_49_META_TYP_339_I5_D: "Sức chứa balo bổ sung",
  T_49_META_TYP_339_I6_D: "Ưu tiên thay thế",
  T_49_META_TYP_34_I0_D: "Nắm đấm mặc định",
  T_49_META_TYP_34_I1_D: "Kar98k",
  T_49_META_TYP_34_I10_D: "AWM2",
  T_49_META_TYP_34_I100_D: "Famas-I",
  T_49_META_TYP_34_I101_D: "Groza-X",
  T_49_META_TYP_34_I102_D: "SVD-Y",
  T_49_META_TYP_34_I103_D: "G36",
  T_49_META_TYP_34_I104_D: "M24",
  T_49_META_TYP_34_I105_D: "M4A1-I",
  T_49_META_TYP_34_I106_D: "M4A1-II",
  T_49_META_TYP_34_I107_D: "M4A1-III",
  T_49_META_TYP_34_I108_D: "M4A1-III",
  T_49_META_TYP_34_I109_D: "Súng săn nạp điện",
  T_49_META_TYP_34_I11_D: "M1014",
  T_49_META_TYP_34_I110_D: "MAC10",
  T_49_META_TYP_34_I111_D: "Súng cầm tay",
  T_49_META_TYP_34_I112_D: "Súng băng",
  T_49_META_TYP_34_I113_D: "Súng lá chắn",
  T_49_META_TYP_34_I114_D: "MP5-II",
  T_49_META_TYP_34_I115_D: "MP5-III",
  T_49_META_TYP_34_I116_D: "MP5-III",
  T_49_META_TYP_34_I117_D: "M60-II",
  T_49_META_TYP_34_I118_D: "M60-III",
  T_49_META_TYP_34_I119_D: "M60-III",
  T_49_META_TYP_34_I12_D: "M10142",
  T_49_META_TYP_34_I120_D: "VSS-II",
  T_49_META_TYP_34_I121_D: "VSS-III",
  T_49_META_TYP_34_I122_D: "M14-II",
  T_49_META_TYP_34_I123_D: "M14-III",
  T_49_META_TYP_34_I124_D: "M14-III",
  T_49_META_TYP_34_I125_D: "Kar98K-II",
  T_49_META_TYP_34_I126_D: "Kar98K-III",
  T_49_META_TYP_34_I127_D: "Kar98K-III",
  T_49_META_TYP_34_I128_D: "Famas-II",
  T_49_META_TYP_34_I129_D: "Famas-III",
  T_49_META_TYP_34_I13_D: "Lựu đạn lửa",
  T_49_META_TYP_34_I133_D: "Lựu choáng",
  T_49_META_TYP_34_I134_D: "Lựu đạn khói",
  T_49_META_TYP_34_I135_D: "Lựu choáng băng",
  T_49_META_TYP_34_I136_D: "Áo chống đạn Lv1",
  T_49_META_TYP_34_I137_D: "Áo chống đạn Lv2",
  T_49_META_TYP_34_I138_D: "Áo chống đạn Lv3",
  T_49_META_TYP_34_I139_D: "Mũ bảo hiểm Lv1",
  T_49_META_TYP_34_I14_D: "AK",
  T_49_META_TYP_34_I140_D: "Mũ bảo hiểm Lv2",
  T_49_META_TYP_34_I141_D: "Mũ bảo hiểm Lv3",
  T_49_META_TYP_34_I142_D: "Giáp chống cháy nổ",
  T_49_META_TYP_34_I143_D: "Balo Lv1",
  T_49_META_TYP_34_I144_D: "Balo Lv2",
  T_49_META_TYP_34_I145_D: "Balo Lv3",
  T_49_META_TYP_34_I146_D: "Nòng súng cấp độ 1",
  T_49_META_TYP_34_I147_D: "Nòng súng Lv2",
  T_49_META_TYP_34_I148_D: "Nòng súng Lv3",
  T_49_META_TYP_34_I149_D: "Bộ giảm thanh",
  T_49_META_TYP_34_I15_D: "AK2",
  T_49_META_TYP_34_I150_D: "Nòng súng tấn công",
  T_49_META_TYP_34_I151_D: "Mõm rộng",
  T_49_META_TYP_34_I152_D: "Tạp chí Lv1",
  T_49_META_TYP_34_I153_D: "Tạp chí Lv2",
  T_49_META_TYP_34_I154_D: "Tạp chí Lv3",
  T_49_META_TYP_34_I155_D: "Băng đạn đôi",
  T_49_META_TYP_34_I156_D: "Tạp chí Chain",
  T_49_META_TYP_34_I157_D: "Tay cầm Lv1",
  T_49_META_TYP_34_I158_D: "Tay cầm Lv2",
  T_49_META_TYP_34_I159_D: "Tay cầm Lv3",
  T_49_META_TYP_34_I16_D: "UMP",
  T_49_META_TYP_34_I160_D: "Chân đế gấp",
  T_49_META_TYP_34_I161_D: "Tay cầm súng trường Marksman",
  T_49_META_TYP_34_I162_D: "Báng súng ngắn",
  T_49_META_TYP_34_I163_D: "Báng súng bắn tỉa",
  T_49_META_TYP_34_I164_D: "Phạm vi hình ảnh nhiệt",
  T_49_META_TYP_34_I165_D: "Cổ phiếu Lv1",
  T_49_META_TYP_34_I166_D: "Cổ phiếu Lv2",
  T_49_META_TYP_34_I167_D: "Cổ phiếu Lv3",
  T_49_META_TYP_34_I168_D: "Bộ mở rộng lá chắn",
  T_49_META_TYP_34_I169_D: "Áo giáp toàn thân",
  T_49_META_TYP_34_I17_D: "UMP2",
  T_49_META_TYP_34_I170_D: "Lớp xen kẽ quá mức",
  T_49_META_TYP_34_I171_D: "Lớp xen kẽ chống cháy nổ",
  T_49_META_TYP_34_I172_D: "Mở rộng ba lô",
  T_49_META_TYP_34_I173_D: "Máy thở điều trị",
  T_49_META_TYP_34_I174_D: "Bộ hồi phục",
  T_49_META_TYP_34_I175_D: "Túi cứu thương",
  T_49_META_TYP_34_I176_D: "Bộ sửa chữa áo giáp",
  T_49_META_TYP_34_I177_D: "Tháp canh trí tuệ nhân tạo được làm từ vật liệu công nghệ cao sẽ chủ động tìm kiếm và tấn công kẻ thù trong phạm vi nhất định.",
  T_49_META_TYP_34_I178_D: "Nấm cấp độ 1",
  T_49_META_TYP_34_I179_D: "Nấm cấp độ 2",
  T_49_META_TYP_34_I18_D: "MP5",
  T_49_META_TYP_34_I180_D: "Nấm cấp độ 3",
  T_49_META_TYP_34_I181_D: "Nấm cấp độ 4",
  T_49_META_TYP_34_I182_D: "UAV cá nhân",
  T_49_META_TYP_34_I184_D: "Mỏ gần",
  T_49_META_TYP_34_I185_D: "Giày bay phản lực",
  T_49_META_TYP_34_I186_D: "Giày Bounce Power",
  T_49_META_TYP_34_I187_D: "dù lượn",
  T_49_META_TYP_34_I188_D: "Lựu đạn mồi nhử",
  T_49_META_TYP_34_I189_D: "Ván trượt từ tính",
  T_49_META_TYP_34_I19_D: "Đại bàng sa mạc",
  T_49_META_TYP_34_I190_D: "Kìm phá bom",
  T_49_META_TYP_34_I191_D: "Nâng cấp súng",
  T_49_META_TYP_34_I192_D: "Đạn Súng trường",
  T_49_META_TYP_34_I193_D: "Đạn súng lục",
  T_49_META_TYP_34_I194_D: "Đạn súng ngắm",
  T_49_META_TYP_34_I195_D: "Đạn súng Shotgun",
  T_49_META_TYP_34_I196_D: "Đạn súng tiểu liên",
  T_49_META_TYP_34_I197_D: "Mũi tên",
  T_49_META_TYP_34_I198_D: "Lựu đạn M79",
  T_49_META_TYP_34_I199_D: "Đạn phun lửa",
  T_49_META_TYP_34_I2_D: "Nỏ",
  T_49_META_TYP_34_I20_D: "G18",
  T_49_META_TYP_34_I200_D: "NÉM DAO2",
  T_49_META_TYP_34_I201_D: "Dây móc",
  T_49_META_TYP_34_I202_D: "Máy bắn bóng",
  T_49_META_TYP_34_I203_D: "quyền anh",
  T_49_META_TYP_34_I204_D: "Súng phun lửa",
  T_49_META_TYP_34_I205_D: "Thẻ Monkeygod",
  T_49_META_TYP_34_I206_D: "Thẻ MadeManA",
  T_49_META_TYP_34_I207_D: "Thẻ Djmale",
  T_49_META_TYP_34_I208_D: "Thẻ Graffitist",
  T_49_META_TYP_34_I209_D: "Thẻ thám tử",
  T_49_META_TYP_34_I21_D: "M14",
  T_49_META_TYP_34_I210_D: "Thẻ Giáo sư",
  T_49_META_TYP_34_I211_D: "Thẻ BountyHunter",
  T_49_META_TYP_34_I212_D: "Thẻ siêu sao",
  T_49_META_TYP_34_I213_D: "Thẻ Xtreme",
  T_49_META_TYP_34_I214_D: "MusicBroCard",
  T_49_META_TYP_34_I215_D: "Thẻ Kenta",
  T_49_META_TYP_34_I216_D: "Thẻ THEO DÕI",
  T_49_META_TYP_34_I217_D: "Thẻ Crazygirl",
  T_49_META_TYP_34_I218_D: "Thẻ RunSpeedUp",
  T_49_META_TYP_34_I219_D: "Thẻ Santino",
  T_49_META_TYP_34_I22_D: "SCAR",
  T_49_META_TYP_34_I220_D: "Thẻ nhân vật phản diện",
  T_49_META_TYP_34_I23_D: "SCAR",
  T_49_META_TYP_34_I24_D: "SCAR-I",
  T_49_META_TYP_34_I25_D: "SCAR-II",
  T_49_META_TYP_34_I26_D: "SCAR-III",
  T_49_META_TYP_34_I27_D: "M1014-I",
  T_49_META_TYP_34_I28_D: "M1014-II",
  T_49_META_TYP_34_I29_D: "M1014-III",
  T_49_META_TYP_34_I3_D: "Lá chắn bóng đá Loot",
  T_49_META_TYP_34_I30_D: "Súng năng lượng siêu nhiệt",
  T_49_META_TYP_34_I31_D: "Súng quá nhiệt-I",
  T_49_META_TYP_34_I32_D: "Súng siêu nhiệt-II",
  T_49_META_TYP_34_I33_D: "Súng siêu nhiệt-III",
  T_49_META_TYP_34_I34_D: "PLASMA-X",
  T_49_META_TYP_34_I35_D: "Súng chữa bệnh-Y",
  T_49_META_TYP_34_I36_D: "Xạ thủ chữa lành",
  T_49_META_TYP_34_I37_D: "Súng chữa bệnh",
  T_49_META_TYP_34_I38_D: "VSS",
  T_49_META_TYP_34_I39_D: "GROZA",
  T_49_META_TYP_34_I4_D: "FootballIce",
  T_49_META_TYP_34_I40_D: "GROZA",
  T_49_META_TYP_34_I41_D: "MP40",
  T_49_META_TYP_34_I42_D: "MP40",
  T_49_META_TYP_34_I43_D: "chảo rán",
  T_49_META_TYP_34_I44_D: "Dao rựa",
  T_49_META_TYP_34_I45_D: "SKS",
  T_49_META_TYP_34_I46_D: "M249",
  T_49_META_TYP_34_I47_D: "M249-X",
  T_49_META_TYP_34_I48_D: "M1873",
  T_49_META_TYP_34_I49_D: "M79",
  T_49_META_TYP_34_I5_D: "PP19",
  T_49_META_TYP_34_I50_D: "FAMAS",
  T_49_META_TYP_34_I51_D: "M500",
  T_49_META_TYP_34_I52_D: "SVD",
  T_49_META_TYP_34_I53_D: "SVD",
  T_49_META_TYP_34_I54_D: "AC80",
  T_49_META_TYP_34_I55_D: "Gậy bóng chày",
  T_49_META_TYP_34_I56_D: "XM8",
  T_49_META_TYP_34_I57_D: "XM8",
  T_49_META_TYP_34_I58_D: "SPAS12",
  T_49_META_TYP_34_I59_D: "SPAS12",
  T_49_META_TYP_34_I6_D: "VSK94",
  T_49_META_TYP_34_I60_D: "M60",
  T_49_META_TYP_34_I61_D: "MGL140",
  T_49_META_TYP_34_I62_D: "P90",
  T_49_META_TYP_34_I63_D: "P90",
  T_49_META_TYP_34_I64_D: "AN94",
  T_49_META_TYP_34_I65_D: "Kiếm Katana",
  T_49_META_TYP_34_I66_D: "CG15",
  T_49_META_TYP_34_I67_D: "RG550",
  T_49_META_TYP_34_I68_D: "Súng máy",
  T_49_META_TYP_34_I7_D: "M4A1",
  T_49_META_TYP_34_I70_D: "Súng móc mạnh mẽ",
  T_49_META_TYP_34_I71_D: "Dao FF",
  T_49_META_TYP_34_I72_D: "M1887",
  T_49_META_TYP_34_I73_D: "3 viên đạn 1887",
  T_49_META_TYP_34_I74_D: "M1887",
  T_49_META_TYP_34_I75_D: "THOMPSON",
  T_49_META_TYP_34_I76_D: "THOMPSON",
  T_49_META_TYP_34_I77_D: "M82B",
  T_49_META_TYP_34_I78_D: "M82B",
  T_49_META_TYP_34_I79_D: "AUG",
  T_49_META_TYP_34_I8_D: "USP",
  T_49_META_TYP_34_I80_D: "PARAFAL",
  T_49_META_TYP_34_I81_D: "PARAFAL",
  T_49_META_TYP_34_I82_D: "Chim gõ kiến",
  T_49_META_TYP_34_I83_D: "Vector",
  T_49_META_TYP_34_I84_D: "MAG-7",
  T_49_META_TYP_34_I85_D: "MAG-7",
  T_49_META_TYP_34_I86_D: "Lưỡi hái",
  T_49_META_TYP_34_I87_D: "Cái búa",
  T_49_META_TYP_34_I88_D: "Ném dao (nhặt)",
  T_49_META_TYP_34_I89_D: "Kord",
  T_49_META_TYP_34_I9_D: "AWM",
  T_49_META_TYP_34_I90_D: "M1917",
  T_49_META_TYP_34_I91_D: "USP-2",
  T_49_META_TYP_34_I92_D: "chim bói cá",
  T_49_META_TYP_34_I93_D: "UZI",
  T_49_META_TYP_34_I94_D: "MP5-I",
  T_49_META_TYP_34_I95_D: "M60-I",
  T_49_META_TYP_34_I96_D: "VSS-I",
  T_49_META_TYP_34_I97_D: "M14-I",
  T_49_META_TYP_34_I98_D: "Kar98K-I",
  T_49_META_TYP_34_I99_D: "AWM_Y",
  T_49_META_TYP_340_I0_D: "Dễ dàng",
  T_49_META_TYP_340_I1_D: "Đơn giản",
  T_49_META_TYP_340_I2_D: "Bình thường",
  T_49_META_TYP_340_I3_D: "Trung bình",
  T_49_META_TYP_340_I4_D: "Khó",
  T_49_META_TYP_340_I5_D: "Địa ngục",
  T_49_META_TYP_342_I0_D: "Sự kiện bắt đầu",
  T_49_META_TYP_342_I1_D: "Sự kiện dừng",
  T_49_META_TYP_342_I2_D: "Tạm dừng sự kiện",
  T_49_META_TYP_342_I3_D: "Phải đợi bao lâu sau khi được tạo để bắt đầu tính thời gian, tính bằng mili giây",
  T_49_META_TYP_342_I4_D: "Số lần lặp lại",
  T_49_META_TYP_342_I5_D: "Sự kiện",
  T_49_META_TYP_342_I6_D: "Đếm ngược hoặc đếm ngược",
  T_49_META_TYP_342_I7_D: "Trạng thái người chơi",
  T_49_META_TYP_342_I8_D: "Thời gian kết thúc của thời gian, tính bằng giây",
  T_49_META_TYP_345_I10_D: "Súng cầm tay",
  T_49_META_TYP_345_I12_D: "Súng tường băng",
  T_49_META_TYP_345_I13_D: "Súng phun lửa",
  T_49_META_TYP_345_I4_D: "Súng săn",
  T_49_META_TYP_345_I6_D: "Súng đặc biệt",
  T_49_META_TYP_345_I8_D: "Súng điện",
  T_49_META_TYP_346_I0_D: "Đạn Súng trường",
  T_49_META_TYP_346_I1_D: "Đạn súng lục",
  T_49_META_TYP_346_I2_D: "Đạn súng ngắm",
  T_49_META_TYP_346_I3_D: "Đạn súng Shotgun",
  T_49_META_TYP_346_I4_D: "Đạn súng tiểu liên",
  T_49_META_TYP_346_I5_D: "Mũi tên",
  T_49_META_TYP_346_I6_D: "Lựu đạn M79",
  T_49_META_TYP_346_I7_D: "Dây móc",
  T_49_META_TYP_346_I8_D: "Lựu đạn chuyên dụng M79",
  T_49_META_TYP_347_I3_D: "Khi đúng, nó có thể được kết hợp với chuyển động tương đối. Khi sai, nó phải được kết hợp với chuyển động tuyệt đối, nếu không thuộc tính sẽ không có hiệu lực chính xác.",
  T_49_META_TYP_347_I6_D: "Giá trị thay đổi",
  T_49_META_TYP_350_I0_D: "Siêu xe",
  T_49_META_TYP_350_I1_D: "Xe máy",
  T_49_META_TYP_350_I2_D: "Xe Jeep",
  T_49_META_TYP_350_I3_D: "SUV",
  T_49_META_TYP_350_I4_D: "Xe tải quái vật",
  T_49_META_TYP_350_I5_D: "Xe Tuk Tuk",
  T_49_META_TYP_352_I1_D: "Sprite chưa chọn",
  T_49_META_TYP_352_I2_D: "Không có loại hình ảnh nào được chọn",
  T_49_META_TYP_352_I3_D: "Màu Sprite chưa chọn",
  T_49_META_TYP_352_I4_D: "Hình ảnh được chọn",
  T_49_META_TYP_352_I5_D: "Chọn loại hình ảnh",
  T_49_META_TYP_352_I6_D: "Màu sắc được chọn",
  T_49_META_TYP_353_I0_D: "Lượng hồi HP",
  T_49_META_TYP_353_I1_D: "Tốc độ hồi HP",
  T_49_META_TYP_353_I2_D: "Thời gian cần (ms)",
  T_49_META_TYP_354_I0_D: "Lượng hồi EP",
  T_49_META_TYP_355_I0_D: "Lượng hồi HP",
  T_49_META_TYP_355_I1_D: "Lượng hồi EP",
  T_49_META_TYP_355_I2_D: "Thời gian cần (ms)",
  T_49_META_TYP_356_I0_D: "Vật phẩm rơi",
  T_49_META_TYP_356_I1_D: "Thời gian thả hộp Airdrop ms",
  T_49_META_TYP_356_I2_D: "Trạng thái thính rơi",
  T_49_META_TYP_357_I0_D: "Bề mặt",
  T_49_META_TYP_357_I1_D: "ranh giới",
  T_49_META_TYP_359_I0_D: "Có nên sử dụng bộ điều khiển của người chơi với vật lý không",
  T_49_META_TYP_359_I1_D: "Nếu đặt trên một độ dốc vượt quá góc này, nó sẽ trượt xuống dưới",
  T_49_META_TYP_359_I10_D: "Gia tốc trọng trường này chỉ áp dụng cho bộ điều khiển của người chơi.",
  T_49_META_TYP_359_I11_D: "Khối lượng, kg",
  T_49_META_TYP_359_I12_D: "Nếu độ dốc vượt quá góc lên dốc tối đa, xe sẽ trượt xuống.",
  T_49_META_TYP_359_I16_D: "Sau khi mở, các nguyên hàm hoặc tập lệnh phía máy chủ sẽ điều khiển chuyển động",
  T_49_META_TYP_359_I17_D: "Khi được bật, lực tác dụng của nhân vật khi đẩy vật thể cứng có thể được tùy chỉnh",
  T_49_META_TYP_359_I18_D: "Lượng lực tác dụng khi nhân vật đẩy vật rắn",
  T_49_META_TYP_359_I19_D: "Đúng khi phần dưới chạm vào máy va chạm, thường được sử dụng để xác định xem người chơi có ở trên mặt đất hay không",
  T_49_META_TYP_359_I2_D: "Chỉ những chướng ngại vật vượt quá chiều cao này mới có tác dụng chặn. Phạm vi giá trị là [0, Chiều cao]",
  T_49_META_TYP_359_I20_D: "Mức vật lý tùy chỉnh, giá trị [0,15]",
  T_49_META_TYP_359_I21_D: "Bật xoay theo trọng lực",
  T_49_META_TYP_359_I3_D: "Độ sâu của viên nang có thể được nhúng vào. Nó có thể ngăn nhân vật bị kẹt hoặc rung lắc. Không nên sửa đổi trừ khi có nhu cầu đặc biệt. Phạm vi giá trị (0, Bán kính]",
  T_49_META_TYP_359_I4_D: "Khoảng cách di chuyển tối thiểu. Các di chuyển nhỏ hơn giá trị này sẽ không được thực hiện. Nếu không có nhu cầu đặc biệt thì nên giữ nguyên là 0",
  T_49_META_TYP_359_I5_D: "Độ lệch của tâm hộp va chạm so với gốc tọa độ cục bộ",
  T_49_META_TYP_359_I6_D: "Bán kính của viên nang, giá trị tối thiểu là 0,01",
  T_49_META_TYP_359_I7_D: "Tổng chiều cao của viên nang, bao gồm cả bán cầu trên và dưới, với giá trị tối thiểu là 2*Bán kính",
  T_49_META_TYP_359_I8_D: "Tốc độ tuyến tính hiện tại, tính bằng m/s",
  T_49_META_TYP_360_I0_D: "Góc bắn bên trái",
  T_49_META_TYP_360_I1_D: "Góc bắn bên phải",
  T_49_META_TYP_360_I2_D: "Góc ngẩng lên tối thiểu",
  T_49_META_TYP_360_I3_D: "Góc cúi xuống tối đa",
  T_49_META_TYP_360_I4_D: "Tốc độ nòng súng",
  T_49_META_TYP_362_I0_D: "Thời gian đóng băng sau khi đánh vào người chơi, tính bằng giây",
  T_49_META_TYP_363_I0_D: "Vô hiệu hóa yêu cầu mua HUD",
  T_49_META_TYP_363_I1_D: "Yêu cầu nhóm giúp đỡ trong việc mua hàng",
  T_49_META_TYP_363_I2_D: "Yêu cầu phe phái giúp đỡ trong việc mua sắm",
  T_49_META_TYP_364_I0_D: "Có phải là trung điểm không",
  T_49_META_TYP_364_I1_D: "Có lặp lại hay không",
  T_49_META_TYP_364_I2_D: "Tên hoạt hình",
  T_49_META_TYP_364_I3_D: "Có nên chơi tự động không",
  T_49_META_TYP_364_I4_D: "Có sử dụng tài nguyên tùy chỉnh không",
  T_49_META_TYP_366_I0_D: "Chỉ định UUID của tài nguyên Batch sẽ được hiển thị",
  T_49_META_TYP_367_I1_D: "Hiển thị nhãn",
  T_49_META_TYP_367_I2_D: "Kiểu biểu tượng để đánh dấu mục tiêu",
  T_49_META_TYP_367_I3_D: "Màu phủ của biểu tượng được hiển thị khi đánh dấu mục tiêu",
  T_49_META_TYP_367_I4_D: "Kiểu biểu tượng được hiển thị trên thang đo",
  T_49_META_TYP_367_I5_D: "Màu phủ biểu tượng hiển thị trên thang đo",
  T_49_META_TYP_367_I6_D: "Luôn hiển thị trên thước đo",
  T_49_META_TYP_370_I0_D: "Tiêu đề chính",
  T_49_META_TYP_370_I1_D: "Phụ đề",
  T_49_META_TYP_370_I2_D: "Màu nền trên cùng",
  T_49_META_TYP_370_I3_D: "Màu nền bên dưới",
  T_49_META_TYP_371_I2_D: "Điểm số bên trái",
  T_49_META_TYP_371_I3_D: "Điểm bên phải",
  T_49_META_TYP_371_I4_D: "Điểm cuối cùng bên trái, được sử dụng để phát hoạt ảnh chuyển điểm",
  T_49_META_TYP_371_I5_D: "Điểm cuối cùng bên phải được sử dụng để phát hoạt ảnh chuyển đổi điểm",
  T_49_META_TYP_372_I0_D: "Đứng",
  T_49_META_TYP_372_I1_D: "Hiển thị nút ngồi",
  T_49_META_TYP_372_I10_D: "Rơi ở độ cao lớn",
  T_49_META_TYP_372_I11_D: "Ngã từ độ cao thấp, chẳng hạn như nhảy",
  T_49_META_TYP_372_I12_D: "Giày bay",
  T_49_META_TYP_372_I13_D: "Nhảy đôi",
  T_49_META_TYP_372_I14_D: "Ngồi trên ghế",
  T_49_META_TYP_372_I15_D: "Bị đẩy ra bởi một máy bắn đá",
  T_49_META_TYP_372_I16_D: "Giai đoạn chuẩn bị máy bắn đá",
  T_49_META_TYP_372_I17_D: "Đạo cụ lướt",
  T_49_META_TYP_372_I18_D: "Thả chân vịt lướt",
  T_49_META_TYP_372_I19_D: "Bị lốp xe nảy lên",
  T_49_META_TYP_372_I2_D: "đang chạy",
  T_49_META_TYP_372_I20_D: "Bị lốp xe của con người đẩy bật lên",
  T_49_META_TYP_372_I21_D: "Một hành động trong khu vực tiệc",
  T_49_META_TYP_372_I22_D: "Lấy một chiếc máy bay",
  T_49_META_TYP_372_I23_D: "Nhập khẩu pháo",
  T_49_META_TYP_372_I24_D: "Khi thoát khỏi pháo, xe cộ, v.v., nếu vật thể bạn đang cưỡi đang bay, thì đây là trạng thái",
  T_49_META_TYP_372_I25_D: "Sau khi nhảy khỏi ván nhảy",
  T_49_META_TYP_372_I26_D: "Hãy ra khỏi đường trượt zipline",
  T_49_META_TYP_372_I27_D: "Không sử dụng",
  T_49_META_TYP_372_I3_D: "bò",
  T_49_META_TYP_372_I4_D: "Bơi nhanh",
  T_49_META_TYP_372_I5_D: "thả theo chiều dọc",
  T_49_META_TYP_372_I6_D: "Qua Bức Tường",
  T_49_META_TYP_372_I7_D: "Không sử dụng",
  T_49_META_TYP_372_I8_D: "Bị đánh ngã nhưng không chết",
  T_49_META_TYP_372_I9_D: "Sử dụng bảng nước",
  T_49_META_TYP_374_I0_D: "Màu sắc sức khỏe, cấp độ và nét vẽ",
  T_49_META_TYP_374_I1_D: "Khi sức khỏe giảm, phần bị mất sẽ hiển thị màu này trong giây lát",
  T_49_META_TYP_374_I10_D: "Bù trừ so với mục tiêu cần theo dõi",
  T_49_META_TYP_374_I11_D: "Giá trị sức khỏe giữa hai đường phân chia sẽ không được hiển thị nếu nó nhỏ hơn hoặc bằng 0",
  T_49_META_TYP_374_I12_D: "Tổng lượng HP",
  T_49_META_TYP_374_I13_D: "Lượng HP hiện tại",
  T_49_META_TYP_374_I14_D: "Khi được bật, những thay đổi về sức khỏe sẽ được hiển thị bằng nhiều màu sắc khác nhau",
  T_49_META_TYP_374_I15_D: "Khi được bật, các thuộc tính bù trừ sẽ được chuyển đổi sang tọa độ thế giới bằng hệ tọa độ cục bộ.",
  T_49_META_TYP_374_I2_D: "Khi sức khỏe tăng lên, phần tăng lên sẽ hiển thị màu này trong giây lát",
  T_49_META_TYP_374_I3_D: "Màu sắc của đường viền sức khỏe và phần dưới mờ",
  T_49_META_TYP_374_I4_D: "Phạm vi 0~1, độ trong suốt của toàn bộ UI",
  T_49_META_TYP_374_I5_D: "Xác định tỷ lệ UI tổng thể và các phông chữ được chia tỷ lệ với nhau",
  T_49_META_TYP_374_I6_D: "Chỉ ra tên của chủ sở hữu thanh sức khỏe hiện tại",
  T_49_META_TYP_374_I8_D: "Chiều dài của thanh sức khỏe hiển thị trên màn hình",
  T_49_META_TYP_374_I9_D: "Phải theo sau một thực thể có thành phần Biến đổi",
  T_49_META_TYP_375_I1_D: "Thực thể chiến đấu",
  T_49_META_TYP_376_I1_D: "Thực thể chiến đấu",
  T_49_META_TYP_38_I0_D: "Alpha",
  T_49_META_TYP_382_I0_D: "mặc định",
  T_49_META_TYP_382_I1_D: "Bỏ qua trạng thái hạ gục và chết trực tiếp",
  T_49_META_TYP_382_I2_D: "Không bỏ qua hạ gục",
  T_49_META_TYP_387_I1_D: "Cho phép kích hoạt ngoài khu vực",
  T_49_META_TYP_389_I0_D: "Độ lệch mặc định của cơ sở",
  T_49_META_TYP_389_I1_D: "Sprite",
  T_49_META_TYP_389_I10_D: "Alpha chưa kích hoạt",
  T_49_META_TYP_389_I2_D: "Bán kính nền",
  T_49_META_TYP_389_I3_D: "Hình ảnh cần điều khiển",
  T_49_META_TYP_389_I4_D: "Bán kính cần điều khiển",
  T_49_META_TYP_389_I5_D: "Bán kính kéo cần điều khiển",
  T_49_META_TYP_389_I6_D: "Hình ảnh mũi tên chỉ hướng",
  T_49_META_TYP_389_I7_D: "Kích thước mũi tên chỉ hướng",
  T_49_META_TYP_389_I8_D: "Độ lệch mũi tên chỉ hướng",
  T_49_META_TYP_389_I9_D: "Kích hoạt Alpha",
  T_49_META_TYP_39_I1_D: "Hình dạng Sprite",
  T_49_META_TYP_39_I10_D: "Gradient trên",
  T_49_META_TYP_39_I11_D: "Gradient dưới",
  T_49_META_TYP_39_I12_D: "Độ trong suốt trên",
  T_49_META_TYP_39_I13_D: "Độ trong suốt nền",
  T_49_META_TYP_39_I3_D: "Lật",
  T_49_META_TYP_39_I4_D: "Điền đầy",
  T_49_META_TYP_39_I5_D: "Trung tâm bản đồ không thể nhìn thấy",
  T_49_META_TYP_39_I6_D: "Hướng điền",
  T_49_META_TYP_39_I7_D: "Giá trị điền vào",
  T_49_META_TYP_39_I8_D: "Điền ngược",
  T_49_META_TYP_39_I9_D: "Gradient",
  T_49_META_TYP_392_I0_D: "Thời gian vùng an toàn xuất hiện trong mỗi vòng trong trò chơi, giá trị mặc định là 0, đơn vị là ms",
  T_49_META_TYP_392_I1_D: "Thời gian cần thiết để thu nhỏ vòng tròn, tính bằng ms",
  T_49_META_TYP_392_I10_D: "Thời gian kết thúc của vòng tròn thu hẹp, tính bằng ms",
  T_49_META_TYP_392_I12_D: "Bán kính cuối vòng tròn độc",
  T_49_META_TYP_392_I13_D: "Thời gian bắt đầu thu bo",
  T_49_META_TYP_392_I14_D: "Khoảng sát thương (ms)",
  T_49_META_TYP_392_I3_D: "Lượng sát thương gây ra cho người chơi trong vòng tròn độc.",
  T_49_META_TYP_392_I4_D: "Danh sách người chơi trong vùng an toàn",
  T_49_META_TYP_392_I5_D: "Thời gian biến mất của vùng an toàn. Nếu thời gian biến mất của vùng an toàn nhỏ hơn thời gian có hiệu lực, sẽ không có vùng an toàn nào được tạo ra.",
  T_49_META_TYP_392_I6_D: "GroupID",
  T_49_META_TYP_392_I7_D: "Bán kính bắt đầu của vòng tròn độc",
  T_49_META_TYP_392_I8_D: "Trạng thái kết thúc",
  T_49_META_TYP_392_I9_D: "Trạng thái",
  T_49_META_TYP_394_I0_D: "Giá trị khoảng 3,1416",
  T_49_META_TYP_394_I1_D: "Giá trị khoảng 2,7183",
  T_49_META_TYP_396_I0_D: "Tiêu đề",
  T_49_META_TYP_396_I1_D: "Nội dung",
  T_49_META_TYP_396_I2_D: "Tùy chọn",
  T_49_META_TYP_396_I3_D: "Hiển thị nền",
  T_49_META_TYP_399_I0_D: "Độ cao nhảy",
  T_49_META_TYP_399_I1_D: "Số lần nhảy liên tiếp bạn có thể thực hiện trước khi hạ cánh",
  T_49_META_TYP_399_I2_D: "Bạn có thể thực hiện nhiều cú nhảy trước khi hạ cánh.",
  T_49_META_TYP_399_I3_D: "Bật di chuyển trên không",
  T_49_META_TYP_40_I1_D: "Nhãn",
  T_49_META_TYP_40_I10_D: "Khoảng cách dòng",
  T_49_META_TYP_40_I11_D: "Phương pháp tràn",
  T_49_META_TYP_40_I12_D: "Kiểu phông chữ",
  T_49_META_TYP_40_I13_D: "Có áp dụng bóng không",
  T_49_META_TYP_40_I14_D: "Màu đổ bóng",
  T_49_META_TYP_40_I15_D: "Độ lệch đổ bóng",
  T_49_META_TYP_40_I3_D: "Khóa bản địa hóa, có thể sử dụng ở nhiều ngôn ngữ",
  T_49_META_TYP_40_I5_D: "Căn chỉnh",
  T_49_META_TYP_40_I6_D: "Căn chỉnh dọc",
  T_49_META_TYP_40_I7_D: "Có in đậm không",
  T_49_META_TYP_40_I8_D: "Có in nghiên không",
  T_49_META_TYP_40_I9_D: "Có gạch dưới không",
  T_49_META_TYP_400_I0_D: "Tấn công chủ động",
  T_49_META_TYP_400_I1_D: "Bị động",
  T_49_META_TYP_400_I2_D: "Không tấn công",
  T_49_META_TYP_401_I0_D: "Không thể bắn",
  T_49_META_TYP_401_I1_D: "Có thể bắn liên tục",
  T_49_META_TYP_401_I2_D: "Bắn một lần cho mỗi lệnh tấn công",
  T_49_META_TYP_401_I3_D: "Mỗi lệnh tấn công bắn ba lần",
  T_49_META_TYP_401_I4_D: "Mỗi lệnh tấn công bắn hai lần",
  T_49_META_TYP_401_I5_D: "Đạn",
  T_49_META_TYP_402_I0_D: "Mục tiêu để thêm làm bạn bè",
  T_49_META_TYP_402_I1_D: "Loại chức năng",
  T_49_META_TYP_402_I2_D: "Kiểu",
  T_49_META_TYP_403_I0_D: "Thêm bạn",
  T_49_META_TYP_403_I1_D: "Báo Cáo",
  T_49_META_TYP_404_I0_D: "Ánh sáng",
  T_49_META_TYP_404_I1_D: "Màu tối",
  T_49_META_TYP_405_I0_D: "Theo cấu trúc phân cấp",
  T_49_META_TYP_405_I1_D: "Theo thứ tự ưu tiên từ cao đến thấp",
  T_49_META_TYP_405_I2_D: "Theo thứ tự ưu tiên từ thấp đến cao",
  T_49_META_TYP_406_I0_D: "Kiểm soát khoảng cách nhảy của người chơi",
  T_49_META_TYP_406_I1_D: "Kiểm soát chiều cao của cơ thể người chơi khi leo lên và xuống",
  T_49_META_TYP_407_I0_D: "Nội địa",
  T_49_META_TYP_407_I1_D: "Ứng dụng",
  T_49_META_TYP_407_I2_D: "Máy chủ",
  T_49_META_TYP_407_I3_D: "Hai đầu",
  T_49_META_TYP_409_I0_D: "Không có lỗi",
  T_49_META_TYP_409_I1_D: "Hết thời gian lưu trữ dữ liệu, chủ yếu cho các hoạt động đọc",
  T_49_META_TYP_409_I10_D: "Thay đổi nhóm không thành công - Nhóm mục tiêu không hợp lệ",
  T_49_META_TYP_409_I11_D: "Thay đổi đội không thành công - Người chơi đã chết không được phép thay đổi đội",
  T_49_META_TYP_409_I12_D: "Thay đổi đội không thành công - Không được phép thay đổi đội trên xe",
  T_49_META_TYP_409_I2_D: "Tần suất đọc và ghi lưu trữ dữ liệu vượt quá giới hạn",
  T_49_META_TYP_409_I3_D: "Bất thường về tham số",
  T_49_META_TYP_409_I4_D: "Không tạo được phòng: Không có PersonaID hợp lệ",
  T_49_META_TYP_409_I5_D: "Trạng thái lỗi chưa xác định",
  T_49_META_TYP_409_I6_D: "Các dịch vụ thương mại đã đóng và người dùng không còn có thể sử dụng các dịch vụ của nhà phát triển",
  T_49_META_TYP_409_I7_D: "Thay đổi nhóm không thành công - chế độ không được hỗ trợ",
  T_49_META_TYP_409_I8_D: "Thay đổi nhóm không thành công - hiện tại đã có trong nhóm mục tiêu",
  T_49_META_TYP_409_I9_D: "Thay đổi nhóm không thành công - đối tượng không hợp lệ",
  T_49_META_TYP_41_I0_D: "Hình dạng Sprite",
  T_49_META_TYP_41_I19_D: "Vô hiệu hóa hộp va chạm",
  T_49_META_TYP_41_I3_D: "Màu bị cấm",
  T_49_META_TYP_41_I4_D: "Màu khi nhấn",
  T_49_META_TYP_41_I5_D: "Kiểu điền",
  T_49_META_TYP_41_I6_D: "Có phải nút FE không",
  T_49_META_TYP_41_I7_D: "Hình ảnh khi nhấn",
  T_49_META_TYP_41_I8_D: "Loại hình ảnh khi nhấn",
  T_49_META_TYP_41_I9_D: "Kiểu lật",
  T_49_META_TYP_411_I0_D: "Tốc độ tiến lên (Lực)",
  T_49_META_TYP_411_I1_D: "Tốc độ lùi (lực)",
  T_49_META_TYP_411_I2_D: "Tốc độ lên (lực)",
  T_49_META_TYP_411_I3_D: "Tốc độ rơi",
  T_49_META_TYP_411_I4_D: "ST lựu đạn tối thiểu",
  T_49_META_TYP_411_I5_D: "ST lựu đạn tối đa",
  T_49_META_TYP_411_I6_D: "Phạm vi lựu đạn",
  T_49_META_TYP_412_I0_D: "Lượng mã lực mà xe đạt được khi sử dụng nút ga",
  T_49_META_TYP_412_I1_D: "Lượng mã lực mà xe đạt được khi sử dụng nút lùi/phanh",
  T_49_META_TYP_412_I2_D: "Ở tốc độ cao, góc lái tối đa",
  T_49_META_TYP_412_I3_D: "Ngưỡng tốc độ cho ứng dụng góc lái tối đa tốc độ cao",
  T_49_META_TYP_412_I4_D: "Sau khi đạt tốc độ tối đa, xe sẽ không cung cấp thêm mã lực nữa, nhưng xe có thể vượt quá tốc độ tối đa này (ví dụ như khi xuống dốc)",
  T_49_META_TYP_412_I5_D: "Khi xe không được điều khiển, xe sẽ giảm tốc bằng cách nhân IdleBrakeInput với BrakeTorque",
  T_49_META_TYP_412_I6_D: "Được sử dụng để tính toán thiệt hại khi đánh người, sử dụng các thông số của công thức sát thương",
  T_49_META_TYP_412_I7_D: "Dùng để tính toán sát thương khi đánh người. Sau khi vượt quá tốc độ này, sát thương sẽ không tăng thêm.",
  T_49_META_TYP_412_I8_D: "Được sử dụng để tính toán thiệt hại do va chạm, thiệt hại tối thiểu",
  T_49_META_TYP_412_I9_D: "Được sử dụng để tính toán thiệt hại do va chạm, thiệt hại tối đa",
  T_49_META_TYP_413_I0_D: "Người chơi (NPC) biến đổi quần áo",
  T_49_META_TYP_414_I1_D: "Phạm vi rộng",
  T_49_META_TYP_415_I0_D: "ID nhân dạng",
  T_49_META_TYP_415_I1_D: "Biệt danh",
  T_49_META_TYP_415_I2_D: "Ảnh đại diện",
  T_49_META_TYP_416_I1_D: "Persona bị ràng buộc",
  T_49_META_TYP_416_I2_D: "Bù lại",
  T_49_META_TYP_416_I3_D: "Độ cao",
  T_49_META_TYP_416_I4_D: "Có nên trả lời tin nhắn hệ thống không",
  T_49_META_TYP_416_I5_D: "Biệt danh của Persona",
  T_49_META_TYP_416_I6_D: "Nhân vật Avatar",
  T_49_META_TYP_416_I7_D: "Biệt danh người dùng",
  T_49_META_TYP_416_I8_D: "Avatar người dùng",
  T_49_META_TYP_417_I0_D: "ID tài nguyên",
  T_49_META_TYP_418_I0_D: "Hết hạn tư cách thành viên",
  T_49_META_TYP_418_I1_D: "Trở thành thành viên",
  T_49_META_TYP_418_I2_D: "Gia hạn tư cách thành viên",
  T_49_META_TYP_42_I0_D: "Văn bản mặc định",
  T_49_META_TYP_42_I1_D: "Kích hoạt văn bản",
  T_49_META_TYP_42_I10_D: "Chiều dài tối đa",
  T_49_META_TYP_42_I14_D: "Màu khi nhấn",
  T_49_META_TYP_42_I16_D: "Khóa bản địa hóa, có thể sử dụng ở nhiều ngôn ngữ",
  T_49_META_TYP_42_I3_D: "Căn chỉnh",
  T_49_META_TYP_42_I4_D: "Căn chỉnh dọc",
  T_49_META_TYP_42_I5_D: "Có in đậm không",
  T_49_META_TYP_42_I6_D: "Có in nghiên không",
  T_49_META_TYP_42_I7_D: "Có gạch dưới không",
  T_49_META_TYP_42_I8_D: "Khoảng cách dòng",
  T_49_META_TYP_42_I9_D: "Tự động xuống dòng",
  T_49_META_TYP_424_I0_D: "Hiệu ứng sương mù tuyến tính",
  T_49_META_TYP_424_I1_D: "Hiệu ứng sương mù chỉ số",
  T_49_META_TYP_424_I2_D: "Hiệu ứng sương mù vuông theo cấp số nhân",
  T_49_META_TYP_426_I0_D: "Cường độ ánh sáng",
  T_49_META_TYP_426_I1_D: "Phạm vi chiếu sáng",
  T_49_META_TYP_426_I2_D: "Góc của hình nón đèn pha tính bằng độ",
  T_49_META_TYP_426_I3_D: "Màu sáng",
  T_49_META_TYP_428_I0_D: "ID Skin súng của người chơi",
  T_49_META_TYP_428_I2_D: "Đặt ID",
  T_49_META_TYP_428_I3_D: "ID mũ đội đầu",
  T_49_META_TYP_428_I4_D: "Nhận diện khuôn mặt",
  T_49_META_TYP_428_I5_D: "ID trang điểm",
  T_49_META_TYP_428_I6_D: "ID thân trên",
  T_49_META_TYP_428_I7_D: "ID thân dưới",
  T_49_META_TYP_428_I8_D: "Mã số giày",
  T_49_META_TYP_431_I1_D: "Quỹ đạo của thực thể mục tiêu",
  T_49_META_TYP_431_I3_D: "Tốc độ di chuyển, đơn vị: m/s",
  T_49_META_TYP_431_I4_D: `Có nên đối mặt với đường tiếp tuyến khi di chuyển hay không. 
Giá trị mặc định là False, nghĩa là hướng của vật thể chuyển động không thay đổi.
Khi Đúng, vật thể chuyển động sẽ hướng theo hướng của đường đi.`,
  T_49_META_TYP_431_I5_D: "Phần trăm đã chơi",
  T_49_META_TYP_432_I0_D: "Góc lăn, ảnh hưởng đến độ quay xuyên tâm của đường đi ở cả hai bên của điểm này",
  T_49_META_TYP_432_I1_D: "Vị trí tương đối của điểm kiểm soát tiếp tuyến và điểm dừng xác định đường tiếp tuyến",
  T_49_META_TYP_433_I0_D: "Nội suy các đường thẳng giữa các điểm đường dẫn",
  T_49_META_TYP_433_I1_D: "Nội suy cong giữa các điểm đường dẫn để chuyển động mượt mà",
  T_49_META_TYP_433_I2_D: "Hỗ trợ điều chỉnh thủ công tiếp tuyến của điểm đường cong",
  T_49_META_TYP_434_I0_D: "Loại đường dẫn",
  T_49_META_TYP_434_I1_D: "Tổng chiều dài của đường đi",
  T_49_META_TYP_434_I2_D: "Liệu sự khởi đầu và kết thúc có được kết nối không",
  T_49_META_TYP_434_I3_D: "Bộ sưu tập Waypoint",
  T_49_META_TYP_437_I3_D: "Mảng người chơi bên trái",
  T_49_META_TYP_437_I4_D: "Mảng người chơi bên phải",
  T_49_META_TYP_437_I5_D: "Mảng tên loại số nguyên",
  T_49_META_TYP_437_I6_D: "Mảng điểm ở bên trái (Liệt kê một chiều: người chơi; Liệt kê hai chiều: dữ liệu điểm được điền theo loại điểm tùy chỉnh)",
  T_49_META_TYP_437_I7_D: "Mảng điểm bên phải (Liệt kê một chiều: người chơi; Liệt kê hai chiều: dữ liệu điểm được điền theo loại điểm tùy chỉnh)",
  T_49_META_TYP_438_I1_D: "Nhóm người chơi mảng",
  T_49_META_TYP_438_I2_D: "Mảng xếp hạng nhóm",
  T_49_META_TYP_438_I3_D: "Mảng điểm nhóm",
  T_49_META_TYP_438_I4_D: "Mảng tên loại số nguyên",
  T_49_META_TYP_438_I5_D: "Mảng màu nhóm",
  T_49_META_TYP_438_I6_D: "Mảng điểm của người chơi (tương ứng với thứ tự khi không được nhóm)",
  T_49_META_TYP_442_I1_D: "Điểm số bên trái",
  T_49_META_TYP_442_I10_D: "Biểu tượng tử thần ở bên phải",
  T_49_META_TYP_442_I2_D: "Điểm bên phải",
  T_49_META_TYP_442_I3_D: "Số người sống sót bên trái",
  T_49_META_TYP_442_I4_D: "Số người sống sót bên phải",
  T_49_META_TYP_442_I5_D: "Số người chết ở bên trái",
  T_49_META_TYP_442_I6_D: "Số người chết bên phải",
  T_49_META_TYP_442_I7_D: "Biểu tượng sinh tồn ở bên trái",
  T_49_META_TYP_442_I8_D: "Biểu tượng sinh tồn ở bên phải",
  T_49_META_TYP_442_I9_D: "Biểu tượng cái chết ở bên trái",
  T_49_META_TYP_444_I0_D: "Tiếng Anh",
  T_49_META_TYP_444_I1_D: "Tiếng Trung giản thể",
  T_49_META_TYP_444_I10_D: "Tiếng Pháp",
  T_49_META_TYP_444_I11_D: "Tiếng Đức",
  T_49_META_TYP_444_I12_D: "Thổ Nhĩ Kỳ",
  T_49_META_TYP_444_I13_D: "Tiếng Hin-ddi",
  T_49_META_TYP_444_I14_D: "Tiếng Nhật",
  T_49_META_TYP_444_I15_D: "Tiếng Rumani",
  T_49_META_TYP_444_I16_D: "Tiếng Ả Rập",
  T_49_META_TYP_444_I17_D: "Miến Điện",
  T_49_META_TYP_444_I18_D: "Tiếng Urdu",
  T_49_META_TYP_444_I19_D: "Tiếng Bengal",
  T_49_META_TYP_444_I2_D: "Tiếng Trung Quốc truyền thống",
  T_49_META_TYP_444_I3_D: "Thái Lan",
  T_49_META_TYP_444_I4_D: "Tiếng Việt",
  T_49_META_TYP_444_I5_D: "Tiếng Indonesia",
  T_49_META_TYP_444_I6_D: "Tiếng Bồ Đào Nha",
  T_49_META_TYP_444_I7_D: "Tiếng Tây Ban Nha",
  T_49_META_TYP_444_I8_D: "Tiếng Nga",
  T_49_META_TYP_444_I9_D: "Hàn Quốc",
  T_49_META_TYP_51_I0_D: "Zombie bình thường",
  T_49_META_TYP_51_I1_D: "Zombie cầm rìu",
  T_49_META_TYP_51_I10_D: "Thây Ma Bay",
  T_49_META_TYP_51_I11_D: "Rồng Zombie",
  T_49_META_TYP_51_I2_D: "Ném zombie",
  T_49_META_TYP_51_I3_D: "Xác sống tự nổ",
  T_49_META_TYP_51_I4_D: "Zombie kéo",
  T_49_META_TYP_51_I5_D: "Dị nhân ném zombie",
  T_49_META_TYP_51_I6_D: "Mr V",
  T_49_META_TYP_51_I7_D: "Quái khiên",
  T_49_META_TYP_51_I8_D: "Thây Ma Đào Đất",
  T_49_META_TYP_51_I9_D: "Xác sống Samurai",
  T_49_META_TYP_56_I10_D: "Độ trễ nổ",
  T_49_META_TYP_56_I11_D: "Phạm vi nổ",
  T_49_META_TYP_56_I12_D: "Sát thương nổ",
  T_49_META_TYP_56_I13_D: "Thời gian cháy",
  T_49_META_TYP_56_I14_D: "DMG đốt cháy",
  T_49_META_TYP_56_I15_D: "Khoảng cách DMG đốt cháy",
  T_49_META_TYP_56_I17_D: "Tài xế xe",
  T_49_META_TYP_56_I18_D: "Tất cả hành khách trên tàu",
  T_49_META_TYP_56_I19_D: "ID xe",
  T_49_META_TYP_56_I20_D: "Ưu tiên cấu hình người chơi",
  T_49_META_TYP_56_I21_D: "HP tối đa",
  T_49_META_TYP_56_I22_D: "Máu hiện tại",
  T_49_META_TYP_57_I0_D: "Chuyển thủ công hay tự động (mặc định là thủ công)",
  T_49_META_TYP_58_I0_D: "Đã tạo loại BUFF",
  T_49_META_TYP_58_I1_D: "Thời gian từ khi BUFF được chọn đến khi BUFF tiếp theo được tạo ra, tính bằng giây",
  T_49_META_TYP_59_I0_D: "Kiểu di chuyển",
  T_49_META_TYP_59_I1_D: "Theo trục X",
  T_49_META_TYP_59_I2_D: "Theo trục Y",
  T_49_META_TYP_59_I3_D: "Theo trục Z",
  T_49_META_TYP_59_I4_D: "Thời gian di chuyển",
  T_49_META_TYP_59_I5_D: "Thời gian dừng",
  T_49_META_TYP_59_I6_D: "Tắt chuyển động qua lại",
  T_49_META_TYP_60_I0_D: "Điểm cướp vũ khí",
  T_49_META_TYP_61_I0_D: "Thực thể cửa hàng được liên kết",
  T_49_META_TYP_61_I1_D: "Thiết lập phạm vi kích hoạt",
  T_49_META_TYP_61_I2_D: "Độ hiển thị mô hình",
  T_49_META_TYP_62_I0_D: "Tốc độ trục XZ",
  T_49_META_TYP_62_I1_D: "Tốc độ trục Y",
  T_49_META_TYP_64_I0_D: "Loại thành phần âm nhạc",
  T_49_META_TYP_66_I0_D: "ID phiên bản",
  T_49_META_TYP_66_I1_D: "Điểm dò đường",
  T_49_META_TYP_68_I0_D: "Sức khỏe hiện tại của AI",
  T_49_META_TYP_68_I1_D: "Sức khỏe tối đa hiện tại của AI",
  T_49_META_TYP_68_I10_D: "Liệu AI có đánh rơi trang bị hoặc vật phẩm khi chết không?",
  T_49_META_TYP_68_I11_D: "Liệu AI hiện tại có đang ở trạng thái bất khả chiến bại không",
  T_49_META_TYP_68_I12_D: "Khi nhận sát thương, tỷ lệ sát thương có thể giảm hoặc tăng.",
  T_49_META_TYP_68_I13_D: "Các loại AI",
  T_49_META_TYP_68_I14_D: "Có tự động tìm kiếm kẻ thù hay không",
  T_49_META_TYP_68_I15_D: "0 có nghĩa là tấn công tự động, 1 có nghĩa là tấn công phòng thủ, 2 có nghĩa là không tấn công gì cả",
  T_49_META_TYP_68_I16_D: "ID đường dẫn",
  T_49_META_TYP_68_I17_D: "Đối tượng bị AI truy đuổi",
  T_49_META_TYP_68_I18_D: "Đối tượng tấn công",
  T_49_META_TYP_68_I19_D: "Tọa độ điểm sinh sản của AI",
  T_49_META_TYP_68_I2_D: "Nhận thực thể của nhóm mà AI thuộc về",
  T_49_META_TYP_68_I20_D: "Số lượng phe nhóm",
  T_49_META_TYP_68_I4_D: "Chỉ có thể sửa đổi sức mạnh tấn công của đòn tấn công thông thường, không tính sức mạnh tấn công của kỹ năng.",
  T_49_META_TYP_68_I7_D: "Phạm vi di chuyển tự do của AI. Bạn chỉ có thể sửa đổi giá trị cơ bản. Nếu có phần thưởng bổ sung, nó sẽ được thêm vào dựa trên giá trị.",
  T_49_META_TYP_68_I8_D: "AI phát hiện phạm vi của kẻ địch và chỉ có thể sửa đổi giá trị cơ bản. Nếu có phần thưởng bổ sung, nó sẽ được thêm vào dựa trên giá trị.",
  T_49_META_TYP_68_I9_D: "Tốc độ di chuyển thực tế. Nếu có gia tốc kỹ năng, nó sẽ được nhân lên.",
  T_49_META_TYP_70_I0_D: "ID thực thể mục tiêu của công thức, được sử dụng nội bộ và người chơi không nhìn thấy.",
  T_49_META_TYP_70_I1_D: "ID thuộc tính thực thể mục tiêu của công thức, được sử dụng nội bộ và người chơi không nhìn thấy.",
  T_49_META_TYP_70_I2_D: "Giá trị tối thiểu được phép",
  T_49_META_TYP_70_I3_D: "Giá trị tối đa được phép",
  T_49_META_TYP_70_I4_D: "Hệ số cơ bản",
  T_49_META_TYP_70_I5_D: "Bộ tích lũy trước",
  T_49_META_TYP_70_I6_D: "Số nhân",
  T_49_META_TYP_70_I7_D: "Bộ tích lũy nhân",
  T_49_META_TYP_70_I8_D: "Bộ tích lũy sau",
  T_49_META_TYP_71_I0_D: "Số sản phẩm",
  T_49_META_TYP_71_I1_D: "Giá cả",
  T_49_META_TYP_71_I10_D: "Có thể mua không",
  T_49_META_TYP_71_I2_D: "Loại tiền tệ",
  T_49_META_TYP_71_I3_D: "Tổng giới hạn mua hàng",
  T_49_META_TYP_71_I4_D: "Các hạn chế mua hàng chung hiện tại",
  T_49_META_TYP_71_I5_D: "Tên sản phẩm",
  T_49_META_TYP_71_I6_D: "Mô tả sản phẩm",
  T_49_META_TYP_71_I7_D: "Danh sách sản phẩm",
  T_49_META_TYP_71_I8_D: "Số lượng vật phẩm",
  T_49_META_TYP_71_I9_D: "Đường dẫn tài nguyên, mặc định là trống",
  T_49_META_TYP_72_I1_D: "Vật phẩm cửa hàng",
  T_49_META_TYP_73_I1_D: "Danh sách kệ hàng",
  T_49_META_TYP_74_I0_D: "Vũ khí",
  T_49_META_TYP_74_I1_D: "Mũ",
  T_49_META_TYP_74_I2_D: "Áo ba lỗ",
  T_49_META_TYP_74_I3_D: "Lựu đạn",
  T_49_META_TYP_75_I0_D: "Một hướng một lần",
  T_49_META_TYP_75_I1_D: "Đi lại",
  T_49_META_TYP_76_I0_D: "Chỉ tuần tra, không tấn công mục tiêu trên đường đi",
  T_49_META_TYP_76_I1_D: "Vừa tuần tra, vừa tấn công",
  T_49_META_TYP_79_I0_D: "Sức mạnh tấn công của vũ khí",
  T_49_META_TYP_79_I1_D: "Phạm vi tấn công",
  T_49_META_TYP_79_I10_D: "Ngưỡng bắt đầu tán xạ",
  T_49_META_TYP_79_I11_D: "ID vật phẩm",
  T_49_META_TYP_79_I12_D: "Thời gian chờ tối thiểu giữa hai lần bắn, tính bằng giây. Mỗi lần bắn có thể bắn ra nhiều viên đạn tùy thuộc vào kiểu bắn.",
  T_49_META_TYP_79_I13_D: "Người chơi sở hữu vũ khí này",
  T_49_META_TYP_79_I14_D: "Có tiêu hao đạn không",
  T_49_META_TYP_79_I15_D: "Kiểu sử dụng cả hai vũ khí (0: không sử dụng cả hai vũ khí, 1: sở hữu, 2: bất kỳ vũ khí nào)",
  T_49_META_TYP_79_I16_D: "Hệ số sát thương của giáp",
  T_49_META_TYP_79_I17_D: "Tốc độ di chuyển của người chơi",
  T_49_META_TYP_79_I18_D: "Tỷ lệ sát thương cho đòn đánh vào thân",
  T_49_META_TYP_79_I19_D: "Tỷ lệ sát thương khi bắn vào đầu",
  T_49_META_TYP_79_I2_D: "Thời gian chờ tối thiểu giữa hai viên đạn, tính bằng giây",
  T_49_META_TYP_79_I20_D: "Tỷ lệ thiệt hại cho các chi",
  T_49_META_TYP_79_I21_D: "Tỷ lệ sát thương bổ sung (xe, thùng dầu, tường băng)",
  T_49_META_TYP_79_I22_D: "Hiển thị khi đeo sau lưng",
  T_49_META_TYP_79_I23_D: "Đập xuống đất để gây thêm sát thương",
  T_49_META_TYP_79_I24_D: "Số lượng đạn bắn mỗi lần",
  T_49_META_TYP_79_I25_D: "Tốc độ nạp đạn (tốc độ cơ bản * hệ số)",
  T_49_META_TYP_79_I26_D: "Số đạn còn lại hiện tại",
  T_49_META_TYP_79_I27_D: "ID da súng",
  T_49_META_TYP_79_I28_D: "Khi cấu hình của người chơi được ưu tiên, cấu hình skin súng của người chơi sẽ ghi đè lên các thuộc tính skin súng của chính vũ khí",
  T_49_META_TYP_79_I29_D: "Khi ghi các thuộc tính của da súng vào vũ khí, giá trị cơ bản của vũ khí sẽ bị ảnh hưởng bởi da súng",
  T_49_META_TYP_79_I3_D: "Số lượng đạn trong băng",
  T_49_META_TYP_79_I30_D: "Tỷ lệ tăng độ lan tỏa (0,1 = mỗi loạt bắn bổ sung làm tăng đường ngắm thêm 10%)",
  T_49_META_TYP_79_I31_D: "Tốc độ phục hồi phân tán",
  T_49_META_TYP_79_I32_D: "Tốc độ của người chơi khi bắn ảnh hưởng đến",
  T_49_META_TYP_79_I33_D: "Kích thước lan tỏa khi di chuyển (1,5 = 1,5 * kích thước điểm ngắm cơ bản)",
  T_49_META_TYP_79_I34_D: "Loại vũ khí",
  T_49_META_TYP_79_I36_D: "Kiểu bắn",
  T_49_META_TYP_79_I37_D: "Có bắn từng phát không",
  T_49_META_TYP_79_I38_D: "Tắt tiếng không",
  T_49_META_TYP_79_I39_D: "Tỷ lệ tốc độ di chuyển khi mở ống ngắm",
  T_49_META_TYP_79_I4_D: "Số lượng đạn ban đầu",
  T_49_META_TYP_79_I5_D: "Xuyên Giáp",
  T_49_META_TYP_79_I6_D: "Khoảng cách gây sát thương tối đa",
  T_49_META_TYP_79_I7_D: "Khoảng cách sát thương tối thiểu",
  T_49_META_TYP_79_I8_D: "Sát thương tối thiểu",
  T_49_META_TYP_79_I9_D: "Số lượng đạn có thể bắn ra trước khi bắt đầu phân tán",
  T_49_META_TYP_80_I1_D: "Khi đúng, việc đóng thủ công bị cấm",
  T_49_META_TYP_80_I2_D: "Thực thể lưu trữ bị ràng buộc",
  T_49_META_TYP_80_I4_D: "Danh sách tiền tệ liên kết",
  T_49_META_TYP_80_I5_D: "ID Ví liên kết",
  T_49_META_TYP_80_I6_D: "Loại mục tiêu được yêu cầu của người chơi UI hiện tại",
  T_49_META_TYP_80_I7_D: "Danh sách vật phẩm được yêu cầu",
  T_49_META_TYP_81_I0_D: "Buff ngẫu nhiên",
  T_49_META_TYP_81_I1_D: "Tăng HP",
  T_49_META_TYP_81_I2_D: "Buff đạn",
  T_49_META_TYP_81_I3_D: "Buff giáp",
  T_49_META_TYP_82_I1_D: "Biểu tượng nút",
  T_49_META_TYP_82_I3_D: "Vị trí so với điểm neo",
  T_49_META_TYP_83_I1_D: "ID Thực thể kích hoạt",
  T_49_META_TYP_83_I2_D: "Truyền tham số",
  T_49_META_TYP_86_I0_D: "Giá trị nhỏ nhất",
  T_49_META_TYP_86_I1_D: "Giá trị tối đa",
  T_49_META_TYP_86_I2_D: "Hệ số cơ sở, nhân với giá trị ban đầu trước khi tính toán",
  T_49_META_TYP_86_I3_D: "Tiền tích lũy, tích lũy trước khi nhân và tham gia vào phép tính nhân",
  T_49_META_TYP_86_I4_D: "Nhân liên tục, phép nhân liên tục, ví dụ (giảm xuống 90%, tăng lên 110%) hiệu ứng là Giá trị*90%*110%",
  T_49_META_TYP_86_I5_D: "Ví dụ, phép tích lũy nhân (cộng 10%, cộng 5%) có tác dụng là Giá trị*(1+10%+5%)",
  T_49_META_TYP_86_I6_D: "Sau tích lũy, không tham gia vào phép tính nhân và được thêm vào cuối",
  T_49_META_TYP_88_I0_D: "Loại cơ bản, loại tiền tệ cơ bản nhất trong trò chơi, loại giá của hàng hóa chung trong phiên bản hiện tại",
  T_49_META_TYP_89_I0_D: "Hiện tại, chỉ có tiền tệ cơ bản trong phiên bản",
  T_49_META_TYP_89_I1_D: "số lượng tiền tệ",
  T_49_META_TYP_89_I2_D: "Biểu tượng tiền tệ",
  T_49_META_TYP_89_I3_D: "Màu biểu tượng tiền tệ",
  T_49_META_TYP_90_I0_D: "Nội dung ví là một loạt các loại tiền tệ",
  T_49_META_TYP_92_I0_D: "Thùng gỗ hình vuông",
  T_49_META_TYP_92_I1_D: "Hộp gỗ dài",
  T_49_META_TYP_92_I10_D: "Tháp pháo",
  T_49_META_TYP_92_I100_D: "Cầu thang",
  T_49_META_TYP_92_I101_D: "Sàn thang B",
  T_49_META_TYP_92_I102_D: "Sàn thang A",
  T_49_META_TYP_92_I103_D: "Bốt điện thoại",
  T_49_META_TYP_92_I104_D: "Tường chủ đề BIS",
  T_49_META_TYP_92_I105_D: "Bồn hoa chủ đề BIS",
  T_49_META_TYP_92_I106_D: "Máy bán hàng tự động",
  T_49_META_TYP_92_I107_D: "Thực thể quái vật",
  T_49_META_TYP_92_I108_D: "Máy tạo đơn vị",
  T_49_META_TYP_92_I109_D: "Siêu xe",
  T_49_META_TYP_92_I11_D: "Phòng bảo vệ",
  T_49_META_TYP_92_I110_D: "TukTuk",
  T_49_META_TYP_92_I111_D: "Thùng gỗ có thể phá hủy",
  T_49_META_TYP_92_I112_D: "SUV",
  T_49_META_TYP_92_I113_D: "Xe máy",
  T_49_META_TYP_92_I114_D: "Xe tải quái vật",
  T_49_META_TYP_92_I115_D: "Máy tạo vàng",
  T_49_META_TYP_92_I116_D: "Sàn thang C",
  T_49_META_TYP_92_I117_D: "Biển chỉ dẫn",
  T_49_META_TYP_92_I118_D: "Hàng rào",
  T_49_META_TYP_92_I119_D: "Máy bán áo đấu",
  T_49_META_TYP_92_I12_D: "Nhà hai tầng",
  T_49_META_TYP_92_I121_D: "Cột bê tông",
  T_49_META_TYP_92_I122_D: "Vật phẩm bóng đá Loot",
  T_49_META_TYP_92_I123_D: "Thùng dầu",
  T_49_META_TYP_92_I124_D: "Khu vực trọng lực thấp",
  T_49_META_TYP_92_I125_D: "Thực thể vũ khí",
  T_49_META_TYP_92_I126_D: "Hàng rào B",
  T_49_META_TYP_92_I127_D: "Nhà nhỏ A",
  T_49_META_TYP_92_I128_D: "Xe tải hỏng",
  T_49_META_TYP_92_I129_D: "Hình cầu cơ bản",
  T_49_META_TYP_92_I13_D: "Tượng cát",
  T_49_META_TYP_92_I130_D: "Hình nón cơ bản",
  T_49_META_TYP_92_I131_D: "Hình trụ cơ bản",
  T_49_META_TYP_92_I132_D: "Máy tạo vật phẩm tiêu thụ",
  T_49_META_TYP_92_I133_D: "Tùy chỉnh vùng nước",
  T_49_META_TYP_92_I134_D: "Mũi tên",
  T_49_META_TYP_92_I135_D: "Khối nhuộm màu",
  T_49_META_TYP_92_I136_D: "Thùng dầu nhuộm màu",
  T_49_META_TYP_92_I137_D: "Thực thể văn bản",
  T_49_META_TYP_92_I138_D: "Biểu tượng",
  T_49_META_TYP_92_I139_D: "Búp Bê Băng",
  T_49_META_TYP_92_I14_D: "Đài phun nước",
  T_49_META_TYP_92_I140_D: "Viên nang Trigger",
  T_49_META_TYP_92_I141_D: "Kích hoạt va chạm quả cầu",
  T_49_META_TYP_92_I142_D: "Khối cơ bản phản chiếu màu đơn 1",
  T_49_META_TYP_92_I143_D: "Nhà máy xe điện đụng",
  T_49_META_TYP_92_I144_D: "Khối công viên giải trí caro",
  T_49_META_TYP_92_I145_D: "Màn hình lớn",
  T_49_META_TYP_92_I146_D: "Bục nhận thưởng",
  T_49_META_TYP_92_I147_D: "Kẹo mút khổng lồ",
  T_49_META_TYP_92_I148_D: "Xe bán đồ ăn nhỏb",
  T_49_META_TYP_92_I15_D: "Cây anh đào",
  T_49_META_TYP_92_I16_D: "Nhà một tầng",
  T_49_META_TYP_92_I17_D: "Nhà ba tầng",
  T_49_META_TYP_92_I18_D: "Cây chuối",
  T_49_META_TYP_92_I19_D: "Bồn cầu",
  T_49_META_TYP_92_I2_D: "Thùng gỗ dài có bụi rậm",
  T_49_META_TYP_92_I20_D: "Hàng rào",
  T_49_META_TYP_92_I21_D: "Container có thể phá hủy",
  T_49_META_TYP_92_I22_D: "Hàng rào có thể phá hủy",
  T_49_META_TYP_92_I23_D: "Lốp xe",
  T_49_META_TYP_92_I24_D: "Xe điện đụng",
  T_49_META_TYP_92_I25_D: "Xe đa năng",
  T_49_META_TYP_92_I26_D: "Xe Jeep",
  T_49_META_TYP_92_I27_D: "Thùng rác",
  T_49_META_TYP_92_I28_D: "Lều y tế",
  T_49_META_TYP_92_I29_D: "Gara",
  T_49_META_TYP_92_I3_D: "Đống cỏ khô",
  T_49_META_TYP_92_I30_D: "Tường vẽ",
  T_49_META_TYP_92_I31_D: "Cổng Torii",
  T_49_META_TYP_92_I32_D: "Bàn sắt",
  T_49_META_TYP_92_I33_D: "Nhà container",
  T_49_META_TYP_92_I34_D: "Xe kéo",
  T_49_META_TYP_92_I35_D: "Tường A",
  T_49_META_TYP_92_I36_D: "Nốt nhạc - Piano",
  T_49_META_TYP_92_I37_D: "Nốt nhạc - Piano",
  T_49_META_TYP_92_I38_D: "Nốt nhạc - Trống",
  T_49_META_TYP_92_I39_D: "Nốt nhạc - Trống",
  T_49_META_TYP_92_I4_D: "Xe hơi hỏng",
  T_49_META_TYP_92_I40_D: "Nốt nhạc - Synthesizer A",
  T_49_META_TYP_92_I41_D: "Nốt nhạc - Synthesizer A",
  T_49_META_TYP_92_I42_D: "Nốt nhạc - Synthesizer B",
  T_49_META_TYP_92_I43_D: "Nốt nhạc - Synthesizer B",
  T_49_META_TYP_92_I44_D: "Nốt nhạc - Synthesizer C",
  T_49_META_TYP_92_I45_D: "Nốt nhạc - Synthesizer C",
  T_49_META_TYP_92_I46_D: "Tạo Buff",
  T_49_META_TYP_92_I47_D: "Cơ chế cánh quạt",
  T_49_META_TYP_92_I48_D: "Cơ chế chảo rán",
  T_49_META_TYP_92_I49_D: "Bẫy khối",
  T_49_META_TYP_92_I5_D: "Xe buýt hỏng",
  T_49_META_TYP_92_I50_D: "Cơ chế vòng",
  T_49_META_TYP_92_I51_D: "Bẫy búa khổng lồ",
  T_49_META_TYP_92_I52_D: "Bảng di động",
  T_49_META_TYP_92_I53_D: "Mục tiêu di chuyển",
  T_49_META_TYP_92_I54_D: "Tường kính thiên văn",
  T_49_META_TYP_92_I55_D: "Thành phần vũ khí điểm cướp bóc",
  T_49_META_TYP_92_I56_D: "Thành phần đạn điểm cướp bóc",
  T_49_META_TYP_92_I57_D: "Thành phần vật phẩm tiêu hao điểm cướp bóc",
  T_49_META_TYP_92_I58_D: "Thành phần vật phẩm ném điểm cướp",
  T_49_META_TYP_92_I59_D: "Thành phần thu phóng điểm cướp bóc",
  T_49_META_TYP_92_I6_D: "Container A",
  T_49_META_TYP_92_I60_D: "Linh kiện áo giáp điểm cướp bóc",
  T_49_META_TYP_92_I61_D: "Ống thẳng",
  T_49_META_TYP_92_I62_D: "Đường ống chữ T",
  T_49_META_TYP_92_I63_D: "Ống chữ thập",
  T_49_META_TYP_92_I64_D: "Ống chuyển hướng",
  T_49_META_TYP_92_I65_D: "Cụm Nấm Khổng Lồ",
  T_49_META_TYP_92_I66_D: "Giá phơi đồ",
  T_49_META_TYP_92_I67_D: "Cầu gỗ",
  T_49_META_TYP_92_I68_D: "Màn hình",
  T_49_META_TYP_92_I69_D: "Cột bê tông",
  T_49_META_TYP_92_I7_D: "Container B",
  T_49_META_TYP_92_I70_D: "Xương rồng",
  T_49_META_TYP_92_I71_D: "Cây khô",
  T_49_META_TYP_92_I72_D: "Đèn lồng cung đình",
  T_49_META_TYP_92_I73_D: "Đèn đường",
  T_49_META_TYP_92_I74_D: "Pin năng lượng mặt trời",
  T_49_META_TYP_92_I75_D: "Điều hòa",
  T_49_META_TYP_92_I76_D: "Hình vuông",
  T_49_META_TYP_92_I77_D: "Dốc",
  T_49_META_TYP_92_I78_D: "Xe bán đồ ăn nhỏ",
  T_49_META_TYP_92_I79_D: "Kích hoạt chết hoặc bất tử",
  T_49_META_TYP_92_I8_D: "Container C",
  T_49_META_TYP_92_I80_D: "Checkpoint",
  T_49_META_TYP_92_I81_D: "Vị trí cuối",
  T_49_META_TYP_92_I82_D: "Xúc xắc",
  T_49_META_TYP_92_I83_D: "Ghế dài",
  T_49_META_TYP_92_I84_D: "Trạm xe buýt",
  T_49_META_TYP_92_I85_D: "Nhà cún",
  T_49_META_TYP_92_I86_D: "Biển quảng cáo",
  T_49_META_TYP_92_I87_D: "Bình nước lớn",
  T_49_META_TYP_92_I88_D: "Tường vẽ graffiti",
  T_49_META_TYP_92_I89_D: "Lều cỏ",
  T_49_META_TYP_92_I9_D: "Nhà nhỏ",
  T_49_META_TYP_92_I90_D: "Cầu vòm đá",
  T_49_META_TYP_92_I91_D: "Bộ bàn dù",
  T_49_META_TYP_92_I92_D: "Biểu ngữ đích đến",
  T_49_META_TYP_92_I93_D: "Pháo đài",
  T_49_META_TYP_92_I94_D: "Điểm sinh quái vật",
  T_49_META_TYP_92_I95_D: "Đánh dấu",
  T_49_META_TYP_92_I97_D: "Kích hoạt tùy chỉnh",
  T_49_META_TYP_92_I98_D: "Cửa đôi",
  T_49_META_TYP_92_I99_D: "Chướng ngại vật",
  T_49_META_TYP_94_I0_D: "Tăng",
  T_49_META_TYP_94_I1_D: "Nhân",
  T_49_META_TYP_95_I0_D: "Loại tiền tệ",
  T_49_META_TYP_95_I1_D: "số lượng tiền tệ",
  T_49_META_TYP_96_I0_D: "Lấy ví",
  T_49_META_TYP_96_I1_D: "Vị trí hiển thị (điểm neo là góc trên bên phải)",
  T_49_META_TYP_97_I0_D: "Vị trí trong tọa độ thế giới",
  T_49_META_TYP_97_I1_D: "Góc quay trong hệ tọa độ thế giới, các thành phần XYZ là góc nghiêng, góc lệch và góc lăn, và thứ tự quay là YXZ.",
  T_49_META_TYP_97_I10_D: "Hướng của trục tọa độ cục bộ x",
  T_49_META_TYP_97_I11_D: "Hướng của trục tọa độ cục bộ z",
  T_49_META_TYP_97_I2_D: "Tỷ lệ trong tọa độ thế giới",
  T_49_META_TYP_97_I3_D: "Nút cha của nút này",
  T_49_META_TYP_97_I4_D: "Sự quay trong hệ tọa độ thế giới, được thể hiện dưới dạng quaternion",
  T_49_META_TYP_97_I5_D: "Vị trí trong hệ tọa độ cục bộ",
  T_49_META_TYP_97_I6_D: "Sự quay trong hệ tọa độ cục bộ, được biểu thị dưới dạng quaternion",
  T_49_META_TYP_97_I7_D: "Góc quay trong hệ tọa độ cục bộ, các thành phần XYZ là góc nghiêng, góc lệch và góc lăn, và thứ tự quay là YXZ.",
  T_49_META_TYP_97_I8_D: "Tỷ lệ kích thước trong hệ tọa độ cục bộ",
  T_49_META_TYP_97_I9_D: "Hướng của trục tọa độ cục bộ y",
  T_49_META_TYP_99_I0_D: "Bán kính bóng đá",
  T_49_META_TYP_99_I1_D: "Hệ số ma sát trong điều kiện bình thường",
  T_49_META_TYP_99_I2_D: "Hệ số ma sát khi va chạm",
  T_49_META_TYP_99_I3_D: "Góc sút tối thiểu",
  T_49_META_TYP_99_I4_D: "Góc bắn cao tối thiểu",
  T_49_META_TYP_99_I5_D: "Thời gian đặt lại",
  T_49_META_TYP_99_I6_D: "Góc sút tối đa",
  T_49_META_TYP_99_I7_D: "Vị trí đặt lại",
  T_49_META_TYPE_0_D: "Đối tượng, gốc của hệ thống phân cấp kiểu",
  T_49_META_TYPE_1_D: "Danh sách là một container cho một tập dữ liệu",
  T_49_META_TYPE_10_D: "Thành phần cơ sở thực thể, tất cả các thành phần sẽ kết hợp thành phần này",
  T_49_META_TYPE_100_D: "Máy thay trang phục",
  T_49_META_TYPE_101_D: "Vật thể biến hình",
  T_49_META_TYPE_1010_D: "Thông tin đếm giờ",
  T_49_META_TYPE_1011_D: "Biểu ngữ mở đầu",
  T_49_META_TYPE_1012_D: "Thực thể biểu ngữ ở đầu vòng đấu của hai đội. Việc sửa đổi các thuộc tính của thực thể sẽ ảnh hưởng đến nội dung hiển thị trên UI tương ứng",
  T_49_META_TYPE_1013_D: "Nói chung, thực thể biểu ngữ ở đầu vòng, việc sửa đổi các thuộc tính của thực thể sẽ ảnh hưởng đến nội dung hiển thị trên UI tương ứng",
  T_49_META_TYPE_1014_D: "Biểu ngữ điểm số vòng đấu của đội. Việc sửa đổi các thuộc tính của thực thể sẽ ảnh hưởng đến nội dung hiển thị trên UI tương ứng",
  T_49_META_TYPE_1015_D: "Thực thể Checkpoint Manager. Việc sửa đổi các thuộc tính của thực thể sẽ ảnh hưởng đến nội dung hiển thị trên UI tương ứng.",
  T_49_META_TYPE_1016_D: "Thực thể được hiển thị vào cuối vòng. Việc sửa đổi các thuộc tính của thực thể sẽ ảnh hưởng đến nội dung hiển thị trên UI tương ứng",
  T_49_META_TYPE_1017_D: "Nếu có hai đội lúc bắt đầu, hãy hiển thị biểu ngữ của hai đội đang chiến đấu với nhau",
  T_49_META_TYPE_1018_D: "Điểm số của cả hai đội",
  T_49_META_TYPE_1019_D: "Kết quả cuối cùng: thắng, thua, hòa",
  T_49_META_TYPE_102_D: "Loại nguồn hồi sinh: Tử vong, Rơi xuống",
  T_49_META_TYPE_1020_D: "Lượt thực thể số, việc sửa đổi các thuộc tính của thực thể sẽ ảnh hưởng đến nội dung hiển thị trên UI tương ứng",
  T_49_META_TYPE_1021_D: "Thực thể đếm ngược pha. Việc sửa đổi các thuộc tính của thực thể sẽ ảnh hưởng đến nội dung hiển thị trên UI tương ứng.",
  T_49_META_TYPE_1022_D: "Thực thể phụ đề thông tin trò chơi. Việc sửa đổi các thuộc tính của thực thể sẽ ảnh hưởng đến nội dung hiển thị trên UI tương ứng.",
  T_49_META_TYPE_1023_D: "Hai thực thể thông tin trò chơi của đội. Việc sửa đổi các thuộc tính thực thể sẽ ảnh hưởng đến nội dung hiển thị trên UI tương ứng",
  T_49_META_TYPE_1024_D: "Thực thể giao diện người dùng thông tin trận đấu của đội. Việc sửa đổi các thuộc tính của thực thể sẽ ảnh hưởng đến nội dung hiển thị trên giao diện người dùng tương ứng.",
  T_49_META_TYPE_1027_D: "Mô tả kiểu của một kiểu, được trả về khi Typeof được sử dụng",
  T_49_META_TYPE_1028_D: "Thực thể thông tin phe phái. Việc sửa đổi các thuộc tính của thực thể sẽ ảnh hưởng đến nội dung hiển thị trên UI tương ứng",
  T_49_META_TYPE_1029_D: "Biểu tượng nhắc nhở thông tin thực thể, việc sửa đổi các thuộc tính thực thể sẽ ảnh hưởng đến nội dung hiển thị trên UI tương ứng",
  T_49_META_TYPE_103_D: "Liệt kê loại ô mục",
  T_49_META_TYPE_1030_D: "Một thực thể đơn giản hóa thông tin trò chơi của hai đội. Việc sửa đổi các thuộc tính thực thể sẽ ảnh hưởng đến nội dung hiển thị trên UI tương ứng",
  T_49_META_TYPE_1031_D: "Giao diện nhắc nhở thời gian thực thể, việc sửa đổi các thuộc tính của thực thể sẽ ảnh hưởng đến nội dung hiển thị trên UI tương ứng",
  T_49_META_TYPE_1032_D: "Văn bản nổi nhắc nhở thực thể. Việc sửa đổi các thuộc tính của thực thể sẽ ảnh hưởng đến nội dung hiển thị trên UI tương ứng",
  T_49_META_TYPE_1033_D: "Thực thể chuyển lượt bao gồm thông tin về lượt hiện tại và thông tin bắt đầu lượt tiếp theo. Việc sửa đổi các thuộc tính của thực thể sẽ ảnh hưởng đến nội dung hiển thị trên UI tương ứng",
  T_49_META_TYPE_1035_D: "Mở thực thể UI nút bảng điểm. Việc sửa đổi các thuộc tính của thực thể sẽ ảnh hưởng đến nội dung hiển thị trên UI tương ứng.",
  T_49_META_TYPE_1036_D: "Chế độ lây nhiễm, giao diện người dùng hiển thị cấp độ zombie hiện tại",
  T_49_META_TYPE_1037_D: "Thêm một thực thể UI hiệu ứng động điểm. Việc sửa đổi các thuộc tính của thực thể sẽ ảnh hưởng đến nội dung hiển thị trên UI tương ứng",
  T_49_META_TYPE_1038_D: "Hiệu ứng giao diện người dùng zombie chế độ lây nhiễm",
  T_49_META_TYPE_1039_D: "Thực thể nhắc nhở văn bản nổi đếm ngược, việc sửa đổi các thuộc tính của thực thể sẽ ảnh hưởng đến nội dung hiển thị trên UI tương ứng",
  T_49_META_TYPE_104_D: "Kiểu áo đấu",
  T_49_META_TYPE_1040_D: "UI chọn thẻ",
  T_49_META_TYPE_1041_D: "UI thông báo định danh",
  T_49_META_TYPE_1042_D: "UI đếm ngược 5 giây",
  T_49_META_TYPE_1043_D: "UI biểu ngữ tiêu đề",
  T_49_META_TYPE_1044_D: "UI công tắc thông dụng",
  T_49_META_TYPE_1045_D: "UI nút kỹ năng",
  T_49_META_TYPE_105_D: "Khung thành",
  T_49_META_TYPE_106_D: "Loại hỗ trợ ngắm",
  T_49_META_TYPE_107_D: "Có thể nhắm mục tiêu và đánh trúng, nhưng không nhất thiết phải chịu sát thương",
  T_49_META_TYPE_108_D: "Kiểu số nguyên, số nguyên có dấu 64 bit",
  T_49_META_TYPE_109_D: "Thực thể kênh trò chuyện là một vùng chứa chứa ID kênh và người chơi riêng của nó.",
  T_49_META_TYPE_11_D: "Thực thể toàn cầu, duy nhất trong toàn bộ trò chơi",
  T_49_META_TYPE_110_D: "Kênh thoại nhàn rỗi",
  T_49_META_TYPE_111_D: "Loại hành vi",
  T_49_META_TYPE_112_D: "Loại trạng thái hành vi của người chơi",
  T_49_META_TYPE_113_D: "Nhạc trống",
  T_49_META_TYPE_114_D: "Thành phần nhạc Lead1",
  T_49_META_TYPE_115_D: "Thành phần nhạc Lead2",
  T_49_META_TYPE_116_D: "Thành phần Lead3",
  T_49_META_TYPE_117_D: "Loại thành phần nhạc trống",
  T_49_META_TYPE_118_D: "Thực thể phe",
  T_49_META_TYPE_119_D: "Tùy chọn tấn công",
  T_49_META_TYPE_12_D: "Một thực thể chiến đấu có thể tấn công, bị tấn công, giết chết, v.v.",
  T_49_META_TYPE_120_D: "UI thanh tiến độ",
  T_49_META_TYPE_121_D: "Mỗi khoảng thời gian sóng",
  T_49_META_TYPE_122_D: "Bầu trời",
  T_49_META_TYPE_123_D: "Liệt kê loại cơ sở Skybox",
  T_49_META_TYPE_124_D: "Phạm vi tìm kiếm",
  T_49_META_TYPE_125_D: "Bạn có thể sửa đổi giao diện cơ bản của các đối tượng, chẳng hạn như kết cấu và độ trong suốt",
  T_49_META_TYPE_126_D: "Thanh máu",
  T_49_META_TYPE_127_D: "Làm thế nào để di chuyển các đối tượng",
  T_49_META_TYPE_128_D: "Vật thể có thể biến hình",
  T_49_META_TYPE_129_D: "Kiểu đạn Loot",
  T_49_META_TYPE_13_D: "Thực thể kiểm soát giao diện người dùng",
  T_49_META_TYPE_130_D: "Kiểu vật phẩm tiêu hao Loot",
  T_49_META_TYPE_131_D: "Kiểu đạn Loot",
  T_49_META_TYPE_132_D: "Kiểu lựu ném Loot",
  T_49_META_TYPE_133_D: "Kiểu ống ngắm Loot",
  T_49_META_TYPE_134_D: "Kiểu vũ khí Loot",
  T_49_META_TYPE_135_D: "Sẽ khiến loại đạn được chọn rơi ra",
  T_49_META_TYPE_136_D: "Sẽ tạo ra loại đạo cụ được chọn thả",
  T_49_META_TYPE_137_D: "Sẽ khiến một vật thể có loại đã chọn rơi xuống",
  T_49_META_TYPE_138_D: "Sẽ khiến phạm vi của loại đã chọn bị giảm",
  T_49_META_TYPE_139_D: "Sẽ khiến áo giáp của loại đã chọn bị rơi",
  T_49_META_TYPE_14_D: "Các thực thể người chơi trong trò chơi, mỗi người dùng một thực thể",
  T_49_META_TYPE_140_D: "Sóng",
  T_49_META_TYPE_141_D: "Vật phẩm bóng đá Loot",
  T_49_META_TYPE_142_D: "Vật phẩm bóng đá Loot",
  T_49_META_TYPE_143_D: "Loại thành phần âm nhạc Lead1",
  T_49_META_TYPE_144_D: "Loại thành phần âm nhạc Lead2",
  T_49_META_TYPE_145_D: "Loại thành phần âm nhạc Lead3",
  T_49_META_TYPE_146_D: "Loại thành phần nhạc bàn phím",
  T_49_META_TYPE_147_D: "Cung cấp nhiều loại camera cài đặt sẵn cũng như các loại camera tùy chỉnh",
  T_49_META_TYPE_148_D: "Linh kiện máy ảnh",
  T_49_META_TYPE_149_D: "Khóa bản địa hóa",
  T_49_META_TYPE_15_D: "Các thực thể nhóm trong trò chơi, một cho mỗi đội",
  T_49_META_TYPE_150_D: "Thùng dầu",
  T_49_META_TYPE_151_D: "Quaternion là một vectơ bốn chiều đặc biệt chỉ được sử dụng để biểu diễn phép quay.",
  T_49_META_TYPE_152_D: "Khu vực trọng lực thấp",
  T_49_META_TYPE_153_D: "Container thực thể, sẽ tạo ra các thực thể có loại tương ứng tại vị trí",
  T_49_META_TYPE_154_D: "Kiểu vũ khí hai tay",
  T_49_META_TYPE_155_D: "Thực thể mũ bảo hiểm",
  T_49_META_TYPE_156_D: "Thực thể áo giáp",
  T_49_META_TYPE_157_D: "Kiểu chuyển đổi camera",
  T_49_META_TYPE_158_D: "Giao diện nhắc nhở văn bản",
  T_49_META_TYPE_159_D: "Vector2",
  T_49_META_TYPE_16_D: "Đối tượng cấp độ thực thể",
  T_49_META_TYPE_160_D: "Loại bản đồ",
  T_49_META_TYPE_161_D: "VFX Lớp phủ không thể thay thế",
  T_49_META_TYPE_162_D: "Danh sách Kiểu",
  T_49_META_TYPE_163_D: "Kiểu hoặc Danh sách kiểu",
  T_49_META_TYPE_164_D: "Thành phần là lớp cơ sở của tất cả các thành phần thực thể hoặc các lớp thành phần cụ thể",
  T_49_META_TYPE_165_D: "Thành phần hộp va chạm",
  T_49_META_TYPE_166_D: "Biểu tượng cảm xúc",
  T_49_META_TYPE_167_D: "Thực thể hiệu ứng đặc biệt biểu thị hiệu ứng đặc biệt được hiển thị (đã xóa, có thể tái chế và tái sử dụng)",
  T_49_META_TYPE_17_D: "Danh sách Cấp vật thể",
  T_49_META_TYPE_170_D: "Chỉ ra liệu khả năng hiển thị có thể được thiết lập hay không",
  T_49_META_TYPE_171_D: "Nấm",
  T_49_META_TYPE_172_D: "Đạn",
  T_49_META_TYPE_173_D: "Thành phần Balo",
  T_49_META_TYPE_174_D: "Thành phần lựu đạn",
  T_49_META_TYPE_175_D: "Lựu choáng băng",
  T_49_META_TYPE_176_D: "Máy tạo vũ khí",
  T_49_META_TYPE_177_D: "Khi có vật cản giữa camera và đối tượng đang được theo dõi, chế độ chuyển động của camera",
  T_49_META_TYPE_178_D: "Máy ảnh tạo ra hình ảnh như thế nào",
  T_49_META_TYPE_179_D: "Hình cầu cơ bản",
  T_49_META_TYPE_18_D: "(Đã lỗi thời, không sử dụng)",
  T_49_META_TYPE_180_D: "Tham chiếu đến một thuộc tính của một thành phần",
  T_49_META_TYPE_181_D: "Được sử dụng để mô tả loại tài sản lưới",
  T_49_META_TYPE_182_D: "Được sử dụng để mô tả loại tài sản vật chất",
  T_49_META_TYPE_183_D: "Được sử dụng để mô tả loại tài sản kết cấu",
  T_49_META_TYPE_184_D: "Một thành phần kết xuất cầu nối để kết xuất bằng cách sử dụng các tài nguyên mô hình tích hợp",
  T_49_META_TYPE_185_D: "Thành phần kết xuất tùy chỉnh để kết xuất với các tài nguyên mô hình tùy chỉnh",
  T_49_META_TYPE_186_D: "Một thành phần đối tượng trống có thể được sử dụng với các thành phần kết xuất, thành phần va chạm, v.v.",
  T_49_META_TYPE_187_D: "Vật chứa",
  T_49_META_TYPE_188_D: "Hình nón hoặc hình trụ cơ bản",
  T_49_META_TYPE_189_D: "Danh sách các chuỗi được bản địa hóa",
  T_49_META_TYPE_19_D: "Mẫu danh sách, bạn có thể chỉ định loại nội dung thông qua T",
  T_49_META_TYPE_190_D: "Giao diện tổng kết hai đội",
  T_49_META_TYPE_191_D: "Một loại vũ khí ném chiến thuật có thể tạm thời làm mù kẻ thù trong một phạm vi nhất định.",
  T_49_META_TYPE_192_D: "Sau khi sử dụng, nó có thể tạo ra khói che giấu sự việc, đây là vũ khí lợi hại để phá vỡ đòn tấn công của kẻ thù.",
  T_49_META_TYPE_193_D: "Bảng kết quả Đa đội",
  T_49_META_TYPE_194_D: "Mìn cảm ứng có thể được đặt trên mặt đất. Chúng sẽ phát nổ khi kẻ địch đến gần. Hãy cẩn thận không được giẫm lên chúng.",
  T_49_META_TYPE_195_D: "Chuyển động nội suy được thực hiện như thế nào",
  T_49_META_TYPE_197_D: "Các thành phần có thể chơi được",
  T_49_META_TYPE_198_D: "Lớp cơ sở tài nguyên vật phẩm",
  T_49_META_TYPE_199_D: "Thiết bị phụ trợ cho chiến đấu trên không, nhưng bạn cần phải chú ý đến mức tiêu thụ năng lượng mọi lúc",
  T_49_META_TYPE_2_D: "Kiểu Boolean, được sử dụng để biểu diễn đúng, sai hoặc có hoặc không",
  T_49_META_TYPE_20_D: "Liệt kê loại giao diện tích hợp, được tạo tự động dựa trên hệ thống loại",
  T_49_META_TYPE_200_D: "Khu vực Jailbreak",
  T_49_META_TYPE_201_D: "Khu vực bạn có thể bơi sau khi vào",
  T_49_META_TYPE_202_D: "ID tài nguyên va chạm",
  T_49_META_TYPE_203_D: "Chuyển động nội suy",
  T_49_META_TYPE_204_D: "Giày được trang bị thiết bị công nghệ cho phép bạn nhảy kép trên không",
  T_49_META_TYPE_205_D: "Một chiếc tàu lượn có thể bay trên bầu trời. Nó có thể được sử dụng để hạ cánh từ độ cao lớn và di chuyển đến một nơi xa hơn.",
  T_49_META_TYPE_206_D: "Ván trượt",
  T_49_META_TYPE_207_D: "Đường trượt zipline",
  T_49_META_TYPE_208_D: "Danh sách các trò chơi có thể chơi",
  T_49_META_TYPE_209_D: "Có thể chơi hoặc danh sách có thể chơi",
  T_49_META_TYPE_21_D: "Thực thể giao diện tích hợp, đóng gói giao diện của các chức năng cụ thể",
  T_49_META_TYPE_210_D: "Hoạt hình đạn đạo là mô phỏng chuyển động đạn đạo.",
  T_49_META_TYPE_211_D: "Hệ tọa độ",
  T_49_META_TYPE_212_D: "Một vật thể theo sau một vật thể khác",
  T_49_META_TYPE_213_D: "Mặt trước của một vật luôn hướng về vật kia",
  T_49_META_TYPE_214_D: "ID được sử dụng để mô tả tài sản sprite atlas",
  T_49_META_TYPE_215_D: "kết quả trận đấu",
  T_49_META_TYPE_216_D: "Bộ chứa dữ liệu từ điển, phần tử dữ liệu là một cặp Khóa, Giá trị",
  T_49_META_TYPE_217_D: "Mẫu dữ liệu từ điển, loại nội dung có thể được chỉ định bởi T1 và T2",
  T_49_META_TYPE_218_D: "Một loại nguồn sáng phát ra ánh sáng có cường độ bằng nhau theo mọi hướng từ vị trí của nó",
  T_49_META_TYPE_219_D: "Xe máy",
  T_49_META_TYPE_22_D: "Giao diện tùy chỉnh, giao diện do người chơi tạo ra thông qua trình chỉnh sửa giao diện",
  T_49_META_TYPE_220_D: "Xe tuk-tuk (xe ba bánh)",
  T_49_META_TYPE_221_D: "Xe mô tô lội nước/súng máy",
  T_49_META_TYPE_222_D: "Xe bốn bánh",
  T_49_META_TYPE_224_D: "Danh sách kiểu kỹ năng",
  T_49_META_TYPE_225_D: "Tháp pháo trí tuệ nhân tạo được làm từ vật liệu công nghệ cao sẽ chủ động tìm kiếm và tấn công kẻ thù trong phạm vi nhất định.",
  T_49_META_TYPE_226_D: "Tháp pháo được tạo ra sau khi sử dụng chân đế tháp pháo",
  T_49_META_TYPE_227_D: "Liệt kê loại điều khiển UI tùy chỉnh",
  T_49_META_TYPE_23_D: "Đánh số loại đối tượng cấp độ, sẽ được tự động tạo dựa trên hệ thống loại",
  T_49_META_TYPE_231_D: "Hộp sửa giáp",
  T_49_META_TYPE_233_D: "Vòng chờ tiến độ",
  T_49_META_TYPE_234_D: "Đối tượng sau khi tạo mìn",
  T_49_META_TYPE_235_D: "Bom keo",
  T_49_META_TYPE_236_D: "Đối tượng tạo tường băng",
  T_49_META_TYPE_237_D: "Súng dây móc",
  T_49_META_TYPE_238_D: "Súng phun cầu vồng",
  T_49_META_TYPE_239_D: "Súng phun sơn (súng trường)",
  T_49_META_TYPE_24_D: "Các loại thiệt hại hiện được hệ thống xác định",
  T_49_META_TYPE_240_D: "Thực thể là đơn vị mang tất cả các thành phần. Các thành phần phải được gắn vào thực thể để tạo ra các phiên bản.",
  T_49_META_TYPE_241_D: "Súng móc mạnh mẽ",
  T_49_META_TYPE_242_D: "Thanh điểm số",
  T_49_META_TYPE_243_D: "Khe cắm quần áo",
  T_49_META_TYPE_244_D: "Một thực thể văn bản biểu diễn một văn bản được hiển thị.",
  T_49_META_TYPE_245_D: "Thực thể Biểu tượng biểu thị một biểu tượng được hiển thị",
  T_49_META_TYPE_246_D: "Màu sơn",
  T_49_META_TYPE_247_D: "Loại giao diện người chơi",
  T_49_META_TYPE_248_D: "Thực thể chuyển đổi giao diện người dùng chung",
  T_49_META_TYPE_249_D: "Chuyển đổi khe đạo cụ",
  T_49_META_TYPE_25_D: "Các giai đoạn trong quá trình chơi trò chơi, chẳng hạn như bắt đầu trò chơi, chuẩn bị trò chơi, kết thúc trò chơi, v.v.",
  T_49_META_TYPE_250_D: "Thực thể hiệu ứng biểu thị một hiệu ứng được hiển thị",
  T_49_META_TYPE_2500_D: "Điểm xuất hiện của người chơi",
  T_49_META_TYPE_2501_D: "Các trình kích hoạt được sử dụng để kích hoạt các sự kiện vào và ra của người chơi (hoặc các đối tượng khác)",
  T_49_META_TYPE_2502_D: "Kích hoạt tử vong hoặc bất khả chiến bại, khi người chơi vào, nó sẽ kiểm soát hiệu ứng tử vong hoặc bất khả chiến bại theo thuộc tính",
  T_49_META_TYPE_2503_D: "Điểm kiểm tra chế độ đua",
  T_49_META_TYPE_2504_D: "Thường được sử dụng trong chế độ đua xe để xác định người chơi nào vào vạch đích được chỉ định. Đây là một trình kích hoạt cụ thể. Các trình kích hoạt tùy chỉnh sẽ được mở sau. Điểm cuối này chỉ là một trình bao bọc của trình kích hoạt tùy chỉnh.",
  T_49_META_TYPE_2505_D: "Hàng rào xung quanh điểm sinh sản, sau khi đóng lại, bạn có thể rời khỏi điểm sinh sản",
  T_49_META_TYPE_2507_D: "Tháp phòng thủ",
  T_49_META_TYPE_2508_D: "Máy tạo quái vật",
  T_49_META_TYPE_2509_D: "Các trường hợp của loại tương ứng có thể được tạo ra theo yêu cầu",
  T_49_META_TYPE_251_D: "Vật chứa hiệu ứng đặc biệt",
  T_49_META_TYPE_2510_D: "Khu vực sinh sản của người chơi (hình chữ nhật)",
  T_49_META_TYPE_252_D: "UI tổng kết sơn",
  T_49_META_TYPE_253_D: "Nút thông báo",
  T_49_META_TYPE_254_D: "Hiệu ứng nhịp tim trên màn hình",
  T_49_META_TYPE_255_D: "Chuỗi bản địa hóa dấu thời gian",
  T_49_META_TYPE_256_D: "Kiểu Rigidbody",
  T_49_META_TYPE_257_D: "Thành phần vật thể cứng",
  T_49_META_TYPE_258_D: "Định dạng hiển thị dấu thời gian",
  T_49_META_TYPE_259_D: "Lời khuyên",
  T_49_META_TYPE_26_D: "Mỗi vòng chơi thường là một vòng nhỏ, bao gồm nhiều giai đoạn.",
  T_49_META_TYPE_260_D: "Nút kỹ năng tiến độ",
  T_49_META_TYPE_261_D: "ID duy nhất",
  T_49_META_TYPE_262_D: "ID Skin súng",
  T_49_META_TYPE_263_D: "ID quần áo",
  T_49_META_TYPE_264_D: "ID vật phẩm, khi phiên bản chỉ có ID vũ khí",
  T_49_META_TYPE_265_D: "Thực thể bảng điều khiển UI",
  T_49_META_TYPE_267_D: "Thực thể xem cuộn UI, UI mà người chơi chỉnh sửa thông qua trình chỉnh sửa UI",
  T_49_META_TYPE_268_D: "Một công tắc có ba trạng thái, ngoài trạng thái bật và tắt, bạn có thể chọn giữ nguyên logic ban đầu",
  T_49_META_TYPE_269_D: "Thiết bị của người chơi",
  T_49_META_TYPE_270_D: "ID Thực thể hoặc Prefab",
  T_49_META_TYPE_271_D: "Thực thể bảng điều khiển UI, UI mà người chơi chỉnh sửa thông qua trình chỉnh sửa UI",
  T_49_META_TYPE_272_D: "Liệt kê giới tính",
  T_49_META_TYPE_273_D: "Thành phần Thực thể Minimap",
  T_49_META_TYPE_274_D: "Biểu tượng hiển thị trên bản đồ nhỏ có thể theo dõi mục tiêu",
  T_49_META_TYPE_275_D: "Các nút phần riêng lẻ trong một bộ xương",
  T_49_META_TYPE_276_D: "Nút được sử dụng để tiếp cận xương da",
  T_49_META_TYPE_277_D: "Phát hiện tia camera phía máy khách",
  T_49_META_TYPE_278_D: "Khối pixel hiển thị trên bản đồ nhỏ biểu thị kích thước va chạm của vật thể tại vị trí đó",
  T_49_META_TYPE_279_D: "Thùng nhuộm",
  T_49_META_TYPE_28_D: "Vào đầu mỗi vòng, trạng thái sẽ được thiết lập lại",
  T_49_META_TYPE_280_D: "Trigger hình cầu",
  T_49_META_TYPE_281_D: "Viên nang Trigger",
  T_49_META_TYPE_282_D: "Mô tả loại ID cấu hình tài sản, được sử dụng để chỉ ra ID cấu hình tài sản đi kèm với gói cha, cần được phân tích cú pháp thông qua bảng cấu hình trước khi tải",
  T_49_META_TYPE_283_D: "Mô tả loại tài sản, được sử dụng để biểu diễn mã định danh tài sản và có thể được tải trực tiếp",
  T_49_META_TYPE_284_D: "Biểu thị một nguồn tài nguyên mô hình hình người có thể được thay thế bằng một nhân vật người chơi",
  T_49_META_TYPE_285_D: "Danh sách hoặc từ điển có thể được lặp lại",
  T_49_META_TYPE_286_D: "ID mô tả nội dung tập lệnh.",
  T_49_META_TYPE_287_D: "ID mô tả nội dung tập lệnh tĩnh.",
  T_49_META_TYPE_288_D: "ID mô tả nội dung UI tùy chỉnh.",
  T_49_META_TYPE_289_D: "ID được sử dụng để mô tả tài sản được cài đặt trước",
  T_49_META_TYPE_29_D: "Hiệu ứng đặc biệt",
  T_49_META_TYPE_290_D: "Cây hành vi",
  T_49_META_TYPE_291_D: "Loại nút cây hành vi",
  T_49_META_TYPE_292_D: "Tùy chỉnh nút cây hành vi",
  T_49_META_TYPE_293_D: "Có thể gắn Thực thể cây hành vi",
  T_49_META_TYPE_294_D: "Thực thể bố cục UI, UI mà người chơi chỉnh sửa thông qua trình chỉnh sửa UI",
  T_49_META_TYPE_295_D: "Trạng thái hoạt ảnh",
  T_49_META_TYPE_296_D: "Clip hoạt ảnh",
  T_49_META_TYPE_297_D: "Điều khiển hoạt ảnh",
  T_49_META_TYPE_298_D: "Loại vòng lặp",
  T_49_META_TYPE_3_D: "Kiểu số nguyên, số nguyên có dấu 32 bit",
  T_49_META_TYPE_30_D: "Biểu tượng",
  T_49_META_TYPE_300_D: "Thực thể UI3DContainer, giao diện người dùng mà người chơi chỉnh sửa thông qua trình chỉnh sửa giao diện người dùng",
  T_49_META_TYPE_301_D: "Loại kỹ năng Zombie",
  T_49_META_TYPE_302_D: "Đếm khe thiết bị",
  T_49_META_TYPE_303_D: "Tương ứng với cột Id trong BuffData.csv, vui lòng xác nhận với GPP xem nó có áp dụng được không trước khi thêm mục mới",
  T_49_META_TYPE_304_D: "Danh sách Kiểu buff",
  T_49_META_TYPE_305_D: "Trạng thái hoạt động của nút cây hành vi",
  T_49_META_TYPE_306_D: "Bạn có thể thêm buff, xóa buff và nhận danh sách các buff đã thêm",
  T_49_META_TYPE_307_D: "Máy tạo bom keo",
  T_49_META_TYPE_308_D: "ID vật phẩm đặc biệt",
  T_49_META_TYPE_309_D: "Ném đạo cụ",
  T_49_META_TYPE_31_D: "Âm thanh",
  T_49_META_TYPE_310_D: "Nỏ",
  T_49_META_TYPE_311_D: "Lựu đạn",
  T_49_META_TYPE_312_D: "Ném đạo cụ",
  T_49_META_TYPE_313_D: "Thành phần lựu đạn băng",
  T_49_META_TYPE_314_D: "Quản lý bộ điều khiển hoạt hình và tài nguyên",
  T_49_META_TYPE_315_D: "Balo người chơi",
  T_49_META_TYPE_316_D: "Thực thể UITexture, UI được người chơi chỉnh sửa thông qua trình chỉnh sửa UI",
  T_49_META_TYPE_317_D: "Ràng buộc chuyển động của vật thể cứng, mỗi ràng buộc có thể được sử dụng kết hợp",
  T_49_META_TYPE_318_D: "Phụ kiện",
  T_49_META_TYPE_319_D: "Điền Loại Liệt kê",
  T_49_META_TYPE_32_D: "Loại trạng thái của người chơi",
  T_49_META_TYPE_320_D: "Điền hướng liệt kê",
  T_49_META_TYPE_321_D: "Các thực thể có thể được nhắm mục tiêu",
  T_49_META_TYPE_322_D: "Loại bộ phận cơ thể bị đánh trúng",
  T_49_META_TYPE_323_D: "Thực thể UIProfileInfo, giao diện người dùng mà người chơi chỉnh sửa thông qua trình chỉnh sửa giao diện người dùng",
  T_49_META_TYPE_324_D: "Một số tác động khác nhau của lực lên vật rắn. Lưu ý rằng điều này chỉ đúng với vật thể rắn động.",
  T_49_META_TYPE_325_D: "ID được sử dụng để mô tả điều khiển trong tài sản giao diện tùy chỉnh",
  T_49_META_TYPE_326_D: "Thông tin hồ sơ người chơi",
  T_49_META_TYPE_327_D: "Thay thế theo cấu hình của từng thành phần",
  T_49_META_TYPE_328_D: "ID tài sản cây hành vi",
  T_49_META_TYPE_329_D: "Kiểu ghế ngồi",
  T_49_META_TYPE_33_D: "Sắp xếp theo: Tăng dần Bỏ qua giá trị 0, Giảm dần, Tăng dần",
  T_49_META_TYPE_330_D: "Chuyển động liên quan đến bản thân",
  T_49_META_TYPE_331_D: "Đường cong Bezier",
  T_49_META_TYPE_332_D: "Các thành phần có thể tái chế",
  T_49_META_TYPE_333_D: "Liệt kê phông chữ",
  T_49_META_TYPE_334_D: "ID Skin phương tiện",
  T_49_META_TYPE_335_D: "Thực thể hiệu ứng âm thanh biểu thị hiệu ứng âm thanh đang được phát.",
  T_49_META_TYPE_336_D: "Danh sách Hiệu ứng âm thanh",
  T_49_META_TYPE_337_D: "SoundEntity hoặc mảng SoundEntity",
  T_49_META_TYPE_338_D: "Thực thể đồng bộ hóa thuộc tính hành vi của người chơi",
  T_49_META_TYPE_339_D: "Đạo cụ phụ kiện trang bị",
  T_49_META_TYPE_34_D: "ID vật phẩm",
  T_49_META_TYPE_340_D: "Kiểu độ khó bot",
  T_49_META_TYPE_341_D: "Từ điển số nguyên",
  T_49_META_TYPE_342_D: "Đối tượng hẹn giờ",
  T_49_META_TYPE_343_D: "Ném dao (nhặt)",
  T_49_META_TYPE_344_D: "Phi đao",
  T_49_META_TYPE_345_D: "Loại vũ khí",
  T_49_META_TYPE_346_D: "Kiểu đạn",
  T_49_META_TYPE_347_D: "Chuyển động mỗi khung hình so với bản thân",
  T_49_META_TYPE_348_D: "Con trỏ hàm trỏ đến một thể hiện hàm để triển khai hàm ảo hoặc cơ chế ủy quyền.",
  T_49_META_TYPE_349_D: "Chỉ đến trình xử lý của một trình tự con và có thể thực hiện một số thao tác xử lý",
  T_49_META_TYPE_350_D: "Kiểm kê xe",
  T_49_META_TYPE_351_D: "Mô tả loại đối tượng",
  T_49_META_TYPE_352_D: "Thực thể UIToggle, giao diện người dùng mà người chơi chỉnh sửa thông qua trình chỉnh sửa giao diện người dùng",
  T_49_META_TYPE_353_D: "Túi cứu thương",
  T_49_META_TYPE_354_D: "Mặt nạ hồi máu",
  T_49_META_TYPE_355_D: "Bộ hồi phục",
  T_49_META_TYPE_356_D: "Airdrop, sau khi thời gian chuẩn bị kết thúc, nó sẽ bắt đầu rơi từ trên cao xuống",
  T_49_META_TYPE_357_D: "Màu sắc mô tả của các đối tượng, chẳng hạn như đường viền, bề mặt, v.v. (xóa, có thể tái chế)",
  T_49_META_TYPE_358_D: "Đề cập đến một sự kiện",
  T_49_META_TYPE_359_D: "Bộ điều khiển người chơi có hiệu ứng vật lý, có thể tác dụng lực và nhận lực",
  T_49_META_TYPE_360_D: "Máy phóng di động",
  T_49_META_TYPE_361_D: "Pháo gấp có thể được sử dụng để phóng người khi mở ra. Hãy cẩn thận đừng để mình bị phóng ra khỏi vùng an toàn!",
  T_49_META_TYPE_362_D: "Trận chiến ném tuyết! Thù lao!",
  T_49_META_TYPE_363_D: "Yêu cầu mua hàng tại cửa hàng",
  T_49_META_TYPE_364_D: "Bộ kích hoạt hoạt ảnh",
  T_49_META_TYPE_365_D: "Thành phần giao diện kích hoạt hoạt ảnh",
  T_49_META_TYPE_366_D: "Kết xuất gói kết hợp",
  T_49_META_TYPE_367_D: "La bàn hàng đầu",
  T_49_META_TYPE_368_D: "ID tài nguyên vai trò tùy chỉnh",
  T_49_META_TYPE_369_D: "ID tài nguyên hoạt ảnh tùy chỉnh",
  T_49_META_TYPE_370_D: "Thông tin hiển thị khi bắt đầu vòng chơi",
  T_49_META_TYPE_371_D: "Vào cuối mỗi vòng, hiển thị kết quả",
  T_49_META_TYPE_372_D: "Kiểu thế đứng của người chơi",
  T_49_META_TYPE_373_D: "ID bộ sưu tập, được sử dụng để thu thập thông tin tài nguyên",
  T_49_META_TYPE_374_D: "Mô tả trên đầu theo Ảnh",
  T_49_META_TYPE_375_D: "Liệt kê loại mục tiêu tấn công quái vật",
  T_49_META_TYPE_376_D: "Liệt kê loại mục tiêu tấn công tháp phòng thủ",
  T_49_META_TYPE_377_D: "Biệt danh cho các thực thể người chơi và loại thực thể phương tiện",
  T_49_META_TYPE_378_D: "ID mô tả nội dung âm thanh.",
  T_49_META_TYPE_379_D: "ID được sử dụng để mô tả tài sản bảng cấu hình",
  T_49_META_TYPE_38_D: "UI thực thể Widget trống, UI được chỉnh sửa bởi người chơi thông qua trình chỉnh sửa UI",
  T_49_META_TYPE_380_D: "ID mô tả nội dung có hiệu ứng đặc biệt.",
  T_49_META_TYPE_381_D: "ID mô tả nội dung bộ điều khiển hoạt hình.",
  T_49_META_TYPE_382_D: "Phương pháp xử lý trạng thái Knockdown",
  T_49_META_TYPE_383_D: "Bề mặt hoặc đồ trang trí của bản đồ",
  T_49_META_TYPE_384_D: "Danh sách ID vật phẩm",
  T_49_META_TYPE_385_D: "ID Kỹ năng Nhân vật",
  T_49_META_TYPE_386_D: "Danh sách ID kỹ năng",
  T_49_META_TYPE_387_D: "Thực thể UITouchPad, giao diện người dùng mà người chơi chỉnh sửa thông qua trình chỉnh sửa giao diện người dùng",
  T_49_META_TYPE_388_D: "ID Skin Balo",
  T_49_META_TYPE_389_D: "Thực thể cần điều khiển, UI được người chơi chỉnh sửa thông qua trình chỉnh sửa UI",
  T_49_META_TYPE_39_D: "Thực thể hình ảnh UI, UI được người chơi chỉnh sửa thông qua trình chỉnh sửa UI",
  T_49_META_TYPE_390_D: "Thực thể có thể gắn nút con",
  T_49_META_TYPE_391_D: "Widget hoặc UI tùy chỉnh",
  T_49_META_TYPE_392_D: "Các vật thể của vòng tròn độc có thể được đặt",
  T_49_META_TYPE_393_D: "Các thực thể có thành phần PhysicalCCT hoặc Rigidbody",
  T_49_META_TYPE_394_D: "Hằng số toán học",
  T_49_META_TYPE_395_D: "Các thực thể có thành phần PhysicalCCT hoặc PlayerCCT có thể di chuyển cùng với chúng",
  T_49_META_TYPE_396_D: "Cấu hình thoát giữa chừng",
  T_49_META_TYPE_397_D: "Thành phần được sử dụng để mô tả hình dạng va chạm",
  T_49_META_TYPE_398_D: "Chuỗi hoặc chuỗi địa phương hóa",
  T_49_META_TYPE_399_D: "Bộ điều khiển nhân vật có hiệu ứng vật lý, chỉ dành cho nhân vật FF",
  T_49_META_TYPE_4_D: "Kiểu dấu phẩy động, số dấu phẩy động độ chính xác đơn 32 bit",
  T_49_META_TYPE_40_D: "Thực thể văn bản UI, UI được người chơi chỉnh sửa thông qua trình chỉnh sửa UI",
  T_49_META_TYPE_400_D: "Làm thế nào để tham gia vào hành vi hung hăng",
  T_49_META_TYPE_401_D: "Kiểu bắn",
  T_49_META_TYPE_402_D: "Widget nút kết nối",
  T_49_META_TYPE_403_D: "Các loại nút mạng xã hội",
  T_49_META_TYPE_404_D: "Kiểu nút mạng xã hội",
  T_49_META_TYPE_405_D: "Loại sắp xếp bố cục",
  T_49_META_TYPE_406_D: "Có thể kích hoạt qua chướng ngại vật",
  T_49_META_TYPE_407_D: "Kiểu nền tảng",
  T_49_META_TYPE_408_D: "Biệt danh dữ liệu cơ bản",
  T_49_META_TYPE_409_D: "Liệt kê mã lỗi",
  T_49_META_TYPE_41_D: "Thực thể nút UI, UI mà người chơi chỉnh sửa thông qua trình chỉnh sửa UI",
  T_49_META_TYPE_410_D: "Biệt danh cho thực thể người chơi hoặc loại thực thể Biến đổi.",
  T_49_META_TYPE_411_D: "Xe trực thăng",
  T_49_META_TYPE_412_D: "Thành phần xe là phần mở rộng chức năng của thành phần xe",
  T_49_META_TYPE_413_D: "Thực thể NPC",
  T_49_META_TYPE_414_D: "Giới hạn góc quay của camera",
  T_49_META_TYPE_415_D: "Nhân vật",
  T_49_META_TYPE_416_D: "Giao diện cửa sổ trò chuyện Persona",
  T_49_META_TYPE_417_D: "Thành phần thực thể hạt",
  T_49_META_TYPE_418_D: "Liệt kê tình trạng thành viên",
  T_49_META_TYPE_419_D: "Loại da súng",
  T_49_META_TYPE_42_D: "Thực thể đầu vào UI, UI mà người chơi chỉnh sửa thông qua trình chỉnh sửa UI",
  T_49_META_TYPE_420_D: "Các loại da xe",
  T_49_META_TYPE_421_D: "Loại da",
  T_49_META_TYPE_422_D: "Loại da ba lô",
  T_49_META_TYPE_423_D: "ID nhân dạng",
  T_49_META_TYPE_424_D: "Hiệu ứng sương mù loại cơ bản",
  T_49_META_TYPE_425_D: "ID tài sản hạt",
  T_49_META_TYPE_426_D: "Một loại nguồn sáng phát ra ánh sáng hình nón từ nguồn sáng đến trục Y âm của nguồn sáng, chiếu sáng mặt đất theo mặc định",
  T_49_META_TYPE_427_D: "Thực thể NPC",
  T_49_META_TYPE_428_D: "Thông tin trang phục mà người chơi cần giữ lại khi biến thành nhân vật khác",
  T_49_META_TYPE_429_D: "Người chơi hoặc thực thể NPC",
  T_49_META_TYPE_43_D: "Kiểu phần tử phải là danh sách các thực thể người chơi",
  T_49_META_TYPE_430_D: "trình tạo số ngẫu nhiên",
  T_49_META_TYPE_431_D: "Đối tượng chuyển động di chuyển theo một đường dẫn tùy chỉnh",
  T_49_META_TYPE_432_D: "Tùy chỉnh các điểm tham chiếu đường cong",
  T_49_META_TYPE_433_D: "Tùy chỉnh Đường cong Đường dẫn Loại Điểm dừng",
  T_49_META_TYPE_434_D: "Đường cong tùy chỉnh",
  T_49_META_TYPE_435_D: "Danh sách định danh duy nhất của người chơi",
  T_49_META_TYPE_436_D: "Danh sách mã lỗi",
  T_49_META_TYPE_437_D: "Chi tiết trận đấu UI thực thể cho cả hai đội. Việc sửa đổi các thuộc tính thực thể sẽ ảnh hưởng đến nội dung hiển thị trên UI tương ứng.",
  T_49_META_TYPE_438_D: "Thực thể giao diện người dùng chi tiết trận đấu của nhiều đội, việc sửa đổi các thuộc tính của thực thể sẽ ảnh hưởng đến nội dung hiển thị trên giao diện người dùng tương ứng",
  T_49_META_TYPE_439_D: "Kết hợp",
  T_49_META_TYPE_44_D: "Kiểu phần tử phải là danh sách các thực thể nhóm",
  T_49_META_TYPE_440_D: "Dòng thời gian",
  T_49_META_TYPE_441_D: "ID tài nguyên dòng thời gian",
  T_49_META_TYPE_442_D: "Thành phần thực thể đơn giản hóa mới cho thông tin trận đấu của hai đội, hỗ trợ hiển thị số tùy chỉnh hoàn toàn",
  T_49_META_TYPE_443_D: "ID tài sản luồng hội thoại",
  T_49_META_TYPE_444_D: "Loại ngôn ngữ",
  T_49_META_TYPE_45_D: "Danh sách Bool",
  T_49_META_TYPE_46_D: "Danh sách Int",
  T_49_META_TYPE_47_D: "Danh sách Float",
  T_49_META_TYPE_48_D: "Danh sách String",
  T_49_META_TYPE_49_D: "Danh sách Vector3",
  T_49_META_TYPE_5_D: "Kiểu chuỗi, giá trị là nội dung văn bản",
  T_49_META_TYPE_50_D: "Kiểu phần tử phải là danh sách các thực thể",
  T_49_META_TYPE_51_D: "Loại Zombie",
  T_49_META_TYPE_53_D: "Vật phẩm ải thường",
  T_49_META_TYPE_54_D: "Đối tượng có thể phá hủy",
  T_49_META_TYPE_55_D: "Điểm xuất hiện chung",
  T_49_META_TYPE_56_D: "Phương tiện",
  T_49_META_TYPE_57_D: "Người chơi có thể được dịch chuyển đến một vị trí được chỉ định khi vào",
  T_49_META_TYPE_58_D: "Có thể tạo ra các buff theo yêu cầu",
  T_49_META_TYPE_59_D: "Nền tảng di chuyển",
  T_49_META_TYPE_6_D: "Vectơ ba chiều, có thể biểu diễn tọa độ không gian hoặc hướng không gian",
  T_49_META_TYPE_60_D: "Sẽ gây ra sự rơi vũ khí của loại đã chọn",
  T_49_META_TYPE_61_D: "Vào phạm vi kích hoạt sẽ mở cửa hàng ràng buộc",
  T_49_META_TYPE_62_D: "Xúc xắc có độ nảy tuyệt vời",
  T_49_META_TYPE_63_D: "Người chơi sẽ được bật đến vị trí được chỉ định khi họ bước vào đó",
  T_49_META_TYPE_64_D: "Khi người chơi bước lên nó, nó sẽ phát ra âm thanh",
  T_49_META_TYPE_65_D: "Khối vuông hoặc dốc cơ bản",
  T_49_META_TYPE_66_D: "Đường dẫn tùy chỉnh",
  T_49_META_TYPE_67_D: "Điểm dò đường",
  T_49_META_TYPE_68_D: "Các thực thể quái vật AI, chẳng hạn như thây ma",
  T_49_META_TYPE_69_D: "Số lớn là số dấu phẩy động có độ chính xác cao",
  T_49_META_TYPE_7_D: "Số là một kiểu bí danh cho số nguyên, số nguyên 64 bit hoặc kiểu dấu phẩy động",
  T_49_META_TYPE_70_D: "Công thức thuộc tính được sử dụng để tính giá trị thuộc tính của thực thể. Hiện tại chỉ một số thuộc tính của người chơi và thuộc tính vũ khí được hỗ trợ.",
  T_49_META_TYPE_71_D: "Chỉ sử dụng cho các thực thể được bán trong cửa hàng. Hàng hóa khác với khái niệm về các mặt hàng thu được khi mua hàng hóa.",
  T_49_META_TYPE_72_D: "Chứa nhiều sản phẩm",
  T_49_META_TYPE_73_D: "Có chứa một số kệ",
  T_49_META_TYPE_74_D: "ID vật phẩm",
  T_49_META_TYPE_75_D: "Chế độ tuần tra",
  T_49_META_TYPE_76_D: "Phong cách tuần tra",
  T_49_META_TYPE_77_D: "Một thực thể tạo ra có thể tạo ra và làm mới các đối tượng",
  T_49_META_TYPE_78_D: "Một thực thể đơn vị có thể được hấp thụ bởi các máy phát đơn vị và sinh ra theo từng đợt",
  T_49_META_TYPE_79_D: "Thực thể vũ khí",
  T_49_META_TYPE_8_D: "Điều kiện là loại Bool đặc biệt",
  T_49_META_TYPE_80_D: "Giao diện cửa hàng",
  T_49_META_TYPE_81_D: "Loại Buff",
  T_49_META_TYPE_82_D: "UI nhịp tim",
  T_49_META_TYPE_83_D: "Thành phần đơn vị giao diện nút tương tác",
  T_49_META_TYPE_84_D: "Các thực thể có thể xếp hạng, có khả năng được xếp hạng",
  T_49_META_TYPE_85_D: "Các thực thể tích phân có tích phân riêng của chúng",
  T_49_META_TYPE_86_D: "Thuộc tính công thức loại yếu tố",
  T_49_META_TYPE_87_D: "Mô tả loại màu RGBA, mỗi phạm vi giá trị kênh là 0~255",
  T_49_META_TYPE_88_D: "Loại tiền tệ, hiện tại chỉ có loại tiền tệ cơ sở",
  T_49_META_TYPE_89_D: "Thực thể tiền tệ, được sử dụng để mô tả loại và số lượng tiền tệ",
  T_49_META_TYPE_9_D: "Một tập hợp các điều kiện",
  T_49_META_TYPE_90_D: "Thực thể ví là một thùng chứa cho một nhóm các thực thể tiền tệ",
  T_49_META_TYPE_91_D: "Tham chiếu đến kiểu số nguyên hoặc mảng số nguyên",
  T_49_META_TYPE_92_D: "Kiểu vật phẩm có thể tạo động",
  T_49_META_TYPE_93_D: "Các thực thể có thuộc tính có thể xây dựng được",
  T_49_META_TYPE_94_D: "Phương pháp sửa đổi thuộc tính",
  T_49_META_TYPE_95_D: "Máy tạo vàng",
  T_49_META_TYPE_96_D: "Ví tiền",
  T_49_META_TYPE_97_D: "Vị trí, xoay và tỷ lệ, hỗ trợ cấu trúc cha-con",
  T_49_META_TYPE_98_D: "Liệt kê tất cả các loại có sẵn",
  T_49_META_TYPE_99_D: "Bóng đá"
};
export {
  _ as default
};
